// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2760%27 height=%2740%27 fill=%27none%27%3E%3Cpath fill=%27%23161616%27 fill-rule=%27evenodd%27 d=%27M45.425 15.806c.83-.181 1.691-.277 2.575-.277 6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12s-12-5.372-12-12c0-.937.108-1.85.311-2.726l.087-.663c.103-.79.351-2.083.798-3.715.74-2.705 1.791-5.412 3.219-7.961.297-.53.608-1.05.934-1.557a31.46 31.46 0 0 1 3.078-4.013c2.548-2.834 8.18-6.628 8.18-6.628a1.412 1.412 0 0 1 2.04.425l1.56 2.53a1.65 1.65 0 0 1-.428 2.19s-5.656 4.121-6.89 5.494a25.481 25.481 0 0 0-2.493 3.247 23.749 23.749 0 0 0-.971 1.654Zm-36 0c.83-.181 1.691-.277 2.575-.277 6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12s-12-5.372-12-12c0-.937.108-1.85.311-2.726l.087-.663c.103-.79.351-2.083.798-3.715.74-2.705 1.791-5.412 3.219-7.961.297-.53.608-1.05.934-1.557a31.465 31.465 0 0 1 3.078-4.013c2.548-2.834 8.18-6.628 8.18-6.628a1.412 1.412 0 0 1 2.04.425l1.56 2.53a1.65 1.65 0 0 1-.428 2.19s-5.656 4.121-6.89 5.494a25.481 25.481 0 0 0-2.493 3.247 23.728 23.728 0 0 0-.971 1.654Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2722%27 height=%2725%27 viewBox=%270 0 22 25%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M18.2587 4.50055C18.1711 4.50055 16.3308 4.35347 16.3308 4.35347C16.3308 4.35347 15.0552 3.07876 14.9091 2.93168C14.8799 2.90226 14.8312 2.87284 14.7923 2.86304L13.877 24.0919L21.0826 22.5133C21.0826 22.5133 18.4827 4.81433 18.4632 4.69666C18.4437 4.579 18.3366 4.51036 18.249 4.50055H18.2587Z%27 fill=%27black%27/%3E%3Cpath d=%27M14.382 2.8632C14.382 2.8632 14.0996 2.95145 13.6614 3.08873C13.233 1.85324 12.4832 0.715801 11.1492 0.715801C11.1103 0.715801 11.0713 0.715801 11.0421 0.715801C10.6623 0.21572 10.195 0 9.79573 0C6.709 0 5.22893 3.89278 4.76154 5.86369C3.56385 6.2363 2.70697 6.50104 2.59986 6.54027C1.92799 6.75599 1.90851 6.7756 1.82088 7.41296C1.75271 7.89342 0 21.5525 0 21.5525L13.5349 24.1019L14.4502 2.8534C14.4502 2.8534 14.4015 2.86321 14.382 2.87301V2.8632ZM10.9447 3.80453C10.9447 3.80453 10.9447 3.89278 10.9447 3.94181C10.195 4.17714 9.37702 4.43208 8.55909 4.68703C9.01674 2.90243 9.88337 2.03954 10.6331 1.71596C10.8181 2.19643 10.9447 2.88282 10.9447 3.81434V3.80453ZM9.71783 0.833468C9.85415 0.833468 9.98074 0.882494 10.1171 0.970744C9.12386 1.44141 8.06249 2.61807 7.61457 4.98119C6.96217 5.18711 6.31951 5.38322 5.72554 5.56952C6.25135 3.76531 7.49773 0.833468 9.71783 0.833468ZM10.2436 11.3548C10.2436 11.3548 9.44519 10.9233 8.46172 10.9233C7.0206 10.9233 6.95244 11.8352 6.95244 12.0608C6.95244 13.3061 10.1852 13.7865 10.1852 16.7184C10.1852 19.0227 8.73436 20.5033 6.77716 20.5033C4.43047 20.5033 3.23279 19.0325 3.23279 19.0325L3.86571 16.9439C3.86571 16.9439 5.10235 18.0127 6.1345 18.0127C6.81611 18.0127 7.08876 17.4734 7.08876 17.0812C7.08876 15.4535 4.43047 15.375 4.43047 12.6981C4.43047 10.4429 6.03713 8.26603 9.27965 8.26603C10.526 8.26603 11.1492 8.62884 11.1492 8.62884L10.2339 11.3646L10.2436 11.3548ZM11.7529 3.68687C11.7529 3.60842 11.7529 3.52017 11.7529 3.43192C11.7529 2.66709 11.6458 2.03954 11.4803 1.54927C12.1619 1.63752 12.6195 2.42196 12.9117 3.32406C12.5709 3.43192 12.1814 3.54959 11.7529 3.68687Z%27 fill=%27black%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2722%27 height=%2725%27 viewBox=%270 0 22 25%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M18.2587 4.50055C18.1711 4.50055 16.3308 4.35347 16.3308 4.35347C16.3308 4.35347 15.0552 3.07876 14.9091 2.93168C14.8799 2.90226 14.8312 2.87284 14.7923 2.86304L13.877 24.0919L21.0826 22.5133C21.0826 22.5133 18.4827 4.81433 18.4632 4.69666C18.4437 4.579 18.3366 4.51036 18.249 4.50055H18.2587Z%27 fill=%27black%27/%3E%3Cpath d=%27M14.382 2.8632C14.382 2.8632 14.0996 2.95145 13.6614 3.08873C13.233 1.85324 12.4832 0.715801 11.1492 0.715801C11.1103 0.715801 11.0713 0.715801 11.0421 0.715801C10.6623 0.21572 10.195 0 9.79573 0C6.709 0 5.22893 3.89278 4.76154 5.86369C3.56385 6.2363 2.70697 6.50104 2.59986 6.54027C1.92799 6.75599 1.90851 6.7756 1.82088 7.41296C1.75271 7.89342 0 21.5525 0 21.5525L13.5349 24.1019L14.4502 2.8534C14.4502 2.8534 14.4015 2.86321 14.382 2.87301V2.8632ZM10.9447 3.80453C10.9447 3.80453 10.9447 3.89278 10.9447 3.94181C10.195 4.17714 9.37702 4.43208 8.55909 4.68703C9.01674 2.90243 9.88337 2.03954 10.6331 1.71596C10.8181 2.19643 10.9447 2.88282 10.9447 3.81434V3.80453ZM9.71783 0.833468C9.85415 0.833468 9.98074 0.882494 10.1171 0.970744C9.12386 1.44141 8.06249 2.61807 7.61457 4.98119C6.96217 5.18711 6.31951 5.38322 5.72554 5.56952C6.25135 3.76531 7.49773 0.833468 9.71783 0.833468ZM10.2436 11.3548C10.2436 11.3548 9.44519 10.9233 8.46172 10.9233C7.0206 10.9233 6.95244 11.8352 6.95244 12.0608C6.95244 13.3061 10.1852 13.7865 10.1852 16.7184C10.1852 19.0227 8.73436 20.5033 6.77716 20.5033C4.43047 20.5033 3.23279 19.0325 3.23279 19.0325L3.86571 16.9439C3.86571 16.9439 5.10235 18.0127 6.1345 18.0127C6.81611 18.0127 7.08876 17.4734 7.08876 17.0812C7.08876 15.4535 4.43047 15.375 4.43047 12.6981C4.43047 10.4429 6.03713 8.26603 9.27965 8.26603C10.526 8.26603 11.1492 8.62884 11.1492 8.62884L10.2339 11.3646L10.2436 11.3548ZM11.7529 3.68687C11.7529 3.60842 11.7529 3.52017 11.7529 3.43192C11.7529 2.66709 11.6458 2.03954 11.4803 1.54927C12.1619 1.63752 12.6195 2.42196 12.9117 3.32406C12.5709 3.43192 12.1814 3.54959 11.7529 3.68687Z%27 fill=%27white%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27%3E%3Cpath fill=%27%232F2F2F%27 fill-rule=%27evenodd%27 d=%27m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2760%27 height=%2740%27 fill=%27none%27%3E%3Cpath fill=%27%23161616%27 fill-rule=%27evenodd%27 d=%27M14.575 23.723c-.83.181-1.691.277-2.575.277-6.627 0-12-5.373-12-12S5.373 0 12 0s12 5.373 12 12c0 .938-.108 1.85-.311 2.726l-.087.663c-.103.791-.351 2.083-.798 3.716-.74 2.704-1.791 5.41-3.219 7.96-.297.531-.608 1.05-.934 1.557a31.458 31.458 0 0 1-3.078 4.013c-2.548 2.835-8.18 6.628-8.18 6.628a1.412 1.412 0 0 1-2.04-.425l-1.559-2.53a1.65 1.65 0 0 1 .427-2.19s5.656-4.12 6.89-5.494a25.481 25.481 0 0 0 2.493-3.246 23.749 23.749 0 0 0 .971-1.655Zm36 0c-.83.181-1.691.277-2.575.277-6.627 0-12-5.373-12-12S41.373 0 48 0s12 5.373 12 12c0 .938-.108 1.85-.311 2.726l-.087.663c-.103.791-.351 2.083-.798 3.716-.74 2.704-1.791 5.41-3.219 7.96-.297.531-.608 1.05-.934 1.557a31.458 31.458 0 0 1-3.078 4.013c-2.548 2.835-8.18 6.628-8.18 6.628a1.412 1.412 0 0 1-2.04-.425l-1.56-2.53a1.65 1.65 0 0 1 .428-2.19s5.656-4.12 6.89-5.494a25.481 25.481 0 0 0 2.493-3.246 23.749 23.749 0 0 0 .971-1.655Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%279%27 height=%276%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23a%29%27%3E%3Cpath fill=%27%23fff%27 d=%27M4.798 5.343c-.1.1-.236.157-.378.157h-.271a.55.55 0 0 1-.38-.157L.107 1.672a.357.357 0 0 1 0-.507L.613.657a.35.35 0 0 1 .5 0l3.171 3.179L7.456.657a.357.357 0 0 1 .507 0l.5.508a.357.357 0 0 1 0 .507L4.799 5.343Z%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27a%27%3E%3Cpath fill=%27%23fff%27 d=%27M0 .5h8.571v5H0z%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%279%27 height=%276%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23a%29%27%3E%3Cpath fill=%27%23FFD748%27 d=%27M4.798 5.343c-.1.1-.236.157-.378.157h-.271a.55.55 0 0 1-.38-.157L.107 1.672a.357.357 0 0 1 0-.507L.613.657a.35.35 0 0 1 .5 0l3.171 3.179L7.456.657a.357.357 0 0 1 .507 0l.5.508a.357.357 0 0 1 0 .507L4.799 5.343Z%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27a%27%3E%3Cpath fill=%27%23fff%27 d=%27M0 .5h8.571v5H0z%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2713%27 fill=%27none%27%3E%3Cpath fill=%27%23fff%27 d=%27M6.718 9.78a.75.75 0 0 1-.53.22h-.38a.77.77 0 0 1-.53-.22L.148 4.64a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0l4.44 4.45 4.44-4.45a.5.5 0 0 1 .71 0l.7.71a.498.498 0 0 1 0 .71l-5.13 5.14Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%279%27 height=%276%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23a%29%27%3E%3Cpath fill=%27%232F2F2F%27 d=%27M4.798 5.343c-.1.1-.236.157-.378.157h-.272a.55.55 0 0 1-.378-.157L.105 1.672a.357.357 0 0 1 0-.507L.612.657a.35.35 0 0 1 .5 0l3.172 3.179L7.455.657a.357.357 0 0 1 .507 0l.5.508a.357.357 0 0 1 0 .507L4.798 5.343Z%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27a%27%3E%3Cpath fill=%27%23fff%27 d=%27M0 .5h8.57v5H0z%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%279%27 height=%276%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23a%29%27%3E%3Cpath fill=%27%237F7E7C%27 d=%27M3.774 5.343c.1.1.236.157.378.157h.272a.55.55 0 0 0 .378-.157l3.665-3.671a.357.357 0 0 0 0-.507L7.959.657a.35.35 0 0 0-.5 0L4.29 3.836 1.116.657a.357.357 0 0 0-.508 0l-.5.508a.357.357 0 0 0 0 .507l3.665 3.671Z%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27a%27%3E%3Cpath fill=%27%23fff%27 d=%27M8.572.5H.002v5h8.57z%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2713%27 fill=%27none%27%3E%3Cpath fill=%27%232F2F2F%27 d=%27M6.718 9.78a.75.75 0 0 1-.53.22h-.38a.77.77 0 0 1-.53-.22L.148 4.64a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0l4.44 4.45 4.44-4.45a.5.5 0 0 1 .71 0l.7.71a.498.498 0 0 1 0 .71l-5.13 5.14Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27%3E%3Cpath fill=%27%23fff%27 fill-rule=%27evenodd%27 d=%27m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27%3E%3Cpath fill=%27%23161616%27 fill-rule=%27evenodd%27 d=%27m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg width=%27345%27 height=%2723%27 viewBox=%270 0 345 23%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M3.17602 11.0648C94.4678 9.40411 290.206 6.68253 342.824 9.08188%27 stroke=%27%23B8DFD7%27 stroke-width=%272.4%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M2.1204 21.0805C93.4535 16.6156 289.357 7.8776 342.306 8.64418%27 stroke=%27%23B8DFD7%27 stroke-width=%272.4%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%271860%27 height=%27750%27 fill=%27none%27%3E%3Cg filter=%27url%28%23a%29%27%3E%3Cellipse cx=%27750.896%27 cy=%27580.836%27 fill=%27%23161616%27 rx=%27750.896%27 ry=%27580.836%27 transform=%27matrix%281 0 0 -1 124.617 1630.45%29%27/%3E%3C/g%3E%3Cg filter=%27url%28%23b%29%27%3E%3Cellipse cx=%27750.896%27 cy=%27580.836%27 fill=%27%23FFD748%27 rx=%27750.896%27 ry=%27580.836%27 transform=%27matrix%281 0 0 -1 678.207 411.679%29%27/%3E%3C/g%3E%3Cg filter=%27url%28%23c%29%27%3E%3Cellipse cx=%27489.715%27 cy=%27378.806%27 fill=%27%23989898%27 rx=%27489.715%27 ry=%27378.806%27 transform=%27matrix%281 0 0 -1 -358 539.046%29%27/%3E%3C/g%3E%3Crect width=%272488%27 height=%271912%27 fill=%27%23161616%27 fill-opacity=%27.3%27 rx=%2796%27 transform=%27matrix%281 0 0 -1 -198 1396.01%29%27/%3E%3Cdefs%3E%3Cfilter id=%27a%27 width=%273205.15%27 height=%272865.03%27 x=%27-727.061%27 y=%27-382.903%27 color-interpolation-filters=%27sRGB%27 filterUnits=%27userSpaceOnUse%27%3E%3CfeFlood flood-opacity=%270%27 result=%27BackgroundImageFix%27/%3E%3CfeBlend in=%27SourceGraphic%27 in2=%27BackgroundImageFix%27 result=%27shape%27/%3E%3CfeGaussianBlur result=%27effect1_foregroundBlur_9415_4374%27 stdDeviation=%27425.839%27/%3E%3C/filter%3E%3Cfilter id=%27b%27 width=%273205.15%27 height=%272865.03%27 x=%27-173.471%27 y=%27-1601.67%27 color-interpolation-filters=%27sRGB%27 filterUnits=%27userSpaceOnUse%27%3E%3CfeFlood flood-opacity=%270%27 result=%27BackgroundImageFix%27/%3E%3CfeBlend in=%27SourceGraphic%27 in2=%27BackgroundImageFix%27 result=%27shape%27/%3E%3CfeGaussianBlur result=%27effect1_foregroundBlur_9415_4374%27 stdDeviation=%27425.839%27/%3E%3C/filter%3E%3Cfilter id=%27c%27 width=%272682.79%27 height=%272460.97%27 x=%27-1209.68%27 y=%27-1070.24%27 color-interpolation-filters=%27sRGB%27 filterUnits=%27userSpaceOnUse%27%3E%3CfeFlood flood-opacity=%270%27 result=%27BackgroundImageFix%27/%3E%3CfeBlend in=%27SourceGraphic%27 in2=%27BackgroundImageFix%27 result=%27shape%27/%3E%3CfeGaussianBlur result=%27effect1_foregroundBlur_9415_4374%27 stdDeviation=%27425.839%27/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2717%27 height=%2714%27 fill=%27none%27%3E%3Cpath fill=%27%23fff%27 fill-rule=%27evenodd%27 d=%27M10.047.793 8.633 2.207 12.426 6H.34v2h12.086l-3.793 3.793 1.414 1.415L16.254 7 10.047.793Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3Csvg width=%27210%27 height=%2714%27 viewBox=%270 0 210 14%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1.80353 7.03576C57.3203 6.02584 176.353 4.37078 208.352 5.82988%27 stroke=%27%23B8DFD7%27 stroke-width=%271.4595%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M1.16136 13.1265C56.7032 10.4113 175.837 5.09749 208.037 5.56367%27 stroke=%27%23B8DFD7%27 stroke-width=%271.4595%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27390%27 height=%27858%27 fill=%27none%27%3E%3Cg filter=%27url%28%23a%29%27%3E%3Cellipse cx=%27338.156%27 cy=%27261.572%27 fill=%27%23161616%27 rx=%27338.156%27 ry=%27261.572%27 transform=%27matrix%281 0 0 -1 -260 985.143%29%27/%3E%3C/g%3E%3Cg filter=%27url%28%23b%29%27%3E%3Cellipse cx=%27267%27 cy=%27261.5%27 fill=%27%23FFD748%27 rx=%27267%27 ry=%27261.5%27 transform=%27matrix%281 0 0 -1 119 303%29%27/%3E%3C/g%3E%3Cg filter=%27url%28%23c%29%27%3E%3Cellipse cx=%27192.5%27 cy=%27210.5%27 fill=%27%23989898%27 rx=%27192.5%27 ry=%27210.5%27 transform=%27matrix%281 0 0 -1 -136 462%29%27/%3E%3C/g%3E%3Cpath fill=%27%23161616%27 fill-opacity=%27.3%27 d=%27M0 858h390V0H0z%27/%3E%3Cdefs%3E%3Cfilter id=%27a%27 width=%271443.4%27 height=%271290.23%27 x=%27-643.542%27 y=%2778.458%27 color-interpolation-filters=%27sRGB%27 filterUnits=%27userSpaceOnUse%27%3E%3CfeFlood flood-opacity=%270%27 result=%27BackgroundImageFix%27/%3E%3CfeBlend in=%27SourceGraphic%27 in2=%27BackgroundImageFix%27 result=%27shape%27/%3E%3CfeGaussianBlur result=%27effect1_foregroundBlur_11327_1787%27 stdDeviation=%27191.771%27/%3E%3C/filter%3E%3Cfilter id=%27b%27 width=%271301.08%27 height=%271290.08%27 x=%27-264.542%27 y=%27-603.542%27 color-interpolation-filters=%27sRGB%27 filterUnits=%27userSpaceOnUse%27%3E%3CfeFlood flood-opacity=%270%27 result=%27BackgroundImageFix%27/%3E%3CfeBlend in=%27SourceGraphic%27 in2=%27BackgroundImageFix%27 result=%27shape%27/%3E%3CfeGaussianBlur result=%27effect1_foregroundBlur_11327_1787%27 stdDeviation=%27191.771%27/%3E%3C/filter%3E%3Cfilter id=%27c%27 width=%271331.95%27 height=%271367.95%27 x=%27-609.475%27 y=%27-432.475%27 color-interpolation-filters=%27sRGB%27 filterUnits=%27userSpaceOnUse%27%3E%3CfeFlood flood-opacity=%270%27 result=%27BackgroundImageFix%27/%3E%3CfeBlend in=%27SourceGraphic%27 in2=%27BackgroundImageFix%27 result=%27shape%27/%3E%3CfeGaussianBlur result=%27effect1_foregroundBlur_11327_1787%27 stdDeviation=%27236.737%27/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2714%27 fill=%27none%27%3E%3Cpath fill=%27%23fff%27 fill-rule=%27evenodd%27 d=%27M9.707.793 8.293 2.207 12.086 6H0v2h12.086l-3.793 3.793 1.414 1.415L15.914 7 9.707.793Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27234%27 height=%2733%27 fill=%27none%27%3E%3Cpath fill=%27%23000%27 d=%27M1.26 2.59A1 1 0 0 1 2.306.885L1.26 2.59Zm231.06 5.682a1 1 0 0 1 .808 1.16l-1.584 8.86a1 1 0 0 1-1.969-.352l1.408-7.875-7.875-1.408a.999.999 0 1 1 .352-1.969l8.86 1.584ZM2.306.885c37.881 23.242 87.106 30.787 130.992 29.662 21.931-.563 42.495-3.29 59.594-7.285 17.124-4.002 30.687-9.258 38.68-14.826l1.143 1.641c-8.301 5.783-22.154 11.109-39.368 15.132-17.24 4.03-37.939 6.772-59.998 7.337C89.257 33.676 39.596 26.111 1.26 2.59L2.306.885Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27230%27 height=%2736%27 fill=%27none%27%3E%3Cpath fill=%27%23000%27 d=%27M.955 34.1a1 1 0 1 0 1.09 1.678L.954 34.1Zm228.209-5.631a1 1 0 0 0 .641-1.261l-2.79-8.557a1 1 0 1 0-1.901.62l2.479 7.606-7.606 2.48a1 1 0 0 0 .62 1.901l8.557-2.79ZM2.044 35.778C69.231-7.838 161.443-5.626 228.401 28.409l.906-1.782C161.817-7.68 68.832-9.964.955 34.1l1.09 1.678Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27410%27 height=%27120%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23a%29%27%3E%3Crect width=%27410%27 height=%27120%27 fill=%27%23fff%27 rx=%2724%27/%3E%3Crect width=%27408%27 height=%27118%27 x=%271%27 y=%271%27 fill=%27%23fff%27 stroke=%27%23161616%27 stroke-width=%272%27 rx=%2723%27/%3E%3Cpath stroke=%27%23161616%27 stroke-width=%271.5%27 d=%27M409.75 72v73M9.25 145V72.001M19.25 145V72M394.75 72v73M34.25 145V71.999M379.75 72v73M54.25 145V72M359.75 72v73M79.25 145V72M334.75 72v73%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27a%27%3E%3Crect width=%27410%27 height=%27120%27 fill=%27%23fff%27 rx=%2724%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27%3E%3Cg clip-path=%27url%28%23a%29%27%3E%3Cmask id=%27b%27 width=%2724%27 height=%2724%27 x=%270%27 y=%270%27 maskUnits=%27userSpaceOnUse%27 style=%27mask-type:luminance%27%3E%3Cpath fill=%27%23fff%27 d=%27M0 24h24V0H0v24Z%27/%3E%3C/mask%3E%3Cg stroke=%27%23161616%27 stroke-linecap=%27square%27 stroke-width=%272%27 mask=%27url%28%23b%29%27%3E%3Cpath d=%27M6 18 17.368 6.63M8.25 6H18v9.75%27/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27a%27%3E%3Cpath fill=%27%23fff%27 d=%27M0 0h24v24H0z%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2732%27 height=%2732%27 fill=%27none%27%3E%3Cpath fill=%27%23161616%27 fill-rule=%27evenodd%27 d=%27M24.707 11.707 13.5 22.914l-6.207-6.207 1.414-1.414 4.793 4.793 9.793-9.793 1.414 1.414Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%277%27 fill=%27none%27%3E%3Cpath fill=%27%23444340%27 d=%27M6.707 6.293a1 1 0 0 1-1.414 0L.707 1.707C.077 1.077.523 0 1.414 0h9.172c.89 0 1.337 1.077.707 1.707L6.707 6.293Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27%3E%3Cpath fill=%27%23161616%27 fill-rule=%27evenodd%27 d=%27m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.414L19.914 12l-6.207-6.207Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg clip-path=%27url%28%23clip0_2200_67437%29%27%3E%3Cmask id=%27mask0_2200_67437%27 style=%27mask-type:luminance%27 maskUnits=%27userSpaceOnUse%27 x=%270%27 y=%270%27 width=%2724%27 height=%2724%27%3E%3Cpath d=%27M0 24L24 24L24 0L0 0L0 24Z%27 fill=%27white%27/%3E%3C/mask%3E%3Cg mask=%27url%28%23mask0_2200_67437%29%27%3E%3Cpath d=%27M6 17.9993L17.3684 6.63086%27 stroke=%27%23161616%27 stroke-width=%272%27 stroke-linecap=%27square%27/%3E%3Cpath d=%27M8.25 6L18 6V15.75%27 stroke=%27%23161616%27 stroke-width=%272%27 stroke-linecap=%27square%27/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_2200_67437%27%3E%3Crect width=%2724%27 height=%2724%27 fill=%27white%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M20.7072 7.70718L9.50007 18.9143L3.29297 12.7072L4.70718 11.293L9.50007 16.0859L19.293 6.29297L20.7072 7.70718Z%27 fill=%27%238C8B87%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27141%27 height=%2713%27 fill=%27none%27%3E%3Cpath stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M2 3c36.863-.798 115.931-1.812 137.303.518%27/%3E%3Cpath stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M2.092 11.065c36.78-2.98 115.702-8.674 137.148-7.614%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27none%27%3E%3Cpath fill=%27%23000%27 fill-rule=%27evenodd%27 d=%27M11.996 17.415 2.29 7.707l1.414-1.414 8.293 8.293 8.293-8.293 1.414 1.414-9.707 9.708Z%27 clip-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27204%27 height=%2713%27 fill=%27none%27%3E%3Cpath stroke=%27%23D095FF%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M2 3c53.69-.798 168.855-1.812 199.985.518%27/%3E%3Cpath stroke=%27%23D095FF%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M2.13 11.065C55.703 8.085 170.656 2.39 201.893 3.45%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M13.2929 17.7929C12.9024 18.1834 12.9024 18.8166 13.2929 19.2071C13.6834 19.5976 14.3166 19.5976 14.7071 19.2071L20.5 13.4142C21.281 12.6332 21.281 11.3668 20.5 10.5858L14.7071 4.79289C14.3166 4.40237 13.6834 4.40237 13.2929 4.79289C12.9024 5.18342 12.9024 5.81658 13.2929 6.20711L18.0858 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H18.0858L13.2929 17.7929Z%27 fill=%27%23FFD748%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3Csvg width=%2722%27 height=%2722%27 viewBox=%270 0 22 22%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z%27 stroke=%27%23ACA59A%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3Csvg width=%2722%27 height=%2722%27 viewBox=%270 0 22 22%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M6.5 11L9.5 14L15.5 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z%27 stroke=%27%23ACA59A%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3Csvg width=%2722%27 height=%2722%27 viewBox=%270 0 22 22%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z%27 stroke=%27%23E95B86%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3Csvg width=%2722%27 height=%2722%27 viewBox=%270 0 22 22%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M6.5 11L9.5 14L15.5 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z%27 stroke=%27%234DAE9B%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%271287%27 height=%27400%27 fill=%27none%27%3E%3Cg filter=%27url%28%23a%29%27%3E%3Ccircle cx=%27658.5%27 cy=%27439.5%27 r=%27358.5%27 fill=%27%23000%27 fill-opacity=%27.9%27/%3E%3C/g%3E%3Cg filter=%27url%28%23b%29%27%3E%3Ccircle cx=%27891.5%27 cy=%27-227.5%27 r=%27264.5%27 fill=%27%23FFD748%27/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id=%27a%27 width=%271317%27 height=%271317%27 x=%270%27 y=%27-219%27 color-interpolation-filters=%27sRGB%27 filterUnits=%27userSpaceOnUse%27%3E%3CfeFlood flood-opacity=%270%27 result=%27BackgroundImageFix%27/%3E%3CfeBlend in=%27SourceGraphic%27 in2=%27BackgroundImageFix%27 result=%27shape%27/%3E%3CfeGaussianBlur result=%27effect1_foregroundBlur_11319_1798%27 stdDeviation=%27150%27/%3E%3C/filter%3E%3Cfilter id=%27b%27 width=%271329%27 height=%271329%27 x=%27227%27 y=%27-892%27 color-interpolation-filters=%27sRGB%27 filterUnits=%27userSpaceOnUse%27%3E%3CfeFlood flood-opacity=%270%27 result=%27BackgroundImageFix%27/%3E%3CfeBlend in=%27SourceGraphic%27 in2=%27BackgroundImageFix%27 result=%27shape%27/%3E%3CfeGaussianBlur result=%27effect1_foregroundBlur_11319_1798%27 stdDeviation=%27200%27/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --gray: #2f2f2f;
  --gray-2: #444340;
  --gray-3: #7f7e7c;
  --gray-4: #ccc;
  --yellow: #16a34a40;
  --dark: #16a34a;
  --dark-2: #2f2f2f;
  --light-gray: #f6f5ef;
  --beige: #f6f5ef;
  --beige-2: #ffdebf;
  --beige-3: #a6a4a2;
  --white: #fff;
  --white-2: #e9e4dc;
  --green: #4dae9b;
  --green-2: #2e685d;
  --purple: #d095ff;
  --pink: #ffc2d6;
  --black: #000;
  --blue: #b1e1f5;
}

html {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: inherit;
  list-style: none;
  -webkit-tap-highlight-color: transparent;
  /* min-width: 0; */
  /* min-height: 0; */
}

body {
  margin: 0;
  padding: 0;
  line-height: 1;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul,
ol,
li,
button,
blockquote {
  margin: 0;
  padding: 0;
}

a {
  display: inline-block;
  color: inherit;
  text-decoration: none;
}

li {
  list-style: none;
}

img {
  max-width: 100%;
  display: block;
}

button {
  background-color: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  border-radius: unset;
  cursor: pointer;
}

html {
  height: 100%;
}

body {
  height: 100%;
  font-family: "Circular Std";
}
body.no-scroll {
  overflow: hidden;
}
body.page-template-memberships {
  background-color: var(--dark);
}

.container {
  width: 100%;
  max-width: 1330px;
  /* margin: 0 auto; */
  /* padding: 0 20px; */
}
.container.solid-background {
  width: 100%;
  max-width: 1330px;
  background-color: #faf2eb;
}
@media screen and (max-width: 1330px) {
  .container {
    max-width: 100vw;
    /* padding: 0 1.5038vw; */
  }
}
@media screen and (max-width: 1280px) {
  .container {
    max-width: 85.1563vw;
    /* padding: 0 1.5625vw; */
  }
}
@media screen and (max-width: 850px) {
  .container {
    max-width: 100%;
    /* padding: 0 5.1282vw; */
  }
}

.general-wrapper {
  display: flex;
  flex-direction: column;
  gap: 50px;
}
@media screen and (max-width: 1330px) {
  .general-wrapper {
    gap: 3.7594vw;
  }
}
@media screen and (max-width: 1280px) {
  .general-wrapper {
    gap: 3.9063vw;
  }
}
@media screen and (max-width: 850px) {
  .general-wrapper {
    gap: 7.6923vw;
  }
}

#wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
#wrapper header {
  flex: 0 0 auto;
}
#wrapper main {
  flex: 1 0 auto;
}
#wrapper footer {
  flex-shrink: 0;
}

:root {
  --paddingList: 15px;
  --figureOffset: 11px;
  --widthFigure: 5px;
  --heightFigure: 5px;
  --bgFigure: var(--dark);
}

.title {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.5px;
  font-size: 50px;
  color: var(--dark);
}
@media screen and (max-width: 1330px) {
  .title {
    letter-spacing: -0.0376vw;
    font-size: 3.7594vw;
  }
}
@media screen and (max-width: 1280px) {
  .title {
    font-size: 2.9688vw;
  }
}
@media screen and (max-width: 850px) {
  .title {
    font-size: 8.2051vw;
    letter-spacing: -0.0821vw;
  }
}

.small-title {
  font-family: "Cambon";
  font-weight: 700;
  font-size: 40px;
  letter-spacing: -0.4px;
  line-height: 1.2;
  color: var(--dark);
}
@media screen and (max-width: 1330px) {
  .small-title {
    font-size: 3.0075vw;
    letter-spacing: -0.0301vw;
  }
}
@media screen and (max-width: 1280px) {
  .small-title {
    font-size: 2.1875vw;
    letter-spacing: -0.0219vw;
  }
}
@media screen and (max-width: 850px) {
  .small-title {
    font-size: 7.7778vw;
    letter-spacing: -0.4103vw;
  }
}

.small-text {
  font-weight: 400;
  line-height: 1.5;
  font-size: 20px;
  color: var(--dark-2);
}
@media screen and (max-width: 1330px) {
  .small-text {
    font-size: 1.5038vw;
  }
}
@media screen and (max-width: 1280px) {
  .small-text {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
}
@media screen and (max-width: 850px) {
  .small-text {
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
  }
}

.subtext {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.2px;
  font-size: 20px;
  color: var(--gray);
}
@media screen and (max-width: 1330px) {
  .subtext {
    letter-spacing: -0.015vw;
    font-size: 1.5038vw;
  }
}
@media screen and (max-width: 1280px) {
  .subtext {
    font-size: 1.4063vw;
    letter-spacing: -0.0078vw;
  }
}
@media screen and (max-width: 850px) {
  .subtext {
    font-size: 4.6154vw;
    letter-spacing: -0.0462vw;
  }
}

.text {
  font-family: "Circular Std";
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--gray);
}
.text
  *:not(
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    img,
    ul,
    ol,
    li,
    blockquote,
    iframe,
    a,
    span,
    .blockquote,
    .blockquote *
  ) {
  margin-bottom: 32px;
}
.text *:last-child {
  margin-bottom: 0;
}
.text h1,
.text h2,
.text h3 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  color: var(--dark);
}
.text h1 {
  letter-spacing: -0.56px;
  font-size: 56px;
}
.text h2 {
  font-size: 50px;
  letter-spacing: -0.5px;
}
.text h3 {
  letter-spacing: -0.4px;
  font-size: 40px;
  margin-bottom: 32px;
}
.text h3.bg-title {
  margin-bottom: 16px;
}
.text h3 span {
  display: inline-block;
  background-color: var(--pink);
  border-radius: 16px;
  padding: 16px 24px;
}
.text h4,
.text h5,
.text h6 {
  font-family: "Circular Std";
  font-weight: 500;
  line-height: 1.4;
  color: var(--dark);
}
.text h4 {
  letter-spacing: -0.32px;
  font-size: 32px;
}
.text h5,
.text h6 {
  letter-spacing: -0.24px;
  font-size: 24px;
}
.text a {
  text-decoration: underline;
  text-underline-offset: 4px;
  text-underline-offset: 6px;
}
.text blockquote {
  background: var(--light-gray);
  border-radius: 24px;
  padding: 74px 116px;
  font-family: "Circular Std";
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.28px;
  font-size: 28px;
  color: var(--dark);
  text-align: center;
  position: relative;
  z-index: 2;
}
.text blockquote::before {
  content: "";
  position: absolute;
  top: 35px;
  left: 37px;
  width: 60px;
  height: 47px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  pointer-events: none;
}
.text img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
.text .alignleft {
  float: left;
}
.text .alignright {
  float: right;
}
.text .aligncenter {
  margin: 0 auto;
}
.text ul li {
  padding-left: var(--paddingList);
  position: relative;
  z-index: 2;
}
.text ul li::after {
  content: "";
  position: absolute;
  top: var(--figureOffset);
  left: 0;
  width: var(--widthFigure);
  height: var(--heightFigure);
  border-radius: 50%;
  background-color: var(--bgFigure);
}
.text ul li ol {
  counter-reset: numUl;
}
.text ul li ol li {
  padding-left: 0;
}
.text ul li ol li::after {
  display: none;
}
.text ul li ol li::before {
  counter-increment: numUl;
  content: counters(numUl, ".") ".";
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
.text ol {
  counter-reset: numOl;
}
.text ol li::before {
  counter-increment: numOl;
  content: counters(numOl, ".") ".";
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
.text ol li ol {
  padding-left: var(--paddingList);
}
.text ol li ul {
  padding-left: var(--paddingList);
}
.text ol li ul li {
  padding-left: var(--paddingList);
  position: relative;
  z-index: 2;
}
.text ol li ul li::after {
  content: "";
  position: absolute;
  top: var(--figureOffset);
  left: 0;
  width: var(--widthFigure);
  height: var(--heightFigure);
  border-radius: 50%;
  background-color: var(--bgFigure);
}
.text ol li ul li::before {
  display: none;
}

@media screen and (max-width: 1330px) {
  :root {
    --paddingList: 1.1278vw;
    --figureOffset: 0.8271vw;
    --widthFigure: 0.3759vw;
    --heightFigure: 0.3759vw;
  }
  .text {
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
  }
  .text
    *:not(
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      img,
      ul,
      ol,
      li,
      blockquote,
      iframe,
      a,
      span,
      .blockquote,
      .blockquote *
    ) {
    margin-bottom: 2.406vw;
  }
  .text h1 {
    letter-spacing: -0.0421vw;
    font-size: 4.2105vw;
  }
  .text h2 {
    font-size: 3.7594vw;
    letter-spacing: -0.0376vw;
  }
  .text h3 {
    letter-spacing: -0.0301vw;
    font-size: 3.0075vw;
    margin-bottom: 2.406vw;
  }
  .text h3.bg-title {
    margin-bottom: 1.203vw;
  }
  .text h3 span {
    border-radius: 1.203vw;
    padding: 1.203vw 1.8045vw;
  }
  .text h4 {
    letter-spacing: -0.0241vw;
    font-size: 2.406vw;
  }
  .text h5,
  .text h6 {
    letter-spacing: -0.018vw;
    font-size: 1.8045vw;
  }
  .text blockquote {
    border-radius: 1.8045vw;
    padding: 5.5639vw 8.7218vw;
    letter-spacing: -0.0211vw;
    font-size: 2.1053vw;
  }
  .text blockquote::before {
    top: 2.6316vw;
    left: 2.782vw;
    width: 4.5113vw;
    height: 3.5338vw;
  }
}
@media screen and (max-width: 850px) {
  :root {
    --paddingList: 2.5641vw;
    --figureOffset: 2.0513vw;
    --widthFigure: 1.0256vw;
    --heightFigure: 1.0256vw;
  }
  .text {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .text
    *:not(
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      img,
      ul,
      ol,
      li,
      blockquote,
      iframe,
      a,
      span,
      .blockquote,
      .blockquote *
    ) {
    margin-bottom: 6.1538vw;
  }
  .text h1 {
    letter-spacing: -0.0923vw;
    font-size: 9.2308vw;
  }
  .text h2 {
    font-size: 8.2051vw;
    letter-spacing: -0.0821vw;
  }
  .text h3 {
    letter-spacing: -0.0718vw;
    font-size: 7.1795vw;
    margin-bottom: 6.1538vw;
  }
  .text h3.bg-title {
    margin-bottom: 4.1026vw;
  }
  .text h3 span {
    border-radius: 4.1026vw;
    padding: 2.5641vw 6.1538vw;
  }
  .text h4 {
    letter-spacing: -0.0667vw;
    font-size: 6.6667vw;
  }
  .text h5,
  .text h6 {
    letter-spacing: -0.0513vw;
    line-height: 1.5;
    font-size: 5.1282vw;
  }
  .text blockquote {
    border-radius: 4.1026vw;
    padding: 20.5128vw 5.1282vw;
    letter-spacing: -0.0718vw;
    font-size: 5.1282vw;
  }
  .text blockquote::before {
    top: 3.8462vw;
    left: 3.8462vw;
    width: 12.8205vw;
    height: 12.8205vw;
  }
}
.page-template-memberships .btn:hover {
  background-color: var(--white);
  color: var(--dark);
}

.btn {
  font-family: "Circular Std";
  font-size: 17px;
  font-weight: 500;
  color: var(--dark);
  text-align: center;
  background-color: var(--yellow);
  border-radius: 12px;
  padding: 18px 24px;
  transition: all 0.4s linear;
}
.btn:hover {
  background-color: var(--dark);
  color: var(--white);
}
.btn.btn--dark {
  background-color: var(--dark);
  color: var(--white);
}
.btn.btn--dark:hover {
  background-color: var(--gray);
}
@media screen and (max-width: 1330px) {
  .btn {
    font-size: 1.2782vw;
    border-radius: 0.9023vw;
    padding: 1.3534vw 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .btn {
    padding: 1.25vw 2.1094vw;
  }
}
@media screen and (max-width: 850px) {
  .btn {
    font-size: 4.359vw;
    border-radius: 3.0769vw;
    padding: 4.6154vw 6.1538vw;
  }
}

.btn-border {
  font-family: "Circular Std";
  font-size: 17px;
  font-weight: 500;
  color: var(--dark);
  text-align: center;
  padding: 15px 22px;
  border-radius: 12px;
  border: 2px solid var(--dark);
  transition: all 0.4s linear;
}
.btn-border:hover {
  background-color: var(--dark);
  color: var(--white);
}
@media screen and (max-width: 1330px) {
  .btn-border {
    font-size: 1.2782vw;
    padding: 1.1278vw 1.6541vw;
    border-radius: 0.9023vw;
    border: 0.1504vw solid var(--dark);
  }
}
@media screen and (max-width: 1280px) {
  .btn-border {
    padding: 1.25vw 1.9531vw;
  }
}
@media screen and (max-width: 850px) {
  .btn-border {
    font-size: 4.359vw;
    padding: 3.8462vw 5.641vw;
    border-radius: 3.0769vw;
    border: 0.5128vw solid var(--dark);
  }
}

.btn-shopify {
  font-family: "Circular Std";
  font-size: 17px;
  font-weight: 500;
  color: var(--dark);
  text-align: center;
  position: relative;
  background-color: var(--yellow);
  border-radius: 12px;
  padding: 18px 24px 18px 46px;
  transition: all 0.4s linear;
}
.btn-shopify::after {
  content: "";
  position: absolute;
  left: 17px;
  top: 50%;
  width: 22px;
  height: 25px;
  transform: translateY(-50%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.btn-shopify:hover {
  background-color: var(--dark);
  color: var(--white);
}
.btn-shopify:hover::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@media screen and (max-width: 1330px) {
  .btn-shopify {
    font-size: 1.2782vw;
    border-radius: 0.9023vw;
    padding: 1.353vw 1.805vw 1.353vw 3.459vw;
  }
  .btn-shopify::after {
    left: 1.278vw;
    width: 1.654vw;
    height: 1.88vw;
  }
}
@media screen and (max-width: 1280px) {
  .btn-shopify {
    padding: 1.406vw 1.875vw 1.406vw 3.594vw;
  }
  .btn-shopify::after {
    left: 1.328vw;
    width: 1.719vw;
    height: 1.953vw;
  }
}
@media screen and (max-width: 850px) {
  .btn-shopify {
    font-size: 4.359vw;
    border-radius: 3.0769vw;
    padding: 4.615vw 8.974vw 4.615vw 15.385vw;
  }
  .btn-shopify::after {
    left: 8.974vw;
    width: 4.359vw;
    height: 5.128vw;
  }
}

.btn-shopify--big {
  font-family: "Circular Std";
  font-size: 24px;
  font-weight: 500;
  color: var(--dark);
  text-align: center;
  position: relative;
  background-color: var(--yellow);
  border-radius: 12px;
  padding: 18px 31px 18px 70px;
  transition: all 0.4s linear;
}
.btn-shopify--big::after {
  content: "";
  position: absolute;
  left: 21px;
  top: 50%;
  width: 34px;
  height: 42px;
  transform: translateY(-50%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.btn-shopify--big:hover {
  background-color: var(--dark);
  color: var(--white);
}
.btn-shopify--big:hover::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@media screen and (max-width: 1330px) {
  .btn-shopify--big {
    font-size: 24px;
    border-radius: 0.9023vw;
    padding: 1.3534vw 1.8045vw 1.3534vw 5.263vw;
  }
  .btn-shopify--big::after {
    left: 1.579vw;
    width: 2.556vw;
    height: 3.158vw;
  }
}
@media screen and (max-width: 1280px) {
  .btn-shopify--big {
    padding: 1.25vw 2.1094vw 1.25vw 5.469vw;
  }
  .btn-shopify--big::after {
    left: 1.641vw;
    width: 2.656vw;
    height: 3.281vw;
  }
}
@media screen and (max-width: 850px) {
  .btn-shopify--big {
    font-size: 4.359vw;
    border-radius: 3.0769vw;
    padding: 4.615vw 8.974vw 4.615vw 15.385vw;
  }
  .btn-shopify--big::after {
    left: 8.974vw;
    width: 4.359vw;
    height: 5.128vw;
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  opacity: 0;
  pointer-events: none;
  transition: all 0.4s linear;
}
.modal.visible {
  opacity: 1;
  pointer-events: all;
}
.modal.visible .modal-dialog .modal-content {
  opacity: 1;
  transform: scale(1);
}
.modal.video-modal .modal-dialog .modal-content {
  background-color: #000;
}
.modal .modal-dialog {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal .modal-dialog.content {
  display: block;
}
.modal .modal-dialog.content .modal-content {
  margin: 0 auto;
}
.modal .modal-dialog .modal-content {
  width: 100%;
  max-width: 1100px;
  min-height: 500px;
  background-color: #fff;
  position: relative;
  z-index: 2;
  transition: all 0.4s linear;
  opacity: 0;
  transform: scale(0);
}
.modal .modal-dialog .modal-content .modal-close {
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 3;
  left: calc(100% + 15px);
  bottom: calc(100% + 5px);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal .modal-dialog .modal-content .modal-close::before,
.modal .modal-dialog .modal-content .modal-close::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #fff;
}
.modal .modal-dialog .modal-content .modal-close::before {
  transform: rotate(45deg);
}
.modal .modal-dialog .modal-content .modal-close::after {
  transform: rotate(-45deg);
}
.modal .modal-dialog .modal-video {
  width: 100%;
  height: 500px;
}
.modal .modal-dialog .modal-video #modal-video-iframe {
  width: 100%;
  height: 100%;
}
.modal .modal-dialog .modal-video iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.modal .modal-dialog .modal-video video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1200px) {
  .modal .modal-dialog .modal-content .modal-close {
    left: auto;
    right: 0;
  }
}
@media screen and (max-width: 991px) {
  .modal .modal-dialog .modal-content {
    min-height: 250px;
  }
  .modal .modal-dialog .modal-video {
    height: 50.4541vw;
    min-height: 250px;
  }
}
.pagination-block {
  margin: 92px 0 137px;
}
.pagination-block .page-numbers {
  display: flex;
  align-items: center;
  justify-content: center;
}
.pagination-block .page-numbers li {
  flex: 0 0 auto;
}
.pagination-block .page-numbers li:not(:first-child) {
  margin-left: 12px;
}
.pagination-block .page-numbers li .page-numbers {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--dark);
  border-radius: 10.5px;
  border: 1px solid var(--white-2);
  background: var(--white);
  padding: 6px 10px;
  min-width: 42px;
  min-height: 42px;
  transition: all 0.4s linear;
}
.pagination-block .page-numbers li .page-numbers.prev {
  margin-right: 4px;
}
.pagination-block .page-numbers li .page-numbers.next {
  margin-left: 4px;
}
.pagination-block .page-numbers li .page-numbers.prev,
.pagination-block .page-numbers li .page-numbers.next {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--dark);
  border: none;
  padding: 0;
}
.pagination-block .page-numbers li .page-numbers.prev.disable,
.pagination-block .page-numbers li .page-numbers.next.disable {
  pointer-events: none;
  color: var(--gray-4);
}
.pagination-block .page-numbers li .page-numbers.current,
.pagination-block .page-numbers li .page-numbers:hover {
  background-color: var(--yellow);
  border-color: var(--yellow);
}
.pagination-block .page-numbers li .page-numbers.dots {
  border: none;
}

@media screen and (max-width: 1330px) {
  .pagination-block {
    margin: 6.9173vw 0 10.3008vw;
  }
  .pagination-block .page-numbers li:not(:first-child) {
    margin-left: 0.9023vw;
  }
  .pagination-block .page-numbers li .page-numbers {
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
    border-radius: 0.7895vw;
    padding: 0.4511vw 0.7519vw;
    min-width: 3.1579vw;
    min-height: 3.1579vw;
  }
  .pagination-block .page-numbers li .page-numbers.prev {
    margin-right: 0.3008vw;
  }
  .pagination-block .page-numbers li .page-numbers.next {
    margin-left: 0.3008vw;
  }
  .pagination-block .page-numbers li .page-numbers.prev,
  .pagination-block .page-numbers li .page-numbers.next {
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
  }
}
@media screen and (max-width: 1280px) {
  .pagination-block {
    margin: 4.9219vw 0 9.2969vw;
  }
  .pagination-block .page-numbers li:not(:first-child) {
    margin-left: 0.9375vw;
  }
  .pagination-block .page-numbers li .page-numbers {
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
    border-radius: 0.8203vw;
    padding: 0.4688vw 0.7813vw;
    min-width: 3.2813vw;
    min-height: 3.2813vw;
  }
  .pagination-block .page-numbers li .page-numbers.prev {
    margin-right: 0.3125vw;
  }
  .pagination-block .page-numbers li .page-numbers.next {
    margin-left: 0.3125vw;
  }
  .pagination-block .page-numbers li .page-numbers.prev,
  .pagination-block .page-numbers li .page-numbers.next {
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
  }
}
@media screen and (max-width: 850px) {
  .pagination-block {
    margin: 7.6923vw 0 16.9231vw;
  }
  .pagination-block .page-numbers li:not(:first-child) {
    margin-left: 1.5385vw;
  }
  .pagination-block .page-numbers li .page-numbers {
    font-weight: 700;
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
    border-radius: 2.6923vw;
    padding: 1.5385vw 2.5641vw;
    min-width: 10.7692vw;
    min-height: 10.7692vw;
  }
  .pagination-block .page-numbers li .page-numbers.prev {
    margin-right: 1.0256vw;
  }
  .pagination-block .page-numbers li .page-numbers.next {
    margin-left: 1.0256vw;
  }
  .pagination-block .page-numbers li .page-numbers.prev,
  .pagination-block .page-numbers li .page-numbers.next {
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
  }
}
.notification {
  position: fixed;
  z-index: 8;
  right: 30px;
  bottom: 30px;
  direction: ltr;
  display: flex;
  align-items: center;
  background-color: #fcede9;
  width: 100%;
  max-width: 450px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #89888f;
  pointer-events: none;
  opacity: 0;
  transition: all 0.4s linear;
  transform: translateY(100%);
}
.notification.show {
  pointer-events: all;
  opacity: 1;
  transform: translateY(0);
}
.notification .notification-icon {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  pointer-events: none;
}
.notification .notification-icon svg {
  width: 20px;
  height: 20px;
  display: block;
}
.notification .notification-text {
  margin: 0 15px;
  font-weight: 700;
  color: #89888f;
  font-size: 14px;
  text-align: center;
}
.notification .notification-button {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.notification .notification-button svg {
  width: 20px;
  height: 20px;
  display: block;
}

@media screen and (max-width: 991px) {
  .notification {
    right: 5px;
    bottom: 10px;
    max-width: 250px;
    padding: 10px;
    border-radius: 10px;
  }
  .notification .notification-icon {
    width: 15px;
    height: 15px;
  }
  .notification .notification-icon svg {
    width: 15px;
    height: 15px;
  }
  .notification .notification-text {
    margin: 0 5px;
  }
  .notification .notification-button {
    width: 15px;
    height: 15px;
  }
  .notification .notification-button svg {
    width: 15px;
    height: 15px;
  }
}
.single-solutions .card .card-info,
.page-template-bfcm .card .card-info {
  display: none;
}

.card {
  background-color: var(--white);
  border-radius: 24px;
  padding: 6px 6px 32px 6px;
  position: relative;
  z-index: 2;
  transition: all 0.4s linear;
}
.card.hide {
  display: none;
}
.card:hover {
  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),
    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),
    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),
    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),
    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),
    0px 100px 80px 0px rgba(0, 0, 0, 0.05);
}
.card:hover .card-img img {
  transform: scale(1.1);
}
.card:hover .card-content__title h3 {
  text-decoration: underline;
}
.card .card-img {
  width: 100%;
  height: 240px;
  border-radius: 18px;
  overflow: hidden;
}
.card .card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.4s linear;
}
.card .card-info {
  margin-top: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 0 50px 0 26px;
}
.card .card-info__labels ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.card .card-info__labels ul li {
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
  text-align: center;
  background-color: var(--light-gray);
  padding: 16px 24px;
  border-radius: 50px;
}
.card .card-info__time {
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
  text-align: center;
  flex: 0 0 auto;
}
.card .card-content {
  margin-top: 32px;
  padding: 0 26px 41px;
}
.card .card-content__logo {
  width: 119px;
  height: 44px;
  margin-bottom: 12px;
}
.card .card-content__logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.card .card-content__title {
  margin-bottom: 23px;
}
.card .card-content__title h3 {
  font-weight: 500;
  font-size: 24px;
  line-height: 1.4;
  letter-spacing: -0.24px;
  color: var(--dark);
}
.card .card-content__button {
  display: inline-block;
  position: absolute;
  left: 31px;
  bottom: 46px;
}
.card .card-content__button a,
.card .card-content__button button {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.card .card-content__button a::before,
.card .card-content__button button::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.card .card-content__button a::after,
.card .card-content__button button::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .card .card-content__button a:hover::before,
  .card .card-content__button button:hover::before {
    transform: translateX(3px);
  }
  .card .card-content__button a:hover::after,
  .card .card-content__button button:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .card .card-content__button a,
  .card .card-content__button button {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .card .card-content__button a::before,
  .card .card-content__button button::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .card .card-content__button a::after,
  .card .card-content__button button::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .card .card-content__button a:hover::before,
  .card .card-content__button button:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .card .card-content__button a,
  .card .card-content__button button {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .card .card-content__button a::before,
  .card .card-content__button button::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .card .card-content__button a,
  .card .card-content__button button {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .card .card-content__button a::before,
  .card .card-content__button button::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .card .card-content__button a::after,
  .card .card-content__button button::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}

@media screen and (max-width: 1330px) {
  .card {
    border-radius: 1.8045vw;
    padding: 0.4511vw;
    padding: 0.4511vw 0.4511vw 2.406vw 0.4511vw;
  }
  .card .card-img {
    height: 18.0451vw;
    border-radius: 1.3534vw;
  }
  .card .card-info {
    margin-top: 1.6541vw;
    gap: 1.5038vw;
    padding: 0 3.7594vw 0 1.9549vw;
  }
  .card .card-info__labels ul {
    gap: 0.7519vw;
  }
  .card .card-info__labels ul li {
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
    padding: 1.203vw 1.8045vw;
    border-radius: 3.7594vw;
  }
  .card .card-info__time {
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
  }
  .card .card-content {
    margin-top: 2.406vw;
    padding: 0 1.9549vw 3.0827vw;
  }
  .card .card-content__logo {
    width: 8.9474vw;
    height: 3.3083vw;
    margin-bottom: 0.9023vw;
  }
  .card .card-content__title {
    margin-bottom: 1.7293vw;
  }
  .card .card-content__title h3 {
    font-size: 1.8045vw;
    letter-spacing: -0.018vw;
  }
  .card .card-content__button {
    left: 2.3308vw;
    bottom: 3.4586vw;
  }
}
@media screen and (max-width: 1280px) {
  .card {
    border-radius: 1.875vw;
    padding: 0.4688vw 0.4688vw 2.6563vw 0.4688vw;
  }
  .card:hover {
    box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),
      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),
      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),
      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),
      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),
      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);
  }
  .card .card-img {
    height: 14.9219vw;
    border-radius: 1.4063vw;
  }
  .card .card-info {
    margin-top: 1.7969vw;
    gap: 1.5625vw;
    padding: 0 1.3281vw 0;
  }
  .card .card-info__labels ul {
    gap: 0.7813vw;
  }
  .card .card-info__labels ul li {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
    padding: 0.7813vw 1.25vw;
    border-radius: 3.9063vw;
  }
  .card .card-info__time {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
  }
  .card .card-content {
    margin-top: 1.9531vw;
    padding: 0 1.4063vw 1.9531vw;
  }
  .card .card-content__logo {
    width: 11.7188vw;
    height: auto;
    margin-bottom: 1.5625vw;
  }
  .card .card-content__title {
    margin-bottom: 1.1719vw;
  }
  .card .card-content__title h3 {
    font-size: 1.7188vw;
    letter-spacing: -0.0172vw;
  }
  .card .card-content__button {
    left: 1.875vw;
    bottom: 1.9531vw;
  }
}
@media screen and (max-width: 850px) {
  .card {
    border-radius: 4.1026vw;
    padding: 1.5385vw 1.5385vw 11.7949vw 1.5385vw;
  }
  .card:hover {
    box-shadow: 0px 0.7692vw 0.5128vw 0px rgba(0, 0, 0, 0.01),
      0px 1.7949vw 1.2821vw 0px rgba(0, 0, 0, 0.02),
      0px 3.0769vw 2.5641vw 0px rgba(0, 0, 0, 0.03),
      0px 5.641vw 4.6154vw 0px rgba(0, 0, 0, 0.03),
      0px 10.7692vw 8.4615vw 0px rgba(0, 0, 0, 0.04),
      0px 25.641vw 20.5128vw 0px rgba(0, 0, 0, 0.05);
  }
  .card .card-img {
    height: 52.3077vw;
    border-radius: 3.0769vw;
  }
  .card .card-info {
    margin-top: 4.1026vw;
    gap: 5.1282vw;
    padding: 0 10vw 0 3.5897vw;
  }
  .card .card-info__labels ul {
    gap: 2.5641vw;
  }
  .card .card-info__labels ul li {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
    padding: 4.1026vw 6.1538vw;
    border-radius: 12.8205vw;
  }
  .card .card-info__time {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .card .card-content {
    margin-top: 5.8974vw;
    padding: 0 4.359vw 0 4.359vw;
  }
  .card .card-content__logo {
    width: 30.5128vw;
    height: 11.2821vw;
    margin-bottom: 3.0769vw;
  }
  .card .card-content__logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .card .card-content__title {
    margin-bottom: 5.3846vw;
  }
  .card .card-content__title h3 {
    font-size: 5.641vw;
    line-height: 1.5;
    letter-spacing: -0.0564vw;
  }
  .card .card-content__button {
    left: 6.1538vw;
    bottom: 6.4103vw;
  }
}
@font-face {
  font-family: "Cambon";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
}
@font-face {
  font-family: "Circular Std";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
}
@font-face {
  font-family: "Circular Std";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
}
@font-face {
  font-family: "Circular Std";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}
.blockquote {
  width: calc(100% + 510px);
  margin: 50px -255px 32px;
  background-color: var(--light-gray);
  border-radius: 24px;
  padding: 114px 255px;
  position: relative;
  z-index: 2;
}
.blockquote::before {
  content: "";
  position: absolute;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.blockquote .blockquote__text {
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.28px;
  font-size: 28px;
  color: var(--dark);
  margin-bottom: 24px;
}
.blockquote .blockquote__subtext {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--dark);
  margin-bottom: 24px;
}
.blockquote .blockquote__info {
  margin-top: 48px;
  display: flex;
  align-items: center;
}
.blockquote .blockquote__info-img {
  flex: 0 0 auto;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
}
.blockquote .blockquote__info-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.blockquote .blockquote__info-name {
  font-weight: 500;
  font-size: 16px;
  color: var(--dark);
}
.blockquote .blockquote__info-position {
  font-weight: 400;
  font-size: 16px;
  color: var(--dark);
}

@media screen and (max-width: 1330px) {
  .blockquote {
    width: calc(100% + 38.3459vw);
    margin: 3.7594vw -19.1729vw 2.2556vw;
    border-radius: 1.8045vw;
    padding: 8.5714vw 19.1729vw;
  }
  .blockquote::before {
    top: -1.3534vw;
    width: 4.5113vw;
    height: 3.0075vw;
  }
  .blockquote .blockquote__text {
    letter-spacing: -0.0211vw;
    font-size: 2.1053vw;
    margin-bottom: 1.8045vw;
  }
  .blockquote .blockquote__subtext {
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
    margin-bottom: 1.8045vw;
  }
  .blockquote .blockquote__info {
    margin-top: 3.609vw;
  }
  .blockquote .blockquote__info-img {
    width: 4.3609vw;
    height: 4.3609vw;
    margin-right: 1.203vw;
  }
  .blockquote .blockquote__info-name {
    font-size: 1.203vw;
  }
  .blockquote .blockquote__info-position {
    font-size: 1.203vw;
  }
}
@media screen and (max-width: 850px) {
  .blockquote {
    width: calc(100% + 10.2564vw);
    margin: 10.7692vw -5.1282vw 6.1538vw;
    border-radius: 4.1026vw;
    padding: 20.5128vw 5.3846vw;
  }
  .blockquote::before {
    top: -4.6154vw;
    width: 15.3846vw;
    height: 10.2564vw;
  }
  .blockquote .blockquote__text {
    letter-spacing: -0.0564vw;
    font-size: 5.641vw;
    margin-bottom: 6.1538vw;
  }
  .blockquote .blockquote__subtext {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
    margin-bottom: 6.1538vw;
  }
  .blockquote .blockquote__info {
    margin-top: 8.2051vw;
  }
  .blockquote .blockquote__info-img {
    width: 14.8718vw;
    height: 14.8718vw;
    margin-right: 4.1026vw;
  }
  .blockquote .blockquote__info-name {
    font-size: 4.1026vw;
  }
  .blockquote .blockquote__info-position {
    font-size: 4.1026vw;
  }
}
.modal.modal-store .modal-dialog .modal-content {
  max-width: 766px;
  min-height: 490px;
  border-radius: 24px;
  overflow: hidden;
}
.modal.modal-store .modal-dialog .modal-content .modal-close {
  top: 21px;
  right: 22px;
  bottom: auto;
  left: auto;
}
.modal.modal-store .modal-dialog .modal-content .modal-close::before,
.modal.modal-store .modal-dialog .modal-content .modal-close::after {
  background-color: #2f2f2f;
  border-radius: 2px;
}
.modal.modal-store .modal-store__wrapper {
  display: flex;
  align-items: stretch;
}
.modal.modal-store .modal-store__image {
  width: 320px;
  height: 474px;
  flex: 0 0 auto;
  border-radius: 18px;
  margin: 8px 58px 8px 8px;
  overflow: hidden;
}
.modal.modal-store .modal-store__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.modal.modal-store .modal-store__form {
  width: 100%;
  height: auto;
  padding: 44px 60px 8px 0;
}
.modal.modal-store .modal-store__form.modal-store__form--thank {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 44px 59px 44px 0;
}
.modal.modal-store
  .modal-store__form.modal-store__form--thank
  .modal-store__form-title,
.modal.modal-store
  .modal-store__form.modal-store__form--thank
  .modal-store__form-wrapper {
  display: none;
}
.modal.modal-store
  .modal-store__form.modal-store__form--thank
  .modal-store__form-thank {
  display: block;
}
.modal.modal-store .modal-store__form .modal-store__form-title {
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.24px;
  font-size: 24px;
  color: var(--dark);
  margin-bottom: 21px;
}
.modal.modal-store .modal-store__form .modal-store__form-wrapper form {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-wrapper
  [class*="brand_name"] {
  display: none;
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-wrapper
  .hs-form-field
  > label {
  display: block;
  margin-bottom: 5px;
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-wrapper
  .hs-form-field
  > label
  span {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-wrapper
  .hs-form-field
  .input {
  width: 100%;
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-wrapper
  .hs-form-field
  .input
  input {
  width: 100%;
  height: 50px;
  border-radius: 8px;
  border: 1px solid #e9e4dc;
  background: #fff;
  outline: none;
  box-shadow: none;
  font-family: "Circular Std";
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-wrapper
  .hs-submit
  input[type="submit"] {
  border-radius: 12px;
  background: #161616;
  padding: 16px 25px;
  font-family: "Circular Std";
  font-weight: 500;
  font-size: 17px;
  color: #fff;
  cursor: pointer;
  border: none;
  outline: none;
}
.modal.modal-store .modal-store__form .modal-store__form-thank {
  display: none;
  text-align: center;
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-thank
  .form-thank__title {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.4;
  font-size: 32px;
  letter-spacing: -0.32px;
  color: var(--dark);
  margin-bottom: 5px;
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-thank
  .form-thank__message {
  font-weight: 500;
  line-height: 1.4;
  font-size: 20px;
  letter-spacing: -0.2px;
  color: var(--dark);
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-thank
  .form-thank__close-button {
  display: flex;
  justify-content: center;
  margin-top: 26px;
}
.modal.modal-store
  .modal-store__form
  .modal-store__form-thank
  .form-thank__close-button
  button,
.modal.modal-store
  .modal-store__form
  .modal-store__form-thank
  .form-thank__close-button
  a {
  font-family: "Circular Std";
  font-weight: 500;
  line-height: 1.5;
  font-size: 17px;
  color: var(--white);
  border-radius: 12px;
  background: var(--dark);
  padding: 14px 24px;
  cursor: pointer;
}

@media screen and (max-width: 850px) {
  .modal.modal-store .modal-dialog {
    padding: 20px 0;
  }
  .modal.modal-store .modal-dialog .modal-content {
    max-width: 100%;
    min-height: 0;
    border-radius: 24px;
    padding: 20px 20px 50px;
  }
  .modal.modal-store .modal-dialog .modal-content .modal-close {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    top: 38px;
    right: 31px;
    bottom: auto;
    left: auto;
  }
  .modal.modal-store .modal-dialog .modal-content .modal-close::before,
  .modal.modal-store .modal-dialog .modal-content .modal-close::after {
    width: 14px;
    background-color: #fff;
    border-radius: 2px;
  }
  .modal.modal-store .modal-store__wrapper {
    flex-direction: column;
  }
  .modal.modal-store .modal-store__image {
    width: 100%;
    height: 224px;
    border-radius: 18px;
    margin: 0 0 22px 0;
  }
  .modal.modal-store .modal-store__form {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
    padding: 0;
  }
  .modal.modal-store .modal-store__form.modal-store__form--thank {
    padding: 0;
  }
  .modal.modal-store .modal-store__form .modal-store__form-title {
    line-height: 1.4;
    letter-spacing: -0.24px;
    font-size: 24px;
  }
  .modal.modal-store .modal-store__form .modal-store__form-wrapper form {
    grid-gap: 20px;
  }
  .modal.modal-store
    .modal-store__form
    .modal-store__form-wrapper
    .hs-form-field
    > label {
    margin-bottom: 5px;
  }
  .modal.modal-store
    .modal-store__form
    .modal-store__form-wrapper
    .hs-form-field
    > label
    span {
    letter-spacing: -0.16px;
    font-size: 16px;
  }
  .modal.modal-store
    .modal-store__form
    .modal-store__form-wrapper
    .hs-form-field
    .input
    input {
    border-radius: 8px;
    letter-spacing: -0.16px;
    font-size: 16px;
  }
  .modal.modal-store
    .modal-store__form
    .modal-store__form-wrapper
    .hs-submit
    input[type="submit"] {
    border-radius: 12px;
    padding: 16px 25px;
    font-size: 17px;
  }
}
.modal.modal-detail.show-thank .modal-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal.modal-detail.show-thank .modal-detail__form-title {
  display: none;
}
.modal.modal-detail.show-thank .modal-detail__form-thank {
  display: block;
}
.modal.modal-detail .modal-dialog .modal-content {
  max-width: 660px;
  min-height: 560px;
  box-shadow: 0px 54px 120px rgba(255, 215, 72, 0.4);
  border-radius: 24px;
  padding: 48px 46px;
}
.modal.modal-detail .modal-dialog .modal-close {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  left: auto;
  bottom: auto;
}
.modal.modal-detail .modal-dialog .modal-close::before,
.modal.modal-detail .modal-dialog .modal-close::after {
  background-color: #2f2f2f;
}
.modal.modal-detail .modal-detail__form-title {
  font-weight: 500;
  line-height: 1.27;
  font-size: 18px;
  letter-spacing: -0.01em;
  color: #2f2f2f;
  margin-bottom: 36px;
}
.modal.modal-detail .modal-detail__form-wrapper .submitted-message {
  display: none;
}
.modal.modal-detail .modal-detail__form-wrapper form {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 25px 20px;
}
.modal.modal-detail .modal-detail__form-wrapper form fieldset {
  width: 100%;
  max-width: 100%;
}
.modal.modal-detail .modal-detail__form-wrapper form .input {
  margin: 0;
}
.modal.modal-detail .modal-detail__form-wrapper form .form-columns-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}
.modal.modal-detail .modal-detail__form-wrapper form .hs-error-msg {
  color: red !important;
}
.modal.modal-detail .modal-detail__form-wrapper form .hs_error_rollup {
  order: 1;
  -ms-grid-column-span: 2;
  grid-column: span 2;
  text-align: center;
  color: red;
}
.modal.modal-detail .modal-detail__form-wrapper form .field {
  width: 100%;
  float: none;
}
.modal.modal-detail .modal-detail__form-wrapper form .field > label {
  display: block;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.01em;
  color: #161616;
  margin-bottom: 8px;
}
.modal.modal-detail .modal-detail__form-wrapper form .field .input input {
  width: 100%;
  height: 54px;
  border: none;
  outline: none;
  border-radius: 8px;
  background: #f6f5ef;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: "Circular Std";
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.01em;
  color: #161616;
}
.modal.modal-detail
  .modal-detail__form-wrapper
  form
  .field
  .input
  input::placeholder {
  font-family: "Circular Std";
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.01em;
  color: rgba(22, 22, 22, 0.4);
}
.modal.modal-detail
  .modal-detail__form-wrapper
  form
  .field
  .input
  input:-moz-placeholder {
  font-family: "Circular Std";
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.01em;
  color: rgba(22, 22, 22, 0.4);
}
.modal.modal-detail
  .modal-detail__form-wrapper
  form
  .field
  .input
  input::-moz-placeholder {
  font-family: "Circular Std";
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.01em;
  color: rgba(22, 22, 22, 0.4);
}
.modal.modal-detail .modal-detail__form-wrapper form .hs_submit {
  display: flex;
  justify-content: flex-start;
}
.modal.modal-detail .modal-detail__form-wrapper form .hs_submit .hs-button {
  cursor: pointer;
  font-family: "Circular Std";
  font-weight: 500;
  font-size: 17px;
  color: #ffffff;
  border-radius: 12px;
  background: var(--dark);
  padding: 16px 48px;
  border: none;
}
.modal.modal-detail .modal-detail__form-thank {
  display: none;
}
.modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-title {
  width: 100%;
  max-width: 430px;
  margin: 0 auto 40px;
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  font-size: 40px;
  letter-spacing: -0.01em;
  color: #161616;
  text-align: center;
}
.modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-text {
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
  font-weight: 500;
  line-height: 1.27;
  font-size: 18px;
  letter-spacing: -0.01em;
  text-align: center;
  color: #2f2f2f;
}

@media screen and (max-width: 1330px) {
  .modal.modal-detail .modal-dialog .modal-content {
    max-width: 49.6241vw;
    min-height: 42.1053vw;
    box-shadow: 0px 4.0602vw 9.0226vw rgba(255, 215, 72, 0.4);
    border-radius: 1.8045vw;
    padding: 3.609vw 3.4586vw;
  }
  .modal.modal-detail .modal-dialog .modal-close {
    width: 1.0526vw;
    height: 1.0526vw;
    top: 1.5038vw;
    right: 1.5038vw;
  }
  .modal.modal-detail .modal-detail__form-title {
    font-size: 1.3534vw;
    margin-bottom: 2.7068vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form {
    grid-gap: 1.8797vw 1.5038vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .form-columns-2 {
    grid-gap: 1.5038vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .field > label {
    font-size: 1.203vw;
    margin-bottom: 0.6015vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .field .input input {
    height: 4.0602vw;
    border-radius: 0.6015vw;
    padding: 1.203vw;
    font-size: 1.203vw;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input::placeholder {
    font-size: 1.203vw;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input:-moz-placeholder {
    font-size: 1.203vw;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input::-moz-placeholder {
    font-size: 1.203vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .hs_submit .hs-button {
    font-size: 1.2782vw;
    border-radius: 0.9023vw;
    padding: 1.203vw 3.609vw;
  }
  .modal.modal-detail
    .modal-detail__form-thank
    .modal-detail__form-thank-title {
    max-width: 32.3308vw;
    margin: 0 auto 3.0075vw;
    font-size: 3.0075vw;
  }
  .modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-text {
    max-width: 21.0526vw;
    font-size: 1.3534vw;
  }
}
@media screen and (max-width: 1280px) {
  .modal.modal-detail .modal-dialog .modal-content {
    max-width: 51.5625vw;
    min-height: 43.75vw;
    box-shadow: 0px 4.2188vw 9.375vw rgba(255, 215, 72, 0.4);
    border-radius: 1.875vw;
    padding: 3.75vw 3.5938vw;
  }
  .modal.modal-detail .modal-dialog .modal-close {
    width: 1.0938vw;
    height: 1.0938vw;
    top: 1.5625vw;
    right: 1.5625vw;
  }
  .modal.modal-detail .modal-detail__form-title {
    font-size: 1.4063vw;
    margin-bottom: 2.8125vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form {
    grid-gap: 1.9531vw 1.5625vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .form-columns-2 {
    grid-gap: 1.5625vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .field > label {
    font-size: 1.25vw;
    margin-bottom: 0.625vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .field .input input {
    height: 4.2188vw;
    border-radius: 0.625vw;
    padding: 1.25vw;
    font-size: 1.25vw;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input::placeholder {
    font-size: 1.25vw;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input:-moz-placeholder {
    font-size: 1.25vw;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input::-moz-placeholder {
    font-size: 1.25vw;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .hs_submit .hs-button {
    font-size: 1.3281vw;
    border-radius: 0.9375vw;
    padding: 1.25vw 3.75vw;
  }
  .modal.modal-detail
    .modal-detail__form-thank
    .modal-detail__form-thank-title {
    max-width: 33.5938vw;
    margin: 0 auto 3.125vw;
    font-size: 2.7344vw;
  }
  .modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-text {
    max-width: 21.875vw;
    font-size: 1.4063vw;
  }
}
@media screen and (max-width: 850px) {
  .modal.modal-detail .modal-dialog {
    padding: 30px 20px;
  }
  .modal.modal-detail .modal-dialog .modal-content {
    max-width: 100%;
    min-height: 537px;
    box-shadow: 0px 54px 120px rgba(255, 215, 72, 0.4);
    border-radius: 15px;
    padding: 50px 20px;
  }
  .modal.modal-detail .modal-dialog .modal-close {
    width: 14px;
    height: 14px;
    top: 10px;
    right: 10px;
  }
  .modal.modal-detail .modal-detail__form-title {
    font-size: 18px;
    margin-bottom: 30px;
  }
  .modal.modal-detail .modal-detail__form-wrapper form {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .form-columns-2 {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .field > label {
    font-size: 16px;
    margin-bottom: 5px;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .field .input input {
    height: 40px;
    border-radius: 5px;
    padding: 15px;
    font-size: 16px;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input::placeholder {
    font-size: 16px;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input:-moz-placeholder {
    font-size: 16px;
  }
  .modal.modal-detail
    .modal-detail__form-wrapper
    form
    .field
    .input
    input::-moz-placeholder {
    font-size: 16px;
  }
  .modal.modal-detail .modal-detail__form-wrapper form .hs_submit .hs-button {
    font-size: 15px;
    border-radius: 10px;
    padding: 10px 35px;
  }
  .modal.modal-detail
    .modal-detail__form-thank
    .modal-detail__form-thank-title {
    max-width: 300px;
    margin: 0 auto 20px;
    font-size: 28px;
  }
  .modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-text {
    max-width: 250px;
    font-size: 16px;
  }
}
:root {
  --heightHeader: 80px;
  --heightHeaderToast: 124px;
  --heightMobileHeader: 60px;
}

.page-template-bfcm .header.header-scroll .header__inner::before {
  background-color: var(--white);
}
.page-template-bfcm .header .header__inner::before {
  background-color: var(--yellow);
}
.page-template-bfcm .header .header__buttons .header__request-button .btn {
  background-color: var(--dark);
  color: var(--white);
}

@media screen and (max-width: 1150px) {
  .page-template-lp .header__buttons {
    display: none !important;
  }
}

.page-template-memberships .header .header__inner::before {
  background-color: var(--dark);
}
.page-template-memberships .header .header__nav > ul > li::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@media screen and (min-width: 1150px) {
  .page-template-memberships .header .header__nav > ul > li:hover::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }
  .page-template-memberships .header .header__nav > ul > li:hover > a {
    color: var(--yellow);
  }
}
.page-template-memberships .header .header__nav > ul > li > a {
  color: var(--white);
}
.page-template-memberships .header .header__nav > ul > li > a::before {
  background-color: var(--yellow);
}
.page-template-memberships .header .header__buttons .header__price-button a,
.page-template-memberships
  .header
  .header__buttons
  .header__price-button
  button {
  color: var(--white);
}
.page-template-memberships .header .header__menu::before,
.page-template-memberships .header .header__menu strong,
.page-template-memberships .header .header__menu::after {
  background-color: var(--white);
}
@media screen and (max-width: 1150px) {
  .page-template-memberships .header .header__nav {
    background-color: var(--dark);
  }
  .page-template-memberships
    .header
    .header__nav
    > ul
    .menu-item-has-children.open
    a {
    color: var(--white);
  }
  .page-template-memberships
    .header
    .header__nav
    > ul
    .menu-item-has-children.open
    a
    .nav-arrow {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }
  .page-template-memberships
    .header
    .header__nav
    > ul
    .menu-item-has-children
    a
    .nav-arrow {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }
  .page-template-memberships
    .header
    .header__nav
    > ul
    .menu-item-has-children
    .sub-menu {
    background: var(--dark);
  }
  .page-template-memberships
    .header
    .header__nav
    > ul
    .menu-item-has-children
    .sub-menu
    li
    a {
    color: var(--white);
  }
}

.header {
  width: 100%;
  height: var(--heightHeader);
  transition: height 0.4s;
}
.header.header-scroll .header__logo .main-logo {
  opacity: 0;
}
.header.header-scroll .header__logo .main-scroll-logo {
  opacity: 1;
}
.header.header--toast {
  height: var(--heightHeaderToast);
}
.header.header--toast .header__inner {
  top: 44px;
  transition-delay: 0.1s;
}
.header.header--toast.header-scroll .header__inner,
.header.header--toast.open-menu .header__inner {
  top: 0 !important;
  transition-delay: 0s;
}
.header .header__inner {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: var(--heightHeader);
  padding: 16px 0;
  transition: top 0.2s;
}
.header .header__inner::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--white);
  transition: all 0.4s linear;
}
.header .header__wrapper {
  display: flex;
  align-items: center;
  gap: 43px;
}
.header .header__logo {
  width: 128px;
  height: 28px;
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
}
.header .header__logo a,
.header .header__logo img {
  width: 100%;
  height: 100%;
}
.header .header__logo img {
  object-fit: contain;
  transition: all 0.4s linear;
}
.header .header__logo .main-scroll-logo {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.header .header__nav > ul {
  display: flex;
  align-items: center;
  margin-right: auto;
}
.header .header__nav > ul > li:not(:first-child) {
  margin-left: 39px;
}
.header .header__nav > ul > li > a {
  font-weight: 400;
  font-size: 17px;
  color: var(--gray);
  transition: all 0.4s linear;
  position: relative;
  z-index: 2;
}
.header .header__nav > ul > li > a::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 0%;
  height: 2px;
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 1150px) {
  .header .header__nav > ul > li:hover a {
    color: var(--dark);
  }
  .header .header__nav > ul > li:hover a::before {
    width: 100%;
  }
}
.header .header__nav > ul .menu-item-has-children {
  position: relative;
  z-index: 2;
  padding-right: 16px;
  position: relative;
  z-index: 2;
}
.header .header__nav > ul .menu-item-has-children::before {
  content: "";
  position: absolute;
  top: 5px;
  right: 0;
  width: 9px;
  height: 6px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.header .header__nav > ul .menu-item-has-children::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 0%;
  height: 2px;
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 1150px) {
  .header .header__nav > ul .menu-item-has-children:hover::before {
    transform: rotate(-180deg);
  }
  .header .header__nav > ul .menu-item-has-children:hover::after {
    width: 100%;
  }
  .header .header__nav > ul .menu-item-has-children:hover > a {
    color: var(--dark);
  }
  .header .header__nav > ul .menu-item-has-children:hover .sub-menu {
    opacity: 1;
    transform: translateX(-50%) translateY(0px);
    pointer-events: all;
  }
}
.header .header__nav > ul .menu-item-has-children .sub-menu {
  position: absolute;
  top: calc(100% + 31px);
  left: calc(50% + 38px);
  transform: translateX(-50%) translateY(10px);
  display: flex;
  flex-direction: column;
  width: 252px;
  border-radius: 24px;
  background: var(--white);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1),
    0px 0px 2px 0px rgba(0, 0, 0, 0.06);
  padding: 31px;
  opacity: 0;
  transition: all 0.3s linear;
  pointer-events: none;
}
.header .header__nav > ul .menu-item-has-children .sub-menu::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -31px;
  left: 0;
  width: 100%;
  height: 100%;
}
.header
  .header__nav
  > ul
  .menu-item-has-children
  .sub-menu
  li:not(:first-child) {
  margin-top: 16px;
}
.header .header__nav > ul .menu-item-has-children .sub-menu li a {
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--gray);
  transition: all 0.3s linear;
  position: relative;
  z-index: 2;
}
.header .header__nav > ul .menu-item-has-children .sub-menu li a::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 0%;
  height: 2px;
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 1150px) {
  .header .header__nav > ul .menu-item-has-children .sub-menu li a:hover {
    color: var(--dark);
  }
  .header
    .header__nav
    > ul
    .menu-item-has-children
    .sub-menu
    li
    a:hover::before {
    width: 100%;
  }
}
.header .header__buttons {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 40px;
}
.header .header__buttons .header__price-button a,
.header .header__buttons .header__price-button button {
  font-weight: 400;
  font-size: 17px;
  color: var(--gray);
}
.header .header__buttons .header__request-button .btn {
  padding: 16px 24px;
}
.header .header__menu {
  display: none;
}

@media screen and (max-width: 1280px) {
  :root {
    --heightHeader: 6.25vw;
    --heightHeaderToast: 9.6875vw;
  }
  .header.header--toast {
    height: var(--heightHeaderToast);
  }
  .header.header--toast .header__inner {
    top: 3.4375vw;
  }
  .header .header__inner {
    padding: 1.25vw 0;
  }
  .header .header__wrapper {
    gap: 3.3594vw;
  }
  .header .header__logo {
    width: 10vw;
    height: 2.1875vw;
  }
  .header .header__nav > ul > li:not(:first-child) {
    margin-left: 3.125vw;
  }
  .header .header__nav > ul > li > a {
    font-size: 1.3281vw;
  }
  .header .header__nav > ul > li > a::before {
    bottom: -0.3125vw;
    height: 0.1563vw;
  }
  .header .header__nav > ul .menu-item-has-children {
    padding-right: 1.5625vw;
  }
  .header .header__nav > ul .menu-item-has-children::before {
    top: 0.3906vw;
    right: 0;
    width: 0.7031vw;
    height: 0.4688vw;
  }
  .header .header__nav > ul .menu-item-has-children::after {
    bottom: -0.3125vw;
    height: 0.1563vw;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu {
    top: calc(100% + 2.4219vw);
    left: calc(50% + 2.9688vw);
    transform: translateX(-50%) translateY(0.7813vw);
    width: 19.6875vw;
    border-radius: 1.875vw;
    box-shadow: 0px 0px 0.7813vw 0px rgba(0, 0, 0, 0.1),
      0px 0px 0.1563vw 0px rgba(0, 0, 0, 0.06);
    padding: 2.4219vw;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu::before {
    top: -2.4219vw;
  }
  .header
    .header__nav
    > ul
    .menu-item-has-children
    .sub-menu
    li:not(:first-child) {
    margin-top: 1.25vw;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu li a {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu li a::before {
    height: 0.1563vw;
  }
  .header .header__buttons {
    gap: 3.5938vw;
  }
  .header .header__buttons .header__price-button a,
  .header .header__buttons .header__price-button button {
    font-size: 1.3281vw;
  }
  .header .header__buttons .header__request-button .btn {
    padding: 1.25vw 1.875vw;
  }
}
@media screen and (max-width: 1150px) {
  :root {
    --heightHeaderToast: 104px;
    --heightMobileHeader: 60px;
  }
  .header {
    height: var(--heightMobileHeader);
  }
  .header.header--toast {
    height: var(--heightHeaderToast);
  }
  .header.header--toast .header__inner {
    top: 44px;
  }
  .header .header__inner {
    height: var(--heightMobileHeader);
    padding: 16px 0;
  }
  .header .header__wrapper {
    gap: 20px;
  }
  .header .header__logo {
    width: 122px;
    height: 26px;
  }
  .header .header__nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    overflow: auto;
    z-index: -2;
    background-color: var(--white);
    padding: 106px 20px 50px;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: all 0.4s linear;
  }
  .header .header__nav.open {
    transform: translateX(0);
  }
  .header .header__nav > ul {
    width: 100%;
    align-items: flex-start;
    flex-direction: column;
    flex: 0 0 auto;
    margin-bottom: 30px;
  }
  .header .header__nav > ul > li {
    width: 100%;
    padding-bottom: 28px;
    border-bottom: 1px solid var(--white-2);
  }
  .header .header__nav > ul > li:not(:first-child) {
    margin-top: 25px;
    margin-left: 0;
  }
  .header .header__nav > ul > li > a {
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: -0.18px;
    font-size: 18px;
    color: var(--gray);
  }
  .header .header__nav > ul .menu-item-has-children {
    padding-right: 0;
  }
  .header .header__nav > ul .menu-item-has-children::before {
    display: none;
  }
  .header .header__nav > ul .menu-item-has-children.open a {
    color: var(--gray-3);
  }
  .header .header__nav > ul .menu-item-has-children.open a .nav-arrow {
    transform: rotateX(145deg);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  }
  .header .header__nav > ul .menu-item-has-children a {
    position: relative;
    z-index: 2;
    padding-right: 18px;
    transition: all 0.4s linear;
  }
  .header .header__nav > ul .menu-item-has-children a .nav-arrow {
    position: absolute;
    top: 8px;
    right: 0;
    width: 12px;
    height: 12px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transition: all 0.4s linear;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu {
    display: none;
    margin-top: 28px;
    position: relative;
    top: 0;
    left: 0;
    transform: translate(0, 0);
    width: 100%;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    opacity: 1;
    transition: none;
    pointer-events: all;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu::before {
    display: none;
  }
  .header
    .header__nav
    > ul
    .menu-item-has-children
    .sub-menu
    li:not(:first-child) {
    margin-top: 24px;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu li a {
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: -0.16px;
    font-size: 16px;
    color: var(--gray);
  }
  .header .header__buttons {
    display: none;
    flex: 0 0 auto;
    margin-top: auto;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 38px;
  }
  .header .header__buttons.show {
    display: flex;
  }
  .header .header__buttons .header__price-button {
    width: 100%;
  }
  .header .header__buttons .header__price-button a,
  .header .header__buttons .header__price-button button {
    width: 100%;
    font-size: 18px;
    text-align: center;
  }
  .header .header__buttons .header__request-button {
    width: 100%;
  }
  .header .header__buttons .header__request-button .btn {
    width: 100%;
    padding: 17px 24px;
  }
  .header .header__menu {
    display: block;
    width: 24px;
    height: 16px;
    position: relative;
    z-index: 2;
    margin-left: auto;
    margin-bottom: 3px;
    margin-right: 4px;
  }
  .header .header__menu::before,
  .header .header__menu strong,
  .header .header__menu::after {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background-color: var(--dark);
    transition: all 0.4s linear;
  }
  .header .header__menu::before {
    top: 0;
  }
  .header .header__menu strong {
    top: 50%;
    transform: translateY(-50%);
  }
  .header .header__menu::after {
    bottom: 0;
  }
  .header .header__menu.open::before {
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
  }
  .header .header__menu.open strong {
    transform: translateY(-50%) scale(0);
    opacity: 0;
  }
  .header .header__menu.open::after {
    bottom: 50%;
    transform: translateY(50%) rotate(-45deg);
  }
}
@media screen and (max-width: 850px) {
  :root {
    --heightHeaderToast: 31.2821vw;
    --heightMobileHeader: 15.3846vw;
  }
  .header {
    height: var(--heightMobileHeader);
  }
  .header.header--toast {
    height: var(--heightHeaderToast);
  }
  .header.header--toast .header__inner {
    top: 15.8974vw;
  }
  .header .header__inner {
    height: var(--heightMobileHeader);
    padding: 4.1026vw 0;
  }
  .header .header__wrapper {
    gap: 5.1282vw;
  }
  .header .header__logo {
    width: 31.2821vw;
    height: 6.6667vw;
  }
  .header .header__nav {
    padding: 27.1795vw 5.1282vw 12.8205vw;
  }
  .header .header__nav > ul {
    margin-bottom: 7.6923vw;
  }
  .header .header__nav > ul > li {
    padding-bottom: 7.1795vw;
  }
  .header .header__nav > ul > li:not(:first-child) {
    margin-top: 6.4103vw;
  }
  .header .header__nav > ul > li > a {
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
  }
  .header .header__nav > ul .menu-item-has-children a {
    padding-right: 4.6154vw;
  }
  .header .header__nav > ul .menu-item-has-children a .nav-arrow {
    top: 2.0513vw;
    width: 3.0769vw;
    height: 3.0769vw;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu {
    margin-top: 7.1795vw;
  }
  .header
    .header__nav
    > ul
    .menu-item-has-children
    .sub-menu
    li:not(:first-child) {
    margin-top: 6.1538vw;
  }
  .header .header__nav > ul .menu-item-has-children .sub-menu li a {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .header .header__buttons {
    gap: 9.7436vw;
  }
  .header .header__buttons .header__price-button a,
  .header .header__buttons .header__price-button button {
    font-size: 4.6154vw;
  }
  .header .header__buttons .header__request-button .btn {
    padding: 4.359vw 6.1538vw;
  }
  .header .header__menu {
    width: 6.1538vw;
    height: 4.1026vw;
    margin-bottom: 0.7692vw;
    margin-right: 1.0256vw;
  }
  .header .header__menu::before,
  .header .header__menu strong,
  .header .header__menu::after {
    height: 0.5128vw;
    border-radius: 0.5128vw;
  }
}
.archive .footer,
.blog .footer,
.single-post:not(.post-template-single-new) .footer,
.error404 .footer,
.page-template-integrations .footer,
.page-template-vip_store .footer,
.page-template-lp .footer,
.page-template-shopify-pos-lp .footer {
  background-color: var(--white);
}

.page-template-pricing .footer {
  background-color: var(--beige);
}

.single-customers .footer,
.page-template-contact_us .footer,
.page-template-thankyou .footer {
  background-color: var(--light-gray);
}

.archive .footer {
  margin-top: 138px;
}
@media screen and (max-width: 1330px) {
  .archive .footer {
    margin-top: 10.3759vw;
  }
}
@media screen and (max-width: 850px) {
  .archive .footer {
    margin-top: 23.0769vw;
  }
}

.footer {
  background-color: var(--yellow);
  padding: 0 30px 30px;
}
.footer.white-bg {
  background-color: var(--white);
}
.footer .footer__inner {
  background-color: var(--dark);
  border-radius: 24px;
  padding: 170px 0 43px;
}
.footer .footer__title {
  margin-bottom: 188px;
}
.footer .footer__title h2 {
  font-family: "Cambon";
  font-weight: 700;
  font-size: 62px;
  line-height: 1.1;
  letter-spacing: -0.62px;
  color: var(--white);
}
.footer .footer__title h2 a,
.footer .footer__title h2 span,
.footer .footer__title h2 strong {
  color: var(--yellow);
  transition: all 0.3s linear;
  position: relative;
  z-index: 2;
  padding-bottom: 6px;
}
.footer .footer__title h2 a::before,
.footer .footer__title h2 span::before,
.footer .footer__title h2 strong::before {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 4px;
  background-color: var(--yellow);
  transition: all 0.3s linear;
}
.footer .footer__title h2 a:hover,
.footer .footer__title h2 span:hover,
.footer .footer__title h2 strong:hover {
  color: var(--dark);
}
.footer .footer__title h2 a:hover::before,
.footer .footer__title h2 span:hover::before,
.footer .footer__title h2 strong:hover::before {
  height: 100%;
}
.footer .footer__list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 30px;
}
.footer .footer__list .list {
  width: 100%;
}
.footer .footer__list .list h4 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -0.24px;
  font-size: 24px;
  color: var(--white);
  margin-bottom: 28px;
}
.footer .footer__list .list ul li:not(:first-child) {
  margin-top: 18px;
}
.footer .footer__list .list ul li:hover a {
  color: #8f8b84;
}
.footer .footer__list .list ul li a {
  font-weight: 400;
  letter-spacing: -0.198px;
  font-size: 18px;
  color: var(--white-2);
  transition: all 0.3s linear;
}
.footer .footer__bottom {
  margin-top: 168px;
  padding-top: 49px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  gap: 48px;
}
.footer .footer__bottom-logo {
  width: 113px;
  height: 24px;
}
.footer .footer__bottom-logo a,
.footer .footer__bottom-logo img {
  width: 100%;
  height: 100%;
}
.footer .footer__bottom-logo img {
  object-fit: contain;
}
.footer .footer__bottom-copy {
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: -0.176px;
  color: var(--white);
  opacity: 0.3;
}
.footer .footer__bottom-social {
  margin-left: auto;
}
.footer .footer__bottom-social ul {
  display: flex;
  align-items: center;
  gap: 16px;
}
.footer .footer__bottom-social ul li {
  width: 24px;
  height: 24px;
}
.footer .footer__bottom-social ul li a,
.footer .footer__bottom-social ul li img {
  width: 100%;
  height: 100%;
}
.footer .footer__bottom-social ul li img {
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .footer {
    padding: 0 2.2556vw 2.2556vw;
  }
  .footer .footer__inner {
    border-radius: 1.8045vw;
    padding: 12.782vw 0 3.2331vw;
  }
  .footer .footer__title {
    margin-bottom: 14.1353vw;
  }
  .footer .footer__title h2 {
    font-size: 4.6617vw;
    letter-spacing: -0.0466vw;
  }
  .footer .footer__title h2 a,
  .footer .footer__title h2 span,
  .footer .footer__title h2 strong {
    padding-bottom: 0.4511vw;
  }
  .footer .footer__title h2 a::before,
  .footer .footer__title h2 span::before,
  .footer .footer__title h2 strong::before {
    height: 0.3008vw;
  }
  .footer .footer__list {
    grid-gap: 2.2556vw;
  }
  .footer .footer__list .list h4 {
    letter-spacing: -0.018vw;
    font-size: 1.8045vw;
    margin-bottom: 2.1053vw;
  }
  .footer .footer__list .list ul li:not(:first-child) {
    margin-top: 1.3534vw;
  }
  .footer .footer__list .list ul li a {
    letter-spacing: -0.0149vw;
    font-size: 1.3534vw;
  }
  .footer .footer__bottom {
    margin-top: 12.6316vw;
    padding-top: 3.6842vw;
    gap: 3.609vw;
  }
  .footer .footer__bottom-logo {
    width: 8.4962vw;
    height: 1.8045vw;
  }
  .footer .footer__bottom-copy {
    font-size: 1.203vw;
    letter-spacing: -0.0132vw;
  }
  .footer .footer__bottom-social ul {
    gap: 1.203vw;
  }
  .footer .footer__bottom-social ul li {
    width: 1.8045vw;
    height: 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .footer {
    padding: 0 2.3438vw 2.3438vw;
  }
  .footer .footer__inner {
    border-radius: 1.875vw;
    padding: 7.9688vw 0 3.2031vw;
  }
  .footer .footer__title {
    max-width: 54.6875vw;
    margin-bottom: 7.1094vw;
  }
  .footer .footer__title h2 {
    font-size: 2.9688vw;
    letter-spacing: -0.0297vw;
  }
  .footer .footer__title h2 a,
  .footer .footer__title h2 span,
  .footer .footer__title h2 strong {
    padding-bottom: 0.4688vw;
  }
  .footer .footer__title h2 a::before,
  .footer .footer__title h2 span::before,
  .footer .footer__title h2 strong::before {
    height: 0.1563vw;
  }
  .footer .footer__list {
    grid-gap: 2.3438vw;
  }
  .footer .footer__list .list h4 {
    letter-spacing: -0.0188vw;
    font-size: 1.875vw;
    margin-bottom: 2.2656vw;
  }
  .footer .footer__list .list ul li:not(:first-child) {
    margin-top: 1.4063vw;
  }
  .footer .footer__list .list ul li a {
    letter-spacing: -0.0155vw;
    font-size: 1.4063vw;
  }
  .footer .footer__bottom {
    margin-top: 10.8594vw;
    padding-top: 3.8281vw;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    gap: 3.75vw;
  }
  .footer .footer__bottom-logo {
    width: 8.8281vw;
    height: 1.875vw;
  }
  .footer .footer__bottom-copy {
    font-size: 1.25vw;
    letter-spacing: -0.0138vw;
  }
  .footer .footer__bottom-social ul {
    gap: 1.25vw;
  }
  .footer .footer__bottom-social ul li {
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .footer {
    padding: 0;
  }
  .footer.white-bg {
    margin-top: 7.6923vw;
  }
  .footer .footer__inner {
    border-radius: 4.1026vw 4.1026vw 0 0;
    padding: 21.0256vw 0 11.0256vw;
  }
  .footer .footer__title {
    max-width: 100%;
    margin-bottom: 16.4103vw;
  }
  .footer .footer__title h2 {
    font-size: 8.2051vw;
    line-height: 1.2;
    letter-spacing: -0.0821vw;
  }
  .footer .footer__title h2 a,
  .footer .footer__title h2 span,
  .footer .footer__title h2 strong {
    padding-bottom: 1.0256vw;
  }
  .footer .footer__title h2 a::before,
  .footer .footer__title h2 span::before,
  .footer .footer__title h2 strong::before {
    height: 0.5128vw;
  }
  .footer .footer__list {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8.2051vw 7.6923vw;
  }
  .footer .footer__list .list h4 {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
    margin-bottom: 4.6154vw;
  }
  .footer .footer__list .list ul li:not(:first-child) {
    margin-top: 2.5641vw;
  }
  .footer .footer__list .list ul li a {
    letter-spacing: -0.0367vw;
    font-size: 3.3333vw;
  }
  .footer .footer__bottom {
    margin-top: 12.0513vw;
    padding-top: 6.1538vw;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10.2564vw;
  }
  .footer .footer__bottom-logo {
    -ms-grid-column-span: 2;
    grid-column: span 2;
    width: 28.9744vw;
    height: 6.1538vw;
  }
  .footer .footer__bottom-copy {
    font-size: 3.0769vw;
    letter-spacing: -0.0338vw;
  }
  .footer .footer__bottom-social ul {
    gap: 4.1026vw;
  }
  .footer .footer__bottom-social ul li {
    width: 6.1538vw;
    height: 6.1538vw;
  }
}
.page-template-lp .footer .footer__list,
.page-template-shopify-pos-lp .footer .footer__list {
  display: none;
}
.page-template-lp .footer .footer__title,
.page-template-shopify-pos-lp .footer .footer__title {
  margin-bottom: 70px;
}
.page-template-lp .footer .footer__bottom,
.page-template-shopify-pos-lp .footer .footer__bottom {
  margin-top: 70px;
}
@media screen and (max-width: 1330px) {
  .page-template-lp .footer .footer__title,
  .page-template-shopify-pos-lp .footer .footer__title {
    margin-bottom: 5.263vw;
  }
  .page-template-lp .footer .footer__bottom,
  .page-template-shopify-pos-lp .footer .footer__bottom {
    margin-top: 5.263vw;
  }
}
@media screen and (max-width: 1280px) {
  .page-template-lp .footer .footer__title,
  .page-template-shopify-pos-lp .footer .footer__title {
    margin-bottom: 5.469vw;
  }
  .page-template-lp .footer .footer__bottom,
  .page-template-shopify-pos-lp .footer .footer__bottom {
    margin-top: 5.469vw;
  }
}
@media screen and (max-width: 850px) {
  .page-template-lp .footer .footer__title,
  .page-template-shopify-pos-lp .footer .footer__title {
    margin-bottom: 17.949vw;
  }
  .page-template-lp .footer .footer__bottom,
  .page-template-shopify-pos-lp .footer .footer__bottom {
    margin-top: 17.949vw;
  }
}

@media screen and (max-width: 1550px) and (min-width: 1280px) {
  .page-template-shopify-pos-lp .footer .container {
    max-width: 82.806vw;
  }
  .page-template-shopify-pos-lp .footer .footer__title h2 {
    font-size: 4vw;
  }
}
.first-screen-home .first-screen-home__inner {
  padding: 104px 0;
}
.first-screen-home .first-screen-home__wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;
}
.first-screen-home .first-screen-home__content {
  width: 100%;
  max-width: 743px;
}
.first-screen-home .first-screen-home__content-title {
  margin-bottom: 29px;
}
.first-screen-home .first-screen-home__content-title h1 {
  font-family: "Cambon";
  font-weight: 700;
  font-size: 62px;
  line-height: 1.1;
  color: var(--dark);
  letter-spacing: -0.62px;
}
.first-screen-home .first-screen-home__content-text {
  width: 100%;
  max-width: 528px;
  font-weight: 400;
  line-height: 1.4;
  font-size: 24px;
  letter-spacing: -0.45px;
  color: var(--gray);
}
.first-screen-home .first-screen-home__content-buttons {
  margin-top: 28px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.first-screen-home .first-screen-home__content-message {
  width: 100%;
  max-width: 470px;
  display: flex;
  justify-content: flex-start;
  margin-top: 82px;
}
.first-screen-home .first-screen-home__content-message-text {
  font-weight: 400;
  line-height: 1.5;
  font-size: 18px;
  color: var(--gray);
  letter-spacing: -0.34px;
}
.first-screen-home .first-screen-home__content-message-text a {
  position: relative;
  z-index: 2;
  padding-right: 28px;
  padding-bottom: 2px;
}
.first-screen-home .first-screen-home__content-message-text a::before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.first-screen-home .first-screen-home__content-message-text a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 28px);
  height: 2px;
  transform: translateX(-28px);
  background-color: var(--gray);
  transition: all 0.3s linear;
}
.first-screen-home .first-screen-home__content-message-text a:hover::before {
  transform: translateX(3px);
}
.first-screen-home .first-screen-home__content-message-text a:hover::after {
  width: 0%;
}
.first-screen-home .first-screen-home__media {
  width: 100%;
  margin-top: -4px;
  max-width: 520px;
  position: relative;
  z-index: 2;
  opacity: 0;
}
.first-screen-home .first-screen-home__media.is-animation {
  animation: showItem 1s linear both;
}
.first-screen-home .first-screen-home__media-decorative {
  position: absolute;
  z-index: 2;
  left: -108px;
  bottom: -12px;
  width: 169px;
  height: 136px;
}
.first-screen-home .first-screen-home__media-decorative img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.first-screen-home .first-screen-home__media-decorative lottie-player {
  width: 100%;
  height: 100%;
}
.first-screen-home .first-screen-home__media-list {
  width: 100%;
  height: 520px;
  border-radius: 24px;
  overflow: hidden;
}
.first-screen-home .first-screen-home__media-list .list {
  width: 100%;
  height: 100%;
}
.first-screen-home .first-screen-home__media-list .list .slick-list,
.first-screen-home .first-screen-home__media-list .list .slick-track {
  width: 100%;
  height: 100%;
}
.first-screen-home .first-screen-home__media-list .item {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.first-screen-home .first-screen-home__media-list .item-wrapper {
  padding: 30px 32px;
}
.first-screen-home .first-screen-home__media-list .item-image {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.first-screen-home .first-screen-home__media-list .item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.first-screen-home .first-screen-home__media-list .item-labels {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.first-screen-home .first-screen-home__media-list .item .item-label {
  display: flex;
  align-items: center;
  border-radius: 12px;
  background-color: var(--white);
  padding: 16px 7px 16px 14px;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.4s linear;
}
.first-screen-home .first-screen-home__media-list .item .item-label.show {
  transform: translateY(0px);
  opacity: 1;
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label:not(:first-child) {
  margin-top: 13px;
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label.item-label--white {
  padding: 15px 16px 15px 12px;
  background-color: var(--white);
  color: var(--dark);
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label.item-label--black {
  padding: 15px 14px 18px;
  background-color: var(--dark);
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label.item-label--black
  .item-label__content {
  text-align: center;
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label.item-label--black
  .item-label__content-title {
  font-weight: 400;
  font-size: 12px;
  letter-spacing: -0.36px;
  color: var(--white);
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label.item-label--black
  .item-label__content-subtitle {
  font-weight: 500;
  font-size: 25px;
  letter-spacing: -0.753px;
  color: var(--white);
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label.item-label--yellow {
  padding: 16px 18px 16px 14px;
  background-color: var(--yellow);
  color: var(--dark);
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label
  .item-label__icon {
  width: 42px;
  height: 42px;
  margin-right: 14px;
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label
  .item-label__icon
  img {
  width: 100%;
  height: 100%;
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label
  .item-label__content-title,
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label
  .item-label__content-subtitle {
  font-weight: 400;
  font-size: 16px;
  color: var(--dark);
  letter-spacing: -0.475px;
}
.first-screen-home
  .first-screen-home__media-list
  .item
  .item-label
  .item-label__content-title {
  margin-bottom: 3px;
}
@media screen and (max-width: 1330px) {
  .first-screen-home .first-screen-home__inner {
    padding: 7.8195vw 0;
  }
  .first-screen-home .first-screen-home__wrapper {
    gap: 2.2556vw;
  }
  .first-screen-home .first-screen-home__content {
    max-width: 55.8647vw;
  }
  .first-screen-home .first-screen-home__content-title {
    margin-bottom: 2.1805vw;
  }
  .first-screen-home .first-screen-home__content-title h1 {
    font-size: 4.6617vw;
    letter-spacing: -0.0466vw;
  }
  .first-screen-home .first-screen-home__content-text {
    max-width: 39.6992vw;
    font-size: 1.8045vw;
    letter-spacing: -0.0338vw;
  }
  .first-screen-home .first-screen-home__content-buttons {
    margin-top: 2.1053vw;
    gap: 1.203vw;
  }
  .first-screen-home .first-screen-home__content-message {
    max-width: 35.3383vw;
    margin-top: 6.1654vw;
  }
  .first-screen-home .first-screen-home__content-message-text {
    font-size: 1.3534vw;
    letter-spacing: -0.0256vw;
  }
  .first-screen-home .first-screen-home__content-message-text a {
    padding-right: 2.1053vw;
    padding-bottom: 0.1504vw;
  }
  .first-screen-home .first-screen-home__content-message-text a::before {
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .first-screen-home .first-screen-home__content-message-text a::after {
    width: calc(100% - 2.1053vw);
    height: 0.1504vw;
    transform: translateX(-2.1053vw);
  }
  .first-screen-home .first-screen-home__media {
    margin-top: -0.3008vw;
    max-width: 39.0977vw;
  }
  .first-screen-home .first-screen-home__media-decorative {
    left: -8.1203vw;
    bottom: -0.9023vw;
    width: 12.7068vw;
    height: 10.2256vw;
  }
  .first-screen-home .first-screen-home__media-list {
    height: 39.0977vw;
    border-radius: 1.8045vw;
  }
  .first-screen-home .first-screen-home__media-list .item-wrapper {
    padding: 2.2556vw 2.406vw;
  }
  .first-screen-home .first-screen-home__media-list .item .item-label {
    border-radius: 0.9023vw;
    padding: 1.203vw 0.5263vw 1.203vw 1.0526vw;
    transform: translateY(3.7594vw);
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label:not(:first-child) {
    margin-top: 0.9774vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--white {
    padding: 1.1278vw 1.203vw 1.1278vw 0.9023vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black {
    padding: 1.1278vw 1.0526vw 1.3534vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black
    .item-label__content-title {
    font-size: 0.9023vw;
    letter-spacing: -0.0271vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black
    .item-label__content-subtitle {
    font-size: 1.8797vw;
    letter-spacing: -0.0566vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--yellow {
    padding: 1.203vw 1.3534vw 1.203vw 1.0526vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__icon {
    width: 3.1579vw;
    height: 3.1579vw;
    margin-right: 1.0526vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-title,
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-subtitle {
    font-size: 1.203vw;
    letter-spacing: -0.0357vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-title {
    margin-bottom: 0.2256vw;
  }
}
@media screen and (max-width: 1280px) {
  .first-screen-home .first-screen-home__inner {
    padding: 3.5938vw 0 7.4219vw;
  }
  .first-screen-home .first-screen-home__wrapper {
    gap: 5.9375vw;
  }
  .first-screen-home .first-screen-home__content {
    margin-top: 2.1094vw;
    max-width: 39.6875vw;
  }
  .first-screen-home .first-screen-home__content-title {
    margin-bottom: 2.1875vw;
  }
  .first-screen-home .first-screen-home__content-title h1 {
    font-size: 3.5938vw;
    letter-spacing: -0.0359vw;
  }
  .first-screen-home .first-screen-home__content-text {
    max-width: 30.9375vw;
    line-height: 1.5;
    font-size: 1.4063vw;
    letter-spacing: 0px;
  }
  .first-screen-home .first-screen-home__content-buttons {
    margin-top: 2.6563vw;
    gap: 1.25vw;
  }
  .first-screen-home .first-screen-home__content-message {
    max-width: 32.8125vw;
    margin-top: 2.5vw;
  }
  .first-screen-home .first-screen-home__content-message-text {
    line-height: 1.4;
    font-size: 1.25vw;
    letter-spacing: 0px;
  }
  .first-screen-home .first-screen-home__content-message-text a {
    padding-right: 2.1875vw;
    padding-bottom: 0.1563vw;
  }
  .first-screen-home .first-screen-home__content-message-text a::before {
    width: 1.875vw;
    height: 1.875vw;
  }
  .first-screen-home .first-screen-home__content-message-text a::after {
    width: calc(100% - 2.1875vw);
    height: 0.1563vw;
    transform: translateX(-2.1875vw);
  }
  .first-screen-home .first-screen-home__media {
    margin-top: 0;
    max-width: 32.4219vw;
  }
  .first-screen-home .first-screen-home__media-decorative {
    left: 2.7344vw;
    bottom: -5.3906vw;
    width: 11.0156vw;
    height: 11.0156vw;
  }
  .first-screen-home .first-screen-home__media-list {
    height: 32.6563vw;
    border-radius: 1.875vw;
  }
  .first-screen-home .first-screen-home__media-list .item-wrapper {
    padding: 1.9531vw;
  }
  .first-screen-home .first-screen-home__media-list .item .item-label {
    border-radius: 0.7813vw;
    padding: 0.9375vw 0.4688vw;
    transform: translateY(3.9063vw);
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label:not(:first-child) {
    margin-top: 0.8594vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--white {
    padding: 1.0156vw 0.4688vw 1.0156vw 0.8594vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black {
    padding: 0.9375vw 0.8594vw 1.1719vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black
    .item-label__content-title {
    font-size: 0.7813vw;
    letter-spacing: -0.0226vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black
    .item-label__content-subtitle {
    font-size: 1.5625vw;
    letter-spacing: -0.0473vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--yellow {
    padding: 1.0156vw 1.1719vw 0.9375vw 0.8594vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__icon {
    width: 2.5781vw;
    height: 2.5781vw;
    margin-right: 0.9375vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-title,
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-subtitle {
    font-size: 0.9375vw;
    letter-spacing: -0.0298vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-title {
    margin-bottom: 0.2344vw;
  }
}
@media screen and (max-width: 850px) {
  .first-screen-home .first-screen-home__inner {
    padding: 12.0513vw 0 26.6667vw;
  }
  .first-screen-home .first-screen-home__wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14.359vw;
  }
  .first-screen-home .first-screen-home__content {
    max-width: 100%;
  }
  .first-screen-home .first-screen-home__content-title {
    margin-bottom: 5.3846vw;
  }
  .first-screen-home .first-screen-home__content-title h1 {
    font-size: 9.7436vw;
    letter-spacing: -0.0974vw;
  }
  .first-screen-home .first-screen-home__content-text {
    max-width: 100%;
    line-height: 1.5;
    font-size: 4.6154vw;
    letter-spacing: -0.0462vw;
  }
  .first-screen-home .first-screen-home__content-buttons {
    margin-top: 6.1538vw;
    gap: 4.1026vw;
  }
  .first-screen-home .first-screen-home__content-button {
    text-align: center;
  }
  .first-screen-home .first-screen-home__content-button:first-child {
    flex: 0 0 auto;
  }
  .first-screen-home .first-screen-home__content-button:last-child {
    width: 100%;
  }
  .first-screen-home .first-screen-home__content-button:last-child .btn-border {
    width: 100%;
  }
  .first-screen-home .first-screen-home__content-message {
    width: 100%;
    max-width: 64.6154vw;
    margin-top: 6.1538vw;
  }
  .first-screen-home .first-screen-home__content-message-text {
    line-height: 1.4;
    font-size: 4.1026vw;
    letter-spacing: -0.0769vw;
  }
  .first-screen-home .first-screen-home__content-message-text a {
    padding-right: 7.1795vw;
    padding-bottom: 0;
  }
  .first-screen-home .first-screen-home__content-message-text a::before {
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .first-screen-home .first-screen-home__content-message-text a::after {
    width: calc(100% - 7.1795vw);
    transform: translateX(-7.1795vw);
    height: 2px;
  }
  .first-screen-home .first-screen-home__media {
    margin-top: 0;
    max-width: 100%;
  }
  .first-screen-home .first-screen-home__media-decorative {
    left: 12.3077vw;
    bottom: -12.3077vw;
    width: 30vw;
    height: 24.1026vw;
  }
  .first-screen-home .first-screen-home__media-list {
    height: 89.2308vw;
    border-radius: 4.1026vw;
  }
  .first-screen-home .first-screen-home__media-list .item-wrapper {
    padding: 5.1282vw 5.3846vw;
  }
  .first-screen-home .first-screen-home__media-list .item .item-label {
    border-radius: 2.0513vw;
    padding: 2.5641vw 1.2821vw 3.0769vw 2.3077vw;
    transform: translateY(6.4103vw);
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label:not(:first-child) {
    margin-top: 2.5641vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--white {
    padding: 2.3077vw 3.3333vw 2.8205vw 2.3077vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black {
    padding: 2.5641vw 2.5641vw 3.0769vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black
    .item-label__content-title {
    font-size: 2.0513vw;
    letter-spacing: -0.0618vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--black
    .item-label__content-subtitle {
    font-size: 4.1026vw;
    letter-spacing: -0.1292vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label.item-label--yellow {
    padding: 2.5641vw 4.6154vw 2.5641vw 2.3077vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__icon {
    width: 7.1795vw;
    height: 7.1795vw;
    margin-right: 2.5641vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-title,
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-subtitle {
    font-size: 2.5641vw;
    letter-spacing: -0.0815vw;
  }
  .first-screen-home
    .first-screen-home__media-list
    .item
    .item-label
    .item-label__content-title {
    margin-bottom: 0.7692vw;
  }
}
@keyframes showItem {
  0% {
    opacity: 0;
    transform: translateX(10px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}
.first-screen {
  padding: 0 30px;
}
.first-screen.white-text .first-screen__content-label,
.first-screen.white-text .first-screen__content-title h1,
.first-screen.white-text .first-screen__content-text {
  color: var(--white);
}
.first-screen.white-text .first-screen__content-message a {
  color: var(--white);
}
.first-screen.white-text .first-screen__content-message a::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.first-screen.white-text .first-screen__content-message a::after {
  background-color: var(--white);
}
.first-screen.white-text .first-screen__content-message a.black-text {
  color: var(--dark);
}
.first-screen.white-text .first-screen__content-message a.black-text::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.first-screen.white-text .first-screen__content-message a.black-text::after {
  background-color: var(--dark);
}
.first-screen.first-screen--type-1 .first-screen__media {
  max-width: 500px;
  height: 568px;
  margin-top: -5px;
  margin-right: 65px;
}
.first-screen.first-screen--type-2 .first-screen__content {
  width: 100%;
  max-width: 557px;
}
.first-screen.first-screen--type-2 .first-screen__media {
  max-width: 604px;
  height: 470px;
  margin-top: 34px;
  margin-right: 13px;
}
.first-screen.first-screen--type-2 .first-screen__media-dec {
  width: 156px;
  height: 135px;
  right: 17px;
  bottom: 0px;
}
.first-screen.first-screen--type-3 .first-screen__content {
  max-width: 460px;
  margin-top: 42px;
}
.first-screen.first-screen--type-3 .first-screen__media {
  max-width: 500px;
  height: 564px;
  margin-top: -4px;
  margin-right: 65px;
}
.first-screen.first-screen--type-3 .first-screen__media-dec {
  width: 188px;
  height: 158px;
  right: 26px;
  bottom: -64px;
}
.first-screen.first-screen--type-4 .first-screen__content {
  max-width: 594px;
  margin-top: 0px;
}
.first-screen.first-screen--type-4 .first-screen__media {
  max-width: 500px;
  height: 584px;
  margin-top: -4px;
  margin-right: 65px;
}
.first-screen.first-screen--type-4 .first-screen__media-dec {
  width: 207px;
  height: 207px;
  left: 25px;
  right: auto;
  bottom: -84px;
}
.first-screen.first-screen--type-5 .first-screen__content {
  max-width: 594px;
  margin-top: 0px;
}
.first-screen.first-screen--type-5 .first-screen__media {
  max-width: 500px;
  height: 579px;
  margin-top: -4px;
  margin-right: 65px;
}
.first-screen.first-screen--type-5 .first-screen__media-dec {
  width: 202px;
  height: 202px;
  left: 4px;
  right: auto;
  bottom: -79px;
}
.first-screen.first-screen--type-6 .first-screen__content {
  max-width: 594px;
}
.first-screen.first-screen--type-6 .first-screen__media {
  max-width: 632px;
  height: 550px;
  margin-top: 17px;
  margin-right: 13px;
}
.first-screen.first-screen--type-7 .first-screen__content {
  max-width: 594px;
}
.first-screen.first-screen--type-7 .first-screen__media {
  max-width: 500px;
  height: 590px;
  margin-top: -4px;
  margin-right: 66px;
}
.first-screen.first-screen--type-lp .first-screen__content-button .btn-border {
  display: none;
}
.first-screen.first-screen--type-pos-lp.white-text
  .first-screen__content-message
  a {
  color: var(--dark);
}
.first-screen.first-screen--type-pos-lp.white-text
  .first-screen__content-message
  a::after {
  background-color: var(--dark);
}
.first-screen.first-screen--type-pos-lp.white-text
  .first-screen__content-message
  a::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.first-screen.first-screen--type-pos-lp .first-screen__media {
  max-width: 830px;
  height: 583px;
  margin-right: -96px;
  margin-bottom: 60px;
  margin-top: 40px;
}
.first-screen.first-screen--type-pos-lp .first-screen__inner {
  padding-bottom: 30px;
}
.first-screen.first-screen--type-pos-lp .first-screen__content-title {
  position: relative;
  margin-bottom: 24px;
}
.first-screen.first-screen--type-pos-lp .first-screen__content-title h1 {
  position: relative;
  z-index: 2;
  letter-spacing: 1px;
}
.first-screen.first-screen--type-pos-lp .first-screen__content-title::after {
  content: "";
  background-size: contain;
  background-position: left center;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  position: absolute;
  bottom: -8px;
  width: 345px;
  height: 23px;
  left: 0;
  z-index: 0;
}
.first-screen.first-screen--type-pos-lp .first-screen__wrapper {
  gap: 0;
}
.first-screen.first-screen--dark .first-screen__inner {
  position: relative;
  z-index: 2;
  background-color: #474643;
  min-height: 750px;
}
@media screen and (max-width: 1920px) {
  .first-screen.first-screen--dark .first-screen__inner {
    min-height: 39.0625vw;
  }
}
.first-screen.first-screen--dark .first-screen__inner::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.first-screen.first-screen--dark .first-screen__content-label,
.first-screen.first-screen--dark .first-screen__content-title h1,
.first-screen.first-screen--dark .first-screen__content-text,
.first-screen.first-screen--dark .first-screen__content-message a {
  color: var(--white);
}
.first-screen.first-screen--dark .first-screen__content-message a::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.first-screen.first-screen--dark .first-screen__content-message a::after {
  background-color: var(--white);
}
.first-screen.first-screen--dark .first-screen__media {
  position: absolute;
  bottom: 0;
  right: 68px;
  margin: 0;
  max-width: 841px;
  height: 650px;
}
@media screen and (max-width: 1920px) {
  .first-screen.first-screen--dark .first-screen__media {
    right: 3.5417vw;
    max-width: 43.8021vw;
    height: 33.8542vw;
  }
}
.first-screen .first-screen__inner {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  background-color: var(--purple);
  border-radius: 24px;
  overflow: hidden;
  padding: 105px 0 86px;
}
.first-screen .first-screen__wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;
}
.first-screen .first-screen__content {
  width: 100%;
  max-width: 630px;
}
.first-screen .first-screen__content-label {
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.14px;
  text-transform: uppercase;
  font-size: 14px;
  color: var(--dark);
  margin-bottom: 16px;
}
.first-screen .first-screen__content-title {
  margin-bottom: 17px;
}
.first-screen .first-screen__content-title h1 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.56px;
  font-size: 56px;
  color: var(--dark);
}
.first-screen .first-screen__content-text {
  width: 100%;
  max-width: 557px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.2px;
  font-size: 20px;
  color: var(--dark);
}
.first-screen .first-screen__content-button {
  margin-top: 32px;
}
.first-screen .first-screen__content-message {
  display: inline-block;
  margin-top: 41px;
}
.first-screen .first-screen__content-message a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.first-screen .first-screen__content-message a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.first-screen .first-screen__content-message a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .first-screen .first-screen__content-message a:hover::before {
    transform: translateX(3px);
  }
  .first-screen .first-screen__content-message a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .first-screen .first-screen__content-message a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .first-screen .first-screen__content-message a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .first-screen .first-screen__content-message a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .first-screen .first-screen__content-message a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .first-screen .first-screen__content-message a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .first-screen .first-screen__content-message a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .first-screen .first-screen__content-message a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .first-screen .first-screen__content-message a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .first-screen .first-screen__content-message a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.first-screen .first-screen__media {
  width: 100%;
  max-width: 500px;
  height: 490px;
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  margin-top: -5px;
  margin-right: 65px;
}
.first-screen .first-screen__media lottie-player {
  display: block;
  width: 100%;
  height: 100%;
}
.first-screen .first-screen__media-img {
  display: block;
  width: 100%;
  height: 100%;
}
.first-screen .first-screen__media-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.first-screen .first-screen__media-dec {
  width: 124px;
  height: 134px;
  position: absolute;
  z-index: 2;
  pointer-events: none;
  right: 53px;
  bottom: -68px;
}
.first-screen .first-screen__media-dec img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .first-screen {
    padding: 0 2.2556vw;
  }
  .first-screen.first-screen--type-1 .first-screen__media {
    max-width: 37.594vw;
    height: 42.7068vw;
    margin-top: -0.3759vw;
    margin-right: 4.8872vw;
  }
  .first-screen.first-screen--type-2 .first-screen__content {
    width: 100%;
    max-width: 41.8797vw;
  }
  .first-screen.first-screen--type-2 .first-screen__media {
    max-width: 45.4135vw;
    height: 35.3383vw;
    margin-top: 2.5564vw;
    margin-right: 0.9774vw;
  }
  .first-screen.first-screen--type-2 .first-screen__media-dec {
    width: 11.7293vw;
    height: 10.1504vw;
    right: 1.2782vw;
    bottom: 0px;
  }
  .first-screen.first-screen--type-3 .first-screen__content {
    max-width: 34.5865vw;
    margin-top: 3.1579vw;
  }
  .first-screen.first-screen--type-3 .first-screen__media {
    max-width: 37.594vw;
    height: 42.406vw;
    margin-top: -0.3008vw;
    margin-right: 4.8872vw;
  }
  .first-screen.first-screen--type-3 .first-screen__media-dec {
    width: 14.1353vw;
    height: 11.8797vw;
    right: 1.9549vw;
    bottom: -4.812vw;
  }
  .first-screen.first-screen--type-4 .first-screen__content {
    max-width: 44.6617vw;
    margin-top: 0px;
  }
  .first-screen.first-screen--type-4 .first-screen__media {
    max-width: 37.594vw;
    height: 43.9098vw;
    margin-top: -0.3008vw;
    margin-right: 4.8872vw;
  }
  .first-screen.first-screen--type-4 .first-screen__media-dec {
    width: 15.5639vw;
    height: 15.5639vw;
    left: 1.8797vw;
    right: auto;
    bottom: -6.3158vw;
  }
  .first-screen.first-screen--type-5 .first-screen__content {
    max-width: 44.6617vw;
    margin-top: 0px;
  }
  .first-screen.first-screen--type-5 .first-screen__media {
    max-width: 37.594vw;
    height: 43.5338vw;
    margin-top: -0.3008vw;
    margin-right: 4.8872vw;
  }
  .first-screen.first-screen--type-5 .first-screen__media-dec {
    width: 15.188vw;
    height: 15.188vw;
    left: 0.3008vw;
    right: auto;
    bottom: -5.9398vw;
  }
  .first-screen.first-screen--type-6 .first-screen__content {
    max-width: 44.6617vw;
  }
  .first-screen.first-screen--type-6 .first-screen__media {
    max-width: 47.5188vw;
    height: 41.3534vw;
    margin-top: 1.2782vw;
    margin-right: 0.9774vw;
  }
  .first-screen.first-screen--type-7 .first-screen__content {
    max-width: 44.6617vw;
  }
  .first-screen.first-screen--type-7 .first-screen__media {
    max-width: 37.594vw;
    height: 44.3609vw;
    margin-top: -0.3008vw;
    margin-right: 4.9624vw;
  }
  .first-screen.first-screen--dark .first-screen__inner {
    min-height: 45.1128vw;
    padding: 5.2632vw 0;
  }
  .first-screen.first-screen--dark .first-screen__media {
    right: 1.5038vw;
    max-width: 45.1128vw;
    height: 34.812vw;
  }
  .first-screen .first-screen__inner {
    border-radius: 1.8045vw;
    padding: 7.8947vw 0 6.4662vw;
  }
  .first-screen .first-screen__wrapper {
    gap: 2.2556vw;
  }
  .first-screen .first-screen__content {
    max-width: 47.3684vw;
  }
  .first-screen .first-screen__content-label {
    letter-spacing: -0.0105vw;
    font-size: 1.0526vw;
    margin-bottom: 1.203vw;
  }
  .first-screen .first-screen__content-title {
    margin-bottom: 1.2782vw;
  }
  .first-screen .first-screen__content-title h1 {
    letter-spacing: -0.0421vw;
    font-size: 4.2105vw;
  }
  .first-screen .first-screen__content-text {
    max-width: 41.8797vw;
    letter-spacing: -0.015vw;
    font-size: 1.5038vw;
  }
  .first-screen .first-screen__content-button {
    margin-top: 2.406vw;
  }
  .first-screen .first-screen__content-message {
    margin-top: 3.0827vw;
  }
  .first-screen .first-screen__media {
    max-width: 37.594vw;
    height: 36.8421vw;
    margin-top: -0.3759vw;
    margin-right: 4.8872vw;
  }
  .first-screen .first-screen__media-dec {
    width: 9.3233vw;
    height: 10.0752vw;
    right: 3.985vw;
    bottom: -5.1128vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__media {
    max-width: 62.406vw;
    height: 43.835vw;
    margin-right: -7.218vw;
    margin-bottom: 0;
    margin-top: 3.008vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__inner {
    padding-bottom: 2.256vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title {
    margin-bottom: 1.805vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title h1 {
    letter-spacing: 0.075vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title::after {
    bottom: -0.602vw;
    width: 25.94vw;
    height: 1.729vw;
  }
}
@media screen and (max-width: 1280px) {
  .first-screen {
    padding: 0 2.3438vw;
  }
  .first-screen.first-screen--type-1 .first-screen__media {
    max-width: 32.7344vw;
    height: 37.1094vw;
    margin-top: -0.3906vw;
    margin-right: 3.6719vw;
  }
  .first-screen.first-screen--type-2 .first-screen__content {
    max-width: 34.375vw;
  }
  .first-screen.first-screen--type-2 .first-screen__media {
    max-width: 39.8438vw;
    height: 31.0156vw;
    margin-top: 2.6563vw;
    margin-right: 1.0156vw;
  }
  .first-screen.first-screen--type-2 .first-screen__media-dec {
    width: 156px;
    height: 135px;
    right: 17px;
    bottom: 0px;
  }
  .first-screen.first-screen--type-3 .first-screen__content {
    max-width: 35.9375vw;
    margin-top: 3.2813vw;
  }
  .first-screen.first-screen--type-3 .first-screen__media {
    max-width: 35.1563vw;
    height: 39.6875vw;
    margin-top: -0.3125vw;
    margin-right: 3.125vw;
  }
  .first-screen.first-screen--type-3 .first-screen__media-dec {
    width: 188px;
    height: 158px;
    right: 26px;
    bottom: -64px;
  }
  .first-screen.first-screen--type-4 .first-screen__content {
    max-width: 37.5vw;
    margin-top: 0px;
  }
  .first-screen.first-screen--type-4 .first-screen__media {
    max-width: 35.1563vw;
    height: 41.0938vw;
    margin-top: -0.3125vw;
    margin-right: 1.5625vw;
  }
  .first-screen.first-screen--type-4 .first-screen__media-dec {
    width: 207px;
    height: 207px;
    left: 25px;
    right: auto;
    bottom: -84px;
  }
  .first-screen.first-screen--type-5 .first-screen__content {
    max-width: 38.2813vw;
    margin-top: 0px;
  }
  .first-screen.first-screen--type-5 .first-screen__media {
    max-width: 35.1563vw;
    height: auto;
    margin-top: -0.3125vw;
    margin-right: 1.5625vw;
  }
  .first-screen.first-screen--type-5 .first-screen__media-dec {
    width: 202px;
    height: 202px;
    left: 4px;
    right: auto;
    bottom: -79px;
  }
  .first-screen.first-screen--type-6 .first-screen__content {
    max-width: 40.625vw;
  }
  .first-screen.first-screen--type-6 .first-screen__media {
    max-width: 39.0625vw;
    height: 33.75vw;
    margin-top: 1.3281vw;
    margin-right: 0px;
  }
  .first-screen.first-screen--type-7 .first-screen__content {
    max-width: 38.2813vw;
  }
  .first-screen.first-screen--type-7 .first-screen__media {
    max-width: 35.1563vw;
    height: 41.4844vw;
    margin-top: -0.3125vw;
    margin-right: 1.5625vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__media {
    max-width: 54.844vw;
    height: 45.547vw;
    margin-right: -7.5vw;
    margin-bottom: 0;
    margin-top: 3.125vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__inner {
    padding-bottom: 2.344vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title {
    margin-bottom: 1.875vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title h1 {
    letter-spacing: 0.078vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title::after {
    bottom: -0.625vw;
    width: 26.953vw;
    height: 1.797vw;
  }
  .first-screen.first-screen--dark .first-screen__inner {
    min-height: 41.4063vw;
    padding: 3.9063vw 0;
  }
  .first-screen.first-screen--dark .first-screen__media {
    right: 1.5625vw;
    max-width: 46.875vw;
    height: 36.1719vw;
  }
  .first-screen .first-screen__inner {
    border-radius: 1.875vw;
    padding: 5vw 0 3.5938vw;
  }
  .first-screen .first-screen__wrapper {
    gap: 2.3438vw;
  }
  .first-screen .first-screen__content {
    max-width: 34.375vw;
  }
  .first-screen .first-screen__content-label {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
    margin-bottom: 1.5625vw;
  }
  .first-screen .first-screen__content-title {
    margin-bottom: 1.4844vw;
  }
  .first-screen .first-screen__content-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0328vw;
    font-size: 3.2813vw;
  }
  .first-screen .first-screen__content-text {
    max-width: 32.9688vw;
    letter-spacing: 0px;
    font-size: 1.4063vw;
  }
  .first-screen .first-screen__content-button {
    margin-top: 2.6563vw;
  }
  .first-screen .first-screen__content-message {
    display: inline-block;
    margin-top: 3.5156vw;
  }
  .first-screen .first-screen__media {
    width: 100%;
    max-width: 32.7344vw;
    height: 37.1094vw;
    margin-top: -0.3906vw;
    margin-right: 3.6719vw;
  }
}
@media screen and (max-width: 850px) {
  .first-screen {
    padding: 0;
  }
  .first-screen .container {
    padding: 0;
  }
  .first-screen.first-screen--type-1 .first-screen__content,
  .first-screen.first-screen--type-2 .first-screen__content,
  .first-screen.first-screen--type-3 .first-screen__content,
  .first-screen.first-screen--type-4 .first-screen__content,
  .first-screen.first-screen--type-5 .first-screen__content,
  .first-screen.first-screen--type-6 .first-screen__content,
  .first-screen.first-screen--type-7 .first-screen__content {
    max-width: 100%;
  }
  .first-screen.first-screen--type-1 .first-screen__media,
  .first-screen.first-screen--type-2 .first-screen__media,
  .first-screen.first-screen--type-3 .first-screen__media,
  .first-screen.first-screen--type-4 .first-screen__media,
  .first-screen.first-screen--type-5 .first-screen__media,
  .first-screen.first-screen--type-6 .first-screen__media,
  .first-screen.first-screen--type-7 .first-screen__media {
    max-width: 100%;
    height: auto;
    margin-top: 0;
    margin-right: 0;
  }
  .first-screen.first-screen--type-lp .first-screen__content-button {
    display: flex;
    flex-direction: column;
    gap: 4.615vw;
  }
  .first-screen.first-screen--type-lp .first-screen__content-button a {
    width: 100%;
  }
  .first-screen.first-screen--type-lp
    .first-screen__content-button
    a.btn--dark {
    width: max-content;
  }
  .first-screen.first-screen--type-lp
    .first-screen__content-button
    .btn-border {
    display: block;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__media {
    max-width: 100%;
    height: auto;
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 0;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__inner {
    padding: 12.0513vw 5.1282vw 12.0513vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title {
    margin-bottom: 6.154vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title h1 {
    letter-spacing: -0.2vw;
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-title::after {
    bottom: -2.051vw;
    width: 53.846vw;
    height: 3.59vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  }
  .first-screen.first-screen--type-pos-lp .first-screen__content-message a {
    text-decoration: underline;
    width: 82%;
    line-height: 0.7;
  }
  .first-screen.first-screen--type-pos-lp
    .first-screen__content-message
    a::after {
    content: "";
    position: relative;
    width: 6.1538vw;
    height: 6.1538vw;
    display: inline-block;
    background-color: transparent !important;
    background-repeat: no-repeat;
    transform: none;
    bottom: 0;
    top: 1.6vw;
    background-size: contain;
    background-position: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  }
  .first-screen.first-screen--type-pos-lp
    .first-screen__content-message
    a::before {
    display: none;
  }
  .first-screen.first-screen--dark .first-screen__inner {
    min-height: 1px;
    padding: 11.2821vw 5.1282vw 0;
  }
  .first-screen.first-screen--dark .first-screen__inner::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  }
  .first-screen.first-screen--dark .first-screen__media {
    position: static;
    max-width: unset;
    width: 102.5641vw;
    height: 78.3846vw;
    margin: -6.5897vw 0px 0px -0.5897vw;
  }
  .first-screen.first-screen--dark .first-screen__content {
    max-width: 87.1795vw;
  }
  .first-screen.first-screen--dark .first-screen__content-message {
    max-width: 64.359vw;
  }
  .first-screen.first-screen--dark .first-screen__content-message a {
    text-decoration: underline;
    text-underline-offset: 0.7692vw;
  }
  .first-screen.first-screen--dark .first-screen__content-message a::before {
    display: none;
  }
  .first-screen.first-screen--dark .first-screen__content-message a::after {
    content: "";
    position: static;
    display: inline-block;
    width: 4.1026vw;
    height: 3.5897vw;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transform: translate(2.0513vw, 1.0256vw);
  }
  .first-screen .first-screen__inner {
    border-radius: 4.1026vw;
    padding: 12.0513vw 5.1282vw 12.0513vw;
  }
  .first-screen .first-screen__wrapper {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 11.2821vw;
  }
  .first-screen .first-screen__content {
    max-width: 100%;
  }
  .first-screen .first-screen__content-label {
    letter-spacing: -0.0359vw;
    font-size: 3.5897vw;
    margin-bottom: 4.1026vw;
  }
  .first-screen .first-screen__content-title {
    margin-bottom: 5.641vw;
  }
  .first-screen .first-screen__content-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0923vw;
    font-size: 9.2308vw;
  }
  .first-screen .first-screen__content-text {
    max-width: 100%;
    letter-spacing: -0.0769vw;
    font-size: 4.6154vw;
  }
  .first-screen .first-screen__content-button {
    margin-top: 6.1538vw;
  }
  .first-screen .first-screen__content-message {
    margin-top: 6.1538vw;
  }
  .first-screen .first-screen__media {
    max-width: 100%;
    height: 89.7436vw;
    margin-top: 0;
    margin-right: 0;
  }
  .first-screen .first-screen__media-dec {
    width: 26.6667vw;
    height: 28.4615vw;
    right: 4.8718vw;
    bottom: -16.6667vw;
  }
}
.single-first-screen {
  padding: 0 30px;
}
.single-first-screen .single-first-screen__inner {
  width: 100%;
  min-height: 670px;
  position: relative;
  z-index: 2;
  border-radius: 24px;
  overflow: hidden;
  padding: 126px;
}
.single-first-screen .single-first-screen__inner::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.35);
}
.single-first-screen .single-first-screen__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
}
.single-first-screen .single-first-screen__bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.single-first-screen .single-first-screen__content {
  width: 100%;
  max-width: 888px;
  margin: 0 auto;
}
.single-first-screen .single-first-screen__content-logo {
  width: 280px;
  height: 100px;
  margin: 0 auto 16px;
}
.single-first-screen .single-first-screen__content-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.single-first-screen .single-first-screen__content-title h1 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.56px;
  font-size: 56px;
  color: var(--white);
  text-align: center;
}
.single-first-screen .single-first-screen__info {
  margin-top: -25px;
  padding: 57px 20px 43px;
  width: 100%;
  background-color: var(--yellow);
  border-radius: 0 0 24px 24px;
}
.single-first-screen .single-first-screen__info .list {
  width: 100%;
  max-width: 1274px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.single-first-screen .single-first-screen__info .item-title {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.4px;
  font-size: 40px;
  color: var(--dark);
  margin-bottom: 8px;
}
.single-first-screen .single-first-screen__info .item-subtitle {
  width: 100%;
  max-width: 300px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--dark);
}

@media screen and (max-width: 1330px) {
  .single-first-screen {
    padding: 0 2.2556vw;
  }
  .single-first-screen .single-first-screen__inner {
    min-height: 50.3759vw;
    border-radius: 1.8045vw;
    padding: 9.4737vw;
  }
  .single-first-screen .single-first-screen__content {
    max-width: 66.7669vw;
  }
  .single-first-screen .single-first-screen__content-logo {
    width: 21.0526vw;
    height: 7.5188vw;
    margin: 0 auto 1.203vw;
  }
  .single-first-screen .single-first-screen__content-title h1 {
    letter-spacing: -0.0421vw;
    font-size: 4.2105vw;
  }
  .single-first-screen .single-first-screen__info {
    margin-top: -1.8797vw;
    padding: 4.2857vw 1.5038vw 3.2331vw;
    border-radius: 0 0 1.8045vw 1.8045vw;
  }
  .single-first-screen .single-first-screen__info .list {
    max-width: 95.7895vw;
  }
  .single-first-screen .single-first-screen__info .item-title {
    letter-spacing: -0.0301vw;
    font-size: 3.0075vw;
    margin-bottom: 0.6015vw;
  }
  .single-first-screen .single-first-screen__info .item-subtitle {
    max-width: 22.5564vw;
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
  }
}
@media screen and (max-width: 1280px) {
  .single-first-screen {
    padding: 0 2.3438vw;
  }
  .single-first-screen .single-first-screen__inner {
    min-height: 38.2813vw;
    border-radius: 1.875vw;
    padding: 5.4688vw;
  }
  .single-first-screen .single-first-screen__content {
    width: 100%;
    max-width: 50.7813vw;
  }
  .single-first-screen .single-first-screen__content-logo {
    width: 21.875vw;
    height: 7.8125vw;
    margin: 0 auto 1.25vw;
  }
  .single-first-screen .single-first-screen__content-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0281vw;
    font-size: 2.9688vw;
  }
  .single-first-screen .single-first-screen__info {
    margin-top: -1.9531vw;
    padding: 4.4531vw 2.3438vw 2.7344vw;
    width: 100%;
    border-radius: 0 0 1.875vw 1.875vw;
  }
  .single-first-screen .single-first-screen__info .list {
    max-width: 100%;
  }
  .single-first-screen .single-first-screen__info .item-title {
    line-height: 1.1;
    letter-spacing: -0.0172vw;
    font-size: 2.7344vw;
    margin-bottom: 0.3906vw;
  }
  .single-first-screen .single-first-screen__info .item-subtitle {
    max-width: 19.5313vw;
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
}
@media screen and (max-width: 850px) {
  .single-first-screen {
    padding: 0;
  }
  .single-first-screen .single-first-screen__inner {
    min-height: 123.0769vw;
    border-radius: 6.1538vw;
    padding: 15.3846vw 5.1282vw 27.6923vw;
  }
  .single-first-screen .single-first-screen__content {
    max-width: 100%;
  }
  .single-first-screen .single-first-screen__content-logo {
    width: 41.5385vw;
    height: 14.6154vw;
    margin: 0 auto 4.1026vw;
  }
  .single-first-screen .single-first-screen__content-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0923vw;
    font-size: 9.2308vw;
  }
  .single-first-screen .single-first-screen__info {
    margin-top: -6.4103vw;
    padding: 14.8718vw 5.1282vw 9.7436vw;
    border-radius: 0 0 6.1538vw 6.1538vw;
  }
  .single-first-screen .single-first-screen__info .list {
    max-width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }
  .single-first-screen .single-first-screen__info .item:not(:first-child) {
    margin-top: 8.4615vw;
  }
  .single-first-screen .single-first-screen__info .item-title {
    letter-spacing: -0.0718vw;
    font-size: 7.1795vw;
    margin-bottom: 1.0256vw;
  }
  .single-first-screen .single-first-screen__info .item-subtitle {
    max-width: 60vw;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
}
.first-screen-store {
  padding: 0 30px;
}
.first-screen-store .first-screen-store__inner {
  background: var(--green-2);
  border-radius: 24px;
  position: relative;
  z-index: 2;
  padding: 121px 0 152px;
  overflow: hidden;
}
.first-screen-store .first-screen-store__inner::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -223px;
  left: 50%;
  transform: translateX(-50%);
  width: 1032px;
  height: 1032px;
  background: var(--yellow);
  border-radius: 50%;
}
.first-screen-store .first-screen-store__header {
  width: 100%;
  max-width: 610px;
  margin: 0 auto 96px;
  text-align: center;
}
.first-screen-store .first-screen-store__header-title {
  margin-bottom: 27px;
  color: var(--dark);
}
.first-screen-store .first-screen-store__header-title h1 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.62px;
  font-size: 62px;
}
.first-screen-store .first-screen-store__header-text {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.26px;
  font-size: 26px;
}
.first-screen-store .first-screen-store__list {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1282px;
  margin: 0 auto;
}
.first-screen-store .first-screen-store__list .list-dec-first {
  position: absolute;
  z-index: 3;
  left: 208px;
  bottom: calc(100% - 24px);
  width: 176px;
  height: 153px;
}
.first-screen-store .first-screen-store__list .list-dec-first img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.first-screen-store .first-screen-store__list .list-dec-last {
  position: absolute;
  z-index: 3;
  right: 18px;
  bottom: 100%;
  width: 224px;
  height: 197px;
}
.first-screen-store .first-screen-store__list .list-dec-last img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.first-screen-store .first-screen-store__list .list {
  counter-reset: num;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 26px;
}
.first-screen-store .first-screen-store__list .item {
  position: relative;
  z-index: 2;
}
.first-screen-store .first-screen-store__list .item:nth-child(1) {
  transform: rotate(-12deg) translate(-15px, -7px);
}
.first-screen-store .first-screen-store__list .item:nth-child(1)::before {
  content: "";
  position: absolute;
  top: calc(100% + 56px);
  left: calc(100% - 123px);
  transform: rotate(12deg);
  width: 234px;
  height: 33px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.first-screen-store .first-screen-store__list .item:nth-child(2) {
  transform: rotate(8deg) translate(0px, -5px);
}
.first-screen-store .first-screen-store__list .item:nth-child(2)::before {
  content: "";
  position: absolute;
  left: calc(100% - 65px);
  bottom: calc(100% + 37px);
  transform: rotate(-8deg);
  width: 230px;
  height: 36px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.first-screen-store .first-screen-store__list .item:nth-child(3) {
  transform: rotate(-12deg) translate(14px, -1px);
}
.first-screen-store .first-screen-store__list .item .item-content {
  display: flex;
  align-items: center;
  border-radius: 24px;
  border: 2px solid var(--dark);
  background: var(--white);
  padding: 26px 76px 25px 29px;
  position: relative;
}
.first-screen-store .first-screen-store__list .item .item-content::before {
  counter-increment: num;
  content: counter(num);
  font-family: "Circular Std";
  font-size: 24px;
  font-weight: 400;
  letter-spacing: -0.24px;
  color: var(--white);
  background-color: var(--green);
  border-radius: 50%;
  padding: 15px 21px 14px;
  flex: 0 0 auto;
}
.first-screen-store .first-screen-store__list .item .item-content::after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  bottom: -14px;
  width: 100%;
  height: 53px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
}
.first-screen-store .first-screen-store__list .item-text {
  font-weight: 500;
  line-height: 1.5;
  font-size: 17px;
  color: var(--dark);
  margin-left: 21px;
}

@media screen and (max-width: 1450px) {
  .first-screen-store {
    padding: 0 2.069vw;
  }
  .first-screen-store .first-screen-store__inner {
    border-radius: 1.6552vw;
    padding: 8.3448vw 0 10.4828vw;
  }
  .first-screen-store .first-screen-store__inner::before {
    top: -15.3793vw;
    width: 71.1724vw;
    height: 71.1724vw;
  }
  .first-screen-store .first-screen-store__header {
    max-width: 42.069vw;
    margin: 0 auto 6.6207vw;
  }
  .first-screen-store .first-screen-store__header-title {
    margin-bottom: 1.8621vw;
  }
  .first-screen-store .first-screen-store__header-title h1 {
    letter-spacing: -0.0428vw;
    font-size: 4.2759vw;
  }
  .first-screen-store .first-screen-store__header-text {
    letter-spacing: -0.0179vw;
    font-size: 1.7931vw;
  }
  .first-screen-store .first-screen-store__list {
    max-width: 88.4138vw;
  }
  .first-screen-store .first-screen-store__list .list-dec-first {
    left: 14.3448vw;
    bottom: calc(100% - 1.6552vw);
    width: 12.1379vw;
    height: 10.5517vw;
  }
  .first-screen-store .first-screen-store__list .list-dec-last {
    right: 1.2414vw;
    width: 15.4483vw;
    height: 13.5862vw;
  }
  .first-screen-store .first-screen-store__list .list {
    grid-gap: 1.7931vw;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(1) {
    transform: rotate(-12deg) translate(-1.0345vw, -0.4828vw);
  }
  .first-screen-store .first-screen-store__list .item:nth-child(1)::before {
    top: calc(100% + 3.8621vw);
    left: calc(100% - 8.4828vw);
    width: 16.1379vw;
    height: 2.2759vw;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(2) {
    transform: rotate(8deg) translate(0px, -0.3448vw);
  }
  .first-screen-store .first-screen-store__list .item:nth-child(2)::before {
    left: calc(100% - 4.4828vw);
    bottom: calc(100% + 2.5517vw);
    width: 15.8621vw;
    height: 2.4828vw;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(3) {
    transform: rotate(-12deg) translate(0.9655vw, -1px);
  }
  .first-screen-store .first-screen-store__list .item .item-content {
    border-radius: 1.6552vw;
    border: 0.1379vw solid var(--dark);
    padding: 1.7931vw 5.2414vw 1.7241vw 2vw;
  }
  .first-screen-store .first-screen-store__list .item .item-content::before {
    font-size: 1.6552vw;
    letter-spacing: -0.0166vw;
    padding: 1.0345vw 1.4483vw 0.9655vw;
  }
  .first-screen-store .first-screen-store__list .item .item-content::after {
    bottom: -0.9655vw;
    height: 3.6552vw;
  }
  .first-screen-store .first-screen-store__list .item-text {
    font-size: 1.1724vw;
    margin-left: 1.4483vw;
  }
}
@media screen and (max-width: 1280px) {
  .first-screen-store {
    padding: 0 2.3438vw;
  }
  .first-screen-store .first-screen-store__inner {
    border-radius: 1.875vw;
    padding: 6.25vw 0;
  }
  .first-screen-store .first-screen-store__inner::before {
    top: -11.0156vw;
    width: 65vw;
    height: 65vw;
  }
  .first-screen-store .first-screen-store__header {
    max-width: 33.9844vw;
    margin: 0 auto 7.5vw;
  }
  .first-screen-store .first-screen-store__header-title {
    margin-bottom: 2.1094vw;
  }
  .first-screen-store .first-screen-store__header-title h1 {
    letter-spacing: normal;
    font-size: 3.2813vw;
  }
  .first-screen-store .first-screen-store__header-text {
    letter-spacing: normal;
    font-size: 1.4063vw;
  }
  .first-screen-store .first-screen-store__list {
    max-width: 82.0313vw;
  }
  .first-screen-store .first-screen-store__list .list-dec-first {
    left: 13.0469vw;
    bottom: calc(100% - 1.4063vw);
    width: 10.625vw;
    height: 8.9063vw;
  }
  .first-screen-store .first-screen-store__list .list-dec-last {
    right: 1.4063vw;
    width: 10.5469vw;
    height: 10.3906vw;
  }
  .first-screen-store .first-screen-store__list .list {
    grid-gap: 2.0313vw;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(1) {
    transform: rotate(-12deg) translate(-1.1719vw, -0.5469vw);
  }
  .first-screen-store .first-screen-store__list .item:nth-child(1)::before {
    top: calc(100% + 3.9063vw);
    left: calc(100% - 8.4375vw);
    width: 15.1563vw;
    height: 1.6406vw;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(2) {
    transform: rotate(8deg) translate(0px, -0.3906vw);
  }
  .first-screen-store .first-screen-store__list .item:nth-child(2)::before {
    left: calc(100% - 4.6875vw);
    bottom: calc(100% + 2.3438vw);
    width: 13.75vw;
    height: 1.875vw;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(3) {
    transform: rotate(-12deg) translate(1.0938vw, -1px);
  }
  .first-screen-store .first-screen-store__list .item .item-content {
    border-radius: 1.875vw;
    border: 0.1563vw solid var(--dark);
    padding: 1.5625vw;
  }
  .first-screen-store .first-screen-store__list .item .item-content::before {
    font-size: 1.4063vw;
    letter-spacing: normal;
    padding: 1.0156vw 1.4063vw;
  }
  .first-screen-store .first-screen-store__list .item .item-content::after {
    bottom: -1.0938vw;
    height: 4.1406vw;
  }
  .first-screen-store .first-screen-store__list .item-text {
    font-size: 1.25vw;
    margin-left: 1.6406vw;
  }
}
@media screen and (max-width: 850px) {
  .first-screen-store {
    padding: 0;
  }
  .first-screen-store .first-screen-store__inner {
    border-radius: 6.1538vw;
    padding: 24.8718vw 5.1282vw 24.8718vw;
  }
  .first-screen-store .first-screen-store__inner::before {
    top: -36.1538vw;
    width: 138.4615vw;
    height: 138.4615vw;
  }
  .first-screen-store .first-screen-store__header {
    max-width: 89.7436vw;
    margin: 0 auto 27.6923vw;
  }
  .first-screen-store .first-screen-store__header-title {
    margin-bottom: 5.641vw;
  }
  .first-screen-store .first-screen-store__header-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0923vw;
    font-size: 9.2308vw;
  }
  .first-screen-store .first-screen-store__header-text {
    letter-spacing: -0.0667vw;
    font-size: 6.6667vw;
  }
  .first-screen-store .first-screen-store__list {
    max-width: 80.7692vw;
  }
  .first-screen-store .first-screen-store__list .list-dec-first {
    left: auto;
    right: 2.8205vw;
    bottom: calc(100% - 8.9744vw);
    width: 32.8205vw;
    height: 27.4359vw;
    transform: rotate(9deg);
  }
  .first-screen-store .first-screen-store__list .list-dec-last {
    right: -2.5641vw;
    bottom: 6.9231vw;
    width: 37.6923vw;
    height: 34.8718vw;
    transform: rotate(9deg);
  }
  .first-screen-store .first-screen-store__list .list {
    grid-template-columns: 1fr;
    grid-gap: 12.8205vw;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(1) {
    transform: rotate(-2deg) translate(0, 0);
  }
  .first-screen-store .first-screen-store__list .item:nth-child(1)::before {
    display: none;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(2) {
    transform: rotate(2deg) translate(0px, 3.3333vw);
  }
  .first-screen-store .first-screen-store__list .item:nth-child(2)::before {
    display: none;
  }
  .first-screen-store .first-screen-store__list .item:nth-child(3) {
    transform: rotate(-2deg) translate(0px, 5.8974vw);
  }
  .first-screen-store .first-screen-store__list .item .item-content {
    border-radius: 4.6154vw;
    border: 0.5128vw solid var(--dark);
    padding: 5.641vw 5.1282vw 5.1282vw 5.3846vw;
  }
  .first-screen-store .first-screen-store__list .item .item-content::before {
    font-size: 4.6154vw;
    letter-spacing: -0.0474vw;
    padding: 2.8205vw 4.1026vw;
  }
  .first-screen-store .first-screen-store__list .item .item-content::after {
    bottom: -2.3077vw;
    height: 13.5897vw;
  }
  .first-screen-store .first-screen-store__list .item-text {
    font-size: 3.3333vw;
    margin-left: 4.359vw;
  }
}
.brands {
  margin-bottom: 111px;
}
.brands.brands--slider .brands-list {
  display: flex;
  overflow: hidden;
  direction: rtl;
}
.brands.brands--slider .brands-list.start-slider .list {
  animation: marquee 20s infinite linear;
}
.brands.brands--slider .brands-list .list {
  display: flex;
  flex: 0 0 auto;
}
.brands.brands--slider .brands-list .list .item {
  padding: 0 42.5px;
  width: 190px;
  height: 90px;
}
.brands.brands--top {
  margin-bottom: 96px;
}
.brands.brands--top .brands__inner {
  padding-top: 64px;
  padding-bottom: 49px;
  border-bottom: 1px solid rgba(22, 22, 22, 0.15);
}
.brands.brands--top .brands-list .list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.brands.brands-light.brands--top .brands__inner {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.brands.brands-light .brands__title h2 {
  color: var(--white);
}
.brands .brands__title {
  text-align: center;
  margin-bottom: 51px;
}
.brands .brands__title h2 {
  font-weight: 400;
  line-height: 1.5;
  font-size: 20px;
  letter-spacing: -0.2px;
  color: var(--dark);
}
.brands .brands-list .item {
  display: flex;
  align-items: center;
  justify-items: center;
  flex: 0 0 auto;
  width: 120px;
  height: 90px;
}
.brands .brands-list .item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .brands {
    margin-bottom: 8.3459vw;
  }
  .brands.brands--slider .brands-list .list .item {
    padding: 0 3.1955vw;
    width: 14.2857vw;
    height: 6.7669vw;
  }
  .brands.brands--top {
    margin-bottom: 7.218vw;
  }
  .brands.brands--top .brands__inner {
    padding-top: 4.812vw;
    padding-bottom: 3.6842vw;
  }
  .brands .brands__title {
    margin-bottom: 3.8346vw;
  }
  .brands .brands__title h2 {
    font-size: 1.5038vw;
    letter-spacing: -0.015vw;
  }
  .brands .brands-list .item {
    width: 9.0226vw;
    height: 6.7669vw;
  }
}
@media screen and (max-width: 1280px) {
  .brands {
    margin-bottom: 6.4063vw;
  }
  .brands.brands--slider .brands-list .list .item {
    padding: 0 2.6172vw;
    width: 11.1406vw;
    height: 5vw;
  }
  .brands.brands--top {
    margin-bottom: 7.5vw;
  }
  .brands.brands--top .brands__inner {
    padding-top: 5vw;
    padding-bottom: 4.1406vw;
    border-bottom: 1px solid rgba(22, 22, 22, 0.15);
  }
  .brands.brands--top .brands__title {
    margin-bottom: 4.375vw;
  }
  .brands.brands--top .brands__title h2 {
    font-size: 1.5625vw;
    letter-spacing: -0.0156vw;
  }
  .brands.brands--top .brands-list .item {
    width: 8.1406vw;
    height: 5vw;
  }
  .brands .brands__title {
    margin-bottom: 2.5vw;
  }
  .brands .brands__title.brands__title--big h2 {
    font-weight: 500;
    line-height: 1.4;
    letter-spacing: -0.0203vw;
    font-size: 2.0313vw;
  }
  .brands .brands__title h2 {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
  }
  .brands .brands-list .item {
    width: 11.1406vw;
    height: 5vw;
  }
}
@media screen and (max-width: 850px) {
  .brands {
    margin-bottom: 9.7436vw;
  }
  .brands.brands--slider .brands-list .list .item {
    padding: 0 5.1282vw;
    width: 25.2308vw;
    height: 11.5385vw;
  }
  .brands.brands--top {
    margin-bottom: 17.1795vw;
  }
  .brands.brands--top .container {
    padding: 0;
  }
  .brands.brands--top .brands__inner {
    padding-top: 12.5641vw;
    padding-bottom: 9.4872vw;
    border-bottom: none;
    position: relative;
    z-index: 2;
  }
  .brands.brands--top .brands__inner::before {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 89.7436vw;
    height: 1px;
    background-color: var(--dark);
    opacity: 0.15;
  }
  .brands.brands--top .brands__title {
    width: 100%;
    max-width: 76.9231vw;
    margin: 0 auto 6.1538vw;
  }
  .brands.brands--top .brands__title h2 {
    font-size: 4.1026vw;
    letter-spacing: -0.041vw;
  }
  .brands.brands--top .brands-list .item {
    max-width: 100%;
    width: 25.2308vw;
    height: 11.5385vw;
  }
  .brands .brands__title {
    margin-bottom: 6.4103vw;
  }
  .brands .brands__title.brands__title--big h2 {
    letter-spacing: -0.0667vw;
    font-size: 6.6667vw;
  }
  .brands .brands__title h2 {
    font-size: 4.1026vw;
    letter-spacing: -0.041vw;
  }
  .brands .brands-list .item {
    max-width: 100%;
    width: 25.2308vw;
    height: 11.5385vw;
  }
}
@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}
.short-about .short-about__wrapper {
  width: 100%;
  background-color: var(--yellow);
  border-radius: 24px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 38px 92px 0 114px;
  overflow: hidden;
}
.short-about .short-about__media {
  width: 408px;
  height: 616px;
  margin-bottom: -5px;
}
.short-about .short-about__media img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.short-about .short-about__content {
  width: 100%;
  max-width: 481px;
  margin-bottom: 113px;
}
.short-about .short-about__content-title {
  margin-bottom: 20px;
}
.short-about .short-about__content-title h2 {
  font-family: "Cambon";
  font-weight: 700;
  font-size: 56px;
  line-height: 1.2;
  letter-spacing: -0.56px;
  color: var(--dark);
}
.short-about .short-about__content-text {
  margin-bottom: 24px;
}
@media screen and (max-width: 1330px) {
  .short-about .short-about__wrapper {
    border-radius: 1.8045vw;
    padding: 2.8571vw 6.9173vw 0 8.5714vw;
  }
  .short-about .short-about__media {
    width: 30.6767vw;
    height: 46.3158vw;
    margin-bottom: -0.3759vw;
  }
  .short-about .short-about__content {
    max-width: 36.1654vw;
    margin-bottom: 8.4962vw;
  }
  .short-about .short-about__content-title {
    margin-bottom: 1.5038vw;
  }
  .short-about .short-about__content-title h2 {
    font-size: 4.2105vw;
    letter-spacing: -0.0421vw;
  }
  .short-about .short-about__content-text {
    margin-bottom: 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .short-about .short-about__wrapper {
    border-radius: 1.875vw;
    padding: 4.5313vw 7.1094vw 0 7.1094vw;
  }
  .short-about .short-about__media {
    width: 26.1719vw;
    height: auto;
    margin-bottom: -0.3906vw;
  }
  .short-about .short-about__content {
    max-width: 32.8125vw;
    margin-bottom: 7.4219vw;
  }
  .short-about .short-about__content-title {
    max-width: 23.4375vw;
    margin-bottom: 2.5vw;
  }
  .short-about .short-about__content-title h2 {
    font-size: 2.9688vw;
    letter-spacing: -0.0297vw;
  }
  .short-about .short-about__content-text {
    margin-bottom: 2.5vw;
  }
}
@media screen and (max-width: 850px) {
  .short-about .short-about__wrapper {
    border-radius: 4.1026vw;
    padding: 8.7179vw 9.7436vw 0 8.2051vw;
    flex-direction: column-reverse;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .short-about .short-about__media {
    width: 57.9487vw;
    height: auto;
    margin: 0 auto -1.2821vw;
  }
  .short-about .short-about__content {
    max-width: 100%;
    margin-bottom: 14.359vw;
  }
  .short-about .short-about__content-title {
    max-width: 100%;
    margin-bottom: 5.1282vw;
  }
  .short-about .short-about__content-title h2 {
    font-size: 8.2051vw;
    letter-spacing: -0.0821vw;
  }
  .short-about .short-about__content-text {
    margin-bottom: 6.1538vw;
  }
}
.offer .offer__inner {
  padding: 107px 0 81px;
}
.offer .offer__header {
  width: 100%;
  max-width: 663px;
  margin: 0 auto 62px;
  text-align: center;
}
.offer .offer__header-title {
  margin-bottom: 11px;
}
.offer .offer__list {
  width: 100%;
}
.offer .offer__list .list {
  width: 100%;
  display: grid;
  align-items: stretch;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
}
.offer .offer__list .item {
  width: 100%;
  height: auto;
  min-height: 430px;
  border-radius: 24px;
  background: var(--light-gray);
  overflow: hidden;
  padding: 30px 60px 38px;
  transition: all 0.4s linear;
  position: relative;
  z-index: 2;
}
.offer .offer__list .item:not(.hide-content):hover::before {
  opacity: 1;
  transform: scale(25);
}
.offer .offer__list .item:not(.hide-content):hover .item-link {
  opacity: 1;
  transform: rotate(0deg);
  pointer-events: all;
}
.offer .offer__list .item:not(.hide-content):hover .item-button a,
.offer .offer__list .item:not(.hide-content):hover .item-button button {
  color: var(--white);
}
.offer .offer__list .item:not(.hide-content):hover .item-button a::before,
.offer .offer__list .item:not(.hide-content):hover .item-button button::before {
  opacity: 1;
}
.offer .offer__list .item:hover .item-content__hide {
  opacity: 1;
  pointer-events: all;
}
.offer .offer__list .item::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 20px;
  right: 20px;
  height: 20px;
  width: 48px;
  height: 48px;
  opacity: 0;
  border-radius: 50%;
  background-color: var(--yellow);
  transition: all 0.4s linear;
}
.offer .offer__list .item .item-link {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--white);
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  opacity: 0;
  transform: rotate(-90deg);
  transition: all 0.4s linear;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.offer .offer__list .item .item-link::before {
  content: "";
  position: absolute;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.offer .offer__list .item .item-icon {
  width: 185px;
  height: 186px;
  margin: 0 auto 16px;
}
.offer .offer__list .item .item-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.offer .offer__list .item .item-content {
  width: 100%;
  max-width: 289px;
  margin: 0 auto;
  text-align: center;
}
.offer .offer__list .item .item-content__title {
  margin-bottom: 9px;
}
.offer .offer__list .item .item-content__title h3 {
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.24px;
  font-size: 24px;
  color: var(--dark);
}
.offer .offer__list .item .item-content__wrapper {
  position: relative;
  z-index: 2;
}
.offer .offer__list .item .item-content__text,
.offer .offer__list .item .item-content__text-hover {
  font-weight: 400;
  line-height: 1.4;
  font-size: 18px;
  letter-spacing: -0.18px;
  color: var(--gray);
  transition: all 0.4s linear;
}
.offer .offer__list .item .item-content__text-hover {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.offer .offer__list .item .item-button {
  margin-top: 21px;
  display: flex;
  justify-content: center;
  transition: all 0.4s linear;
}
.offer .offer__list .item .item-button a,
.offer .offer__list .item .item-button button {
  text-align: center;
  padding: 16px;
  font-family: "Circular Std";
  font-weight: 500;
  font-size: 13px;
  letter-spacing: -0.13px;
  color: var(--green);
  position: relative;
  z-index: 2;
  transition: all 0.4s linear;
}
.offer .offer__list .item .item-button a::before,
.offer .offer__list .item .item-button button::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--green);
  border-radius: 41px;
  opacity: 0;
  transition: all 0.4s linear;
}
.offer .offer__list .item .item-content__hide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  background: rgba(186, 100, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 0;
  pointer-events: none;
  transition: all 0.4s linear;
}
.offer .offer__list .item .item-content__hide-text {
  width: 100%;
  max-width: 298px;
  margin: 0 auto 28px;
  text-align: center;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--white);
}
.offer .offer__list .item .item-content__hide-button a,
.offer .offer__list .item .item-content__hide-button button {
  padding: 20px 24px;
  border-radius: 12px;
  background: var(--white);
  font-weight: 500;
  font-size: 17px;
  color: var(--dark);
}

@media screen and (max-width: 1330px) {
  .offer .offer__inner {
    padding: 8.0451vw 0 6.0902vw;
  }
  .offer .offer__header {
    max-width: 49.8496vw;
    margin: 0 auto 4.6617vw;
  }
  .offer .offer__header-title {
    margin-bottom: 0.8271vw;
  }
  .offer .offer__list .list {
    grid-gap: 2.2556vw;
  }
  .offer .offer__list .item {
    width: 100%;
    min-height: 32.3308vw;
    border-radius: 1.8045vw;
    padding: 2.2556vw 4.5113vw 2.8571vw;
  }
  .offer .offer__list .item::before {
    top: 1.5038vw;
    right: 1.5038vw;
    height: 1.5038vw;
    width: 3.609vw;
    height: 3.609vw;
  }
  .offer .offer__list .item .item-link {
    width: 3.609vw;
    height: 3.609vw;
    top: 1.5038vw;
    right: 1.5038vw;
  }
  .offer .offer__list .item .item-link::before {
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .offer .offer__list .item .item-icon {
    width: 13.9098vw;
    height: 13.985vw;
    margin: 0 auto 1.203vw;
  }
  .offer .offer__list .item .item-content {
    max-width: 21.7293vw;
  }
  .offer .offer__list .item .item-content__title {
    margin-bottom: 0.6767vw;
  }
  .offer .offer__list .item .item-content__title h3 {
    letter-spacing: -0.018vw;
    font-size: 1.8045vw;
  }
  .offer .offer__list .item .item-content__text {
    font-size: 1.3534vw;
    letter-spacing: -0.0135vw;
  }
  .offer .offer__list .item .item-button {
    margin-top: 1.5789vw;
  }
  .offer .offer__list .item .item-button a,
  .offer .offer__list .item .item-button button {
    padding: 1.203vw;
    font-size: 0.9774vw;
    letter-spacing: -0.0098vw;
  }
  .offer .offer__list .item .item-button a::before,
  .offer .offer__list .item .item-button button::before {
    border-radius: 3.0827vw;
  }
  .offer .offer__list .item .item-content__hide-text {
    max-width: 22.406vw;
    margin: 0 auto 2.1053vw;
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
  }
  .offer .offer__list .item .item-content__hide-button a,
  .offer .offer__list .item .item-content__hide-button button {
    padding: 1.5038vw 1.8045vw;
    border-radius: 0.9023vw;
    font-size: 1.2782vw;
  }
}
@media screen and (max-width: 1280px) {
  .offer .offer__inner {
    padding: 6.0156vw 0 3.8281vw;
  }
  .offer .offer__header {
    width: 100%;
    max-width: 53.125vw;
    margin: 0 auto 5.625vw;
    text-align: center;
  }
  .offer .offer__header-title {
    margin-bottom: 1.7969vw;
  }
  .offer .offer__list .list {
    grid-gap: 2.3438vw;
  }
  .offer .offer__list .item {
    min-height: 33.5938vw;
    border-radius: 1.875vw;
    padding: 3.125vw 3.125vw 2.9688vw;
  }
  .offer .offer__list .item::before {
    top: 1.5625vw;
    right: 1.5625vw;
    height: 1.5625vw;
    width: 3.75vw;
    height: 3.75vw;
  }
  .offer .offer__list .item .item-link {
    width: 3.75vw;
    height: 3.75vw;
    top: 1.5625vw;
    right: 1.5625vw;
  }
  .offer .offer__list .item .item-link::before {
    width: 1.875vw;
    height: 1.875vw;
  }
  .offer .offer__list .item .item-icon {
    width: 12.9688vw;
    height: 12.9688vw;
    margin: 0 auto 2.0313vw;
  }
  .offer .offer__list .item .item-content {
    width: 100%;
    max-width: 22.5781vw;
    margin: 0 auto;
    text-align: center;
  }
  .offer .offer__list .item .item-content__title {
    margin-bottom: 0.8594vw;
  }
  .offer .offer__list .item .item-content__title h3 {
    line-height: 1.4;
    letter-spacing: -0.0172vw;
    font-size: 1.7188vw;
  }
  .offer .offer__list .item .item-content__text,
  .offer .offer__list .item .item-content__text-hover {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
  }
  .offer .offer__list .item .item-button {
    margin-top: 1.6406vw;
  }
  .offer .offer__list .item .item-button a,
  .offer .offer__list .item .item-button button {
    text-align: center;
    padding: 1.25vw;
    font-family: "Circular Std";
    font-weight: 500;
    font-size: 1.0156vw;
    letter-spacing: -0.0102vw;
  }
  .offer .offer__list .item .item-content__hide-text {
    max-width: 19.5313vw;
    margin: 0 auto 1.5625vw;
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
  }
  .offer .offer__list .item .item-content__hide-button a,
  .offer .offer__list .item .item-content__hide-button button {
    padding: 1.1719vw 1.5625vw;
    border-radius: 0.9375vw;
    font-size: 1.25vw;
  }
}
@media screen and (max-width: 850px) {
  .offer .offer__inner {
    padding: 19.2308vw 0;
  }
  .offer .offer__header {
    max-width: 100%;
    margin: 0 auto 11.0256vw;
  }
  .offer .offer__header-title {
    margin-bottom: 5.3846vw;
  }
  .offer .offer__list .list {
    width: calc(100% + 5.1282vw);
    margin: 0 -2.5641vw;
    display: block;
  }
  .offer .offer__list .list .slick-track {
    display: flex;
    align-items: stretch;
  }
  .offer .offer__list .list .slick-dots {
    position: relative;
    bottom: 0;
    margin-top: 6.1538vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .offer .offer__list .list .slick-dots li {
    width: 2.0513vw;
    height: 2.0513vw;
    background-color: var(--dark);
    opacity: 0.2;
    border-radius: 50%;
    transition: all 0.3s linear;
  }
  .offer .offer__list .list .slick-dots li.slick-active {
    width: 2.5641vw;
    height: 2.5641vw;
    opacity: 1;
  }
  .offer .offer__list .list .slick-dots li:not(:first-child) {
    margin-left: 2.0513vw;
  }
  .offer .offer__list .list .slick-dots li button {
    width: 100%;
    height: 100%;
    font-size: 0;
  }
  .offer .offer__list .item {
    margin: 0 2.5641vw;
    height: auto;
    min-height: 1px;
    border-radius: 4.1026vw;
    padding: 7.6923vw 7.6923vw 9.7436vw;
  }
  .offer .offer__list .item::before {
    display: none;
  }
  .offer .offer__list .item .item-link {
    width: 12.3077vw;
    height: 12.3077vw;
    top: 4.1026vw;
    right: 4.1026vw;
    opacity: 1;
    pointer-events: all;
  }
  .offer .offer__list .item .item-link::before {
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .offer .offer__list .item .item-icon {
    width: 47.4359vw;
    height: 47.6923vw;
    margin: 0 auto 4.1026vw;
  }
  .offer .offer__list .item .item-content {
    max-width: 74.1026vw;
  }
  .offer .offer__list .item .item-content__title {
    margin-bottom: 4.1026vw;
  }
  .offer .offer__list .item .item-content__title h3 {
    line-height: 1.4;
    letter-spacing: -0.0564vw;
    font-size: 5.641vw;
  }
  .offer .offer__list .item .item-content__text {
    font-size: 4.1026vw;
    letter-spacing: -0.041vw;
  }
  .offer .offer__list .item .item-button {
    margin-top: 6.4103vw;
    opacity: 1;
  }
  .offer .offer__list .item .item-button a,
  .offer .offer__list .item .item-button button {
    color: var(--white);
    padding: 4.1026vw;
    font-size: 3.3333vw;
    letter-spacing: -0.0333vw;
  }
  .offer .offer__list .item .item-button a::before,
  .offer .offer__list .item .item-button button::before {
    border-radius: 10.5128vw;
    opacity: 1;
  }
  .offer .offer__list .item .item-content__hide-text {
    width: 100%;
    max-width: 71.7949vw;
    margin: 0 auto 3.8462vw;
    letter-spacing: -0.0462vw;
    font-size: 4.1026vw;
  }
  .offer .offer__list .item .item-content__hide-button a,
  .offer .offer__list .item .item-content__hide-button button {
    padding: 4.6154vw 5.1282vw;
    border-radius: 2.5641vw;
    font-size: 4.1026vw;
  }
}
.preview {
  position: relative;
  z-index: 2;
}
.preview .preview__wrapper {
  background-color: var(--purple);
  border-radius: 24px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 43px 80px 0;
}
.preview .preview__content {
  width: 100%;
  max-width: 571px;
  margin-bottom: 110px;
}
.preview .preview__content-title {
  margin-bottom: 20px;
}
.preview .preview__content-text {
  width: 100%;
  max-width: 460px;
  margin-bottom: 23px;
}
.preview .preview__media {
  width: 536px;
  height: 607px;
}
.preview .preview__media img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .preview .preview__wrapper {
    border-radius: 1.8045vw;
    padding: 3.2331vw 6.015vw 0;
  }
  .preview .preview__content {
    max-width: 42.9323vw;
    margin-bottom: 8.2707vw;
  }
  .preview .preview__content-title {
    margin-bottom: 1.5038vw;
  }
  .preview .preview__content-text {
    max-width: 34.5865vw;
    margin-bottom: 1.7293vw;
  }
  .preview .preview__media {
    width: 40.3008vw;
    height: auto;
  }
}
@media screen and (max-width: 1280px) {
  .preview .preview__wrapper {
    border-radius: 1.875vw;
    padding: 5.8594vw 7.0313vw 0;
  }
  .preview .preview__content {
    max-width: 32.8125vw;
    margin-bottom: 6.0938vw;
  }
  .preview .preview__content-title {
    margin-bottom: 2.5vw;
  }
  .preview .preview__content-text {
    max-width: 32.8125vw;
    margin-bottom: 2.5vw;
  }
  .preview .preview__media {
    width: 32.7344vw;
    height: auto;
  }
}
@media screen and (max-width: 850px) {
  .preview .preview__wrapper {
    border-radius: 4.1026vw;
    padding: 8.2051vw 7.9487vw 108.2051vw;
    flex-direction: column;
    position: relative;
    z-index: 2;
  }
  .preview .preview__content {
    max-width: 100%;
    margin-bottom: 12.3077vw;
  }
  .preview .preview__content-title {
    margin-bottom: 5.641vw;
  }
  .preview .preview__content-text {
    max-width: 100%;
    margin-bottom: 5.8974vw;
  }
  .preview .preview__media {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 93.8462vw;
    height: auto;
    margin: 0 auto;
  }
}
.testimonials {
  margin-top: -98px;
  padding: 0 30px;
}
.testimonials .testimonials__inner {
  background-color: var(--beige);
  border-radius: 24px;
  padding: 245px 0 183px;
}
.testimonials .testimonials__header {
  text-align: center;
  margin-bottom: 76px;
}
.testimonials .testimonials__header-title {
  margin-bottom: 13px;
}
.testimonials .testimonials__header-text {
  width: 100%;
  max-width: 521px;
  margin: 0 auto;
}
.testimonials .testimonials__panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 52px;
  margin-bottom: 36px;
  position: relative;
  z-index: 2;
}
.testimonials .testimonials__panel .swiper-pagination {
  width: auto;
  position: relative;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}
.testimonials
  .testimonials__panel
  .swiper-pagination
  .swiper-pagination-bullet {
  position: relative;
  z-index: 2;
  width: auto;
  height: auto;
  background-color: transparent;
  border-radius: 0;
  font-weight: 500;
  line-height: 1.5;
  font-size: 24px;
  letter-spacing: -0.24px;
  color: rgba(22, 22, 22, 0.3);
  opacity: 1;
  margin: 0;
  transition: all 0.4s linear;
}
.testimonials
  .testimonials__panel
  .swiper-pagination
  .swiper-pagination-bullet:not(:first-child) {
  margin-left: 48px;
}
.testimonials
  .testimonials__panel
  .swiper-pagination
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
  color: var(--dark);
}
.testimonials .testimonials__panel .swiper-pagination .pagination-line {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: var(--dark);
  transition: all 0.4s linear;
}
.testimonials
  .testimonials__panel
  .swiper-pagination
  .pagination-line
  .move-line {
  content: "";
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background: var(--gray-4);
}
.testimonials .testimonials__panel-nav {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
}
.testimonials .testimonials__list .item {
  display: flex;
  align-items: stretch;
}
.testimonials .testimonials__list .item .item-content {
  width: 100%;
  background-color: var(--white);
  border-radius: 24px;
  padding: 36px 76px 35px 40px;
}
.testimonials .testimonials__list .item .item-content__logo {
  width: 177px;
  height: 60px;
  margin-bottom: 24px;
}
.testimonials .testimonials__list .item .item-content__logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.testimonials .testimonials__list .item .item-content__text {
  font-weight: 400;
  line-height: 1.4;
  font-size: 28px;
  letter-spacing: -0.28px;
  color: var(--dark);
  margin-bottom: 20px;
}
.testimonials .testimonials__list .item .item-content__info {
  font-weight: 400;
  font-size: 16px;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 35px;
}
.testimonials .testimonials__list .item .item-content__button {
  display: flex;
  justify-content: flex-start;
}
.testimonials .testimonials__list .item .item-content__button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.testimonials .testimonials__list .item .item-content__button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.testimonials .testimonials__list .item .item-content__button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .testimonials
    .testimonials__list
    .item
    .item-content__button
    a:hover::before {
    transform: translateX(3px);
  }
  .testimonials .testimonials__list .item .item-content__button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .testimonials .testimonials__list .item .item-content__button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .testimonials .testimonials__list .item .item-content__button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .testimonials .testimonials__list .item .item-content__button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .testimonials
    .testimonials__list
    .item
    .item-content__button
    a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .testimonials .testimonials__list .item .item-content__button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .testimonials .testimonials__list .item .item-content__button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .testimonials .testimonials__list .item .item-content__button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .testimonials .testimonials__list .item .item-content__button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .testimonials .testimonials__list .item .item-content__button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.testimonials .testimonials__list .item .item-img {
  width: 100%;
  max-width: 520px;
  height: auto;
  min-height: 482px;
  flex: 0 0 auto;
  border-radius: 24px;
  overflow: hidden;
}
.testimonials .testimonials__list .item .item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1330px) {
  .testimonials {
    margin-top: -7.3684vw;
    padding: 0 2.2556vw;
  }
  .testimonials .testimonials__inner {
    border-radius: 1.8045vw;
    padding: 18.4211vw 0 13.7594vw;
  }
  .testimonials .testimonials__header {
    margin-bottom: 5.7143vw;
  }
  .testimonials .testimonials__header-title {
    margin-bottom: 0.9774vw;
  }
  .testimonials .testimonials__header-text {
    max-width: 39.1729vw;
  }
  .testimonials .testimonials__panel {
    gap: 3.9098vw;
    margin-bottom: 2.7068vw;
  }
  .testimonials
    .testimonials__panel
    .swiper-pagination
    .swiper-pagination-bullet {
    font-size: 1.8045vw;
    letter-spacing: -0.018vw;
  }
  .testimonials
    .testimonials__panel
    .swiper-pagination
    .swiper-pagination-bullet:not(:first-child) {
    margin-left: 3.609vw;
  }
  .testimonials .testimonials__panel .swiper-pagination .pagination-line {
    height: 0.1504vw;
  }
  .testimonials .testimonials__list .item .item-content {
    border-radius: 1.8045vw;
    padding: 2.7068vw 5.7143vw 2.6316vw 3.0075vw;
  }
  .testimonials .testimonials__list .item .item-content__logo {
    width: 13.3083vw;
    height: 4.5113vw;
    margin-bottom: 1.8045vw;
  }
  .testimonials .testimonials__list .item .item-content__text {
    font-size: 2.1053vw;
    letter-spacing: -0.0211vw;
    margin-bottom: 1.5038vw;
  }
  .testimonials .testimonials__list .item .item-content__info {
    font-size: 1.203vw;
    margin-bottom: 2.6316vw;
  }
  .testimonials .testimonials__list .item .item-img {
    max-width: 39.0977vw;
    min-height: 36.2406vw;
    border-radius: 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .testimonials {
    margin-top: -6.4844vw;
    padding: 0 2.3438vw;
  }
  .testimonials .testimonials__inner {
    border-radius: 1.875vw;
    padding: 15.4688vw 0 6.6406vw;
  }
  .testimonials .testimonials__header {
    margin-bottom: 5.3125vw;
  }
  .testimonials .testimonials__header-title {
    margin-bottom: 1.5625vw;
  }
  .testimonials .testimonials__header-text {
    max-width: 40.7031vw;
  }
  .testimonials .testimonials__panel {
    gap: 4.0625vw;
    margin-bottom: 2.0313vw;
  }
  .testimonials
    .testimonials__panel
    .swiper-pagination
    .swiper-pagination-bullet {
    font-size: 1.5625vw;
    letter-spacing: -0.0188vw;
  }
  .testimonials
    .testimonials__panel
    .swiper-pagination
    .swiper-pagination-bullet:not(:first-child) {
    margin-left: 5.3906vw;
  }
  .testimonials .testimonials__panel .swiper-pagination .pagination-line {
    bottom: -0.3906vw;
    height: 0.1563vw;
  }
  .testimonials .testimonials__list .item .item-content {
    border-radius: 1.875vw;
    padding: 2.8125vw 3.8281vw 3.75vw 3.125vw;
  }
  .testimonials .testimonials__list .item .item-content__logo {
    width: 8.9063vw;
    height: 3.125vw;
    margin-bottom: 1.875vw;
  }
  .testimonials .testimonials__list .item .item-content__text {
    font-size: 1.5625vw;
    letter-spacing: -0.0156vw;
    margin-bottom: 1.25vw;
  }
  .testimonials .testimonials__list .item .item-content__info {
    font-size: 1.25vw;
    margin-bottom: 1.9531vw;
  }
  .testimonials .testimonials__list .item .item-img {
    max-width: 32.9688vw;
    min-height: 30.4688vw;
    border-radius: 1.5625vw;
  }
}
@media screen and (max-width: 850px) {
  .testimonials {
    margin-top: -33.3333vw;
    padding: 0;
  }
  .testimonials .testimonials__inner {
    border-radius: 4.1026vw 4.1026vw 0 0;
    padding: 56.4103vw 0 17.1795vw;
  }
  .testimonials .testimonials__header {
    margin-bottom: 7.6923vw;
  }
  .testimonials .testimonials__header-title {
    margin-bottom: 5.3846vw;
  }
  .testimonials .testimonials__header-text {
    max-width: 75.641vw;
    margin: 0 auto 8.2051vw;
  }
  .testimonials .testimonials__panel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 13.3333vw;
    margin-bottom: 9.2308vw;
    position: relative;
    z-index: 2;
  }
  .testimonials .testimonials__panel .swiper-pagination {
    width: auto;
    position: relative;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
  }
  .testimonials
    .testimonials__panel
    .swiper-pagination
    .swiper-pagination-bullet {
    position: relative;
    z-index: 2;
    width: auto;
    height: auto;
    background-color: transparent;
    border-radius: 0;
    font-weight: 500;
    line-height: 1.5;
    font-size: 6.1538vw;
    letter-spacing: -0.0615vw;
    color: rgba(22, 22, 22, 0.3);
    opacity: 1;
    margin: 0;
    transition: all 0.4s linear;
  }
  .testimonials
    .testimonials__panel
    .swiper-pagination
    .swiper-pagination-bullet:not(:first-child) {
    margin-left: 12.3077vw;
  }
  .testimonials
    .testimonials__panel
    .swiper-pagination
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
    color: var(--dark);
  }
  .testimonials .testimonials__panel .swiper-pagination .pagination-line {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0.5128vw;
    background-color: var(--dark);
    transition: all 0.4s linear;
  }
  .testimonials .testimonials__panel-nav {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;
  }
  .testimonials .testimonials__list .swiper-pagination {
    margin-top: 4.8718vw;
    position: relative;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .testimonials
    .testimonials__list
    .swiper-pagination
    .swiper-pagination-bullet {
    width: 2.0513vw;
    height: 2.0513vw;
    background-color: var(--dark);
    opacity: 0.2;
    border-radius: 50%;
    transition: all 0.3s linear;
    margin: 0;
    padding: 0;
  }
  .testimonials
    .testimonials__list
    .swiper-pagination
    .swiper-pagination-bullet:not(:first-child) {
    margin-left: 2.0513vw;
  }
  .testimonials
    .testimonials__list
    .swiper-pagination
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 2.5641vw;
    height: 2.5641vw;
    opacity: 1;
  }
  .testimonials .testimonials__list .item {
    flex-direction: column-reverse;
  }
  .testimonials .testimonials__list .item .item-content {
    width: auto;
    border-radius: 4.1026vw;
    padding: 8.2051vw;
  }
  .testimonials .testimonials__list .item .item-content__logo {
    width: 29.4872vw;
    height: 9.7436vw;
    margin-bottom: 4.6154vw;
  }
  .testimonials .testimonials__list .item .item-content__text {
    font-size: 5.1282vw;
    letter-spacing: -0.0513vw;
    margin-bottom: 4.6154vw;
  }
  .testimonials .testimonials__list .item .item-content__info {
    font-size: 3.5897vw;
    margin-bottom: 8.9744vw;
  }
  .testimonials .testimonials__list .item .item-img {
    max-width: 100%;
    height: 76.9231vw;
    border-radius: 4.1026vw;
  }
}
@keyframes line {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
.check {
  position: relative;
  padding: 0 30px;
}
.check .check__inner {
  background-color: var(--dark);
  border-radius: 24px;
  padding: 181px 0 146px;
}
.check .check__title {
  text-align: center;
  margin-bottom: 120px;
}
.check .check__title .title {
  color: var(--white);
}
.check .check__list {
  width: 100%;
}
.check .check__list .list {
  width: 100%;
  display: grid;
  align-items: stretch;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 121px 109px;
}
.check .check__list .item {
  width: 100%;
  height: auto;
}
.check .check__list .item .item-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 38px;
}
.check .check__list .item .item-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.check .check__list .item .item-content__title {
  margin-bottom: 17px;
}
.check .check__list .item .item-content__title h3 {
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.24px;
  font-size: 24px;
  color: var(--white);
}
.check .check__list .item .item-content__text {
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.198px;
  font-size: 18px;
  color: var(--white-2);
}
.check .check__button {
  display: flex;
  justify-content: center;
  margin-top: 101px;
}
.check .check__button .btn:hover {
  background-color: var(--gray-4);
  color: var(--dark);
}

@media screen and (max-width: 1330px) {
  .check {
    padding: 0 2.2556vw;
  }
  .check .check__inner {
    border-radius: 1.8045vw;
    padding: 13.609vw 0 10.9774vw;
  }
  .check .check__title {
    margin-bottom: 9.0226vw;
  }
  .check .check__list .list {
    grid-gap: 9.0977vw 8.1955vw;
  }
  .check .check__list .item .item-icon {
    width: 3.7594vw;
    height: 3.7594vw;
    margin-bottom: 2.8571vw;
  }
  .check .check__list .item .item-content__title {
    margin-bottom: 1.2782vw;
  }
  .check .check__list .item .item-content__title h3 {
    letter-spacing: -0.018vw;
    font-size: 1.8045vw;
  }
  .check .check__list .item .item-content__text {
    letter-spacing: -0.0149vw;
    font-size: 1.3534vw;
  }
  .check .check__button {
    margin-top: 7.594vw;
  }
}
@media screen and (max-width: 1280px) {
  .check {
    padding: 0 2.3438vw;
  }
  .check .check__inner {
    border-radius: 1.875vw;
    padding: 6.7188vw 0 8.5156vw;
  }
  .check .check__title {
    margin-bottom: 8.5156vw;
  }
  .check .check__list .list {
    grid-gap: 8.9063vw 2.5781vw;
  }
  .check .check__list .item .item-icon {
    width: 3.75vw;
    height: 3.75vw;
    margin-bottom: 2.2656vw;
  }
  .check .check__list .item .item-content__title {
    margin-bottom: 1.4844vw;
  }
  .check .check__list .item .item-content__title h3 {
    line-height: 1.4;
    letter-spacing: -0.0172vw;
    font-size: 1.7188vw;
  }
  .check .check__list .item .item-content__text {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .check .check__button {
    margin-top: 7.8906vw;
  }
}
@media screen and (max-width: 850px) {
  .check {
    padding: 0;
  }
  .check .check__inner {
    border-radius: 4.1026vw;
    padding: 15.3846vw 0 21.2821vw;
  }
  .check .check__title {
    margin-bottom: 14.8718vw;
  }
  .check .check__list .list {
    grid-template-columns: 1fr;
    grid-gap: 12.5641vw;
  }
  .check .check__list .item .item-icon {
    width: 20.2564vw;
    height: 14.8718vw;
    margin-bottom: 5.8974vw;
  }
  .check .check__list .item .item-content {
    padding-left: 2.5641vw;
  }
  .check .check__list .item .item-content__title {
    margin-bottom: 4.1026vw;
  }
  .check .check__list .item .item-content__title h3 {
    line-height: 1.4;
    letter-spacing: -0.0564vw;
    font-size: 5.641vw;
  }
  .check .check__list .item .item-content__text {
    line-height: 1.5;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .check .check__button {
    margin-top: 17.6923vw;
  }
}
.words .words__inner {
  padding-top: 395px;
  position: relative;
  z-index: 2;
  overflow: hidden;
  min-height: 1034px;
  display: flex;
  align-items: end;
}
.words .words__coin {
  position: absolute;
  z-index: 2;
  top: 395px;
  top: -20px;
  left: calc(50% - 252px);
  transform: translateX(-50%);
  width: 48px;
  height: 46px;
}
.words .words__coin img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.words .words__image {
  position: absolute;
  z-index: 3;
  bottom: 0;
  left: calc(50% + 64px);
  transform: translateX(-50%);
  width: 912px;
  height: 994px;
  margin: 0 auto;
}
.words .words__image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.words .words__wrapper {
  margin-bottom: 293px;
}
.words .words__lines {
  width: 100%;
  display: flex;
  align-items: center;
}
.words .words__lines:not(:first-child) {
  margin-top: 55px;
}
.words .words__lines:first-child .words__line {
  animation: marquee-reverse 30s infinite linear;
}
.words .words__lines:last-child {
  direction: rtl;
}
.words .words__lines:last-child .words__line {
  animation: marquee 30s infinite linear;
}
.words .words__line {
  flex: 0 0 auto;
  text-align: center;
  white-space: nowrap;
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.1;
  font-size: 110px;
  letter-spacing: -3.3px;
  color: var(--dark);
  pointer-events: none;
}

@media screen and (max-width: 1330px) {
  .words .words__inner {
    padding-top: 225px;
    min-height: 664px;
  }
  .words .words__coin {
    top: -11px;
    left: calc(50% - 199px);
    width: 31px;
    height: 29px;
  }
  .words .words__image {
    left: calc(50% + 2px);
    width: 584px;
    height: 636px;
  }
  .words .words__wrapper {
    margin-bottom: 188px;
  }
  .words .words__lines:not(:first-child) {
    margin-top: 34px;
  }
  .words .words__line {
    font-size: 70px;
    letter-spacing: -2.115px;
  }
}
@media screen and (max-width: 850px) {
  .words .words__inner {
    padding-top: 129px;
    min-height: 400px;
  }
  .words .words__coin {
    position: absolute;
    z-index: 3;
    top: 58px;
    left: calc(50% - 98px);
    transform: translateX(-50%);
    width: 15px;
    height: 15px;
  }
  .words .words__image {
    left: 50%;
    transform: translateX(-50%);
    width: 296px;
    height: auto;
  }
  .words .words__wrapper {
    transform: translateY(-200px);
    margin-bottom: 0;
  }
  .words .words__lines:not(:first-child) {
    margin-top: 21px;
  }
  .words .words__line {
    font-size: 42px;
    letter-spacing: -1.2px;
  }
}
@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes marquee-reverse {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.numbers {
  background-color: var(--yellow);
}
.numbers .numbers__inner {
  padding: 141px 0 171px;
}
.numbers .numbers__header {
  text-align: center;
  margin-bottom: 46px;
}
.numbers .numbers__header-icon {
  width: 232px;
  height: 189px;
  margin: 0 auto 74px;
}
.numbers .numbers__header-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.numbers .numbers__header-title {
  margin-bottom: 10px;
}
.numbers .numbers__header-title h2 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.72px;
  font-size: 72px;
  color: var(--dark);
  text-align: center;
}
.numbers .numbers__header-text {
  width: 100%;
  max-width: 521px;
  margin: 0 auto;
}
.numbers .numbers__list {
  width: 100%;
  max-width: 1216px;
  margin: 0 auto;
}
.numbers .numbers__list .list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 32px;
}
.numbers .numbers__list .item .item-top {
  display: flex;
  justify-content: center;
}
.numbers .numbers__list .item .item-top__number,
.numbers .numbers__list .item .item-top__symbol {
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -1.76px;
  font-size: 80px;
  color: var(--dark);
  text-align: center !important;
}
.numbers .numbers__list .item .item-top__symbol {
  flex: 0 0 auto;
}
.numbers .numbers__list .item .item-title {
  text-align: center;
}
.numbers .numbers__list .item .item-title h3 {
  font-weight: 400;
  line-height: 1.4;
  font-size: 18px;
  letter-spacing: -0.18px;
  color: var(--gray-2);
  text-align: center;
}
.numbers .numbers__buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 76px;
}
@media screen and (max-width: 1330px) {
  .numbers .numbers__inner {
    padding: 10.6015vw 0 12.8571vw;
  }
  .numbers .numbers__header {
    margin-bottom: 3.4586vw;
  }
  .numbers .numbers__header-icon {
    width: 17.4436vw;
    height: 14.2105vw;
    margin: 0 auto 5.5639vw;
  }
  .numbers .numbers__header-title {
    margin-bottom: 0.7519vw;
  }
  .numbers .numbers__header-title h2 {
    letter-spacing: -0.0541vw;
    font-size: 5.4135vw;
  }
  .numbers .numbers__header-text {
    max-width: 39.1729vw;
  }
  .numbers .numbers__list {
    max-width: 91.4286vw;
  }
  .numbers .numbers__list .list {
    grid-gap: 2.406vw;
  }
  .numbers .numbers__list .item .item-top__number,
  .numbers .numbers__list .item .item-top__symbol {
    letter-spacing: -0.1323vw;
    font-size: 6.015vw;
  }
  .numbers .numbers__list .item .item-title h3 {
    font-size: 1.3534vw;
    letter-spacing: -0.0135vw;
  }
  .numbers .numbers__buttons {
    gap: 1.203vw;
    margin-top: 5.7143vw;
  }
}
@media screen and (max-width: 1280px) {
  .numbers .numbers__inner {
    padding: 8.8281vw 0 10.8594vw;
  }
  .numbers .numbers__header {
    margin-bottom: 3.75vw;
  }
  .numbers .numbers__header-icon {
    width: 14.7656vw;
    height: 12.1094vw;
    margin: 0 auto 5.0781vw;
  }
  .numbers .numbers__header-title {
    margin-bottom: 1.875vw;
  }
  .numbers .numbers__header-title h2 {
    letter-spacing: -0.0297vw;
    font-size: 2.9688vw;
  }
  .numbers .numbers__header-text {
    max-width: 40.7031vw;
  }
  .numbers .numbers__list {
    max-width: 82.0313vw;
  }
  .numbers .numbers__list .list {
    grid-gap: 2.3438vw;
  }
  .numbers .numbers__list .item .item-top__number,
  .numbers .numbers__list .item .item-top__symbol {
    letter-spacing: -0.1031vw;
    font-size: 4.6875vw;
  }
  .numbers .numbers__list .item .item-title h3 {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
  }
  .numbers .numbers__buttons {
    gap: 1.25vw;
    margin-top: 5.3906vw;
  }
}
@media screen and (max-width: 850px) {
  .numbers .numbers__inner {
    padding: 24.8718vw 0 21.5385vw;
  }
  .numbers .numbers__header {
    margin-bottom: 8.2051vw;
  }
  .numbers .numbers__header-icon {
    width: 32.5641vw;
    height: 26.6667vw;
    margin: 0 auto 8.4615vw;
  }
  .numbers .numbers__header-title {
    width: 100%;
    max-width: 74.359vw;
    margin: 0 auto 4.6154vw;
  }
  .numbers .numbers__header-title h2 {
    letter-spacing: -0.0821vw;
    font-size: 8.2051vw;
  }
  .numbers .numbers__header-text {
    max-width: 100%;
  }
  .numbers .numbers__list {
    max-width: 100%;
  }
  .numbers .numbers__list .list {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8.2051vw 6.1538vw;
  }
  .numbers .numbers__list .item .item-top__number,
  .numbers .numbers__list .item .item-top__symbol {
    letter-spacing: -0.2256vw;
    font-size: 10.2564vw;
  }
  .numbers .numbers__list .item .item-title h3 {
    line-height: 1.5;
    font-size: 4.1026vw;
    letter-spacing: -0.041vw;
  }
  .numbers .numbers__buttons {
    flex-direction: column;
    gap: 4.1026vw;
    margin-top: 8.2051vw;
  }
}
.about-cards.about-cards-light .about-cards__title .title,
.about-cards.about-cards-light .about-cards__list .item .item-content__title h3,
.about-cards.about-cards-light .about-cards__list .item .item-content__text {
  color: var(--white);
}
.about-cards .about-cards__inner {
  padding-bottom: 96px;
}
.about-cards .about-cards__title {
  width: 100%;
  max-width: 983px;
  margin: 0 auto 76px;
  text-align: center;
}
.about-cards .about-cards__list {
  width: 100%;
}
.about-cards .about-cards__list .list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 31px;
}
.about-cards .about-cards__list .item .item-icon {
  width: 58px;
  height: 58px;
  margin-bottom: 24px;
}
.about-cards .about-cards__list .item .item-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.about-cards .about-cards__list .item .item-content__title {
  margin-bottom: 19px;
}
.about-cards .about-cards__list .item .item-content__title h3 {
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.24px;
  font-size: 24px;
  color: var(--dark);
}
.about-cards .about-cards__list .item .item-content__text {
  width: 100%;
  max-width: 375px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.3px;
  font-size: 18px;
  color: var(--gray);
}
.about-cards.about-cards--big .about-cards__list {
  padding: 0 45px 0 55px;
}
.about-cards.about-cards--big .about-cards__list .list {
  grid-template-columns: repeat(2, 1fr);
  gap: 80px 114px;
}
.about-cards.about-cards--big .about-cards__list .item {
  display: flex;
  gap: 16px;
}
.about-cards.about-cards--big .about-cards__list .item .item-content__title {
  margin-bottom: 32px;
}
.about-cards.about-cards--big .about-cards__list .item .item-content__title h3 {
  font-family: "Cambon";
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.01em;
}
.about-cards.about-cards--big .about-cards__list .item .item-icon {
  width: 58px;
  height: 58px;
  margin-bottom: 0;
  flex-shrink: 0;
}
.about-cards .about-cards__numbers {
  width: 100%;
  margin-top: 82px;
  padding-top: 62px;
  border-top: 1px solid rgba(22, 22, 22, 0.15);
  position: relative;
  z-index: 2;
}
.about-cards .about-cards__numbers .about-cards__numbers-title {
  position: absolute;
  top: 16px;
  left: 0;
  color: var(--dark);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
.about-cards .about-cards__numbers .list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
}
.about-cards .about-cards__numbers .item {
  width: 100%;
}
.about-cards .about-cards__numbers .item .item-top {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.about-cards .about-cards__numbers .item .item-top__symbol,
.about-cards .about-cards__numbers .item .item-top__number {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.4px;
  font-size: 40px;
  color: var(--dark);
}
.about-cards .about-cards__numbers .item .item-title h3 {
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--dark);
}

.page-template-lp .about-cards .about-cards__list .list {
  grid-gap: 88px;
}

@media screen and (max-width: 1330px) {
  .about-cards .about-cards__inner {
    padding-bottom: 7.218vw;
  }
  .about-cards .about-cards__title {
    max-width: 73.9098vw;
    margin: 0 auto 5.7143vw;
  }
  .about-cards .about-cards__list .list {
    grid-gap: 2.3308vw;
  }
  .about-cards .about-cards__list .item .item-icon {
    width: 4.3609vw;
    height: 4.3609vw;
    margin-bottom: 1.8045vw;
  }
  .about-cards .about-cards__list .item .item-content__title {
    margin-bottom: 1.4286vw;
  }
  .about-cards .about-cards__list .item .item-content__title h3 {
    letter-spacing: -0.018vw;
    font-size: 1.8045vw;
  }
  .about-cards .about-cards__list .item .item-content__text {
    max-width: 28.1955vw;
    letter-spacing: -0.0226vw;
    font-size: 1.3534vw;
  }
  .about-cards .about-cards__numbers {
    margin-top: 6.1654vw;
    padding-top: 4.6617vw;
  }
  .about-cards .about-cards__numbers .about-cards__numbers-title {
    top: 1.203vw;
    font-size: 1.0526vw;
  }
  .about-cards .about-cards__numbers .list {
    grid-gap: 2.2556vw;
  }
  .about-cards .about-cards__numbers .item .item-top {
    margin-bottom: 0.4511vw;
  }
  .about-cards .about-cards__numbers .item .item-top__symbol,
  .about-cards .about-cards__numbers .item .item-top__number {
    letter-spacing: -0.0301vw;
    font-size: 3.0075vw;
  }
  .about-cards .about-cards__numbers .item .item-title h3 {
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
  }
  .about-cards.about-cards--big .about-cards__list {
    padding: 0 3.383vw 0 4.135vw;
  }
  .about-cards.about-cards--big .about-cards__list .list {
    gap: 6.015vw 8.571vw;
  }
  .about-cards.about-cards--big .about-cards__list .item {
    gap: 1.203vw;
  }
  .about-cards.about-cards--big .about-cards__list .item .item-content__title {
    margin-bottom: 2.406vw;
  }
  .about-cards.about-cards--big
    .about-cards__list
    .item
    .item-content__title
    h3 {
    font-size: 3.008vw;
    line-height: 3.609vw;
  }
  .about-cards.about-cards--big .about-cards__list .item .item-icon {
    width: 4.361vw;
    height: 4.361vw;
  }
  .page-template-lp .about-cards .about-cards__list .list {
    grid-gap: 6.617vw;
  }
}
@media screen and (max-width: 1280px) {
  .about-cards .about-cards__inner {
    padding-bottom: 7.0313vw;
  }
  .about-cards .about-cards__title {
    max-width: 39.8438vw;
    margin: 0 auto 4.1406vw;
  }
  .about-cards .about-cards__list .list {
    grid-gap: 2.3438vw;
  }
  .about-cards .about-cards__list .item .item-icon {
    width: 4.5313vw;
    height: 4.5313vw;
    margin-bottom: 1.9531vw;
  }
  .about-cards .about-cards__list .item .item-content__title {
    margin-bottom: 0.7031vw;
  }
  .about-cards .about-cards__list .item .item-content__title h3 {
    letter-spacing: -0.0172vw;
    font-size: 1.7188vw;
  }
  .about-cards .about-cards__list .item .item-content__text {
    max-width: 25.7031vw;
    line-height: 1.4;
    letter-spacing: 0px;
    font-size: 1.25vw;
  }
  .about-cards .about-cards__numbers {
    margin-top: 7.4219vw;
    padding-top: 5.1563vw;
  }
  .about-cards .about-cards__numbers .about-cards__numbers-title {
    top: 0.7031vw;
    font-size: 1.0938vw;
  }
  .about-cards .about-cards__numbers .list {
    grid-gap: 2.3438vw;
  }
  .about-cards .about-cards__numbers .item .item-top {
    margin-bottom: 0.625vw;
  }
  .about-cards .about-cards__numbers .item .item-top__symbol,
  .about-cards .about-cards__numbers .item .item-top__number {
    letter-spacing: -0.0234vw;
    font-size: 2.3438vw;
  }
  .about-cards .about-cards__numbers .item .item-title h3 {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .about-cards.about-cards--big .about-cards__list {
    padding: 0 3.516vw 0 4.297vw;
  }
  .about-cards.about-cards--big .about-cards__list .list {
    gap: 6.25vw 8.906vw;
  }
  .about-cards.about-cards--big .about-cards__list .item {
    gap: 1.25vw;
  }
  .about-cards.about-cards--big .about-cards__list .item .item-content__title {
    margin-bottom: 2.5vw;
  }
  .about-cards.about-cards--big
    .about-cards__list
    .item
    .item-content__title
    h3 {
    font-size: 3.125vw;
    line-height: 3.75vw;
  }
  .about-cards.about-cards--big .about-cards__list .item .item-icon {
    width: 4.531vw;
    height: 4.531vw;
  }
  .page-template-lp .about-cards .about-cards__list .list {
    grid-gap: 6.875vw;
  }
}
@media screen and (max-width: 850px) {
  .about-cards .about-cards__inner {
    padding-bottom: 14.6154vw;
  }
  .about-cards .about-cards__title {
    max-width: 76.9231vw;
    margin: 0 auto 13.8462vw;
  }
  .about-cards .about-cards__title h2 br {
    display: none;
  }
  .about-cards .about-cards__list .list {
    grid-template-columns: 1fr;
    grid-gap: 11.7949vw;
  }
  .about-cards .about-cards__list .item .item-icon {
    width: 14.8718vw;
    height: 14.8718vw;
    margin-bottom: 6.4103vw;
  }
  .about-cards .about-cards__list .item .item-content__title {
    margin-bottom: 3.5897vw;
  }
  .about-cards .about-cards__list .item .item-content__title h3 {
    letter-spacing: -0.3333vw;
    font-size: 6.1538vw;
  }
  .about-cards .about-cards__list .item .item-content__text {
    max-width: 96.1538vw;
    letter-spacing: -0.0769vw;
    font-size: 4.1026vw;
  }
  .about-cards .about-cards__numbers {
    margin-top: 19.4872vw;
    padding-top: 13.0769vw;
  }
  .about-cards .about-cards__numbers .about-cards__numbers-title {
    top: 4.1026vw;
    font-size: 3.5897vw;
  }
  .about-cards .about-cards__numbers .list {
    width: 100%;
    grid-template-columns: 1fr;
    grid-gap: 8.7179vw;
  }
  .about-cards .about-cards__numbers .item {
    width: 100%;
  }
  .about-cards .about-cards__numbers .item .item-top {
    margin-bottom: 1.7949vw;
  }
  .about-cards .about-cards__numbers .item .item-top__symbol,
  .about-cards .about-cards__numbers .item .item-top__number {
    letter-spacing: -0.1026vw;
    font-size: 10.2564vw;
  }
  .about-cards .about-cards__numbers .item .item-title h3 {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .about-cards.about-cards--big .about-cards__list {
    padding: 0;
  }
  .about-cards.about-cards--big .about-cards__list .list {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .about-cards.about-cards--big .about-cards__list .item {
    display: flex;
    flex-direction: column;
    gap: 6.154vw;
  }
  .about-cards.about-cards--big .about-cards__list .item .item-content__title {
    margin-bottom: 6.154vw;
  }
  .about-cards.about-cards--big
    .about-cards__list
    .item
    .item-content__title
    h3 {
    font-size: 7.179vw;
    line-height: 8.718vw;
  }
  .about-cards.about-cards--big .about-cards__list .item .item-icon {
    width: 14.872vw;
    height: 14.872vw;
  }
  .page-template-lp .about-cards .about-cards__list .list {
    grid-gap: 11.7949vw;
  }
}
.testimonials-cards {
  margin-bottom: 148px;
}
.testimonials-cards.testimonials-cards--lp .testimonials-cards__wrapper {
  padding: 95px 156px 92px 142px;
}
.testimonials-cards.testimonials-cards--lp .testimonials-cards__content {
  width: 100%;
  max-width: 100%;
}
.testimonials-cards.testimonials-cards--lp .testimonials-cards__content-text {
  font-family: "Cambon";
  font-size: 54px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  margin-bottom: 78px;
}
.testimonials-cards.testimonials-cards--lp
  .testimonials-cards__content-info-position {
  font-size: 18px;
}
.testimonials-cards .testimonials-cards__wrapper {
  width: 100%;
  background-color: var(--yellow);
  border-radius: 24px;
  overflow: hidden;
  padding: 114px 156px 116px 156px;
  display: flex;
  align-items: flex-start;
  gap: 100px;
}
.testimonials-cards .testimonials-cards__image {
  width: 200px;
  height: 300px;
  border-radius: 24px;
  background: linear-gradient(180deg, #ededed 0%, #f7f7f7 81.83%);
  overflow: hidden;
  flex: 0 0 auto;
}
.testimonials-cards .testimonials-cards__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.testimonials-cards .testimonials-cards__content {
  width: 100%;
  max-width: 678px;
}
.testimonials-cards .testimonials-cards__content-text {
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: -0.5px;
  font-size: 28px;
  color: var(--dark);
  margin-bottom: 14px;
}
.testimonials-cards .testimonials-cards__content-button {
  display: inline-block;
  margin-bottom: 56px;
}
.testimonials-cards .testimonials-cards__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.testimonials-cards .testimonials-cards__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.testimonials-cards .testimonials-cards__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .testimonials-cards .testimonials-cards__content-button a:hover::before {
    transform: translateX(3px);
  }
  .testimonials-cards .testimonials-cards__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .testimonials-cards .testimonials-cards__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .testimonials-cards .testimonials-cards__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .testimonials-cards .testimonials-cards__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .testimonials-cards .testimonials-cards__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .testimonials-cards .testimonials-cards__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .testimonials-cards .testimonials-cards__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .testimonials-cards .testimonials-cards__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .testimonials-cards .testimonials-cards__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .testimonials-cards .testimonials-cards__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.testimonials-cards .testimonials-cards__content-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.testimonials-cards .testimonials-cards__content-info-name {
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.2px;
  font-size: 20px;
  color: var(--dark);
  margin-bottom: -3px;
}
.testimonials-cards .testimonials-cards__content-info-position {
  font-weight: 400;
  line-height: 1.5;
  font-size: 16px;
  letter-spacing: -0.4px;
  color: var(--dark);
}
.testimonials-cards .testimonials-cards__content-logo {
  width: 143px;
  height: auto;
}
.testimonials-cards .testimonials-cards__content-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.testimonials-cards.testimonials-cards--big {
  margin: 0 30px 30px 30px;
  border-radius: 24px;
  background-color: #b8dfd7;
}
.testimonials-cards.testimonials-cards--big .testimonials-cards__wrapper {
  background-color: transparent;
}
.testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
  .testimonials-cards__content {
  max-width: 100%;
}
.testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
  .testimonials-cards__content-text,
.testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
  .testimonials-cards__content-info {
  max-width: 678px;
}
.testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
  .testimonials-cards__image {
  display: none !important;
}

@media screen and (max-width: 1330px) {
  .testimonials-cards {
    margin-bottom: 11.1278vw;
  }
  .testimonials-cards.testimonials-cards--lp .testimonials-cards__wrapper {
    padding: 7.1429vw 11.7293vw 6.9173vw 10.6767vw;
  }
  .testimonials-cards.testimonials-cards--lp .testimonials-cards__content-text {
    font-size: 4.0602vw;
    margin-bottom: 5.8647vw;
  }
  .testimonials-cards.testimonials-cards--lp
    .testimonials-cards__content-info-position {
    font-size: 1.3534vw;
  }
  .testimonials-cards .testimonials-cards__wrapper {
    border-radius: 1.8045vw;
    padding: 8.5714vw 11.7293vw 8.7218vw 11.7293vw;
    gap: 7.5188vw;
  }
  .testimonials-cards .testimonials-cards__image {
    width: 15.0376vw;
    height: 22.5564vw;
    border-radius: 1.8045vw;
  }
  .testimonials-cards .testimonials-cards__content {
    max-width: 50.9774vw;
  }
  .testimonials-cards .testimonials-cards__content-text {
    letter-spacing: -0.0376vw;
    font-size: 2.1053vw;
    margin-bottom: 1.0526vw;
  }
  .testimonials-cards .testimonials-cards__content-button {
    margin-bottom: 4.2105vw;
  }
  .testimonials-cards .testimonials-cards__content-info-name {
    letter-spacing: -0.015vw;
    font-size: 1.5038vw;
    margin-bottom: -0.2256vw;
  }
  .testimonials-cards .testimonials-cards__content-info-position {
    font-size: 1.203vw;
    letter-spacing: -0.0301vw;
  }
  .testimonials-cards .testimonials-cards__content-logo {
    width: 10.7519vw;
  }
  .testimonials-cards.testimonials-cards--big {
    margin: 0 2.256vw 2.256vw 2.256vw;
    border-radius: 1.805vw;
  }
  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
    .testimonials-cards__content-text,
  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
    .testimonials-cards__content-info {
    max-width: 50.977vw;
  }
}
@media screen and (max-width: 1280px) {
  .testimonials-cards {
    margin-bottom: 7.0313vw;
  }
  .testimonials-cards.testimonials-cards--lp .testimonials-cards__wrapper {
    padding: 7.0313vw;
  }
  .testimonials-cards.testimonials-cards--lp .testimonials-cards__content-text {
    font-size: 3.5156vw;
    margin-bottom: 3.9063vw;
  }
  .testimonials-cards.testimonials-cards--lp
    .testimonials-cards__content-info-position {
    font-size: 1.4063vw;
  }
  .testimonials-cards .testimonials-cards__wrapper {
    border-radius: 1.875vw;
    padding: 7.0313vw;
    gap: 3.9063vw;
  }
  .testimonials-cards .testimonials-cards__image {
    width: 15.625vw;
    height: 23.4375vw;
    border-radius: 1.4063vw;
  }
  .testimonials-cards .testimonials-cards__content {
    max-width: 48.4375vw;
  }
  .testimonials-cards .testimonials-cards__content-text {
    letter-spacing: -0.0156vw;
    font-size: 1.5625vw;
    margin-bottom: 1.0938vw;
  }
  .testimonials-cards .testimonials-cards__content-button {
    margin-bottom: 9.9219vw;
  }
  .testimonials-cards .testimonials-cards__content-info-name {
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
    margin-bottom: -0.2344vw;
  }
  .testimonials-cards .testimonials-cards__content-info-position {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
  }
  .testimonials-cards .testimonials-cards__content-logo {
    width: 9.2969vw;
  }
  .testimonials-cards.testimonials-cards--big {
    margin: 0 2.344vw 2.344vw 2.344vw;
    border-radius: 1.875vw;
  }
  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
    .testimonials-cards__content-text,
  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
    .testimonials-cards__content-info {
    max-width: 52.969vw;
  }
}
@media screen and (max-width: 850px) {
  .testimonials-cards {
    margin-bottom: 17.9487vw;
  }
  .testimonials-cards.testimonials-cards--lp .testimonials-cards__wrapper {
    padding: 8.2051vw;
  }
  .testimonials-cards.testimonials-cards--lp .testimonials-cards__content-text {
    font-size: 6.1538vw;
    letter-spacing: -0.01em;
    margin-bottom: 7.9487vw;
  }
  .testimonials-cards.testimonials-cards--lp
    .testimonials-cards__content-footer {
    gap: 6.1538vw;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .testimonials-cards.testimonials-cards--lp .testimonials-cards__content-logo {
    margin: 0;
    width: 22.0256vw;
  }
  .testimonials-cards.testimonials-cards--lp
    .testimonials-cards__content-info-position {
    font-size: 3.5897vw;
  }
  .testimonials-cards .testimonials-cards__wrapper {
    border-radius: 4.1026vw;
    padding: 8.2051vw;
    gap: 0;
    align-items: flex-start;
    flex-direction: column;
  }
  .testimonials-cards .testimonials-cards__image {
    width: 25.1282vw;
    height: 37.9487vw;
    border-radius: 4.1026vw;
  }
  .testimonials-cards .testimonials-cards__content {
    max-width: 100%;
  }
  .testimonials-cards .testimonials-cards__content-text {
    letter-spacing: -0.0897vw;
    font-size: 5.1282vw;
    margin-bottom: 4.1026vw;
  }
  .testimonials-cards .testimonials-cards__content-button {
    margin-bottom: 13.0769vw;
  }
  .testimonials-cards .testimonials-cards__content-footer {
    margin-top: 3.8462vw;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  }
  .testimonials-cards .testimonials-cards__content-info-name {
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
    margin-bottom: -1px;
  }
  .testimonials-cards .testimonials-cards__content-info-position {
    font-size: 3.5897vw;
    letter-spacing: -0.0667vw;
  }
  .testimonials-cards .testimonials-cards__content-logo {
    margin-top: 8.4615vw;
    width: 31.0256vw;
  }
  .testimonials-cards.testimonials-cards--big {
    margin: 0 5.128vw 4.103vw 5.128vw;
    border-radius: 4.103vw;
  }
  .testimonials-cards.testimonials-cards--big .testimonials-cards__content {
    max-width: 100%;
  }
  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
    .testimonials-cards__content-text,
  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
    .testimonials-cards__content-info {
    max-width: 100%;
  }
  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img
    .testimonials-cards__content-footer {
    margin-top: 0;
  }
}
.info .info__inner {
  padding-bottom: 157px;
}
.info .info__list .list:not(:first-child) {
  margin-top: 81px;
}
.info .info__list .list .item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 55px 0 85px;
  gap: 170px;
}
.info .info__list .list .item.item--reverse {
  flex-direction: row-reverse;
  padding: 0 85px 0 55px;
}
.info .info__list .item:not(:first-child) {
  margin-top: 81px;
}
.info .info__list .item .item-media {
  width: 100%;
  max-width: 520px;
  height: 400px;
  border-radius: 24px;
  overflow: hidden;
}
.info .info__list .item .item-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.info .info__list .item .item__content {
  width: 100%;
  max-width: 460px;
  margin-top: 88px;
}
.info .info__list .item .item__content-title {
  margin-bottom: 29px;
}
.info .info__list .item .item__content-title h3 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.4px;
  font-size: 40px;
  color: var(--dark);
}
.info .info__list .item .item__content-text {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 20px;
  color: var(--gray);
}
.info .info__list .item .item__content-button {
  display: inline-block;
  margin-top: 23px;
}
.info .info__list .item .item__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.info .info__list .item .item__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.info .info__list .item .item__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .info .info__list .item .item__content-button a:hover::before {
    transform: translateX(3px);
  }
  .info .info__list .item .item__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .info .info__list .item .item__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .info .info__list .item .item__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .info .info__list .item .item__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .info .info__list .item .item__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .info .info__list .item .item__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .info .info__list .item .item__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .info .info__list .item .item__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .info .info__list .item .item__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .info .info__list .item .item__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}

@media screen and (max-width: 1330px) {
  .info .info__inner {
    padding-bottom: 11.8045vw;
  }
  .info .info__list .list:not(:first-child) {
    margin-top: 6.0902vw;
  }
  .info .info__list .list .item {
    padding: 0 4.1353vw 0 6.391vw;
    gap: 12.782vw;
  }
  .info .info__list .list .item.item--reverse {
    padding: 0 6.391vw 0 4.1353vw;
  }
  .info .info__list .item:not(:first-child) {
    margin-top: 6.0902vw;
  }
  .info .info__list .item .item-media {
    max-width: 39.0977vw;
    height: 30.0752vw;
    border-radius: 1.8045vw;
  }
  .info .info__list .item .item__content {
    max-width: 34.5865vw;
    margin-top: 6.6165vw;
  }
  .info .info__list .item .item__content-title {
    margin-bottom: 2.1805vw;
  }
  .info .info__list .item .item__content-title h3 {
    letter-spacing: -0.0301vw;
    font-size: 3.0075vw;
  }
  .info .info__list .item .item__content-text {
    letter-spacing: -0.0301vw;
    font-size: 1.5038vw;
  }
  .info .info__list .item .item__content-button {
    margin-top: 1.7293vw;
  }
}
@media screen and (max-width: 1280px) {
  .info .info__inner {
    padding-bottom: 12.3438vw;
  }
  .info .info__list .list:not(:first-child) {
    margin-top: 6.7188vw;
  }
  .info .info__list .list .item {
    padding: 0 2.5781vw 0 4.6875vw;
    gap: 9.6875vw;
  }
  .info .info__list .list .item.item--reverse {
    padding: 0 4.6875vw 0 2.5781vw;
  }
  .info .info__list .item:not(:first-child) {
    margin-top: 6.25vw;
  }
  .info .info__list .item .item-media {
    max-width: 34.5313vw;
    height: 26.5625vw;
    border-radius: 1.875vw;
  }
  .info .info__list .item .item__content {
    max-width: 30.4688vw;
    margin-top: 3.9063vw;
  }
  .info .info__list .item .item__content-title {
    margin-bottom: 2.5vw;
  }
  .info .info__list .item .item__content-title h3 {
    letter-spacing: -0.0234vw;
    font-size: 2.3438vw;
  }
  .info .info__list .item .item__content-text {
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
  }
  .info .info__list .item .item__content-button {
    margin-top: 1.1719vw;
  }
}
@media screen and (max-width: 850px) {
  .info .info__inner {
    padding-bottom: 17.2564vw;
  }
  .info .info__list .list:not(:first-child) {
    margin-top: 16.9231vw;
  }
  .info .info__list .list .item {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column-reverse;
    padding: 0;
    gap: 9.2308vw;
  }
  .info .info__list .list .item.item--reverse {
    flex-direction: column-reverse;
    padding: 0;
  }
  .info .info__list .item:not(:first-child) {
    margin-top: 16.9231vw;
  }
  .info .info__list .item .item-media {
    max-width: 100%;
    height: 69.2308vw;
    border-radius: 4.1026vw;
  }
  .info .info__list .item .item__content {
    max-width: 100%;
    margin-top: 0;
  }
  .info .info__list .item .item__content-title {
    margin-bottom: 5.641vw;
  }
  .info .info__list .item .item__content-title h3 {
    letter-spacing: -0.0718vw;
    font-size: 7.1795vw;
  }
  .info .info__list .item .item__content-text {
    letter-spacing: -0.0769vw;
    font-size: 4.6154vw;
  }
  .info .info__list .item .item__content-button {
    margin-top: 4.1026vw;
  }
}
.fact {
  position: relative;
  z-index: 2;
  padding: 0 30px 30px;
  border-radius: 0 0 24px 24px;
  background-color: var(--white);
}
.fact .fact__inner {
  background-color: var(--beige);
  border-radius: 24px;
  padding: 155px 0 160px;
}
.fact .fact__title {
  width: 100%;
  max-width: 960px;
  margin: 0 auto 90px;
  text-align: center;
}
.fact .fact__wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 48px;
}
.fact .fact__content {
  width: 100%;
  max-width: 624px;
}
.fact .fact__content .fact__statistic-logo {
  display: none;
}
.fact .fact__content-img {
  width: 100%;
  height: 316px;
  border-radius: 24px;
  overflow: hidden;
  margin-bottom: 42px;
}
.fact .fact__content-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.fact .fact__content-text {
  font-weight: 400;
  line-height: 1.4;
  font-size: 28px;
  letter-spacing: -0.5px;
  color: var(--dark);
}
.fact .fact__content-text.small-text {
  font-size: 20px;
}
.fact .fact__content-text.small-text b {
  font-size: 28px;
}
.fact .fact__content-text ul li {
  position: relative;
  z-index: 2;
  padding-left: 20px;
}
.fact .fact__content-text ul li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: var(--dark);
}
.fact .fact__content-button {
  display: inline-block;
  margin-top: 22px;
}
.fact .fact__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.fact .fact__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.fact .fact__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .fact .fact__content-button a:hover::before {
    transform: translateX(3px);
  }
  .fact .fact__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .fact .fact__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .fact .fact__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .fact .fact__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .fact .fact__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .fact .fact__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .fact .fact__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .fact .fact__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .fact .fact__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .fact .fact__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.fact .fact__content-info {
  display: flex;
  align-items: center;
  margin-top: 38px;
}
.fact .fact__content-info-img {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  margin-right: 24px;
}
.fact .fact__content-info-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.fact .fact__content-info-name {
  font-weight: 500;
  font-size: 20px;
  color: var(--dark);
  margin-bottom: 11px;
}
.fact .fact__content-info-position {
  font-weight: 400;
  font-size: 18px;
  color: var(--dark);
}
.fact .fact__statistic {
  width: 100%;
  max-width: 316px;
}
.fact .fact__statistic-logo {
  width: 100%;
  height: 316px;
  background-color: var(--white);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fact .fact__statistic-logo img {
  width: 160px;
  height: 220px;
  object-fit: contain;
}
.fact .fact__statistic-numbers {
  margin-top: 42px;
}
.fact .fact__statistic-numbers .item:not(:first-child) {
  margin-top: 28px;
}
.fact .fact__statistic-numbers .item .item-top {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.fact .fact__statistic-numbers .item .item-top__number,
.fact .fact__statistic-numbers .item .item-top__symbol {
  font-family: "Cambon";
  font-weight: 700;
  font-size: 50px;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: var(--dark);
}
.fact .fact__statistic-numbers .item .item-title {
  width: 100%;
  max-width: 250px;
}
.fact .fact__statistic-numbers .item .item-title h3 {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--gray-2);
}

.page-template-lp .fact .fact__title .title {
  font-size: 48px;
}

.page-template-lp .fact .fact__content-text {
  font-size: 20px;
}

.page-template-lp .fact .fact__content-text b {
  font-size: 28px;
}

.page-template-lp .fact .fact__statistic-numbers .item .item-top__number,
.page-template-lp .fact .fact__statistic-numbers .item .item-top__symbol {
  font-size: 48px;
}

@media screen and (max-width: 1280px) {
  .fact {
    padding: 0 2.3438vw 2.3438vw;
    border-radius: 0 0 1.875vw 1.875vw;
  }
  .fact .fact__inner {
    border-radius: 1.875vw;
    padding: 9.7656vw 0 10.1563vw;
  }
  .fact .fact__title {
    max-width: 53.9063vw;
    margin: 0 auto 5.1563vw;
  }
  .fact .fact__wrapper {
    gap: 3.125vw;
  }
  .fact .fact__content {
    width: 100%;
    max-width: 48.75vw;
  }
  .fact .fact__content-img {
    height: 24.6875vw;
    border-radius: 1.875vw;
    margin-bottom: 3.5938vw;
  }
  .fact .fact__content-text {
    max-width: 44.1406vw;
    font-size: 1.5625vw;
    letter-spacing: 0px;
  }
  .fact .fact__content-text.small-text {
    font-size: 1.5625vw;
  }
  .fact .fact__content-text.small-text b {
    font-size: 2.1875vw;
  }
  .fact .fact__content-text ul li {
    padding-left: 1.5625vw;
  }
  .fact .fact__content-text ul li::before {
    top: 0.7813vw;
    width: 0.7031vw;
    height: 0.7031vw;
  }
  .fact .fact__content-button {
    margin-top: 1.4063vw;
  }
  .fact .fact__content-info {
    margin-top: 3.2813vw;
  }
  .fact .fact__content-info-img {
    width: 6.0938vw;
    height: 6.0938vw;
    margin-right: 1.875vw;
  }
  .fact .fact__content-info-name {
    font-size: 1.4063vw;
    margin-bottom: 0.4688vw;
  }
  .fact .fact__content-info-position {
    font-size: 1.25vw;
  }
  .fact .fact__statistic {
    max-width: 24.6875vw;
  }
  .fact .fact__statistic-logo {
    height: 24.6875vw;
    border-radius: 1.875vw;
  }
  .fact .fact__statistic-logo img {
    width: 12.5vw;
    height: 17.1875vw;
  }
  .fact .fact__statistic-numbers {
    margin-top: 3.75vw;
    padding-left: 0.7031vw;
  }
  .fact .fact__statistic-numbers .item:not(:first-child) {
    margin-top: 3.5938vw;
  }
  .fact .fact__statistic-numbers .item .item-top {
    margin-bottom: 0.625vw;
  }
  .fact .fact__statistic-numbers .item .item-top__number,
  .fact .fact__statistic-numbers .item .item-top__symbol {
    font-size: 2.9688vw;
    letter-spacing: -0.0297vw;
  }
  .fact .fact__statistic-numbers .item .item-title {
    max-width: 19.5313vw;
  }
  .fact .fact__statistic-numbers .item .item-title h3 {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .page-template-lp .fact .fact__title .title {
    font-size: 3.75vw;
  }
  .page-template-lp .fact .fact__content-text {
    font-size: 1.563vw;
  }
  .page-template-lp .fact .fact__content-text b {
    font-size: 2.188vw;
  }
  .page-template-lp .fact .fact__statistic-numbers .item .item-top__number,
  .page-template-lp .fact .fact__statistic-numbers .item .item-top__symbol {
    font-size: 3.75vw;
  }
}
@media screen and (max-width: 850px) {
  .fact {
    padding: 0;
    border-radius: 4.1026vw;
  }
  .fact .fact__inner {
    border-radius: 4.1026vw;
    padding: 17.4359vw 0 21.5385vw;
  }
  .fact .fact__title {
    max-width: 78.4615vw;
    margin: 0 auto 13.0769vw;
  }
  .fact .fact__wrapper {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 14.359vw;
  }
  .fact .fact__content {
    max-width: 100%;
  }
  .fact .fact__content-img {
    width: 100%;
    height: 46.1538vw;
    border-radius: 4.1026vw;
    margin-bottom: 8.2051vw;
  }
  .fact .fact__content-text {
    max-width: 100%;
    font-size: 5.1282vw;
    letter-spacing: -0.1026vw;
  }
  .fact .fact__content-text.small-text {
    font-size: 4.6154vw;
  }
  .fact .fact__content-text.small-text b {
    font-size: 5.1282vw;
  }
  .fact .fact__content-text ul li {
    padding-left: 2.5641vw;
  }
  .fact .fact__content-text ul li::before {
    top: 2.8205vw;
    width: 1.2821vw;
    height: 1.2821vw;
  }
  .fact .fact__content-button {
    margin-top: 6.4103vw;
  }
  .fact .fact__content-info {
    margin-top: 10.2564vw;
  }
  .fact .fact__content-info-img {
    width: 16.4103vw;
    height: 16.4103vw;
    margin-right: 4.1026vw;
  }
  .fact .fact__content-info-name {
    font-size: 4.6154vw;
    margin-bottom: 2.8205vw;
  }
  .fact .fact__content-info-position {
    font-size: 4.1026vw;
  }
  .fact .fact__statistic {
    max-width: 100%;
  }
  .fact .fact__statistic-logo {
    height: 81.0256vw;
    border-radius: 4.1026vw;
  }
  .fact .fact__statistic-logo img {
    width: 41.0256vw;
    height: 56.4103vw;
  }
  .fact .fact__statistic-numbers {
    margin-top: 8.9744vw;
    padding-left: 0;
  }
  .fact .fact__statistic-numbers .item:not(:first-child) {
    margin-top: 8.4615vw;
  }
  .fact .fact__statistic-numbers .item .item-top {
    margin-bottom: 1.5385vw;
  }
  .fact .fact__statistic-numbers .item .item-top__number,
  .fact .fact__statistic-numbers .item .item-top__symbol {
    font-size: 8.2051vw;
    letter-spacing: -0.0821vw;
  }
  .fact .fact__statistic-numbers .item .item-title {
    max-width: 68.4615vw;
  }
  .fact .fact__statistic-numbers .item .item-title h3 {
    letter-spacing: -0.0769vw;
    font-size: 4.1026vw;
  }
  .page-template-lp .fact .fact__title .title {
    font-size: 8.205vw;
  }
  .page-template-lp .fact .fact__content-text {
    font-size: 5.128vw;
  }
  .page-template-lp .fact .fact__content {
    display: flex;
    flex-direction: column;
  }
  .page-template-lp .fact .fact__content .fact__statistic-logo {
    display: flex;
    margin: 2.128vw 0 12.821vw 0;
  }
  .page-template-lp .fact .fact__content .fact__content-img {
    order: 1;
    margin-bottom: 0;
  }
  .page-template-lp .fact .fact__content .fact__content-info {
    margin-top: 4.2564vw;
  }
  .page-template-lp .fact .fact__content-text b {
    font-size: 5.128vw;
  }
  .page-template-lp .fact .fact__statistic .fact__statistic-logo {
    display: none;
  }
  .page-template-lp .fact .fact__statistic-numbers {
    margin-top: 0;
  }
  .page-template-lp .fact .fact__statistic-numbers .item .item-top__number,
  .page-template-lp .fact .fact__statistic-numbers .item .item-top__symbol {
    font-size: 8.205vw;
  }
  .page-template-lp .fact .fact__content-button a {
    text-decoration: underline;
  }
  .page-template-lp .fact .fact__content-button a:hover {
    text-decoration: none;
  }
  .page-template-lp .fact .fact__content-button a::after {
    display: none;
  }
}
.more-info {
  margin-top: -20px;
  padding-top: 20px;
  background-color: var(--yellow);
}
.more-info .more-info__inner {
  padding: 136px 0 133px;
}
.more-info .more-info__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 57px;
}
.more-info .more-info__header-title {
  width: 100%;
  max-width: 528px;
}
.more-info .more-info__header-button {
  margin-bottom: 15px;
}
.more-info .more-info__list .list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
}
.more-info .more-info__list .card .card-content .card-content__logo {
  display: none;
}

@media screen and (max-width: 1280px) {
  .more-info {
    margin-top: -1.5625vw;
    padding-top: 1.5625vw;
    background-color: var(--yellow);
  }
  .more-info .more-info__inner {
    padding: 9.6875vw 0 11.7188vw;
  }
  .more-info .more-info__header {
    margin-bottom: 3.9063vw;
  }
  .more-info .more-info__header-title {
    max-width: 44.5313vw;
  }
  .more-info .more-info__header-button {
    margin-bottom: 0.3906vw;
  }
  .more-info .more-info__list .list {
    grid-gap: 2.3438vw;
  }
}
@media screen and (max-width: 850px) {
  .more-info {
    margin-top: -5.1282vw;
    padding-top: 5.1282vw;
  }
  .more-info .more-info__inner {
    padding: 20.2564vw 0 17.1795vw;
  }
  .more-info .more-info__header {
    justify-content: center;
    flex-direction: column;
    text-align: center;
    margin-bottom: 11.2821vw;
  }
  .more-info .more-info__header-title {
    max-width: 100%;
    margin-bottom: 7.9487vw;
  }
  .more-info .more-info__header-button {
    margin-bottom: 0;
  }
  .more-info .more-info__list .list {
    display: block;
    width: calc(100% + 5.1282vw);
    margin: 0 -2.5641vw;
  }
  .more-info .more-info__list .list .slick-track {
    display: flex;
    align-items: stretch;
  }
  .more-info .more-info__list .list .slick-track .card {
    margin: 0 2.5641vw;
    height: auto;
  }
  .more-info .more-info__list .list .slick-dots {
    margin-top: 8.7179vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    bottom: 0;
  }
  .more-info .more-info__list .list .slick-dots li {
    width: 2.0513vw;
    height: 2.0513vw;
    background-color: var(--dark);
    opacity: 0.2;
    border-radius: 50%;
    transition: all 0.3s linear;
  }
  .more-info .more-info__list .list .slick-dots li.slick-active {
    width: 2.5641vw;
    height: 2.5641vw;
    opacity: 1;
  }
  .more-info .more-info__list .list .slick-dots li:not(:first-child) {
    margin-left: 2.0513vw;
  }
  .more-info .more-info__list .list .slick-dots li button {
    width: 100%;
    height: 100%;
    font-size: 0;
  }
}
.section-404 {
  background-color: var(--white);
  width: 100%;
  height: 100%;
}
.section-404__inner {
  padding: 79px 0 120px 0;
}
.section-404__content {
  text-align: center;
}
.section-404__content-title {
  font-family: "Cambon";
  font-weight: 700;
  font-size: 62px;
  line-height: 1.1;
  letter-spacing: -0.62px;
  color: var(--dark);
  margin: 0 auto 40px auto;
  max-width: 90%;
}
.section-404__content-subtitle {
  font-family: "Circular Std";
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.2px;
  line-height: 1.5;
  color: var(--gray);
  margin-bottom: 90px;
}
.section-404__content-subtitle a {
  text-decoration: underline;
}
.section-404__content-img {
  margin: 0 auto;
  width: 812px;
  height: 426px;
}
.section-404__content-img img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 1330px) {
  .section-404__inner {
    padding: 5.94vw 0 9.023vw 0;
  }
  .section-404__content-title {
    font-size: 4.662vw;
    margin: 0 auto 3.008vw auto;
  }
  .section-404__content-subtitle {
    font-size: 1.504vw;
    margin-bottom: 6.767vw;
  }
  .section-404__content-img {
    width: 61.053vw;
    height: 32.03vw;
  }
}
@media screen and (max-width: 850px) {
  .section-404__inner {
    padding: 12.308vw 0 42.308vw 0;
  }
  .section-404__content-title {
    font-size: 9.231vw;
    margin-bottom: 8.205vw;
  }
  .section-404__content-subtitle {
    font-size: 4.615vw;
    margin-bottom: 21.538vw;
  }
  .section-404__content-img {
    width: 89.744vw;
    height: 47.179vw;
  }
}
.article .article__inner {
  padding: 90px 0 150px;
}
.article .article__content {
  width: 100%;
  max-width: 780px;
  margin: 0 auto;
}
.article .article__footer {
  margin-top: 110px;
  padding-top: 126px;
  border-top: 1px solid rgba(22, 22, 22, 0.15);
}
.article .article__footer-title {
  width: 100%;
  max-width: 987px;
  margin: 0 auto;
  text-align: center;
}
.article .article__footer-title h2 {
  font-weight: 700;
  font-family: "Cambon";
  line-height: 1.2;
  letter-spacing: -0.48px;
  font-size: 48px;
  color: var(--black);
}
.article .article__footer-button {
  display: flex;
  justify-content: center;
  margin-top: 49px;
}

@media screen and (max-width: 1330px) {
  .article .article__inner {
    padding: 6.7669vw 0 11.2782vw;
  }
  .article .article__content {
    max-width: 58.6466vw;
  }
  .article .article__footer {
    margin-top: 8.2707vw;
    padding-top: 9.4737vw;
  }
  .article .article__footer-title {
    max-width: 74.2105vw;
  }
  .article .article__footer-title h2 {
    letter-spacing: -0.0361vw;
    font-size: 3.609vw;
  }
  .article .article__footer-button {
    margin-top: 3.6842vw;
  }
}
@media screen and (max-width: 850px) {
  .article .article__inner {
    padding: 15.1282vw 0 38.4615vw;
  }
  .article .article__content {
    max-width: 100%;
  }
  .article .article__footer {
    margin-top: 18.4615vw;
    padding-top: 21.5385vw;
  }
  .article .article__footer-title {
    max-width: 100%;
  }
  .article .article__footer-title h2 {
    letter-spacing: -0.0821vw;
    font-size: 8.2051vw;
  }
  .article .article__footer-button {
    margin-top: 7.4359vw;
  }
}
.other-article {
  background-color: var(--light-gray);
}
.other-article .other-article__inner {
  padding: 122px 0 142px;
}
.other-article .other-article__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  margin-bottom: 48px;
}
.other-article .other-article__list {
  width: 100%;
  max-width: 1290px;
  margin: 0 auto;
}
.other-article .other-article__list .list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
}
.other-article .other-article__list .list .card .card-info .card-info__time {
  display: none;
}

@media screen and (max-width: 1330px) {
  .other-article .other-article__inner {
    padding: 9.1729vw 0 10.6767vw;
  }
  .other-article .other-article__header {
    gap: 3.7594vw;
    margin-bottom: 3.609vw;
  }
  .other-article .other-article__list {
    max-width: 96.9925vw;
  }
  .other-article .other-article__list .list {
    grid-gap: 2.2556vw;
  }
}
@media screen and (max-width: 1280px) {
  .other-article {
    background-color: var(--light-gray);
  }
  .other-article .other-article__inner {
    padding: 7.8125vw 0 9.375vw;
  }
  .other-article .other-article__header {
    gap: 2.7344vw;
    margin-bottom: 3.5156vw;
  }
  .other-article .other-article__list {
    max-width: 100%;
  }
  .other-article .other-article__list .list {
    grid-gap: 2.3438vw;
  }
}
@media screen and (max-width: 850px) {
  .other-article .other-article__inner {
    padding: 20vw 0 16.4103vw;
  }
  .other-article .other-article__header {
    justify-content: center;
    flex-direction: column;
    gap: 7.6923vw;
    margin-bottom: 10.7692vw;
  }
  .other-article .other-article__list {
    max-width: 100%;
  }
  .other-article .other-article__list .list {
    display: block;
    width: calc(100% + 5.1282vw);
    margin: 0 -2.5641vw;
  }
  .other-article .other-article__list .list .slick-track {
    display: flex;
    align-items: stretch;
  }
  .other-article .other-article__list .list .slick-track .card {
    margin: 0 2.5641vw;
    height: auto;
  }
  .other-article .other-article__list .list .slick-dots {
    margin-top: 6.1538vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .other-article .other-article__list .list .slick-dots li {
    width: 2.0513vw;
    height: 2.0513vw;
    background-color: var(--dark);
    opacity: 0.2;
    border-radius: 50%;
    transition: all 0.3s linear;
  }
  .other-article .other-article__list .list .slick-dots li.slick-active {
    width: 2.5641vw;
    height: 2.5641vw;
    opacity: 1;
  }
  .other-article .other-article__list .list .slick-dots li:not(:first-child) {
    margin-left: 2.0513vw;
  }
  .other-article .other-article__list .list .slick-dots li button {
    width: 100%;
    height: 100%;
    font-size: 0;
  }
  .other-article .other-article__list .card {
    padding-bottom: 0;
  }
  .other-article .other-article__list .card .card-info {
    margin-top: 5.641vw;
    gap: 2.5641vw;
    padding: 0 4.359vw;
  }
  .other-article .other-article__list .card .card-info__labels ul li a {
    font-size: 3.5897vw;
    padding: 2.5641vw 4.1026vw;
  }
  .other-article .other-article__list .card .card-content {
    margin-top: 3.5897vw;
    padding: 0 4.359vw 6.1538vw;
  }
  .other-article .other-article__list .card .card-content__logo {
    width: 40vw;
    height: auto;
  }
  .other-article .other-article__list .card .card-content__title {
    margin-bottom: 6.4103vw;
  }
  .other-article .other-article__list .card .card-content__title h3 {
    font-size: 4.1026vw;
    letter-spacing: -0.041vw;
  }
}
.contact {
  background: var(--light-gray);
}
.contact .contact__inner {
  padding: 82px 0 184px;
}
.contact .contact__wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.contact .contact__content {
  width: 100%;
  max-width: 520px;
  margin-top: 4px;
}
.contact .contact__content-title.contact__content-title--less h1 {
  font-size: 48px;
  letter-spacing: -0.48px;
}
.contact .contact__content-title h1 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.56px;
  font-size: 56px;
  color: var(--dark);
}
.contact .contact__content-subtitle {
  margin-top: 29px;
}
.contact .contact__content-subtitle h2 {
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.28px;
  font-size: 28px;
  color: var(--dark);
}
.contact .contact__content-list {
  margin-top: 27px;
}
.contact .contact__content-list > ul li {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.32px;
  font-size: 18px;
  color: var(--dark);
  position: relative;
  z-index: 2;
  padding-left: 43px;
}
.contact .contact__content-list > ul li:not(:first-child) {
  margin-top: 24px;
}
.contact .contact__content-list > ul li::before {
  content: "";
  position: absolute;
  top: 11px;
  left: 0;
  width: 32px;
  height: 32px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.contact .contact__content-list > a {
  margin-top: 32px;
  margin-left: 42px;
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.contact .contact__content-list > a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.contact .contact__content-list > a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .contact .contact__content-list > a:hover::before {
    transform: translateX(3px);
  }
  .contact .contact__content-list > a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .contact .contact__content-list > a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .contact .contact__content-list > a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .contact .contact__content-list > a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .contact .contact__content-list > a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .contact .contact__content-list > a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .contact .contact__content-list > a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .contact .contact__content-list > a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .contact .contact__content-list > a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .contact .contact__content-list > a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.contact .contact__content-text {
  margin-top: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.3px;
  font-size: 18px;
  color: var(--dark);
}
.contact .contact__content-button {
  margin-top: 23px;
}
.contact .contact__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.contact .contact__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.contact .contact__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .contact .contact__content-button a:hover::before {
    transform: translateX(3px);
  }
  .contact .contact__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .contact .contact__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .contact .contact__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .contact .contact__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .contact .contact__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .contact .contact__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .contact .contact__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .contact .contact__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .contact .contact__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .contact .contact__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.contact .contact__content-info {
  margin-top: 32px;
  display: flex;
  align-items: flex-start;
}
.contact .contact__content-info-img {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  overflow: hidden;
  flex: 0 0 auto;
  margin-right: 24px;
}
.contact .contact__content-info-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.contact .contact__content-info-wrapper {
  margin-top: 15px;
}
.contact .contact__content-info-name {
  font-weight: 500;
  font-size: 20px;
  color: var(--dark);
  margin-bottom: 9px;
}
.contact .contact__content-info-position {
  font-weight: 400;
  font-size: 18px;
  letter-spacing: -0.15px;
  color: var(--dark);
}
.contact .contact__content-brands {
  margin-top: 55px;
}
.contact .contact__content-brands ul {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 30px 45px;
}
.contact .contact__content-brands ul li {
  width: 100%;
  height: 50px;
}
.contact .contact__content-brands ul li img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  mix-blend-mode: multiply;
}
.contact .contact__form {
  width: 100%;
  max-width: 660px;
  background-color: var(--white);
  border-radius: 24px;
  position: relative;
  z-index: 2;
  padding: 49px 46px 45px;
}
.contact .contact__form .contact__form-image {
  width: 210px;
  height: 210px;
  position: absolute;
  pointer-events: none;
}
.contact .contact__form .contact__form-image.contact__form-image--position-1 {
  right: 66px;
  bottom: -80px;
}
.contact .contact__form .contact__form-image.contact__form-image--position-2 {
  right: 45px;
  bottom: -89px;
}
.contact .contact__form .contact__form-image.contact__form-image--position-3 {
  right: -115px;
  bottom: -62px;
}
.contact .contact__form .contact__form-image img {
  object-fit: contain;
}
.contact .contact__form .contact__form-image img,
.contact .contact__form .contact__form-image lottie-player {
  width: 100%;
  height: 100%;
}
.contact .contact__form .contact__form-wrapper form {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
}
.contact .contact__form .contact__form-wrapper form fieldset {
  width: 100%;
  max-width: 100%;
}
.contact .contact__form .contact__form-wrapper form .hs-form-field {
  width: 100%;
}
.contact .contact__form .contact__form-wrapper form .hs-form-field > label {
  display: inline-block;
  margin-bottom: 8px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
}
.contact .contact__form .contact__form-wrapper form .hs-error-msg,
.contact .contact__form .contact__form-wrapper form .hs-main-font-element {
  font-size: 14px;
  line-height: 1;
  color: red;
}
.contact .contact__form .contact__form-wrapper form .form-columns-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}
.contact .contact__form .contact__form-wrapper form .input {
  margin: 0;
}
.contact
  .contact__form
  .contact__form-wrapper
  form
  input:not(input[type="submit"]),
.contact .contact__form .contact__form-wrapper form select,
.contact .contact__form .contact__form-wrapper form textarea {
  border: none;
  outline: none;
  box-shadow: none;
  width: 100%;
  height: 54px;
  padding: 0 16px;
  border-radius: 8px;
  background: var(--light-gray);
  font-family: "Circular Std";
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
}
.contact
  .contact__form
  .contact__form-wrapper
  form
  input:not(input[type="submit"])::placeholder,
.contact .contact__form .contact__form-wrapper form select::placeholder,
.contact .contact__form .contact__form-wrapper form textarea::placeholder {
  font-family: "Circular Std";
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: rgba(22, 22, 22, 0.4);
}
.contact
  .contact__form
  .contact__form-wrapper
  form
  input:not(input[type="submit"]):-moz-placeholder,
.contact .contact__form .contact__form-wrapper form select:-moz-placeholder,
.contact .contact__form .contact__form-wrapper form textarea:-moz-placeholder {
  font-family: "Circular Std";
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: rgba(22, 22, 22, 0.4);
}
.contact
  .contact__form
  .contact__form-wrapper
  form
  input:not(input[type="submit"])::-moz-placeholder,
.contact .contact__form .contact__form-wrapper form select::-moz-placeholder,
.contact .contact__form .contact__form-wrapper form textarea::-moz-placeholder {
  font-family: "Circular Std";
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: rgba(22, 22, 22, 0.4);
}
.contact
  .contact__form
  .contact__form-wrapper
  form
  .hs-fieldtype-select
  .input {
  position: relative;
  z-index: 2;
}
.contact
  .contact__form
  .contact__form-wrapper
  form
  .hs-fieldtype-select
  .input::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 21px;
  width: 12px;
  height: 7px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.contact .contact__form .contact__form-wrapper form select {
  cursor: pointer;
  appearance: none;
  font-size: 16px;
  color: rgba(22, 22, 22, 0.4);
}
.contact .contact__form .contact__form-wrapper form select option {
  color: var(--dark);
}
.contact .contact__form .contact__form-wrapper form select::-ms-expand {
  display: none;
}
.contact .contact__form .contact__form-wrapper form textarea {
  padding: 14px 16px;
  min-height: 108px;
}
.contact .contact__form .contact__form-wrapper form input[type="submit"] {
  border-radius: 12px;
  background: var(--dark);
  padding: 13px 48px;
  border-radius: 12px;
  font-family: "Circular Std";
  font-weight: 500;
  line-height: 1.5;
  font-size: 17px;
  color: var(--white);
  border: none;
  box-shadow: none;
  transition: all 0.4s linear;
  cursor: pointer;
}
.contact .contact__form .contact__form-wrapper form input[type="submit"]:hover {
  background-color: var(--yellow);
  color: var(--dark);
}

@media screen and (max-width: 1330px) {
  .contact .contact__inner {
    padding: 6.1654vw 0 13.8346vw;
  }
  .contact .contact__content {
    max-width: 39.0977vw;
    margin-top: 0.3008vw;
  }
  .contact .contact__content-title.contact__content-title--less h1 {
    font-size: 3.609vw;
    letter-spacing: -0.0361vw;
  }
  .contact .contact__content-title h1 {
    letter-spacing: -0.0421vw;
    font-size: 4.2105vw;
  }
  .contact .contact__content-subtitle {
    margin-top: 2.1805vw;
  }
  .contact .contact__content-subtitle h2 {
    letter-spacing: -0.0211vw;
    font-size: 2.1053vw;
  }
  .contact .contact__content-list {
    margin-top: 2.0301vw;
  }
  .contact .contact__content-list > ul li {
    letter-spacing: -0.0241vw;
    font-size: 1.3534vw;
    padding-left: 3.2331vw;
  }
  .contact .contact__content-list > ul li:not(:first-child) {
    margin-top: 1.8045vw;
  }
  .contact .contact__content-list > ul li::before {
    top: 0.8271vw;
    width: 2.406vw;
    height: 2.406vw;
  }
  .contact .contact__content-list > a {
    margin-top: 2.406vw;
    margin-left: 3.1579vw;
  }
  .contact .contact__content-text {
    margin-top: 2.2556vw;
    letter-spacing: -0.0226vw;
    font-size: 1.3534vw;
  }
  .contact .contact__content-button {
    margin-top: 1.7293vw;
  }
  .contact .contact__content-info {
    margin-top: 2.406vw;
  }
  .contact .contact__content-info-img {
    width: 5.8647vw;
    height: 5.8647vw;
    margin-right: 1.8045vw;
  }
  .contact .contact__content-info-wrapper {
    margin-top: 1.1278vw;
  }
  .contact .contact__content-info-name {
    font-size: 1.5038vw;
    margin-bottom: 0.6767vw;
  }
  .contact .contact__content-info-position {
    font-size: 1.3534vw;
    letter-spacing: -0.0113vw;
  }
  .contact .contact__content-brands {
    margin-top: 4.1353vw;
  }
  .contact .contact__content-brands ul {
    grid-gap: 2.2556vw 3.3835vw;
  }
  .contact .contact__content-brands ul li {
    height: 3.7594vw;
  }
  .contact .contact__form {
    max-width: 49.6241vw;
    border-radius: 1.8045vw;
    padding: 3.6842vw 3.4586vw 3.3835vw;
  }
  .contact .contact__form .contact__form-image {
    width: 15.7895vw;
    height: 15.7895vw;
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-1 {
    right: 4.9624vw;
    bottom: -6.015vw;
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-2 {
    right: 3.3835vw;
    bottom: -6.6917vw;
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-3 {
    right: -8.6466vw;
    bottom: -4.6617vw;
  }
  .contact .contact__form .contact__form-wrapper form {
    grid-gap: 1.8045vw;
  }
  .contact .contact__form .contact__form-wrapper form .hs-form-field > label {
    display: inline-block;
    margin-bottom: 0.6015vw;
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
  }
  .contact .contact__form .contact__form-wrapper form .hs-error-msg,
  .contact .contact__form .contact__form-wrapper form .hs-main-font-element {
    font-size: 1.0526vw;
  }
  .contact .contact__form .contact__form-wrapper form .form-columns-2 {
    grid-gap: 1.5038vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"]),
  .contact .contact__form .contact__form-wrapper form select,
  .contact .contact__form .contact__form-wrapper form textarea {
    height: 4.0602vw;
    padding: 0 1.203vw;
    border-radius: 0.6015vw;
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"])::placeholder,
  .contact .contact__form .contact__form-wrapper form select::placeholder,
  .contact .contact__form .contact__form-wrapper form textarea::placeholder {
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"]):-moz-placeholder,
  .contact .contact__form .contact__form-wrapper form select:-moz-placeholder,
  .contact
    .contact__form
    .contact__form-wrapper
    form
    textarea:-moz-placeholder {
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"])::-moz-placeholder,
  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,
  .contact
    .contact__form
    .contact__form-wrapper
    form
    textarea::-moz-placeholder {
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    .hs-fieldtype-select
    .input::before {
    right: 1.5789vw;
    width: 0.9023vw;
    height: 0.5263vw;
  }
  .contact .contact__form .contact__form-wrapper form select {
    font-size: 1.203vw;
  }
  .contact .contact__form .contact__form-wrapper form textarea {
    padding: 1.0526vw 1.203vw;
    min-height: 8.1203vw;
  }
  .contact .contact__form .contact__form-wrapper form input[type="submit"] {
    border-radius: 0.9023vw;
    padding: 0.9774vw 3.609vw;
    border-radius: 0.9023vw;
    font-size: 1.2782vw;
  }
}
@media screen and (max-width: 1280px) {
  .contact .contact__inner {
    padding: 6.25vw 0;
  }
  .contact .contact__content {
    width: 100%;
    max-width: 35.1563vw;
    margin-top: 0.3125vw;
  }
  .contact .contact__content-title.contact__content-title--less h1 {
    font-size: 2.1875vw;
    letter-spacing: -0.0297vw;
  }
  .contact .contact__content-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0281vw;
    font-size: 2.9688vw;
  }
  .contact .contact__content-subtitle {
    margin-top: 1.1719vw;
  }
  .contact .contact__content-subtitle h2 {
    letter-spacing: -0.0141vw;
    font-size: 1.5625vw;
  }
  .contact .contact__content-list {
    margin-top: 1.1719vw;
  }
  .contact .contact__content-list > ul li {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
    padding-left: 2.3438vw;
  }
  .contact .contact__content-list > ul li:not(:first-child) {
    margin-top: 1.1719vw;
  }
  .contact .contact__content-list > ul li::before {
    top: 0.3906vw;
    width: 1.9531vw;
    height: 1.9531vw;
  }
  .contact .contact__content-list > a {
    margin-top: 1.1719vw;
    margin-left: 2.3438vw;
  }
  .contact .contact__content-text {
    margin-top: 1.1719vw;
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .contact .contact__content-button {
    margin-top: 1.1719vw;
  }
  .contact .contact__content-info {
    margin-top: 2.3438vw;
  }
  .contact .contact__content-info-img {
    width: 4.5313vw;
    height: 4.5313vw;
    margin-right: 1.0938vw;
  }
  .contact .contact__content-info-wrapper {
    margin-top: 0.7813vw;
  }
  .contact .contact__content-info-name {
    font-size: 1.4063vw;
    margin-bottom: 0.3906vw;
  }
  .contact .contact__content-info-position {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
  }
  .contact .contact__content-brands {
    margin-top: 2.7344vw;
  }
  .contact .contact__content-brands ul {
    grid-gap: 2.3438vw;
  }
  .contact .contact__content-brands ul li {
    height: 2.7344vw;
  }
  .contact .contact__form {
    max-width: 41.0156vw;
    border-radius: 1.875vw;
    padding: 3.125vw 2.3438vw;
  }
  .contact .contact__form .contact__form-image {
    width: 14.0625vw;
    height: 14.0625vw;
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-1 {
    right: 3.125vw;
    bottom: -6.25vw;
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-2 {
    right: 3.5156vw;
    bottom: -6.9531vw;
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-3 {
    right: -5.4688vw;
    bottom: -4.8438vw;
  }
  .contact .contact__form .contact__form-wrapper form {
    grid-gap: 1.1719vw;
  }
  .contact .contact__form .contact__form-wrapper form .hs-form-field > label {
    margin-bottom: 0.625vw;
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .contact .contact__form .contact__form-wrapper form .hs-error-msg,
  .contact .contact__form .contact__form-wrapper form .hs-main-font-element {
    font-size: 1.0938vw;
  }
  .contact .contact__form .contact__form-wrapper form .form-columns-2 {
    grid-gap: 1.1719vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"]),
  .contact .contact__form .contact__form-wrapper form select,
  .contact .contact__form .contact__form-wrapper form textarea {
    height: 4.2188vw;
    padding: 0 1.25vw;
    border-radius: 0.625vw;
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"])::placeholder,
  .contact .contact__form .contact__form-wrapper form select::placeholder,
  .contact .contact__form .contact__form-wrapper form textarea::placeholder {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"]):-moz-placeholder,
  .contact .contact__form .contact__form-wrapper form select:-moz-placeholder,
  .contact
    .contact__form
    .contact__form-wrapper
    form
    textarea:-moz-placeholder {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"])::-moz-placeholder,
  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,
  .contact
    .contact__form
    .contact__form-wrapper
    form
    textarea::-moz-placeholder {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    .hs-fieldtype-select
    .input::before {
    right: 1.6406vw;
    width: 0.9375vw;
    height: 0.5469vw;
  }
  .contact .contact__form .contact__form-wrapper form select {
    font-size: 1.25vw;
  }
  .contact .contact__form .contact__form-wrapper form textarea {
    padding: 1.0938vw 1.25vw;
    min-height: 8.4375vw;
  }
  .contact .contact__form .contact__form-wrapper form input[type="submit"] {
    border-radius: 0.9375vw;
    padding: 1.0156vw 3.75vw;
    border-radius: 0.9375vw;
    font-size: 1.3281vw;
  }
}
@media screen and (max-width: 850px) {
  .contact .contact__inner {
    padding: 13.8462vw 0 24.8718vw;
  }
  .contact .contact__wrapper {
    display: block;
  }
  .contact .contact__content {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    margin-top: 0;
  }
  .contact .contact__content-title.contact__content-title--less h1 {
    font-size: 9.2308vw;
    letter-spacing: -0.0923vw;
  }
  .contact .contact__content-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0923vw;
    font-size: 9.2308vw;
  }
  .contact .contact__content-subtitle {
    order: 1;
    margin-top: 20vw;
    width: 100%;
    max-width: 66.6667vw;
  }
  .contact .contact__content-subtitle h2 {
    letter-spacing: -0.0718vw;
    font-size: 5.641vw;
    color: var(--dark);
  }
  .contact .contact__content-subtitle h2 br {
    display: none;
  }
  .contact .contact__content-list {
    order: 1;
    margin-top: 17.6923vw;
  }
  .contact .contact__content-list > ul li {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
    padding-left: 11.0256vw;
  }
  .contact .contact__content-list > ul li br {
    display: none;
  }
  .contact .contact__content-list > ul li:not(:first-child) {
    margin-top: 6.1538vw;
  }
  .contact .contact__content-list > ul li::before {
    top: 50%;
    transform: translateY(-50%);
    width: 8.2051vw;
    height: 8.2051vw;
  }
  .contact .contact__content-list > a {
    margin-top: 6.1538vw;
  }
  .contact .contact__content-text {
    order: 1;
    margin-top: 7.6923vw;
    line-height: 1.5;
    font-size: 4.1026vw;
    letter-spacing: -0.0846vw;
  }
  .contact .contact__content-text br {
    display: none;
  }
  .contact .contact__content-button {
    order: 1;
    margin-top: 5.8974vw;
  }
  .contact .contact__content-info {
    order: 1;
    margin-top: 15.1282vw;
  }
  .contact .contact__content-info-img {
    width: 16.4103vw;
    height: 16.4103vw;
    margin-right: 4.1026vw;
  }
  .contact .contact__content-info-wrapper {
    margin-top: 0px;
  }
  .contact .contact__content-info-name {
    font-size: 4.6154vw;
    margin-bottom: 1.2821vw;
  }
  .contact .contact__content-info-position {
    font-size: 4.1026vw;
    line-height: 1.4;
    letter-spacing: -0.0385vw;
  }
  .contact .contact__content-brands {
    width: 100%;
    max-width: 62.3077vw;
    margin: 10.2564vw auto 0;
  }
  .contact .contact__content-brands ul {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 7.6923vw 7.1795vw;
  }
  .contact .contact__content-brands ul li {
    width: 100%;
    height: 11.5385vw;
  }
  .contact .contact__form {
    margin-top: 8.2051vw;
    margin-bottom: 24.6154vw;
    max-width: 100%;
    border-radius: 6.1538vw;
    padding: 8.2051vw 6.1538vw 23.0769vw;
  }
  .contact .contact__form .contact__form-image {
    width: 41.5385vw;
    height: 41.5385vw;
    transform: translateX(50%);
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-1 {
    right: 50%;
    bottom: -24.6154vw;
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-2 {
    right: 50%;
    bottom: -24.6154vw;
  }
  .contact .contact__form .contact__form-image.contact__form-image--position-3 {
    right: 50%;
    bottom: -24.6154vw;
  }
  .contact .contact__form .contact__form-image img {
    object-fit: contain;
  }
  .contact .contact__form .contact__form-image img,
  .contact .contact__form .contact__form-image lottie-player {
    width: 100%;
    height: 100%;
  }
  .contact .contact__form .contact__form-wrapper form {
    grid-template-columns: 1fr;
    grid-gap: 6.1538vw;
  }
  .contact .contact__form .contact__form-wrapper form .hs-form-field > label {
    margin-bottom: 2.0513vw;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .contact .contact__form .contact__form-wrapper form .hs-error-msg,
  .contact .contact__form .contact__form-wrapper form .hs-main-font-element {
    font-size: 3.5897vw;
  }
  .contact .contact__form .contact__form-wrapper form .form-columns-2 {
    grid-template-columns: 1fr;
    grid-gap: 6.1538vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"]),
  .contact .contact__form .contact__form-wrapper form select,
  .contact .contact__form .contact__form-wrapper form textarea {
    height: 13.8462vw;
    padding: 0 4.1026vw;
    border-radius: 2.0513vw;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"])::placeholder,
  .contact .contact__form .contact__form-wrapper form select::placeholder,
  .contact .contact__form .contact__form-wrapper form textarea::placeholder {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"]):-moz-placeholder,
  .contact .contact__form .contact__form-wrapper form select:-moz-placeholder,
  .contact
    .contact__form
    .contact__form-wrapper
    form
    textarea:-moz-placeholder {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    input:not(input[type="submit"])::-moz-placeholder,
  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,
  .contact
    .contact__form
    .contact__form-wrapper
    form
    textarea::-moz-placeholder {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .contact
    .contact__form
    .contact__form-wrapper
    form
    .hs-fieldtype-select
    .input::before {
    right: 5.3846vw;
    width: 3.0769vw;
    height: 1.7949vw;
  }
  .contact .contact__form .contact__form-wrapper form select {
    font-size: 4.1026vw;
  }
  .contact .contact__form .contact__form-wrapper form textarea {
    padding: 3.5897vw 4.1026vw;
    min-height: 27.6923vw;
  }
  .contact .contact__form .contact__form-wrapper form input[type="submit"] {
    width: 100%;
    border-radius: 3.0769vw;
    padding: 3.3333vw 12.3077vw;
    border-radius: 3.0769vw;
    font-size: 4.359vw;
  }
}
.general-header {
  padding: 100px 0 76px;
}
.general-header.general-header--store {
  padding: 90px 0 63px;
}
.general-header.general-header--store .general-header__panel {
  margin: 0 auto;
}
.general-header .general-header__wrapper {
  width: 100%;
  max-width: 932px;
  margin: 0 auto;
  text-align: center;
}
.general-header .general-header__label {
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.14px;
  text-transform: uppercase;
  font-size: 14px;
  color: var(--dark);
  margin-bottom: 20px;
}
.general-header .general-header__title {
  margin-bottom: 20px;
}
.general-header .general-header__title h1 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.56px;
  font-size: 56px;
  color: var(--dark);
}
.general-header .general-header__text {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.42px;
  font-size: 20px;
  color: var(--dark);
}
.general-header .general-header__panel {
  width: 100%;
  max-width: 630px;
  margin: 48px auto 0;
  border-radius: 60px;
  border: 1px solid var(--white-2);
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.general-header .general-header__panel-button {
  position: relative;
  z-index: 2;
}
.general-header .general-header__panel-button.current-button button {
  color: var(--white);
  background-color: var(--dark);
}
.general-header .general-header__panel-button button {
  padding: 7px 20px;
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
  background-color: transparent;
  transition: all 0.4s linear;
  border-radius: 40px;
}
.general-header .general-header__panel-button .hover-block {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--dark);
  border-radius: 40px;
  transition: all 0.4s linear;
}

@media screen and (max-width: 1330px) {
  .general-header {
    padding: 7.5188vw 0 5.7143vw;
  }
  .general-header.general-header--store {
    padding: 4.6875vw 0 3.2813vw;
  }
  .general-header.general-header--store .general-header__panel {
    margin: 0 auto;
  }
  .general-header .general-header__wrapper {
    max-width: 70.0752vw;
  }
  .general-header .general-header__label {
    letter-spacing: -0.0105vw;
    font-size: 1.0526vw;
    margin-bottom: 1.5038vw;
  }
  .general-header .general-header__title {
    margin-bottom: 1.5038vw;
  }
  .general-header .general-header__title h1 {
    letter-spacing: -0.0421vw;
    font-size: 4.2105vw;
  }
  .general-header .general-header__text {
    letter-spacing: -0.0316vw;
    font-size: 1.5038vw;
  }
  .general-header .general-header__panel {
    max-width: 630px;
    margin: 48px auto 0;
    border-radius: 60px;
    padding: 10px;
  }
  .general-header .general-header__panel-button button {
    padding: 7px 20px;
    font-weight: 450;
    letter-spacing: -0.16px;
    font-size: 16px;
    color: var(--dark);
    transition: all 0.4s linear;
  }
  .general-header .general-header__panel-button .hover-block {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--dark);
    border-radius: 40px;
    transition: all 0.4s linear;
  }
}
@media screen and (max-width: 1280px) {
  .general-header {
    padding: 6.25vw 0 2.5vw;
  }
  .general-header.general-header--store {
    padding: 3.9063vw 0;
  }
  .general-header.general-header--store .general-header__panel {
    margin: 0 auto;
  }
  .general-header .general-header__wrapper {
    max-width: 55.4688vw;
  }
  .general-header .general-header__label {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
    margin-bottom: 1.6406vw;
  }
  .general-header .general-header__title {
    margin-bottom: 1.4844vw;
  }
  .general-header .general-header__title h1 {
    line-height: 1.1;
    letter-spacing: -0.0328vw;
    font-size: 3.2813vw;
  }
  .general-header .general-header__text {
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
  }
  .general-header .general-header__panel {
    max-width: 48.4375vw;
    margin: 3.75vw auto 0;
    border-radius: 4.6875vw;
    padding: 0.625vw 0.7813vw;
  }
  .general-header .general-header__panel-button button {
    padding: 0.9375vw 1.5625vw;
    font-weight: 400;
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
    border-radius: 3.125vw;
  }
}
@media screen and (max-width: 850px) {
  .general-header {
    padding: 12.0513vw 0;
  }
  .general-header.general-header--store {
    padding: 6.6667vw 0 11.0256vw;
  }
  .general-header.general-header--store .general-header__panel {
    margin: 0 auto;
  }
  .general-header .general-header__wrapper {
    max-width: 100%;
  }
  .general-header .general-header__label {
    letter-spacing: -0.0359vw;
    font-size: 3.5897vw;
    margin-bottom: 4.359vw;
  }
  .general-header .general-header__title {
    margin-bottom: 6.1538vw;
  }
  .general-header .general-header__title h1 {
    line-height: 1.1;
    letter-spacing: -0.0923vw;
    font-size: 9.2308vw;
  }
  .general-header .general-header__text {
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
  }
  .general-header .general-header__panel {
    max-width: 100%;
    margin: 5.641vw auto 0;
    border-radius: 0px;
    padding: 0px;
    border: none;
    background: transparent;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .general-header .general-header__panel-button {
    border-radius: 10.2564vw;
    border: 1px solid var(--white-2);
    background: var(--white);
    margin: 2.0513vw 1.0256vw 0;
  }
  .general-header .general-header__panel-button.current-button {
    background-color: var(--dark);
    border-color: var(--dark);
  }
  .general-header .general-header__panel-button.current-button button {
    background-color: transparent;
    color: var(--white);
  }
  .general-header .general-header__panel-button button {
    padding: 2.5641vw 6.1538vw;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
    color: rgba(22, 22, 22, 0.5);
  }
  .general-header .general-header__panel-button .hover-block {
    display: none;
  }
}
.general-banner {
  order: -1;
}
.general-banner .general-banner__wrapper {
  background-color: var(--beige-2);
  border-radius: 24px;
  padding: 77px 80px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.general-banner .general-banner__content {
  width: 100%;
  max-width: 480px;
}
.general-banner .general-banner__content-logo {
  width: 198px;
  height: 53px;
  margin-bottom: 22px;
}
.general-banner .general-banner__content-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.general-banner .general-banner__content-text {
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.28px;
  font-size: 28px;
  color: var(--dark);
}
.general-banner .general-banner__content-subtext {
  margin-top: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.general-banner .general-banner__content-button {
  display: inline-block;
  margin-top: 76px;
}
.general-banner .general-banner__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.general-banner .general-banner__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.general-banner .general-banner__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .general-banner .general-banner__content-button a:hover::before {
    transform: translateX(3px);
  }
  .general-banner .general-banner__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .general-banner .general-banner__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .general-banner .general-banner__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .general-banner .general-banner__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .general-banner .general-banner__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .general-banner .general-banner__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .general-banner .general-banner__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .general-banner .general-banner__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .general-banner .general-banner__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .general-banner .general-banner__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.general-banner .general-banner__image {
  width: 100%;
  max-width: 570px;
  height: 376px;
  border-radius: 24px;
  overflow: hidden;
}
.general-banner .general-banner__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1330px) {
  .general-banner .general-banner__wrapper {
    border-radius: 1.8045vw;
    padding: 5.7895vw 6.015vw;
  }
  .general-banner .general-banner__content {
    max-width: 36.0902vw;
  }
  .general-banner .general-banner__content-logo {
    width: 14.8872vw;
    height: 3.985vw;
    margin-bottom: 1.6541vw;
  }
  .general-banner .general-banner__content-text {
    letter-spacing: -0.0211vw;
    font-size: 2.1053vw;
  }
  .general-banner .general-banner__content-subtext {
    margin-top: 1.203vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .general-banner .general-banner__content-button {
    margin-top: 5.7143vw;
  }
  .general-banner .general-banner__image {
    max-width: 42.8571vw;
    height: 28.2707vw;
    border-radius: 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .general-banner .general-banner__wrapper {
    border-radius: 1.875vw;
    padding: 5.3125vw 4.6875vw;
  }
  .general-banner .general-banner__content {
    max-width: 31.25vw;
  }
  .general-banner .general-banner__content-logo {
    width: 10.9375vw;
    height: auto;
    margin-bottom: 1.5625vw;
  }
  .general-banner .general-banner__content-text {
    letter-spacing: -0.0156vw;
    font-size: 1.5625vw;
  }
  .general-banner .general-banner__content-subtext {
    margin-top: 1.25vw;
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .general-banner .general-banner__content-button {
    margin-top: 5.9375vw;
  }
  .general-banner .general-banner__image {
    max-width: 36.7188vw;
    height: 24.2188vw;
    border-radius: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .general-banner .container {
    padding: 0;
  }
  .general-banner .general-banner__wrapper {
    border-radius: 6.1538vw;
    padding: 5.1282vw 5.1282vw 11.0256vw;
    justify-content: flex-start;
    flex-direction: column-reverse;
  }
  .general-banner .general-banner__content {
    max-width: 100%;
  }
  .general-banner .general-banner__content-logo {
    display: none;
  }
  .general-banner .general-banner__content-text {
    letter-spacing: -0.0564vw;
    font-size: 5.641vw;
  }
  .general-banner .general-banner__content-subtext {
    margin-top: 4.1026vw;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .general-banner .general-banner__content-button {
    margin-top: 8.2051vw;
  }
  .general-banner .general-banner__image {
    width: 100%;
    max-width: 100%;
    height: 58.9744vw;
    border-radius: 4.1026vw;
    margin-bottom: 6.1538vw;
  }
}
.general-list:nth-child(2) {
  order: 1;
}
.general-list:nth-child(3) {
  order: 2;
}
.general-list .list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 50px 30px;
}
.general-list .list .card {
  border: 1px solid var(--white-2);
  position: relative;
  z-index: 2;
  padding: 6px 6px 82px 6px;
  transition: all 0.4s linear;
}
.general-list .list .card:hover {
  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),
    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),
    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),
    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),
    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),
    0px 100px 80px 0px rgba(0, 0, 0, 0.05);
}
.general-list .list .card:hover .card-content__button::after {
  width: 100%;
}
.general-list .list .card .card-info__labels ul {
  display: flex;
  align-items: center;
  gap: 10px;
}
.general-list .list .card .card-info__labels ul li a {
  font-weight: 500;
  letter-spacing: -0.3px;
  font-size: 14px;
  color: var(--dark);
  text-align: center;
  padding: 10px 16px;
}
.general-list .list .card .card-info__time {
  display: none;
}
.general-list .list .card .card-content {
  margin-top: 14px;
  padding: 0 26px 0;
}
.general-list .list .card .card-content__title {
  margin-bottom: 0;
}
.general-list .list .card .card-content__title h3 {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.general-list .list .card .card-content__button {
  position: absolute;
  z-index: 2;
  left: 31px;
  bottom: 31px;
}

@media screen and (max-width: 1330px) {
  .general-list .list {
    grid-gap: 3.7594vw 2.2556vw;
  }
  .general-list .list .card {
    padding: 0.4511vw 0.4511vw 6.1654vw 0.4511vw;
  }
  .general-list .list .card .card-info__labels ul {
    gap: 0.7519vw;
  }
  .general-list .list .card .card-info__labels ul li a {
    letter-spacing: -0.0226vw;
    font-size: 1.0526vw;
    padding: 0.7519vw 1.203vw;
  }
  .general-list .list .card .card-content {
    margin-top: 1.0526vw;
    padding: 0 1.9549vw 0;
  }
  .general-list .list .card .card-content__title h3 {
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .general-list .list .card .card-content__button {
    left: 2.3308vw;
    bottom: 2.3308vw;
  }
}
@media screen and (max-width: 1280px) {
  .general-list .list {
    grid-gap: 3.9063vw 2.3438vw;
  }
  .general-list .list .card {
    padding: 0.4688vw 0.4688vw 6.4063vw 0.4688vw;
  }
  .general-list .list .card:hover {
    box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),
      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),
      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),
      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),
      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),
      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);
  }
  .general-list .list .card .card-info__labels ul {
    display: flex;
    align-items: center;
    gap: 0.7813vw;
  }
  .general-list .list .card .card-info__labels ul li a {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
    padding: 0.7813vw 1.25vw;
  }
  .general-list .list .card .card-content {
    margin-top: 0.7031vw;
    padding: 0 1.3281vw 0;
  }
  .general-list .list .card .card-content__title {
    margin-bottom: 0;
  }
  .general-list .list .card .card-content__title h3 {
    letter-spacing: -0.0313vw;
    font-size: 1.25vw;
  }
  .general-list .list .card .card-content__button {
    left: 1.7969vw;
    bottom: 2.6563vw;
  }
}
@media screen and (max-width: 850px) {
  .general-list .list {
    grid-template-columns: 1fr;
    grid-gap: 7.6923vw;
  }
  .general-list .list .card {
    padding: 1.5385vw 1.5385vw 18.2051vw 1.5385vw;
  }
  .general-list .list .card:hover {
    box-shadow: 0px 0.7692vw 0.5128vw 0px rgba(0, 0, 0, 0.01),
      0px 1.7949vw 1.2821vw 0px rgba(0, 0, 0, 0.02),
      0px 3.0769vw 2.5641vw 0px rgba(0, 0, 0, 0.03),
      0px 5.641vw 4.6154vw 0px rgba(0, 0, 0, 0.03),
      0px 10.7692vw 8.4615vw 0px rgba(0, 0, 0, 0.04),
      0px 25.641vw 20.5128vw 0px rgba(0, 0, 0, 0.05);
  }
  .general-list .list .card .card-info {
    margin-top: 5.3846vw;
    padding: 0 4.359vw;
    gap: 2.5641vw;
  }
  .general-list .list .card .card-info__labels ul {
    gap: 2.5641vw;
  }
  .general-list .list .card .card-info__labels ul li a {
    font-weight: 500;
    letter-spacing: -0.0769vw;
    font-size: 3.5897vw;
    color: var(--dark);
    text-align: center;
    padding: 2.5641vw 4.1026vw;
  }
  .general-list .list .card .card-content {
    margin-top: 3.5897vw;
    padding: 0 4.359vw 0;
  }
  .general-list .list .card .card-content__logo {
    width: 40vw;
    height: auto;
  }
  .general-list .list .card .card-content__title h3 {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .general-list .list .card .card-content__button {
    left: 5.641vw;
    bottom: 5.3846vw;
  }
}
.general-info .general-info__wrapper {
  border-radius: 24px;
  background-color: var(--blue);
  overflow: hidden;
  padding: 78px 80px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.general-info .general-info__content-logo {
  width: 239px;
  height: 54px;
  margin-bottom: 30px;
}
.general-info .general-info__content-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.general-info .general-info__content-list {
  width: 100%;
  max-width: 495px;
}
.general-info .general-info__content-list .list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px 55px;
}
.general-info .general-info__content-list .item {
  width: 100%;
}
.general-info .general-info__content-list .item .item-title {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.4px;
  font-size: 40px;
  color: var(--black);
  margin-bottom: 3px;
}
.general-info .general-info__content-list .item .item-subtitle {
  width: 100%;
  max-width: 215px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--dark);
}
.general-info .general-info__content-button {
  margin-top: 53px;
  display: inline-block;
}
.general-info .general-info__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.general-info .general-info__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.general-info .general-info__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .general-info .general-info__content-button a:hover::before {
    transform: translateX(3px);
  }
  .general-info .general-info__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .general-info .general-info__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .general-info .general-info__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .general-info .general-info__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .general-info .general-info__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .general-info .general-info__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .general-info .general-info__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .general-info .general-info__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .general-info .general-info__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .general-info .general-info__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.general-info .general-info__image {
  width: 100%;
  max-width: 570px;
  height: 376px;
  border-radius: 24px;
}
.general-info .general-info__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1330px) {
  .general-info .general-info__wrapper {
    border-radius: 1.8045vw;
    padding: 5.8647vw 6.015vw;
  }
  .general-info .general-info__content-logo {
    width: 17.9699vw;
    height: 4.0602vw;
    margin-bottom: 2.2556vw;
  }
  .general-info .general-info__content-list {
    max-width: 37.218vw;
  }
  .general-info .general-info__content-list .list {
    grid-gap: 2.2556vw 4.1353vw;
  }
  .general-info .general-info__content-list .item .item-title {
    letter-spacing: -0.0301vw;
    font-size: 3.0075vw;
    margin-bottom: 0.2256vw;
  }
  .general-info .general-info__content-list .item .item-subtitle {
    max-width: 16.1654vw;
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
  }
  .general-info .general-info__content-button {
    margin-top: 3.985vw;
  }
  .general-info .general-info__image {
    max-width: 42.8571vw;
    height: 28.2707vw;
    border-radius: 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .general-info .general-info__wrapper {
    border-radius: 1.875vw;
    padding: 5.3125vw 4.6875vw;
  }
  .general-info .general-info__content-logo {
    width: 13.125vw;
    height: 2.9688vw;
    margin-bottom: 1.5625vw;
  }
  .general-info .general-info__content-list {
    max-width: 30.4688vw;
  }
  .general-info .general-info__content-list .list {
    grid-gap: 2.5vw 2.7344vw;
  }
  .general-info .general-info__content-list .item .item-title {
    letter-spacing: -0.0234vw;
    font-size: 2.3438vw;
    margin-bottom: 0.625vw;
  }
  .general-info .general-info__content-list .item .item-subtitle {
    max-width: 13.6719vw;
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .general-info .general-info__content-button {
    margin-top: 3.0469vw;
  }
  .general-info .general-info__image {
    max-width: 36.7188vw;
    height: 24.2188vw;
    border-radius: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .general-info .container {
    padding: 0;
  }
  .general-info .general-info__wrapper {
    border-radius: 6.1538vw;
    padding: 5.3846vw 5.1282vw 7.9487vw;
    flex-direction: column-reverse;
  }
  .general-info .general-info__content-logo {
    width: 47.6923vw;
    height: 10.7692vw;
    margin-bottom: 6.1538vw;
  }
  .general-info .general-info__content-list {
    width: 100%;
    max-width: 126.9231vw;
  }
  .general-info .general-info__content-list .list {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 6.1538vw 8.9744vw;
  }
  .general-info .general-info__content-list .item .item-title {
    letter-spacing: -0.0718vw;
    font-size: 7.1795vw;
    margin-bottom: 0.7692vw;
  }
  .general-info .general-info__content-list .item .item-subtitle {
    max-width: 100%;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .general-info .general-info__content-button {
    margin-top: 9.7436vw;
  }
  .general-info .general-info__image {
    max-width: 100%;
    height: 58.9744vw;
    border-radius: 4.1026vw;
    margin-bottom: 6.1538vw;
  }
}
.general-testimonial {
  order: 1;
}
.general-testimonial .general-testimonial__wrapper {
  border-radius: 24px;
  background-color: var(--yellow);
  padding: 114px 156px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.general-testimonial .general-testimonial__image {
  width: 200px;
  height: 300px;
  border-radius: 18px;
  overflow: hidden;
}
.general-testimonial .general-testimonial__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.general-testimonial .general-testimonial__content {
  width: 100%;
  max-width: 678px;
}
.general-testimonial .general-testimonial__content-text {
  font-weight: 400;
  line-height: 1.4;
  font-size: 28px;
  letter-spacing: -0.5px;
  color: var(--dark);
}
.general-testimonial .general-testimonial__content-button {
  display: inline-block;
  margin-top: 15px;
}
.general-testimonial .general-testimonial__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.general-testimonial .general-testimonial__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.general-testimonial .general-testimonial__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .general-testimonial .general-testimonial__content-button a:hover::before {
    transform: translateX(3px);
  }
  .general-testimonial .general-testimonial__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .general-testimonial .general-testimonial__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .general-testimonial .general-testimonial__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .general-testimonial .general-testimonial__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .general-testimonial .general-testimonial__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .general-testimonial .general-testimonial__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .general-testimonial .general-testimonial__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .general-testimonial .general-testimonial__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .general-testimonial .general-testimonial__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .general-testimonial .general-testimonial__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.general-testimonial .general-testimonial__content-footer {
  margin-top: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.general-testimonial .general-testimonial__content-info {
  width: 100%;
  max-width: 365px;
}
.general-testimonial .general-testimonial__content-info-name {
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.2px;
  color: var(--dark);
  font-size: 20px;
}
.general-testimonial .general-testimonial__content-info-position {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.33px;
  font-size: 16px;
  color: var(--dark);
}
.general-testimonial .general-testimonial__content-logo {
  width: 147px;
  height: 23px;
}
.general-testimonial .general-testimonial__content-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .general-testimonial .general-testimonial__wrapper {
    border-radius: 1.8045vw;
    padding: 8.5714vw 11.7293vw;
  }
  .general-testimonial .general-testimonial__image {
    width: 15.0376vw;
    height: 22.5564vw;
    border-radius: 1.3534vw;
  }
  .general-testimonial .general-testimonial__content {
    max-width: 50.9774vw;
  }
  .general-testimonial .general-testimonial__content-text {
    font-size: 2.1053vw;
    letter-spacing: -0.0376vw;
  }
  .general-testimonial .general-testimonial__content-button {
    margin-top: 1.1278vw;
  }
  .general-testimonial .general-testimonial__content-footer {
    margin-top: 6.7669vw;
  }
  .general-testimonial .general-testimonial__content-info {
    max-width: 27.4436vw;
  }
  .general-testimonial .general-testimonial__content-info-name {
    letter-spacing: -0.015vw;
    font-size: 1.5038vw;
  }
  .general-testimonial .general-testimonial__content-info-position {
    letter-spacing: -0.0248vw;
    font-size: 1.203vw;
  }
  .general-testimonial .general-testimonial__content-logo {
    width: 11.0526vw;
    height: 1.7293vw;
  }
}
@media screen and (max-width: 1280px) {
  .general-testimonial .general-testimonial__wrapper {
    border-radius: 1.875vw;
    padding: 7.0313vw;
  }
  .general-testimonial .general-testimonial__image {
    width: 15.625vw;
    height: 23.4375vw;
    border-radius: 1.4063vw;
  }
  .general-testimonial .general-testimonial__content {
    max-width: 47.8906vw;
  }
  .general-testimonial .general-testimonial__content-text {
    font-size: 1.5625vw;
    letter-spacing: -0.0156vw;
  }
  .general-testimonial .general-testimonial__content-button {
    margin-top: 1.0938vw;
  }
  .general-testimonial .general-testimonial__content-footer {
    margin-top: 9.9219vw;
  }
  .general-testimonial .general-testimonial__content-info {
    max-width: 26.5625vw;
  }
  .general-testimonial .general-testimonial__content-info-name {
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
  }
  .general-testimonial .general-testimonial__content-info-position {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
  .general-testimonial .general-testimonial__content-logo {
    width: 9.375vw;
    height: auto;
  }
}
@media screen and (max-width: 850px) {
  .general-testimonial .general-testimonial__wrapper {
    border-radius: 4.1026vw;
    padding: 6.1538vw 6.1538vw 9.2308vw;
    justify-content: flex-start;
    flex-direction: column;
  }
  .general-testimonial .general-testimonial__image {
    width: 25.1282vw;
    height: 37.9487vw;
    border-radius: 4.1026vw;
    margin-top: 15.3846vw;
  }
  .general-testimonial .general-testimonial__content {
    max-width: 100%;
  }
  .general-testimonial .general-testimonial__content-text {
    font-size: 5.641vw;
    letter-spacing: -0.0564vw;
  }
  .general-testimonial .general-testimonial__content-button {
    margin-top: 7.1795vw;
  }
  .general-testimonial .general-testimonial__content-footer {
    margin-top: 4.1026vw;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  }
  .general-testimonial .general-testimonial__content-info {
    max-width: 100%;
  }
  .general-testimonial .general-testimonial__content-info-name {
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
  }
  .general-testimonial .general-testimonial__content-info-position {
    letter-spacing: -0.0359vw;
    font-size: 3.5897vw;
  }
  .general-testimonial .general-testimonial__content-logo {
    width: 37.6923vw;
    height: 5.8974vw;
    margin-top: 9.2308vw;
  }
}
.lobby-header .lobby-header__inner {
  padding: 104px 0 40px;
}
.lobby-header .lobby-header__title {
  text-align: center;
  margin-bottom: 36px;
}
.lobby-header .lobby-header__title h1 {
  font-weight: 700;
  font-family: "Cambon";
  line-height: 1.2;
  letter-spacing: -0.56px;
  font-size: 56px;
  color: var(--dark);
}
.lobby-header .lobby-header__subtitle {
  text-align: center;
  margin-bottom: 88px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.2px;
  font-size: 20px;
  color: var(--dark);
}
.lobby-header .lobby-header__wrapper {
  width: 100%;
  background: var(--light-gray);
  border-radius: 24px;
  overflow: hidden;
  padding: 80px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.lobby-header .lobby-header__content {
  width: 100%;
  max-width: 428px;
  margin-top: 7px;
}
.lobby-header .lobby-header__content-title {
  margin-bottom: 28px;
}
.lobby-header .lobby-header__content-title h3 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.4px;
  font-size: 40px;
  color: var(--dark);
}
.lobby-header .lobby-header__content-text {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 20px;
  color: var(--gray);
  margin-bottom: 32px;
}
.lobby-header .lobby-header__content-button {
  display: inline-block;
}
.lobby-header .lobby-header__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.lobby-header .lobby-header__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.lobby-header .lobby-header__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .lobby-header .lobby-header__content-button a:hover::before {
    transform: translateX(3px);
  }
  .lobby-header .lobby-header__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .lobby-header .lobby-header__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .lobby-header .lobby-header__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .lobby-header .lobby-header__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .lobby-header .lobby-header__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .lobby-header .lobby-header__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .lobby-header .lobby-header__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .lobby-header .lobby-header__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .lobby-header .lobby-header__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .lobby-header .lobby-header__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.lobby-header .lobby-header__content-info {
  margin-top: 30px;
  padding-top: 13px;
  border-top: 1px solid var(--white-2);
  display: flex;
  align-items: center;
}
.lobby-header .lobby-header__content-info-autor {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.14px;
  font-size: 14px;
  color: var(--beige-3);
  padding-right: 13px;
  margin-right: 8px;
  position: relative;
  z-index: 2;
}
.lobby-header .lobby-header__content-info-autor::before {
  content: "";
  position: absolute;
  top: 8px;
  right: 0;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--beige-3);
}
.lobby-header .lobby-header__content-info-data {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.14px;
  font-size: 14px;
  color: var(--beige-3);
}
.lobby-header .lobby-header__image {
  width: 100%;
  max-width: 570px;
  height: 400px;
  border-radius: 18px;
  overflow: hidden;
}
.lobby-header .lobby-header__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1330px) {
  .lobby-header .lobby-header__inner {
    padding: 7.8195vw 0 3.0075vw;
  }
  .lobby-header .lobby-header__title {
    margin-bottom: 2.7068vw;
  }
  .lobby-header .lobby-header__title h1 {
    letter-spacing: -0.0421vw;
    font-size: 4.2105vw;
  }
  .lobby-header .lobby-header__subtitle {
    margin-bottom: 6.6165vw;
    letter-spacing: -0.015vw;
    font-size: 1.5038vw;
  }
  .lobby-header .lobby-header__wrapper {
    border-radius: 1.8045vw;
    padding: 6.015vw;
  }
  .lobby-header .lobby-header__content {
    max-width: 32.1805vw;
    margin-top: 0.5263vw;
  }
  .lobby-header .lobby-header__content-title {
    margin-bottom: 2.1053vw;
  }
  .lobby-header .lobby-header__content-title h3 {
    letter-spacing: -0.0301vw;
    font-size: 3.0075vw;
  }
  .lobby-header .lobby-header__content-text {
    letter-spacing: -0.0301vw;
    font-size: 1.5038vw;
    margin-bottom: 2.406vw;
  }
  .lobby-header .lobby-header__content-info {
    margin-top: 2.2556vw;
    padding-top: 0.9774vw;
  }
  .lobby-header .lobby-header__content-info-autor {
    letter-spacing: -0.0105vw;
    font-size: 1.0526vw;
    padding-right: 0.9774vw;
    margin-right: 0.6015vw;
  }
  .lobby-header .lobby-header__content-info-autor::before {
    top: 0.6015vw;
    width: 0.3008vw;
    height: 0.3008vw;
  }
  .lobby-header .lobby-header__content-info-data {
    letter-spacing: -0.0105vw;
    font-size: 1.0526vw;
  }
  .lobby-header .lobby-header__image {
    max-width: 42.8571vw;
    height: 30.0752vw;
    border-radius: 1.3534vw;
  }
}
@media screen and (max-width: 1280px) {
  .lobby-header .lobby-header__inner {
    padding: 6.5625vw 0 3.125vw;
  }
  .lobby-header .lobby-header__title {
    margin-bottom: 1.5625vw;
  }
  .lobby-header .lobby-header__title h1 {
    line-height: 1.1;
    letter-spacing: -0.0328vw;
    font-size: 3.2813vw;
  }
  .lobby-header .lobby-header__subtitle {
    margin-bottom: 6.3281vw;
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
  }
  .lobby-header .lobby-header__wrapper {
    border-radius: 1.875vw;
    padding: 5.3125vw 4.6875vw 3.9063vw;
  }
  .lobby-header .lobby-header__content {
    max-width: 28.9063vw;
    margin-top: 0.3125vw;
  }
  .lobby-header .lobby-header__content-title {
    margin-bottom: 2.3438vw;
  }
  .lobby-header .lobby-header__content-title h3 {
    letter-spacing: -0.0234vw;
    font-size: 2.3438vw;
  }
  .lobby-header .lobby-header__content-text {
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
    margin-bottom: 1.875vw;
  }
  .lobby-header .lobby-header__content-info {
    margin-top: 2.5vw;
    padding-top: 0.9375vw;
  }
  .lobby-header .lobby-header__content-info-autor {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
    padding-right: 1.0156vw;
    margin-right: 0.625vw;
  }
  .lobby-header .lobby-header__content-info-autor::before {
    top: 0.625vw;
    width: 0.3125vw;
    height: 0.3125vw;
  }
  .lobby-header .lobby-header__content-info-data {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
  }
  .lobby-header .lobby-header__image {
    max-width: 36.7188vw;
    height: 25.7813vw;
    border-radius: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .lobby-header .container {
    padding: 0;
  }
  .lobby-header .lobby-header__inner {
    padding: 12.308vw 0 7.692vw;
  }
  .lobby-header .lobby-header__title {
    margin-bottom: 10.256vw;
  }
  .lobby-header .lobby-header__title h1 {
    line-height: 1.1;
    letter-spacing: -0.092vw;
    font-size: 9.231vw;
  }
  .lobby-header .lobby-header__subtitle {
    width: 100%;
    max-width: 76.9231vw;
    margin: 0 auto;
    margin-bottom: 10.2564vw;
    letter-spacing: -0.0513vw;
    font-size: 4.6154vw;
  }
  .lobby-header .lobby-header__wrapper {
    border-radius: 6.154vw;
    padding: 5.128vw 5.128vw 6.154vw;
    justify-content: flex-start;
    flex-direction: column-reverse;
  }
  .lobby-header .lobby-header__content {
    max-width: 100%;
    margin-top: 0;
  }
  .lobby-header .lobby-header__content-title {
    margin-bottom: 6.154vw;
  }
  .lobby-header .lobby-header__content-title h3 {
    letter-spacing: -0.051vw;
    font-size: 7.179vw;
  }
  .lobby-header .lobby-header__content-text {
    width: 100%;
    letter-spacing: -0.051vw;
    font-size: 5.128vw;
    margin-bottom: 7.692vw;
  }
  .lobby-header .lobby-header__content-info {
    margin-top: 8.205vw;
    padding-top: 3.333vw;
  }
  .lobby-header .lobby-header__content-info-autor {
    letter-spacing: -0.036vw;
    font-size: 3.59vw;
    padding-right: 3.333vw;
    margin-right: 2.051vw;
  }
  .lobby-header .lobby-header__content-info-autor::before {
    top: 2.051vw;
    width: 1.026vw;
    height: 1.026vw;
  }
  .lobby-header .lobby-header__content-info-data {
    letter-spacing: -0.036vw;
    font-size: 3.59vw;
  }
  .lobby-header .lobby-header__image {
    width: 100%;
    max-width: 100%;
    height: 63.077vw;
    border-radius: 4.103vw;
    overflow: hidden;
    margin-bottom: 5.128vw;
  }
}
.lobby-list .list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 40px 30px;
}
.lobby-list .card {
  border: 1px solid var(--white-2);
  position: relative;
  z-index: 2;
  padding: 6px 6px 123px 6px;
  transition: all 0.4s linear;
}
.lobby-list .card:hover {
  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),
    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),
    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),
    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),
    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),
    0px 100px 80px 0px rgba(0, 0, 0, 0.05);
}
.lobby-list .card:hover .card-content__button::after {
  width: 100%;
}
.lobby-list .card .card-content {
  padding: 0 26px 0;
  margin-bottom: 0;
}
.lobby-list .card .card-content__button {
  position: absolute;
  z-index: 2;
  left: 30px;
  bottom: 95px;
}
.lobby-list .card .card-content__button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.lobby-list .card .card-content__button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.lobby-list .card .card-content__button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .lobby-list .card .card-content__button a:hover::before {
    transform: translateX(3px);
  }
  .lobby-list .card .card-content__button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .lobby-list .card .card-content__button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .lobby-list .card .card-content__button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .lobby-list .card .card-content__button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .lobby-list .card .card-content__button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .lobby-list .card .card-content__button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .lobby-list .card .card-content__button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .lobby-list .card .card-content__button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .lobby-list .card .card-content__button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .lobby-list .card .card-content__button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.lobby-list .card .card-content__footer {
  position: absolute;
  left: 32px;
  z-index: 2;
  bottom: 31px;
  display: flex;
  align-items: center;
  padding-top: 13px;
  width: 100%;
  max-width: 346px;
  border-top: 1px solid var(--white-2);
}
.lobby-list .card .card-content__footer-autor {
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -0.14px;
  font-size: 14px;
  color: var(--beige-3);
  position: relative;
  z-index: 2;
  padding-right: 13px;
  margin-right: 8px;
}
.lobby-list .card .card-content__footer-autor::before {
  content: "";
  position: absolute;
  top: 8px;
  right: 0;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--beige-3);
}
.lobby-list .card .card-content__footer-data {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.14px;
  font-size: 14px;
  color: var(--beige-3);
}

@media screen and (max-width: 1330px) {
  .lobby-list .list {
    grid-gap: 3.0075vw 2.2556vw;
  }
  .lobby-list .card {
    padding: 0.4511vw 0.4511vw 9.2481vw 0.4511vw;
  }
  .lobby-list .card:hover {
    box-shadow: 0px 0.2256vw 0.1504vw 0px rgba(0, 0, 0, 0.01),
      0px 0.5263vw 0.3759vw 0px rgba(0, 0, 0, 0.02),
      0px 0.9023vw 0.7519vw 0px rgba(0, 0, 0, 0.03),
      0px 1.6541vw 1.2782vw 0px rgba(0, 0, 0, 0.03),
      0px 3.1579vw 2.4812vw 0px rgba(0, 0, 0, 0.04),
      0px 7.5188vw 6.015vw 0px rgba(0, 0, 0, 0.05);
  }
  .lobby-list .card .card-content {
    padding: 0 1.9549vw 0;
  }
  .lobby-list .card .card-content__button {
    left: 2.2556vw;
    bottom: 7.1429vw;
  }
  .lobby-list .card .card-content__footer {
    left: 2.406vw;
    bottom: 2.3308vw;
    padding-top: 0.9774vw;
    max-width: 26.015vw;
  }
  .lobby-list .card .card-content__footer-autor {
    letter-spacing: -0.0105vw;
    font-size: 1.0526vw;
    padding-right: 0.9774vw;
    margin-right: 0.6015vw;
  }
  .lobby-list .card .card-content__footer-autor::before {
    top: 0.6015vw;
    width: 0.3008vw;
    height: 0.3008vw;
  }
  .lobby-list .card .card-content__footer-data {
    letter-spacing: -0.0105vw;
    font-size: 1.0526vw;
  }
}
@media screen and (max-width: 1280px) {
  .lobby-list .list {
    grid-gap: 3.125vw 2.3438vw;
  }
  .lobby-list .card {
    padding: 0.4688vw 0.4688vw 9.6094vw 0.4688vw;
  }
  .lobby-list .card:hover {
    box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),
      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),
      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),
      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),
      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),
      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);
  }
  .lobby-list .card .card-content {
    padding: 0 1.3281vw 0;
  }
  .lobby-list .card .card-content__button {
    left: 1.7969vw;
    bottom: 7.0313vw;
  }
  .lobby-list .card .card-content__footer {
    left: 1.7969vw;
    bottom: 1.7969vw;
    padding-top: 1.0156vw;
    max-width: 22.1094vw;
  }
  .lobby-list .card .card-content__footer-autor {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
    padding-right: 1.0156vw;
    margin-right: 0.625vw;
  }
  .lobby-list .card .card-content__footer-autor::before {
    top: 0.625vw;
    width: 0.3125vw;
    height: 0.3125vw;
  }
  .lobby-list .card .card-content__footer-data {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
  }
}
@media screen and (max-width: 850px) {
  .lobby-list .list {
    grid-template-columns: 1fr;
    grid-gap: 7.692vw;
  }
  .lobby-list .card {
    padding: 1.538vw 1.538vw 6.154vw 1.538vw;
  }
  .lobby-list .card:hover {
    box-shadow: 0px 0.71vw 0.568vw 0px rgba(0, 0, 0, 0.01),
      0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),
      0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),
      0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),
      0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),
      0px 100px 80px 0px rgba(0, 0, 0, 0.05);
  }
  .lobby-list .card .card-content {
    padding: 0 6.154vw 0;
    margin-bottom: 0;
    margin-top: 6.154vw;
  }
  .lobby-list .card .card-content__button {
    position: relative;
    margin-bottom: 8.205vw;
    left: auto;
    bottom: auto;
  }
  .lobby-list .card .card-content__footer {
    position: relative;
    left: auto;
    bottom: auto;
    padding-top: 3.333vw;
    max-width: 100%;
  }
  .lobby-list .card .card-content__footer-autor {
    letter-spacing: -0.036vw;
    font-size: 3.59vw;
    padding-right: 3.333vw;
    margin-right: 2.051vw;
  }
  .lobby-list .card .card-content__footer-autor::before {
    top: 2.051vw;
    width: 1.026vw;
    height: 1.026vw;
  }
  .lobby-list .card .card-content__footer-data {
    letter-spacing: -0.036vw;
    font-size: 3.59vw;
  }
}
.blog-single-first-screen {
  position: relative;
  z-index: 2;
}
.blog-single-first-screen::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 127px);
  z-index: -1;
}
.blog-single-first-screen.default-color::before {
  background-color: #f6f5ef;
}
.blog-single-first-screen.bg-color-1::before {
  background-color: #ffdebf;
}
.blog-single-first-screen.bg-color-2::before {
  background-color: #fff2e5;
}
.blog-single-first-screen.bg-color-3::before {
  background-color: #ffc2d6;
}
.blog-single-first-screen.bg-color-4::before {
  background-color: #ffe7ef;
}
.blog-single-first-screen.bg-color-5::before {
  background-color: #e3bfff;
}
.blog-single-first-screen.bg-color-6::before {
  background-color: #f4e5ff;
}
.blog-single-first-screen.bg-color-7::before {
  background-color: #b8dfd7;
}
.blog-single-first-screen.bg-color-8::before {
  background-color: #e7f6eb;
}
.blog-single-first-screen.bg-color-9::before {
  background-color: #b1e1f5;
}
.blog-single-first-screen.bg-color-10::before {
  background-color: #e0f3fb;
}
.blog-single-first-screen .blog-single-first-screen__inner {
  padding-top: 100px;
}
.blog-single-first-screen .blog-single-first-screen__header {
  margin-bottom: 76px;
}
.blog-single-first-screen .blog-single-first-screen__header-title {
  width: 100%;
  max-width: 815px;
  margin: 0 auto 24px;
  text-align: center;
}
.blog-single-first-screen .blog-single-first-screen__header-title h2 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  font-size: 48px;
  letter-spacing: -0.48px;
  color: var(--dark);
}
.blog-single-first-screen .blog-single-first-screen__header-info {
  display: flex;
  align-items: center;
  justify-content: center;
}
.blog-single-first-screen .blog-single-first-screen__header-autor,
.blog-single-first-screen .blog-single-first-screen__header-date,
.blog-single-first-screen .blog-single-first-screen__header-time {
  color: var(--gray-2);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.14px;
}
.blog-single-first-screen .blog-single-first-screen__header-autor,
.blog-single-first-screen .blog-single-first-screen__header-date {
  padding-right: 13px;
  margin-right: 8px;
  position: relative;
  z-index: 2;
}
.blog-single-first-screen .blog-single-first-screen__header-autor::before,
.blog-single-first-screen .blog-single-first-screen__header-date::before {
  content: "";
  position: absolute;
  top: 8px;
  right: 0;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--beige-3);
}
.blog-single-first-screen .blog-single-first-screen__image {
  width: 100%;
  max-width: 780px;
  height: 470px;
  margin: 0 auto;
  border-radius: 24px;
  overflow: hidden;
}
.blog-single-first-screen .blog-single-first-screen__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1330px) {
  .blog-single-first-screen::before {
    height: calc(100% - 9.5489vw);
  }
  .blog-single-first-screen .blog-single-first-screen__inner {
    padding-top: 7.5188vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header {
    margin-bottom: 5.7143vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-title {
    max-width: 61.2782vw;
    margin: 0 auto 1.8045vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-title h2 {
    font-size: 3.609vw;
    letter-spacing: -0.0361vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-autor,
  .blog-single-first-screen .blog-single-first-screen__header-date,
  .blog-single-first-screen .blog-single-first-screen__header-time {
    font-size: 1.0526vw;
    letter-spacing: -0.0105vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-autor,
  .blog-single-first-screen .blog-single-first-screen__header-date {
    padding-right: 0.9774vw;
    margin-right: 0.6015vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-autor::before,
  .blog-single-first-screen .blog-single-first-screen__header-date::before {
    top: 0.6015vw;
    width: 0.3008vw;
    height: 0.3008vw;
  }
  .blog-single-first-screen .blog-single-first-screen__image {
    max-width: 58.6466vw;
    height: 35.3383vw;
    border-radius: 1.8045vw;
  }
}
@media screen and (max-width: 850px) {
  .blog-single-first-screen::before {
    height: calc(100% - 17.179vw);
  }
  .blog-single-first-screen .blog-single-first-screen__inner {
    padding-top: 12.308vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header {
    margin-bottom: 11.282vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-title {
    max-width: 100%;
    margin: 0 auto 6.154vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-title h2 {
    font-size: 8.205vw;
    letter-spacing: -0.082vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-autor,
  .blog-single-first-screen .blog-single-first-screen__header-date,
  .blog-single-first-screen .blog-single-first-screen__header-time {
    font-size: 3.59vw;
    letter-spacing: -0.036vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-autor,
  .blog-single-first-screen .blog-single-first-screen__header-date {
    padding-right: 3.333vw;
    margin-right: 2.051vw;
  }
  .blog-single-first-screen .blog-single-first-screen__header-autor::before,
  .blog-single-first-screen .blog-single-first-screen__header-date::before {
    top: 2.051vw;
    right: 0;
    width: 1.026vw;
    height: 1.026vw;
  }
  .blog-single-first-screen .blog-single-first-screen__image {
    width: 100%;
    max-width: 89.744vw;
    height: 53.846vw;
    border-radius: 4.103vw;
  }
  .blog-single-first-screen .blog-single-first-screen__image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.blog-single-article .blog-single-article__inner {
  padding: 80px 0 178px;
}
.blog-single-article .blog-single-article__content {
  width: 100%;
  max-width: 780px;
  margin: 0 auto;
}

@media screen and (max-width: 1330px) {
  .blog-single-article .blog-single-article__inner {
    padding: 6.015vw 0 13.3835vw;
  }
  .blog-single-article .blog-single-article__content {
    max-width: 58.6466vw;
  }
}
@media screen and (max-width: 850px) {
  .blog-single-article .blog-single-article__inner {
    padding: 10.2564vw 0 33.3333vw;
  }
  .blog-single-article .blog-single-article__content {
    max-width: 100%;
  }
}
.section-thanks {
  background-color: var(--light-gray);
  padding: 124px 0 522px 0;
}
.section-thanks__content {
  max-width: 988px;
  width: 100%;
  margin: 0 auto;
  background-color: var(--white);
  border-radius: 24px;
  padding: 62px 245px 104px 245px;
  position: relative;
}
.section-thanks__content-title {
  color: var(--dark);
  text-align: center;
  font-family: "Cambon";
  font-size: 56px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.56px;
  margin-bottom: 30px;
}
.section-thanks__content-subtitle {
  color: var(--dark);
  text-align: center;
  font-family: "Circular Std";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.2px;
  margin: 0 auto 69px auto;
  max-width: 70%;
}
.section-thanks__content-link {
  display: flex;
  justify-content: center;
}
.section-thanks__content-link a {
  font-weight: 400;
  line-height: 1.4;
  font-size: 18px;
  letter-spacing: -0.18px;
  color: var(--dark);
  padding-bottom: 5px;
  -webkit-text-decoration: underline 2px;
  text-decoration: underline 2px;
  text-underline-offset: 5px;
  position: relative;
  z-index: 2;
  padding-right: 27px;
}
.section-thanks__content-link a::before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.section-thanks__content-img {
  position: absolute;
  bottom: -68px;
  right: 216px;
  width: 113px;
  height: 117px;
}
.section-thanks__content-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .section-thanks {
    padding: 9.323vw 0 39.248vw 0;
  }
  .section-thanks__content {
    max-width: 74.286vw;
    border-radius: 1.805vw;
    padding: 4.662vw 18.421vw 7.82vw 18.421vw;
  }
  .section-thanks__content-title {
    font-size: 4.211vw;
    margin-bottom: 30zpx;
  }
  .section-thanks__content-subtitle {
    font-size: 1.504vw;
    margin: 0 auto 5.188vw auto;
  }
  .section-thanks__content-link a {
    font-size: 1.3534vw;
    letter-spacing: -0.0135vw;
    padding-bottom: 0.3759vw;
    -webkit-text-decoration: underline 0.1504vw;
    text-decoration: underline 0.1504vw;
    text-underline-offset: 0.3759vw;
    padding-right: 2.0301vw;
  }
  .section-thanks__content-link a::before {
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .section-thanks__content-img {
    bottom: -5.113vw;
    right: 16.241vw;
    width: 8.496vw;
    height: 8.797vw;
  }
}
@media screen and (max-width: 1280px) {
  .section-thanks {
    padding: 9.323vw 0 22.248vw 0;
  }
}
@media screen and (max-width: 850px) {
  .section-thanks {
    padding: 13.846vw 0 41.282vw 0;
  }
  .section-thanks__content {
    max-width: 100%;
    border-radius: 4.615vw;
    padding: 13.333vw 6.154vw 25.769vw 6.154vw;
  }
  .section-thanks__content-title {
    font-size: 9.231vw;
    margin-bottom: 7.692vw;
  }
  .section-thanks__content-subtitle {
    font-size: 4.615vw;
    margin: 0 auto 12.564vw auto;
    max-width: 100%;
  }
  .section-thanks__content-link {
    max-width: 51.282vw;
    margin: 0 auto;
  }
  .section-thanks__content-link a {
    font-size: 4.1026vw;
    letter-spacing: -0.041vw;
    -webkit-text-decoration: underline 1px;
    text-decoration: underline 1px;
    text-underline-offset: 1.2821vw;
    padding-right: 6.9231vw;
  }
  .section-thanks__content-link a::before {
    top: 50%;
    transform: translateY(-50%);
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .section-thanks__content-img {
    position: absolute;
    bottom: -18.718vw;
    right: 50%;
    transform: translateX(50%);
    width: 28.974vw;
    height: 30vw;
  }
}
.first-screen-integrations {
  padding: 0 30px;
}
.first-screen-integrations .first-screen-integrations__inner {
  background-color: var(--light-gray);
  border-radius: 0 0 24px 24px;
  overflow: hidden;
  padding: 105px 0;
}
.first-screen-integrations .first-screen-integrations__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.first-screen-integrations .first-screen-integrations__content {
  width: 100%;
  max-width: 630px;
}
.first-screen-integrations .first-screen-integrations__content-label {
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.14px;
  text-transform: uppercase;
  font-size: 14px;
  color: var(--dark);
  margin-bottom: 16px;
}
.first-screen-integrations .first-screen-integrations__content-title {
  margin-bottom: 17px;
}
.first-screen-integrations .first-screen-integrations__content-title h1 {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.56px;
  font-size: 56px;
  color: var(--dark);
}
.first-screen-integrations .first-screen-integrations__content-text {
  width: 100%;
  max-width: 530px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.2px;
  font-size: 20px;
  color: var(--dark);
}
.first-screen-integrations .first-screen-integrations__content-button {
  margin-top: 32px;
  display: flex;
  gap: 16px;
  justify-content: flex-start;
}
.first-screen-integrations .first-screen-integrations__media {
  width: 100%;
  max-width: 579px;
  height: 540px;
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  margin-right: 52px;
}
.first-screen-integrations .first-screen-integrations__media-img {
  width: 100%;
  height: 100%;
}
.first-screen-integrations .first-screen-integrations__media-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .first-screen-integrations {
    padding: 0 2.256vw;
  }
  .first-screen-integrations .first-screen-integrations__inner {
    border-radius: 0 0 1.805vw 1.805vw;
    padding: 7.895vw 0;
  }
  .first-screen-integrations .first-screen-integrations__content {
    max-width: 47.368vw;
  }
  .first-screen-integrations .first-screen-integrations__content-label {
    font-size: 1.053vw;
    margin-bottom: 1.203vw;
  }
  .first-screen-integrations .first-screen-integrations__content-title {
    margin-bottom: 1.278vw;
  }
  .first-screen-integrations .first-screen-integrations__content-title h1 {
    font-size: 4.211vw;
  }
  .first-screen-integrations .first-screen-integrations__content-text {
    max-width: 39.85vw;
    font-size: 1.504vw;
  }
  .first-screen-integrations .first-screen-integrations__content-button {
    margin-top: 2.406vw;
    gap: 1.203vw;
  }
  .first-screen-integrations .first-screen-integrations__media {
    max-width: 43.534vw;
    height: 40.602vw;
    margin-right: 3.91vw;
  }
}
@media screen and (max-width: 1280px) {
  .first-screen-integrations {
    padding: 0 2.3438vw;
  }
  .first-screen-integrations .first-screen-integrations__inner {
    border-radius: 0 0 1.875vw 1.875vw;
    padding: 4.0625vw 0;
  }
  .first-screen-integrations .first-screen-integrations__content {
    max-width: 38.2813vw;
  }
  .first-screen-integrations .first-screen-integrations__content-label {
    letter-spacing: -0.0109vw;
    font-size: 1.0938vw;
    margin-bottom: 1.25vw;
  }
  .first-screen-integrations .first-screen-integrations__content-title {
    margin-bottom: 1.875vw;
  }
  .first-screen-integrations .first-screen-integrations__content-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0328vw;
    font-size: 3.2813vw;
  }
  .first-screen-integrations .first-screen-integrations__content-text {
    max-width: 32.8125vw;
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
  }
  .first-screen-integrations .first-screen-integrations__content-button {
    margin-top: 2.5vw;
    gap: 1.25vw;
  }
  .first-screen-integrations .first-screen-integrations__media {
    max-width: 39.2188vw;
    height: 37.1094vw;
    margin-right: 0;
  }
}
@media screen and (max-width: 850px) {
  .first-screen-integrations {
    padding: 0;
  }
  .first-screen-integrations .container {
    padding: 0;
  }
  .first-screen-integrations .first-screen-integrations__inner {
    border-radius: 4.1026vw;
    padding: 12.0513vw 5.1282vw 11.795vw;
  }
  .first-screen-integrations .first-screen-integrations__wrapper {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 11.2821vw;
  }
  .first-screen-integrations .first-screen-integrations__content {
    max-width: 100%;
  }
  .first-screen-integrations .first-screen-integrations__content-title {
    margin-bottom: 5.641vw;
  }
  .first-screen-integrations .first-screen-integrations__content-title h1 {
    line-height: 1.1;
    letter-spacing: -0.0923vw;
    font-size: 9.2308vw;
  }
  .first-screen-integrations .first-screen-integrations__content-text {
    max-width: 100%;
    letter-spacing: -0.0769vw;
    font-size: 4.6154vw;
  }
  .first-screen-integrations .first-screen-integrations__content-button {
    margin-top: 6.1538vw;
    gap: 4.103vw;
    flex-direction: column;
  }
  .first-screen-integrations .first-screen-integrations__media {
    max-width: 100%;
    height: 83.59vw;
    margin-top: 0;
    margin-right: 0;
  }
}
.promo .promo__inner {
  padding: 118px 0 188px 0;
  border-bottom: 1px solid rgba(22, 22, 22, 0.1450980392);
}
.promo .promo__title {
  margin: 0 auto 90px auto;
  text-align: center;
  max-width: 70%;
}
.promo .promo__title h2 {
  color: var(--dark);
  text-align: center;
  font-family: "Cambon";
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.48px;
}
.promo .promo__card {
  display: flex;
  gap: 170px;
  padding-left: 55px;
  align-items: center;
}
.promo .promo__card-media {
  width: 520px;
  height: auto;
  position: relative;
}
.promo .promo__card-media-img {
  width: 100%;
}
.promo .promo__card-media-img img {
  width: 100%;
  height: auto;
  object-fit: contain;
}
.promo .promo__card-media-dec {
  position: absolute;
  bottom: -52px;
  right: 73px;
  width: 204px;
  height: 159.648px;
}
.promo .promo__card-media-dec img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.promo .promo__card-info {
  width: 460px;
}
.promo .promo__card-title {
  margin-bottom: 32px;
}
.promo .promo__card-title h2 {
  color: var(--dark);
  font-family: "Cambon";
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.4px;
}
.promo .promo__card-text {
  font-family: "Circular Std";
  color: var(--dark);
}
.promo .promo__card-text p {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.2px;
}
.promo .promo__card-text ul {
  margin-top: 32px;
}
.promo .promo__card-text ul li {
  list-style-type: disc;
  list-style-position: inside;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  /* 25.6px */
  letter-spacing: -0.16px;
}
.promo .promo__card-button {
  margin-top: 32px;
}

@media screen and (max-width: 1330px) {
  .promo .promo__inner {
    padding: 8.872vw 0 14.135vw 0;
  }
  .promo .promo__title {
    margin: 0 auto 7.068vw auto;
  }
  .promo .promo__title h2 {
    font-size: 3.609vw;
    letter-spacing: -0.036vw;
  }
  .promo .promo__card {
    gap: 12.782vw;
    padding-left: 4.135vw;
  }
  .promo .promo__card-media {
    width: 39.098vw;
  }
  .promo .promo__card-media-dec {
    bottom: -3.91vw;
    right: 5.489vw;
    width: 15.338vw;
    height: 12.004vw;
  }
  .promo .promo__card-info {
    width: 34.586vw;
  }
  .promo .promo__card-title {
    margin-bottom: 2.406vw;
  }
  .promo .promo__card-title h2 {
    font-size: 3.008vw;
    letter-spacing: -0.03vw;
  }
  .promo .promo__card-text p {
    font-size: 1.504vw;
    letter-spacing: -0.015vw;
  }
  .promo .promo__card-text ul {
    margin-top: 2.406vw;
  }
  .promo .promo__card-text ul li {
    font-size: 1.203vw;
    letter-spacing: -0.012vw;
  }
  .promo .promo__card-button {
    margin-top: 2.406vw;
  }
}
@media screen and (max-width: 1280px) {
  .promo .promo__inner {
    padding: 6.6406vw 0 8.0469vw 0;
  }
  .promo .promo__title {
    margin: 0 auto 5.625vw auto;
    max-width: 39.8438vw;
  }
  .promo .promo__title h2 {
    font-size: 2.9688vw;
    letter-spacing: -0.0297vw;
  }
  .promo .promo__card {
    gap: 7.1094vw;
    padding-left: 2.7344vw;
  }
  .promo .promo__card-media {
    width: 34.375vw;
    margin-top: -3.5156vw;
  }
  .promo .promo__card-media-dec {
    position: absolute;
    bottom: -2.8906vw;
    right: 5.0781vw;
    width: 12.8906vw;
    height: 10.1563vw;
  }
  .promo .promo__card-info {
    width: 34.375vw;
  }
  .promo .promo__card-title {
    margin-bottom: 2.1875vw;
  }
  .promo .promo__card-title h2 {
    font-size: 2.3438vw;
    letter-spacing: -0.0234vw;
  }
  .promo .promo__card-text p {
    font-size: 1.4063vw;
    letter-spacing: -0.0141vw;
  }
  .promo .promo__card-text ul {
    margin-top: 2.6563vw;
  }
  .promo .promo__card-text ul li {
    font-size: 1.25vw;
    line-height: 160%;
    letter-spacing: -0.0125vw;
  }
  .promo .promo__card-button {
    margin-top: 2.6563vw;
  }
}
@media screen and (max-width: 850px) {
  .promo .promo__inner {
    padding: 15.385vw 0 14.359vw 0;
  }
  .promo .promo__title {
    margin: 0 auto 8.205vw auto;
    max-width: 100%;
  }
  .promo .promo__title h2 {
    font-size: 8.205vw;
    letter-spacing: -0.082vw;
  }
  .promo .promo__card {
    flex-direction: column;
    gap: 19.487vw;
    padding-left: 0;
  }
  .promo .promo__card-media {
    width: 100%;
    margin-top: 0;
  }
  .promo .promo__card-media-dec {
    bottom: -8.974vw;
    right: 12.821vw;
    width: 35.128vw;
    height: 27.436vw;
  }
  .promo .promo__card-info {
    width: 100%;
  }
  .promo .promo__card-title {
    margin-bottom: 6.154vw;
  }
  .promo .promo__card-title h2 {
    font-size: 7.179vw;
    letter-spacing: -0.072vw;
  }
  .promo .promo__card-text p {
    font-size: 4.615vw;
    letter-spacing: -0.046vw;
  }
  .promo .promo__card-text ul {
    margin-top: 6.154vw;
    margin-left: 5.128vw;
  }
  .promo .promo__card-text ul li {
    list-style-position: outside;
    font-size: 4.103vw;
    letter-spacing: -0.041vw;
  }
  .promo .promo__card-button {
    margin-top: 8.205vw;
  }
}
.apps .apps__inner {
  padding-top: 90px;
}
.apps .apps__title {
  margin: 0 auto 20px auto;
  text-align: center;
  max-width: 60%;
}
.apps .apps__title h2 {
  color: var(--dark);
  text-align: center;
  font-family: "Cambon";
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.48px;
}
.apps .apps__subtitle {
  margin: 0 auto 48px auto;
  text-align: center;
  max-width: 60%;
  color: var(--dark);
  font-family: "Circular Std";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.2px;
}
.apps .apps__filter {
  width: 100%;
  max-width: 1050px;
  margin: 0 auto 39px;
  border-radius: 60px;
  border: 1px solid var(--white-2);
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.apps .apps__filter button {
  padding: 7px 20px;
  font-family: "Circular Std";
  font-weight: 400;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
  background-color: transparent;
  transition: all 0.4s linear;
  border-radius: 40px;
}
.apps .apps__filter button.active {
  background-color: var(--dark);
  color: var(--white);
}
.apps .apps__cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 38px 30px;
}
.apps .apps__cards .item {
  background-color: var(--light-gray);
  border-radius: 24px;
  width: 100%;
  color: var(--dark);
}
.apps .apps__cards .item-img {
  margin: 8px 8px 24px;
  background-color: var(--white);
  border-radius: 18px;
  height: 212px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.apps .apps__cards .item-img img {
  display: block;
  margin: auto;
  max-width: 100%;
  height: auto;
}
.apps .apps__cards .item-img .link_to_post {
  width: 48px;
  height: 48px;
  background-color: var(--yellow);
  border-radius: 50%;
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 12px;
  right: 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-position: center;
  background-size: 24px 24px;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 0.3s;
  cursor: pointer;
}
.apps .apps__cards .item-img .link_to_post a {
  width: 100%;
  height: 100%;
}
.apps .apps__cards .item__content {
  margin: 0 32px 38px 32px;
}
.apps .apps__cards .item-label {
  display: inline-block;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.14px;
  border-radius: 999px;
  padding: 10px 16px;
  background-color: var(--white);
  margin-bottom: 16px;
}
.apps .apps__cards .item-title {
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.24px;
  margin-bottom: 10px;
}
.apps .apps__cards .item-title span {
  color: #8d8c89;
}
.apps .apps__cards .item-info {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.18px;
}
.apps .apps__cards .item:hover .link_to_post {
  opacity: 1;
}

@media screen and (max-width: 1330px) {
  .apps .apps__inner {
    padding-top: 6.767vw;
  }
  .apps .apps__title {
    margin: 0 auto 1.504vw auto;
  }
  .apps .apps__title h2 {
    font-size: 3.609vw;
    letter-spacing: -0.036vw;
  }
  .apps .apps__subtitle {
    margin: 0 auto 3.609vw auto;
    font-size: 1.504vw;
    letter-spacing: -0.015vw;
  }
  .apps .apps__filter {
    max-width: 78.9474vw;
    margin: 0 auto 2.9323vw;
    border-radius: 4.5113vw;
    padding: 0.7519vw;
  }
  .apps .apps__filter button {
    padding: 0.5263vw 1.5038vw;
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
    border-radius: 3.0075vw;
  }
  .apps .apps__cards {
    grid-gap: 2.857vw 2.256vw;
  }
  .apps .apps__cards .item {
    border-radius: 1.805vw;
  }
  .apps .apps__cards .item-img {
    margin: 0.602vw 0.602vw 1.805vw;
    border-radius: 1.353vw;
    height: 15.94vw;
  }
  .apps .apps__cards .item-img .link_to_post {
    width: 3.609vw;
    height: 3.609vw;
    top: 0.902vw;
    right: 0.902vw;
    background-size: 1.805vw 1.805vw;
  }
  .apps .apps__cards .item__content {
    margin: 0 2.406vw 2.857vw 2.406vw;
  }
  .apps .apps__cards .item-label {
    font-size: 1.053vw;
    letter-spacing: -0.011vw;
    padding: 0.752vw 1.203vw;
    margin-bottom: 1.203vw;
  }
  .apps .apps__cards .item-title {
    font-size: 1.805vw;
    letter-spacing: -0.018vw;
    margin-bottom: 0.752vw;
  }
  .apps .apps__cards .item-info {
    font-size: 1.353vw;
    letter-spacing: -0.014vw;
  }
}
@media screen and (max-width: 1280px) {
  .apps .apps__inner {
    padding-top: 7.8906vw;
  }
  .apps .apps__title {
    margin: 0 auto 1.6406vw auto;
    max-width: 43.4375vw;
  }
  .apps .apps__title h2 {
    font-size: 2.9688vw;
    letter-spacing: -0.0297vw;
  }
  .apps .apps__subtitle {
    margin: 0 auto 3.75vw auto;
    max-width: 53.9063vw;
    font-size: 1.4063vw;
    letter-spacing: -0.0141vw;
  }
  .apps .apps__filter {
    max-width: 100%;
    margin: 0 auto 3.125vw;
    border-radius: 4.6875vw;
    padding: 1.0938vw 1.1719vw;
  }
  .apps .apps__filter button {
    padding: 0.5469vw 1.5625vw;
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
    border-radius: 3.125vw;
  }
  .apps .apps__cards {
    grid-gap: 2.9688vw 2.3438vw;
  }
  .apps .apps__cards .item {
    border-radius: 1.875vw;
  }
  .apps .apps__cards .item-img {
    margin: 0.625vw 0.625vw 1.6406vw;
    border-radius: 1.4063vw;
    height: 13.2031vw;
  }
  .apps .apps__cards .item__content {
    margin: 0 1.875vw 2.9688vw 1.875vw;
  }
  .apps .apps__cards .item-label {
    font-size: 1.0938vw;
    letter-spacing: -0.0109vw;
    border-radius: 78.0469vw;
    padding: 0.5469vw 1.1719vw;
    margin-bottom: 1.0938vw;
  }
  .apps .apps__cards .item-title {
    font-size: 1.7188vw;
    letter-spacing: -0.0188vw;
    margin-bottom: 0.625vw;
  }
  .apps .apps__cards .item-info {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
  }
}
@media screen and (max-width: 850px) {
  .apps .apps__inner {
    padding-top: 12.821vw;
  }
  .apps .apps__title {
    margin: 0 auto 19.999px auto;
    max-width: 100%;
  }
  .apps .apps__title h2 {
    font-size: 8.205vw;
    letter-spacing: -0.082vw;
  }
  .apps .apps__subtitle {
    margin: 0 auto 8.205vw auto;
    max-width: 100%;
    font-size: 4.615vw;
    letter-spacing: -0.051vw;
  }
  .apps .apps__filter {
    max-width: 100%;
    margin: 0 auto 8.2051vw;
    border-radius: 0px;
    padding: 0px;
    border: none;
    background: transparent;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .apps .apps__filter button {
    min-width: 17.6923vw;
    border-radius: 10.2564vw;
    border: 1px solid var(--white-2);
    background: var(--white);
    margin: 2.0513vw 1.0256vw 0;
    padding: 2.5641vw 6.1538vw;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .apps .apps__cards {
    grid-template-columns: 1fr;
    grid-gap: 7.692vw;
  }
  .apps .apps__cards .item {
    border-radius: 4.103vw;
  }
  .apps .apps__cards .item-img {
    margin: 2.051vw 2.051vw 6.154vw;
    border-radius: 3.077vw;
    height: 46.154vw;
  }
  .apps .apps__cards .item-img .link_to_post {
    width: 12.308vw;
    height: 12.308vw;
    top: 3.077vw;
    right: 3.077vw;
    background-size: 6.154vw 6.154vw;
  }
  .apps .apps__cards .item__content {
    margin: 0 6.154vw 6.41vw 6.154vw;
  }
  .apps .apps__cards .item-label {
    font-size: 3.59vw;
    letter-spacing: -0.036vw;
    padding: 2.564vw 4.103vw;
    margin-bottom: 4.103vw;
  }
  .apps .apps__cards .item-title {
    font-size: 5.641vw;
    letter-spacing: -0.062vw;
    margin-bottom: 2.564vw;
  }
  .apps .apps__cards .item-info {
    font-size: 4.103vw;
    letter-spacing: -0.041vw;
  }
}
.pricing {
  /* padding: 100px 0 40px 0; */
  /* background-color: var(--beige); */
}
.pricing__title {
  color: var(--gray);
  font-family: "Cambon";
  text-align: center;
  margin-bottom: 24px;
}
.pricing__title h2 {
  font-size: 56px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.56px;
}
.pricing-tabs {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  max-width: max-content;
  margin: 0 auto 72px auto;
  background-color: var(--white);
  border-radius: 999px;
  padding: 8px;
  border: 1px solid var(--white-2);
}
.pricing-tabs .pricing-tab {
  padding: 10px 24px;
  background-color: var(--white);
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  border-radius: 999px;
}
.pricing-tabs .pricing-tab.active {
  background-color: var(--gray);
  color: var(--white);
}

/* Animations for mobile pricing below (Swtiching between tabs) */
.fade-enter {
  opacity: 0;
  transform: translateY(-20px);
}
.fade-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 300ms, transform 300ms;
}
.fade-exit {
  opacity: 1;
  transform: translateY(0);
}
.fade-exit-active {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 300ms, transform 300ms;
}

.pricing .pricing-tab-content {
  display: flex;
  gap: 30px;
  justify-content: center;
  align-items: stretch;
}
.pricing .pricing-tab__pane {
  height: auto;
}
.pricing .pricing-tab__pane > .pricing-pane {
  width: 100%;
  height: 100%;
}
.pricing .pricing-pane {
  height: auto;
  background-color: var(--white);
  padding: 4px 4px 40px 4px;
  border-radius: 24px;
  position: relative;
  border: 2px solid var(--white);
}
.pricing .pricing-pane > .pricing-pane {
  width: 100%;
  height: 100%;
  padding: 0;
  border-radius: 0;
  position: static;
  border: none;
}
.pricing .pricing-pane.popular {
  border: 2px solid #ffd748;
}
.pricing .pricing-pane.popular .pricing-pane__header {
  background-color: var(--yellow);
}
.pricing .pricing-pane__label {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 12px 12px 0px 0px;
  padding: 6px 16px;
  background: var(--yellow);
  color: var(--black);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.14px;
}
.pricing .pricing-pane__header {
  text-align: center;
  position: relative;
  background-color: var(--yellow);
  border-radius: 18px;
  background: var(--yellow);
  padding: 31px 30px 32px 30px;
  margin-bottom: 48px;
}
.pricing .pricing-pane__title {
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.24px;
}
.pricing .pricing-pane__subtitle {
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
}
.pricing .pricing-pane__percent {
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  color: #161616;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.14px;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid var(--white-2);
  background: var(--white);
}
.pricing .pricing-pane__info {
  text-align: center;
}
.pricing .pricing-pane__info-price {
  text-align: center;
  margin-bottom: 24px;
}
.pricing .pricing-pane__info-price .price {
  color: var(--gray);
  font-family: "Cambon";
  font-size: 56px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.56px;
}
.pricing .pricing-pane__info-price .price sup {
  font-size: 36px;
}
.pricing .pricing-pane__info-price .gray {
  color: var(--gray);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.16px;
  opacity: 0.3;
}
.pricing .pricing-pane__info p {
  color: var(--gray-2);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
  max-width: 65%;
  margin: 0 auto 30px auto;
  min-height: 42px;
}
.pricing .pricing-pane__info p strong {
  font-weight: 700;
}
.pricing .pricing-pane__info .btn {
  min-width: 170px;
  margin-bottom: 32px;
}
.pricing .pricing-pane__list {
  padding: 0 18px;
}
.pricing .pricing-pane__list ul li {
  color: #8c8b87;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.15px;
  padding-left: 32px;
  position: relative;
}
.pricing .pricing-pane__list ul li::before {
  content: "";
  position: absolute;
  width: 24px;
  height: 24px;
  left: 0;
  top: 0;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.pricing .pricing-pane__list ul li:not(:last-of-type) {
  margin-bottom: 10px;
}

@media screen and (max-width: 1330px) {
  .pricing {
    /* padding: 7.519vw 0 3.008vw 0; */
  }
  .pricing__title {
    margin-bottom: 1.805vw;
  }
  .pricing__title h2 {
    font-size: 4.211vw;
    letter-spacing: -0.042vw;
  }
  .pricing-tabs {
    gap: 0.602vw;
    margin: 0 auto 5.414vw auto;
    border-radius: 75.113vw;
    padding: 0.602vw;
  }
  .pricing-tabs .pricing-tab {
    padding: 0.752vw 1.805vw;
    font-size: 1.278vw;
    border-radius: 75.113vw;
  }
  .pricing .pricing-tab-content {
    gap: 2.256vw;
  }
  .pricing .pricing-pane {
    padding: 0.301vw 0.301vw 3.008vw 0.301vw;
    border-radius: 1.805vw;
    border: 0.15vw solid var(--white);
  }
  .pricing .pricing-pane.popular {
    border: 0.15vw solid #ffd748;
  }
  .pricing .pricing-pane__label {
    border-radius: 0.902vw 0.902vw 0vw 0vw;
    padding: 0.451vw 1.203vw;
    font-size: 1.053vw;
    letter-spacing: -0.011vw;
  }
  .pricing .pricing-pane__header {
    border-radius: 1.353vw;
    padding: 2.331vw 2.256vw 2.406vw 2.256vw;
    margin-bottom: 3.609vw;
  }
  .pricing .pricing-pane__title {
    font-size: 1.805vw;
    letter-spacing: -0.018vw;
  }
  .pricing .pricing-pane__subtitle {
    font-size: 1.053vw;
    letter-spacing: -0.011vw;
  }
  .pricing .pricing-pane__percent {
    bottom: -0.977vw;
    font-size: 1.053vw;
    letter-spacing: -0.011vw;
    padding: 0.15vw 0.752vw;
    border-radius: 75.113vw;
  }
  .pricing .pricing-pane__info-price {
    margin-bottom: 1.805vw;
  }
  .pricing .pricing-pane__info-price .price {
    font-size: 4.211vw;
    letter-spacing: -0.042vw;
  }
  .pricing .pricing-pane__info-price .price sup {
    font-size: 2.707vw;
  }
  .pricing .pricing-pane__info-price .gray {
    font-size: 1.203vw;
    letter-spacing: -0.012vw;
  }
  .pricing .pricing-pane__info p {
    font-size: 1.053vw;
    letter-spacing: -0.011vw;
    margin: 0 auto 2.256vw auto;
    min-height: 3.158vw;
  }
  .pricing .pricing-pane__info .btn {
    min-width: 12.782vw;
    margin-bottom: 2.406vw;
  }
  .pricing .pricing-pane__list {
    padding: 0 1.353vw;
  }
  .pricing .pricing-pane__list ul li {
    font-size: 1.128vw;
    letter-spacing: -0.011vw;
    padding-left: 2.406vw;
  }
  .pricing .pricing-pane__list ul li::before {
    width: 1.805vw;
    height: 1.805vw;
  }
  .pricing .pricing-pane__list ul li:not(:last-of-type) {
    margin-bottom: 0.752vw;
  }
}
@media screen and (max-width: 1280px) {
  .pricing {
    /* padding: 6.5625vw 0 3.125vw 0; */
  }
  .pricing__title {
    margin-bottom: 1.5625vw;
  }
  .pricing__title h2 {
    font-size: 3.2813vw;
    line-height: 1.1;
    letter-spacing: -0.0438vw;
  }
  .pricing-tabs {
    gap: 0.625vw;
    margin: 0 auto 6.3281vw auto;
    border-radius: 78.0469vw;
    padding: 0.625vw;
  }
  .pricing-tabs .pricing-tab {
    padding: 0.625vw 2.0313vw;
    font-size: 1.3281vw;
    line-height: 1.5;
    border-radius: 78.0469vw;
  }
  .pricing .pricing-tab-content {
    gap: 1.5625vw;
  }
  .pricing .pricing-pane {
    padding: 0.3125vw 0.3125vw 3.125vw 0.3125vw;
    border-radius: 1.875vw;
    border: 0.1563vw solid var(--white);
  }
  .pricing .pricing-pane.popular {
    border: 0.1563vw solid #ffd748;
  }
  .pricing .pricing-pane__label {
    width: 100%;
    max-width: 11.0156vw;
    border-radius: 0.9375vw 0.9375vw 0px 0px;
    padding: 0.4688vw 1.25vw;
    font-size: 1.0938vw;
    letter-spacing: -0.0109vw;
  }
  .pricing .pricing-pane__header {
    border-radius: 1.4063vw;
    padding: 1.3281vw 3.2031vw 1.9531vw;
    margin-bottom: 3.125vw;
  }
  .pricing .pricing-pane__title {
    font-size: 1.7188vw;
    letter-spacing: -0.0172vw;
    margin-bottom: 0.3906vw;
  }
  .pricing .pricing-pane__subtitle {
    font-size: 1.0938vw;
    letter-spacing: -0.0109vw;
  }
  .pricing .pricing-pane__percent {
    bottom: -1.0156vw;
    font-size: 1.0938vw;
    letter-spacing: -0.0109vw;
    padding: 0.1563vw 0.7031vw;
    border-radius: 78.0469vw;
  }
  .pricing .pricing-pane__info {
    text-align: center;
  }
  .pricing .pricing-pane__info-price {
    margin-bottom: 2.5781vw;
  }
  .pricing .pricing-pane__info-price .price {
    font-size: 3.5938vw;
    letter-spacing: -0.0438vw;
  }
  .pricing .pricing-pane__info-price .price sup {
    font-size: 2.1094vw;
  }
  .pricing .pricing-pane__info-price .gray {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
    opacity: 0.3;
  }
  .pricing .pricing-pane__info p {
    font-size: 1.0938vw;
    letter-spacing: -0.0109vw;
    max-width: 14.0625vw;
    margin: 0 auto 2.6563vw auto;
    min-height: 3.2813vw;
  }
  .pricing .pricing-pane__info .btn {
    min-width: 13.2813vw;
    margin-bottom: 2.9688vw;
  }
  .pricing .pricing-pane__list {
    padding: 0 0.9375vw;
  }
  .pricing .pricing-pane__list ul li {
    font-size: 1.0938vw;
    letter-spacing: -0.0117vw;
    padding-left: 2.5781vw;
  }
  .pricing .pricing-pane__list ul li::before {
    width: 1.875vw;
    height: 1.875vw;
  }
  .pricing .pricing-pane__list ul li:not(:last-of-type) {
    margin-bottom: 0.9375vw;
  }
}
@media screen and (max-width: 850px) {
  .pricing {
    /* padding: 54px 0 30px 0; */
    /* background-color: var(--beige); */
  }
  .pricing__title {
    margin: 0 auto 6.154vw auto;
    max-width: 70%;
  }
  .pricing__title h2 {
    font-size: 9.231vw;
    letter-spacing: -0.092vw;
    line-height: 150%;
  }
  .pricing-tabs {
    gap: 2.051vw;
    margin: 0 auto 10.769vw auto;
    border-radius: 256.154vw;
    padding: 2.051vw;
    border: 1px solid var(--white-2);
  }
  .pricing-tabs .pricing-tab {
    padding: 2.564vw 6.154vw;
    font-size: 4.359vw;
    border-radius: 999px;
  }
  .pricing .pricing-tab-content {
    gap: 7.692vw;
    flex-direction: column;
  }
  .pricing .pricing-pane {
    padding: 1.026vw 1.026vw 10.256vw 1.026vw;
    border-radius: 4.615vw;
    border: 0.513vw solid var(--white);
  }
  .pricing .pricing-pane.popular {
    border: 0.513vw solid #ffd748;
    margin-top: 15.205vw;
  }
  .pricing .pricing-pane__label {
    border-radius: 3.077vw 3.077vw 0vw 0vw;
    padding: 1.538vw 4.103vw;
    font-size: 3.59vw;
    letter-spacing: -0.036vw;
    max-width: 36.1538vw;
  }
  .pricing .pricing-pane__header {
    border-radius: 4.615vw;
    padding: 7.949vw 7.692vw 8.205vw 7.692vw;
    margin-bottom: 11.538vw;
  }
  .pricing .pricing-pane__title {
    font-size: 6.154vw;
    letter-spacing: -0.062vw;
  }
  .pricing .pricing-pane__subtitle {
    font-size: 3.59vw;
    letter-spacing: -0.036vw;
  }
  .pricing .pricing-pane__percent {
    bottom: -3.333vw;
    font-size: 3.59vw;
    letter-spacing: -0.036vw;
    padding: 0.513vw 2.564vw;
    border-radius: 256.154vw;
  }
  .pricing .pricing-pane__info-price {
    margin-bottom: 6.154vw;
  }
  .pricing .pricing-pane__info-price .price {
    font-size: 14.359vw;
    letter-spacing: -0.144vw;
  }
  .pricing .pricing-pane__info-price .price sup {
    font-size: 9.231vw;
  }
  .pricing .pricing-pane__info-price .gray {
    font-size: 4.103vw;
    letter-spacing: -0.041vw;
  }
  .pricing .pricing-pane__info p {
    font-size: 3.59vw;
    letter-spacing: -0.036vw;
    max-width: 50%;
    margin: 0 auto 8.718vw auto;
    min-height: 10.769vw;
  }
  .pricing .pricing-pane__info .btn {
    min-width: 43.59vw;
    margin-bottom: 8.205vw;
  }
  .pricing .pricing-pane__list {
    padding: 0 4.615vw;
  }
  .pricing .pricing-pane__list ul li {
    font-size: 3.846vw;
    letter-spacing: -0.038vw;
    padding-left: 8.205vw;
  }
  .pricing .pricing-pane__list ul li::before {
    width: 6.154vw;
    height: 6.154vw;
  }
  .pricing .pricing-pane__list ul li:not(:last-of-type) {
    margin-bottom: 2.821vw;
  }
}
.pricing-plan {
  /* background-color: var(--beige); */
  padding-bottom: 73px;
}
.pricing-plan__inner {
  display: flex;
  background-color: var(--dark);
  padding: 6px 39px 6px 6px;
  min-height: 130px;
  border-radius: 24px;
}
.pricing-plan__title {
  background-color: var(--yellow);
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 31px 62px;
}
.pricing-plan__title h2 {
  color: var(--dark);
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.24px;
}
.pricing-plan__title span {
  color: var(--dark);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
}
.pricing-plan__info {
  color: var(--white);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.16px;
  margin: auto auto auto 32px;
}
.pricing-plan__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 32px;
}
.pricing-plan__btn .btn-border {
  background-color: var(--white);
  min-width: 170px;
}
.pricing-plan__btn .btn-border:hover {
  background-color: var(--yellow);
  color: var(--dark);
}

@media screen and (max-width: 1330px) {
  .pricing-plan {
    padding-bottom: 5.489vw;
  }
  .pricing-plan__inner {
    padding: 0.451vw 2.932vw 0.451vw 0.451vw;
    min-height: 9.774vw;
    border-radius: 1.805vw;
  }
  .pricing-plan__title {
    border-radius: 1.353vw;
    padding: 2.331vw 4.662vw;
  }
  .pricing-plan__title h2 {
    font-size: 1.805vw;
    letter-spacing: -0.018vw;
  }
  .pricing-plan__title span {
    font-size: 1.053vw;
    letter-spacing: -0.011vw;
  }
  .pricing-plan__info {
    font-size: 1.203vw;
    letter-spacing: -0.012vw;
    margin: auto auto auto 2.406vw;
  }
  .pricing-plan__btn {
    margin-left: 2.406vw;
  }
  .pricing-plan__btn .btn-border {
    min-width: 12.782vw;
  }
}
@media screen and (max-width: 1280px) {
  .pricing-plan {
    padding-bottom: 8.4375vw;
  }
  .pricing-plan__inner {
    padding: 0.4688vw 2.9688vw 0.4688vw 0.4688vw;
    min-height: 10.1563vw;
    border-radius: 1.875vw;
  }
  .pricing-plan__title {
    border-radius: 1.4063vw;
    padding: 2.4219vw 3.6719vw;
    min-width: 22.5vw;
  }
  .pricing-plan__title h2 {
    font-size: 1.7188vw;
    letter-spacing: -0.0172vw;
  }
  .pricing-plan__title span {
    font-size: 1.0938vw;
    letter-spacing: -0.0109vw;
  }
  .pricing-plan__info {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
    margin: auto auto auto 2.5vw;
  }
  .pricing-plan__btn {
    margin-left: 2.5vw;
  }
  .pricing-plan__btn .btn-border {
    min-width: 13.2813vw;
  }
}
@media screen and (max-width: 850px) {
  .pricing-plan {
    padding-bottom: 15.897vw;
  }
  .pricing-plan__inner {
    flex-direction: column;
    align-items: center;
    padding: 1.538vw 1.538vw 11.795vw 1.538vw;
    min-height: unset;
    border-radius: 6.154vw;
  }
  .pricing-plan__title {
    border-radius: 4.615vw;
    width: 100%;
    padding: 7.949vw;
  }
  .pricing-plan__title h2 {
    font-size: 6.154vw;
    letter-spacing: -0.062vw;
  }
  .pricing-plan__title span {
    font-size: 3.59vw;
    letter-spacing: -0.036vw;
  }
  .pricing-plan__info {
    font-size: 4.103vw;
    text-align: center;
    letter-spacing: -0.041vw;
    margin: 9.744vw auto 6.154vw auto;
    max-width: 70%;
  }
  .pricing-plan__btn {
    margin-left: 0;
  }
  .pricing-plan__btn .btn-border {
    min-width: 43.59vw;
  }
}
.pricing-table {
  background-color: var(--beige);
  padding-bottom: 157px;
}
.pricing-table__title {
  color: var(--dark);
  text-align: center;
  margin-bottom: 60px;
}
.pricing-table__title h2 {
  font-family: "Cambon";
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.48px;
}
.pricing-table__inner table {
  border-collapse: collapse;
  width: 100%;
}
.pricing-table__inner table thead tr {
  height: 54px;
}
.pricing-table__inner table thead th {
  color: var(--01-primary-text, #161616);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  /* 30px */
  letter-spacing: -0.2px;
  background-color: var(--white);
}
.pricing-table__inner table thead th:nth-child(1) {
  width: 25%;
  background-color: transparent;
}
.pricing-table__inner table thead th:nth-child(2) {
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
}
.pricing-table__inner table thead th:last-of-type {
  border-top-right-radius: 999px;
  border-bottom-right-radius: 999px;
}
.pricing-table__inner table thead th:not(:first-of-type) {
  width: 15%;
}
.pricing-table__inner table tbody tr {
  height: 80px;
  border-bottom: 1px solid rgba(22, 22, 22, 0.0666666667);
}
.pricing-table__inner table tbody tr td:nth-child(1) {
  width: 25%;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.18px;
}
.pricing-table__inner table tbody tr td:not(:first-of-type) {
  width: 15%;
  text-align: center;
  padding: 0 15px;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.18px;
}
.pricing-table__inner table tbody tr td:not(:first-of-type) img {
  margin: 0 auto;
  width: 32px;
  height: 32px;
  object-fit: contain;
  object-position: center;
}
.pricing-table__inner table tbody tr td span {
  color: var(--dark);
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.15px;
}
.pricing-table__inner table tbody tr td .empty {
  opacity: 0.2;
  background-color: var(--dark);
  width: 13px;
  height: 2px;
  margin: auto;
}

@media screen and (max-width: 1330px) {
  .pricing-table {
    padding-bottom: 11.805vw;
  }
  .pricing-table__title {
    margin-bottom: 4.511vw;
  }
  .pricing-table__title h2 {
    font-size: 3.609vw;
    letter-spacing: -0.036vw;
  }
  .pricing-table__inner table thead tr {
    height: 4.06vw;
  }
  .pricing-table__inner table thead th {
    font-size: 1.504vw;
    letter-spacing: -0.015vw;
  }
  .pricing-table__inner table tbody tr {
    height: 6.015vw;
  }
  .pricing-table__inner table tbody tr td:nth-child(1) {
    font-size: 1.353vw;
    letter-spacing: -0.014vw;
  }
  .pricing-table__inner table tbody tr td:not(:first-of-type) {
    padding: 0 1.128vw;
    font-size: 1.353vw;
    letter-spacing: -0.014vw;
  }
  .pricing-table__inner table tbody tr td:not(:first-of-type) img {
    width: 2.406vw;
    height: 2.406vw;
  }
  .pricing-table__inner table tbody tr td span {
    font-size: 1.128vw;
    letter-spacing: -0.011vw;
  }
  .pricing-table__inner table tbody tr td .empty {
    width: 0.977vw;
    height: 0.15vw;
  }
}
@media screen and (max-width: 1280px) {
  .pricing-table {
    padding-bottom: 9.375vw;
  }
  .pricing-table__title {
    margin-bottom: 4.4531vw;
  }
  .pricing-table__title h2 {
    font-size: 2.9688vw;
    line-height: 1.2;
    letter-spacing: -0.0297vw;
  }
  .pricing-table__inner table thead tr {
    height: 4.2188vw;
  }
  .pricing-table__inner table thead th {
    font-size: 1.5625vw;
    letter-spacing: -0.0156vw;
  }
  .pricing-table__inner table thead th:nth-child(2) {
    border-top-left-radius: 78.0469vw;
    border-bottom-left-radius: 78.0469vw;
  }
  .pricing-table__inner table thead th:last-of-type {
    border-top-right-radius: 78.0469vw;
    border-bottom-right-radius: 78.0469vw;
  }
  .pricing-table__inner table tbody tr {
    height: 6.25vw;
    border-bottom: 1px solid rgba(22, 22, 22, 0.0666666667);
  }
  .pricing-table__inner table tbody tr td:nth-child(1) {
    font-size: 1.4063vw;
    letter-spacing: -0.0141vw;
  }
  .pricing-table__inner table tbody tr td:not(:first-of-type) {
    padding: 0 1.1719vw;
    font-size: 1.4063vw;
    line-height: 150%;
    letter-spacing: -0.0141vw;
  }
  .pricing-table__inner table tbody tr td:not(:first-of-type) img {
    width: 2.5vw;
    height: 2.5vw;
  }
  .pricing-table__inner table tbody tr td span {
    font-size: 1.1719vw;
    letter-spacing: -0.0117vw;
  }
  .pricing-table__inner table tbody tr td .empty {
    width: 1.0156vw;
    height: 0.1563vw;
  }
}
@media screen and (max-width: 850px) {
  .pricing-table {
    padding-bottom: 33.077vw;
  }
  .pricing-table__title {
    margin-bottom: 12.821vw;
  }
  .pricing-table__title h2 {
    font-size: 8.205vw;
    letter-spacing: -0.082vw;
  }
  .pricing-table__inner {
    max-width: calc(100% + 5.1282vw);
    overflow: scroll;
    margin-right: -5.1282vw;
  }
  .pricing-table__inner table {
    width: max-content;
  }
  .pricing-table__inner table thead tr {
    height: 13.846vw;
  }
  .pricing-table__inner table thead th {
    font-size: 4.615vw;
    letter-spacing: -0.046vw;
  }
  .pricing-table__inner table thead th:nth-child(1) {
    width: 31.667vw;
    padding-right: 5.615vw;
  }
  .pricing-table__inner table thead th:not(:first-of-type) {
    width: 40.967vw;
  }
  .pricing-table__inner table tbody tr {
    height: 20.513vw;
  }
  .pricing-table__inner table tbody tr td:nth-child(1) {
    width: 31.667vw;
    font-size: 4.103vw;
    letter-spacing: -0.041vw;
    padding-right: 5.615vw;
  }
  .pricing-table__inner table tbody tr td:not(:first-of-type) {
    width: 40.967vw;
    padding: 0 3.846vw;
    font-size: 4.615vw;
    letter-spacing: -0.046vw;
  }
  .pricing-table__inner table tbody tr td:not(:first-of-type) img {
    width: 8.205vw;
    height: 8.205vw;
  }
  .pricing-table__inner table tbody tr td span {
    font-size: 3.846vw;
    letter-spacing: -0.038vw;
  }
  .pricing-table__inner table tbody tr td .empty {
    width: 3.333vw;
    height: 0.513vw;
  }
}
.first-screen-bfcm {
  background-color: var(--yellow);
  position: relative;
  z-index: 2;
}
.first-screen-bfcm::before {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  bottom: calc(100% - 10px);
  width: 100%;
  height: 100%;
  background-color: var(--yellow);
}
.first-screen-bfcm .first-screen-bfcm__inner {
  padding: 32px 0 42px;
}
.first-screen-bfcm .first-screen-bfcm__wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 2;
  min-height: 726px;
}
.first-screen-bfcm .first-screen-bfcm__content {
  width: 617px;
}
.first-screen-bfcm .first-screen-bfcm__content-title {
  margin-bottom: 20px;
}
.first-screen-bfcm .first-screen-bfcm__content-title h2 {
  font-family: "Cambon";
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.48px;
  color: var(--dark);
}
.first-screen-bfcm .first-screen-bfcm__content-title h2 span {
  position: relative;
  z-index: 2;
}
.first-screen-bfcm .first-screen-bfcm__content-title h2 span::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -5px;
  z-index: -1;
  width: 100%;
  height: 13px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.first-screen-bfcm .first-screen-bfcm__content-text {
  width: 550px;
  margin-bottom: 32px;
}
.first-screen-bfcm .first-screen-bfcm__content-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}
.first-screen-bfcm .first-screen-bfcm__content-message {
  font-size: 18px;
  margin-top: 42px;
  letter-spacing: -1px;
}
.first-screen-bfcm .first-screen-bfcm__content-message a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.first-screen-bfcm .first-screen-bfcm__content-message a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.first-screen-bfcm .first-screen-bfcm__content-message a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .first-screen-bfcm .first-screen-bfcm__content-message a:hover::before {
    transform: translateX(3px);
  }
  .first-screen-bfcm .first-screen-bfcm__content-message a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .first-screen-bfcm .first-screen-bfcm__content-message a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-message a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-message a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .first-screen-bfcm .first-screen-bfcm__content-message a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .first-screen-bfcm .first-screen-bfcm__content-message a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-message a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .first-screen-bfcm .first-screen-bfcm__content-message a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-message a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-message a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.first-screen-bfcm .first-screen-bfcm__image {
  position: absolute;
  right: 19px;
  bottom: 0;
  width: 690px;
  height: 750px;
}
.first-screen-bfcm .first-screen-bfcm__image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.first-screen-bfcm .first-screen-bfcm__offer {
  background-color: var(--dark);
  border-radius: 24px;
  padding: 8px 82px 8px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.first-screen-bfcm .first-screen-bfcm__offer-wrapper {
  display: flex;
  align-items: center;
}
.first-screen-bfcm .first-screen-bfcm__offer-img {
  width: 275px;
  height: 184px;
  border-radius: 18px;
  overflow: hidden;
  flex: 0 0 auto;
  margin-right: 42px;
}
.first-screen-bfcm .first-screen-bfcm__offer-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.first-screen-bfcm .first-screen-bfcm__offer-content {
  width: 430px;
}
.first-screen-bfcm .first-screen-bfcm__offer-content-title h3 {
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.3px;
  font-size: 30px;
  color: var(--white);
}
.first-screen-bfcm .first-screen-bfcm__offer-content-text {
  font-size: 20px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.2px;
  color: var(--white);
}
.first-screen-bfcm .first-screen-bfcm__offer-button a {
  font-family: "Cambon";
  font-weight: 700;
  font-size: 34px;
  line-height: 1.1;
  letter-spacing: -0.34px;
  color: var(--yellow);
  position: relative;
  z-index: 2;
}
.first-screen-bfcm .first-screen-bfcm__offer-button a:hover::before {
  width: 0;
}
.first-screen-bfcm .first-screen-bfcm__offer-button a::before {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 2px;
  background-color: var(--yellow);
  transition: all 0.3s linear;
}

@media screen and (max-width: 1330px) {
  .first-screen-bfcm .first-screen-bfcm__inner {
    padding: 2.406vw 0 3.1579vw;
  }
  .first-screen-bfcm .first-screen-bfcm__wrapper {
    min-height: 54.5865vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content {
    width: 46.391vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title {
    margin-bottom: 1.5038vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title h2 {
    font-size: 3.609vw;
    letter-spacing: -0.0361vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title h2 span::before {
    bottom: -0.3759vw;
    height: 0.9774vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-text {
    width: 41.3534vw;
    margin-bottom: 2.406vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-buttons {
    gap: 1.203vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-message {
    font-size: 1.3534vw;
    margin-top: 3.1579vw;
  }
  .first-screen-bfcm .first-screen-bfcm__image {
    right: 1.4286vw;
    width: 51.8797vw;
    height: 56.391vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer {
    border-radius: 1.8045vw;
    padding: 0.6015vw 6.1654vw 0.6015vw 0.6015vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-img {
    width: 20.6767vw;
    height: 13.8346vw;
    border-radius: 1.3534vw;
    margin-right: 3.1579vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content {
    width: 32.3308vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content-title h3 {
    letter-spacing: -0.0226vw;
    font-size: 2.2556vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content-text {
    font-size: 1.5038vw;
    letter-spacing: -0.015vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-button a {
    font-size: 2.5564vw;
    letter-spacing: -0.0256vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-button a::before {
    height: 0.1504vw;
  }
}
@media screen and (max-width: 1280px) {
  .first-screen-bfcm .first-screen-bfcm__inner {
    padding: 0.7031vw 0 2.3438vw;
  }
  .first-screen-bfcm .first-screen-bfcm__wrapper {
    min-height: 39.9219vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content {
    width: 31.25vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title {
    margin-bottom: 1.4844vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title h2 {
    font-size: 2.6563vw;
    line-height: 1.1;
    letter-spacing: -0.0266vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title h2 span::before {
    bottom: -0.1563vw;
    height: 0.8594vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-text {
    width: 30.4688vw;
    margin-bottom: 1.875vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-buttons {
    gap: 1.25vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-message {
    font-size: 1.4063vw;
    margin-top: 2.5vw;
  }
  .first-screen-bfcm .first-screen-bfcm__image {
    right: 4.2188vw;
    width: 38.3594vw;
    height: 40.625vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer {
    border-radius: 1.875vw;
    padding: 0.625vw 6.4063vw 0.625vw 0.625vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-img {
    width: 18.125vw;
    height: 12.0313vw;
    border-radius: 1.4063vw;
    margin-right: 2.3438vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content {
    width: 26.3438vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content-title h3 {
    letter-spacing: -0.0188vw;
    font-size: 1.875vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content-text {
    font-size: 1.25vw;
    letter-spacing: -0.0125vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-button a {
    font-size: 1.875vw;
    letter-spacing: -0.0188vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-button a::before {
    height: 1px;
  }
}
@media screen and (max-width: 850px) {
  .first-screen-bfcm {
    background-color: transparent;
    position: relative;
    z-index: 2;
  }
  .first-screen-bfcm::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 42.3077vw);
    background-color: var(--yellow);
  }
  .first-screen-bfcm .first-screen-bfcm__inner {
    padding: 12.0513vw 0 0;
  }
  .first-screen-bfcm .first-screen-bfcm__wrapper {
    align-items: flex-start;
    min-height: 0;
    padding-bottom: 114.6154vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content {
    width: 100%;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title {
    margin-bottom: 5.1282vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title h2 {
    font-size: 9.2308vw;
    line-height: 1.1;
    letter-spacing: -0.0923vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-title h2 span::before {
    bottom: 0;
    height: 2.0513vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-text {
    width: 100%;
    margin-bottom: 6.1538vw;
  }
  .first-screen-bfcm .first-screen-bfcm__content-buttons {
    gap: 4.1026vw;
  }
  .first-screen-bfcm
    .first-screen-bfcm__content
    .first-screen-home__content-button {
    width: 100%;
  }
  .first-screen-bfcm
    .first-screen-bfcm__content
    .first-screen-home__content-button
    .btn {
    padding: 4.6154vw 3.1538vw;
  }
  .first-screen-bfcm
    .first-screen-bfcm__content
    .first-screen-home__content-button
    .btn,
  .first-screen-bfcm
    .first-screen-bfcm__content
    .first-screen-home__content-button
    .btn-border {
    width: 100%;
  }
  .first-screen-bfcm .first-screen-bfcm__content-message {
    font-size: 4.1026vw;
    margin-top: 6.1538vw;
  }
  .first-screen-bfcm .first-screen-bfcm__image {
    right: 50%;
    bottom: 0;
    transform: translateX(50%);
    width: 100vw;
    height: 108.7179vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer {
    width: 89.7436vw;
    margin: 0 auto;
    border-radius: 6.1538vw;
    padding: 2.0513vw 2.0513vw 10.2564vw 2.0513vw;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-wrapper {
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-img {
    width: 100%;
    height: 57.9487vw;
    border-radius: 4.6154vw;
    margin-right: 0;
    margin-bottom: 6.6667vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content {
    width: 100%;
    margin-bottom: 6.4103vw;
    text-align: center;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content-title {
    margin-bottom: 1.2821vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content-title h3 {
    letter-spacing: -0.0564vw;
    font-size: 5.641vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-content-text {
    font-size: 4.1026vw;
    letter-spacing: -0.041vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-button {
    text-align: center;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-button a {
    font-size: 5.1282vw;
    letter-spacing: -0.0513vw;
  }
  .first-screen-bfcm .first-screen-bfcm__offer-button a::before {
    height: 1px;
  }
}
.must-have-info .must-have-info__inner {
  padding: 96px 0 125px;
}
.must-have-info .must-have-info__header {
  width: 700px;
  margin: 0 auto 66px;
  text-align: center;
}
.must-have-info .must-have-info__header-title {
  margin-bottom: 21px;
}
.must-have-info .must-have-info__wrapper {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
  width: 100%;
  min-height: 730px;
}
.must-have-info .must-have-info__accordion {
  width: 520px;
}
.must-have-info .must-have-info__accordion .accordion {
  width: 100%;
  border-bottom: 1px solid var(--white-2);
  padding-bottom: 29px;
}
.must-have-info .must-have-info__accordion .accordion:not(:first-child) {
  margin-top: 34px;
}
.must-have-info
  .must-have-info__accordion
  .accordion.open
  .accordion-header::before {
  transform: rotate(-180deg);
}
.must-have-info .must-have-info__accordion .accordion .accordion-header {
  font-weight: 500;
  line-height: 1.5;
  font-size: 26px;
  letter-spacing: -0.26px;
  color: var(--dark);
  position: relative;
  z-index: 2;
  padding-right: 113px;
  cursor: pointer;
}
.must-have-info
  .must-have-info__accordion
  .accordion
  .accordion-header::before {
  content: "";
  position: absolute;
  top: 7px;
  right: 12px;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.must-have-info .must-have-info__accordion .accordion .accordion-content {
  display: none;
  margin-top: 18px;
}
.must-have-info .must-have-info__accordion .accordion .accordion-content__text {
  margin-bottom: 29px;
}
.must-have-info
  .must-have-info__accordion
  .accordion
  .accordion-content__list
  ul
  li {
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  letter-spacing: -0.18px;
  color: var(--gray);
  position: relative;
  z-index: 2;
  padding-left: 28px;
}
.must-have-info
  .must-have-info__accordion
  .accordion
  .accordion-content__list
  ul
  li::before {
  content: "";
  position: absolute;
  top: 11px;
  left: 10px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--gray);
}
.must-have-info
  .must-have-info__accordion
  .accordion
  .accordion-content__button {
  display: flex;
  justify-content: flex-start;
  margin-top: 29px;
}
.must-have-info .must-have-info__accordion .accordion .accordion-content__img {
  display: none;
}
.must-have-info .must-have-info__gallery {
  width: 630px;
  height: 730px;
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 2;
}
.must-have-info .must-have-info__gallery ul {
  width: 100%;
  height: 100%;
}
.must-have-info .must-have-info__gallery ul li {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.4s linear;
  opacity: 0;
}
.must-have-info .must-have-info__gallery ul li.show {
  opacity: 1;
}
.must-have-info .must-have-info__gallery ul li.hide {
  opacity: 0;
}
.must-have-info .must-have-info__gallery img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .must-have-info .must-have-info__inner {
    padding: 7.218vw 0 9.3985vw;
  }
  .must-have-info .must-have-info__header {
    width: 52.6316vw;
    margin: 0 auto 4.9624vw;
  }
  .must-have-info .must-have-info__header-title {
    margin-bottom: 1.5789vw;
  }
  .must-have-info .must-have-info__wrapper {
    min-height: 54.8872vw;
  }
  .must-have-info .must-have-info__accordion {
    width: 39.0977vw;
  }
  .must-have-info .must-have-info__accordion .accordion {
    padding-bottom: 2.1805vw;
  }
  .must-have-info .must-have-info__accordion .accordion:not(:first-child) {
    margin-top: 2.5564vw;
  }
  .must-have-info .must-have-info__accordion .accordion .accordion-header {
    font-size: 1.9549vw;
    letter-spacing: -0.0195vw;
    padding-right: 8.4962vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-header::before {
    top: 0.5263vw;
    right: 0.9023vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .must-have-info .must-have-info__accordion .accordion .accordion-content {
    margin-top: 1.3534vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__text {
    margin-bottom: 2.1805vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__list
    ul
    li {
    font-size: 1.3534vw;
    letter-spacing: -0.0135vw;
    padding-left: 2.1053vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__list
    ul
    li::before {
    top: 0.8271vw;
    left: 0.7519vw;
    width: 0.5263vw;
    height: 0.5263vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__button {
    margin-top: 2.1805vw;
  }
  .must-have-info .must-have-info__gallery {
    width: 47.3684vw;
    height: 54.8872vw;
    top: 3.7594vw;
  }
}
@media screen and (max-width: 1280px) {
  .must-have-info .must-have-info__inner {
    padding: 7.2656vw 0 8.2813vw;
  }
  .must-have-info .must-have-info__header {
    width: 44.5313vw;
    margin: 0 auto 6.0156vw;
  }
  .must-have-info .must-have-info__header-title {
    margin-bottom: 1.0938vw;
  }
  .must-have-info .must-have-info__wrapper {
    min-height: 45.9375vw;
  }
  .must-have-info .must-have-info__accordion {
    width: 32.8125vw;
  }
  .must-have-info .must-have-info__accordion .accordion {
    padding-bottom: 2.5781vw;
  }
  .must-have-info .must-have-info__accordion .accordion:not(:first-child) {
    margin-top: 1.9531vw;
  }
  .must-have-info .must-have-info__accordion .accordion .accordion-header {
    font-size: 1.4063vw;
    letter-spacing: -0.0141vw;
    padding-right: 2.9688vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-header::before {
    top: 0;
    right: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
  .must-have-info .must-have-info__accordion .accordion .accordion-content {
    margin-top: 2.2656vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__text {
    margin-bottom: 1.7969vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__list
    ul
    li {
    font-size: 1.1719vw;
    letter-spacing: -0.0117vw;
    padding-left: 1.7969vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__list
    ul
    li::before {
    top: 0.7813vw;
    left: 0.625vw;
    width: 0.4688vw;
    height: 0.4688vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__button {
    margin-top: 1.9531vw;
  }
  .must-have-info .must-have-info__gallery {
    width: 39.8438vw;
    height: 45.9375vw;
    top: 5.7031vw;
  }
}
@media screen and (max-width: 850px) {
  .must-have-info .must-have-info__inner {
    padding: 20.5128vw 0 23.0769vw;
  }
  .must-have-info .must-have-info__header {
    width: 100%;
    margin: 0 auto 4.8718vw;
  }
  .must-have-info .must-have-info__header-title {
    width: 82.0513vw;
    margin: 0 auto 4.8718vw;
  }
  .must-have-info .must-have-info__wrapper {
    align-items: flex-start;
    min-height: 0;
  }
  .must-have-info .must-have-info__accordion {
    width: 100%;
  }
  .must-have-info .must-have-info__accordion .accordion {
    padding-bottom: 6.9231vw;
  }
  .must-have-info .must-have-info__accordion .accordion:not(:first-child) {
    margin-top: 6.1538vw;
  }
  .must-have-info .must-have-info__accordion .accordion .accordion-header {
    font-size: 5.1282vw;
    letter-spacing: -0.0513vw;
    padding-right: 10.7692vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-header::before {
    top: 0.5128vw;
    right: 0px;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .must-have-info .must-have-info__accordion .accordion .accordion-content {
    display: none;
    margin-top: 6.1538vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__text {
    margin-bottom: 6.1538vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__text.small-text {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__list
    ul
    li {
    font-size: 4.1026vw;
    letter-spacing: -0.041vw;
    padding-left: 6.1538vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__list
    ul
    li::before {
    top: 2.5641vw;
    left: 2.3077vw;
    width: 1.5385vw;
    height: 1.5385vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__button {
    margin-top: 7.1795vw;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__img {
    margin-top: 6.1538vw;
    display: block;
    width: 100%;
    height: auto;
  }
  .must-have-info
    .must-have-info__accordion
    .accordion
    .accordion-content__img
    img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .must-have-info .must-have-info__gallery {
    display: none;
  }
}
.short-info .short-info__inner {
  padding-bottom: 137px;
}
.short-info .short-info__title {
  margin-bottom: 88px;
  text-align: center;
}
.short-info .short-info__wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.short-info .short-info__image {
  width: 630px;
  height: 450px;
  border-radius: 24px;
  overflow: hidden;
  margin-right: 140px;
  flex: 0 0 auto;
}
.short-info .short-info__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.short-info .short-info__content {
  width: 100%;
}
.short-info .short-info__content-text {
  margin-bottom: 22px;
}
.short-info .short-info__content-button {
  margin-bottom: 41px;
}
.short-info .short-info__content-button a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.short-info .short-info__content-button a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.short-info .short-info__content-button a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .short-info .short-info__content-button a:hover::before {
    transform: translateX(3px);
  }
  .short-info .short-info__content-button a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .short-info .short-info__content-button a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .short-info .short-info__content-button a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .short-info .short-info__content-button a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .short-info .short-info__content-button a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .short-info .short-info__content-button a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .short-info .short-info__content-button a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .short-info .short-info__content-button a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .short-info .short-info__content-button a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .short-info .short-info__content-button a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.short-info .short-info__content-info {
  display: flex;
  align-items: center;
}
.short-info .short-info__content-info-img {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  flex: 0 0 auto;
}
.short-info .short-info__content-info-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.short-info .short-info__content-info-name {
  font-weight: 500;
  font-size: 20px;
  color: var(--dark);
  margin-bottom: 9px;
}
.short-info .short-info__content-info-position {
  font-weight: 400;
  font-size: 15px;
  color: var(--dark);
}
.short-info .short-info__content-list {
  margin-top: 49px;
  padding-top: 28px;
  border-top: 1px solid rgba(22, 22, 22, 0.2);
}
.short-info .short-info__content-list .list {
  display: flex;
  align-items: flex-start;
}
.short-info .short-info__content-list .item:not(:first-child) {
  margin-left: 35px;
}
.short-info .short-info__content-list .item-top {
  display: flex;
  align-items: center;
}
.short-info .short-info__content-list .item-top__symbol,
.short-info .short-info__content-list .item-top__number {
  font-family: "Cambon";
  color: var(--dark);
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.32px;
}
.short-info .short-info__content-list .item-title h3 {
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.18px;
  font-size: 18px;
  color: var(--dark);
}

@media screen and (max-width: 1330px) {
  .short-info .short-info__inner {
    padding-bottom: 10.3008vw;
  }
  .short-info .short-info__title {
    margin-bottom: 6.6165vw;
  }
  .short-info .short-info__image {
    width: 47.3684vw;
    height: 33.8346vw;
    border-radius: 1.8045vw;
    margin-right: 10.5263vw;
  }
  .short-info .short-info__content-text {
    margin-bottom: 1.6541vw;
  }
  .short-info .short-info__content-button {
    margin-bottom: 3.0827vw;
  }
  .short-info .short-info__content-info-img {
    width: 4.0602vw;
    height: 4.0602vw;
    margin-right: 1.203vw;
  }
  .short-info .short-info__content-info-name {
    font-size: 1.5038vw;
    margin-bottom: 0.6767vw;
  }
  .short-info .short-info__content-info-position {
    font-size: 1.1278vw;
  }
  .short-info .short-info__content-list {
    margin-top: 3.6842vw;
    padding-top: 2.1053vw;
  }
  .short-info .short-info__content-list .item:not(:first-child) {
    margin-left: 2.6316vw;
  }
  .short-info .short-info__content-list .item-top__symbol,
  .short-info .short-info__content-list .item-top__number {
    font-size: 2.406vw;
    letter-spacing: -0.0241vw;
  }
  .short-info .short-info__content-list .item-title h3 {
    letter-spacing: -0.0135vw;
    font-size: 1.3534vw;
  }
}
@media screen and (max-width: 1280px) {
  .short-info .short-info__inner {
    padding-bottom: 9.375vw;
  }
  .short-info .short-info__title {
    margin-bottom: 5.7813vw;
  }
  .short-info .short-info__image {
    width: 39.8438vw;
    height: 28.5156vw;
    border-radius: 1.875vw;
    margin-right: 7.0313vw;
  }
  .short-info .short-info__content-text {
    margin-bottom: 1.25vw;
  }
  .short-info .short-info__content-button {
    margin-bottom: 2.3438vw;
  }
  .short-info .short-info__content-info-img {
    width: 4.2188vw;
    height: 4.2188vw;
    margin-right: 1.25vw;
  }
  .short-info .short-info__content-info-name {
    font-size: 1.4063vw;
    margin-bottom: 0.3125vw;
  }
  .short-info .short-info__content-info-position {
    font-size: 1.1719vw;
  }
  .short-info .short-info__content-list {
    margin-top: 2.4219vw;
    padding-top: 1.5625vw;
  }
  .short-info .short-info__content-list .item:not(:first-child) {
    margin-left: 2.0313vw;
  }
  .short-info .short-info__content-list .item-top__symbol,
  .short-info .short-info__content-list .item-top__number {
    font-size: 1.875vw;
    letter-spacing: -0.0188vw;
  }
  .short-info .short-info__content-list .item-title h3 {
    letter-spacing: -0.0125vw;
    font-size: 1.25vw;
  }
}
@media screen and (max-width: 850px) {
  .short-info .short-info__inner {
    padding-bottom: 23.0769vw;
  }
  .short-info .short-info__title {
    margin-bottom: 7.4359vw;
  }
  .short-info .short-info__wrapper {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  }
  .short-info .short-info__image {
    width: 100%;
    height: 64.1026vw;
    border-radius: 3.3333vw;
    margin-right: 0;
    margin-bottom: 6.1538vw;
  }
  .short-info .short-info__content {
    width: 100%;
  }
  .short-info .short-info__content-text {
    margin-bottom: 6.1538vw;
  }
  .short-info .short-info__content-text.small-text {
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
  }
  .short-info .short-info__content-button {
    margin-bottom: 8.2051vw;
  }
  .short-info .short-info__content-info-img {
    width: 13.8462vw;
    height: 13.8462vw;
    margin-right: 4.1026vw;
  }
  .short-info .short-info__content-info-name {
    font-size: 4.6154vw;
    margin-bottom: 1.0256vw;
  }
  .short-info .short-info__content-info-position {
    font-size: 3.5897vw;
  }
  .short-info .short-info__content-list {
    margin-top: 12.3077vw;
    padding-top: 4.6154vw;
  }
  .short-info .short-info__content-list .item:not(:first-child) {
    margin-left: 7.9487vw;
  }
  .short-info .short-info__content-list .item-top__symbol,
  .short-info .short-info__content-list .item-top__number {
    font-size: 5.641vw;
    letter-spacing: -0.0564vw;
  }
  .short-info .short-info__content-list .item-title {
    margin-top: 1.2821vw;
  }
  .short-info .short-info__content-list .item-title h3 {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
}
.enterprise-info {
  padding: 0 30px;
}
.enterprise-info .enterprise-info__inner {
  border-radius: 24px;
  background-color: var(--beige);
  padding: 117px 0 145px;
}
.enterprise-info .enterprise-info__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 90px;
}
.enterprise-info .enterprise-info__content {
  width: 493px;
}
.enterprise-info .enterprise-info__content-title {
  margin-bottom: 32px;
}
.enterprise-info .enterprise-info__content-title h3 span {
  position: relative;
  z-index: 2;
}
.enterprise-info .enterprise-info__content-title h3 span::before {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  bottom: -6px;
  width: 100%;
  height: 13px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.enterprise-info .enterprise-info__content-text {
  margin-bottom: 32px;
}
.enterprise-info .enterprise-info__content-button {
  display: flex;
  justify-content: flex-start;
}
.enterprise-info .enterprise-info__image {
  width: 630px;
  height: 450px;
  border-radius: 24px;
  overflow: hidden;
  flex: 0 0 auto;
}
.enterprise-info .enterprise-info__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.enterprise-info .enterprise-info__list .list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 30px;
}
.enterprise-info .enterprise-info__list .item .item-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 31px;
  margin-left: 30px;
}
.enterprise-info .enterprise-info__list .item .item-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.enterprise-info .enterprise-info__list .item .item-content {
  padding: 0 24px 0;
}
.enterprise-info .enterprise-info__list .item .item-content__title {
  margin-bottom: 21px;
}
.enterprise-info .enterprise-info__list .item .item-content__title h3 {
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -0.2px;
  font-size: 20px;
  color: var(--dark);
}
.enterprise-info .enterprise-info__list .item .item-content__text {
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.198px;
  font-size: 18px;
  color: var(--gray);
}

@media screen and (max-width: 1330px) {
  .enterprise-info {
    padding: 0 2.2556vw;
  }
  .enterprise-info .enterprise-info__inner {
    border-radius: 1.8045vw;
    padding: 8.797vw 0 10.9023vw;
  }
  .enterprise-info .enterprise-info__wrapper {
    margin-bottom: 6.7669vw;
  }
  .enterprise-info .enterprise-info__content {
    width: 37.0677vw;
  }
  .enterprise-info .enterprise-info__content-title {
    margin-bottom: 2.406vw;
  }
  .enterprise-info .enterprise-info__content-title h3 span::before {
    bottom: -0.4511vw;
    height: 0.9774vw;
  }
  .enterprise-info .enterprise-info__content-text {
    margin-bottom: 2.406vw;
  }
  .enterprise-info .enterprise-info__image {
    width: 47.3684vw;
    height: 33.8346vw;
    border-radius: 1.8045vw;
  }
  .enterprise-info .enterprise-info__list .list {
    grid-gap: 2.2556vw;
  }
  .enterprise-info .enterprise-info__list .item .item-icon {
    width: 3.609vw;
    height: 3.609vw;
    margin-bottom: 2.3308vw;
    margin-left: 2.2556vw;
  }
  .enterprise-info .enterprise-info__list .item .item-content {
    padding: 0 1.8045vw 0;
  }
  .enterprise-info .enterprise-info__list .item .item-content__title {
    margin-bottom: 1.5789vw;
  }
  .enterprise-info .enterprise-info__list .item .item-content__title h3 {
    letter-spacing: -0.015vw;
    font-size: 1.5038vw;
  }
  .enterprise-info .enterprise-info__list .item .item-content__text {
    letter-spacing: -0.0149vw;
    font-size: 1.3534vw;
  }
}
@media screen and (max-width: 1280px) {
  .enterprise-info {
    padding: 0 2.3438vw;
  }
  .enterprise-info .enterprise-info__inner {
    border-radius: 1.875vw;
    padding: 7.8125vw 0 7.0313vw;
  }
  .enterprise-info .enterprise-info__wrapper {
    margin-bottom: 5.3906vw;
  }
  .enterprise-info .enterprise-info__content {
    width: 32.8906vw;
  }
  .enterprise-info .enterprise-info__content-title {
    margin-bottom: 2.5vw;
  }
  .enterprise-info .enterprise-info__content-title h3 span::before {
    bottom: -0.4688vw;
    height: 1.0156vw;
  }
  .enterprise-info .enterprise-info__content-text {
    margin-bottom: 2.5vw;
  }
  .enterprise-info .enterprise-info__image {
    width: 39.8438vw;
    height: 28.4375vw;
    border-radius: 1.4844vw;
  }
  .enterprise-info .enterprise-info__list .list {
    grid-gap: 2.3438vw;
  }
  .enterprise-info .enterprise-info__list .item .item-icon {
    width: 3.75vw;
    height: 3.75vw;
    margin-bottom: 1.7188vw;
    margin-left: 1.6406vw;
  }
  .enterprise-info .enterprise-info__list .item .item-content {
    padding: 0 1.25vw 0;
  }
  .enterprise-info .enterprise-info__list .item .item-content__title {
    margin-bottom: 0.9375vw;
  }
  .enterprise-info .enterprise-info__list .item .item-content__title h3 {
    letter-spacing: -0.0141vw;
    font-size: 1.4063vw;
  }
  .enterprise-info .enterprise-info__list .item .item-content__text {
    letter-spacing: -0.0138vw;
    font-size: 1.25vw;
  }
}
@media screen and (max-width: 850px) {
  .enterprise-info {
    padding: 0;
  }
  .enterprise-info .enterprise-info__inner {
    border-radius: 6.1538vw;
    padding: 17.4359vw 0 20.5128vw;
  }
  .enterprise-info .enterprise-info__wrapper {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 13.8462vw;
  }
  .enterprise-info .enterprise-info__content {
    width: 100%;
    margin-bottom: 8.2051vw;
  }
  .enterprise-info .enterprise-info__content-title {
    margin-bottom: 4.6154vw;
  }
  .enterprise-info .enterprise-info__content-title h3 span::before {
    bottom: 0;
    height: 1.7949vw;
  }
  .enterprise-info .enterprise-info__content-text {
    margin-bottom: 6.1538vw;
  }
  .enterprise-info .enterprise-info__content-text.small-text {
    letter-spacing: -0.0462vw;
    font-size: 4.6154vw;
  }
  .enterprise-info .enterprise-info__image {
    width: 89.7436vw;
    height: 64.1026vw;
    border-radius: 3.3333vw;
  }
  .enterprise-info .enterprise-info__list {
    width: 76.9231vw;
    margin: 0 auto;
  }
  .enterprise-info .enterprise-info__list .list {
    grid-template-columns: 1fr;
    grid-gap: 11.2821vw;
  }
  .enterprise-info .enterprise-info__list .item .item-icon {
    width: 12.3077vw;
    height: 12.3077vw;
    margin-bottom: 5.3846vw;
    margin-left: 0;
  }
  .enterprise-info .enterprise-info__list .item .item-content {
    padding: 0;
  }
  .enterprise-info .enterprise-info__list .item .item-content__title {
    margin-bottom: 4.1026vw;
  }
  .enterprise-info .enterprise-info__list .item .item-content__title h3 {
    letter-spacing: -0.0513vw;
    font-size: 5.1282vw;
  }
  .enterprise-info .enterprise-info__list .item .item-content__text {
    letter-spacing: -0.0451vw;
    font-size: 4.1026vw;
  }
}
.short-about-company .short-about-company__inner {
  padding: 173px 0;
}
.short-about-company .short-about-company__wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  max-width: 1206px;
  margin: 0 auto;
}
.short-about-company .short-about-company__side {
  width: 402px;
  margin-right: 89px;
}
.short-about-company .short-about-company__side-logo {
  width: 215px;
  height: auto;
  margin: 0 auto 59px;
}
.short-about-company .short-about-company__side-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.short-about-company .short-about-company__side-text h3 {
  font-family: "Cambon";
  font-weight: 700;
  font-size: 40px;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: var(--dark);
  text-align: center;
}
.short-about-company .short-about-company__content {
  width: 740px;
}
.short-about-company .short-about-company__content-text {
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: -0.3px;
  font-size: 30px;
  color: var(--dark);
}
.short-about-company .short-about-company__content-text * {
  margin-bottom: 30px;
}
.short-about-company .short-about-company__content-text *:last-child {
  margin-bottom: 0;
}
.short-about-company .short-about-company__content-button {
  margin-top: 34px;
  display: flex;
  justify-content: flex-start;
}

@media screen and (max-width: 1330px) {
  .short-about-company .short-about-company__inner {
    padding: 13.0075vw 0;
  }
  .short-about-company .short-about-company__wrapper {
    max-width: 90.6767vw;
  }
  .short-about-company .short-about-company__side {
    width: 30.2256vw;
    margin-right: 6.6917vw;
  }
  .short-about-company .short-about-company__side-logo {
    width: 16.1654vw;
    margin: 0 auto 4.4361vw;
  }
  .short-about-company .short-about-company__side-text h3 {
    font-size: 3.0075vw;
    letter-spacing: -0.0301vw;
  }
  .short-about-company .short-about-company__content {
    width: 55.6391vw;
  }
  .short-about-company .short-about-company__content-text {
    letter-spacing: -0.0226vw;
    font-size: 2.2556vw;
  }
  .short-about-company .short-about-company__content-text * {
    margin-bottom: 2.2556vw;
  }
  .short-about-company .short-about-company__content-button {
    margin-top: 2.5564vw;
  }
}
@media screen and (max-width: 1280px) {
  .short-about-company .short-about-company__inner {
    padding: 11.25vw 0;
  }
  .short-about-company .short-about-company__wrapper {
    max-width: 75vw;
  }
  .short-about-company .short-about-company__side {
    width: 23.4375vw;
    margin-right: 5.7813vw;
  }
  .short-about-company .short-about-company__side-logo {
    width: 16.7969vw;
    height: auto;
    margin: 0 auto 2.6563vw;
  }
  .short-about-company .short-about-company__side-text h3 {
    font-size: 2.1875vw;
    letter-spacing: -0.0219vw;
  }
  .short-about-company .short-about-company__content {
    width: 46.875vw;
  }
  .short-about-company .short-about-company__content-text {
    letter-spacing: -0.0164vw;
    font-size: 1.6406vw;
  }
  .short-about-company .short-about-company__content-text * {
    margin-bottom: 1.9531vw;
  }
  .short-about-company .short-about-company__content-button {
    margin-top: 2.5vw;
  }
}
@media screen and (max-width: 850px) {
  .short-about-company .short-about-company__inner {
    padding: 23.0769vw 0;
  }
  .short-about-company .short-about-company__wrapper {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    max-width: 100%;
  }
  .short-about-company .short-about-company__side {
    width: 73.0769vw;
    margin: 0 auto 9.7436vw;
  }
  .short-about-company .short-about-company__side-logo {
    width: 55.1282vw;
    margin: 0 auto 9.2308vw;
  }
  .short-about-company .short-about-company__side-text h3 {
    font-size: 7.1795vw;
    line-height: 1.2;
    letter-spacing: -0.0718vw;
  }
  .short-about-company .short-about-company__content {
    width: 100%;
  }
  .short-about-company .short-about-company__content-text {
    letter-spacing: -0.0564vw;
    font-size: 5.641vw;
  }
  .short-about-company .short-about-company__content-text * {
    margin-bottom: 7.6923vw;
  }
  .short-about-company .short-about-company__content-button {
    margin-top: 6.1538vw;
  }
}
.store .store__inner {
  padding-bottom: 186px;
}
.store .store__list .list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 42px 30px;
}
.store .store__list .item {
  width: 100%;
  cursor: pointer;
}
.store .store__list .item.show {
  display: block;
}
.store .store__list .item.hide {
  display: none;
}
.store .store__list .item:hover .item-top::before {
  opacity: 0.4;
}
.store .store__list .item:hover .item-top__text {
  opacity: 1;
}
.store .store__list .item:hover .item-top__text::before {
  width: 100%;
}
.store .store__list .item:hover .item-top__image img {
  transform: scale(1.2);
}
.store .store__list .item .item-top {
  width: 100%;
  height: 262px;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 38px;
  border-radius: 18px;
  overflow: hidden;
  margin-bottom: 12px;
}
.store .store__list .item .item-top::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: var(--black);
  opacity: 0;
  transition: all 0.3s linear;
}
.store .store__list .item .item-top__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
}
.store .store__list .item .item-top__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s linear;
}
.store .store__list .item .item-top__text {
  font-family: "Cambon";
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.22px;
  font-size: 22px;
  color: var(--white);
  text-transform: uppercase;
  position: relative;
  z-index: 2;
  opacity: 0;
  transition: all 0.3s linear;
}
.store .store__list .item .item-top__text::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 1px;
  background: var(--white);
  transition: all 0.3s linear;
}
.store .store__list .item .item-title h3 {
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: -0.16px;
  font-size: 16px;
  color: var(--dark);
}
.store .store__button {
  display: flex;
  justify-content: center;
  margin-top: 82px;
}

@media screen and (max-width: 1330px) {
  .store .store__inner {
    padding-bottom: 13.985vw;
  }
  .store .store__list .list {
    grid-gap: 3.1579vw 2.2556vw;
  }
  .store .store__list .item .item-top {
    height: 19.6992vw;
    padding: 2.8571vw;
    border-radius: 1.3534vw;
    margin-bottom: 0.9023vw;
  }
  .store .store__list .item .item-top__text {
    letter-spacing: -0.0165vw;
    font-size: 1.6541vw;
  }
  .store .store__list .item .item-title h3 {
    letter-spacing: -0.012vw;
    font-size: 1.203vw;
  }
  .store .store__button {
    margin-top: 6.1654vw;
  }
}
@media screen and (max-width: 1280px) {
  .store .store__inner {
    padding-bottom: 7.8125vw;
  }
  .store .store__list .list {
    grid-gap: 1.9531vw;
  }
  .store .store__list .item .item-top {
    height: 16.4063vw;
    padding: 1.5625vw;
    border-radius: 1.1719vw;
    margin-bottom: 0.7813vw;
  }
  .store .store__list .item .item-top__text {
    letter-spacing: -0.0172vw;
    font-size: 1.4063vw;
  }
  .store .store__list .item .item-title h3 {
    letter-spacing: -0.0125vw;
    font-size: 1.0938vw;
  }
  .store .store__button {
    margin-top: 3.9063vw;
  }
}
@media screen and (max-width: 850px) {
  .store .store__inner {
    padding-bottom: 33.8462vw;
  }
  .store .store__list .list {
    grid-template-columns: 1fr;
    grid-gap: 8.2051vw;
  }
  .store .store__list .item .item-top {
    height: 57.4359vw;
    padding: 5.1282vw;
    border-radius: 4.6154vw;
    margin-bottom: 2.5641vw;
  }
  .store .store__list .item .item-top__text {
    letter-spacing: -0.0564vw;
    font-size: 4.6154vw;
  }
  .store .store__list .item .item-title h3 {
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .store .store__button {
    margin-top: 12.3077vw;
  }
}
.toast {
  padding: 10px 0;
  width: 100%;
  background: black;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.toast.toast--color {
  background: #2e685d;
}
.toast.toast--color .toast-content {
  justify-content: center;
  gap: 3px;
}
.toast .toast-wrapper {
  text-decoration: none;
  width: 100%;
}
.toast .toast-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.toast .toast-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ffd748;
  font-family: "Circular Std";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-decoration: none;
  position: relative;
}
.toast .toast-link::after {
  content: "";
  position: relative;
  width: 24px;
  height: 24px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.toast .toast-text {
  color: #fff;
  font-family: "Circular Std";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
}

@media screen and (max-width: 1280px) {
  .toast {
    padding: 0.7813vw 0;
  }
  .toast.toast--color .toast-content {
    gap: 0.2344vw;
  }
  .toast .toast-link {
    gap: 0.625vw;
    font-size: 1.1719vw;
  }
  .toast .toast-link::after {
    width: 1.875vw;
    height: 1.875vw;
  }
  .toast .toast-text {
    font-size: 1.1719vw;
  }
}
@media screen and (max-width: 1150px) {
  .toast {
    padding: 10px 0;
  }
  .toast.toast--color .toast-content {
    gap: 3px;
  }
  .toast .toast-link {
    gap: 8px;
    font-size: 15px;
  }
  .toast .toast-link::after {
    width: 24px;
    height: 24px;
  }
  .toast .toast-text {
    font-size: 15px;
  }
}
@media screen and (max-width: 850px) {
  .toast {
    padding: 2.5641vw 0;
    height: 15.8974vw;
  }
  .toast.toast--color .toast-content,
  .toast .toast-content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5128vw;
  }
  .toast .toast-link {
    gap: 1.7949vw;
    font-size: 2.8205vw;
  }
  .toast .toast-text {
    font-size: 2.8205vw;
  }
}
.get-started {
  margin: 120px 0;
}
.get-started .get-started__wrapper {
  max-width: 1150px;
  width: 100%;
  margin: 0 auto;
  background-color: var(--black);
  border-radius: 24px;
  padding: 80px 60px;
  display: grid;
  grid-template-columns: 1fr 295px;
  gap: 105px;
  align-items: center;
}
.get-started .get-started__title {
  color: var(--white);
  font-family: "Cambon";
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.01em;
}
.get-started .get-started__title svg {
  display: inline;
}
.get-started .get-started__link {
  display: flex;
  align-items: center;
  width: 295px;
  padding: 25px 80px;
  font-family: "Circular Std";
  font-size: 24px;
  font-weight: 500;
  color: var(--dark);
  text-align: center;
  background-color: var(--yellow);
  border-radius: 12px;
  transition: all 0.4s linear;
  border: 1px solid var(--yellow);
}
.get-started .get-started__link:hover {
  background-color: var(--dark);
  color: var(--white);
}
.get-started--column {
  margin: 79px 0 86px 0;
  padding-top: 79px;
  position: relative;
}
.get-started--column::after {
  content: "";
  position: absolute;
  top: 0;
  left: -90px;
  right: -90px;
  height: 1px;
  background: rgba(22, 22, 22, 0.1294117647);
}
.get-started--column .get-started__wrapper {
  grid-template-columns: 1fr !important;
  gap: 20px;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.get-started--column .get-started__wrapper .get-started__title {
  color: var(--black);
  font-size: 28px;
  margin-bottom: 0;
  text-align: center;
}
.get-started--column .get-started__wrapper .get-started__link {
  width: 139px;
  font-size: 17px;
  padding: 12px 24px;
  text-decoration: none !important;
  margin: 0 auto;
}
.get-started--big {
  margin: 78px 0 108px 0;
}
.get-started--big .get-started__wrapper {
  max-width: 100%;
  padding: 55px 60px;
  grid-template-columns: 1fr 250px;
}
.get-started--big .get-started__wrapper .get-started__link {
  padding: 16.5px 20px;
  width: 187px;
  font-size: 17px;
  justify-content: center;
  margin-left: auto;
}
.get-started--big .get-started__title svg {
  transform: translateY(7px);
}

@media screen and (max-width: 1330px) {
  .get-started {
    margin: 9.023vw 0;
  }
  .get-started .get-started__wrapper {
    max-width: 86.466vw;
    border-radius: 1.805vw;
    padding: 6.015vw 4.511vw;
    grid-template-columns: 1fr 22.18vw;
    gap: 7.895vw;
  }
  .get-started .get-started__title {
    font-size: 3.008vw;
    line-height: 3.609vw;
  }
  .get-started .get-started__link {
    width: 22.18vw;
    padding: 1.88vw 6.015vw;
    font-size: 1.805vw;
    border-radius: 0.902vw;
    border: 0.075vw solid var(--yellow);
  }
  .get-started--column {
    margin: 5.94vw 0 6.466vw 0;
    padding-top: 5.94vw;
  }
  .get-started--column::after {
    left: -6.767vw;
    right: -6.767vw;
    height: 0.075vw;
  }
  .get-started--column .get-started__wrapper {
    grid-template-columns: 1fr;
    padding: 0;
    gap: 1.504vw;
  }
  .get-started--column .get-started__link {
    width: 10.451vw;
    font-size: 1.278vw;
    padding: 0.902vw 1.805vw;
  }
  .get-started--column .get-started__title {
    font-size: 2.105vw;
  }
  .get-started--big {
    margin: 5.865vw 0 8.12vw 0;
  }
  .get-started--big .get-started__wrapper {
    padding: 4.135vw 4.511vw;
  }
  .get-started--big .get-started__wrapper .get-started__link {
    padding: 1.241vw 1.305vw;
    width: 14.06vw;
    font-size: 1.278vw;
  }
}
@media screen and (max-width: 1280px) {
  .get-started {
    margin: 9.375vw 0;
  }
  .get-started .get-started__wrapper {
    max-width: 89.844vw;
    border-radius: 1.875vw;
    padding: 6.25vw 4.688vw;
    grid-template-columns: 1fr 23.047vw;
    gap: 8.203vw;
  }
  .get-started .get-started__title {
    font-size: 3.125vw;
    line-height: 3.75vw;
  }
  .get-started .get-started__link {
    width: 23.047vw;
    padding: 1.953vw 6.25vw;
    font-size: 1.875vw;
    border-radius: 0.938vw;
    border: 0.078vw solid var(--yellow);
  }
  .get-started--column {
    margin: 6.172vw 0 6.719vw 0;
    padding-top: 6.172vw;
  }
  .get-started--column::after {
    left: -7.031vw;
    right: -7.031vw;
    height: 0.078vw;
  }
  .get-started--column .get-started__wrapper {
    grid-template-columns: 1fr;
    padding: 0;
    gap: 2.5vw;
  }
  .get-started--column .get-started__link {
    width: 10.859vw;
    font-size: 1.328vw;
    padding: 0.938vw 1.875vw;
  }
  .get-started--column .get-started__title {
    font-size: 2.188vw;
  }
  .get-started--big {
    margin: 6.094vw 0 8.438vw 0;
  }
  .get-started--big .get-started__wrapper {
    padding: 4.297vw 4.688vw;
  }
  .get-started--big .get-started__wrapper .get-started__link {
    padding: 1.289vw 1.275vw;
    width: 14.609vw;
    font-size: 1.328vw;
  }
}
@media screen and (max-width: 850px) {
  .get-started {
    margin: 5.128vw 0;
  }
  .get-started .get-started__wrapper {
    max-width: 100%;
    border-radius: 6.154vw;
    padding: 8.205vw;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2.564vw;
  }
  .get-started .get-started__title {
    font-size: 6.154vw;
    line-height: 1.2;
  }
  .get-started .get-started__title svg {
    width: 7.949vw;
    height: 4.615vw;
  }
  .get-started .get-started__link {
    width: auto;
    padding: 5.128vw 7.179vw;
    font-size: 4.359vw;
    border-radius: 3.077vw;
    border: 0.256vw solid var(--yellow);
  }
  .get-started--column {
    margin: 10.256vw 0 14.103vw 0;
    padding-top: 12.821vw;
  }
  .get-started--column::after {
    left: 0;
    right: 0;
    height: 0.256vw;
  }
  .get-started--column .get-started__wrapper {
    grid-template-columns: 1fr;
    padding: 0;
    gap: 8.205vw;
    max-width: 69.231vw;
    margin: 0 auto;
  }
  .get-started--column .get-started__link {
    min-width: 35.641vw;
    font-size: 4.359vw;
    padding: 5.128vw 6.154vw;
  }
  .get-started--column .get-started__title {
    font-size: 2.188vw;
  }
  .get-started--big {
    margin: 12.821vw 0 10.256vw 0;
  }
  .get-started--big .get-started__wrapper {
    padding: 8.205vw 8.205vw;
  }
  .get-started--big .get-started__wrapper .get-started__link {
    padding: 4.28vw 5.718vw;
    width: 53.077vw;
    font-size: 4.359vw;
    margin-left: auto;
    margin-right: auto;
  }
  .get-started--big .get-started__title {
    max-width: 63vw;
    margin-bottom: 2.372vw;
  }
  .get-started--big .get-started__title br {
    display: none;
  }
  .get-started--big .get-started__title svg {
    height: 8.615vw;
  }
}
.blog-single-article-card {
  margin: 32px 0;
  display: block;
  text-decoration: none !important;
}
.blog-single-article-card__content {
  max-width: 360px;
  width: 100%;
  margin-bottom: 0 !important;
}
.blog-single-article-card__text {
  font-family: "Cambon";
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.02em;
  margin-bottom: 0 !important;
}
.blog-single-article-card__text span {
  display: block;
}
.blog-single-article-card__text span:empty {
  height: 5px;
}
.blog-single-article-card__text p {
  margin-bottom: 0 !important;
}
.blog-single-article-card--blockquote {
  background-color: #fdfada;
  border-radius: 24px;
  padding: 39px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 33px;
  margin: 32px 0;
}
.blog-single-article-card--blockquote .blog-single-article-card__text span {
  font-family: "Cambon";
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.02em;
}
.blog-single-article-card__author {
  display: grid;
  grid-template-columns: 65px 1fr;
  gap: 14px;
  align-items: center;
  margin-top: 48px;
}
.blog-single-article-card__author img {
  width: 65px;
  height: 65px;
  border-radius: 50%;
}
.blog-single-article-card__author-name b {
  display: block;
  font-family: "Circular Std";
  font-size: 17px;
  font-weight: 500;
  line-height: 1.29;
  margin-bottom: 4px !important;
}
.blog-single-article-card__author-name span {
  display: block;
  font-family: "Circular Std";
  font-size: 15px;
  font-weight: 400;
  line-height: 1.26;
}
.blog-single-article-card__img {
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 15.6px;
  overflow: hidden;
}
.blog-single-article-card__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

@media screen and (max-width: 1330px) {
  .blog-single-article-card {
    margin: 2.406vw 0;
  }
  .blog-single-article-card__content {
    max-width: 27.068vw;
  }
  .blog-single-article-card__text {
    font-size: 2.105vw;
    line-height: 2.556vw;
  }
  .blog-single-article-card__text span:empty {
    height: 0.376vw;
  }
  .blog-single-article-card--blockquote {
    border-radius: 1.805vw;
    padding: 2.932vw;
    gap: 2.481vw;
    margin: 2.406vw 0;
  }
  .blog-single-article-card--blockquote .blog-single-article-card__text span {
    font-size: 2.105vw;
    line-height: 2.556vw;
  }
  .blog-single-article-card--v2 .blog-single-article-card__text {
    max-width: 25.564vw;
  }
  .blog-single-article-card--v2
    .blog-single-article-card__text
    span:nth-child(1) {
    font-size: 2.932vw;
    margin-bottom: 0.376vw !important;
  }
  .blog-single-article-card--v2
    .blog-single-article-card__text
    span:nth-child(2) {
    font-size: 2.406vw;
    margin-bottom: 0.376vw !important;
  }
  .blog-single-article-card--v2
    .blog-single-article-card__text
    span:nth-child(3) {
    font-size: 6.316vw;
  }
  .blog-single-article-card--v3 {
    gap: 1.88vw;
  }
  .blog-single-article-card--v3
    .blog-single-article-card__text
    span:nth-child(1) {
    font-size: 3.008vw;
    margin-bottom: 1.579vw !important;
  }
  .blog-single-article-card--v3
    .blog-single-article-card__text
    span:nth-child(2) {
    font-size: 2.105vw;
    margin-bottom: 1.654vw !important;
  }
  .blog-single-article-card--v3
    .blog-single-article-card__text
    span:nth-child(3) {
    font-size: 2.105vw;
  }
  .blog-single-article-card--v4 .blog-single-article-card__text {
    max-width: 25.564vw;
  }
  .blog-single-article-card--v4
    .blog-single-article-card__text
    span:nth-child(1) {
    font-size: 2.707vw;
    line-height: 3.233vw;
    margin-bottom: 0.376vw !important;
  }
  .blog-single-article-card--v4
    .blog-single-article-card__text
    span:nth-child(2) {
    font-size: 6.015vw;
  }
  .blog-single-article-card__author {
    grid-template-columns: 4.887vw 1fr;
    gap: 1.053vw;
    margin-top: 3.609vw;
  }
  .blog-single-article-card__author img {
    width: 4.887vw;
    height: 4.887vw;
  }
  .blog-single-article-card__author-name b {
    font-size: 1.278vw;
    margin-bottom: 0.301vw !important;
  }
  .blog-single-article-card__author-name span {
    font-size: 1.128vw;
  }
  .blog-single-article-card__img {
    border-radius: 1.173vw;
  }
}
@media screen and (max-width: 850px) {
  .blog-single-article-card {
    margin: 6.154vw 0;
  }
  .blog-single-article-card__content {
    max-width: 37.179vw;
    width: 37.179vw;
  }
  .blog-single-article-card__text {
    font-size: 7.179vw;
    font-weight: 700;
    line-height: 8.718vw;
  }
  .blog-single-article-card__text span:empty {
    height: 1.282vw;
  }
  .blog-single-article-card--blockquote {
    padding: 4.615vw;
    align-items: center;
    gap: 5.41vw;
    margin: 6.154vw 0;
  }
  .blog-single-article-card--blockquote .blog-single-article-card__text span {
    font-size: 7.179vw;
    line-height: 8.718vw;
  }
  .blog-single-article-card--v2 {
    gap: 8.205vw;
  }
  .blog-single-article-card--v2 .blog-single-article-card__text {
    max-width: 100%;
  }
  .blog-single-article-card--v2
    .blog-single-article-card__text
    span:nth-child(1) {
    font-size: 8.205vw;
    margin-bottom: 1.282vw !important;
  }
  .blog-single-article-card--v2
    .blog-single-article-card__text
    span:nth-child(2) {
    font-size: 7.179vw;
    margin-bottom: 1.282vw !important;
  }
  .blog-single-article-card--v2
    .blog-single-article-card__text
    span:nth-child(3) {
    font-size: 12.821vw;
  }
  .blog-single-article-card--v3 {
    gap: 8.205vw;
  }
  .blog-single-article-card--v3
    .blog-single-article-card__text
    span:nth-child(1) {
    font-size: 8.718vw;
    margin-bottom: 5.385vw !important;
  }
  .blog-single-article-card--v3
    .blog-single-article-card__text
    span:nth-child(2) {
    font-size: 6.154vw;
    margin-bottom: 5.641vw !important;
  }
  .blog-single-article-card--v3
    .blog-single-article-card__text
    span:nth-child(3) {
    font-size: 6.154vw;
  }
  .blog-single-article-card--v4 {
    gap: 8.205vw;
  }
  .blog-single-article-card--v4 .blog-single-article-card__text {
    max-width: 100%;
  }
  .blog-single-article-card--v4
    .blog-single-article-card__text
    span:nth-child(1) {
    font-size: 8.205vw;
    line-height: 1.2;
    margin-bottom: 1.282vw !important;
  }
  .blog-single-article-card--v4
    .blog-single-article-card__text
    span:nth-child(2) {
    font-size: 12.821vw;
  }
  .blog-single-article-card__author {
    display: grid;
    grid-template-columns: 12.821vw 1fr;
    gap: 3.077vw;
    margin-top: 8.205vw;
    padding: 0 5.128vw 0 5.128vw;
  }
  .blog-single-article-card__author img {
    width: 12.821vw;
    height: 12.821vw;
  }
  .blog-single-article-card__author-name b {
    font-size: 4.359vw;
    margin-bottom: 1.026vw !important;
  }
  .blog-single-article-card__author-name span {
    font-size: 3.59vw;
  }
  .blog-single-article-card__img {
    border-radius: 4vw;
    margin-bottom: 0 !important;
  }
}
.blog-single-article-v2 .text h5 {
  margin-bottom: 32px !important;
}
.blog-single-article-v2 .text h3 {
  font-family: "Cambon" !important;
  position: relative;
  padding-top: 64px;
  margin-top: 64px;
}
.blog-single-article-v2 .text h3::after {
  content: "";
  position: absolute;
  top: 0;
  left: -90px;
  right: -90px;
  height: 1px;
  background: rgba(22, 22, 22, 0.1294117647);
}
.blog-single-article-v2 .title-step {
  padding-top: 64px;
  padding-bottom: 16px;
  position: relative;
  margin-top: 64px;
  margin-bottom: 0 !important;
}
.blog-single-article-v2 .title-step::after {
  content: "";
  position: absolute;
  top: 0;
  left: -90px;
  right: -90px;
  height: 1px;
  background: rgba(22, 22, 22, 0.1294117647);
}
.blog-single-article-v2 .title-step span {
  display: inline-block;
  font-family: "Cambon";
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.01em;
  padding: 10px 24px;
  border-radius: 16px;
  min-width: 90px;
  background-color: var(--yellow);
}
.blog-single-article-v2 .title-step + h3 {
  padding-top: 0;
  margin-top: 0;
}
.blog-single-article-v2 .title-step + h3::after {
  display: none;
}
.blog-single-article-v2 .get-started {
  margin: 32px 0 64px 0 !important;
}
.blog-single-article-v2 .get-started__link {
  width: 139px;
  font-size: 17px;
  padding: 12px 24px;
  text-decoration: none !important;
}
.blog-single-article-v2 .get-started__wrapper {
  grid-template-columns: 1fr 139px;
  padding: 55px 60px;
}
.blog-single-article-v2 .get-started.get-started--column {
  padding-top: 79px;
  margin: 100px 0 0 0 !important;
}
.blog-single-article-v2 .get-started.get-started--column .get-started__wrapper {
  grid-template-columns: 1fr;
  gap: 20px;
  padding: 0;
}
.blog-single-article-v2 .get-started__title {
  font-size: 28px;
  margin-bottom: 0;
}
.blog-single-article-v2 .blog-single-article-list {
  padding: 40px;
  border-radius: 24px;
  border: 1px solid rgba(22, 22, 22, 0.1490196078);
}
.blog-single-article-v2 .blog-single-article-list ol li {
  list-style: decimal;
  font-family: "Circular Std";
  font-size: 18px;
  font-weight: 400;
  line-height: 1.72;
  letter-spacing: -0.01em;
  list-style-position: outside;
  margin-left: 30px;
}
.blog-single-article-v2 .blog-single-article-list ol li::before {
  display: none;
}
.blog-single-article-v2 .blog-single-article__table {
  font-family: "Circular Std";
  margin: 40px 0 64px 0 !important;
}
.blog-single-article-v2 .blog-single-article__table * {
  margin-bottom: 0 !important;
}
.blog-single-article-v2 .blog-single-article__table .theader {
  display: grid;
  grid-template-columns: 120px repeat(2, 1fr);
  gap: 0 30px;
}
.blog-single-article-v2 .blog-single-article__table .theader-item {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.22;
  letter-spacing: -0.01em;
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
  background: #f6f5ef;
  padding: 12px 15px 12px 18px;
  border-radius: 12px;
}
.blog-single-article-v2 .blog-single-article__table .theader-item::before {
  content: "";
  position: relative;
  gap: 10px;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.blog-single-article-v2
  .blog-single-article__table
  .theader-item:nth-child(2)::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}
.blog-single-article-v2 .blog-single-article__table .tbody {
  display: grid;
  grid-template-columns: 120px repeat(2, 1fr);
  gap: 0 30px;
}
.blog-single-article-v2 .blog-single-article__table .tbody__title {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.22;
  letter-spacing: -0.01em;
  margin-top: 32px;
}
.blog-single-article-v2 .blog-single-article__table .tbody__text {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.22;
  letter-spacing: -0.01em;
  padding: 0 10px 0 20px;
  margin-top: 32px;
}
.blog-single-article-v2 .blog-single-article__table .tbody__text a {
  display: inline;
  text-underline-offset: 4px;
}
.blog-single-article-v2 + .more-info .more-info__header-title {
  max-width: 640px;
}

@media screen and (max-width: 1330px) {
  .blog-single-article-v2 .text h5 {
    margin-bottom: 2.406vw !important;
  }
  .blog-single-article-v2 .text h3 {
    padding-top: 4.812vw;
    margin-top: 4.812vw;
  }
  .blog-single-article-v2 .text h3::after {
    left: -6.767vw;
    right: -6.767vw;
    height: 0.075vw;
  }
  .blog-single-article-v2 .title-step {
    padding-top: 4.812vw;
    padding-bottom: 1.203vw;
    margin-top: 4.812vw;
  }
  .blog-single-article-v2 .title-step::after {
    left: -6.767vw;
    right: -6.767vw;
    height: 0.075vw;
  }
  .blog-single-article-v2 .title-step span {
    font-size: 3.008vw;
    padding: 0.752vw 1.805vw;
    border-radius: 1.203vw;
    min-width: 6.767vw;
  }
  .blog-single-article-v2 .get-started {
    margin: 2.406vw 0 4.812vw 0 !important;
  }
  .blog-single-article-v2 .get-started__link {
    width: 10.451vw;
    font-size: 1.278vw;
    padding: 0.902vw 1.805vw;
  }
  .blog-single-article-v2 .get-started__wrapper {
    grid-template-columns: 1fr 10.451vw;
    padding: 4.135vw 4.511vw;
  }
  .blog-single-article-v2 .get-started__title {
    font-size: 2.105vw;
  }
  .blog-single-article-v2 .get-started.get-started--column {
    margin: 7.519vw 0 0 0 !important;
    padding-top: 5.94vw;
  }
  .blog-single-article-v2
    .get-started.get-started--column
    .get-started__wrapper {
    grid-template-columns: 1fr;
    gap: 1.504vw;
    padding: 0;
  }
  .blog-single-article-v2 .blog-single-article-list {
    padding: 3.008vw;
    border-radius: 1.805vw;
    border: 0.075vw solid rgba(22, 22, 22, 0.1490196078);
  }
  .blog-single-article-v2 .blog-single-article-list ol li {
    font-size: 1.353vw;
    margin-left: 2.256vw;
  }
  .blog-single-article-v2 .blog-single-article__table {
    margin: 3.008vw 0 4.812vw 0 !important;
  }
  .blog-single-article-v2 .blog-single-article__table .theader {
    grid-template-columns: 9.023vw repeat(2, 1fr);
    gap: 0 2.256vw;
  }
  .blog-single-article-v2 .blog-single-article__table .theader-item {
    font-size: 1.353vw;
    gap: 0.752vw;
    padding: 0.902vw 1.128vw 0.902vw 1.353vw;
    border-radius: 0.902vw;
  }
  .blog-single-article-v2 .blog-single-article__table .theader-item::before {
    width: 1.654vw;
    height: 1.654vw;
  }
  .blog-single-article-v2 .blog-single-article__table .tbody {
    grid-template-columns: 9.023vw repeat(2, 1fr);
    gap: 0 2.256vw;
  }
  .blog-single-article-v2 .blog-single-article__table .tbody__title {
    font-size: 1.353vw;
    margin-top: 2.406vw;
  }
  .blog-single-article-v2 .blog-single-article__table .tbody__text {
    font-size: 1.353vw;
    letter-spacing: -0.01em;
    padding: 0 0.752vw 0 1.504vw;
    margin-top: 2.406vw;
  }
  .blog-single-article-v2 .blog-single-article__table .tbody__text a {
    text-underline-offset: 0.301vw;
  }
  .blog-single-article-v2 + .more-info .more-info__header-title {
    max-width: 38.5313vw;
  }
}
@media screen and (max-width: 850px) {
  .blog-single-article-v2 .text {
    font-size: 4.103vw;
  }
  .blog-single-article-v2 .text h5 {
    margin-bottom: 8.205vw !important;
  }
  .blog-single-article-v2 .text h3 {
    padding-top: 8.205vw;
    margin-top: 8.205vw;
    font-size: 7.179vw;
  }
  .blog-single-article-v2 .text h3::after {
    left: -5.1282vw;
    right: -5.1282vw;
    height: 0.256vw;
  }
  .blog-single-article-v2 .text h4:first-of-type {
    font-weight: 450;
  }
  .blog-single-article-v2 .text h4 {
    font-size: 5.128vw !important;
  }
  .blog-single-article-v2 .title-step {
    padding-top: 8.205vw;
    padding-bottom: 4.103vw;
    margin-top: 8.205vw;
  }
  .blog-single-article-v2 .title-step::after {
    left: -5.128vw;
    right: -5.128vw;
    height: 0.256vw;
  }
  .blog-single-article-v2 .title-step span {
    font-size: 7.179vw;
    padding: 4.103vw 6.154vw;
    border-radius: 4.103vw;
    min-width: 20vw;
  }
  .blog-single-article-v2 .title-step + h3 {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  .blog-single-article-v2 .get-started {
    margin: 8.205vw 0 8.205vw 0 !important;
  }
  .blog-single-article-v2 .get-started__link {
    width: auto;
    padding: 3.128vw 7.179vw;
    font-size: 4.359vw;
    border-radius: 3.077vw;
  }
  .blog-single-article-v2 .get-started__wrapper {
    max-width: 100%;
    border-radius: 6.154vw;
    padding: 8.205vw;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2.564vw;
  }
  .blog-single-article-v2 .get-started__title {
    font-size: 6.154vw;
    line-height: 1.2;
  }
  .blog-single-article-v2 .get-started__title svg {
    width: 7.949vw;
    height: 4.615vw;
    margin-bottom: 0;
  }
  .blog-single-article-v2 .get-started.get-started--column {
    margin: 10.256vw 0 0 0 !important;
    padding-top: 12.821vw;
  }
  .blog-single-article-v2 .get-started.get-started--column::after {
    left: 0;
    right: 0;
    height: 0.256vw;
  }
  .blog-single-article-v2
    .get-started.get-started--column
    .get-started__wrapper {
    grid-template-columns: 1fr;
    padding: 0;
    gap: 8.205vw;
    max-width: 69.231vw;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
  }
  .blog-single-article-v2 .get-started.get-started--column .get-started__link {
    min-width: 35.641vw;
    font-size: 4.359vw;
    padding: 3.128vw 6.154vw;
  }
  .blog-single-article-v2 .get-started.get-started--column .get-started__title {
    text-align: center;
    font-size: 6.154vw;
  }
  .blog-single-article-v2 .blog-single-article-list {
    padding: 6.41vw;
    border-radius: 6.154vw;
    border: 0.256vw solid rgba(22, 22, 22, 0.1490196078);
  }
  .blog-single-article-v2 .blog-single-article-list h4 {
    max-width: 102.564vw;
    font-size: 5.128vw;
  }
  .blog-single-article-v2 .blog-single-article-list h4 br {
    display: none;
  }
  .blog-single-article-v2 .blog-single-article-list ol li {
    font-size: 4.103vw;
    margin-left: 7.692vw;
  }
  .blog-single-article-v2 .blog-single-article__table {
    margin: 8.205vw -5.128vw 8.205vw 0 !important;
    max-width: 100%;
    overflow: auto;
    padding-left: 6.154vw;
  }
  .blog-single-article-v2 .blog-single-article__table .theader {
    grid-template-columns: 30.769vw repeat(2, 71.795vw);
    gap: 0 5.128vw;
  }
  .blog-single-article-v2 .blog-single-article__table .theader-item {
    font-size: 4.615vw;
    gap: 2.564vw;
    padding: 3.077vw 3.846vw 3.077vw 4.615vw;
    border-radius: 3.077vw;
  }
  .blog-single-article-v2 .blog-single-article__table .theader-item::before {
    width: 4.615vw;
    height: 4.615vw;
  }
  .blog-single-article-v2 .blog-single-article__table .tbody {
    grid-template-columns: 30.769vw repeat(2, 71.795vw);
    gap: 0 5.128vw;
  }
  .blog-single-article-v2 .blog-single-article__table .tbody__title {
    font-size: 4.615vw;
    margin-top: 8.205vw;
  }
  .blog-single-article-v2 .blog-single-article__table .tbody__text {
    font-size: 4.615vw;
    padding: 0 2.564vw;
    margin-top: 6.41vw;
  }
  .blog-single-article-v2 .blog-single-article__table .tbody__text a {
    text-underline-offset: 1.026vw;
  }
  .blog-single-article-v2 + .more-info .more-info__header-title {
    max-width: 100%;
  }
}
.table-dec {
  margin: 60px 0;
}
.table-dec .table-dec__title {
  display: none;
}
.table-dec .table-dec__wrapper {
  background-color: #f6f5ef;
  border-radius: 16px;
  padding: 60px 89px 15px 63px;
}
.table-dec .theader {
  display: grid;
  grid-template-columns: 200px repeat(2, 1fr);
  padding-right: 57px;
  margin-bottom: 10px;
}
.table-dec .theader-item {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.22;
  letter-spacing: -0.01em;
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
  background: #fff;
  padding: 18px 15px 18px 18px;
  border-radius: 12px;
}
.table-dec .theader-item:first-child {
  margin-right: 20px;
}
.table-dec .theader-item::before {
  content: "";
  position: relative;
  gap: 10px;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.table-dec .theader-item:nth-child(2) {
  margin-right: 45px;
}
.table-dec .theader-item:nth-child(2)::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.table-dec .tbody__item {
  display: grid;
  grid-template-columns: 180px repeat(2, 1fr);
  gap: 0 20px;
  padding: 27px 57px 30px 0;
  border-bottom: 1px solid rgba(22, 22, 22, 0.2117647059);
}
.table-dec .tbody__item:last-child {
  border-bottom: transparent;
}
.table-dec .tbody__title {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.22;
  letter-spacing: -0.01em;
}
.table-dec .tbody__text {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.22;
  letter-spacing: -0.01em;
  padding: 0 10px 0 20px;
}
.table-dec .tbody__text p {
  margin-bottom: 11px;
  max-width: 306px;
}
.table-dec .tbody__text a {
  display: block;
  text-underline-offset: 4px;
  text-decoration: underline;
  max-width: 256px;
  line-height: 1.3;
}

@media screen and (max-width: 1330px) {
  .table-dec {
    margin: 4.511vw 0;
  }
  .table-dec .table-dec__wrapper {
    border-radius: 1.203vw;
    padding: 4.511vw 6.692vw 1.128vw 4.737vw;
  }
  .table-dec .theader {
    grid-template-columns: 15.038vw repeat(2, 1fr);
    padding-right: 4.286vw;
    margin-bottom: 0.752vw;
  }
  .table-dec .theader-item {
    font-size: 1.353vw;
    gap: 0.752vw;
    padding: 1.353vw 1.128vw 1.353vw 1.353vw;
    border-radius: 0.902vw;
  }
  .table-dec .theader-item:first-child {
    margin-right: 1.504vw;
  }
  .table-dec .theader-item::before {
    gap: 0.752vw;
    width: 1.654vw;
    height: 1.654vw;
  }
  .table-dec .theader-item:nth-child(2) {
    margin-right: 3.383vw;
  }
  .table-dec .tbody__item {
    grid-template-columns: 13.534vw repeat(2, 1fr);
    gap: 0 1.504vw;
    padding: 2.03vw 4.286vw 2.256vw 0;
    border-bottom: 0.075vw solid rgba(22, 22, 22, 0.2117647059);
  }
  .table-dec .tbody__title {
    font-size: 1.353vw;
  }
  .table-dec .tbody__text {
    font-size: 1.353vw;
    padding: 0 0.752vw 0 1.504vw;
  }
  .table-dec .tbody__text p {
    margin-bottom: 0.827vw;
    max-width: 23.008vw;
  }
  .table-dec .tbody__text a {
    text-underline-offset: 0.301vw;
    max-width: 19.248vw;
  }
}
@media screen and (max-width: 850px) {
  .table-dec {
    margin: 15.385vw 0;
  }
  .table-dec .table-dec__title {
    display: block;
    text-align: center;
    max-width: 68.205vw;
    margin: 0 auto 11.026vw auto;
    font-family: "Cambon";
    font-size: 8.205vw;
    font-weight: 700;
    line-height: 1.18;
  }
  .table-dec .table-dec__wrapper {
    border-radius: 4.103vw;
    padding: 15.385vw 6.59vw 3.846vw 12.59vw;
    overflow: auto;
    max-width: 100%;
  }
  .table-dec .theader {
    grid-template-columns: 33.846vw repeat(2, 78.462vw);
    padding-right: 0;
    margin-bottom: 10px;
  }
  .table-dec .theader-item {
    font-size: 4.615vw;
    gap: 2.564vw;
    padding: 4.615vw 3.846vw 4.615vw 4.615vw;
    border-radius: 3.077vw;
  }
  .table-dec .theader-item:first-child {
    margin-right: 5.128vw;
  }
  .table-dec .theader-item::before {
    gap: 2.564vw;
    width: 5.641vw;
    height: 5.641vw;
  }
  .table-dec .theader-item:nth-child(2) {
    margin-right: 11.538vw;
  }
  .table-dec .tbody {
    width: max-content;
  }
  .table-dec .tbody__item {
    display: grid;
    grid-template-columns: 36.615vw repeat(2, 71.462vw);
    gap: 0 5.128vw;
    padding: 5.641vw 10.256vw 7.692vw 0;
    border-bottom: 0.256vw solid rgba(22, 22, 22, 0.2117647059);
  }
  .table-dec .tbody__title {
    font-size: 4.615vw;
  }
  .table-dec .tbody__text {
    font-size: 4.615vw;
    padding: 0 2.564vw 0 0;
  }
  .table-dec .tbody__text p {
    margin-bottom: 2.821vw;
    max-width: 65.641vw;
  }
  .table-dec .tbody__text a {
    text-underline-offset: 1.026vw;
    max-width: 65.641vw;
  }
}
.section-form {
  margin-bottom: 100px;
}
.section-form .section-form__top {
  text-align: center;
  max-width: 980px;
  width: 100%;
  margin: 0 auto 75px auto;
}
.section-form .section-form__top .title {
  margin-bottom: 30px;
}
.section-form .section-form__top .subtitle {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.01em;
  text-align: center;
  max-width: 85%;
  margin: 0 auto;
}
.section-form__inner {
  width: 100%;
  display: flex;
  gap: 99px;
  padding: 72px 0 88px 157px;
  border-radius: 24px;
  background-color: #4ba594;
}
.section-form .section-form__main {
  width: 432px;
  padding-top: 22px;
}
.section-form .section-form__main .title {
  font-family: "Circular Std";
  font-size: 28px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.01em;
  color: var(--white);
  margin-bottom: 11px;
}
.section-form .section-form__main form {
  position: relative;
}
.section-form .section-form__main form .hs_error_rollup {
  color: white;
  position: absolute;
  left: 177px;
  max-width: 185px;
  bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
}
.section-form .section-form__main form .hs-fieldtype-text label {
  color: var(--white);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.01em;
  margin-bottom: 8px;
  display: block;
}
.section-form .section-form__main form fieldset {
  margin-bottom: 22px;
}
.section-form .section-form__main form fieldset.form-columns-1 .input {
  margin: 0;
}
.section-form .section-form__main form fieldset.form-columns-1 .hs-input {
  width: 100%;
}
.section-form .section-form__main form fieldset.form-columns-2 {
  display: flex;
  gap: 24px;
}
.section-form .section-form__main form fieldset.form-columns-2 .input {
  margin: 0;
}
.section-form .section-form__main form input {
  width: 100%;
  background: #e0f1ee;
  padding: 12px 16px 14px 16px;
  border-radius: 8px;
  border: none;
  color: var(--dark);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.01em;
  border: 2px solid #e0f1ee;
}
.section-form .section-form__main form input.invalid,
.section-form .section-form__main form input.error {
  border: 2px solid #f32a2a;
}
.section-form .section-form__main form .hs-submit input {
  background-color: var(--dark);
  color: var(--white);
  font-family: "Circular Std";
  font-size: 17px;
  font-weight: 500;
  text-align: center;
  border-radius: 12px;
  padding: 13.5px 24px;
  transition: all 0.4s linear;
  width: 152px;
  border-color: var(--dark);
}
.section-form .section-form__main form .hs-error-msgs {
  display: none;
}
.section-form .section-form__main .submitted-message {
  background-color: #3b3b3b;
  border-radius: 5px;
  padding: 29px 41px 35px 43px;
  margin-bottom: 100px;
  margin-top: 40px;
  max-width: 383px;
}
.section-form .section-form__main .submitted-message p {
  color: var(--white);
}
.section-form .section-form__main .submitted-message p:nth-child(1) {
  font-size: 28px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.01em;
  margin-bottom: 36px;
}
.section-form .section-form__main .submitted-message p:nth-child(2) {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.01em;
}
.section-form .section-form__img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center right;
}
.section-form__wrapper {
  margin-bottom: 24px;
}
.section-form__link a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.section-form__link a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.section-form__link a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
.section-form__link a:hover::before {
  transform: translateX(3px);
}
.section-form__link a:hover::after {
  width: 0%;
}

@media screen and (max-width: 1330px) {
  .section-form {
    margin-bottom: 7.519vw;
  }
  .section-form .section-form__top {
    max-width: 73.684vw;
    margin: 0 auto 5.639vw auto;
  }
  .section-form .section-form__top .title {
    margin-bottom: 2.256vw;
  }
  .section-form .section-form__top .subtitle {
    font-size: 1.504vw;
    line-height: 2.256vw;
  }
  .section-form__inner {
    gap: 7.444vw;
    padding: 5.414vw 0 6.617vw 11.805vw;
    border-radius: 1.805vw;
  }
  .section-form .section-form__main {
    width: 32.481vw;
    padding-top: 1.654vw;
  }
  .section-form .section-form__main .title {
    font-size: 2.105vw;
    margin-bottom: 0.827vw;
  }
  .section-form .section-form__main form .hs_error_rollup {
    left: 13.308vw;
    max-width: 13.91vw;
    bottom: 0.752vw;
    font-size: 0.977vw;
  }
  .section-form .section-form__main form .hs-fieldtype-text label {
    font-size: 1.203vw;
    margin-bottom: 0.602vw;
  }
  .section-form .section-form__main form fieldset {
    margin-bottom: 1.654vw;
  }
  .section-form .section-form__main form fieldset.form-columns-2 {
    gap: 1.805vw;
  }
  .section-form .section-form__main form input {
    padding: 1.053vw 1.203vw 1.203vw 1.203vw;
    border-radius: 0.602vw;
    font-size: 1.203vw;
  }
  .section-form .section-form__main form .hs-submit input {
    font-size: 1.278vw;
    border-radius: 0.902vw;
    padding: 1.015vw 1.805vw;
    width: 11.429vw;
  }
  .section-form .section-form__main .submitted-message {
    border-radius: 0.376vw;
    padding: 2.18vw 3.083vw 2.632vw 3.233vw;
    margin-bottom: 7.519vw;
    margin-top: 3.008vw;
    max-width: 28.797vw;
  }
  .section-form .section-form__main .submitted-message p:nth-child(1) {
    font-size: 2.105vw;
    margin-bottom: 2.707vw;
  }
  .section-form .section-form__main .submitted-message p:nth-child(2) {
    font-size: 1.203vw;
  }
  .section-form__wrapper {
    margin-bottom: 1.805vw;
  }
  .section-form__link a {
    padding-right: 2.256vw;
    letter-spacing: -0.03vw;
    font-size: 1.353vw;
  }
  .section-form__link a::before {
    top: 0.15vw;
    width: 1.805vw;
    height: 1.805vw;
  }
  .section-form__link a::after {
    width: calc(100% - 2.256vw);
    height: 0.15vw;
    transform: translateX(-2.256vw);
  }
}
@media screen and (max-width: 850px) {
  .section-form {
    margin-bottom: 10.256vw;
  }
  .section-form .section-form__top {
    max-width: 83.59vw;
    margin: 0 auto 12.051vw auto;
  }
  .section-form .section-form__top .title {
    margin-bottom: 6.41vw;
  }
  .section-form .section-form__top .subtitle {
    font-size: 5.128vw;
    font-weight: 400;
    line-height: 7.692vw;
    max-width: 100%;
  }
  .section-form__inner {
    flex-direction: column;
    gap: 10.256vw;
    padding: 12.821vw 6.154vw 9.487vw 6.154vw;
    border-radius: 6.154vw;
  }
  .section-form .section-form__main {
    width: 100%;
    padding-top: 0;
  }
  .section-form .section-form__main .title {
    font-size: 6.154vw;
    margin-bottom: 4.103vw;
  }
  .section-form .section-form__main .submitted-message {
    border-radius: 1.282vw;
    padding: 7.436vw 13.59vw 7.436vw 5.897vw;
    margin-bottom: 35.897vw;
    margin-top: 38.462vw;
    max-width: 100%;
  }
  .section-form .section-form__main .submitted-message p:nth-child(1) {
    font-size: 6.667vw;
    margin-bottom: 8.462vw;
  }
  .section-form .section-form__main .submitted-message p:nth-child(2) {
    font-size: 4.103vw;
  }
  .section-form .section-form__main form .hs_error_rollup {
    max-width: 100%;
    font-size: 3.333vw;
    position: static;
    margin: 8.205vw 0;
  }
  .section-form .section-form__main form .hs-fieldtype-text label {
    font-size: 4.103vw;
    margin-bottom: 2.051vw;
  }
  .section-form .section-form__main form fieldset {
    margin-bottom: 4.103vw;
  }
  .section-form .section-form__main form fieldset.form-columns-2 {
    flex-direction: column;
    gap: 16px;
  }
  .section-form
    .section-form__main
    form
    fieldset.form-columns-2
    .hs-form-field {
    width: 100%;
  }
  .section-form .section-form__main form input {
    padding: 2.29vw 3.333vw 2.103vw 3.333vw;
    border-radius: 2.051vw;
    font-size: 4.103vw;
  }
  .section-form .section-form__main form .hs-submit input {
    font-size: 4.359vw;
    border-radius: 3.077vw;
    padding: 3.462vw 6.154vw;
    width: 100%;
  }
  .section-form .section-form__img {
    width: calc(100% + 6.154vw);
    margin-right: -6.154vw;
  }
  .section-form__wrapper {
    margin-bottom: 6.154vw;
  }
  .section-form__link a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .section-form__link a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .section-form__link a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
  .section-form__link a:hover::before {
    transform: translateX(0.7692vw);
  }
  .section-form__link a:hover::after {
    width: 0%;
  }
}
.review-banner {
  margin-bottom: 120px;
}
.review-banner .review-banner__wrapper {
  width: 100%;
  max-width: 1290px;
  margin: 0 auto;
  border-radius: 24px;
  background: var(--yellow);
  overflow: hidden;
  padding: 80px 80px 80px 114px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 85px;
}
.review-banner .review-banner__content {
  width: 100%;
  max-width: 487px;
  margin-top: 15px;
}
.review-banner .review-banner__content-text {
  font-weight: 400;
  line-height: 1.4;
  font-size: 28px;
  letter-spacing: -0.01em;
  color: var(--dark);
  margin-bottom: 29px;
}
.review-banner .review-banner__content-logo {
  width: 217px;
  height: auto;
  margin-bottom: 50px;
}
.review-banner .review-banner__content-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.review-banner .review-banner__content-more a {
  position: relative;
  z-index: 2;
  padding-right: 30px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.4px;
  font-size: 18px;
  color: var(--dark);
}
.review-banner .review-banner__content-more a::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: all 0.3s linear;
}
.review-banner .review-banner__content-more a::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  height: 2px;
  transform: translateX(-30px);
  background-color: var(--dark);
  transition: all 0.3s linear;
}
@media screen and (min-width: 850px) {
  .review-banner .review-banner__content-more a:hover::before {
    transform: translateX(3px);
  }
  .review-banner .review-banner__content-more a:hover::after {
    width: 0%;
  }
}
@media screen and (max-width: 1330px) {
  .review-banner .review-banner__content-more a {
    padding-right: 2.2556vw;
    letter-spacing: -0.0301vw;
    font-size: 1.3534vw;
  }
  .review-banner .review-banner__content-more a::before {
    top: 0.1504vw;
    width: 1.8045vw;
    height: 1.8045vw;
  }
  .review-banner .review-banner__content-more a::after {
    width: calc(100% - 2.2556vw);
    height: 0.1504vw;
    transform: translateX(-2.2556vw);
  }
  .review-banner .review-banner__content-more a:hover::before {
    transform: translateX(0.2256vw);
  }
}
@media screen and (max-width: 1280px) {
  .review-banner .review-banner__content-more a {
    padding-right: 2.0313vw;
    letter-spacing: -0.0078vw;
    font-size: 1.25vw;
  }
  .review-banner .review-banner__content-more a::before {
    top: 0;
    width: 1.875vw;
    height: 1.875vw;
  }
}
@media screen and (max-width: 850px) {
  .review-banner .review-banner__content-more a {
    padding-right: 7.6923vw;
    line-height: 1.4;
    letter-spacing: -0.041vw;
    font-size: 4.1026vw;
  }
  .review-banner .review-banner__content-more a::before {
    top: 0;
    width: 6.1538vw;
    height: 6.1538vw;
  }
  .review-banner .review-banner__content-more a::after {
    width: calc(100% - 7.6923vw);
    height: 0.5128vw;
    transform: translateX(-7.6923vw);
  }
}
.review-banner .review-banner__image {
  display: block;
  width: 523px;
  height: 370px;
  border-radius: 24px;
  overflow: hidden;
  flex: 0 0 auto;
}
.review-banner .review-banner__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1330px) {
  .review-banner {
    margin-bottom: 9.0226vw;
  }
  .review-banner .review-banner__wrapper {
    max-width: 96.9925vw;
    border-radius: 1.8045vw;
    padding: 6.015vw 6.015vw 6.015vw 8.5714vw;
    gap: 6.391vw;
  }
  .review-banner .review-banner__content {
    max-width: 36.6165vw;
    margin-top: 1.1278vw;
  }
  .review-banner .review-banner__content-text {
    font-size: 2.1053vw;
    margin-bottom: 2.1805vw;
  }
  .review-banner .review-banner__content-logo {
    width: 16.3158vw;
    margin-bottom: 3.7594vw;
  }
  .review-banner .review-banner__image {
    width: 39.3233vw;
    height: 27.8195vw;
    border-radius: 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .review-banner {
    margin-bottom: 6.25vw;
  }
  .review-banner .review-banner__wrapper {
    max-width: 100%;
    border-radius: 1.1719vw;
    padding: 3.9063vw;
    gap: 3.9063vw;
    align-items: center;
  }
  .review-banner .review-banner__content {
    max-width: 38.0469vw;
    margin-top: 1.1719vw;
  }
  .review-banner .review-banner__content-text {
    font-size: 1.7969vw;
    margin-bottom: 2.2656vw;
  }
  .review-banner .review-banner__content-logo {
    width: 16.9531vw;
    margin-bottom: 2.7344vw;
  }
  .review-banner .review-banner__image {
    width: 38.2813vw;
    height: 26.9531vw;
    border-radius: 1.1719vw;
  }
}
@media screen and (max-width: 850px) {
  .review-banner {
    margin-bottom: 14.1026vw;
  }
  .review-banner .review-banner__wrapper {
    flex-direction: column-reverse;
    border-radius: 4.1026vw;
    padding: 0;
    gap: 6.1538vw;
  }
  .review-banner .review-banner__content {
    max-width: 73.3333vw;
    margin: 0 auto;
    margin-top: 0;
    padding-bottom: 10.2564vw;
  }
  .review-banner .review-banner__content-text {
    font-size: 4.6154vw;
    margin-bottom: 6.1538vw;
  }
  .review-banner .review-banner__content-logo {
    width: 46.9231vw;
    margin-bottom: 5.8974vw;
  }
  .review-banner .review-banner__image {
    width: 100%;
    height: auto;
    border-radius: 4.1026vw;
  }
}
.counter-section {
  margin-bottom: 170px;
}
.counter-section .counter-section__list .list {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  gap: 32px;
}
.counter-section .counter-section__list .item {
  width: 280px;
}
.counter-section .counter-section__list .item-top {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.counter-section .counter-section__list .item-top__number,
.counter-section .counter-section__list .item-top__symbol {
  font-family: "Circular Std";
  font-weight: 700;
  line-height: 1.5;
  font-size: 80px;
  letter-spacing: -0.022em;
  color: #ffffff;
}
.counter-section .counter-section__list .item-title {
  width: 230px;
  margin: 0 auto;
  font-weight: 400;
  line-height: 1.2;
  font-size: 20px;
  letter-spacing: -0.01em;
  color: #ffffff;
  text-align: center;
}
.counter-section .counter-section__text {
  margin-bottom: 65px;
  font-weight: 500;
  line-height: 1.4;
  font-size: 24px;
  letter-spacing: -0.01em;
  color: #ffffff;
  text-align: center;
}

@media screen and (max-width: 1330px) {
  .counter-section {
    margin-bottom: 12.782vw;
  }
  .counter-section .counter-section__list .list {
    gap: 2.406vw;
  }
  .counter-section .counter-section__list .item {
    width: 21.0526vw;
  }
  .counter-section .counter-section__list .item-top__number,
  .counter-section .counter-section__list .item-top__symbol {
    font-size: 6.015vw;
  }
  .counter-section .counter-section__list .item-title {
    width: 17.2932vw;
    font-size: 1.5038vw;
  }
  .counter-section .counter-section__text {
    margin-bottom: 4.8872vw;
    font-size: 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .counter-section {
    margin-bottom: 6.25vw;
  }
  .counter-section .counter-section__list .list {
    gap: 2.3438vw;
  }
  .counter-section .counter-section__list .item {
    width: 16.7969vw;
  }
  .counter-section .counter-section__list .item-top__number,
  .counter-section .counter-section__list .item-top__symbol {
    font-size: 5.4688vw;
  }
  .counter-section .counter-section__list .item-title {
    width: 15.625vw;
    font-size: 1.4063vw;
  }
  .counter-section .counter-section__text {
    margin-bottom: 2.3438vw;
    font-size: 1.5625vw;
  }
}
@media screen and (max-width: 850px) {
  .counter-section {
    margin-bottom: 20vw;
  }
  .counter-section .counter-section__list .list {
    gap: 8.4615vw;
  }
  .counter-section .counter-section__list .item {
    width: 100%;
  }
  .counter-section .counter-section__list .item-top__number,
  .counter-section .counter-section__list .item-top__symbol {
    font-size: 15.3846vw;
  }
  .counter-section .counter-section__list .item-title {
    width: 55.3846vw;
    font-size: 4.6154vw;
  }
  .counter-section .counter-section__text {
    width: 71.7949vw;
    margin: 0 auto 13.8462vw;
    font-size: 4.1026vw;
  }
}
.coming-soon-banner {
  background-color: var(--yellow);
}
.coming-soon-banner.hide {
  padding-bottom: 30px;
}
.coming-soon-banner .coming-soon-banner__inner {
  padding: 60px 0;
}
.coming-soon-banner .coming-soon-banner__wrapper {
  width: 100%;
  max-width: 1290px;
  margin: 0 auto;
  background: #474643;
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  z-index: 2;
  min-height: 400px;
  padding: 60px;
}
.coming-soon-banner .coming-soon-banner__wrapper::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.coming-soon-banner .coming-soon-banner__content {
  width: 100%;
  max-width: 460px;
}
.coming-soon-banner .coming-soon-banner__content-top {
  font-weight: 500;
  line-height: 1.5;
  font-size: 14px;
  letter-spacing: -0.01em;
  color: var(--yellow);
  text-transform: uppercase;
  margin-bottom: 5px;
}
.coming-soon-banner .coming-soon-banner__content-title {
  margin-bottom: 5px;
}
.coming-soon-banner .coming-soon-banner__content-title .title {
  color: var(--white);
}
.coming-soon-banner .coming-soon-banner__content-text {
  font-weight: 400;
  line-height: 1.5;
  font-size: 20px;
  letter-spacing: -0.01em;
  color: #e9e4dc;
  margin-top: -3px;
}
.coming-soon-banner .coming-soon-banner__content-button {
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
}
.coming-soon-banner .coming-soon-banner__image {
  position: absolute;
  right: 22px;
  bottom: 0;
  width: 625px;
  height: 371px;
}
.coming-soon-banner .coming-soon-banner__image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1330px) {
  .coming-soon-banner.hide {
    padding-bottom: 2.2556vw;
  }
  .coming-soon-banner .coming-soon-banner__inner {
    padding: 4.5113vw 0;
  }
  .coming-soon-banner .coming-soon-banner__wrapper {
    max-width: 96.9925vw;
    border-radius: 1.8045vw;
    min-height: 30.0752vw;
    padding: 4.5113vw;
  }
  .coming-soon-banner .coming-soon-banner__content {
    max-width: 34.5865vw;
  }
  .coming-soon-banner .coming-soon-banner__content-top {
    font-size: 1.0526vw;
    margin-bottom: 0.3759vw;
  }
  .coming-soon-banner .coming-soon-banner__content-title {
    margin-bottom: 0.3759vw;
  }
  .coming-soon-banner .coming-soon-banner__content-text {
    font-size: 1.5038vw;
    margin-top: -0.2256vw;
  }
  .coming-soon-banner .coming-soon-banner__content-button {
    margin-top: 1.5038vw;
  }
  .coming-soon-banner .coming-soon-banner__image {
    right: 1.6541vw;
    width: 46.9925vw;
    height: 27.8947vw;
  }
}
@media screen and (max-width: 1280px) {
  .coming-soon-banner.hide {
    padding-bottom: 2.3438vw;
  }
  .coming-soon-banner .coming-soon-banner__inner {
    padding: 3.9063vw 0;
  }
  .coming-soon-banner .coming-soon-banner__wrapper {
    max-width: 100%;
    border-radius: 1.1719vw;
    min-height: 27.3438vw;
    padding: 3.9063vw;
  }
  .coming-soon-banner .coming-soon-banner__content {
    max-width: 35.9375vw;
  }
  .coming-soon-banner .coming-soon-banner__content-top {
    font-size: 1.0938vw;
    margin-bottom: 0.3906vw;
  }
  .coming-soon-banner .coming-soon-banner__content-title {
    margin-bottom: 0.3906vw;
  }
  .coming-soon-banner .coming-soon-banner__content-text {
    font-size: 1.5625vw;
    margin-top: -0.2344vw;
  }
  .coming-soon-banner .coming-soon-banner__content-button {
    margin-top: 1.5625vw;
  }
  .coming-soon-banner .coming-soon-banner__image {
    right: 1.5625vw;
    bottom: 0;
    width: 35.9375vw;
    height: 21.3281vw;
  }
}
@media screen and (max-width: 850px) {
  .coming-soon-banner.hide {
    padding-bottom: 11.5385vw;
  }
  .coming-soon-banner .coming-soon-banner__inner {
    padding: 11.7949vw 0;
  }
  .coming-soon-banner .coming-soon-banner__wrapper {
    border-radius: 4.1026vw;
    min-height: 1px;
    padding: 10.2564vw 0 0 0;
  }
  .coming-soon-banner .coming-soon-banner__content {
    max-width: 74.1026vw;
    margin: 0 auto;
  }
  .coming-soon-banner .coming-soon-banner__content-top {
    font-size: 3.5897vw;
    margin-bottom: 2.0513vw;
  }
  .coming-soon-banner .coming-soon-banner__content-title {
    margin-bottom: 4.359vw;
  }
  .coming-soon-banner .coming-soon-banner__content-text {
    font-size: 4.6154vw;
    margin-top: 0;
  }
  .coming-soon-banner .coming-soon-banner__content-button {
    margin-top: 6.1538vw;
  }
  .coming-soon-banner .coming-soon-banner__image {
    margin: 16.4103vw auto 0;
    position: static;
    width: 99.4872vw;
    height: 59.1795vw;
  }
}
.programs {
  margin-bottom: 120px;
}
.programs .programs__title {
  margin-bottom: 68px;
}
.programs .programs__title .title {
  color: var(--white);
  text-align: center;
}
.programs .programs__navigation {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto 130px;
}
.programs .programs__navigation ul {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 33px 20px;
  align-items: stretch;
}
.programs .programs__navigation ul li {
  width: 100%;
  height: auto;
  position: relative;
}
.programs .programs__navigation ul li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #56534f;
  border-radius: 12px;
  z-index: -1;
  background: var(--dark);
  transition: all 0.3s linear;
}
.programs .programs__navigation ul li:hover a::before {
  opacity: 1;
}
.programs .programs__navigation ul li.is-active::before {
  top: -10px;
  background: #2b2a28;
}
.programs .programs__navigation ul li.is-active a::after {
  background: #161616;
}
.programs .programs__navigation ul li a {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 41px 15px;
  font-weight: 500;
  line-height: 1.5;
  font-size: 24px;
  text-align: center;
  letter-spacing: -0.01em;
  color: var(--yellow);
}
.programs .programs__navigation ul li a::before,
.programs .programs__navigation ul li a::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #56534f;
  border-radius: 12px;
  transition: all 0.3s linear;
}
.programs .programs__navigation ul li a::before {
  opacity: 0;
  z-index: -1;
  background: linear-gradient(180deg, #4d452a 0%, #2b2a28 100%);
}
.programs .programs__navigation ul li a::after {
  z-index: -2;
  background: #2b2a28;
}
.programs .programs__list {
  width: 100%;
  max-width: 1190px;
  margin: 0 auto;
  position: relative;
}
.programs .programs__list .list-line {
  position: absolute;
  top: 209px;
  left: calc(50% + 26px);
  transform: translateX(-50%);
  width: 60px;
  height: calc(100% - 656px);
  border-radius: 16px 0 0 0;
  border: 2px solid #56534f;
  border-right: none;
  border-bottom: none;
}
.programs .programs__list .list-line #path-circle {
  position: absolute;
  top: 87px;
  left: -6.6px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: var(--yellow);
}
.programs .programs__list .list {
  width: 100%;
}
.programs .programs__list .item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 130px;
  position: relative;
}
.programs .programs__list .item:not(:first-child) {
  margin-top: 60px;
}
.programs .programs__list .item:nth-child(4n + 1),
.programs .programs__list .item:nth-child(4n + 2) {
  flex-direction: row;
}
.programs .programs__list .item:nth-child(4n + 1) .item-image::before,
.programs .programs__list .item:nth-child(4n + 2) .item-image::before {
  content: "";
  position: absolute;
  left: -58px;
  bottom: 100%;
  width: 330px;
  height: 30px;
  border: 2px solid #56534f;
  border-radius: 0 16px 0 0;
  border-left: none;
  border-bottom: none;
}
.programs .programs__list .item:nth-child(4n + 3),
.programs .programs__list .item:nth-child(4n + 4) {
  flex-direction: row-reverse;
}
.programs .programs__list .item:nth-child(4n + 3) .item-image::before,
.programs .programs__list .item:nth-child(4n + 4) .item-image::before {
  content: "";
  position: absolute;
  right: -54px;
  bottom: 100%;
  width: 330px;
  height: 30px;
  border: 2px solid #56534f;
  border-radius: 16px 0 0 0;
  border-right: none;
  border-bottom: none;
}
.programs .programs__list .item:first-child .item-image::before {
  display: none;
}
.programs .programs__list .item-link {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.programs .programs__list .item-content {
  width: 100%;
  max-width: 520px;
  color: var(--white);
}
.programs .programs__list .item-content__title {
  margin-bottom: 22px;
}
.programs .programs__list .item-content__title .small-title {
  color: var(--white);
}
.programs .programs__list .item-content__list {
  margin-bottom: 22px;
}
.programs .programs__list .item-content__list ul {
  width: 100%;
  max-width: 510px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}
.programs .programs__list .item-content__list ul li {
  border-radius: 60px;
  background: #2f2f2f;
  border: 1px solid #74706d;
  padding: 12px 16px;
  font-weight: 400;
  line-height: 1.2;
  font-size: 16px;
  letter-spacing: -0.01em;
  color: var(--yellow);
}
.programs .programs__list .item-content__text {
  font-weight: 450;
  line-height: 1.5;
  font-size: 20px;
  letter-spacing: -0.01em;
  color: #e9e4dc;
}
.programs .programs__list .item-content__text.item-content__text--mobile {
  display: none;
}
.programs .programs__list .item-image {
  position: relative;
  flex: 0 0 auto;
  width: 540px;
  height: 420px;
  border-radius: 28px;
  border: 1px solid #56534f;
  padding: 10px;
  background-color: var(--dark);
}
.programs .programs__list .item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 24px;
}

@media screen and (max-width: 1330px) {
  .programs {
    margin-bottom: 9.0226vw;
  }
  .programs .programs__title {
    margin-bottom: 5.1128vw;
  }
  .programs .programs__navigation {
    max-width: 75.188vw;
    margin: 0 auto 9.7744vw;
  }
  .programs .programs__navigation ul {
    grid-gap: 2.4812vw 1.5038vw;
  }
  .programs .programs__navigation ul li::before {
    top: 0.7519vw;
    border-radius: 0.9023vw;
  }
  .programs .programs__navigation ul li a {
    padding: 3.0827vw 1.1278vw;
    font-size: 1.8045vw;
  }
  .programs .programs__navigation ul li a::before,
  .programs .programs__navigation ul li a::after {
    border-radius: 0.9023vw;
  }
  .programs .programs__list {
    max-width: 89.4737vw;
  }
  .programs .programs__list .list-line {
    top: 15.7143vw;
    left: calc(50% + 1.9549vw);
    width: 4.5113vw;
    height: calc(100% - 49.3233vw);
  }
  .programs .programs__list .item {
    gap: 9.7744vw;
  }
  .programs .programs__list .item:not(:first-child) {
    margin-top: 4.5113vw;
  }
  .programs .programs__list .item:nth-child(4n + 1) .item-image::before,
  .programs .programs__list .item:nth-child(4n + 2) .item-image::before {
    left: -4.3609vw;
    width: 24.812vw;
    height: 2.2556vw;
  }
  .programs .programs__list .item:nth-child(4n + 3) .item-image::before,
  .programs .programs__list .item:nth-child(4n + 4) .item-image::before {
    right: -4.0602vw;
    width: 24.812vw;
    height: 2.2556vw;
  }
  .programs .programs__list .item-content {
    max-width: 39.0977vw;
  }
  .programs .programs__list .item-content__title {
    margin-bottom: 1.6541vw;
  }
  .programs .programs__list .item-content__list {
    margin-bottom: 1.6541vw;
  }
  .programs .programs__list .item-content__list ul {
    max-width: 38.3459vw;
    gap: 0.6015vw;
  }
  .programs .programs__list .item-content__list ul li {
    border-radius: 4.5113vw;
    padding: 0.9023vw 1.203vw;
    font-size: 1.203vw;
  }
  .programs .programs__list .item-content__text {
    font-size: 1.5038vw;
  }
  .programs .programs__list .item-image {
    width: 40.6015vw;
    height: 31.5789vw;
    border-radius: 2.1053vw;
    padding: 0.7519vw;
  }
  .programs .programs__list .item-image img {
    border-radius: 1.8045vw;
  }
}
@media screen and (max-width: 1280px) {
  .programs {
    margin-bottom: 6.25vw;
  }
  .programs .programs__title {
    margin-bottom: 3.9063vw;
  }
  .programs .programs__navigation {
    max-width: 100%;
    margin: 0 auto 4.6875vw;
  }
  .programs .programs__navigation ul {
    grid-gap: 2.5781vw 1.5625vw;
  }
  .programs .programs__navigation ul li::before {
    top: 0.7813vw;
    border-radius: 0.9375vw;
  }
  .programs .programs__navigation ul li a {
    padding: 3.2031vw 1.1719vw;
    font-size: 1.875vw;
  }
  .programs .programs__navigation ul li a::before,
  .programs .programs__navigation ul li a::after {
    border-radius: 0.9375vw;
  }
  .programs .programs__list {
    max-width: 92.9688vw;
  }
  .programs .programs__list .list-line {
    top: 16.3281vw;
    left: calc(50% + 2.0313vw);
    width: 4.6875vw;
    height: calc(100% - 47.0313vw);
  }
  .programs .programs__list .item {
    gap: 10.1563vw;
  }
  .programs .programs__list .item:not(:first-child) {
    margin-top: 4.6875vw;
  }
  .programs .programs__list .item:nth-child(4n + 1) .item-image::before,
  .programs .programs__list .item:nth-child(4n + 2) .item-image::before {
    left: -4.5313vw;
    width: 25.7813vw;
    height: 2.3438vw;
  }
  .programs .programs__list .item:nth-child(4n + 3) .item-image::before,
  .programs .programs__list .item:nth-child(4n + 4) .item-image::before {
    right: -4.0625vw;
    width: 25.7813vw;
    height: 2.3438vw;
  }
  .programs .programs__list .item-content {
    max-width: 40.625vw;
  }
  .programs .programs__list .item-content__title {
    margin-bottom: 1.1719vw;
  }
  .programs .programs__list .item-content__list {
    margin-bottom: 1.1719vw;
  }
  .programs .programs__list .item-content__list ul {
    max-width: 34.375vw;
    gap: 0.625vw;
  }
  .programs .programs__list .item-content__list ul li {
    border-radius: 4.6875vw;
    padding: 0.7813vw 0.9375vw;
    font-size: 1.0938vw;
  }
  .programs .programs__list .item-content__text {
    font-size: 1.4063vw;
  }
  .programs .programs__list .item-image {
    width: 36.7188vw;
    height: 28.5938vw;
    border-radius: 1.1719vw;
    padding: 0.7813vw;
  }
  .programs .programs__list .item-image img {
    border-radius: 1.1719vw;
  }
}
@media screen and (max-width: 850px) {
  .programs {
    margin-bottom: 17.9487vw;
  }
  .programs .programs__title {
    margin-bottom: 10.2564vw;
  }
  .programs .programs__navigation {
    width: calc(100% + 3.5897vw);
    margin: 0 -1.7949vw 16.6667vw;
    max-width: unset;
  }
  .programs .programs__navigation ul {
    grid-gap: 5.641vw 3.0769vw;
    grid-template-columns: 1fr 1fr;
  }
  .programs .programs__navigation ul li::before {
    top: 2.5641vw;
    border-radius: 3.0769vw;
  }
  .programs .programs__navigation ul li a {
    padding: 5.1282vw 2.5641vw;
    font-size: 4.1026vw;
  }
  .programs .programs__navigation ul li a::before,
  .programs .programs__navigation ul li a::after {
    border-radius: 3.0769vw;
  }
  .programs .programs__list {
    max-width: 100%;
  }
  .programs .programs__list .list-line {
    display: none;
  }
  .programs .programs__list .item {
    gap: 8.2051vw;
  }
  .programs .programs__list .item:not(:first-child) {
    margin-top: 17.9487vw;
  }
  .programs .programs__list .item:nth-child(4n + 1),
  .programs .programs__list .item:nth-child(4n + 2),
  .programs .programs__list .item:nth-child(4n + 3),
  .programs .programs__list .item:nth-child(4n + 4) {
    flex-direction: column-reverse;
  }
  .programs .programs__list .item:nth-child(4n + 1) .item-image::before,
  .programs .programs__list .item:nth-child(4n + 2) .item-image::before,
  .programs .programs__list .item:nth-child(4n + 3) .item-image::before,
  .programs .programs__list .item:nth-child(4n + 4) .item-image::before {
    display: none;
  }
  .programs .programs__list .item-content {
    max-width: 100%;
  }
  .programs .programs__list .item-content__title {
    margin-bottom: 5.1282vw;
  }
  .programs .programs__list .item-content__list {
    margin-bottom: 5.1282vw;
  }
  .programs .programs__list .item-content__list ul {
    gap: 2.0513vw;
    max-width: 100%;
  }
  .programs .programs__list .item-content__list ul li {
    border-radius: 15.3846vw;
    padding: 3.0769vw 4.1026vw;
    font-size: 3.5897vw;
  }
  .programs .programs__list .item-content__text {
    font-size: 4.6154vw;
    letter-spacing: -0.02em;
    display: none;
  }
  .programs .programs__list .item-content__text.item-content__text--mobile {
    display: block;
  }
  .programs .programs__list .item-image {
    width: 89.7436vw;
    height: 69.7436vw;
    border-radius: 4.6154vw;
    padding: 1.5385vw;
  }
  .programs .programs__list .item-image img {
    border-radius: 4.1026vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/pabloo-mobile-pricing-styling/mobile-styling.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;;;EAIE,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EAEb,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,oBAAoB;IACpB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EAGE,cAAc;AAChB;AACA;EAGE,cAAc;AAChB;AACA;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,wBAAwB;IACxB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;;;;;;;;;;;;;;EAmBE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;EAGE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;;EAEE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAAskC;EACtkC,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;;;;;;;;;;;;;;;;;;;IAmBE,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;;IAEE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;;;;;;;;;;;;;;;;;;IAmBE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;;IAEE,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAElB,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,kCAAkC;EACpC;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,kCAAkC;EACpC;AACF;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAE5B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EAEZ,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,yDAA0lE;AAC5lE;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,yDAA0lE;AAC5lE;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,cAAc;IACd,cAAc;EAChB;AACF;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,uBAAuB;IACvB,yCAAyC;EAC3C;EACA;IACE,aAAa;IACb,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAE5B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EAEZ,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,yDAA0lE;AAC5lE;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,yDAA0lE;AAC5lE;AACA;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,2CAA2C;EAC7C;EACA;IACE,aAAa;IACb,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,aAAa;IACb,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,uBAAuB;IACvB,yCAAyC;EAC3C;EACA;IACE,aAAa;IACb,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,UAAU;EACV,oBAAoB;EAEpB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EAEV,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EAGb,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EAEV,2BAA2B;EAC3B,UAAU;EAEV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EAGf,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;AACA;EAEE,wBAAwB;AAC1B;AACA;EAEE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;AACA;EAGE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAEhB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;;EAEE,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EAGd,aAAa;EAGb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;EAEV,2BAA2B;EAE3B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,UAAU;EAEV,wBAAwB;AAC1B;AACA;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EAEV,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EAOE;;;;;0CAKwC;AAC1C;AACA;EAEE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;EAEjB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAGhB,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAEnB,eAAe;EACf,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAGlB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;;IAGE,0BAA0B;EAC5B;EACA;;IAEE,SAAS;EACX;AACF;AACA;EACE;;IAEE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;;IAEE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;;IAEE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;;IAGE,+BAA+B;EACjC;AACF;AACA;EACE;;IAEE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;;IAEE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;;IAEE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;IAEE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;;IAEE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;IACjB,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,4CAA4C;EAC9C;EACA;IAOE;;;;;iDAK6C;EAC/C;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,6CAA6C;EAC/C;EACA;IAOE;;;;;oDAKgD;EAClD;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,aAAa;IACb,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,0BAA0B;IAC1B,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IAEZ,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EAET,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yDAA+jC;EAC/jC,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAGhB,aAAa;EAGb,mBAAmB;AACrB;AACA;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EAGE,aAAa;EAGb,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,aAAa;EAGb,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;;;;;EAME,aAAa;AACf;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EAEE,aAAa;EAEb,0BAA0B;EAC1B,cAAc;AAChB;AACA;;;;EAIE,aAAa;AACf;AACA;;;;;EAKE,cAAc;EACd,kBAAkB;AACpB;AACA;;;;;;EAME,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;EAKE,WAAW;AACb;AACA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EAEb,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;EAKE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;;;;EAIE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;;EAIE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;;;;EAME,aAAa;EAGb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;;IAEE,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IAIE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;;;;;IAKE,kBAAkB;EACpB;EACA;;;;;;IAME,uBAAuB;IACvB,eAAe;EACjB;EACA;;;;;;IAME,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;EACjB;EACA;;;;;IAKE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EAEjB,kDAAkD;EAClD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EAEE,aAAa;EAEb,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EAEE,aAAa;EAEb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EAGE,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EAGb,aAAa;EAGb,mBAAmB;EAGnB,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;AAiDA;;;;;;EAME,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;;;;;;EAME,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;;;;;;EAME,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EAGE,aAAa;EAGb,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;IAErB,yDAAyD;IACzD,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;EAiCA;;;;;;IAME,kBAAkB;EACpB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;;;IAGE,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IAEnB,wDAAwD;IACxD,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;EACnB;EAiCA;;;;;;IAME,iBAAiB;EACnB;EACA;;;;;;IAME,iBAAiB;EACnB;EACA;;;;;;IAME,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;;IAGE,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IAEjB,kDAAkD;IAClD,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;EACb;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IAEE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IAEE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;EAiCA;;;;;;IAME,eAAe;EACjB;EACA;;;;;;IAME,eAAe;EACjB;EACA;;;;;;IAME,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA;;;IAGE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,yDAA+f;AACjgB;AACA;EACE;IACE,yDAAkgB;EACpgB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;;;;;;EAME,mBAAmB;AACrB;AACA;;;EAGE,8BAA8B;AAChC;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;;;;;;IAME,mBAAmB;EACrB;EACA;;;;;;;IAOE,yDAA6V;EAC/V;EACA;;;;;;;IAOE,yDAA6V;EAC/V;EACA;;;;;;IAME,uBAAuB;EACzB;EACA;;;;;;;;IAQE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAE3B,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,SAAS;EAET,sBAAsB;AACxB;AACA;;EAEE,iBAAiB;EAEjB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,eAAe;EAEf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAE9B,2BAA2B;AAC7B;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EAGZ,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EAEE,mBAAmB;EAEnB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAElB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,WAAW;EACX,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;EACX,yDAAkgB;EAClgB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,WAAW;EACX,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IAEV,2CAA2C;IAC3C,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EAEtB,4CAA4C;EAG5C,aAAa;EAIb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EAGxB;uCACqC;EACrC,aAAa;EACb,UAAU;EAEV,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAElB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,SAAS;EACT,WAAW;EACX,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IACE,kBAAkB;EACpB;EACA;;;;;;;IAOE,WAAW;EACb;AACF;AACA;EACE,iBAAiB;EAGjB,aAAa;EAGb,mBAAmB;EACnB,SAAS;AACX;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,QAAQ;IACR,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,0BAA0B;IAE1B,gDAAgD;IAChD,gBAAgB;IAChB,sBAAsB;IAGtB;8CAC0C;IAC1C,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,SAAS;EACX;EACA;IACE,iCAAiC;IACjC,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,8BAA8B;IAC9B,wBAAwB;IAGxB,aAAa;IAIb,sBAAsB;IAEtB,4BAA4B;IAE5B,2BAA2B;EAC7B;EACA;IAEE,wBAAwB;EAC1B;EACA;IACE,WAAW;IAGX,uBAAuB;IAIvB,sBAAsB;IAGtB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,uCAAuC;EACzC;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IAEE,0BAA0B;IAC1B,yDAAsgB;EACxgB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IAEnB,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,0DAAgW;IAChW,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IAExB,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;IAEP,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAEhB,gBAAgB;IAChB,UAAU;IACV,UAAU;IAEV,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;;;;;;IAME,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;IAGb,cAAc;IACd,gBAAgB;IAChB,WAAW;IAGX,mBAAmB;IAGnB,uBAAuB;IAIvB,sBAAsB;IACtB,SAAS;EACX;EACA;IAGE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;;IAEE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;;;IAGE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAE7B,2BAA2B;EAC7B;EACA;IACE,MAAM;EACR;EACA;IACE,QAAQ;IAER,2BAA2B;EAC7B;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;IAER,yCAAyC;EAC3C;EACA;IAEE,oCAAoC;IACpC,UAAU;EACZ;EACA;IACE,WAAW;IAEX,yCAAyC;EAC3C;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,cAAc;EAChB;EACA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;;;;;;IAME,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;;IAGE,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA;;;;;;;;EAQE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;EAGE,oBAAoB;EAEpB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;AACA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,+BAA+B;EAE/B,2BAA2B;AAC7B;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,YAAY;AACd;AACA;EACE,WAAW;EAEX,aAAa;EAEb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EAErB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+CAA+C;EAG/C,aAAa;EAGb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EAEE,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;IAGE,wBAAwB;EAC1B;EACA;;;IAGE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;IAGE,wBAAwB;EAC1B;EACA;;;IAGE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,+CAA+C;IAC/C,WAAW;EACb;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oCAAoC;IACpC,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;;;IAGE,wBAAwB;EAC1B;EACA;;;IAGE,gBAAgB;EAClB;EACA;IAEE,qCAAqC;IACrC,2BAA2B;EAC7B;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,qBAAqB;IAErB,aAAa;IAEb,qCAAqC;IACrC,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE;;IAEE,sBAAsB;EACxB;EACA;;IAEE,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,sBAAsB;EACxB;EACA;;IAEE,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,uBAAuB;EACzB;EACA;;IAEE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAGhB,aAAa;EAGb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;EAGhB,aAAa;EAGb,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EAEE,0BAA0B;AAC5B;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EAEE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EAGV,aAAa;EAGb,qBAAqB;EAGrB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EAGE,aAAa;EAIb,sBAAsB;EAGtB,qBAAqB;AACvB;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,UAAU;EAEV,2BAA2B;EAE3B,2BAA2B;AAC7B;AACA;EAEE,0BAA0B;EAC1B,UAAU;AACZ;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;;;;EAIE,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;AACA;;;;EAIE,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;;;;;;EAME,WAAW;EACX,YAAY;AACd;AACA;;;;;;;;;;EAUE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,0CAA0C;IAE1C,+BAA+B;EACjC;EACA;;;;IAIE,oBAAoB;EACtB;EACA;;;;IAIE,2CAA2C;EAC7C;EACA;;;;IAIE,mCAAmC;EACrC;EACA;;;;;IAKE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;;IAKE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;IAIE,0CAA0C;EAC5C;EACA;;;;;IAKE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;;;;;;;;;;IAUE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;;;;;IAKE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IACE,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAE1B,+BAA+B;EACjC;EACA;;;;IAIE,oBAAoB;EACtB;EACA;;;;IAIE,4CAA4C;EAC9C;EACA;;;;IAIE,mCAAmC;EACrC;EACA;;;;;IAKE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;;IAKE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;IAIE,4CAA4C;EAC9C;EACA;;;;;IAKE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;;;;;;;;;;IAUE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;;IAKE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IAIE,sBAAsB;IAGtB,mBAAmB;IAGnB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IAGE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAE5B,gCAAgC;IAChC,WAAW;EACb;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,4CAA4C;IAE5C,+BAA+B;EACjC;EACA;;;;IAIE,oBAAoB;EACtB;EACA;;;;IAIE,4CAA4C;EAC9C;EACA;;;;IAIE,mCAAmC;EACrC;EACA;;;;;IAKE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;;IAKE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;IAIE,4CAA4C;EAC9C;EACA;;;;;IAKE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;;;;;;;;;;IAUE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;;IAKE,uBAAuB;EACzB;AACF;AAaA;EACE;IACE,UAAU;IAEV,2BAA2B;EAC7B;EACA;IACE,UAAU;IAEV,0BAA0B;EAC5B;AACF;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0DAA0S;AAC5S;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0DAA6S;AAC/S;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;;EAGE,0DAA6S;AAC/S;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,0DAAse;EACte,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,UAAU;AACZ;AACA;EACE,MAAM;AACR;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0DAA61D;EAC71D,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,0DAAsS;AACxS;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;AACA;EACE;IACE,eAAe;IACf,oBAAoB;IACpB,iBAAiB;EACnB;AACF;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EAGb,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,WAAW;IACX,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,aAAa;IACb,SAAS;IACT,WAAW;IACX,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;;;;;;;IAOE,eAAe;EACjB;EACA;;;;;;;IAOE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;EACA;IAGE,aAAa;IAIb,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;;;IAKE,kBAAkB;EACpB;EACA;;;IAGE,cAAc;EAChB;EACA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,0DAA8e;EAChf;EACA;IACE,0BAA0B;IAC1B,UAAU;IACV,gBAAgB;EAClB;EACA;;;IAGE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,wCAAwC;IACxC,4BAA4B;IAE5B,eAAe;IACf,SAAS;IACT,UAAU;IACV,wBAAwB;IACxB,2BAA2B;IAC3B,0DAA6S;EAC/S;EACA;;;IAGE,aAAa;EACf;EACA;IACE,eAAe;IACf,6BAA6B;EAC/B;EACA;IACE,0DAAgwD;EAClwD;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;EACrC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,0DAAkS;IAClS,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IAExB,wCAAwC;EAC1C;EACA;IACE,uBAAuB;IACvB,qCAAqC;EACvC;EACA;IAGE,uBAAuB;IAGvB,2BAA2B;IAI3B,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EAGd,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,mCAAmC;IACnC,oCAAoC;EACtC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,mCAAmC;IACnC,WAAW;IACX,kCAAkC;EACpC;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,oCAAoC;IACpC,oCAAoC;EACtC;EACA;IACE,eAAe;IAGf,mBAAmB;IAGnB,uBAAuB;IAIvB,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EAET,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAElB,aAAa;EAEb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EAEE,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EAExB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,0DAAylB;EACzlB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EAEE,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EAEzB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,0DAAwb;EACxb,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EAEE,+CAA+C;AACjD;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EAGvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;EACZ,0DAAkoB;EACloB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IAEE,yDAAyD;EAC3D;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IAEE,iDAAiD;EACnD;EACA;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IAEE,mDAAmD;EACrD;EACA;IACE,uBAAuB;IACvB,kCAAkC;IAClC,uCAAuC;EACzC;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mCAAmC;EACrC;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IAEE,yDAAyD;EAC3D;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IAEE,iDAAiD;EACnD;EACA;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,cAAc;IACd,eAAe;EACjB;EACA;IAEE,mDAAmD;EACrD;EACA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,qCAAqC;EACvC;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IAEjB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IAEjB,uBAAuB;EACzB;EACA;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IAEE,wCAAwC;EAC1C;EACA;IACE,aAAa;EACf;EACA;IAEE,gDAAgD;EAClD;EACA;IACE,aAAa;EACf;EACA;IAEE,iDAAiD;EACnD;EACA;IACE,uBAAuB;IACvB,kCAAkC;IAClC,2CAA2C;EAC7C;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EAGE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;AACA;EAEE,sCAAsC;AACxC;AACA;EAGE,aAAa;EAGb,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EAGE,aAAa;EAGb,8BAA8B;EAG9B,mBAAmB;AACrB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,qBAAqB;EAGrB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,+CAA+C;EACjD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IAET,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AAWA;EACE;IAEE,yBAAyB;EAC3B;EACA;IAEE,2BAA2B;EAC7B;AACF;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EAGnB,aAAa;EAGb,qBAAqB;EAGrB,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;IACvB,qCAAqC;EACvC;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,qCAAqC;EACvC;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,qCAAqC;IAIrC,8BAA8B;IAG9B,uBAAuB;IAGvB,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EAEX,aAAa;EAGb,oBAAoB;EAEpB,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EAEvB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EAEV,oBAAoB;AACtB;AACA;EACE,UAAU;EAEV,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAE/B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,UAAU;EAEV,yBAAyB;EAEzB,2BAA2B;EAG3B,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0DAA8jB;EAC9jB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAElB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;AACA;EACE,gBAAgB;EAGhB,aAAa;EAGb,uBAAuB;EAEvB,2BAA2B;AAC7B;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EAEV,2BAA2B;AAC7B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;EAEV,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;EAGpC,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EAIvB,sBAAsB;EACtB,UAAU;EACV,oBAAoB;EAEpB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,uBAAuB;IACvB,mCAAmC;EACrC;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,aAAa;IACb,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;;IAEE,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;EACA;IACE,aAAa;IACb,cAAc;IACd,aAAa;IACb,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;;IAEE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;;IAEE,0BAA0B;IAC1B,uBAAuB;IACvB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;EAChB;EACA;IAGE,aAAa;IAGb,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IAGpB,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAElB,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,mCAAmC;EACrC;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,UAAU;EACZ;EACA;;IAEE,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;IAEE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;;IAEE,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EAGnB,aAAa;EAGb,qBAAqB;EAGrB,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE;IACE,uBAAuB;IACvB,qCAAqC;IAIrC,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IAET,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,cAAc;EAChB;AACF;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EAGT,aAAa;EAGb,mBAAmB;AACrB;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,4BAA4B;EAC5B,UAAU;EACV,SAAS;EAET,2BAA2B;AAC7B;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,oBAAoB;AACtB;AACA;EAGE,aAAa;EAGb,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EAGE,aAAa;EAGb,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;;;;;IAME,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;;;;;IAME,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EAGjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;;;;IAIE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;;;;IAIE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,4CAA4C;EAC9C;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;;;;IAIE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;;IAIE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;EACA;IACE,eAAe;IACf,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,oCAAoC;IACpC,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IAGE,aAAa;IAGb,mBAAmB;IAGnB,8BAA8B;IAC9B,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IAGT,aAAa;IAGb,mBAAmB;EACrB;EACA;;;;IAIE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,UAAU;IACV,SAAS;IAET,2BAA2B;EAC7B;EACA;;;;IAIE,sBAAsB;EACxB;EACA;;;;IAIE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAE7B,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;EACX;EACA;;;;IAIE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAElB,2BAA2B;IAC3B,SAAS;IACT,UAAU;EACZ;EACA;;;;IAIE,qBAAqB;EACvB;EACA;;;;IAIE,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;EACA;IAIE,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AASA;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EAEX,aAAa;EAGb,oBAAoB;EAEpB,qCAAqC;EACrC,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,qBAAqB;AACvB;AACA;EAGE,aAAa;EAGb,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAGlB,aAAa;EAGb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,uBAAuB;EAEvB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,sBAAsB;EAEtB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EAGX,aAAa;EAGb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EAEE,8CAA8C;AAChD;AACA;EACE,cAAc;AAChB;AACA;EAEE,sCAAsC;AACxC;AACA;EAGE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,uBAAuB;IACvB,WAAW;IACX,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,sBAAsB;IAEtB,2BAA2B;IAC3B,WAAW;IACX,YAAY;EACd;EACA;IACE,SAAS;IAET,2BAA2B;IAC3B,YAAY;IACZ,YAAY;EACd;EACA;IAEE,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;AACA;EACE;IAEE,yBAAyB;EAC3B;EACA;IAEE,2BAA2B;EAC7B;AACF;AAWA;EACE;IAEE,yBAAyB;EAC3B;EACA;IAEE,4BAA4B;EAC9B;AACF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EAEX,aAAa;EAEb,qCAAqC;EACrC,cAAc;AAChB;AACA;EAGE,aAAa;EAGb,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EAGE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,oBAAoB;EACtB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IAEE,qCAAqC;IACrC,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;IACzB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IAIE,sBAAsB;IACtB,aAAa;IACb,oBAAoB;EACtB;AACF;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EAEX,aAAa;EAEb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EAEE,qCAAqC;EACrC,eAAe;AACjB;AACA;EAGE,aAAa;EACb,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAEhB,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EAEX,aAAa;EAEb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;;;;;IAKE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;;;;;IAKE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IAEX,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,yBAAyB;IACzB,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IAEE,0BAA0B;IAC1B,SAAS;EACX;EACA;IAGE,aAAa;IAIb,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;;;;;IAKE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAGhC,aAAa;EAGb,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EAQnB,+DAA+D;EAC/D,gBAAgB;EAGhB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,eAAe;AACjB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,8CAA8C;EAChD;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,8CAA8C;IAC9C,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iCAAiC;IACjC,sBAAsB;EACxB;EACA;;;;IAIE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,iCAAiC;IACjC,sBAAsB;EACxB;EACA;;;;IAIE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;;IAEE,aAAa;IAIb,mBAAmB;IAGnB,mBAAmB;IAGnB,8BAA8B;EAChC;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,MAAM;IAGN,uBAAuB;IAIvB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IAGpB,uBAAuB;IAGvB,2BAA2B;IAI3B,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,iCAAiC;IACjC,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;;;;IAIE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;EAC9B,sBAAsB;EACtB,UAAU;AACZ;AACA;EAIE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,8BAA8B;IAC9B,aAAa;EACf;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IAGE,uBAAuB;IAGvB,2BAA2B;IAI3B,8BAA8B;IAC9B,UAAU;IACV,aAAa;EACf;EACA;IAIE,8BAA8B;IAC9B,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EAGnB,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EAEb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;IAC5B,kCAAkC;EACpC;EACA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IAGE,uBAAuB;IAGvB,2BAA2B;IAI3B,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IAGE,aAAa;IAIb,sBAAsB;EACxB;EACA;IAGE,aAAa;IACb,4BAA4B;EAC9B;EACA;IAGE,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,qBAAqB;IACrB,qBAAqB;IACrB,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,8BAA8B;EAChC;EACA;IAGE,uBAAuB;IAIvB,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IAGE,aAAa;IAGb,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,oBAAoB;IAGpB,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAElB,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;AACA;EAEE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EAGE,aAAa;EAGb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,mCAAmC;AACrC;AACA;EACE,sBAAsB;AACxB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IAGE,uBAAuB;IAIvB,sBAAsB;IACtB,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IAGE,aAAa;IAGb,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,oBAAoB;IAGpB,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAElB,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,oBAAoB;IACpB,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0DAAsS;EACtS,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,gBAAgB;EAGhB,aAAa;EAGb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAGhB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EAEE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EAEX,aAAa;EAEb,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,UAAU;AACZ;AACA;EAEE,aAAa;EAEb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;;;;;;;EAOE,YAAY;EACZ,aAAa;EAEb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AA6EA;;;;;;;EAOE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;AACA;;;;;;;EAOE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;AACA;;;;;;;EAOE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;AACA;;;;;;EAME,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;;;EAME,WAAW;EACX,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,WAAW;EACX,0DAAsR;EACtR,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,eAAe;EAGf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EAEZ,gBAAgB;EAEhB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,mCAAmC;EACrC;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;;;;;;;IAOE,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;EACpB;EAqEA;;;;;;;IAOE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;;;;;;;;;;;IAWE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;;;;;;;;;;;IAWE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;;;;;;IAME,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;;;;;;;IAOE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;EACnB;EAqEA;;;;;;;IAOE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;;;;;;;;;;;IAWE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;;;;;;;;;;;IAWE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;;;;;;IAME,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;EACA;IAGE,aAAa;IAIb,sBAAsB;IACtB,eAAe;IACf,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IAGE,QAAQ;IACR,gBAAgB;IAChB,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IAGE,QAAQ;IACR,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,QAAQ;IAER,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IAGE,QAAQ;IACR,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IAGE,QAAQ;IACR,oBAAoB;EACtB;EACA;IAGE,QAAQ;IACR,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IAEE,qCAAqC;IACrC,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,wBAAwB;IACxB,eAAe;IACf,uBAAuB;IACvB,oCAAoC;EACtC;EACA;IACE,gBAAgB;IAChB,iBAAiB;IAEjB,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IAEE,mBAAmB;EACrB;EACA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;IAEE,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;EACA;IAEE,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;;;;;;;IAOE,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;EACrB;EAqEA;;;;;;;IAOE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;;;;;;;;;;IAWE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;;;;;;;;;;IAWE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;;;;;IAME,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;EACpB;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EAGxB,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAE7B,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EAEnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAElB,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IAEnB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IAGvB,mBAAmB;IAGnB,uBAAuB;IAEvB,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,gCAAgC;IAChC,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;EACA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;AACF;AACA;EAGE,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAGlB,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,oCAAoC;IAGpC,2BAA2B;IAI3B,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;EACzB;AACF;AACA;EAGE,QAAQ;AACV;AACA;EAGE,QAAQ;AACV;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EAEzB,2BAA2B;AAC7B;AACA;EAOE;;;;;0CAKwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4CAA4C;EAC9C;EACA;IAOE;;;;;iDAK6C;EAC/C;EACA;IAGE,aAAa;IAGb,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE;IAEE,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,6CAA6C;EAC/C;EACA;IAOE;;;;;oDAKgD;EAClD;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;EAC5B;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAGlB,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,mCAAmC;IAInC,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IAEE,qCAAqC;IACrC,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;EACzB;AACF;AACA;EAGE,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;EAGpB,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,gBAAgB;EAGhB,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,YAAY;EACd;AACF;AACA;EACE;IACE,uBAAuB;IACvB,mCAAmC;IAGnC,2BAA2B;IAI3B,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IAGpB,uBAAuB;IAGvB,2BAA2B;IAI3B,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;EACtB;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EAGb,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EAGpC,aAAa;EAGb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,mCAAmC;EACrC;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,gCAAgC;IAGhC,2BAA2B;IAI3B,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAE1B,2BAA2B;AAC7B;AACA;EAOE;;;;;0CAKwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EAGZ,aAAa;EAGb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4CAA4C;EAC9C;EACA;IAOE;;;;;kDAK8C;EAChD;EACA;IACE,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4CAA4C;EAC9C;EACA;IAOE;;;;;iDAK6C;EAC/C;EACA;IACE,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE;IAEE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,wCAAwC;EAC1C;EACA;IAOE;;;;;4CAKwC;EAC1C;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;AACA;;;EAGE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;;;IAGE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;IAEE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;;;IAGE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;;IAEE,sBAAsB;IACtB,qBAAqB;EACvB;EACA;;IAEE,YAAY;IACZ,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;IAEZ,iBAAiB;EACnB;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,cAAc;AAChB;AACA;EAGE,aAAa;EAGb,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,0DAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,yCAAyC;EAC3C;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,2CAA2C;IAC3C,mCAAmC;IACnC,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,sCAAsC;IACtC,8BAA8B;IAC9B,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,QAAQ;IAER,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IAEV,0BAA0B;IAC1B,eAAe;IACf,YAAY;EACd;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAGhB,aAAa;EACb,SAAS;EAGT,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EAGb,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kCAAkC;IAClC,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;EACtB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,kCAAkC;IAClC,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,oCAAoC;EACtC;EACA;IAGE,uBAAuB;IAGvB,2BAA2B;IAI3B,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,YAAY;IAIZ,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,eAAe;IACf,aAAa;IACb,eAAe;EACjB;AACF;AACA;EACE,wBAAwB;EACxB,uDAAuD;AACzD;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EAGE,aAAa;EACb,UAAU;EACV,kBAAkB;EAGlB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IAIE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EAGxB,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAE7B,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,eAAe;EAGf,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,0DAAsvB;EACtvB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,UAAU;EAEV,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,+BAA+B;IAC/B,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;IACd,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gCAAgC;IAChC,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IAGvB,mBAAmB;IAGnB,uBAAuB;IAEvB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,wBAAwB;IACxB,gCAAgC;IAChC,wBAAwB;IACxB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IAEE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,+BAA+B;IAC/B,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;AACA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EAGE,aAAa;EACb,QAAQ;EAGR,mBAAmB;EAGnB,uBAAuB;EAGvB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EAGT,uBAAuB;EAGvB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EAET,2BAA2B;EAC3B,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EAET,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,0DAAoV;AACtV;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,wCAAwC;IACxC,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,sCAAsC;IACtC,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,wCAAwC;IACxC,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,2CAA2C;IAC3C,sBAAsB;IACtB,mCAAmC;EACrC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,wCAAwC;IACxC,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,uBAAuB;IACvB,mCAAmC;IACnC,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,4BAA4B;IAC5B,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,oCAAoC;EACtC;EACA;IACE,2BAA2B;IAC3B,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;EAClC;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,YAAY;IAIZ,sBAAsB;EACxB;EACA;IACE,yCAAyC;IACzC,sBAAsB;IACtB,kCAAkC;EACpC;EACA;IACE,6BAA6B;IAC7B,oBAAoB;EACtB;EACA;IACE,sCAAsC;IACtC,wBAAwB;IACxB,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,wCAAwC;IACxC,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;IACd,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EAGE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EAGnB,aAAa;EAIb,sBAAsB;EAGtB,uBAAuB;EAGvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wCAAwC;IACxC,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4CAA4C;IAC5C,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IAIE,sBAAsB;IAGtB,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,uDAAuD;AACzD;AACA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EAEZ,mBAAmB;EAEnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,cAAc;EAChB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,kCAAkC;IAClC,qCAAqC;EACvC;EACA;IACE,cAAc;IACd,uDAAuD;EACzD;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IAGE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,oBAAoB;AACtB;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0DAAoa;EACpa,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EAGzB,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;AAChC;AACA;EAGE,aAAa;EAGb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAGhB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,WAAW;EACX,+BAA+B;EAE/B,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,4CAA4C;EAC9C;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,sBAAsB;EACxB;EACA;IAGE,uBAAuB;IACvB,aAAa;IACb,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;;;IAGE,WAAW;EACb;EACA;;;;IAIE,0BAA0B;EAC5B;EACA;;;;;;;;IAQE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,SAAS;IAET,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,6CAA6C;IAG7C,mBAAmB;IAInB,sBAAsB;IAGtB,uBAAuB;EACzB;EACA;IAGE,mBAAmB;IAInB,sBAAsB;IAGtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,uCAAuC;EACvC,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAKE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;AACA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0DAAiS;EACjS,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;;;;;;EAME,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;;;;EAME,aAAa;EAGb,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EAEZ,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;;;;IAIE,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;;;;IAIE,uBAAuB;EACzB;EACA;;;;;;IAME,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;EACxB;EACA;;;;;;IAME,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;;;;IAIE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;;;;IAIE,MAAM;IACN,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;;;;IAIE,uBAAuB;EACzB;EACA;;;;;;IAME,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;EACxB;EACA;;;;;;IAME,aAAa;IACb,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;;;;IAIE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IAGE,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;EAC1B;EACA;;;;IAIE,aAAa;IACb,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,oBAAoB;EACtB;EACA;;;;IAIE,uBAAuB;EACzB;EACA;;;;IAIE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;;;;;IAME,mBAAmB;IACnB,wBAAwB;IACxB,sBAAsB;EACxB;EACA;;;;;;IAME,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;;;;IAIE,oBAAoB;EACtB;EACA;;;;IAIE,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,YAAY;EACd;EACA;;;;;IAKE,WAAW;IACX,YAAY;IAEZ,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EAGnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EAGE,aAAa;EAGb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAGlB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EAGE,aAAa;EAGb,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EAGE,aAAa;EAGb,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IAGE,uBAAuB;IAGvB,2BAA2B;IAI3B,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,0DAAwa;EACxa,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EAGE,aAAa;EAGb,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAGhB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IAGE,uBAAuB;IAGvB,2BAA2B;IAI3B,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAGhB,aAAa;EAGb,2BAA2B;AAC7B;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IAGE,uBAAuB;IAGvB,2BAA2B;IAI3B,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EAEE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,UAAU;EAGV,aAAa;EAGb,qBAAqB;EAGrB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,UAAU;EAEV,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;EAEjB,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,UAAU;EAEV,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,SAAS;EACT,WAAW;EACX,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EAGE,aAAa;EAGb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IAEE,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;AACT;AACA;EACE,mBAAmB;AACrB;AACA;EAGE,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;AAChC;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,0DAA+iB;AACjjB;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;IACR,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;;IAKE,sBAAsB;IAGtB,mBAAmB;IAGnB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAElB,aAAa;EAEb,gCAAgC;EAChC,UAAU;EAGV,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EAGE,aAAa;EAGb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EAEnB,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;AACA;EAEE,qCAAqC;EACrC,SAAS;EAGT,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;EAElB,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EAGf,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EAEE,0BAA0B;AAC5B;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IAExB,kCAAkC;IAClC,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,mCAAmC;EACrC;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;EACA;IAEE,0BAA0B;IAC1B,UAAU;IACV,YAAY;EACd;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IAEvB,mCAAmC;IACnC,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,mCAAmC;EACrC;EACA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;EACA;IAEE,0BAA0B;IAC1B,UAAU;IACV,UAAU;EACZ;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAGhB,aAAa;IAIb,sBAAsB;IAGtB,uBAAuB;IAGvB,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,mCAAmC;EACrC;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,OAAO;IACP,QAAQ;IACR,eAAe;EACjB;EACA;IAEE,0BAA0B;IAC1B,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EAGb,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EAEE,aAAa;EAEb,+BAA+B;EAC/B,SAAS;EAGT,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;EAEjB,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;;;IAGE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;;IAGE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;;IAGE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;;;IAGE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;;IAGE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;;IAGE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;;;IAGE,kBAAkB;IAClB,oBAAoB;IACpB,iCAAiC;EACnC;EACA;;;IAGE,kBAAkB;EACpB;EACA;IAEE,kCAAkC;IAClC,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAGhB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;;IAGE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;;IAGE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;;;IAGE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;;IAGE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;;;IAGE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;EACnC;EACA;;;IAGE,mBAAmB;EACrB;EACA;IAEE,aAAa;IAEb,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;AACF;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EAEE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EAEE,0BAA0B;EAC1B,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EAEE,aAAa;EAEb,2CAA2C;EAC3C,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EAGvB,aAAa;EACb,SAAS;EAGT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EAET,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,0DAAoY;AACtY;AACA;;;EAGE,0DAAqY;AACvY;AACA;EAEE,aAAa;EAEb,2CAA2C;EAC3C,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,sCAAsC;EACxC;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IAEE,mCAAmC;IACnC,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gCAAgC;IAChC,mBAAmB;EACrB;EACA;;;IAIE,0BAA0B;IAC1B,YAAY;IACZ,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,oDAAoD;EACtD;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,sCAAsC;EACxC;EACA;IAEE,6CAA6C;IAC7C,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IAEE,6CAA6C;IAC7C,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,sCAAsC;EACxC;EACA;IACE,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAGhB,aAAa;IAIb,sBAAsB;IAGtB,uBAAuB;IAGvB,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iCAAiC;IACjC,qBAAqB;EACvB;EACA;IACE,OAAO;IACP,QAAQ;IACR,eAAe;EACjB;EACA;;;IAIE,0BAA0B;IAC1B,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,cAAc;IAGd,mBAAmB;IAGnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,oDAAoD;EACtD;EACA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,6CAA6C;IAC7C,eAAe;IACf,cAAc;IACd,qBAAqB;EACvB;EACA;IAEE,mDAAmD;IACnD,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IAEE,mDAAmD;IACnD,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EAEE,aAAa;EAEb,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EAGvB,aAAa;EACb,SAAS;EAGT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EAET,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,0DAAoY;AACtY;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0DAAqY;AACvY;AACA;EAEE,aAAa;EAEb,2CAA2C;EAC3C,WAAW;EACX,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;EACA;IAEE,8CAA8C;IAC9C,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IAEE,8CAA8C;IAC9C,cAAc;IACd,iCAAiC;IACjC,2DAA2D;EAC7D;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,wCAAwC;IACxC,cAAc;IACd,eAAe;EACjB;EACA;IAEE,mDAAmD;IACnD,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IAGE,kBAAkB;EACpB;EACA;IAEE,aAAa;IAEb,mDAAmD;IACnD,cAAc;IACd,mCAAmC;IACnC,2DAA2D;EAC7D;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EAGX,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EAGE,aAAa;EACb,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EAEpB,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;EAEnB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EAEE,0BAA0B;AAC5B;AACA;EACE,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,mCAAmC;IACnC,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,wCAAwC;IACxC,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uCAAuC;IACvC,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;EACA;IACE,2BAA2B;IAC3B,cAAc;IAEd,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;EACjB;EACA;IAIE,sBAAsB;IACtB,aAAa;IACb,yCAAyC;IACzC,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,wCAAwC;IACxC,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IAIE,sBAAsB;IACtB,SAAS;EACX;EACA;;;;;IAKE,WAAW;EACb;EACA;IACE,uCAAuC;IACvC,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,WAAW;EACb;EACA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;EACA;IACE,SAAS;EACX;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAG7B,aAAa;EAGb,uBAAuB;EAGvB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA6S;EAC7S,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,WAAW;EAEX,4BAA4B;EAC5B,6BAA6B;EAE7B,2BAA2B;AAC7B;AACA;EACE;IAEE,0BAA0B;EAC5B;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IAEE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,MAAM;IACN,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAEhB,gCAAgC;EAClC;AACF;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAGhB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,yCAAyC;IACzC,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IAGb,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IAIE,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;IACV,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,uBAAuB;EAEvB,eAAe;EACf,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EAGE,aAAa;EAGb,qBAAqB;EAGrB,uBAAuB;AACzB;AACA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;;IAEE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;AACF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0DAAmjC;EACnjC,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EAGE,aAAa;EAGb,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EAEZ,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EAEE,aAAa;EAEb,qCAAqC;EACrC,mBAAmB;EAGnB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EAEvB,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EAGV,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EAEnB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,WAAW;EAQX,6DAA6D;AAC/D;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EAEtB,2BAA2B;EAC3B,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EAGX,aAAa;EAGb,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;EAKE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAKE,2BAA2B;AAC7B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAGhB,aAAa;EAGb,mBAAmB;EAGnB,2BAA2B;EAE3B,eAAe;EACf,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAGlB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAE1B,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;;;;IAOE,8BAA8B;EAChC;EACA;;;;IAIE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  --gray: #2f2f2f;\n  --gray-2: #444340;\n  --gray-3: #7f7e7c;\n  --gray-4: #ccc;\n  --yellow: #16a34a40;\n  --dark: #16a34a;\n  --dark-2: #2f2f2f;\n  --light-gray: #f6f5ef;\n  --beige: #f6f5ef;\n  --beige-2: #ffdebf;\n  --beige-3: #a6a4a2;\n  --white: #fff;\n  --white-2: #e9e4dc;\n  --green: #4dae9b;\n  --green-2: #2e685d;\n  --purple: #d095ff;\n  --pink: #ffc2d6;\n  --black: #000;\n  --blue: #b1e1f5;\n}\n\nhtml {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit;\n  list-style: none;\n  -webkit-tap-highlight-color: transparent;\n  /* min-width: 0; */\n  /* min-height: 0; */\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nul,\nol,\nli,\nbutton,\nblockquote {\n  margin: 0;\n  padding: 0;\n}\n\na {\n  display: inline-block;\n  color: inherit;\n  text-decoration: none;\n}\n\nli {\n  list-style: none;\n}\n\nimg {\n  max-width: 100%;\n  display: block;\n}\n\nbutton {\n  background-color: transparent;\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border-radius: unset;\n  cursor: pointer;\n}\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n  font-family: \"Circular Std\";\n}\nbody.no-scroll {\n  overflow: hidden;\n}\nbody.page-template-memberships {\n  background-color: var(--dark);\n}\n\n.container {\n  width: 100%;\n  max-width: 1330px;\n  /* margin: 0 auto; */\n  /* padding: 0 20px; */\n}\n.container.solid-background {\n  width: 100%;\n  max-width: 1330px;\n  background-color: #faf2eb;\n}\n@media screen and (max-width: 1330px) {\n  .container {\n    max-width: 100vw;\n    /* padding: 0 1.5038vw; */\n  }\n}\n@media screen and (max-width: 1280px) {\n  .container {\n    max-width: 85.1563vw;\n    /* padding: 0 1.5625vw; */\n  }\n}\n@media screen and (max-width: 850px) {\n  .container {\n    max-width: 100%;\n    /* padding: 0 5.1282vw; */\n  }\n}\n\n.general-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  gap: 50px;\n}\n@media screen and (max-width: 1330px) {\n  .general-wrapper {\n    gap: 3.7594vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-wrapper {\n    gap: 3.9063vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-wrapper {\n    gap: 7.6923vw;\n  }\n}\n\n#wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n}\n#wrapper header {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n#wrapper main {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n}\n#wrapper footer {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n:root {\n  --paddingList: 15px;\n  --figureOffset: 11px;\n  --widthFigure: 5px;\n  --heightFigure: 5px;\n  --bgFigure: var(--dark);\n}\n\n.title {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.5px;\n  font-size: 50px;\n  color: var(--dark);\n}\n@media screen and (max-width: 1330px) {\n  .title {\n    letter-spacing: -0.0376vw;\n    font-size: 3.7594vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .title {\n    font-size: 2.9688vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .title {\n    font-size: 8.2051vw;\n    letter-spacing: -0.0821vw;\n  }\n}\n\n.small-title {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  font-size: 40px;\n  letter-spacing: -0.4px;\n  line-height: 1.2;\n  color: var(--dark);\n}\n@media screen and (max-width: 1330px) {\n  .small-title {\n    font-size: 3.0075vw;\n    letter-spacing: -0.0301vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .small-title {\n    font-size: 2.1875vw;\n    letter-spacing: -0.0219vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .small-title {\n    font-size: 7.7778vw;\n    letter-spacing: -0.4103vw;\n  }\n}\n\n.small-text {\n  font-weight: 400;\n  line-height: 1.5;\n  font-size: 20px;\n  color: var(--dark-2);\n}\n@media screen and (max-width: 1330px) {\n  .small-text {\n    font-size: 1.5038vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .small-text {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .small-text {\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n  }\n}\n\n.subtext {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  font-size: 20px;\n  color: var(--gray);\n}\n@media screen and (max-width: 1330px) {\n  .subtext {\n    letter-spacing: -0.015vw;\n    font-size: 1.5038vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .subtext {\n    font-size: 1.4063vw;\n    letter-spacing: -0.0078vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .subtext {\n    font-size: 4.6154vw;\n    letter-spacing: -0.0462vw;\n  }\n}\n\n.text {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--gray);\n}\n.text\n  *:not(\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    img,\n    ul,\n    ol,\n    li,\n    blockquote,\n    iframe,\n    a,\n    span,\n    .blockquote,\n    .blockquote *\n  ) {\n  margin-bottom: 32px;\n}\n.text *:last-child {\n  margin-bottom: 0;\n}\n.text h1,\n.text h2,\n.text h3 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--dark);\n}\n.text h1 {\n  letter-spacing: -0.56px;\n  font-size: 56px;\n}\n.text h2 {\n  font-size: 50px;\n  letter-spacing: -0.5px;\n}\n.text h3 {\n  letter-spacing: -0.4px;\n  font-size: 40px;\n  margin-bottom: 32px;\n}\n.text h3.bg-title {\n  margin-bottom: 16px;\n}\n.text h3 span {\n  display: inline-block;\n  background-color: var(--pink);\n  border-radius: 16px;\n  padding: 16px 24px;\n}\n.text h4,\n.text h5,\n.text h6 {\n  font-family: \"Circular Std\";\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--dark);\n}\n.text h4 {\n  letter-spacing: -0.32px;\n  font-size: 32px;\n}\n.text h5,\n.text h6 {\n  letter-spacing: -0.24px;\n  font-size: 24px;\n}\n.text a {\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  text-underline-offset: 6px;\n}\n.text blockquote {\n  background: var(--light-gray);\n  border-radius: 24px;\n  padding: 74px 116px;\n  font-family: \"Circular Std\";\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.28px;\n  font-size: 28px;\n  color: var(--dark);\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n.text blockquote::before {\n  content: \"\";\n  position: absolute;\n  top: 35px;\n  left: 37px;\n  width: 60px;\n  height: 47px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='40' fill='none'%3E%3Cpath fill='%23161616' fill-rule='evenodd' d='M45.425 15.806c.83-.181 1.691-.277 2.575-.277 6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12s-12-5.372-12-12c0-.937.108-1.85.311-2.726l.087-.663c.103-.79.351-2.083.798-3.715.74-2.705 1.791-5.412 3.219-7.961.297-.53.608-1.05.934-1.557a31.46 31.46 0 0 1 3.078-4.013c2.548-2.834 8.18-6.628 8.18-6.628a1.412 1.412 0 0 1 2.04.425l1.56 2.53a1.65 1.65 0 0 1-.428 2.19s-5.656 4.121-6.89 5.494a25.481 25.481 0 0 0-2.493 3.247 23.749 23.749 0 0 0-.971 1.654Zm-36 0c.83-.181 1.691-.277 2.575-.277 6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12s-12-5.372-12-12c0-.937.108-1.85.311-2.726l.087-.663c.103-.79.351-2.083.798-3.715.74-2.705 1.791-5.412 3.219-7.961.297-.53.608-1.05.934-1.557a31.465 31.465 0 0 1 3.078-4.013c2.548-2.834 8.18-6.628 8.18-6.628a1.412 1.412 0 0 1 2.04.425l1.56 2.53a1.65 1.65 0 0 1-.428 2.19s-5.656 4.121-6.89 5.494a25.481 25.481 0 0 0-2.493 3.247 23.728 23.728 0 0 0-.971 1.654Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  pointer-events: none;\n}\n.text img {\n  max-width: 100%;\n  height: auto;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.text .alignleft {\n  float: left;\n}\n.text .alignright {\n  float: right;\n}\n.text .aligncenter {\n  margin: 0 auto;\n}\n.text ul li {\n  padding-left: var(--paddingList);\n  position: relative;\n  z-index: 2;\n}\n.text ul li::after {\n  content: \"\";\n  position: absolute;\n  top: var(--figureOffset);\n  left: 0;\n  width: var(--widthFigure);\n  height: var(--heightFigure);\n  border-radius: 50%;\n  background-color: var(--bgFigure);\n}\n.text ul li ol {\n  counter-reset: numUl;\n}\n.text ul li ol li {\n  padding-left: 0;\n}\n.text ul li ol li::after {\n  display: none;\n}\n.text ul li ol li::before {\n  counter-increment: numUl;\n  content: counters(numUl, \".\") \".\";\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n}\n.text ol {\n  counter-reset: numOl;\n}\n.text ol li::before {\n  counter-increment: numOl;\n  content: counters(numOl, \".\") \".\";\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n}\n.text ol li ol {\n  padding-left: var(--paddingList);\n}\n.text ol li ul {\n  padding-left: var(--paddingList);\n}\n.text ol li ul li {\n  padding-left: var(--paddingList);\n  position: relative;\n  z-index: 2;\n}\n.text ol li ul li::after {\n  content: \"\";\n  position: absolute;\n  top: var(--figureOffset);\n  left: 0;\n  width: var(--widthFigure);\n  height: var(--heightFigure);\n  border-radius: 50%;\n  background-color: var(--bgFigure);\n}\n.text ol li ul li::before {\n  display: none;\n}\n\n@media screen and (max-width: 1330px) {\n  :root {\n    --paddingList: 1.1278vw;\n    --figureOffset: 0.8271vw;\n    --widthFigure: 0.3759vw;\n    --heightFigure: 0.3759vw;\n  }\n  .text {\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n  }\n  .text\n    *:not(\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6,\n      img,\n      ul,\n      ol,\n      li,\n      blockquote,\n      iframe,\n      a,\n      span,\n      .blockquote,\n      .blockquote *\n    ) {\n    margin-bottom: 2.406vw;\n  }\n  .text h1 {\n    letter-spacing: -0.0421vw;\n    font-size: 4.2105vw;\n  }\n  .text h2 {\n    font-size: 3.7594vw;\n    letter-spacing: -0.0376vw;\n  }\n  .text h3 {\n    letter-spacing: -0.0301vw;\n    font-size: 3.0075vw;\n    margin-bottom: 2.406vw;\n  }\n  .text h3.bg-title {\n    margin-bottom: 1.203vw;\n  }\n  .text h3 span {\n    border-radius: 1.203vw;\n    padding: 1.203vw 1.8045vw;\n  }\n  .text h4 {\n    letter-spacing: -0.0241vw;\n    font-size: 2.406vw;\n  }\n  .text h5,\n  .text h6 {\n    letter-spacing: -0.018vw;\n    font-size: 1.8045vw;\n  }\n  .text blockquote {\n    border-radius: 1.8045vw;\n    padding: 5.5639vw 8.7218vw;\n    letter-spacing: -0.0211vw;\n    font-size: 2.1053vw;\n  }\n  .text blockquote::before {\n    top: 2.6316vw;\n    left: 2.782vw;\n    width: 4.5113vw;\n    height: 3.5338vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  :root {\n    --paddingList: 2.5641vw;\n    --figureOffset: 2.0513vw;\n    --widthFigure: 1.0256vw;\n    --heightFigure: 1.0256vw;\n  }\n  .text {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .text\n    *:not(\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6,\n      img,\n      ul,\n      ol,\n      li,\n      blockquote,\n      iframe,\n      a,\n      span,\n      .blockquote,\n      .blockquote *\n    ) {\n    margin-bottom: 6.1538vw;\n  }\n  .text h1 {\n    letter-spacing: -0.0923vw;\n    font-size: 9.2308vw;\n  }\n  .text h2 {\n    font-size: 8.2051vw;\n    letter-spacing: -0.0821vw;\n  }\n  .text h3 {\n    letter-spacing: -0.0718vw;\n    font-size: 7.1795vw;\n    margin-bottom: 6.1538vw;\n  }\n  .text h3.bg-title {\n    margin-bottom: 4.1026vw;\n  }\n  .text h3 span {\n    border-radius: 4.1026vw;\n    padding: 2.5641vw 6.1538vw;\n  }\n  .text h4 {\n    letter-spacing: -0.0667vw;\n    font-size: 6.6667vw;\n  }\n  .text h5,\n  .text h6 {\n    letter-spacing: -0.0513vw;\n    line-height: 1.5;\n    font-size: 5.1282vw;\n  }\n  .text blockquote {\n    border-radius: 4.1026vw;\n    padding: 20.5128vw 5.1282vw;\n    letter-spacing: -0.0718vw;\n    font-size: 5.1282vw;\n  }\n  .text blockquote::before {\n    top: 3.8462vw;\n    left: 3.8462vw;\n    width: 12.8205vw;\n    height: 12.8205vw;\n  }\n}\n.page-template-memberships .btn:hover {\n  background-color: var(--white);\n  color: var(--dark);\n}\n\n.btn {\n  font-family: \"Circular Std\";\n  font-size: 17px;\n  font-weight: 500;\n  color: var(--dark);\n  text-align: center;\n  background-color: var(--yellow);\n  border-radius: 12px;\n  padding: 18px 24px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.btn:hover {\n  background-color: var(--dark);\n  color: var(--white);\n}\n.btn.btn--dark {\n  background-color: var(--dark);\n  color: var(--white);\n}\n.btn.btn--dark:hover {\n  background-color: var(--gray);\n}\n@media screen and (max-width: 1330px) {\n  .btn {\n    font-size: 1.2782vw;\n    border-radius: 0.9023vw;\n    padding: 1.3534vw 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .btn {\n    padding: 1.25vw 2.1094vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .btn {\n    font-size: 4.359vw;\n    border-radius: 3.0769vw;\n    padding: 4.6154vw 6.1538vw;\n  }\n}\n\n.btn-border {\n  font-family: \"Circular Std\";\n  font-size: 17px;\n  font-weight: 500;\n  color: var(--dark);\n  text-align: center;\n  padding: 15px 22px;\n  border-radius: 12px;\n  border: 2px solid var(--dark);\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.btn-border:hover {\n  background-color: var(--dark);\n  color: var(--white);\n}\n@media screen and (max-width: 1330px) {\n  .btn-border {\n    font-size: 1.2782vw;\n    padding: 1.1278vw 1.6541vw;\n    border-radius: 0.9023vw;\n    border: 0.1504vw solid var(--dark);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .btn-border {\n    padding: 1.25vw 1.9531vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .btn-border {\n    font-size: 4.359vw;\n    padding: 3.8462vw 5.641vw;\n    border-radius: 3.0769vw;\n    border: 0.5128vw solid var(--dark);\n  }\n}\n\n.btn-shopify {\n  font-family: \"Circular Std\";\n  font-size: 17px;\n  font-weight: 500;\n  color: var(--dark);\n  text-align: center;\n  position: relative;\n  background-color: var(--yellow);\n  border-radius: 12px;\n  padding: 18px 24px 18px 46px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.btn-shopify::after {\n  content: \"\";\n  position: absolute;\n  left: 17px;\n  top: 50%;\n  width: 22px;\n  height: 25px;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='22' height='25' viewBox='0 0 22 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.2587 4.50055C18.1711 4.50055 16.3308 4.35347 16.3308 4.35347C16.3308 4.35347 15.0552 3.07876 14.9091 2.93168C14.8799 2.90226 14.8312 2.87284 14.7923 2.86304L13.877 24.0919L21.0826 22.5133C21.0826 22.5133 18.4827 4.81433 18.4632 4.69666C18.4437 4.579 18.3366 4.51036 18.249 4.50055H18.2587Z' fill='black'/%3E%3Cpath d='M14.382 2.8632C14.382 2.8632 14.0996 2.95145 13.6614 3.08873C13.233 1.85324 12.4832 0.715801 11.1492 0.715801C11.1103 0.715801 11.0713 0.715801 11.0421 0.715801C10.6623 0.21572 10.195 0 9.79573 0C6.709 0 5.22893 3.89278 4.76154 5.86369C3.56385 6.2363 2.70697 6.50104 2.59986 6.54027C1.92799 6.75599 1.90851 6.7756 1.82088 7.41296C1.75271 7.89342 0 21.5525 0 21.5525L13.5349 24.1019L14.4502 2.8534C14.4502 2.8534 14.4015 2.86321 14.382 2.87301V2.8632ZM10.9447 3.80453C10.9447 3.80453 10.9447 3.89278 10.9447 3.94181C10.195 4.17714 9.37702 4.43208 8.55909 4.68703C9.01674 2.90243 9.88337 2.03954 10.6331 1.71596C10.8181 2.19643 10.9447 2.88282 10.9447 3.81434V3.80453ZM9.71783 0.833468C9.85415 0.833468 9.98074 0.882494 10.1171 0.970744C9.12386 1.44141 8.06249 2.61807 7.61457 4.98119C6.96217 5.18711 6.31951 5.38322 5.72554 5.56952C6.25135 3.76531 7.49773 0.833468 9.71783 0.833468ZM10.2436 11.3548C10.2436 11.3548 9.44519 10.9233 8.46172 10.9233C7.0206 10.9233 6.95244 11.8352 6.95244 12.0608C6.95244 13.3061 10.1852 13.7865 10.1852 16.7184C10.1852 19.0227 8.73436 20.5033 6.77716 20.5033C4.43047 20.5033 3.23279 19.0325 3.23279 19.0325L3.86571 16.9439C3.86571 16.9439 5.10235 18.0127 6.1345 18.0127C6.81611 18.0127 7.08876 17.4734 7.08876 17.0812C7.08876 15.4535 4.43047 15.375 4.43047 12.6981C4.43047 10.4429 6.03713 8.26603 9.27965 8.26603C10.526 8.26603 11.1492 8.62884 11.1492 8.62884L10.2339 11.3646L10.2436 11.3548ZM11.7529 3.68687C11.7529 3.60842 11.7529 3.52017 11.7529 3.43192C11.7529 2.66709 11.6458 2.03954 11.4803 1.54927C12.1619 1.63752 12.6195 2.42196 12.9117 3.32406C12.5709 3.43192 12.1814 3.54959 11.7529 3.68687Z' fill='black'/%3E%3C/svg%3E%0A\");\n}\n.btn-shopify:hover {\n  background-color: var(--dark);\n  color: var(--white);\n}\n.btn-shopify:hover::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='22' height='25' viewBox='0 0 22 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.2587 4.50055C18.1711 4.50055 16.3308 4.35347 16.3308 4.35347C16.3308 4.35347 15.0552 3.07876 14.9091 2.93168C14.8799 2.90226 14.8312 2.87284 14.7923 2.86304L13.877 24.0919L21.0826 22.5133C21.0826 22.5133 18.4827 4.81433 18.4632 4.69666C18.4437 4.579 18.3366 4.51036 18.249 4.50055H18.2587Z' fill='black'/%3E%3Cpath d='M14.382 2.8632C14.382 2.8632 14.0996 2.95145 13.6614 3.08873C13.233 1.85324 12.4832 0.715801 11.1492 0.715801C11.1103 0.715801 11.0713 0.715801 11.0421 0.715801C10.6623 0.21572 10.195 0 9.79573 0C6.709 0 5.22893 3.89278 4.76154 5.86369C3.56385 6.2363 2.70697 6.50104 2.59986 6.54027C1.92799 6.75599 1.90851 6.7756 1.82088 7.41296C1.75271 7.89342 0 21.5525 0 21.5525L13.5349 24.1019L14.4502 2.8534C14.4502 2.8534 14.4015 2.86321 14.382 2.87301V2.8632ZM10.9447 3.80453C10.9447 3.80453 10.9447 3.89278 10.9447 3.94181C10.195 4.17714 9.37702 4.43208 8.55909 4.68703C9.01674 2.90243 9.88337 2.03954 10.6331 1.71596C10.8181 2.19643 10.9447 2.88282 10.9447 3.81434V3.80453ZM9.71783 0.833468C9.85415 0.833468 9.98074 0.882494 10.1171 0.970744C9.12386 1.44141 8.06249 2.61807 7.61457 4.98119C6.96217 5.18711 6.31951 5.38322 5.72554 5.56952C6.25135 3.76531 7.49773 0.833468 9.71783 0.833468ZM10.2436 11.3548C10.2436 11.3548 9.44519 10.9233 8.46172 10.9233C7.0206 10.9233 6.95244 11.8352 6.95244 12.0608C6.95244 13.3061 10.1852 13.7865 10.1852 16.7184C10.1852 19.0227 8.73436 20.5033 6.77716 20.5033C4.43047 20.5033 3.23279 19.0325 3.23279 19.0325L3.86571 16.9439C3.86571 16.9439 5.10235 18.0127 6.1345 18.0127C6.81611 18.0127 7.08876 17.4734 7.08876 17.0812C7.08876 15.4535 4.43047 15.375 4.43047 12.6981C4.43047 10.4429 6.03713 8.26603 9.27965 8.26603C10.526 8.26603 11.1492 8.62884 11.1492 8.62884L10.2339 11.3646L10.2436 11.3548ZM11.7529 3.68687C11.7529 3.60842 11.7529 3.52017 11.7529 3.43192C11.7529 2.66709 11.6458 2.03954 11.4803 1.54927C12.1619 1.63752 12.6195 2.42196 12.9117 3.32406C12.5709 3.43192 12.1814 3.54959 11.7529 3.68687Z' fill='white'/%3E%3C/svg%3E%0A\");\n}\n@media screen and (max-width: 1330px) {\n  .btn-shopify {\n    font-size: 1.2782vw;\n    border-radius: 0.9023vw;\n    padding: 1.353vw 1.805vw 1.353vw 3.459vw;\n  }\n  .btn-shopify::after {\n    left: 1.278vw;\n    width: 1.654vw;\n    height: 1.88vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .btn-shopify {\n    padding: 1.406vw 1.875vw 1.406vw 3.594vw;\n  }\n  .btn-shopify::after {\n    left: 1.328vw;\n    width: 1.719vw;\n    height: 1.953vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .btn-shopify {\n    font-size: 4.359vw;\n    border-radius: 3.0769vw;\n    padding: 4.615vw 8.974vw 4.615vw 15.385vw;\n  }\n  .btn-shopify::after {\n    left: 8.974vw;\n    width: 4.359vw;\n    height: 5.128vw;\n  }\n}\n\n.btn-shopify--big {\n  font-family: \"Circular Std\";\n  font-size: 24px;\n  font-weight: 500;\n  color: var(--dark);\n  text-align: center;\n  position: relative;\n  background-color: var(--yellow);\n  border-radius: 12px;\n  padding: 18px 31px 18px 70px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.btn-shopify--big::after {\n  content: \"\";\n  position: absolute;\n  left: 21px;\n  top: 50%;\n  width: 34px;\n  height: 42px;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='22' height='25' viewBox='0 0 22 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.2587 4.50055C18.1711 4.50055 16.3308 4.35347 16.3308 4.35347C16.3308 4.35347 15.0552 3.07876 14.9091 2.93168C14.8799 2.90226 14.8312 2.87284 14.7923 2.86304L13.877 24.0919L21.0826 22.5133C21.0826 22.5133 18.4827 4.81433 18.4632 4.69666C18.4437 4.579 18.3366 4.51036 18.249 4.50055H18.2587Z' fill='black'/%3E%3Cpath d='M14.382 2.8632C14.382 2.8632 14.0996 2.95145 13.6614 3.08873C13.233 1.85324 12.4832 0.715801 11.1492 0.715801C11.1103 0.715801 11.0713 0.715801 11.0421 0.715801C10.6623 0.21572 10.195 0 9.79573 0C6.709 0 5.22893 3.89278 4.76154 5.86369C3.56385 6.2363 2.70697 6.50104 2.59986 6.54027C1.92799 6.75599 1.90851 6.7756 1.82088 7.41296C1.75271 7.89342 0 21.5525 0 21.5525L13.5349 24.1019L14.4502 2.8534C14.4502 2.8534 14.4015 2.86321 14.382 2.87301V2.8632ZM10.9447 3.80453C10.9447 3.80453 10.9447 3.89278 10.9447 3.94181C10.195 4.17714 9.37702 4.43208 8.55909 4.68703C9.01674 2.90243 9.88337 2.03954 10.6331 1.71596C10.8181 2.19643 10.9447 2.88282 10.9447 3.81434V3.80453ZM9.71783 0.833468C9.85415 0.833468 9.98074 0.882494 10.1171 0.970744C9.12386 1.44141 8.06249 2.61807 7.61457 4.98119C6.96217 5.18711 6.31951 5.38322 5.72554 5.56952C6.25135 3.76531 7.49773 0.833468 9.71783 0.833468ZM10.2436 11.3548C10.2436 11.3548 9.44519 10.9233 8.46172 10.9233C7.0206 10.9233 6.95244 11.8352 6.95244 12.0608C6.95244 13.3061 10.1852 13.7865 10.1852 16.7184C10.1852 19.0227 8.73436 20.5033 6.77716 20.5033C4.43047 20.5033 3.23279 19.0325 3.23279 19.0325L3.86571 16.9439C3.86571 16.9439 5.10235 18.0127 6.1345 18.0127C6.81611 18.0127 7.08876 17.4734 7.08876 17.0812C7.08876 15.4535 4.43047 15.375 4.43047 12.6981C4.43047 10.4429 6.03713 8.26603 9.27965 8.26603C10.526 8.26603 11.1492 8.62884 11.1492 8.62884L10.2339 11.3646L10.2436 11.3548ZM11.7529 3.68687C11.7529 3.60842 11.7529 3.52017 11.7529 3.43192C11.7529 2.66709 11.6458 2.03954 11.4803 1.54927C12.1619 1.63752 12.6195 2.42196 12.9117 3.32406C12.5709 3.43192 12.1814 3.54959 11.7529 3.68687Z' fill='black'/%3E%3C/svg%3E%0A\");\n}\n.btn-shopify--big:hover {\n  background-color: var(--dark);\n  color: var(--white);\n}\n.btn-shopify--big:hover::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='22' height='25' viewBox='0 0 22 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.2587 4.50055C18.1711 4.50055 16.3308 4.35347 16.3308 4.35347C16.3308 4.35347 15.0552 3.07876 14.9091 2.93168C14.8799 2.90226 14.8312 2.87284 14.7923 2.86304L13.877 24.0919L21.0826 22.5133C21.0826 22.5133 18.4827 4.81433 18.4632 4.69666C18.4437 4.579 18.3366 4.51036 18.249 4.50055H18.2587Z' fill='black'/%3E%3Cpath d='M14.382 2.8632C14.382 2.8632 14.0996 2.95145 13.6614 3.08873C13.233 1.85324 12.4832 0.715801 11.1492 0.715801C11.1103 0.715801 11.0713 0.715801 11.0421 0.715801C10.6623 0.21572 10.195 0 9.79573 0C6.709 0 5.22893 3.89278 4.76154 5.86369C3.56385 6.2363 2.70697 6.50104 2.59986 6.54027C1.92799 6.75599 1.90851 6.7756 1.82088 7.41296C1.75271 7.89342 0 21.5525 0 21.5525L13.5349 24.1019L14.4502 2.8534C14.4502 2.8534 14.4015 2.86321 14.382 2.87301V2.8632ZM10.9447 3.80453C10.9447 3.80453 10.9447 3.89278 10.9447 3.94181C10.195 4.17714 9.37702 4.43208 8.55909 4.68703C9.01674 2.90243 9.88337 2.03954 10.6331 1.71596C10.8181 2.19643 10.9447 2.88282 10.9447 3.81434V3.80453ZM9.71783 0.833468C9.85415 0.833468 9.98074 0.882494 10.1171 0.970744C9.12386 1.44141 8.06249 2.61807 7.61457 4.98119C6.96217 5.18711 6.31951 5.38322 5.72554 5.56952C6.25135 3.76531 7.49773 0.833468 9.71783 0.833468ZM10.2436 11.3548C10.2436 11.3548 9.44519 10.9233 8.46172 10.9233C7.0206 10.9233 6.95244 11.8352 6.95244 12.0608C6.95244 13.3061 10.1852 13.7865 10.1852 16.7184C10.1852 19.0227 8.73436 20.5033 6.77716 20.5033C4.43047 20.5033 3.23279 19.0325 3.23279 19.0325L3.86571 16.9439C3.86571 16.9439 5.10235 18.0127 6.1345 18.0127C6.81611 18.0127 7.08876 17.4734 7.08876 17.0812C7.08876 15.4535 4.43047 15.375 4.43047 12.6981C4.43047 10.4429 6.03713 8.26603 9.27965 8.26603C10.526 8.26603 11.1492 8.62884 11.1492 8.62884L10.2339 11.3646L10.2436 11.3548ZM11.7529 3.68687C11.7529 3.60842 11.7529 3.52017 11.7529 3.43192C11.7529 2.66709 11.6458 2.03954 11.4803 1.54927C12.1619 1.63752 12.6195 2.42196 12.9117 3.32406C12.5709 3.43192 12.1814 3.54959 11.7529 3.68687Z' fill='white'/%3E%3C/svg%3E%0A\");\n}\n@media screen and (max-width: 1330px) {\n  .btn-shopify--big {\n    font-size: 24px;\n    border-radius: 0.9023vw;\n    padding: 1.3534vw 1.8045vw 1.3534vw 5.263vw;\n  }\n  .btn-shopify--big::after {\n    left: 1.579vw;\n    width: 2.556vw;\n    height: 3.158vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .btn-shopify--big {\n    padding: 1.25vw 2.1094vw 1.25vw 5.469vw;\n  }\n  .btn-shopify--big::after {\n    left: 1.641vw;\n    width: 2.656vw;\n    height: 3.281vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .btn-shopify--big {\n    font-size: 4.359vw;\n    border-radius: 3.0769vw;\n    padding: 4.615vw 8.974vw 4.615vw 15.385vw;\n  }\n  .btn-shopify--big::after {\n    left: 8.974vw;\n    width: 4.359vw;\n    height: 5.128vw;\n  }\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 999;\n  opacity: 0;\n  pointer-events: none;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.modal.visible {\n  opacity: 1;\n  pointer-events: all;\n}\n.modal.visible .modal-dialog .modal-content {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n.modal.video-modal .modal-dialog .modal-content {\n  background-color: #000;\n}\n.modal .modal-dialog {\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 30px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.modal .modal-dialog.content {\n  display: block;\n}\n.modal .modal-dialog.content .modal-content {\n  margin: 0 auto;\n}\n.modal .modal-dialog .modal-content {\n  width: 100%;\n  max-width: 1100px;\n  min-height: 500px;\n  background-color: #fff;\n  position: relative;\n  z-index: 2;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  opacity: 0;\n  -webkit-transform: scale(0);\n  transform: scale(0);\n}\n.modal .modal-dialog .modal-content .modal-close {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  z-index: 3;\n  left: calc(100% + 15px);\n  bottom: calc(100% + 5px);\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.modal .modal-dialog .modal-content .modal-close::before,\n.modal .modal-dialog .modal-content .modal-close::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 2px;\n  background-color: #fff;\n}\n.modal .modal-dialog .modal-content .modal-close::before {\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.modal .modal-dialog .modal-content .modal-close::after {\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.modal .modal-dialog .modal-video {\n  width: 100%;\n  height: 500px;\n}\n.modal .modal-dialog .modal-video #modal-video-iframe {\n  width: 100%;\n  height: 100%;\n}\n.modal .modal-dialog .modal-video iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n.modal .modal-dialog .modal-video video {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media screen and (max-width: 1200px) {\n  .modal .modal-dialog .modal-content .modal-close {\n    left: auto;\n    right: 0;\n  }\n}\n@media screen and (max-width: 991px) {\n  .modal .modal-dialog .modal-content {\n    min-height: 250px;\n  }\n  .modal .modal-dialog .modal-video {\n    height: 50.4541vw;\n    min-height: 250px;\n  }\n}\n.pagination-block {\n  margin: 92px 0 137px;\n}\n.pagination-block .page-numbers {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.pagination-block .page-numbers li {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.pagination-block .page-numbers li:not(:first-child) {\n  margin-left: 12px;\n}\n.pagination-block .page-numbers li .page-numbers {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--dark);\n  border-radius: 10.5px;\n  border: 1px solid var(--white-2);\n  background: var(--white);\n  padding: 6px 10px;\n  min-width: 42px;\n  min-height: 42px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.pagination-block .page-numbers li .page-numbers.prev {\n  margin-right: 4px;\n}\n.pagination-block .page-numbers li .page-numbers.next {\n  margin-left: 4px;\n}\n.pagination-block .page-numbers li .page-numbers.prev,\n.pagination-block .page-numbers li .page-numbers.next {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--dark);\n  border: none;\n  padding: 0;\n}\n.pagination-block .page-numbers li .page-numbers.prev.disable,\n.pagination-block .page-numbers li .page-numbers.next.disable {\n  pointer-events: none;\n  color: var(--gray-4);\n}\n.pagination-block .page-numbers li .page-numbers.current,\n.pagination-block .page-numbers li .page-numbers:hover {\n  background-color: var(--yellow);\n  border-color: var(--yellow);\n}\n.pagination-block .page-numbers li .page-numbers.dots {\n  border: none;\n}\n\n@media screen and (max-width: 1330px) {\n  .pagination-block {\n    margin: 6.9173vw 0 10.3008vw;\n  }\n  .pagination-block .page-numbers li:not(:first-child) {\n    margin-left: 0.9023vw;\n  }\n  .pagination-block .page-numbers li .page-numbers {\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n    border-radius: 0.7895vw;\n    padding: 0.4511vw 0.7519vw;\n    min-width: 3.1579vw;\n    min-height: 3.1579vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.prev {\n    margin-right: 0.3008vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.next {\n    margin-left: 0.3008vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.prev,\n  .pagination-block .page-numbers li .page-numbers.next {\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .pagination-block {\n    margin: 4.9219vw 0 9.2969vw;\n  }\n  .pagination-block .page-numbers li:not(:first-child) {\n    margin-left: 0.9375vw;\n  }\n  .pagination-block .page-numbers li .page-numbers {\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n    border-radius: 0.8203vw;\n    padding: 0.4688vw 0.7813vw;\n    min-width: 3.2813vw;\n    min-height: 3.2813vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.prev {\n    margin-right: 0.3125vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.next {\n    margin-left: 0.3125vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.prev,\n  .pagination-block .page-numbers li .page-numbers.next {\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .pagination-block {\n    margin: 7.6923vw 0 16.9231vw;\n  }\n  .pagination-block .page-numbers li:not(:first-child) {\n    margin-left: 1.5385vw;\n  }\n  .pagination-block .page-numbers li .page-numbers {\n    font-weight: 700;\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n    border-radius: 2.6923vw;\n    padding: 1.5385vw 2.5641vw;\n    min-width: 10.7692vw;\n    min-height: 10.7692vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.prev {\n    margin-right: 1.0256vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.next {\n    margin-left: 1.0256vw;\n  }\n  .pagination-block .page-numbers li .page-numbers.prev,\n  .pagination-block .page-numbers li .page-numbers.next {\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n  }\n}\n.notification {\n  position: fixed;\n  z-index: 8;\n  right: 30px;\n  bottom: 30px;\n  direction: ltr;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #fcede9;\n  width: 100%;\n  max-width: 450px;\n  padding: 20px;\n  border-radius: 20px;\n  border: 1px solid #89888f;\n  pointer-events: none;\n  opacity: 0;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%);\n}\n.notification.show {\n  pointer-events: all;\n  opacity: 1;\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n}\n.notification .notification-icon {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  pointer-events: none;\n}\n.notification .notification-icon svg {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n.notification .notification-text {\n  margin: 0 15px;\n  font-weight: 700;\n  color: #89888f;\n  font-size: 14px;\n  text-align: center;\n}\n.notification .notification-button {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n.notification .notification-button svg {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n@media screen and (max-width: 991px) {\n  .notification {\n    right: 5px;\n    bottom: 10px;\n    max-width: 250px;\n    padding: 10px;\n    border-radius: 10px;\n  }\n  .notification .notification-icon {\n    width: 15px;\n    height: 15px;\n  }\n  .notification .notification-icon svg {\n    width: 15px;\n    height: 15px;\n  }\n  .notification .notification-text {\n    margin: 0 5px;\n  }\n  .notification .notification-button {\n    width: 15px;\n    height: 15px;\n  }\n  .notification .notification-button svg {\n    width: 15px;\n    height: 15px;\n  }\n}\n.single-solutions .card .card-info,\n.page-template-bfcm .card .card-info {\n  display: none;\n}\n\n.card {\n  background-color: var(--white);\n  border-radius: 24px;\n  padding: 6px 6px 32px 6px;\n  position: relative;\n  z-index: 2;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.card.hide {\n  display: none;\n}\n.card:hover {\n  -webkit-box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),\n    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),\n    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),\n    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),\n    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),\n    0px 100px 80px 0px rgba(0, 0, 0, 0.05);\n  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),\n    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),\n    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),\n    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),\n    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),\n    0px 100px 80px 0px rgba(0, 0, 0, 0.05);\n}\n.card:hover .card-img img {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n.card:hover .card-content__title h3 {\n  text-decoration: underline;\n}\n.card .card-img {\n  width: 100%;\n  height: 240px;\n  border-radius: 18px;\n  overflow: hidden;\n}\n.card .card-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.card .card-info {\n  margin-top: 22px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 0 50px 0 26px;\n}\n.card .card-info__labels ul {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.card .card-info__labels ul li {\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n  text-align: center;\n  background-color: var(--light-gray);\n  padding: 16px 24px;\n  border-radius: 50px;\n}\n.card .card-info__time {\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n  text-align: center;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.card .card-content {\n  margin-top: 32px;\n  padding: 0 26px 41px;\n}\n.card .card-content__logo {\n  width: 119px;\n  height: 44px;\n  margin-bottom: 12px;\n}\n.card .card-content__logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.card .card-content__title {\n  margin-bottom: 23px;\n}\n.card .card-content__title h3 {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 1.4;\n  letter-spacing: -0.24px;\n  color: var(--dark);\n}\n.card .card-content__button {\n  display: inline-block;\n  position: absolute;\n  left: 31px;\n  bottom: 46px;\n}\n.card .card-content__button a,\n.card .card-content__button button {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.card .card-content__button a::before,\n.card .card-content__button button::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.card .card-content__button a::after,\n.card .card-content__button button::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .card .card-content__button a:hover::before,\n  .card .card-content__button button:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .card .card-content__button a:hover::after,\n  .card .card-content__button button:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .card .card-content__button a,\n  .card .card-content__button button {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .card .card-content__button a::before,\n  .card .card-content__button button::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .card .card-content__button a::after,\n  .card .card-content__button button::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .card .card-content__button a:hover::before,\n  .card .card-content__button button:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .card .card-content__button a,\n  .card .card-content__button button {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .card .card-content__button a::before,\n  .card .card-content__button button::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .card .card-content__button a,\n  .card .card-content__button button {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .card .card-content__button a::before,\n  .card .card-content__button button::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .card .card-content__button a::after,\n  .card .card-content__button button::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n\n@media screen and (max-width: 1330px) {\n  .card {\n    border-radius: 1.8045vw;\n    padding: 0.4511vw;\n    padding: 0.4511vw 0.4511vw 2.406vw 0.4511vw;\n  }\n  .card .card-img {\n    height: 18.0451vw;\n    border-radius: 1.3534vw;\n  }\n  .card .card-info {\n    margin-top: 1.6541vw;\n    gap: 1.5038vw;\n    padding: 0 3.7594vw 0 1.9549vw;\n  }\n  .card .card-info__labels ul {\n    gap: 0.7519vw;\n  }\n  .card .card-info__labels ul li {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n    padding: 1.203vw 1.8045vw;\n    border-radius: 3.7594vw;\n  }\n  .card .card-info__time {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .card .card-content {\n    margin-top: 2.406vw;\n    padding: 0 1.9549vw 3.0827vw;\n  }\n  .card .card-content__logo {\n    width: 8.9474vw;\n    height: 3.3083vw;\n    margin-bottom: 0.9023vw;\n  }\n  .card .card-content__title {\n    margin-bottom: 1.7293vw;\n  }\n  .card .card-content__title h3 {\n    font-size: 1.8045vw;\n    letter-spacing: -0.018vw;\n  }\n  .card .card-content__button {\n    left: 2.3308vw;\n    bottom: 3.4586vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .card {\n    border-radius: 1.875vw;\n    padding: 0.4688vw 0.4688vw 2.6563vw 0.4688vw;\n  }\n  .card:hover {\n    -webkit-box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),\n      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),\n      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),\n      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),\n      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),\n      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);\n    box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),\n      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),\n      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),\n      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),\n      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),\n      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);\n  }\n  .card .card-img {\n    height: 14.9219vw;\n    border-radius: 1.4063vw;\n  }\n  .card .card-info {\n    margin-top: 1.7969vw;\n    gap: 1.5625vw;\n    padding: 0 1.3281vw 0;\n  }\n  .card .card-info__labels ul {\n    gap: 0.7813vw;\n  }\n  .card .card-info__labels ul li {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n    padding: 0.7813vw 1.25vw;\n    border-radius: 3.9063vw;\n  }\n  .card .card-info__time {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n  }\n  .card .card-content {\n    margin-top: 1.9531vw;\n    padding: 0 1.4063vw 1.9531vw;\n  }\n  .card .card-content__logo {\n    width: 11.7188vw;\n    height: auto;\n    margin-bottom: 1.5625vw;\n  }\n  .card .card-content__title {\n    margin-bottom: 1.1719vw;\n  }\n  .card .card-content__title h3 {\n    font-size: 1.7188vw;\n    letter-spacing: -0.0172vw;\n  }\n  .card .card-content__button {\n    left: 1.875vw;\n    bottom: 1.9531vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .card {\n    border-radius: 4.1026vw;\n    padding: 1.5385vw 1.5385vw 11.7949vw 1.5385vw;\n  }\n  .card:hover {\n    -webkit-box-shadow: 0px 0.7692vw 0.5128vw 0px rgba(0, 0, 0, 0.01),\n      0px 1.7949vw 1.2821vw 0px rgba(0, 0, 0, 0.02),\n      0px 3.0769vw 2.5641vw 0px rgba(0, 0, 0, 0.03),\n      0px 5.641vw 4.6154vw 0px rgba(0, 0, 0, 0.03),\n      0px 10.7692vw 8.4615vw 0px rgba(0, 0, 0, 0.04),\n      0px 25.641vw 20.5128vw 0px rgba(0, 0, 0, 0.05);\n    box-shadow: 0px 0.7692vw 0.5128vw 0px rgba(0, 0, 0, 0.01),\n      0px 1.7949vw 1.2821vw 0px rgba(0, 0, 0, 0.02),\n      0px 3.0769vw 2.5641vw 0px rgba(0, 0, 0, 0.03),\n      0px 5.641vw 4.6154vw 0px rgba(0, 0, 0, 0.03),\n      0px 10.7692vw 8.4615vw 0px rgba(0, 0, 0, 0.04),\n      0px 25.641vw 20.5128vw 0px rgba(0, 0, 0, 0.05);\n  }\n  .card .card-img {\n    height: 52.3077vw;\n    border-radius: 3.0769vw;\n  }\n  .card .card-info {\n    margin-top: 4.1026vw;\n    gap: 5.1282vw;\n    padding: 0 10vw 0 3.5897vw;\n  }\n  .card .card-info__labels ul {\n    gap: 2.5641vw;\n  }\n  .card .card-info__labels ul li {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n    padding: 4.1026vw 6.1538vw;\n    border-radius: 12.8205vw;\n  }\n  .card .card-info__time {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .card .card-content {\n    margin-top: 5.8974vw;\n    padding: 0 4.359vw 0 4.359vw;\n  }\n  .card .card-content__logo {\n    width: 30.5128vw;\n    height: 11.2821vw;\n    margin-bottom: 3.0769vw;\n  }\n  .card .card-content__logo img {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: contain;\n    object-fit: contain;\n  }\n  .card .card-content__title {\n    margin-bottom: 5.3846vw;\n  }\n  .card .card-content__title h3 {\n    font-size: 5.641vw;\n    line-height: 1.5;\n    letter-spacing: -0.0564vw;\n  }\n  .card .card-content__button {\n    left: 6.1538vw;\n    bottom: 6.4103vw;\n  }\n}\n@font-face {\n  font-family: \"Cambon\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Circular Std\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Circular Std\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Circular Std\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n}\n.blockquote {\n  width: calc(100% + 510px);\n  margin: 50px -255px 32px;\n  background-color: var(--light-gray);\n  border-radius: 24px;\n  padding: 114px 255px;\n  position: relative;\n  z-index: 2;\n}\n.blockquote::before {\n  content: \"\";\n  position: absolute;\n  top: -18px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 60px;\n  height: 40px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='40' fill='none'%3E%3Cpath fill='%23161616' fill-rule='evenodd' d='M14.575 23.723c-.83.181-1.691.277-2.575.277-6.627 0-12-5.373-12-12S5.373 0 12 0s12 5.373 12 12c0 .938-.108 1.85-.311 2.726l-.087.663c-.103.791-.351 2.083-.798 3.716-.74 2.704-1.791 5.41-3.219 7.96-.297.531-.608 1.05-.934 1.557a31.458 31.458 0 0 1-3.078 4.013c-2.548 2.835-8.18 6.628-8.18 6.628a1.412 1.412 0 0 1-2.04-.425l-1.559-2.53a1.65 1.65 0 0 1 .427-2.19s5.656-4.12 6.89-5.494a25.481 25.481 0 0 0 2.493-3.246 23.749 23.749 0 0 0 .971-1.655Zm36 0c-.83.181-1.691.277-2.575.277-6.627 0-12-5.373-12-12S41.373 0 48 0s12 5.373 12 12c0 .938-.108 1.85-.311 2.726l-.087.663c-.103.791-.351 2.083-.798 3.716-.74 2.704-1.791 5.41-3.219 7.96-.297.531-.608 1.05-.934 1.557a31.458 31.458 0 0 1-3.078 4.013c-2.548 2.835-8.18 6.628-8.18 6.628a1.412 1.412 0 0 1-2.04-.425l-1.56-2.53a1.65 1.65 0 0 1 .428-2.19s5.656-4.12 6.89-5.494a25.481 25.481 0 0 0 2.493-3.246 23.749 23.749 0 0 0 .971-1.655Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.blockquote .blockquote__text {\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.28px;\n  font-size: 28px;\n  color: var(--dark);\n  margin-bottom: 24px;\n}\n.blockquote .blockquote__subtext {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--dark);\n  margin-bottom: 24px;\n}\n.blockquote .blockquote__info {\n  margin-top: 48px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.blockquote .blockquote__info-img {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 58px;\n  height: 58px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-right: 16px;\n}\n.blockquote .blockquote__info-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.blockquote .blockquote__info-name {\n  font-weight: 500;\n  font-size: 16px;\n  color: var(--dark);\n}\n.blockquote .blockquote__info-position {\n  font-weight: 400;\n  font-size: 16px;\n  color: var(--dark);\n}\n\n@media screen and (max-width: 1330px) {\n  .blockquote {\n    width: calc(100% + 38.3459vw);\n    margin: 3.7594vw -19.1729vw 2.2556vw;\n    border-radius: 1.8045vw;\n    padding: 8.5714vw 19.1729vw;\n  }\n  .blockquote::before {\n    top: -1.3534vw;\n    width: 4.5113vw;\n    height: 3.0075vw;\n  }\n  .blockquote .blockquote__text {\n    letter-spacing: -0.0211vw;\n    font-size: 2.1053vw;\n    margin-bottom: 1.8045vw;\n  }\n  .blockquote .blockquote__subtext {\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n    margin-bottom: 1.8045vw;\n  }\n  .blockquote .blockquote__info {\n    margin-top: 3.609vw;\n  }\n  .blockquote .blockquote__info-img {\n    width: 4.3609vw;\n    height: 4.3609vw;\n    margin-right: 1.203vw;\n  }\n  .blockquote .blockquote__info-name {\n    font-size: 1.203vw;\n  }\n  .blockquote .blockquote__info-position {\n    font-size: 1.203vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .blockquote {\n    width: calc(100% + 10.2564vw);\n    margin: 10.7692vw -5.1282vw 6.1538vw;\n    border-radius: 4.1026vw;\n    padding: 20.5128vw 5.3846vw;\n  }\n  .blockquote::before {\n    top: -4.6154vw;\n    width: 15.3846vw;\n    height: 10.2564vw;\n  }\n  .blockquote .blockquote__text {\n    letter-spacing: -0.0564vw;\n    font-size: 5.641vw;\n    margin-bottom: 6.1538vw;\n  }\n  .blockquote .blockquote__subtext {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n    margin-bottom: 6.1538vw;\n  }\n  .blockquote .blockquote__info {\n    margin-top: 8.2051vw;\n  }\n  .blockquote .blockquote__info-img {\n    width: 14.8718vw;\n    height: 14.8718vw;\n    margin-right: 4.1026vw;\n  }\n  .blockquote .blockquote__info-name {\n    font-size: 4.1026vw;\n  }\n  .blockquote .blockquote__info-position {\n    font-size: 4.1026vw;\n  }\n}\n.modal.modal-store .modal-dialog .modal-content {\n  max-width: 766px;\n  min-height: 490px;\n  border-radius: 24px;\n  overflow: hidden;\n}\n.modal.modal-store .modal-dialog .modal-content .modal-close {\n  top: 21px;\n  right: 22px;\n  bottom: auto;\n  left: auto;\n}\n.modal.modal-store .modal-dialog .modal-content .modal-close::before,\n.modal.modal-store .modal-dialog .modal-content .modal-close::after {\n  background-color: #2f2f2f;\n  border-radius: 2px;\n}\n.modal.modal-store .modal-store__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.modal.modal-store .modal-store__image {\n  width: 320px;\n  height: 474px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  border-radius: 18px;\n  margin: 8px 58px 8px 8px;\n  overflow: hidden;\n}\n.modal.modal-store .modal-store__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.modal.modal-store .modal-store__form {\n  width: 100%;\n  height: auto;\n  padding: 44px 60px 8px 0;\n}\n.modal.modal-store .modal-store__form.modal-store__form--thank {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 44px 59px 44px 0;\n}\n.modal.modal-store\n  .modal-store__form.modal-store__form--thank\n  .modal-store__form-title,\n.modal.modal-store\n  .modal-store__form.modal-store__form--thank\n  .modal-store__form-wrapper {\n  display: none;\n}\n.modal.modal-store\n  .modal-store__form.modal-store__form--thank\n  .modal-store__form-thank {\n  display: block;\n}\n.modal.modal-store .modal-store__form .modal-store__form-title {\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: -0.24px;\n  font-size: 24px;\n  color: var(--dark);\n  margin-bottom: 21px;\n}\n.modal.modal-store .modal-store__form .modal-store__form-wrapper form {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr;\n  grid-template-columns: 1fr;\n  grid-gap: 20px;\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-wrapper\n  [class*=\"brand_name\"] {\n  display: none;\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-wrapper\n  .hs-form-field\n  > label {\n  display: block;\n  margin-bottom: 5px;\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-wrapper\n  .hs-form-field\n  > label\n  span {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-wrapper\n  .hs-form-field\n  .input {\n  width: 100%;\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-wrapper\n  .hs-form-field\n  .input\n  input {\n  width: 100%;\n  height: 50px;\n  border-radius: 8px;\n  border: 1px solid #e9e4dc;\n  background: #fff;\n  outline: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-wrapper\n  .hs-submit\n  input[type=\"submit\"] {\n  border-radius: 12px;\n  background: #161616;\n  padding: 16px 25px;\n  font-family: \"Circular Std\";\n  font-weight: 500;\n  font-size: 17px;\n  color: #fff;\n  cursor: pointer;\n  border: none;\n  outline: none;\n}\n.modal.modal-store .modal-store__form .modal-store__form-thank {\n  display: none;\n  text-align: center;\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-thank\n  .form-thank__title {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.4;\n  font-size: 32px;\n  letter-spacing: -0.32px;\n  color: var(--dark);\n  margin-bottom: 5px;\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-thank\n  .form-thank__message {\n  font-weight: 500;\n  line-height: 1.4;\n  font-size: 20px;\n  letter-spacing: -0.2px;\n  color: var(--dark);\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-thank\n  .form-thank__close-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-top: 26px;\n}\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-thank\n  .form-thank__close-button\n  button,\n.modal.modal-store\n  .modal-store__form\n  .modal-store__form-thank\n  .form-thank__close-button\n  a {\n  font-family: \"Circular Std\";\n  font-weight: 500;\n  line-height: 1.5;\n  font-size: 17px;\n  color: var(--white);\n  border-radius: 12px;\n  background: var(--dark);\n  padding: 14px 24px;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 850px) {\n  .modal.modal-store .modal-dialog {\n    padding: 20px 0;\n  }\n  .modal.modal-store .modal-dialog .modal-content {\n    max-width: 100%;\n    min-height: 0;\n    border-radius: 24px;\n    padding: 20px 20px 50px;\n  }\n  .modal.modal-store .modal-dialog .modal-content .modal-close {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.4);\n    top: 38px;\n    right: 31px;\n    bottom: auto;\n    left: auto;\n  }\n  .modal.modal-store .modal-dialog .modal-content .modal-close::before,\n  .modal.modal-store .modal-dialog .modal-content .modal-close::after {\n    width: 14px;\n    background-color: #fff;\n    border-radius: 2px;\n  }\n  .modal.modal-store .modal-store__wrapper {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .modal.modal-store .modal-store__image {\n    width: 100%;\n    height: 224px;\n    border-radius: 18px;\n    margin: 0 0 22px 0;\n  }\n  .modal.modal-store .modal-store__form {\n    width: 100%;\n    max-width: 320px;\n    margin: 0 auto;\n    padding: 0;\n  }\n  .modal.modal-store .modal-store__form.modal-store__form--thank {\n    padding: 0;\n  }\n  .modal.modal-store .modal-store__form .modal-store__form-title {\n    line-height: 1.4;\n    letter-spacing: -0.24px;\n    font-size: 24px;\n  }\n  .modal.modal-store .modal-store__form .modal-store__form-wrapper form {\n    grid-gap: 20px;\n  }\n  .modal.modal-store\n    .modal-store__form\n    .modal-store__form-wrapper\n    .hs-form-field\n    > label {\n    margin-bottom: 5px;\n  }\n  .modal.modal-store\n    .modal-store__form\n    .modal-store__form-wrapper\n    .hs-form-field\n    > label\n    span {\n    letter-spacing: -0.16px;\n    font-size: 16px;\n  }\n  .modal.modal-store\n    .modal-store__form\n    .modal-store__form-wrapper\n    .hs-form-field\n    .input\n    input {\n    border-radius: 8px;\n    letter-spacing: -0.16px;\n    font-size: 16px;\n  }\n  .modal.modal-store\n    .modal-store__form\n    .modal-store__form-wrapper\n    .hs-submit\n    input[type=\"submit\"] {\n    border-radius: 12px;\n    padding: 16px 25px;\n    font-size: 17px;\n  }\n}\n.modal.modal-detail.show-thank .modal-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.modal.modal-detail.show-thank .modal-detail__form-title {\n  display: none;\n}\n.modal.modal-detail.show-thank .modal-detail__form-thank {\n  display: block;\n}\n.modal.modal-detail .modal-dialog .modal-content {\n  max-width: 660px;\n  min-height: 560px;\n  -webkit-box-shadow: 0px 54px 120px rgba(255, 215, 72, 0.4);\n  box-shadow: 0px 54px 120px rgba(255, 215, 72, 0.4);\n  border-radius: 24px;\n  padding: 48px 46px;\n}\n.modal.modal-detail .modal-dialog .modal-close {\n  width: 14px;\n  height: 14px;\n  top: 20px;\n  right: 20px;\n  left: auto;\n  bottom: auto;\n}\n.modal.modal-detail .modal-dialog .modal-close::before,\n.modal.modal-detail .modal-dialog .modal-close::after {\n  background-color: #2f2f2f;\n}\n.modal.modal-detail .modal-detail__form-title {\n  font-weight: 500;\n  line-height: 1.27;\n  font-size: 18px;\n  letter-spacing: -0.01em;\n  color: #2f2f2f;\n  margin-bottom: 36px;\n}\n.modal.modal-detail .modal-detail__form-wrapper .submitted-message {\n  display: none;\n}\n.modal.modal-detail .modal-detail__form-wrapper form {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr;\n  grid-template-columns: 1fr;\n  grid-gap: 25px 20px;\n}\n.modal.modal-detail .modal-detail__form-wrapper form fieldset {\n  width: 100%;\n  max-width: 100%;\n}\n.modal.modal-detail .modal-detail__form-wrapper form .input {\n  margin: 0;\n}\n.modal.modal-detail .modal-detail__form-wrapper form .form-columns-2 {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 20px 1fr;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 20px;\n}\n.modal.modal-detail .modal-detail__form-wrapper form .hs-error-msg {\n  color: red !important;\n}\n.modal.modal-detail .modal-detail__form-wrapper form .hs_error_rollup {\n  -webkit-box-ordinal-group: 2;\n  -ms-flex-order: 1;\n  order: 1;\n  -ms-grid-column-span: 2;\n  grid-column: span 2;\n  text-align: center;\n  color: red;\n}\n.modal.modal-detail .modal-detail__form-wrapper form .field {\n  width: 100%;\n  float: none;\n}\n.modal.modal-detail .modal-detail__form-wrapper form .field > label {\n  display: block;\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: #161616;\n  margin-bottom: 8px;\n}\n.modal.modal-detail .modal-detail__form-wrapper form .field .input input {\n  width: 100%;\n  height: 54px;\n  border: none;\n  outline: none;\n  border-radius: 8px;\n  background: #f6f5ef;\n  padding: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: #161616;\n}\n.modal.modal-detail\n  .modal-detail__form-wrapper\n  form\n  .field\n  .input\n  input::-webkit-input-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: rgba(22, 22, 22, 0.4);\n}\n.modal.modal-detail\n  .modal-detail__form-wrapper\n  form\n  .field\n  .input\n  input::-moz-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: rgba(22, 22, 22, 0.4);\n}\n.modal.modal-detail\n  .modal-detail__form-wrapper\n  form\n  .field\n  .input\n  input:-ms-input-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: rgba(22, 22, 22, 0.4);\n}\n.modal.modal-detail\n  .modal-detail__form-wrapper\n  form\n  .field\n  .input\n  input::-ms-input-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: rgba(22, 22, 22, 0.4);\n}\n.modal.modal-detail\n  .modal-detail__form-wrapper\n  form\n  .field\n  .input\n  input::placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: rgba(22, 22, 22, 0.4);\n}\n.modal.modal-detail\n  .modal-detail__form-wrapper\n  form\n  .field\n  .input\n  input:-moz-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: rgba(22, 22, 22, 0.4);\n}\n.modal.modal-detail\n  .modal-detail__form-wrapper\n  form\n  .field\n  .input\n  input::-moz-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: rgba(22, 22, 22, 0.4);\n}\n.modal.modal-detail .modal-detail__form-wrapper form .hs_submit {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.modal.modal-detail .modal-detail__form-wrapper form .hs_submit .hs-button {\n  cursor: pointer;\n  font-family: \"Circular Std\";\n  font-weight: 500;\n  font-size: 17px;\n  color: #ffffff;\n  border-radius: 12px;\n  background: var(--dark);\n  padding: 16px 48px;\n  border: none;\n}\n.modal.modal-detail .modal-detail__form-thank {\n  display: none;\n}\n.modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-title {\n  width: 100%;\n  max-width: 430px;\n  margin: 0 auto 40px;\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  font-size: 40px;\n  letter-spacing: -0.01em;\n  color: #161616;\n  text-align: center;\n}\n.modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-text {\n  width: 100%;\n  max-width: 280px;\n  margin: 0 auto;\n  font-weight: 500;\n  line-height: 1.27;\n  font-size: 18px;\n  letter-spacing: -0.01em;\n  text-align: center;\n  color: #2f2f2f;\n}\n\n@media screen and (max-width: 1330px) {\n  .modal.modal-detail .modal-dialog .modal-content {\n    max-width: 49.6241vw;\n    min-height: 42.1053vw;\n    -webkit-box-shadow: 0px 4.0602vw 9.0226vw rgba(255, 215, 72, 0.4);\n    box-shadow: 0px 4.0602vw 9.0226vw rgba(255, 215, 72, 0.4);\n    border-radius: 1.8045vw;\n    padding: 3.609vw 3.4586vw;\n  }\n  .modal.modal-detail .modal-dialog .modal-close {\n    width: 1.0526vw;\n    height: 1.0526vw;\n    top: 1.5038vw;\n    right: 1.5038vw;\n  }\n  .modal.modal-detail .modal-detail__form-title {\n    font-size: 1.3534vw;\n    margin-bottom: 2.7068vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form {\n    grid-gap: 1.8797vw 1.5038vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .form-columns-2 {\n    grid-gap: 1.5038vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .field > label {\n    font-size: 1.203vw;\n    margin-bottom: 0.6015vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .field .input input {\n    height: 4.0602vw;\n    border-radius: 0.6015vw;\n    padding: 1.203vw;\n    font-size: 1.203vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-webkit-input-placeholder {\n    font-size: 1.203vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-moz-placeholder {\n    font-size: 1.203vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input:-ms-input-placeholder {\n    font-size: 1.203vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-ms-input-placeholder {\n    font-size: 1.203vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::placeholder {\n    font-size: 1.203vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input:-moz-placeholder {\n    font-size: 1.203vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-moz-placeholder {\n    font-size: 1.203vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .hs_submit .hs-button {\n    font-size: 1.2782vw;\n    border-radius: 0.9023vw;\n    padding: 1.203vw 3.609vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-thank\n    .modal-detail__form-thank-title {\n    max-width: 32.3308vw;\n    margin: 0 auto 3.0075vw;\n    font-size: 3.0075vw;\n  }\n  .modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-text {\n    max-width: 21.0526vw;\n    font-size: 1.3534vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .modal.modal-detail .modal-dialog .modal-content {\n    max-width: 51.5625vw;\n    min-height: 43.75vw;\n    -webkit-box-shadow: 0px 4.2188vw 9.375vw rgba(255, 215, 72, 0.4);\n    box-shadow: 0px 4.2188vw 9.375vw rgba(255, 215, 72, 0.4);\n    border-radius: 1.875vw;\n    padding: 3.75vw 3.5938vw;\n  }\n  .modal.modal-detail .modal-dialog .modal-close {\n    width: 1.0938vw;\n    height: 1.0938vw;\n    top: 1.5625vw;\n    right: 1.5625vw;\n  }\n  .modal.modal-detail .modal-detail__form-title {\n    font-size: 1.4063vw;\n    margin-bottom: 2.8125vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form {\n    grid-gap: 1.9531vw 1.5625vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .form-columns-2 {\n    grid-gap: 1.5625vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .field > label {\n    font-size: 1.25vw;\n    margin-bottom: 0.625vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .field .input input {\n    height: 4.2188vw;\n    border-radius: 0.625vw;\n    padding: 1.25vw;\n    font-size: 1.25vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-webkit-input-placeholder {\n    font-size: 1.25vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-moz-placeholder {\n    font-size: 1.25vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input:-ms-input-placeholder {\n    font-size: 1.25vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-ms-input-placeholder {\n    font-size: 1.25vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::placeholder {\n    font-size: 1.25vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input:-moz-placeholder {\n    font-size: 1.25vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-moz-placeholder {\n    font-size: 1.25vw;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .hs_submit .hs-button {\n    font-size: 1.3281vw;\n    border-radius: 0.9375vw;\n    padding: 1.25vw 3.75vw;\n  }\n  .modal.modal-detail\n    .modal-detail__form-thank\n    .modal-detail__form-thank-title {\n    max-width: 33.5938vw;\n    margin: 0 auto 3.125vw;\n    font-size: 2.7344vw;\n  }\n  .modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-text {\n    max-width: 21.875vw;\n    font-size: 1.4063vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .modal.modal-detail .modal-dialog {\n    padding: 30px 20px;\n  }\n  .modal.modal-detail .modal-dialog .modal-content {\n    max-width: 100%;\n    min-height: 537px;\n    -webkit-box-shadow: 0px 54px 120px rgba(255, 215, 72, 0.4);\n    box-shadow: 0px 54px 120px rgba(255, 215, 72, 0.4);\n    border-radius: 15px;\n    padding: 50px 20px;\n  }\n  .modal.modal-detail .modal-dialog .modal-close {\n    width: 14px;\n    height: 14px;\n    top: 10px;\n    right: 10px;\n  }\n  .modal.modal-detail .modal-detail__form-title {\n    font-size: 18px;\n    margin-bottom: 30px;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 20px;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .form-columns-2 {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 20px;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .field > label {\n    font-size: 16px;\n    margin-bottom: 5px;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .field .input input {\n    height: 40px;\n    border-radius: 5px;\n    padding: 15px;\n    font-size: 16px;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-webkit-input-placeholder {\n    font-size: 16px;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-moz-placeholder {\n    font-size: 16px;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input:-ms-input-placeholder {\n    font-size: 16px;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-ms-input-placeholder {\n    font-size: 16px;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::placeholder {\n    font-size: 16px;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input:-moz-placeholder {\n    font-size: 16px;\n  }\n  .modal.modal-detail\n    .modal-detail__form-wrapper\n    form\n    .field\n    .input\n    input::-moz-placeholder {\n    font-size: 16px;\n  }\n  .modal.modal-detail .modal-detail__form-wrapper form .hs_submit .hs-button {\n    font-size: 15px;\n    border-radius: 10px;\n    padding: 10px 35px;\n  }\n  .modal.modal-detail\n    .modal-detail__form-thank\n    .modal-detail__form-thank-title {\n    max-width: 300px;\n    margin: 0 auto 20px;\n    font-size: 28px;\n  }\n  .modal.modal-detail .modal-detail__form-thank .modal-detail__form-thank-text {\n    max-width: 250px;\n    font-size: 16px;\n  }\n}\n:root {\n  --heightHeader: 80px;\n  --heightHeaderToast: 124px;\n  --heightMobileHeader: 60px;\n}\n\n.page-template-bfcm .header.header-scroll .header__inner::before {\n  background-color: var(--white);\n}\n.page-template-bfcm .header .header__inner::before {\n  background-color: var(--yellow);\n}\n.page-template-bfcm .header .header__buttons .header__request-button .btn {\n  background-color: var(--dark);\n  color: var(--white);\n}\n\n@media screen and (max-width: 1150px) {\n  .page-template-lp .header__buttons {\n    display: none !important;\n  }\n}\n\n.page-template-memberships .header .header__inner::before {\n  background-color: var(--dark);\n}\n.page-template-memberships .header .header__nav > ul > li::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='6' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill='%23fff' d='M4.798 5.343c-.1.1-.236.157-.378.157h-.271a.55.55 0 0 1-.38-.157L.107 1.672a.357.357 0 0 1 0-.507L.613.657a.35.35 0 0 1 .5 0l3.171 3.179L7.456.657a.357.357 0 0 1 .507 0l.5.508a.357.357 0 0 1 0 .507L4.799 5.343Z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 .5h8.571v5H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n}\n@media screen and (min-width: 1150px) {\n  .page-template-memberships .header .header__nav > ul > li:hover::before {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='6' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill='%23FFD748' d='M4.798 5.343c-.1.1-.236.157-.378.157h-.271a.55.55 0 0 1-.38-.157L.107 1.672a.357.357 0 0 1 0-.507L.613.657a.35.35 0 0 1 .5 0l3.171 3.179L7.456.657a.357.357 0 0 1 .507 0l.5.508a.357.357 0 0 1 0 .507L4.799 5.343Z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 .5h8.571v5H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  }\n  .page-template-memberships .header .header__nav > ul > li:hover > a {\n    color: var(--yellow);\n  }\n}\n.page-template-memberships .header .header__nav > ul > li > a {\n  color: var(--white);\n}\n.page-template-memberships .header .header__nav > ul > li > a::before {\n  background-color: var(--yellow);\n}\n.page-template-memberships .header .header__buttons .header__price-button a,\n.page-template-memberships\n  .header\n  .header__buttons\n  .header__price-button\n  button {\n  color: var(--white);\n}\n.page-template-memberships .header .header__menu::before,\n.page-template-memberships .header .header__menu strong,\n.page-template-memberships .header .header__menu::after {\n  background-color: var(--white);\n}\n@media screen and (max-width: 1150px) {\n  .page-template-memberships .header .header__nav {\n    background-color: var(--dark);\n  }\n  .page-template-memberships\n    .header\n    .header__nav\n    > ul\n    .menu-item-has-children.open\n    a {\n    color: var(--white);\n  }\n  .page-template-memberships\n    .header\n    .header__nav\n    > ul\n    .menu-item-has-children.open\n    a\n    .nav-arrow {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='13' fill='none'%3E%3Cpath fill='%23fff' d='M6.718 9.78a.75.75 0 0 1-.53.22h-.38a.77.77 0 0 1-.53-.22L.148 4.64a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0l4.44 4.45 4.44-4.45a.5.5 0 0 1 .71 0l.7.71a.498.498 0 0 1 0 .71l-5.13 5.14Z'/%3E%3C/svg%3E\");\n  }\n  .page-template-memberships\n    .header\n    .header__nav\n    > ul\n    .menu-item-has-children\n    a\n    .nav-arrow {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='13' fill='none'%3E%3Cpath fill='%23fff' d='M6.718 9.78a.75.75 0 0 1-.53.22h-.38a.77.77 0 0 1-.53-.22L.148 4.64a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0l4.44 4.45 4.44-4.45a.5.5 0 0 1 .71 0l.7.71a.498.498 0 0 1 0 .71l-5.13 5.14Z'/%3E%3C/svg%3E\");\n  }\n  .page-template-memberships\n    .header\n    .header__nav\n    > ul\n    .menu-item-has-children\n    .sub-menu {\n    background: var(--dark);\n  }\n  .page-template-memberships\n    .header\n    .header__nav\n    > ul\n    .menu-item-has-children\n    .sub-menu\n    li\n    a {\n    color: var(--white);\n  }\n}\n\n.header {\n  width: 100%;\n  height: var(--heightHeader);\n  -webkit-transition: height 0.4s;\n  transition: height 0.4s;\n}\n.header.header-scroll .header__logo .main-logo {\n  opacity: 0;\n}\n.header.header-scroll .header__logo .main-scroll-logo {\n  opacity: 1;\n}\n.header.header--toast {\n  height: var(--heightHeaderToast);\n}\n.header.header--toast .header__inner {\n  top: 44px;\n  -webkit-transition-delay: 0.1s;\n  transition-delay: 0.1s;\n}\n.header.header--toast.header-scroll .header__inner,\n.header.header--toast.open-menu .header__inner {\n  top: 0 !important;\n  -webkit-transition-delay: 0s;\n  transition-delay: 0s;\n}\n.header .header__inner {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: var(--heightHeader);\n  padding: 16px 0;\n  -webkit-transition: top 0.2s;\n  transition: top 0.2s;\n}\n.header .header__inner::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--white);\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.header .header__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 43px;\n}\n.header .header__logo {\n  width: 128px;\n  height: 28px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 2;\n}\n.header .header__logo a,\n.header .header__logo img {\n  width: 100%;\n  height: 100%;\n}\n.header .header__logo img {\n  -o-object-fit: contain;\n  object-fit: contain;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.header .header__logo .main-scroll-logo {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n.header .header__nav > ul {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-right: auto;\n}\n.header .header__nav > ul > li:not(:first-child) {\n  margin-left: 39px;\n}\n.header .header__nav > ul > li > a {\n  font-weight: 400;\n  font-size: 17px;\n  color: var(--gray);\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  position: relative;\n  z-index: 2;\n}\n.header .header__nav > ul > li > a::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -4px;\n  width: 0%;\n  height: 2px;\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 1150px) {\n  .header .header__nav > ul > li:hover a {\n    color: var(--dark);\n  }\n  .header .header__nav > ul > li:hover a::before {\n    width: 100%;\n  }\n}\n.header .header__nav > ul .menu-item-has-children {\n  position: relative;\n  z-index: 2;\n  padding-right: 16px;\n  position: relative;\n  z-index: 2;\n}\n.header .header__nav > ul .menu-item-has-children::before {\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  right: 0;\n  width: 9px;\n  height: 6px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='6' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill='%232F2F2F' d='M4.798 5.343c-.1.1-.236.157-.378.157h-.272a.55.55 0 0 1-.378-.157L.105 1.672a.357.357 0 0 1 0-.507L.612.657a.35.35 0 0 1 .5 0l3.172 3.179L7.455.657a.357.357 0 0 1 .507 0l.5.508a.357.357 0 0 1 0 .507L4.798 5.343Z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 .5h8.57v5H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.header .header__nav > ul .menu-item-has-children::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -4px;\n  width: 0%;\n  height: 2px;\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 1150px) {\n  .header .header__nav > ul .menu-item-has-children:hover::before {\n    -webkit-transform: rotate(-180deg);\n    transform: rotate(-180deg);\n  }\n  .header .header__nav > ul .menu-item-has-children:hover::after {\n    width: 100%;\n  }\n  .header .header__nav > ul .menu-item-has-children:hover > a {\n    color: var(--dark);\n  }\n  .header .header__nav > ul .menu-item-has-children:hover .sub-menu {\n    opacity: 1;\n    -webkit-transform: translateX(-50%) translateY(0px);\n    transform: translateX(-50%) translateY(0px);\n    pointer-events: all;\n  }\n}\n.header .header__nav > ul .menu-item-has-children .sub-menu {\n  position: absolute;\n  top: calc(100% + 31px);\n  left: calc(50% + 38px);\n  -webkit-transform: translateX(-50%) translateY(10px);\n  transform: translateX(-50%) translateY(10px);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 252px;\n  border-radius: 24px;\n  background: var(--white);\n  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1),\n    0px 0px 2px 0px rgba(0, 0, 0, 0.06);\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1),\n    0px 0px 2px 0px rgba(0, 0, 0, 0.06);\n  padding: 31px;\n  opacity: 0;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  pointer-events: none;\n}\n.header .header__nav > ul .menu-item-has-children .sub-menu::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: -31px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.header\n  .header__nav\n  > ul\n  .menu-item-has-children\n  .sub-menu\n  li:not(:first-child) {\n  margin-top: 16px;\n}\n.header .header__nav > ul .menu-item-has-children .sub-menu li a {\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--gray);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  position: relative;\n  z-index: 2;\n}\n.header .header__nav > ul .menu-item-has-children .sub-menu li a::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 0%;\n  height: 2px;\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 1150px) {\n  .header .header__nav > ul .menu-item-has-children .sub-menu li a:hover {\n    color: var(--dark);\n  }\n  .header\n    .header__nav\n    > ul\n    .menu-item-has-children\n    .sub-menu\n    li\n    a:hover::before {\n    width: 100%;\n  }\n}\n.header .header__buttons {\n  margin-left: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 40px;\n}\n.header .header__buttons .header__price-button a,\n.header .header__buttons .header__price-button button {\n  font-weight: 400;\n  font-size: 17px;\n  color: var(--gray);\n}\n.header .header__buttons .header__request-button .btn {\n  padding: 16px 24px;\n}\n.header .header__menu {\n  display: none;\n}\n\n@media screen and (max-width: 1280px) {\n  :root {\n    --heightHeader: 6.25vw;\n    --heightHeaderToast: 9.6875vw;\n  }\n  .header.header--toast {\n    height: var(--heightHeaderToast);\n  }\n  .header.header--toast .header__inner {\n    top: 3.4375vw;\n  }\n  .header .header__inner {\n    padding: 1.25vw 0;\n  }\n  .header .header__wrapper {\n    gap: 3.3594vw;\n  }\n  .header .header__logo {\n    width: 10vw;\n    height: 2.1875vw;\n  }\n  .header .header__nav > ul > li:not(:first-child) {\n    margin-left: 3.125vw;\n  }\n  .header .header__nav > ul > li > a {\n    font-size: 1.3281vw;\n  }\n  .header .header__nav > ul > li > a::before {\n    bottom: -0.3125vw;\n    height: 0.1563vw;\n  }\n  .header .header__nav > ul .menu-item-has-children {\n    padding-right: 1.5625vw;\n  }\n  .header .header__nav > ul .menu-item-has-children::before {\n    top: 0.3906vw;\n    right: 0;\n    width: 0.7031vw;\n    height: 0.4688vw;\n  }\n  .header .header__nav > ul .menu-item-has-children::after {\n    bottom: -0.3125vw;\n    height: 0.1563vw;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu {\n    top: calc(100% + 2.4219vw);\n    left: calc(50% + 2.9688vw);\n    -webkit-transform: translateX(-50%) translateY(0.7813vw);\n    transform: translateX(-50%) translateY(0.7813vw);\n    width: 19.6875vw;\n    border-radius: 1.875vw;\n    -webkit-box-shadow: 0px 0px 0.7813vw 0px rgba(0, 0, 0, 0.1),\n      0px 0px 0.1563vw 0px rgba(0, 0, 0, 0.06);\n    box-shadow: 0px 0px 0.7813vw 0px rgba(0, 0, 0, 0.1),\n      0px 0px 0.1563vw 0px rgba(0, 0, 0, 0.06);\n    padding: 2.4219vw;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu::before {\n    top: -2.4219vw;\n  }\n  .header\n    .header__nav\n    > ul\n    .menu-item-has-children\n    .sub-menu\n    li:not(:first-child) {\n    margin-top: 1.25vw;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu li a {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu li a::before {\n    height: 0.1563vw;\n  }\n  .header .header__buttons {\n    gap: 3.5938vw;\n  }\n  .header .header__buttons .header__price-button a,\n  .header .header__buttons .header__price-button button {\n    font-size: 1.3281vw;\n  }\n  .header .header__buttons .header__request-button .btn {\n    padding: 1.25vw 1.875vw;\n  }\n}\n@media screen and (max-width: 1150px) {\n  :root {\n    --heightHeaderToast: 104px;\n    --heightMobileHeader: 60px;\n  }\n  .header {\n    height: var(--heightMobileHeader);\n  }\n  .header.header--toast {\n    height: var(--heightHeaderToast);\n  }\n  .header.header--toast .header__inner {\n    top: 44px;\n  }\n  .header .header__inner {\n    height: var(--heightMobileHeader);\n    padding: 16px 0;\n  }\n  .header .header__wrapper {\n    gap: 20px;\n  }\n  .header .header__logo {\n    width: 122px;\n    height: 26px;\n  }\n  .header .header__nav {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    max-height: 100vh;\n    overflow: auto;\n    z-index: -2;\n    background-color: var(--white);\n    padding: 106px 20px 50px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n    -webkit-transition: all 0.4s linear;\n    transition: all 0.4s linear;\n  }\n  .header .header__nav.open {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n  .header .header__nav > ul {\n    width: 100%;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    margin-bottom: 30px;\n  }\n  .header .header__nav > ul > li {\n    width: 100%;\n    padding-bottom: 28px;\n    border-bottom: 1px solid var(--white-2);\n  }\n  .header .header__nav > ul > li:not(:first-child) {\n    margin-top: 25px;\n    margin-left: 0;\n  }\n  .header .header__nav > ul > li > a {\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: -0.18px;\n    font-size: 18px;\n    color: var(--gray);\n  }\n  .header .header__nav > ul .menu-item-has-children {\n    padding-right: 0;\n  }\n  .header .header__nav > ul .menu-item-has-children::before {\n    display: none;\n  }\n  .header .header__nav > ul .menu-item-has-children.open a {\n    color: var(--gray-3);\n  }\n  .header .header__nav > ul .menu-item-has-children.open a .nav-arrow {\n    -webkit-transform: rotateX(145deg);\n    transform: rotateX(145deg);\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='6' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill='%237F7E7C' d='M3.774 5.343c.1.1.236.157.378.157h.272a.55.55 0 0 0 .378-.157l3.665-3.671a.357.357 0 0 0 0-.507L7.959.657a.35.35 0 0 0-.5 0L4.29 3.836 1.116.657a.357.357 0 0 0-.508 0l-.5.508a.357.357 0 0 0 0 .507l3.665 3.671Z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M8.572.5H.002v5h8.57z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  }\n  .header .header__nav > ul .menu-item-has-children a {\n    position: relative;\n    z-index: 2;\n    padding-right: 18px;\n    -webkit-transition: all 0.4s linear;\n    transition: all 0.4s linear;\n  }\n  .header .header__nav > ul .menu-item-has-children a .nav-arrow {\n    position: absolute;\n    top: 8px;\n    right: 0;\n    width: 12px;\n    height: 12px;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='13' fill='none'%3E%3Cpath fill='%232F2F2F' d='M6.718 9.78a.75.75 0 0 1-.53.22h-.38a.77.77 0 0 1-.53-.22L.148 4.64a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0l4.44 4.45 4.44-4.45a.5.5 0 0 1 .71 0l.7.71a.498.498 0 0 1 0 .71l-5.13 5.14Z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    -webkit-transition: all 0.4s linear;\n    transition: all 0.4s linear;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu {\n    display: none;\n    margin-top: 28px;\n    position: relative;\n    top: 0;\n    left: 0;\n    -webkit-transform: translate(0, 0);\n    transform: translate(0, 0);\n    width: 100%;\n    border-radius: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    padding: 0;\n    opacity: 1;\n    -webkit-transition: none;\n    transition: none;\n    pointer-events: all;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu::before {\n    display: none;\n  }\n  .header\n    .header__nav\n    > ul\n    .menu-item-has-children\n    .sub-menu\n    li:not(:first-child) {\n    margin-top: 24px;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu li a {\n    font-weight: 500;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n    font-size: 16px;\n    color: var(--gray);\n  }\n  .header .header__buttons {\n    display: none;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    margin-top: auto;\n    width: 100%;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 38px;\n  }\n  .header .header__buttons.show {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .header .header__buttons .header__price-button {\n    width: 100%;\n  }\n  .header .header__buttons .header__price-button a,\n  .header .header__buttons .header__price-button button {\n    width: 100%;\n    font-size: 18px;\n    text-align: center;\n  }\n  .header .header__buttons .header__request-button {\n    width: 100%;\n  }\n  .header .header__buttons .header__request-button .btn {\n    width: 100%;\n    padding: 17px 24px;\n  }\n  .header .header__menu {\n    display: block;\n    width: 24px;\n    height: 16px;\n    position: relative;\n    z-index: 2;\n    margin-left: auto;\n    margin-bottom: 3px;\n    margin-right: 4px;\n  }\n  .header .header__menu::before,\n  .header .header__menu strong,\n  .header .header__menu::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    border-radius: 2px;\n    background-color: var(--dark);\n    -webkit-transition: all 0.4s linear;\n    transition: all 0.4s linear;\n  }\n  .header .header__menu::before {\n    top: 0;\n  }\n  .header .header__menu strong {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n  }\n  .header .header__menu::after {\n    bottom: 0;\n  }\n  .header .header__menu.open::before {\n    top: 50%;\n    -webkit-transform: translateY(-50%) rotate(45deg);\n    transform: translateY(-50%) rotate(45deg);\n  }\n  .header .header__menu.open strong {\n    -webkit-transform: translateY(-50%) scale(0);\n    transform: translateY(-50%) scale(0);\n    opacity: 0;\n  }\n  .header .header__menu.open::after {\n    bottom: 50%;\n    -webkit-transform: translateY(50%) rotate(-45deg);\n    transform: translateY(50%) rotate(-45deg);\n  }\n}\n@media screen and (max-width: 850px) {\n  :root {\n    --heightHeaderToast: 31.2821vw;\n    --heightMobileHeader: 15.3846vw;\n  }\n  .header {\n    height: var(--heightMobileHeader);\n  }\n  .header.header--toast {\n    height: var(--heightHeaderToast);\n  }\n  .header.header--toast .header__inner {\n    top: 15.8974vw;\n  }\n  .header .header__inner {\n    height: var(--heightMobileHeader);\n    padding: 4.1026vw 0;\n  }\n  .header .header__wrapper {\n    gap: 5.1282vw;\n  }\n  .header .header__logo {\n    width: 31.2821vw;\n    height: 6.6667vw;\n  }\n  .header .header__nav {\n    padding: 27.1795vw 5.1282vw 12.8205vw;\n  }\n  .header .header__nav > ul {\n    margin-bottom: 7.6923vw;\n  }\n  .header .header__nav > ul > li {\n    padding-bottom: 7.1795vw;\n  }\n  .header .header__nav > ul > li:not(:first-child) {\n    margin-top: 6.4103vw;\n  }\n  .header .header__nav > ul > li > a {\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n  }\n  .header .header__nav > ul .menu-item-has-children a {\n    padding-right: 4.6154vw;\n  }\n  .header .header__nav > ul .menu-item-has-children a .nav-arrow {\n    top: 2.0513vw;\n    width: 3.0769vw;\n    height: 3.0769vw;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu {\n    margin-top: 7.1795vw;\n  }\n  .header\n    .header__nav\n    > ul\n    .menu-item-has-children\n    .sub-menu\n    li:not(:first-child) {\n    margin-top: 6.1538vw;\n  }\n  .header .header__nav > ul .menu-item-has-children .sub-menu li a {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .header .header__buttons {\n    gap: 9.7436vw;\n  }\n  .header .header__buttons .header__price-button a,\n  .header .header__buttons .header__price-button button {\n    font-size: 4.6154vw;\n  }\n  .header .header__buttons .header__request-button .btn {\n    padding: 4.359vw 6.1538vw;\n  }\n  .header .header__menu {\n    width: 6.1538vw;\n    height: 4.1026vw;\n    margin-bottom: 0.7692vw;\n    margin-right: 1.0256vw;\n  }\n  .header .header__menu::before,\n  .header .header__menu strong,\n  .header .header__menu::after {\n    height: 0.5128vw;\n    border-radius: 0.5128vw;\n  }\n}\n.archive .footer,\n.blog .footer,\n.single-post:not(.post-template-single-new) .footer,\n.error404 .footer,\n.page-template-integrations .footer,\n.page-template-vip_store .footer,\n.page-template-lp .footer,\n.page-template-shopify-pos-lp .footer {\n  background-color: var(--white);\n}\n\n.page-template-pricing .footer {\n  background-color: var(--beige);\n}\n\n.single-customers .footer,\n.page-template-contact_us .footer,\n.page-template-thankyou .footer {\n  background-color: var(--light-gray);\n}\n\n.archive .footer {\n  margin-top: 138px;\n}\n@media screen and (max-width: 1330px) {\n  .archive .footer {\n    margin-top: 10.3759vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .archive .footer {\n    margin-top: 23.0769vw;\n  }\n}\n\n.footer {\n  background-color: var(--yellow);\n  padding: 0 30px 30px;\n}\n.footer.white-bg {\n  background-color: var(--white);\n}\n.footer .footer__inner {\n  background-color: var(--dark);\n  border-radius: 24px;\n  padding: 170px 0 43px;\n}\n.footer .footer__title {\n  margin-bottom: 188px;\n}\n.footer .footer__title h2 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  font-size: 62px;\n  line-height: 1.1;\n  letter-spacing: -0.62px;\n  color: var(--white);\n}\n.footer .footer__title h2 a,\n.footer .footer__title h2 span,\n.footer .footer__title h2 strong {\n  color: var(--yellow);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  position: relative;\n  z-index: 2;\n  padding-bottom: 6px;\n}\n.footer .footer__title h2 a::before,\n.footer .footer__title h2 span::before,\n.footer .footer__title h2 strong::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 4px;\n  background-color: var(--yellow);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.footer .footer__title h2 a:hover,\n.footer .footer__title h2 span:hover,\n.footer .footer__title h2 strong:hover {\n  color: var(--dark);\n}\n.footer .footer__title h2 a:hover::before,\n.footer .footer__title h2 span:hover::before,\n.footer .footer__title h2 strong:hover::before {\n  height: 100%;\n}\n.footer .footer__list {\n  width: 100%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 30px;\n}\n.footer .footer__list .list {\n  width: 100%;\n}\n.footer .footer__list .list h4 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: -0.24px;\n  font-size: 24px;\n  color: var(--white);\n  margin-bottom: 28px;\n}\n.footer .footer__list .list ul li:not(:first-child) {\n  margin-top: 18px;\n}\n.footer .footer__list .list ul li:hover a {\n  color: #8f8b84;\n}\n.footer .footer__list .list ul li a {\n  font-weight: 400;\n  letter-spacing: -0.198px;\n  font-size: 18px;\n  color: var(--white-2);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.footer .footer__bottom {\n  margin-top: 168px;\n  padding-top: 49px;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 48px;\n}\n.footer .footer__bottom-logo {\n  width: 113px;\n  height: 24px;\n}\n.footer .footer__bottom-logo a,\n.footer .footer__bottom-logo img {\n  width: 100%;\n  height: 100%;\n}\n.footer .footer__bottom-logo img {\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.footer .footer__bottom-copy {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.2;\n  letter-spacing: -0.176px;\n  color: var(--white);\n  opacity: 0.3;\n}\n.footer .footer__bottom-social {\n  margin-left: auto;\n}\n.footer .footer__bottom-social ul {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 16px;\n}\n.footer .footer__bottom-social ul li {\n  width: 24px;\n  height: 24px;\n}\n.footer .footer__bottom-social ul li a,\n.footer .footer__bottom-social ul li img {\n  width: 100%;\n  height: 100%;\n}\n.footer .footer__bottom-social ul li img {\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .footer {\n    padding: 0 2.2556vw 2.2556vw;\n  }\n  .footer .footer__inner {\n    border-radius: 1.8045vw;\n    padding: 12.782vw 0 3.2331vw;\n  }\n  .footer .footer__title {\n    margin-bottom: 14.1353vw;\n  }\n  .footer .footer__title h2 {\n    font-size: 4.6617vw;\n    letter-spacing: -0.0466vw;\n  }\n  .footer .footer__title h2 a,\n  .footer .footer__title h2 span,\n  .footer .footer__title h2 strong {\n    padding-bottom: 0.4511vw;\n  }\n  .footer .footer__title h2 a::before,\n  .footer .footer__title h2 span::before,\n  .footer .footer__title h2 strong::before {\n    height: 0.3008vw;\n  }\n  .footer .footer__list {\n    grid-gap: 2.2556vw;\n  }\n  .footer .footer__list .list h4 {\n    letter-spacing: -0.018vw;\n    font-size: 1.8045vw;\n    margin-bottom: 2.1053vw;\n  }\n  .footer .footer__list .list ul li:not(:first-child) {\n    margin-top: 1.3534vw;\n  }\n  .footer .footer__list .list ul li a {\n    letter-spacing: -0.0149vw;\n    font-size: 1.3534vw;\n  }\n  .footer .footer__bottom {\n    margin-top: 12.6316vw;\n    padding-top: 3.6842vw;\n    gap: 3.609vw;\n  }\n  .footer .footer__bottom-logo {\n    width: 8.4962vw;\n    height: 1.8045vw;\n  }\n  .footer .footer__bottom-copy {\n    font-size: 1.203vw;\n    letter-spacing: -0.0132vw;\n  }\n  .footer .footer__bottom-social ul {\n    gap: 1.203vw;\n  }\n  .footer .footer__bottom-social ul li {\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .footer {\n    padding: 0 2.3438vw 2.3438vw;\n  }\n  .footer .footer__inner {\n    border-radius: 1.875vw;\n    padding: 7.9688vw 0 3.2031vw;\n  }\n  .footer .footer__title {\n    max-width: 54.6875vw;\n    margin-bottom: 7.1094vw;\n  }\n  .footer .footer__title h2 {\n    font-size: 2.9688vw;\n    letter-spacing: -0.0297vw;\n  }\n  .footer .footer__title h2 a,\n  .footer .footer__title h2 span,\n  .footer .footer__title h2 strong {\n    padding-bottom: 0.4688vw;\n  }\n  .footer .footer__title h2 a::before,\n  .footer .footer__title h2 span::before,\n  .footer .footer__title h2 strong::before {\n    height: 0.1563vw;\n  }\n  .footer .footer__list {\n    grid-gap: 2.3438vw;\n  }\n  .footer .footer__list .list h4 {\n    letter-spacing: -0.0188vw;\n    font-size: 1.875vw;\n    margin-bottom: 2.2656vw;\n  }\n  .footer .footer__list .list ul li:not(:first-child) {\n    margin-top: 1.4063vw;\n  }\n  .footer .footer__list .list ul li a {\n    letter-spacing: -0.0155vw;\n    font-size: 1.4063vw;\n  }\n  .footer .footer__bottom {\n    margin-top: 10.8594vw;\n    padding-top: 3.8281vw;\n    border-top: 1px solid rgba(255, 255, 255, 0.15);\n    gap: 3.75vw;\n  }\n  .footer .footer__bottom-logo {\n    width: 8.8281vw;\n    height: 1.875vw;\n  }\n  .footer .footer__bottom-copy {\n    font-size: 1.25vw;\n    letter-spacing: -0.0138vw;\n  }\n  .footer .footer__bottom-social ul {\n    gap: 1.25vw;\n  }\n  .footer .footer__bottom-social ul li {\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .footer {\n    padding: 0;\n  }\n  .footer.white-bg {\n    margin-top: 7.6923vw;\n  }\n  .footer .footer__inner {\n    border-radius: 4.1026vw 4.1026vw 0 0;\n    padding: 21.0256vw 0 11.0256vw;\n  }\n  .footer .footer__title {\n    max-width: 100%;\n    margin-bottom: 16.4103vw;\n  }\n  .footer .footer__title h2 {\n    font-size: 8.2051vw;\n    line-height: 1.2;\n    letter-spacing: -0.0821vw;\n  }\n  .footer .footer__title h2 a,\n  .footer .footer__title h2 span,\n  .footer .footer__title h2 strong {\n    padding-bottom: 1.0256vw;\n  }\n  .footer .footer__title h2 a::before,\n  .footer .footer__title h2 span::before,\n  .footer .footer__title h2 strong::before {\n    height: 0.5128vw;\n  }\n  .footer .footer__list {\n    -ms-grid-columns: 1fr 7.6923vw 1fr;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 8.2051vw 7.6923vw;\n  }\n  .footer .footer__list .list h4 {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n    margin-bottom: 4.6154vw;\n  }\n  .footer .footer__list .list ul li:not(:first-child) {\n    margin-top: 2.5641vw;\n  }\n  .footer .footer__list .list ul li a {\n    letter-spacing: -0.0367vw;\n    font-size: 3.3333vw;\n  }\n  .footer .footer__bottom {\n    margin-top: 12.0513vw;\n    padding-top: 6.1538vw;\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 10.2564vw 1fr;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 10.2564vw;\n  }\n  .footer .footer__bottom-logo {\n    -ms-grid-column-span: 2;\n    grid-column: span 2;\n    width: 28.9744vw;\n    height: 6.1538vw;\n  }\n  .footer .footer__bottom-copy {\n    font-size: 3.0769vw;\n    letter-spacing: -0.0338vw;\n  }\n  .footer .footer__bottom-social ul {\n    gap: 4.1026vw;\n  }\n  .footer .footer__bottom-social ul li {\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n}\n.page-template-lp .footer .footer__list,\n.page-template-shopify-pos-lp .footer .footer__list {\n  display: none;\n}\n.page-template-lp .footer .footer__title,\n.page-template-shopify-pos-lp .footer .footer__title {\n  margin-bottom: 70px;\n}\n.page-template-lp .footer .footer__bottom,\n.page-template-shopify-pos-lp .footer .footer__bottom {\n  margin-top: 70px;\n}\n@media screen and (max-width: 1330px) {\n  .page-template-lp .footer .footer__title,\n  .page-template-shopify-pos-lp .footer .footer__title {\n    margin-bottom: 5.263vw;\n  }\n  .page-template-lp .footer .footer__bottom,\n  .page-template-shopify-pos-lp .footer .footer__bottom {\n    margin-top: 5.263vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .page-template-lp .footer .footer__title,\n  .page-template-shopify-pos-lp .footer .footer__title {\n    margin-bottom: 5.469vw;\n  }\n  .page-template-lp .footer .footer__bottom,\n  .page-template-shopify-pos-lp .footer .footer__bottom {\n    margin-top: 5.469vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .page-template-lp .footer .footer__title,\n  .page-template-shopify-pos-lp .footer .footer__title {\n    margin-bottom: 17.949vw;\n  }\n  .page-template-lp .footer .footer__bottom,\n  .page-template-shopify-pos-lp .footer .footer__bottom {\n    margin-top: 17.949vw;\n  }\n}\n\n@media screen and (max-width: 1550px) and (min-width: 1280px) {\n  .page-template-shopify-pos-lp .footer .container {\n    max-width: 82.806vw;\n  }\n  .page-template-shopify-pos-lp .footer .footer__title h2 {\n    font-size: 4vw;\n  }\n}\n.first-screen-home .first-screen-home__inner {\n  padding: 104px 0;\n}\n.first-screen-home .first-screen-home__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  gap: 30px;\n}\n.first-screen-home .first-screen-home__content {\n  width: 100%;\n  max-width: 743px;\n}\n.first-screen-home .first-screen-home__content-title {\n  margin-bottom: 29px;\n}\n.first-screen-home .first-screen-home__content-title h1 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  font-size: 62px;\n  line-height: 1.1;\n  color: var(--dark);\n  letter-spacing: -0.62px;\n}\n.first-screen-home .first-screen-home__content-text {\n  width: 100%;\n  max-width: 528px;\n  font-weight: 400;\n  line-height: 1.4;\n  font-size: 24px;\n  letter-spacing: -0.45px;\n  color: var(--gray);\n}\n.first-screen-home .first-screen-home__content-buttons {\n  margin-top: 28px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 16px;\n}\n.first-screen-home .first-screen-home__content-message {\n  width: 100%;\n  max-width: 470px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  margin-top: 82px;\n}\n.first-screen-home .first-screen-home__content-message-text {\n  font-weight: 400;\n  line-height: 1.5;\n  font-size: 18px;\n  color: var(--gray);\n  letter-spacing: -0.34px;\n}\n.first-screen-home .first-screen-home__content-message-text a {\n  position: relative;\n  z-index: 2;\n  padding-right: 28px;\n  padding-bottom: 2px;\n}\n.first-screen-home .first-screen-home__content-message-text a::before {\n  content: \"\";\n  position: absolute;\n  top: 0px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.first-screen-home .first-screen-home__content-message-text a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 28px);\n  height: 2px;\n  -webkit-transform: translateX(-28px);\n  transform: translateX(-28px);\n  background-color: var(--gray);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.first-screen-home .first-screen-home__content-message-text a:hover::before {\n  -webkit-transform: translateX(3px);\n  transform: translateX(3px);\n}\n.first-screen-home .first-screen-home__content-message-text a:hover::after {\n  width: 0%;\n}\n.first-screen-home .first-screen-home__media {\n  width: 100%;\n  margin-top: -4px;\n  max-width: 520px;\n  position: relative;\n  z-index: 2;\n  opacity: 0;\n}\n.first-screen-home .first-screen-home__media.is-animation {\n  -webkit-animation: showItem 1s linear both;\n  animation: showItem 1s linear both;\n}\n.first-screen-home .first-screen-home__media-decorative {\n  position: absolute;\n  z-index: 2;\n  left: -108px;\n  bottom: -12px;\n  width: 169px;\n  height: 136px;\n}\n.first-screen-home .first-screen-home__media-decorative img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.first-screen-home .first-screen-home__media-decorative lottie-player {\n  width: 100%;\n  height: 100%;\n}\n.first-screen-home .first-screen-home__media-list {\n  width: 100%;\n  height: 520px;\n  border-radius: 24px;\n  overflow: hidden;\n}\n.first-screen-home .first-screen-home__media-list .list {\n  width: 100%;\n  height: 100%;\n}\n.first-screen-home .first-screen-home__media-list .list .slick-list,\n.first-screen-home .first-screen-home__media-list .list .slick-track {\n  width: 100%;\n  height: 100%;\n}\n.first-screen-home .first-screen-home__media-list .item {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.first-screen-home .first-screen-home__media-list .item-wrapper {\n  padding: 30px 32px;\n}\n.first-screen-home .first-screen-home__media-list .item-image {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.first-screen-home .first-screen-home__media-list .item-image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.first-screen-home .first-screen-home__media-list .item-labels {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n.first-screen-home .first-screen-home__media-list .item .item-label {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 12px;\n  background-color: var(--white);\n  padding: 16px 7px 16px 14px;\n  opacity: 0;\n  -webkit-transform: translateY(50px);\n  transform: translateY(50px);\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.first-screen-home .first-screen-home__media-list .item .item-label.show {\n  -webkit-transform: translateY(0px);\n  transform: translateY(0px);\n  opacity: 1;\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label:not(:first-child) {\n  margin-top: 13px;\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label.item-label--white {\n  padding: 15px 16px 15px 12px;\n  background-color: var(--white);\n  color: var(--dark);\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label.item-label--black {\n  padding: 15px 14px 18px;\n  background-color: var(--dark);\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label.item-label--black\n  .item-label__content {\n  text-align: center;\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label.item-label--black\n  .item-label__content-title {\n  font-weight: 400;\n  font-size: 12px;\n  letter-spacing: -0.36px;\n  color: var(--white);\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label.item-label--black\n  .item-label__content-subtitle {\n  font-weight: 500;\n  font-size: 25px;\n  letter-spacing: -0.753px;\n  color: var(--white);\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label.item-label--yellow {\n  padding: 16px 18px 16px 14px;\n  background-color: var(--yellow);\n  color: var(--dark);\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label\n  .item-label__icon {\n  width: 42px;\n  height: 42px;\n  margin-right: 14px;\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label\n  .item-label__icon\n  img {\n  width: 100%;\n  height: 100%;\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label\n  .item-label__content-title,\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label\n  .item-label__content-subtitle {\n  font-weight: 400;\n  font-size: 16px;\n  color: var(--dark);\n  letter-spacing: -0.475px;\n}\n.first-screen-home\n  .first-screen-home__media-list\n  .item\n  .item-label\n  .item-label__content-title {\n  margin-bottom: 3px;\n}\n@media screen and (max-width: 1330px) {\n  .first-screen-home .first-screen-home__inner {\n    padding: 7.8195vw 0;\n  }\n  .first-screen-home .first-screen-home__wrapper {\n    gap: 2.2556vw;\n  }\n  .first-screen-home .first-screen-home__content {\n    max-width: 55.8647vw;\n  }\n  .first-screen-home .first-screen-home__content-title {\n    margin-bottom: 2.1805vw;\n  }\n  .first-screen-home .first-screen-home__content-title h1 {\n    font-size: 4.6617vw;\n    letter-spacing: -0.0466vw;\n  }\n  .first-screen-home .first-screen-home__content-text {\n    max-width: 39.6992vw;\n    font-size: 1.8045vw;\n    letter-spacing: -0.0338vw;\n  }\n  .first-screen-home .first-screen-home__content-buttons {\n    margin-top: 2.1053vw;\n    gap: 1.203vw;\n  }\n  .first-screen-home .first-screen-home__content-message {\n    max-width: 35.3383vw;\n    margin-top: 6.1654vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text {\n    font-size: 1.3534vw;\n    letter-spacing: -0.0256vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text a {\n    padding-right: 2.1053vw;\n    padding-bottom: 0.1504vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text a::before {\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text a::after {\n    width: calc(100% - 2.1053vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.1053vw);\n    transform: translateX(-2.1053vw);\n  }\n  .first-screen-home .first-screen-home__media {\n    margin-top: -0.3008vw;\n    max-width: 39.0977vw;\n  }\n  .first-screen-home .first-screen-home__media-decorative {\n    left: -8.1203vw;\n    bottom: -0.9023vw;\n    width: 12.7068vw;\n    height: 10.2256vw;\n  }\n  .first-screen-home .first-screen-home__media-list {\n    height: 39.0977vw;\n    border-radius: 1.8045vw;\n  }\n  .first-screen-home .first-screen-home__media-list .item-wrapper {\n    padding: 2.2556vw 2.406vw;\n  }\n  .first-screen-home .first-screen-home__media-list .item .item-label {\n    border-radius: 0.9023vw;\n    padding: 1.203vw 0.5263vw 1.203vw 1.0526vw;\n    -webkit-transform: translateY(3.7594vw);\n    transform: translateY(3.7594vw);\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label:not(:first-child) {\n    margin-top: 0.9774vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--white {\n    padding: 1.1278vw 1.203vw 1.1278vw 0.9023vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black {\n    padding: 1.1278vw 1.0526vw 1.3534vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black\n    .item-label__content-title {\n    font-size: 0.9023vw;\n    letter-spacing: -0.0271vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black\n    .item-label__content-subtitle {\n    font-size: 1.8797vw;\n    letter-spacing: -0.0566vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--yellow {\n    padding: 1.203vw 1.3534vw 1.203vw 1.0526vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__icon {\n    width: 3.1579vw;\n    height: 3.1579vw;\n    margin-right: 1.0526vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-title,\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-subtitle {\n    font-size: 1.203vw;\n    letter-spacing: -0.0357vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-title {\n    margin-bottom: 0.2256vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .first-screen-home .first-screen-home__inner {\n    padding: 3.5938vw 0 7.4219vw;\n  }\n  .first-screen-home .first-screen-home__wrapper {\n    gap: 5.9375vw;\n  }\n  .first-screen-home .first-screen-home__content {\n    margin-top: 2.1094vw;\n    max-width: 39.6875vw;\n  }\n  .first-screen-home .first-screen-home__content-title {\n    margin-bottom: 2.1875vw;\n  }\n  .first-screen-home .first-screen-home__content-title h1 {\n    font-size: 3.5938vw;\n    letter-spacing: -0.0359vw;\n  }\n  .first-screen-home .first-screen-home__content-text {\n    max-width: 30.9375vw;\n    line-height: 1.5;\n    font-size: 1.4063vw;\n    letter-spacing: 0px;\n  }\n  .first-screen-home .first-screen-home__content-buttons {\n    margin-top: 2.6563vw;\n    gap: 1.25vw;\n  }\n  .first-screen-home .first-screen-home__content-message {\n    max-width: 32.8125vw;\n    margin-top: 2.5vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text {\n    line-height: 1.4;\n    font-size: 1.25vw;\n    letter-spacing: 0px;\n  }\n  .first-screen-home .first-screen-home__content-message-text a {\n    padding-right: 2.1875vw;\n    padding-bottom: 0.1563vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text a::before {\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text a::after {\n    width: calc(100% - 2.1875vw);\n    height: 0.1563vw;\n    -webkit-transform: translateX(-2.1875vw);\n    transform: translateX(-2.1875vw);\n  }\n  .first-screen-home .first-screen-home__media {\n    margin-top: 0;\n    max-width: 32.4219vw;\n  }\n  .first-screen-home .first-screen-home__media-decorative {\n    left: 2.7344vw;\n    bottom: -5.3906vw;\n    width: 11.0156vw;\n    height: 11.0156vw;\n  }\n  .first-screen-home .first-screen-home__media-list {\n    height: 32.6563vw;\n    border-radius: 1.875vw;\n  }\n  .first-screen-home .first-screen-home__media-list .item-wrapper {\n    padding: 1.9531vw;\n  }\n  .first-screen-home .first-screen-home__media-list .item .item-label {\n    border-radius: 0.7813vw;\n    padding: 0.9375vw 0.4688vw;\n    -webkit-transform: translateY(3.9063vw);\n    transform: translateY(3.9063vw);\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label:not(:first-child) {\n    margin-top: 0.8594vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--white {\n    padding: 1.0156vw 0.4688vw 1.0156vw 0.8594vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black {\n    padding: 0.9375vw 0.8594vw 1.1719vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black\n    .item-label__content-title {\n    font-size: 0.7813vw;\n    letter-spacing: -0.0226vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black\n    .item-label__content-subtitle {\n    font-size: 1.5625vw;\n    letter-spacing: -0.0473vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--yellow {\n    padding: 1.0156vw 1.1719vw 0.9375vw 0.8594vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__icon {\n    width: 2.5781vw;\n    height: 2.5781vw;\n    margin-right: 0.9375vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-title,\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-subtitle {\n    font-size: 0.9375vw;\n    letter-spacing: -0.0298vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-title {\n    margin-bottom: 0.2344vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .first-screen-home .first-screen-home__inner {\n    padding: 12.0513vw 0 26.6667vw;\n  }\n  .first-screen-home .first-screen-home__wrapper {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    gap: 14.359vw;\n  }\n  .first-screen-home .first-screen-home__content {\n    max-width: 100%;\n  }\n  .first-screen-home .first-screen-home__content-title {\n    margin-bottom: 5.3846vw;\n  }\n  .first-screen-home .first-screen-home__content-title h1 {\n    font-size: 9.7436vw;\n    letter-spacing: -0.0974vw;\n  }\n  .first-screen-home .first-screen-home__content-text {\n    max-width: 100%;\n    line-height: 1.5;\n    font-size: 4.6154vw;\n    letter-spacing: -0.0462vw;\n  }\n  .first-screen-home .first-screen-home__content-buttons {\n    margin-top: 6.1538vw;\n    gap: 4.1026vw;\n  }\n  .first-screen-home .first-screen-home__content-button {\n    text-align: center;\n  }\n  .first-screen-home .first-screen-home__content-button:first-child {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n  }\n  .first-screen-home .first-screen-home__content-button:last-child {\n    width: 100%;\n  }\n  .first-screen-home .first-screen-home__content-button:last-child .btn-border {\n    width: 100%;\n  }\n  .first-screen-home .first-screen-home__content-message {\n    width: 100%;\n    max-width: 64.6154vw;\n    margin-top: 6.1538vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text {\n    line-height: 1.4;\n    font-size: 4.1026vw;\n    letter-spacing: -0.0769vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text a {\n    padding-right: 7.1795vw;\n    padding-bottom: 0;\n  }\n  .first-screen-home .first-screen-home__content-message-text a::before {\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .first-screen-home .first-screen-home__content-message-text a::after {\n    width: calc(100% - 7.1795vw);\n    -webkit-transform: translateX(-7.1795vw);\n    transform: translateX(-7.1795vw);\n    height: 2px;\n  }\n  .first-screen-home .first-screen-home__media {\n    margin-top: 0;\n    max-width: 100%;\n  }\n  .first-screen-home .first-screen-home__media-decorative {\n    left: 12.3077vw;\n    bottom: -12.3077vw;\n    width: 30vw;\n    height: 24.1026vw;\n  }\n  .first-screen-home .first-screen-home__media-list {\n    height: 89.2308vw;\n    border-radius: 4.1026vw;\n  }\n  .first-screen-home .first-screen-home__media-list .item-wrapper {\n    padding: 5.1282vw 5.3846vw;\n  }\n  .first-screen-home .first-screen-home__media-list .item .item-label {\n    border-radius: 2.0513vw;\n    padding: 2.5641vw 1.2821vw 3.0769vw 2.3077vw;\n    -webkit-transform: translateY(6.4103vw);\n    transform: translateY(6.4103vw);\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label:not(:first-child) {\n    margin-top: 2.5641vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--white {\n    padding: 2.3077vw 3.3333vw 2.8205vw 2.3077vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black {\n    padding: 2.5641vw 2.5641vw 3.0769vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black\n    .item-label__content-title {\n    font-size: 2.0513vw;\n    letter-spacing: -0.0618vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--black\n    .item-label__content-subtitle {\n    font-size: 4.1026vw;\n    letter-spacing: -0.1292vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label.item-label--yellow {\n    padding: 2.5641vw 4.6154vw 2.5641vw 2.3077vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__icon {\n    width: 7.1795vw;\n    height: 7.1795vw;\n    margin-right: 2.5641vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-title,\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-subtitle {\n    font-size: 2.5641vw;\n    letter-spacing: -0.0815vw;\n  }\n  .first-screen-home\n    .first-screen-home__media-list\n    .item\n    .item-label\n    .item-label__content-title {\n    margin-bottom: 0.7692vw;\n  }\n}\n@-webkit-keyframes showItem {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(10px);\n    transform: translateX(10px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0px);\n    transform: translateX(0px);\n  }\n}\n@keyframes showItem {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(10px);\n    transform: translateX(10px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0px);\n    transform: translateX(0px);\n  }\n}\n.first-screen {\n  padding: 0 30px;\n}\n.first-screen.white-text .first-screen__content-label,\n.first-screen.white-text .first-screen__content-title h1,\n.first-screen.white-text .first-screen__content-text {\n  color: var(--white);\n}\n.first-screen.white-text .first-screen__content-message a {\n  color: var(--white);\n}\n.first-screen.white-text .first-screen__content-message a::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n}\n.first-screen.white-text .first-screen__content-message a::after {\n  background-color: var(--white);\n}\n.first-screen.white-text .first-screen__content-message a.black-text {\n  color: var(--dark);\n}\n.first-screen.white-text .first-screen__content-message a.black-text::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23161616' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n}\n.first-screen.white-text .first-screen__content-message a.black-text::after {\n  background-color: var(--dark);\n}\n.first-screen.first-screen--type-1 .first-screen__media {\n  max-width: 500px;\n  height: 568px;\n  margin-top: -5px;\n  margin-right: 65px;\n}\n.first-screen.first-screen--type-2 .first-screen__content {\n  width: 100%;\n  max-width: 557px;\n}\n.first-screen.first-screen--type-2 .first-screen__media {\n  max-width: 604px;\n  height: 470px;\n  margin-top: 34px;\n  margin-right: 13px;\n}\n.first-screen.first-screen--type-2 .first-screen__media-dec {\n  width: 156px;\n  height: 135px;\n  right: 17px;\n  bottom: 0px;\n}\n.first-screen.first-screen--type-3 .first-screen__content {\n  max-width: 460px;\n  margin-top: 42px;\n}\n.first-screen.first-screen--type-3 .first-screen__media {\n  max-width: 500px;\n  height: 564px;\n  margin-top: -4px;\n  margin-right: 65px;\n}\n.first-screen.first-screen--type-3 .first-screen__media-dec {\n  width: 188px;\n  height: 158px;\n  right: 26px;\n  bottom: -64px;\n}\n.first-screen.first-screen--type-4 .first-screen__content {\n  max-width: 594px;\n  margin-top: 0px;\n}\n.first-screen.first-screen--type-4 .first-screen__media {\n  max-width: 500px;\n  height: 584px;\n  margin-top: -4px;\n  margin-right: 65px;\n}\n.first-screen.first-screen--type-4 .first-screen__media-dec {\n  width: 207px;\n  height: 207px;\n  left: 25px;\n  right: auto;\n  bottom: -84px;\n}\n.first-screen.first-screen--type-5 .first-screen__content {\n  max-width: 594px;\n  margin-top: 0px;\n}\n.first-screen.first-screen--type-5 .first-screen__media {\n  max-width: 500px;\n  height: 579px;\n  margin-top: -4px;\n  margin-right: 65px;\n}\n.first-screen.first-screen--type-5 .first-screen__media-dec {\n  width: 202px;\n  height: 202px;\n  left: 4px;\n  right: auto;\n  bottom: -79px;\n}\n.first-screen.first-screen--type-6 .first-screen__content {\n  max-width: 594px;\n}\n.first-screen.first-screen--type-6 .first-screen__media {\n  max-width: 632px;\n  height: 550px;\n  margin-top: 17px;\n  margin-right: 13px;\n}\n.first-screen.first-screen--type-7 .first-screen__content {\n  max-width: 594px;\n}\n.first-screen.first-screen--type-7 .first-screen__media {\n  max-width: 500px;\n  height: 590px;\n  margin-top: -4px;\n  margin-right: 66px;\n}\n.first-screen.first-screen--type-lp .first-screen__content-button .btn-border {\n  display: none;\n}\n.first-screen.first-screen--type-pos-lp.white-text\n  .first-screen__content-message\n  a {\n  color: var(--dark);\n}\n.first-screen.first-screen--type-pos-lp.white-text\n  .first-screen__content-message\n  a::after {\n  background-color: var(--dark);\n}\n.first-screen.first-screen--type-pos-lp.white-text\n  .first-screen__content-message\n  a::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23161616' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n}\n.first-screen.first-screen--type-pos-lp .first-screen__media {\n  max-width: 830px;\n  height: 583px;\n  margin-right: -96px;\n  margin-bottom: 60px;\n  margin-top: 40px;\n}\n.first-screen.first-screen--type-pos-lp .first-screen__inner {\n  padding-bottom: 30px;\n}\n.first-screen.first-screen--type-pos-lp .first-screen__content-title {\n  position: relative;\n  margin-bottom: 24px;\n}\n.first-screen.first-screen--type-pos-lp .first-screen__content-title h1 {\n  position: relative;\n  z-index: 2;\n  letter-spacing: 1px;\n}\n.first-screen.first-screen--type-pos-lp .first-screen__content-title::after {\n  content: \"\";\n  background-size: contain;\n  background-position: left center;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='345' height='23' viewBox='0 0 345 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.17602 11.0648C94.4678 9.40411 290.206 6.68253 342.824 9.08188' stroke='%23B8DFD7' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M2.1204 21.0805C93.4535 16.6156 289.357 7.8776 342.306 8.64418' stroke='%23B8DFD7' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n  position: absolute;\n  bottom: -8px;\n  width: 345px;\n  height: 23px;\n  left: 0;\n  z-index: 0;\n}\n.first-screen.first-screen--type-pos-lp .first-screen__wrapper {\n  gap: 0;\n}\n.first-screen.first-screen--dark .first-screen__inner {\n  position: relative;\n  z-index: 2;\n  background-color: #474643;\n  min-height: 750px;\n}\n@media screen and (max-width: 1920px) {\n  .first-screen.first-screen--dark .first-screen__inner {\n    min-height: 39.0625vw;\n  }\n}\n.first-screen.first-screen--dark .first-screen__inner::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1860' height='750' fill='none'%3E%3Cg filter='url(%23a)'%3E%3Cellipse cx='750.896' cy='580.836' fill='%23161616' rx='750.896' ry='580.836' transform='matrix(1 0 0 -1 124.617 1630.45)'/%3E%3C/g%3E%3Cg filter='url(%23b)'%3E%3Cellipse cx='750.896' cy='580.836' fill='%23FFD748' rx='750.896' ry='580.836' transform='matrix(1 0 0 -1 678.207 411.679)'/%3E%3C/g%3E%3Cg filter='url(%23c)'%3E%3Cellipse cx='489.715' cy='378.806' fill='%23989898' rx='489.715' ry='378.806' transform='matrix(1 0 0 -1 -358 539.046)'/%3E%3C/g%3E%3Crect width='2488' height='1912' fill='%23161616' fill-opacity='.3' rx='96' transform='matrix(1 0 0 -1 -198 1396.01)'/%3E%3Cdefs%3E%3Cfilter id='a' width='3205.15' height='2865.03' x='-727.061' y='-382.903' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_9415_4374' stdDeviation='425.839'/%3E%3C/filter%3E%3Cfilter id='b' width='3205.15' height='2865.03' x='-173.471' y='-1601.67' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_9415_4374' stdDeviation='425.839'/%3E%3C/filter%3E%3Cfilter id='c' width='2682.79' height='2460.97' x='-1209.68' y='-1070.24' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_9415_4374' stdDeviation='425.839'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.first-screen.first-screen--dark .first-screen__content-label,\n.first-screen.first-screen--dark .first-screen__content-title h1,\n.first-screen.first-screen--dark .first-screen__content-text,\n.first-screen.first-screen--dark .first-screen__content-message a {\n  color: var(--white);\n}\n.first-screen.first-screen--dark .first-screen__content-message a::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='14' fill='none'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M10.047.793 8.633 2.207 12.426 6H.34v2h12.086l-3.793 3.793 1.414 1.415L16.254 7 10.047.793Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n}\n.first-screen.first-screen--dark .first-screen__content-message a::after {\n  background-color: var(--white);\n}\n.first-screen.first-screen--dark .first-screen__media {\n  position: absolute;\n  bottom: 0;\n  right: 68px;\n  margin: 0;\n  max-width: 841px;\n  height: 650px;\n}\n@media screen and (max-width: 1920px) {\n  .first-screen.first-screen--dark .first-screen__media {\n    right: 3.5417vw;\n    max-width: 43.8021vw;\n    height: 33.8542vw;\n  }\n}\n.first-screen .first-screen__inner {\n  width: 100%;\n  max-width: 1920px;\n  margin: 0 auto;\n  background-color: var(--purple);\n  border-radius: 24px;\n  overflow: hidden;\n  padding: 105px 0 86px;\n}\n.first-screen .first-screen__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  gap: 40px;\n}\n.first-screen .first-screen__content {\n  width: 100%;\n  max-width: 630px;\n}\n.first-screen .first-screen__content-label {\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n  text-transform: uppercase;\n  font-size: 14px;\n  color: var(--dark);\n  margin-bottom: 16px;\n}\n.first-screen .first-screen__content-title {\n  margin-bottom: 17px;\n}\n.first-screen .first-screen__content-title h1 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.56px;\n  font-size: 56px;\n  color: var(--dark);\n}\n.first-screen .first-screen__content-text {\n  width: 100%;\n  max-width: 557px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  font-size: 20px;\n  color: var(--dark);\n}\n.first-screen .first-screen__content-button {\n  margin-top: 32px;\n}\n.first-screen .first-screen__content-message {\n  display: inline-block;\n  margin-top: 41px;\n}\n.first-screen .first-screen__content-message a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.first-screen .first-screen__content-message a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.first-screen .first-screen__content-message a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .first-screen .first-screen__content-message a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .first-screen .first-screen__content-message a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .first-screen .first-screen__content-message a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .first-screen .first-screen__content-message a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .first-screen .first-screen__content-message a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .first-screen .first-screen__content-message a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .first-screen .first-screen__content-message a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .first-screen .first-screen__content-message a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .first-screen .first-screen__content-message a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .first-screen .first-screen__content-message a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .first-screen .first-screen__content-message a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.first-screen .first-screen__media {\n  width: 100%;\n  max-width: 500px;\n  height: 490px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 2;\n  margin-top: -5px;\n  margin-right: 65px;\n}\n.first-screen .first-screen__media lottie-player {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.first-screen .first-screen__media-img {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.first-screen .first-screen__media-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.first-screen .first-screen__media-dec {\n  width: 124px;\n  height: 134px;\n  position: absolute;\n  z-index: 2;\n  pointer-events: none;\n  right: 53px;\n  bottom: -68px;\n}\n.first-screen .first-screen__media-dec img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .first-screen {\n    padding: 0 2.2556vw;\n  }\n  .first-screen.first-screen--type-1 .first-screen__media {\n    max-width: 37.594vw;\n    height: 42.7068vw;\n    margin-top: -0.3759vw;\n    margin-right: 4.8872vw;\n  }\n  .first-screen.first-screen--type-2 .first-screen__content {\n    width: 100%;\n    max-width: 41.8797vw;\n  }\n  .first-screen.first-screen--type-2 .first-screen__media {\n    max-width: 45.4135vw;\n    height: 35.3383vw;\n    margin-top: 2.5564vw;\n    margin-right: 0.9774vw;\n  }\n  .first-screen.first-screen--type-2 .first-screen__media-dec {\n    width: 11.7293vw;\n    height: 10.1504vw;\n    right: 1.2782vw;\n    bottom: 0px;\n  }\n  .first-screen.first-screen--type-3 .first-screen__content {\n    max-width: 34.5865vw;\n    margin-top: 3.1579vw;\n  }\n  .first-screen.first-screen--type-3 .first-screen__media {\n    max-width: 37.594vw;\n    height: 42.406vw;\n    margin-top: -0.3008vw;\n    margin-right: 4.8872vw;\n  }\n  .first-screen.first-screen--type-3 .first-screen__media-dec {\n    width: 14.1353vw;\n    height: 11.8797vw;\n    right: 1.9549vw;\n    bottom: -4.812vw;\n  }\n  .first-screen.first-screen--type-4 .first-screen__content {\n    max-width: 44.6617vw;\n    margin-top: 0px;\n  }\n  .first-screen.first-screen--type-4 .first-screen__media {\n    max-width: 37.594vw;\n    height: 43.9098vw;\n    margin-top: -0.3008vw;\n    margin-right: 4.8872vw;\n  }\n  .first-screen.first-screen--type-4 .first-screen__media-dec {\n    width: 15.5639vw;\n    height: 15.5639vw;\n    left: 1.8797vw;\n    right: auto;\n    bottom: -6.3158vw;\n  }\n  .first-screen.first-screen--type-5 .first-screen__content {\n    max-width: 44.6617vw;\n    margin-top: 0px;\n  }\n  .first-screen.first-screen--type-5 .first-screen__media {\n    max-width: 37.594vw;\n    height: 43.5338vw;\n    margin-top: -0.3008vw;\n    margin-right: 4.8872vw;\n  }\n  .first-screen.first-screen--type-5 .first-screen__media-dec {\n    width: 15.188vw;\n    height: 15.188vw;\n    left: 0.3008vw;\n    right: auto;\n    bottom: -5.9398vw;\n  }\n  .first-screen.first-screen--type-6 .first-screen__content {\n    max-width: 44.6617vw;\n  }\n  .first-screen.first-screen--type-6 .first-screen__media {\n    max-width: 47.5188vw;\n    height: 41.3534vw;\n    margin-top: 1.2782vw;\n    margin-right: 0.9774vw;\n  }\n  .first-screen.first-screen--type-7 .first-screen__content {\n    max-width: 44.6617vw;\n  }\n  .first-screen.first-screen--type-7 .first-screen__media {\n    max-width: 37.594vw;\n    height: 44.3609vw;\n    margin-top: -0.3008vw;\n    margin-right: 4.9624vw;\n  }\n  .first-screen.first-screen--dark .first-screen__inner {\n    min-height: 45.1128vw;\n    padding: 5.2632vw 0;\n  }\n  .first-screen.first-screen--dark .first-screen__media {\n    right: 1.5038vw;\n    max-width: 45.1128vw;\n    height: 34.812vw;\n  }\n  .first-screen .first-screen__inner {\n    border-radius: 1.8045vw;\n    padding: 7.8947vw 0 6.4662vw;\n  }\n  .first-screen .first-screen__wrapper {\n    gap: 2.2556vw;\n  }\n  .first-screen .first-screen__content {\n    max-width: 47.3684vw;\n  }\n  .first-screen .first-screen__content-label {\n    letter-spacing: -0.0105vw;\n    font-size: 1.0526vw;\n    margin-bottom: 1.203vw;\n  }\n  .first-screen .first-screen__content-title {\n    margin-bottom: 1.2782vw;\n  }\n  .first-screen .first-screen__content-title h1 {\n    letter-spacing: -0.0421vw;\n    font-size: 4.2105vw;\n  }\n  .first-screen .first-screen__content-text {\n    max-width: 41.8797vw;\n    letter-spacing: -0.015vw;\n    font-size: 1.5038vw;\n  }\n  .first-screen .first-screen__content-button {\n    margin-top: 2.406vw;\n  }\n  .first-screen .first-screen__content-message {\n    margin-top: 3.0827vw;\n  }\n  .first-screen .first-screen__media {\n    max-width: 37.594vw;\n    height: 36.8421vw;\n    margin-top: -0.3759vw;\n    margin-right: 4.8872vw;\n  }\n  .first-screen .first-screen__media-dec {\n    width: 9.3233vw;\n    height: 10.0752vw;\n    right: 3.985vw;\n    bottom: -5.1128vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__media {\n    max-width: 62.406vw;\n    height: 43.835vw;\n    margin-right: -7.218vw;\n    margin-bottom: 0;\n    margin-top: 3.008vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__inner {\n    padding-bottom: 2.256vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title {\n    margin-bottom: 1.805vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title h1 {\n    letter-spacing: 0.075vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title::after {\n    bottom: -0.602vw;\n    width: 25.94vw;\n    height: 1.729vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .first-screen {\n    padding: 0 2.3438vw;\n  }\n  .first-screen.first-screen--type-1 .first-screen__media {\n    max-width: 32.7344vw;\n    height: 37.1094vw;\n    margin-top: -0.3906vw;\n    margin-right: 3.6719vw;\n  }\n  .first-screen.first-screen--type-2 .first-screen__content {\n    max-width: 34.375vw;\n  }\n  .first-screen.first-screen--type-2 .first-screen__media {\n    max-width: 39.8438vw;\n    height: 31.0156vw;\n    margin-top: 2.6563vw;\n    margin-right: 1.0156vw;\n  }\n  .first-screen.first-screen--type-2 .first-screen__media-dec {\n    width: 156px;\n    height: 135px;\n    right: 17px;\n    bottom: 0px;\n  }\n  .first-screen.first-screen--type-3 .first-screen__content {\n    max-width: 35.9375vw;\n    margin-top: 3.2813vw;\n  }\n  .first-screen.first-screen--type-3 .first-screen__media {\n    max-width: 35.1563vw;\n    height: 39.6875vw;\n    margin-top: -0.3125vw;\n    margin-right: 3.125vw;\n  }\n  .first-screen.first-screen--type-3 .first-screen__media-dec {\n    width: 188px;\n    height: 158px;\n    right: 26px;\n    bottom: -64px;\n  }\n  .first-screen.first-screen--type-4 .first-screen__content {\n    max-width: 37.5vw;\n    margin-top: 0px;\n  }\n  .first-screen.first-screen--type-4 .first-screen__media {\n    max-width: 35.1563vw;\n    height: 41.0938vw;\n    margin-top: -0.3125vw;\n    margin-right: 1.5625vw;\n  }\n  .first-screen.first-screen--type-4 .first-screen__media-dec {\n    width: 207px;\n    height: 207px;\n    left: 25px;\n    right: auto;\n    bottom: -84px;\n  }\n  .first-screen.first-screen--type-5 .first-screen__content {\n    max-width: 38.2813vw;\n    margin-top: 0px;\n  }\n  .first-screen.first-screen--type-5 .first-screen__media {\n    max-width: 35.1563vw;\n    height: auto;\n    margin-top: -0.3125vw;\n    margin-right: 1.5625vw;\n  }\n  .first-screen.first-screen--type-5 .first-screen__media-dec {\n    width: 202px;\n    height: 202px;\n    left: 4px;\n    right: auto;\n    bottom: -79px;\n  }\n  .first-screen.first-screen--type-6 .first-screen__content {\n    max-width: 40.625vw;\n  }\n  .first-screen.first-screen--type-6 .first-screen__media {\n    max-width: 39.0625vw;\n    height: 33.75vw;\n    margin-top: 1.3281vw;\n    margin-right: 0px;\n  }\n  .first-screen.first-screen--type-7 .first-screen__content {\n    max-width: 38.2813vw;\n  }\n  .first-screen.first-screen--type-7 .first-screen__media {\n    max-width: 35.1563vw;\n    height: 41.4844vw;\n    margin-top: -0.3125vw;\n    margin-right: 1.5625vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__media {\n    max-width: 54.844vw;\n    height: 45.547vw;\n    margin-right: -7.5vw;\n    margin-bottom: 0;\n    margin-top: 3.125vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__inner {\n    padding-bottom: 2.344vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title {\n    margin-bottom: 1.875vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title h1 {\n    letter-spacing: 0.078vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title::after {\n    bottom: -0.625vw;\n    width: 26.953vw;\n    height: 1.797vw;\n  }\n  .first-screen.first-screen--dark .first-screen__inner {\n    min-height: 41.4063vw;\n    padding: 3.9063vw 0;\n  }\n  .first-screen.first-screen--dark .first-screen__media {\n    right: 1.5625vw;\n    max-width: 46.875vw;\n    height: 36.1719vw;\n  }\n  .first-screen .first-screen__inner {\n    border-radius: 1.875vw;\n    padding: 5vw 0 3.5938vw;\n  }\n  .first-screen .first-screen__wrapper {\n    gap: 2.3438vw;\n  }\n  .first-screen .first-screen__content {\n    max-width: 34.375vw;\n  }\n  .first-screen .first-screen__content-label {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n    margin-bottom: 1.5625vw;\n  }\n  .first-screen .first-screen__content-title {\n    margin-bottom: 1.4844vw;\n  }\n  .first-screen .first-screen__content-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0328vw;\n    font-size: 3.2813vw;\n  }\n  .first-screen .first-screen__content-text {\n    max-width: 32.9688vw;\n    letter-spacing: 0px;\n    font-size: 1.4063vw;\n  }\n  .first-screen .first-screen__content-button {\n    margin-top: 2.6563vw;\n  }\n  .first-screen .first-screen__content-message {\n    display: inline-block;\n    margin-top: 3.5156vw;\n  }\n  .first-screen .first-screen__media {\n    width: 100%;\n    max-width: 32.7344vw;\n    height: 37.1094vw;\n    margin-top: -0.3906vw;\n    margin-right: 3.6719vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .first-screen {\n    padding: 0;\n  }\n  .first-screen .container {\n    padding: 0;\n  }\n  .first-screen.first-screen--type-1 .first-screen__content,\n  .first-screen.first-screen--type-2 .first-screen__content,\n  .first-screen.first-screen--type-3 .first-screen__content,\n  .first-screen.first-screen--type-4 .first-screen__content,\n  .first-screen.first-screen--type-5 .first-screen__content,\n  .first-screen.first-screen--type-6 .first-screen__content,\n  .first-screen.first-screen--type-7 .first-screen__content {\n    max-width: 100%;\n  }\n  .first-screen.first-screen--type-1 .first-screen__media,\n  .first-screen.first-screen--type-2 .first-screen__media,\n  .first-screen.first-screen--type-3 .first-screen__media,\n  .first-screen.first-screen--type-4 .first-screen__media,\n  .first-screen.first-screen--type-5 .first-screen__media,\n  .first-screen.first-screen--type-6 .first-screen__media,\n  .first-screen.first-screen--type-7 .first-screen__media {\n    max-width: 100%;\n    height: auto;\n    margin-top: 0;\n    margin-right: 0;\n  }\n  .first-screen.first-screen--type-lp .first-screen__content-button {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 4.615vw;\n  }\n  .first-screen.first-screen--type-lp .first-screen__content-button a {\n    width: 100%;\n  }\n  .first-screen.first-screen--type-lp\n    .first-screen__content-button\n    a.btn--dark {\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n  }\n  .first-screen.first-screen--type-lp\n    .first-screen__content-button\n    .btn-border {\n    display: block;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__media {\n    max-width: 100%;\n    height: auto;\n    margin-top: 0;\n    margin-right: 0;\n    margin-bottom: 0;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__inner {\n    padding: 12.0513vw 5.1282vw 12.0513vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title {\n    margin-bottom: 6.154vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title h1 {\n    letter-spacing: -0.2vw;\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-title::after {\n    bottom: -2.051vw;\n    width: 53.846vw;\n    height: 3.59vw;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='210' height='14' viewBox='0 0 210 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.80353 7.03576C57.3203 6.02584 176.353 4.37078 208.352 5.82988' stroke='%23B8DFD7' stroke-width='1.4595' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M1.16136 13.1265C56.7032 10.4113 175.837 5.09749 208.037 5.56367' stroke='%23B8DFD7' stroke-width='1.4595' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n  }\n  .first-screen.first-screen--type-pos-lp .first-screen__content-message a {\n    text-decoration: underline;\n    width: 82%;\n    line-height: 0.7;\n  }\n  .first-screen.first-screen--type-pos-lp\n    .first-screen__content-message\n    a::after {\n    content: \"\";\n    position: relative;\n    width: 6.1538vw;\n    height: 6.1538vw;\n    display: inline-block;\n    background-color: transparent !important;\n    background-repeat: no-repeat;\n    -webkit-transform: none;\n    transform: none;\n    bottom: 0;\n    top: 1.6vw;\n    background-size: contain;\n    background-position: center;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23161616' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  }\n  .first-screen.first-screen--type-pos-lp\n    .first-screen__content-message\n    a::before {\n    display: none;\n  }\n  .first-screen.first-screen--dark .first-screen__inner {\n    min-height: 1px;\n    padding: 11.2821vw 5.1282vw 0;\n  }\n  .first-screen.first-screen--dark .first-screen__inner::before {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='390' height='858' fill='none'%3E%3Cg filter='url(%23a)'%3E%3Cellipse cx='338.156' cy='261.572' fill='%23161616' rx='338.156' ry='261.572' transform='matrix(1 0 0 -1 -260 985.143)'/%3E%3C/g%3E%3Cg filter='url(%23b)'%3E%3Cellipse cx='267' cy='261.5' fill='%23FFD748' rx='267' ry='261.5' transform='matrix(1 0 0 -1 119 303)'/%3E%3C/g%3E%3Cg filter='url(%23c)'%3E%3Cellipse cx='192.5' cy='210.5' fill='%23989898' rx='192.5' ry='210.5' transform='matrix(1 0 0 -1 -136 462)'/%3E%3C/g%3E%3Cpath fill='%23161616' fill-opacity='.3' d='M0 858h390V0H0z'/%3E%3Cdefs%3E%3Cfilter id='a' width='1443.4' height='1290.23' x='-643.542' y='78.458' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_11327_1787' stdDeviation='191.771'/%3E%3C/filter%3E%3Cfilter id='b' width='1301.08' height='1290.08' x='-264.542' y='-603.542' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_11327_1787' stdDeviation='191.771'/%3E%3C/filter%3E%3Cfilter id='c' width='1331.95' height='1367.95' x='-609.475' y='-432.475' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_11327_1787' stdDeviation='236.737'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E\");\n  }\n  .first-screen.first-screen--dark .first-screen__media {\n    position: static;\n    max-width: unset;\n    width: 102.5641vw;\n    height: 78.3846vw;\n    margin: -6.5897vw 0px 0px -0.5897vw;\n  }\n  .first-screen.first-screen--dark .first-screen__content {\n    max-width: 87.1795vw;\n  }\n  .first-screen.first-screen--dark .first-screen__content-message {\n    max-width: 64.359vw;\n  }\n  .first-screen.first-screen--dark .first-screen__content-message a {\n    text-decoration: underline;\n    text-underline-offset: 0.7692vw;\n  }\n  .first-screen.first-screen--dark .first-screen__content-message a::before {\n    display: none;\n  }\n  .first-screen.first-screen--dark .first-screen__content-message a::after {\n    content: \"\";\n    position: static;\n    display: inline-block;\n    width: 4.1026vw;\n    height: 3.5897vw;\n    background-color: transparent;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='14' fill='none'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M9.707.793 8.293 2.207 12.086 6H0v2h12.086l-3.793 3.793 1.414 1.415L15.914 7 9.707.793Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    -webkit-transform: translate(2.0513vw, 1.0256vw);\n    transform: translate(2.0513vw, 1.0256vw);\n  }\n  .first-screen .first-screen__inner {\n    border-radius: 4.1026vw;\n    padding: 12.0513vw 5.1282vw 12.0513vw;\n  }\n  .first-screen .first-screen__wrapper {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 11.2821vw;\n  }\n  .first-screen .first-screen__content {\n    max-width: 100%;\n  }\n  .first-screen .first-screen__content-label {\n    letter-spacing: -0.0359vw;\n    font-size: 3.5897vw;\n    margin-bottom: 4.1026vw;\n  }\n  .first-screen .first-screen__content-title {\n    margin-bottom: 5.641vw;\n  }\n  .first-screen .first-screen__content-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0923vw;\n    font-size: 9.2308vw;\n  }\n  .first-screen .first-screen__content-text {\n    max-width: 100%;\n    letter-spacing: -0.0769vw;\n    font-size: 4.6154vw;\n  }\n  .first-screen .first-screen__content-button {\n    margin-top: 6.1538vw;\n  }\n  .first-screen .first-screen__content-message {\n    margin-top: 6.1538vw;\n  }\n  .first-screen .first-screen__media {\n    max-width: 100%;\n    height: 89.7436vw;\n    margin-top: 0;\n    margin-right: 0;\n  }\n  .first-screen .first-screen__media-dec {\n    width: 26.6667vw;\n    height: 28.4615vw;\n    right: 4.8718vw;\n    bottom: -16.6667vw;\n  }\n}\n.single-first-screen {\n  padding: 0 30px;\n}\n.single-first-screen .single-first-screen__inner {\n  width: 100%;\n  min-height: 670px;\n  position: relative;\n  z-index: 2;\n  border-radius: 24px;\n  overflow: hidden;\n  padding: 126px;\n}\n.single-first-screen .single-first-screen__inner::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.35);\n}\n.single-first-screen .single-first-screen__bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -2;\n}\n.single-first-screen .single-first-screen__bg img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.single-first-screen .single-first-screen__content {\n  width: 100%;\n  max-width: 888px;\n  margin: 0 auto;\n}\n.single-first-screen .single-first-screen__content-logo {\n  width: 280px;\n  height: 100px;\n  margin: 0 auto 16px;\n}\n.single-first-screen .single-first-screen__content-logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.single-first-screen .single-first-screen__content-title h1 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.56px;\n  font-size: 56px;\n  color: var(--white);\n  text-align: center;\n}\n.single-first-screen .single-first-screen__info {\n  margin-top: -25px;\n  padding: 57px 20px 43px;\n  width: 100%;\n  background-color: var(--yellow);\n  border-radius: 0 0 24px 24px;\n}\n.single-first-screen .single-first-screen__info .list {\n  width: 100%;\n  max-width: 1274px;\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.single-first-screen .single-first-screen__info .item-title {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  font-size: 40px;\n  color: var(--dark);\n  margin-bottom: 8px;\n}\n.single-first-screen .single-first-screen__info .item-subtitle {\n  width: 100%;\n  max-width: 300px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--dark);\n}\n\n@media screen and (max-width: 1330px) {\n  .single-first-screen {\n    padding: 0 2.2556vw;\n  }\n  .single-first-screen .single-first-screen__inner {\n    min-height: 50.3759vw;\n    border-radius: 1.8045vw;\n    padding: 9.4737vw;\n  }\n  .single-first-screen .single-first-screen__content {\n    max-width: 66.7669vw;\n  }\n  .single-first-screen .single-first-screen__content-logo {\n    width: 21.0526vw;\n    height: 7.5188vw;\n    margin: 0 auto 1.203vw;\n  }\n  .single-first-screen .single-first-screen__content-title h1 {\n    letter-spacing: -0.0421vw;\n    font-size: 4.2105vw;\n  }\n  .single-first-screen .single-first-screen__info {\n    margin-top: -1.8797vw;\n    padding: 4.2857vw 1.5038vw 3.2331vw;\n    border-radius: 0 0 1.8045vw 1.8045vw;\n  }\n  .single-first-screen .single-first-screen__info .list {\n    max-width: 95.7895vw;\n  }\n  .single-first-screen .single-first-screen__info .item-title {\n    letter-spacing: -0.0301vw;\n    font-size: 3.0075vw;\n    margin-bottom: 0.6015vw;\n  }\n  .single-first-screen .single-first-screen__info .item-subtitle {\n    max-width: 22.5564vw;\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .single-first-screen {\n    padding: 0 2.3438vw;\n  }\n  .single-first-screen .single-first-screen__inner {\n    min-height: 38.2813vw;\n    border-radius: 1.875vw;\n    padding: 5.4688vw;\n  }\n  .single-first-screen .single-first-screen__content {\n    width: 100%;\n    max-width: 50.7813vw;\n  }\n  .single-first-screen .single-first-screen__content-logo {\n    width: 21.875vw;\n    height: 7.8125vw;\n    margin: 0 auto 1.25vw;\n  }\n  .single-first-screen .single-first-screen__content-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0281vw;\n    font-size: 2.9688vw;\n  }\n  .single-first-screen .single-first-screen__info {\n    margin-top: -1.9531vw;\n    padding: 4.4531vw 2.3438vw 2.7344vw;\n    width: 100%;\n    border-radius: 0 0 1.875vw 1.875vw;\n  }\n  .single-first-screen .single-first-screen__info .list {\n    max-width: 100%;\n  }\n  .single-first-screen .single-first-screen__info .item-title {\n    line-height: 1.1;\n    letter-spacing: -0.0172vw;\n    font-size: 2.7344vw;\n    margin-bottom: 0.3906vw;\n  }\n  .single-first-screen .single-first-screen__info .item-subtitle {\n    max-width: 19.5313vw;\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .single-first-screen {\n    padding: 0;\n  }\n  .single-first-screen .single-first-screen__inner {\n    min-height: 123.0769vw;\n    border-radius: 6.1538vw;\n    padding: 15.3846vw 5.1282vw 27.6923vw;\n  }\n  .single-first-screen .single-first-screen__content {\n    max-width: 100%;\n  }\n  .single-first-screen .single-first-screen__content-logo {\n    width: 41.5385vw;\n    height: 14.6154vw;\n    margin: 0 auto 4.1026vw;\n  }\n  .single-first-screen .single-first-screen__content-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0923vw;\n    font-size: 9.2308vw;\n  }\n  .single-first-screen .single-first-screen__info {\n    margin-top: -6.4103vw;\n    padding: 14.8718vw 5.1282vw 9.7436vw;\n    border-radius: 0 0 6.1538vw 6.1538vw;\n  }\n  .single-first-screen .single-first-screen__info .list {\n    max-width: 100%;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    text-align: center;\n  }\n  .single-first-screen .single-first-screen__info .item:not(:first-child) {\n    margin-top: 8.4615vw;\n  }\n  .single-first-screen .single-first-screen__info .item-title {\n    letter-spacing: -0.0718vw;\n    font-size: 7.1795vw;\n    margin-bottom: 1.0256vw;\n  }\n  .single-first-screen .single-first-screen__info .item-subtitle {\n    max-width: 60vw;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n}\n.first-screen-store {\n  padding: 0 30px;\n}\n.first-screen-store .first-screen-store__inner {\n  background: var(--green-2);\n  border-radius: 24px;\n  position: relative;\n  z-index: 2;\n  padding: 121px 0 152px;\n  overflow: hidden;\n}\n.first-screen-store .first-screen-store__inner::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: -223px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 1032px;\n  height: 1032px;\n  background: var(--yellow);\n  border-radius: 50%;\n}\n.first-screen-store .first-screen-store__header {\n  width: 100%;\n  max-width: 610px;\n  margin: 0 auto 96px;\n  text-align: center;\n}\n.first-screen-store .first-screen-store__header-title {\n  margin-bottom: 27px;\n  color: var(--dark);\n}\n.first-screen-store .first-screen-store__header-title h1 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: -0.62px;\n  font-size: 62px;\n}\n.first-screen-store .first-screen-store__header-text {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.26px;\n  font-size: 26px;\n}\n.first-screen-store .first-screen-store__list {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 1282px;\n  margin: 0 auto;\n}\n.first-screen-store .first-screen-store__list .list-dec-first {\n  position: absolute;\n  z-index: 3;\n  left: 208px;\n  bottom: calc(100% - 24px);\n  width: 176px;\n  height: 153px;\n}\n.first-screen-store .first-screen-store__list .list-dec-first img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.first-screen-store .first-screen-store__list .list-dec-last {\n  position: absolute;\n  z-index: 3;\n  right: 18px;\n  bottom: 100%;\n  width: 224px;\n  height: 197px;\n}\n.first-screen-store .first-screen-store__list .list-dec-last img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.first-screen-store .first-screen-store__list .list {\n  counter-reset: num;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 26px 1fr 26px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 26px;\n}\n.first-screen-store .first-screen-store__list .item {\n  position: relative;\n  z-index: 2;\n}\n.first-screen-store .first-screen-store__list .item:nth-child(1) {\n  -webkit-transform: rotate(-12deg) translate(-15px, -7px);\n  transform: rotate(-12deg) translate(-15px, -7px);\n}\n.first-screen-store .first-screen-store__list .item:nth-child(1)::before {\n  content: \"\";\n  position: absolute;\n  top: calc(100% + 56px);\n  left: calc(100% - 123px);\n  -webkit-transform: rotate(12deg);\n  transform: rotate(12deg);\n  width: 234px;\n  height: 33px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='234' height='33' fill='none'%3E%3Cpath fill='%23000' d='M1.26 2.59A1 1 0 0 1 2.306.885L1.26 2.59Zm231.06 5.682a1 1 0 0 1 .808 1.16l-1.584 8.86a1 1 0 0 1-1.969-.352l1.408-7.875-7.875-1.408a.999.999 0 1 1 .352-1.969l8.86 1.584ZM2.306.885c37.881 23.242 87.106 30.787 130.992 29.662 21.931-.563 42.495-3.29 59.594-7.285 17.124-4.002 30.687-9.258 38.68-14.826l1.143 1.641c-8.301 5.783-22.154 11.109-39.368 15.132-17.24 4.03-37.939 6.772-59.998 7.337C89.257 33.676 39.596 26.111 1.26 2.59L2.306.885Z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.first-screen-store .first-screen-store__list .item:nth-child(2) {\n  -webkit-transform: rotate(8deg) translate(0px, -5px);\n  transform: rotate(8deg) translate(0px, -5px);\n}\n.first-screen-store .first-screen-store__list .item:nth-child(2)::before {\n  content: \"\";\n  position: absolute;\n  left: calc(100% - 65px);\n  bottom: calc(100% + 37px);\n  -webkit-transform: rotate(-8deg);\n  transform: rotate(-8deg);\n  width: 230px;\n  height: 36px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='230' height='36' fill='none'%3E%3Cpath fill='%23000' d='M.955 34.1a1 1 0 1 0 1.09 1.678L.954 34.1Zm228.209-5.631a1 1 0 0 0 .641-1.261l-2.79-8.557a1 1 0 1 0-1.901.62l2.479 7.606-7.606 2.48a1 1 0 0 0 .62 1.901l8.557-2.79ZM2.044 35.778C69.231-7.838 161.443-5.626 228.401 28.409l.906-1.782C161.817-7.68 68.832-9.964.955 34.1l1.09 1.678Z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.first-screen-store .first-screen-store__list .item:nth-child(3) {\n  -webkit-transform: rotate(-12deg) translate(14px, -1px);\n  transform: rotate(-12deg) translate(14px, -1px);\n}\n.first-screen-store .first-screen-store__list .item .item-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 24px;\n  border: 2px solid var(--dark);\n  background: var(--white);\n  padding: 26px 76px 25px 29px;\n  position: relative;\n}\n.first-screen-store .first-screen-store__list .item .item-content::before {\n  counter-increment: num;\n  content: counter(num);\n  font-family: \"Circular Std\";\n  font-size: 24px;\n  font-weight: 400;\n  letter-spacing: -0.24px;\n  color: var(--white);\n  background-color: var(--green);\n  border-radius: 50%;\n  padding: 15px 21px 14px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.first-screen-store .first-screen-store__list .item .item-content::after {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  left: 0;\n  bottom: -14px;\n  width: 100%;\n  height: 53px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='410' height='120' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Crect width='410' height='120' fill='%23fff' rx='24'/%3E%3Crect width='408' height='118' x='1' y='1' fill='%23fff' stroke='%23161616' stroke-width='2' rx='23'/%3E%3Cpath stroke='%23161616' stroke-width='1.5' d='M409.75 72v73M9.25 145V72.001M19.25 145V72M394.75 72v73M34.25 145V71.999M379.75 72v73M54.25 145V72M359.75 72v73M79.25 145V72M334.75 72v73'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Crect width='410' height='120' fill='%23fff' rx='24'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: bottom;\n  background-size: cover;\n}\n.first-screen-store .first-screen-store__list .item-text {\n  font-weight: 500;\n  line-height: 1.5;\n  font-size: 17px;\n  color: var(--dark);\n  margin-left: 21px;\n}\n\n@media screen and (max-width: 1450px) {\n  .first-screen-store {\n    padding: 0 2.069vw;\n  }\n  .first-screen-store .first-screen-store__inner {\n    border-radius: 1.6552vw;\n    padding: 8.3448vw 0 10.4828vw;\n  }\n  .first-screen-store .first-screen-store__inner::before {\n    top: -15.3793vw;\n    width: 71.1724vw;\n    height: 71.1724vw;\n  }\n  .first-screen-store .first-screen-store__header {\n    max-width: 42.069vw;\n    margin: 0 auto 6.6207vw;\n  }\n  .first-screen-store .first-screen-store__header-title {\n    margin-bottom: 1.8621vw;\n  }\n  .first-screen-store .first-screen-store__header-title h1 {\n    letter-spacing: -0.0428vw;\n    font-size: 4.2759vw;\n  }\n  .first-screen-store .first-screen-store__header-text {\n    letter-spacing: -0.0179vw;\n    font-size: 1.7931vw;\n  }\n  .first-screen-store .first-screen-store__list {\n    max-width: 88.4138vw;\n  }\n  .first-screen-store .first-screen-store__list .list-dec-first {\n    left: 14.3448vw;\n    bottom: calc(100% - 1.6552vw);\n    width: 12.1379vw;\n    height: 10.5517vw;\n  }\n  .first-screen-store .first-screen-store__list .list-dec-last {\n    right: 1.2414vw;\n    width: 15.4483vw;\n    height: 13.5862vw;\n  }\n  .first-screen-store .first-screen-store__list .list {\n    grid-gap: 1.7931vw;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(1) {\n    -webkit-transform: rotate(-12deg) translate(-1.0345vw, -0.4828vw);\n    transform: rotate(-12deg) translate(-1.0345vw, -0.4828vw);\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(1)::before {\n    top: calc(100% + 3.8621vw);\n    left: calc(100% - 8.4828vw);\n    width: 16.1379vw;\n    height: 2.2759vw;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(2) {\n    -webkit-transform: rotate(8deg) translate(0px, -0.3448vw);\n    transform: rotate(8deg) translate(0px, -0.3448vw);\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(2)::before {\n    left: calc(100% - 4.4828vw);\n    bottom: calc(100% + 2.5517vw);\n    width: 15.8621vw;\n    height: 2.4828vw;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(3) {\n    -webkit-transform: rotate(-12deg) translate(0.9655vw, -1px);\n    transform: rotate(-12deg) translate(0.9655vw, -1px);\n  }\n  .first-screen-store .first-screen-store__list .item .item-content {\n    border-radius: 1.6552vw;\n    border: 0.1379vw solid var(--dark);\n    padding: 1.7931vw 5.2414vw 1.7241vw 2vw;\n  }\n  .first-screen-store .first-screen-store__list .item .item-content::before {\n    font-size: 1.6552vw;\n    letter-spacing: -0.0166vw;\n    padding: 1.0345vw 1.4483vw 0.9655vw;\n  }\n  .first-screen-store .first-screen-store__list .item .item-content::after {\n    bottom: -0.9655vw;\n    height: 3.6552vw;\n  }\n  .first-screen-store .first-screen-store__list .item-text {\n    font-size: 1.1724vw;\n    margin-left: 1.4483vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .first-screen-store {\n    padding: 0 2.3438vw;\n  }\n  .first-screen-store .first-screen-store__inner {\n    border-radius: 1.875vw;\n    padding: 6.25vw 0;\n  }\n  .first-screen-store .first-screen-store__inner::before {\n    top: -11.0156vw;\n    width: 65vw;\n    height: 65vw;\n  }\n  .first-screen-store .first-screen-store__header {\n    max-width: 33.9844vw;\n    margin: 0 auto 7.5vw;\n  }\n  .first-screen-store .first-screen-store__header-title {\n    margin-bottom: 2.1094vw;\n  }\n  .first-screen-store .first-screen-store__header-title h1 {\n    letter-spacing: normal;\n    font-size: 3.2813vw;\n  }\n  .first-screen-store .first-screen-store__header-text {\n    letter-spacing: normal;\n    font-size: 1.4063vw;\n  }\n  .first-screen-store .first-screen-store__list {\n    max-width: 82.0313vw;\n  }\n  .first-screen-store .first-screen-store__list .list-dec-first {\n    left: 13.0469vw;\n    bottom: calc(100% - 1.4063vw);\n    width: 10.625vw;\n    height: 8.9063vw;\n  }\n  .first-screen-store .first-screen-store__list .list-dec-last {\n    right: 1.4063vw;\n    width: 10.5469vw;\n    height: 10.3906vw;\n  }\n  .first-screen-store .first-screen-store__list .list {\n    grid-gap: 2.0313vw;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(1) {\n    -webkit-transform: rotate(-12deg) translate(-1.1719vw, -0.5469vw);\n    transform: rotate(-12deg) translate(-1.1719vw, -0.5469vw);\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(1)::before {\n    top: calc(100% + 3.9063vw);\n    left: calc(100% - 8.4375vw);\n    width: 15.1563vw;\n    height: 1.6406vw;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(2) {\n    -webkit-transform: rotate(8deg) translate(0px, -0.3906vw);\n    transform: rotate(8deg) translate(0px, -0.3906vw);\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(2)::before {\n    left: calc(100% - 4.6875vw);\n    bottom: calc(100% + 2.3438vw);\n    width: 13.75vw;\n    height: 1.875vw;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(3) {\n    -webkit-transform: rotate(-12deg) translate(1.0938vw, -1px);\n    transform: rotate(-12deg) translate(1.0938vw, -1px);\n  }\n  .first-screen-store .first-screen-store__list .item .item-content {\n    border-radius: 1.875vw;\n    border: 0.1563vw solid var(--dark);\n    padding: 1.5625vw;\n  }\n  .first-screen-store .first-screen-store__list .item .item-content::before {\n    font-size: 1.4063vw;\n    letter-spacing: normal;\n    padding: 1.0156vw 1.4063vw;\n  }\n  .first-screen-store .first-screen-store__list .item .item-content::after {\n    bottom: -1.0938vw;\n    height: 4.1406vw;\n  }\n  .first-screen-store .first-screen-store__list .item-text {\n    font-size: 1.25vw;\n    margin-left: 1.6406vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .first-screen-store {\n    padding: 0;\n  }\n  .first-screen-store .first-screen-store__inner {\n    border-radius: 6.1538vw;\n    padding: 24.8718vw 5.1282vw 24.8718vw;\n  }\n  .first-screen-store .first-screen-store__inner::before {\n    top: -36.1538vw;\n    width: 138.4615vw;\n    height: 138.4615vw;\n  }\n  .first-screen-store .first-screen-store__header {\n    max-width: 89.7436vw;\n    margin: 0 auto 27.6923vw;\n  }\n  .first-screen-store .first-screen-store__header-title {\n    margin-bottom: 5.641vw;\n  }\n  .first-screen-store .first-screen-store__header-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0923vw;\n    font-size: 9.2308vw;\n  }\n  .first-screen-store .first-screen-store__header-text {\n    letter-spacing: -0.0667vw;\n    font-size: 6.6667vw;\n  }\n  .first-screen-store .first-screen-store__list {\n    max-width: 80.7692vw;\n  }\n  .first-screen-store .first-screen-store__list .list-dec-first {\n    left: auto;\n    right: 2.8205vw;\n    bottom: calc(100% - 8.9744vw);\n    width: 32.8205vw;\n    height: 27.4359vw;\n    -webkit-transform: rotate(9deg);\n    transform: rotate(9deg);\n  }\n  .first-screen-store .first-screen-store__list .list-dec-last {\n    right: -2.5641vw;\n    bottom: 6.9231vw;\n    width: 37.6923vw;\n    height: 34.8718vw;\n    -webkit-transform: rotate(9deg);\n    transform: rotate(9deg);\n  }\n  .first-screen-store .first-screen-store__list .list {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 12.8205vw;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(1) {\n    -webkit-transform: rotate(-2deg) translate(0, 0);\n    transform: rotate(-2deg) translate(0, 0);\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(1)::before {\n    display: none;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(2) {\n    -webkit-transform: rotate(2deg) translate(0px, 3.3333vw);\n    transform: rotate(2deg) translate(0px, 3.3333vw);\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(2)::before {\n    display: none;\n  }\n  .first-screen-store .first-screen-store__list .item:nth-child(3) {\n    -webkit-transform: rotate(-2deg) translate(0px, 5.8974vw);\n    transform: rotate(-2deg) translate(0px, 5.8974vw);\n  }\n  .first-screen-store .first-screen-store__list .item .item-content {\n    border-radius: 4.6154vw;\n    border: 0.5128vw solid var(--dark);\n    padding: 5.641vw 5.1282vw 5.1282vw 5.3846vw;\n  }\n  .first-screen-store .first-screen-store__list .item .item-content::before {\n    font-size: 4.6154vw;\n    letter-spacing: -0.0474vw;\n    padding: 2.8205vw 4.1026vw;\n  }\n  .first-screen-store .first-screen-store__list .item .item-content::after {\n    bottom: -2.3077vw;\n    height: 13.5897vw;\n  }\n  .first-screen-store .first-screen-store__list .item-text {\n    font-size: 3.3333vw;\n    margin-left: 4.359vw;\n  }\n}\n.brands {\n  margin-bottom: 111px;\n}\n.brands.brands--slider .brands-list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  direction: rtl;\n}\n.brands.brands--slider .brands-list.start-slider .list {\n  -webkit-animation: marquee 20s infinite linear;\n  animation: marquee 20s infinite linear;\n}\n.brands.brands--slider .brands-list .list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.brands.brands--slider .brands-list .list .item {\n  padding: 0 42.5px;\n  width: 190px;\n  height: 90px;\n}\n.brands.brands--top {\n  margin-bottom: 96px;\n}\n.brands.brands--top .brands__inner {\n  padding-top: 64px;\n  padding-bottom: 49px;\n  border-bottom: 1px solid rgba(22, 22, 22, 0.15);\n}\n.brands.brands--top .brands-list .list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.brands.brands-light.brands--top .brands__inner {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n.brands.brands-light .brands__title h2 {\n  color: var(--white);\n}\n.brands .brands__title {\n  text-align: center;\n  margin-bottom: 51px;\n}\n.brands .brands__title h2 {\n  font-weight: 400;\n  line-height: 1.5;\n  font-size: 20px;\n  letter-spacing: -0.2px;\n  color: var(--dark);\n}\n.brands .brands-list .item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-items: center;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 120px;\n  height: 90px;\n}\n.brands .brands-list .item img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .brands {\n    margin-bottom: 8.3459vw;\n  }\n  .brands.brands--slider .brands-list .list .item {\n    padding: 0 3.1955vw;\n    width: 14.2857vw;\n    height: 6.7669vw;\n  }\n  .brands.brands--top {\n    margin-bottom: 7.218vw;\n  }\n  .brands.brands--top .brands__inner {\n    padding-top: 4.812vw;\n    padding-bottom: 3.6842vw;\n  }\n  .brands .brands__title {\n    margin-bottom: 3.8346vw;\n  }\n  .brands .brands__title h2 {\n    font-size: 1.5038vw;\n    letter-spacing: -0.015vw;\n  }\n  .brands .brands-list .item {\n    width: 9.0226vw;\n    height: 6.7669vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .brands {\n    margin-bottom: 6.4063vw;\n  }\n  .brands.brands--slider .brands-list .list .item {\n    padding: 0 2.6172vw;\n    width: 11.1406vw;\n    height: 5vw;\n  }\n  .brands.brands--top {\n    margin-bottom: 7.5vw;\n  }\n  .brands.brands--top .brands__inner {\n    padding-top: 5vw;\n    padding-bottom: 4.1406vw;\n    border-bottom: 1px solid rgba(22, 22, 22, 0.15);\n  }\n  .brands.brands--top .brands__title {\n    margin-bottom: 4.375vw;\n  }\n  .brands.brands--top .brands__title h2 {\n    font-size: 1.5625vw;\n    letter-spacing: -0.0156vw;\n  }\n  .brands.brands--top .brands-list .item {\n    width: 8.1406vw;\n    height: 5vw;\n  }\n  .brands .brands__title {\n    margin-bottom: 2.5vw;\n  }\n  .brands .brands__title.brands__title--big h2 {\n    font-weight: 500;\n    line-height: 1.4;\n    letter-spacing: -0.0203vw;\n    font-size: 2.0313vw;\n  }\n  .brands .brands__title h2 {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n  }\n  .brands .brands-list .item {\n    width: 11.1406vw;\n    height: 5vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .brands {\n    margin-bottom: 9.7436vw;\n  }\n  .brands.brands--slider .brands-list .list .item {\n    padding: 0 5.1282vw;\n    width: 25.2308vw;\n    height: 11.5385vw;\n  }\n  .brands.brands--top {\n    margin-bottom: 17.1795vw;\n  }\n  .brands.brands--top .container {\n    padding: 0;\n  }\n  .brands.brands--top .brands__inner {\n    padding-top: 12.5641vw;\n    padding-bottom: 9.4872vw;\n    border-bottom: none;\n    position: relative;\n    z-index: 2;\n  }\n  .brands.brands--top .brands__inner::before {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    bottom: 0;\n    width: 89.7436vw;\n    height: 1px;\n    background-color: var(--dark);\n    opacity: 0.15;\n  }\n  .brands.brands--top .brands__title {\n    width: 100%;\n    max-width: 76.9231vw;\n    margin: 0 auto 6.1538vw;\n  }\n  .brands.brands--top .brands__title h2 {\n    font-size: 4.1026vw;\n    letter-spacing: -0.041vw;\n  }\n  .brands.brands--top .brands-list .item {\n    max-width: 100%;\n    width: 25.2308vw;\n    height: 11.5385vw;\n  }\n  .brands .brands__title {\n    margin-bottom: 6.4103vw;\n  }\n  .brands .brands__title.brands__title--big h2 {\n    letter-spacing: -0.0667vw;\n    font-size: 6.6667vw;\n  }\n  .brands .brands__title h2 {\n    font-size: 4.1026vw;\n    letter-spacing: -0.041vw;\n  }\n  .brands .brands-list .item {\n    max-width: 100%;\n    width: 25.2308vw;\n    height: 11.5385vw;\n  }\n}\n@-webkit-keyframes marquee {\n  0% {\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n  100% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n  }\n}\n@keyframes marquee {\n  0% {\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n  100% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n  }\n}\n.short-about .short-about__wrapper {\n  width: 100%;\n  background-color: var(--yellow);\n  border-radius: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 38px 92px 0 114px;\n  overflow: hidden;\n}\n.short-about .short-about__media {\n  width: 408px;\n  height: 616px;\n  margin-bottom: -5px;\n}\n.short-about .short-about__media img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.short-about .short-about__content {\n  width: 100%;\n  max-width: 481px;\n  margin-bottom: 113px;\n}\n.short-about .short-about__content-title {\n  margin-bottom: 20px;\n}\n.short-about .short-about__content-title h2 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  font-size: 56px;\n  line-height: 1.2;\n  letter-spacing: -0.56px;\n  color: var(--dark);\n}\n.short-about .short-about__content-text {\n  margin-bottom: 24px;\n}\n@media screen and (max-width: 1330px) {\n  .short-about .short-about__wrapper {\n    border-radius: 1.8045vw;\n    padding: 2.8571vw 6.9173vw 0 8.5714vw;\n  }\n  .short-about .short-about__media {\n    width: 30.6767vw;\n    height: 46.3158vw;\n    margin-bottom: -0.3759vw;\n  }\n  .short-about .short-about__content {\n    max-width: 36.1654vw;\n    margin-bottom: 8.4962vw;\n  }\n  .short-about .short-about__content-title {\n    margin-bottom: 1.5038vw;\n  }\n  .short-about .short-about__content-title h2 {\n    font-size: 4.2105vw;\n    letter-spacing: -0.0421vw;\n  }\n  .short-about .short-about__content-text {\n    margin-bottom: 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .short-about .short-about__wrapper {\n    border-radius: 1.875vw;\n    padding: 4.5313vw 7.1094vw 0 7.1094vw;\n  }\n  .short-about .short-about__media {\n    width: 26.1719vw;\n    height: auto;\n    margin-bottom: -0.3906vw;\n  }\n  .short-about .short-about__content {\n    max-width: 32.8125vw;\n    margin-bottom: 7.4219vw;\n  }\n  .short-about .short-about__content-title {\n    max-width: 23.4375vw;\n    margin-bottom: 2.5vw;\n  }\n  .short-about .short-about__content-title h2 {\n    font-size: 2.9688vw;\n    letter-spacing: -0.0297vw;\n  }\n  .short-about .short-about__content-text {\n    margin-bottom: 2.5vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .short-about .short-about__wrapper {\n    border-radius: 4.1026vw;\n    padding: 8.7179vw 9.7436vw 0 8.2051vw;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n  }\n  .short-about .short-about__media {\n    width: 57.9487vw;\n    height: auto;\n    margin: 0 auto -1.2821vw;\n  }\n  .short-about .short-about__content {\n    max-width: 100%;\n    margin-bottom: 14.359vw;\n  }\n  .short-about .short-about__content-title {\n    max-width: 100%;\n    margin-bottom: 5.1282vw;\n  }\n  .short-about .short-about__content-title h2 {\n    font-size: 8.2051vw;\n    letter-spacing: -0.0821vw;\n  }\n  .short-about .short-about__content-text {\n    margin-bottom: 6.1538vw;\n  }\n}\n.offer .offer__inner {\n  padding: 107px 0 81px;\n}\n.offer .offer__header {\n  width: 100%;\n  max-width: 663px;\n  margin: 0 auto 62px;\n  text-align: center;\n}\n.offer .offer__header-title {\n  margin-bottom: 11px;\n}\n.offer .offer__list {\n  width: 100%;\n}\n.offer .offer__list .list {\n  width: 100%;\n  display: -ms-grid;\n  display: grid;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 30px;\n}\n.offer .offer__list .item {\n  width: 100%;\n  height: auto;\n  min-height: 430px;\n  border-radius: 24px;\n  background: var(--light-gray);\n  overflow: hidden;\n  padding: 30px 60px 38px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  position: relative;\n  z-index: 2;\n}\n.offer .offer__list .item:not(.hide-content):hover::before {\n  opacity: 1;\n  -webkit-transform: scale(25);\n  transform: scale(25);\n}\n.offer .offer__list .item:not(.hide-content):hover .item-link {\n  opacity: 1;\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n  pointer-events: all;\n}\n.offer .offer__list .item:not(.hide-content):hover .item-button a,\n.offer .offer__list .item:not(.hide-content):hover .item-button button {\n  color: var(--white);\n}\n.offer .offer__list .item:not(.hide-content):hover .item-button a::before,\n.offer .offer__list .item:not(.hide-content):hover .item-button button::before {\n  opacity: 1;\n}\n.offer .offer__list .item:hover .item-content__hide {\n  opacity: 1;\n  pointer-events: all;\n}\n.offer .offer__list .item::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: 20px;\n  right: 20px;\n  height: 20px;\n  width: 48px;\n  height: 48px;\n  opacity: 0;\n  border-radius: 50%;\n  background-color: var(--yellow);\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.offer .offer__list .item .item-link {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: var(--white);\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  z-index: 2;\n  opacity: 0;\n  -webkit-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.offer .offer__list .item .item-link::before {\n  content: \"\";\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cg clip-path='url(%23a)'%3E%3Cmask id='b' width='24' height='24' x='0' y='0' maskUnits='userSpaceOnUse' style='mask-type:luminance'%3E%3Cpath fill='%23fff' d='M0 24h24V0H0v24Z'/%3E%3C/mask%3E%3Cg stroke='%23161616' stroke-linecap='square' stroke-width='2' mask='url(%23b)'%3E%3Cpath d='M6 18 17.368 6.63M8.25 6H18v9.75'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h24v24H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.offer .offer__list .item .item-icon {\n  width: 185px;\n  height: 186px;\n  margin: 0 auto 16px;\n}\n.offer .offer__list .item .item-icon img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.offer .offer__list .item .item-content {\n  width: 100%;\n  max-width: 289px;\n  margin: 0 auto;\n  text-align: center;\n}\n.offer .offer__list .item .item-content__title {\n  margin-bottom: 9px;\n}\n.offer .offer__list .item .item-content__title h3 {\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.24px;\n  font-size: 24px;\n  color: var(--dark);\n}\n.offer .offer__list .item .item-content__wrapper {\n  position: relative;\n  z-index: 2;\n}\n.offer .offer__list .item .item-content__text,\n.offer .offer__list .item .item-content__text-hover {\n  font-weight: 400;\n  line-height: 1.4;\n  font-size: 18px;\n  letter-spacing: -0.18px;\n  color: var(--gray);\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.offer .offer__list .item .item-content__text-hover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n.offer .offer__list .item .item-button {\n  margin-top: 21px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.offer .offer__list .item .item-button a,\n.offer .offer__list .item .item-button button {\n  text-align: center;\n  padding: 16px;\n  font-family: \"Circular Std\";\n  font-weight: 500;\n  font-size: 13px;\n  letter-spacing: -0.13px;\n  color: var(--green);\n  position: relative;\n  z-index: 2;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.offer .offer__list .item .item-button a::before,\n.offer .offer__list .item .item-button button::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--green);\n  border-radius: 41px;\n  opacity: 0;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.offer .offer__list .item .item-content__hide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background: rgba(186, 100, 255, 0.9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  opacity: 0;\n  pointer-events: none;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.offer .offer__list .item .item-content__hide-text {\n  width: 100%;\n  max-width: 298px;\n  margin: 0 auto 28px;\n  text-align: center;\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--white);\n}\n.offer .offer__list .item .item-content__hide-button a,\n.offer .offer__list .item .item-content__hide-button button {\n  padding: 20px 24px;\n  border-radius: 12px;\n  background: var(--white);\n  font-weight: 500;\n  font-size: 17px;\n  color: var(--dark);\n}\n\n@media screen and (max-width: 1330px) {\n  .offer .offer__inner {\n    padding: 8.0451vw 0 6.0902vw;\n  }\n  .offer .offer__header {\n    max-width: 49.8496vw;\n    margin: 0 auto 4.6617vw;\n  }\n  .offer .offer__header-title {\n    margin-bottom: 0.8271vw;\n  }\n  .offer .offer__list .list {\n    grid-gap: 2.2556vw;\n  }\n  .offer .offer__list .item {\n    width: 100%;\n    min-height: 32.3308vw;\n    border-radius: 1.8045vw;\n    padding: 2.2556vw 4.5113vw 2.8571vw;\n  }\n  .offer .offer__list .item::before {\n    top: 1.5038vw;\n    right: 1.5038vw;\n    height: 1.5038vw;\n    width: 3.609vw;\n    height: 3.609vw;\n  }\n  .offer .offer__list .item .item-link {\n    width: 3.609vw;\n    height: 3.609vw;\n    top: 1.5038vw;\n    right: 1.5038vw;\n  }\n  .offer .offer__list .item .item-link::before {\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .offer .offer__list .item .item-icon {\n    width: 13.9098vw;\n    height: 13.985vw;\n    margin: 0 auto 1.203vw;\n  }\n  .offer .offer__list .item .item-content {\n    max-width: 21.7293vw;\n  }\n  .offer .offer__list .item .item-content__title {\n    margin-bottom: 0.6767vw;\n  }\n  .offer .offer__list .item .item-content__title h3 {\n    letter-spacing: -0.018vw;\n    font-size: 1.8045vw;\n  }\n  .offer .offer__list .item .item-content__text {\n    font-size: 1.3534vw;\n    letter-spacing: -0.0135vw;\n  }\n  .offer .offer__list .item .item-button {\n    margin-top: 1.5789vw;\n  }\n  .offer .offer__list .item .item-button a,\n  .offer .offer__list .item .item-button button {\n    padding: 1.203vw;\n    font-size: 0.9774vw;\n    letter-spacing: -0.0098vw;\n  }\n  .offer .offer__list .item .item-button a::before,\n  .offer .offer__list .item .item-button button::before {\n    border-radius: 3.0827vw;\n  }\n  .offer .offer__list .item .item-content__hide-text {\n    max-width: 22.406vw;\n    margin: 0 auto 2.1053vw;\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n  }\n  .offer .offer__list .item .item-content__hide-button a,\n  .offer .offer__list .item .item-content__hide-button button {\n    padding: 1.5038vw 1.8045vw;\n    border-radius: 0.9023vw;\n    font-size: 1.2782vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .offer .offer__inner {\n    padding: 6.0156vw 0 3.8281vw;\n  }\n  .offer .offer__header {\n    width: 100%;\n    max-width: 53.125vw;\n    margin: 0 auto 5.625vw;\n    text-align: center;\n  }\n  .offer .offer__header-title {\n    margin-bottom: 1.7969vw;\n  }\n  .offer .offer__list .list {\n    grid-gap: 2.3438vw;\n  }\n  .offer .offer__list .item {\n    min-height: 33.5938vw;\n    border-radius: 1.875vw;\n    padding: 3.125vw 3.125vw 2.9688vw;\n  }\n  .offer .offer__list .item::before {\n    top: 1.5625vw;\n    right: 1.5625vw;\n    height: 1.5625vw;\n    width: 3.75vw;\n    height: 3.75vw;\n  }\n  .offer .offer__list .item .item-link {\n    width: 3.75vw;\n    height: 3.75vw;\n    top: 1.5625vw;\n    right: 1.5625vw;\n  }\n  .offer .offer__list .item .item-link::before {\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n  .offer .offer__list .item .item-icon {\n    width: 12.9688vw;\n    height: 12.9688vw;\n    margin: 0 auto 2.0313vw;\n  }\n  .offer .offer__list .item .item-content {\n    width: 100%;\n    max-width: 22.5781vw;\n    margin: 0 auto;\n    text-align: center;\n  }\n  .offer .offer__list .item .item-content__title {\n    margin-bottom: 0.8594vw;\n  }\n  .offer .offer__list .item .item-content__title h3 {\n    line-height: 1.4;\n    letter-spacing: -0.0172vw;\n    font-size: 1.7188vw;\n  }\n  .offer .offer__list .item .item-content__text,\n  .offer .offer__list .item .item-content__text-hover {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n  }\n  .offer .offer__list .item .item-button {\n    margin-top: 1.6406vw;\n  }\n  .offer .offer__list .item .item-button a,\n  .offer .offer__list .item .item-button button {\n    text-align: center;\n    padding: 1.25vw;\n    font-family: \"Circular Std\";\n    font-weight: 500;\n    font-size: 1.0156vw;\n    letter-spacing: -0.0102vw;\n  }\n  .offer .offer__list .item .item-content__hide-text {\n    max-width: 19.5313vw;\n    margin: 0 auto 1.5625vw;\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n  }\n  .offer .offer__list .item .item-content__hide-button a,\n  .offer .offer__list .item .item-content__hide-button button {\n    padding: 1.1719vw 1.5625vw;\n    border-radius: 0.9375vw;\n    font-size: 1.25vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .offer .offer__inner {\n    padding: 19.2308vw 0;\n  }\n  .offer .offer__header {\n    max-width: 100%;\n    margin: 0 auto 11.0256vw;\n  }\n  .offer .offer__header-title {\n    margin-bottom: 5.3846vw;\n  }\n  .offer .offer__list .list {\n    width: calc(100% + 5.1282vw);\n    margin: 0 -2.5641vw;\n    display: block;\n  }\n  .offer .offer__list .list .slick-track {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n  }\n  .offer .offer__list .list .slick-dots {\n    position: relative;\n    bottom: 0;\n    margin-top: 6.1538vw;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n  .offer .offer__list .list .slick-dots li {\n    width: 2.0513vw;\n    height: 2.0513vw;\n    background-color: var(--dark);\n    opacity: 0.2;\n    border-radius: 50%;\n    -webkit-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n  }\n  .offer .offer__list .list .slick-dots li.slick-active {\n    width: 2.5641vw;\n    height: 2.5641vw;\n    opacity: 1;\n  }\n  .offer .offer__list .list .slick-dots li:not(:first-child) {\n    margin-left: 2.0513vw;\n  }\n  .offer .offer__list .list .slick-dots li button {\n    width: 100%;\n    height: 100%;\n    font-size: 0;\n  }\n  .offer .offer__list .item {\n    margin: 0 2.5641vw;\n    height: auto;\n    min-height: 1px;\n    border-radius: 4.1026vw;\n    padding: 7.6923vw 7.6923vw 9.7436vw;\n  }\n  .offer .offer__list .item::before {\n    display: none;\n  }\n  .offer .offer__list .item .item-link {\n    width: 12.3077vw;\n    height: 12.3077vw;\n    top: 4.1026vw;\n    right: 4.1026vw;\n    opacity: 1;\n    pointer-events: all;\n  }\n  .offer .offer__list .item .item-link::before {\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .offer .offer__list .item .item-icon {\n    width: 47.4359vw;\n    height: 47.6923vw;\n    margin: 0 auto 4.1026vw;\n  }\n  .offer .offer__list .item .item-content {\n    max-width: 74.1026vw;\n  }\n  .offer .offer__list .item .item-content__title {\n    margin-bottom: 4.1026vw;\n  }\n  .offer .offer__list .item .item-content__title h3 {\n    line-height: 1.4;\n    letter-spacing: -0.0564vw;\n    font-size: 5.641vw;\n  }\n  .offer .offer__list .item .item-content__text {\n    font-size: 4.1026vw;\n    letter-spacing: -0.041vw;\n  }\n  .offer .offer__list .item .item-button {\n    margin-top: 6.4103vw;\n    opacity: 1;\n  }\n  .offer .offer__list .item .item-button a,\n  .offer .offer__list .item .item-button button {\n    color: var(--white);\n    padding: 4.1026vw;\n    font-size: 3.3333vw;\n    letter-spacing: -0.0333vw;\n  }\n  .offer .offer__list .item .item-button a::before,\n  .offer .offer__list .item .item-button button::before {\n    border-radius: 10.5128vw;\n    opacity: 1;\n  }\n  .offer .offer__list .item .item-content__hide-text {\n    width: 100%;\n    max-width: 71.7949vw;\n    margin: 0 auto 3.8462vw;\n    letter-spacing: -0.0462vw;\n    font-size: 4.1026vw;\n  }\n  .offer .offer__list .item .item-content__hide-button a,\n  .offer .offer__list .item .item-content__hide-button button {\n    padding: 4.6154vw 5.1282vw;\n    border-radius: 2.5641vw;\n    font-size: 4.1026vw;\n  }\n}\n.preview {\n  position: relative;\n  z-index: 2;\n}\n.preview .preview__wrapper {\n  background-color: var(--purple);\n  border-radius: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 43px 80px 0;\n}\n.preview .preview__content {\n  width: 100%;\n  max-width: 571px;\n  margin-bottom: 110px;\n}\n.preview .preview__content-title {\n  margin-bottom: 20px;\n}\n.preview .preview__content-text {\n  width: 100%;\n  max-width: 460px;\n  margin-bottom: 23px;\n}\n.preview .preview__media {\n  width: 536px;\n  height: 607px;\n}\n.preview .preview__media img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .preview .preview__wrapper {\n    border-radius: 1.8045vw;\n    padding: 3.2331vw 6.015vw 0;\n  }\n  .preview .preview__content {\n    max-width: 42.9323vw;\n    margin-bottom: 8.2707vw;\n  }\n  .preview .preview__content-title {\n    margin-bottom: 1.5038vw;\n  }\n  .preview .preview__content-text {\n    max-width: 34.5865vw;\n    margin-bottom: 1.7293vw;\n  }\n  .preview .preview__media {\n    width: 40.3008vw;\n    height: auto;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .preview .preview__wrapper {\n    border-radius: 1.875vw;\n    padding: 5.8594vw 7.0313vw 0;\n  }\n  .preview .preview__content {\n    max-width: 32.8125vw;\n    margin-bottom: 6.0938vw;\n  }\n  .preview .preview__content-title {\n    margin-bottom: 2.5vw;\n  }\n  .preview .preview__content-text {\n    max-width: 32.8125vw;\n    margin-bottom: 2.5vw;\n  }\n  .preview .preview__media {\n    width: 32.7344vw;\n    height: auto;\n  }\n}\n@media screen and (max-width: 850px) {\n  .preview .preview__wrapper {\n    border-radius: 4.1026vw;\n    padding: 8.2051vw 7.9487vw 108.2051vw;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    position: relative;\n    z-index: 2;\n  }\n  .preview .preview__content {\n    max-width: 100%;\n    margin-bottom: 12.3077vw;\n  }\n  .preview .preview__content-title {\n    margin-bottom: 5.641vw;\n  }\n  .preview .preview__content-text {\n    max-width: 100%;\n    margin-bottom: 5.8974vw;\n  }\n  .preview .preview__media {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    width: 93.8462vw;\n    height: auto;\n    margin: 0 auto;\n  }\n}\n.testimonials {\n  margin-top: -98px;\n  padding: 0 30px;\n}\n.testimonials .testimonials__inner {\n  background-color: var(--beige);\n  border-radius: 24px;\n  padding: 245px 0 183px;\n}\n.testimonials .testimonials__header {\n  text-align: center;\n  margin-bottom: 76px;\n}\n.testimonials .testimonials__header-title {\n  margin-bottom: 13px;\n}\n.testimonials .testimonials__header-text {\n  width: 100%;\n  max-width: 521px;\n  margin: 0 auto;\n}\n.testimonials .testimonials__panel {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  gap: 52px;\n  margin-bottom: 36px;\n  position: relative;\n  z-index: 2;\n}\n.testimonials .testimonials__panel .swiper-pagination {\n  width: auto;\n  position: relative;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.testimonials\n  .testimonials__panel\n  .swiper-pagination\n  .swiper-pagination-bullet {\n  position: relative;\n  z-index: 2;\n  width: auto;\n  height: auto;\n  background-color: transparent;\n  border-radius: 0;\n  font-weight: 500;\n  line-height: 1.5;\n  font-size: 24px;\n  letter-spacing: -0.24px;\n  color: rgba(22, 22, 22, 0.3);\n  opacity: 1;\n  margin: 0;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.testimonials\n  .testimonials__panel\n  .swiper-pagination\n  .swiper-pagination-bullet:not(:first-child) {\n  margin-left: 48px;\n}\n.testimonials\n  .testimonials__panel\n  .swiper-pagination\n  .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  color: var(--dark);\n}\n.testimonials .testimonials__panel .swiper-pagination .pagination-line {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 2px;\n  background-color: var(--dark);\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.testimonials\n  .testimonials__panel\n  .swiper-pagination\n  .pagination-line\n  .move-line {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  width: 0%;\n  height: 100%;\n  background: var(--gray-4);\n}\n.testimonials .testimonials__panel-nav {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n.testimonials .testimonials__list .item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.testimonials .testimonials__list .item .item-content {\n  width: 100%;\n  background-color: var(--white);\n  border-radius: 24px;\n  padding: 36px 76px 35px 40px;\n}\n.testimonials .testimonials__list .item .item-content__logo {\n  width: 177px;\n  height: 60px;\n  margin-bottom: 24px;\n}\n.testimonials .testimonials__list .item .item-content__logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.testimonials .testimonials__list .item .item-content__text {\n  font-weight: 400;\n  line-height: 1.4;\n  font-size: 28px;\n  letter-spacing: -0.28px;\n  color: var(--dark);\n  margin-bottom: 20px;\n}\n.testimonials .testimonials__list .item .item-content__info {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.25;\n  color: var(--black);\n  margin-bottom: 35px;\n}\n.testimonials .testimonials__list .item .item-content__button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.testimonials .testimonials__list .item .item-content__button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.testimonials .testimonials__list .item .item-content__button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.testimonials .testimonials__list .item .item-content__button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .testimonials\n    .testimonials__list\n    .item\n    .item-content__button\n    a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .testimonials .testimonials__list .item .item-content__button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .testimonials .testimonials__list .item .item-content__button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .testimonials .testimonials__list .item .item-content__button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .testimonials .testimonials__list .item .item-content__button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .testimonials\n    .testimonials__list\n    .item\n    .item-content__button\n    a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .testimonials .testimonials__list .item .item-content__button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .testimonials .testimonials__list .item .item-content__button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .testimonials .testimonials__list .item .item-content__button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .testimonials .testimonials__list .item .item-content__button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .testimonials .testimonials__list .item .item-content__button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.testimonials .testimonials__list .item .item-img {\n  width: 100%;\n  max-width: 520px;\n  height: auto;\n  min-height: 482px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  border-radius: 24px;\n  overflow: hidden;\n}\n.testimonials .testimonials__list .item .item-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media screen and (max-width: 1330px) {\n  .testimonials {\n    margin-top: -7.3684vw;\n    padding: 0 2.2556vw;\n  }\n  .testimonials .testimonials__inner {\n    border-radius: 1.8045vw;\n    padding: 18.4211vw 0 13.7594vw;\n  }\n  .testimonials .testimonials__header {\n    margin-bottom: 5.7143vw;\n  }\n  .testimonials .testimonials__header-title {\n    margin-bottom: 0.9774vw;\n  }\n  .testimonials .testimonials__header-text {\n    max-width: 39.1729vw;\n  }\n  .testimonials .testimonials__panel {\n    gap: 3.9098vw;\n    margin-bottom: 2.7068vw;\n  }\n  .testimonials\n    .testimonials__panel\n    .swiper-pagination\n    .swiper-pagination-bullet {\n    font-size: 1.8045vw;\n    letter-spacing: -0.018vw;\n  }\n  .testimonials\n    .testimonials__panel\n    .swiper-pagination\n    .swiper-pagination-bullet:not(:first-child) {\n    margin-left: 3.609vw;\n  }\n  .testimonials .testimonials__panel .swiper-pagination .pagination-line {\n    height: 0.1504vw;\n  }\n  .testimonials .testimonials__list .item .item-content {\n    border-radius: 1.8045vw;\n    padding: 2.7068vw 5.7143vw 2.6316vw 3.0075vw;\n  }\n  .testimonials .testimonials__list .item .item-content__logo {\n    width: 13.3083vw;\n    height: 4.5113vw;\n    margin-bottom: 1.8045vw;\n  }\n  .testimonials .testimonials__list .item .item-content__text {\n    font-size: 2.1053vw;\n    letter-spacing: -0.0211vw;\n    margin-bottom: 1.5038vw;\n  }\n  .testimonials .testimonials__list .item .item-content__info {\n    font-size: 1.203vw;\n    margin-bottom: 2.6316vw;\n  }\n  .testimonials .testimonials__list .item .item-img {\n    max-width: 39.0977vw;\n    min-height: 36.2406vw;\n    border-radius: 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .testimonials {\n    margin-top: -6.4844vw;\n    padding: 0 2.3438vw;\n  }\n  .testimonials .testimonials__inner {\n    border-radius: 1.875vw;\n    padding: 15.4688vw 0 6.6406vw;\n  }\n  .testimonials .testimonials__header {\n    margin-bottom: 5.3125vw;\n  }\n  .testimonials .testimonials__header-title {\n    margin-bottom: 1.5625vw;\n  }\n  .testimonials .testimonials__header-text {\n    max-width: 40.7031vw;\n  }\n  .testimonials .testimonials__panel {\n    gap: 4.0625vw;\n    margin-bottom: 2.0313vw;\n  }\n  .testimonials\n    .testimonials__panel\n    .swiper-pagination\n    .swiper-pagination-bullet {\n    font-size: 1.5625vw;\n    letter-spacing: -0.0188vw;\n  }\n  .testimonials\n    .testimonials__panel\n    .swiper-pagination\n    .swiper-pagination-bullet:not(:first-child) {\n    margin-left: 5.3906vw;\n  }\n  .testimonials .testimonials__panel .swiper-pagination .pagination-line {\n    bottom: -0.3906vw;\n    height: 0.1563vw;\n  }\n  .testimonials .testimonials__list .item .item-content {\n    border-radius: 1.875vw;\n    padding: 2.8125vw 3.8281vw 3.75vw 3.125vw;\n  }\n  .testimonials .testimonials__list .item .item-content__logo {\n    width: 8.9063vw;\n    height: 3.125vw;\n    margin-bottom: 1.875vw;\n  }\n  .testimonials .testimonials__list .item .item-content__text {\n    font-size: 1.5625vw;\n    letter-spacing: -0.0156vw;\n    margin-bottom: 1.25vw;\n  }\n  .testimonials .testimonials__list .item .item-content__info {\n    font-size: 1.25vw;\n    margin-bottom: 1.9531vw;\n  }\n  .testimonials .testimonials__list .item .item-img {\n    max-width: 32.9688vw;\n    min-height: 30.4688vw;\n    border-radius: 1.5625vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .testimonials {\n    margin-top: -33.3333vw;\n    padding: 0;\n  }\n  .testimonials .testimonials__inner {\n    border-radius: 4.1026vw 4.1026vw 0 0;\n    padding: 56.4103vw 0 17.1795vw;\n  }\n  .testimonials .testimonials__header {\n    margin-bottom: 7.6923vw;\n  }\n  .testimonials .testimonials__header-title {\n    margin-bottom: 5.3846vw;\n  }\n  .testimonials .testimonials__header-text {\n    max-width: 75.641vw;\n    margin: 0 auto 8.2051vw;\n  }\n  .testimonials .testimonials__panel {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    gap: 13.3333vw;\n    margin-bottom: 9.2308vw;\n    position: relative;\n    z-index: 2;\n  }\n  .testimonials .testimonials__panel .swiper-pagination {\n    width: auto;\n    position: relative;\n    z-index: 2;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n  }\n  .testimonials\n    .testimonials__panel\n    .swiper-pagination\n    .swiper-pagination-bullet {\n    position: relative;\n    z-index: 2;\n    width: auto;\n    height: auto;\n    background-color: transparent;\n    border-radius: 0;\n    font-weight: 500;\n    line-height: 1.5;\n    font-size: 6.1538vw;\n    letter-spacing: -0.0615vw;\n    color: rgba(22, 22, 22, 0.3);\n    opacity: 1;\n    margin: 0;\n    -webkit-transition: all 0.4s linear;\n    transition: all 0.4s linear;\n  }\n  .testimonials\n    .testimonials__panel\n    .swiper-pagination\n    .swiper-pagination-bullet:not(:first-child) {\n    margin-left: 12.3077vw;\n  }\n  .testimonials\n    .testimonials__panel\n    .swiper-pagination\n    .swiper-pagination-bullet.swiper-pagination-bullet-active {\n    color: var(--dark);\n  }\n  .testimonials .testimonials__panel .swiper-pagination .pagination-line {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 0.5128vw;\n    background-color: var(--dark);\n    -webkit-transition: all 0.4s linear;\n    transition: all 0.4s linear;\n  }\n  .testimonials .testimonials__panel-nav {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    pointer-events: none;\n  }\n  .testimonials .testimonials__list .swiper-pagination {\n    margin-top: 4.8718vw;\n    position: relative;\n    z-index: 2;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n  .testimonials\n    .testimonials__list\n    .swiper-pagination\n    .swiper-pagination-bullet {\n    width: 2.0513vw;\n    height: 2.0513vw;\n    background-color: var(--dark);\n    opacity: 0.2;\n    border-radius: 50%;\n    -webkit-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n    margin: 0;\n    padding: 0;\n  }\n  .testimonials\n    .testimonials__list\n    .swiper-pagination\n    .swiper-pagination-bullet:not(:first-child) {\n    margin-left: 2.0513vw;\n  }\n  .testimonials\n    .testimonials__list\n    .swiper-pagination\n    .swiper-pagination-bullet.swiper-pagination-bullet-active {\n    width: 2.5641vw;\n    height: 2.5641vw;\n    opacity: 1;\n  }\n  .testimonials .testimonials__list .item {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n  }\n  .testimonials .testimonials__list .item .item-content {\n    width: auto;\n    border-radius: 4.1026vw;\n    padding: 8.2051vw;\n  }\n  .testimonials .testimonials__list .item .item-content__logo {\n    width: 29.4872vw;\n    height: 9.7436vw;\n    margin-bottom: 4.6154vw;\n  }\n  .testimonials .testimonials__list .item .item-content__text {\n    font-size: 5.1282vw;\n    letter-spacing: -0.0513vw;\n    margin-bottom: 4.6154vw;\n  }\n  .testimonials .testimonials__list .item .item-content__info {\n    font-size: 3.5897vw;\n    margin-bottom: 8.9744vw;\n  }\n  .testimonials .testimonials__list .item .item-img {\n    max-width: 100%;\n    height: 76.9231vw;\n    border-radius: 4.1026vw;\n  }\n}\n@-webkit-keyframes line {\n  0% {\n    width: 0%;\n  }\n  100% {\n    width: 100%;\n  }\n}\n@keyframes line {\n  0% {\n    width: 0%;\n  }\n  100% {\n    width: 100%;\n  }\n}\n.check {\n  position: relative;\n  padding: 0 30px;\n}\n.check .check__inner {\n  background-color: var(--dark);\n  border-radius: 24px;\n  padding: 181px 0 146px;\n}\n.check .check__title {\n  text-align: center;\n  margin-bottom: 120px;\n}\n.check .check__title .title {\n  color: var(--white);\n}\n.check .check__list {\n  width: 100%;\n}\n.check .check__list .list {\n  width: 100%;\n  display: -ms-grid;\n  display: grid;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -ms-grid-columns: 1fr 109px 1fr 109px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 121px 109px;\n}\n.check .check__list .item {\n  width: 100%;\n  height: auto;\n}\n.check .check__list .item .item-icon {\n  width: 50px;\n  height: 50px;\n  margin-bottom: 38px;\n}\n.check .check__list .item .item-icon img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.check .check__list .item .item-content__title {\n  margin-bottom: 17px;\n}\n.check .check__list .item .item-content__title h3 {\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.24px;\n  font-size: 24px;\n  color: var(--white);\n}\n.check .check__list .item .item-content__text {\n  font-weight: 400;\n  line-height: 1.3;\n  letter-spacing: -0.198px;\n  font-size: 18px;\n  color: var(--white-2);\n}\n.check .check__button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-top: 101px;\n}\n.check .check__button .btn:hover {\n  background-color: var(--gray-4);\n  color: var(--dark);\n}\n\n@media screen and (max-width: 1330px) {\n  .check {\n    padding: 0 2.2556vw;\n  }\n  .check .check__inner {\n    border-radius: 1.8045vw;\n    padding: 13.609vw 0 10.9774vw;\n  }\n  .check .check__title {\n    margin-bottom: 9.0226vw;\n  }\n  .check .check__list .list {\n    grid-gap: 9.0977vw 8.1955vw;\n  }\n  .check .check__list .item .item-icon {\n    width: 3.7594vw;\n    height: 3.7594vw;\n    margin-bottom: 2.8571vw;\n  }\n  .check .check__list .item .item-content__title {\n    margin-bottom: 1.2782vw;\n  }\n  .check .check__list .item .item-content__title h3 {\n    letter-spacing: -0.018vw;\n    font-size: 1.8045vw;\n  }\n  .check .check__list .item .item-content__text {\n    letter-spacing: -0.0149vw;\n    font-size: 1.3534vw;\n  }\n  .check .check__button {\n    margin-top: 7.594vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .check {\n    padding: 0 2.3438vw;\n  }\n  .check .check__inner {\n    border-radius: 1.875vw;\n    padding: 6.7188vw 0 8.5156vw;\n  }\n  .check .check__title {\n    margin-bottom: 8.5156vw;\n  }\n  .check .check__list .list {\n    grid-gap: 8.9063vw 2.5781vw;\n  }\n  .check .check__list .item .item-icon {\n    width: 3.75vw;\n    height: 3.75vw;\n    margin-bottom: 2.2656vw;\n  }\n  .check .check__list .item .item-content__title {\n    margin-bottom: 1.4844vw;\n  }\n  .check .check__list .item .item-content__title h3 {\n    line-height: 1.4;\n    letter-spacing: -0.0172vw;\n    font-size: 1.7188vw;\n  }\n  .check .check__list .item .item-content__text {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .check .check__button {\n    margin-top: 7.8906vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .check {\n    padding: 0;\n  }\n  .check .check__inner {\n    border-radius: 4.1026vw;\n    padding: 15.3846vw 0 21.2821vw;\n  }\n  .check .check__title {\n    margin-bottom: 14.8718vw;\n  }\n  .check .check__list .list {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 12.5641vw;\n  }\n  .check .check__list .item .item-icon {\n    width: 20.2564vw;\n    height: 14.8718vw;\n    margin-bottom: 5.8974vw;\n  }\n  .check .check__list .item .item-content {\n    padding-left: 2.5641vw;\n  }\n  .check .check__list .item .item-content__title {\n    margin-bottom: 4.1026vw;\n  }\n  .check .check__list .item .item-content__title h3 {\n    line-height: 1.4;\n    letter-spacing: -0.0564vw;\n    font-size: 5.641vw;\n  }\n  .check .check__list .item .item-content__text {\n    line-height: 1.5;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .check .check__button {\n    margin-top: 17.6923vw;\n  }\n}\n.words .words__inner {\n  padding-top: 395px;\n  position: relative;\n  z-index: 2;\n  overflow: hidden;\n  min-height: 1034px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: end;\n}\n.words .words__coin {\n  position: absolute;\n  z-index: 2;\n  top: 395px;\n  top: -20px;\n  left: calc(50% - 252px);\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 48px;\n  height: 46px;\n}\n.words .words__coin img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.words .words__image {\n  position: absolute;\n  z-index: 3;\n  bottom: 0;\n  left: calc(50% + 64px);\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 912px;\n  height: 994px;\n  margin: 0 auto;\n}\n.words .words__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.words .words__wrapper {\n  margin-bottom: 293px;\n}\n.words .words__lines {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.words .words__lines:not(:first-child) {\n  margin-top: 55px;\n}\n.words .words__lines:first-child .words__line {\n  -webkit-animation: marquee-reverse 30s infinite linear;\n  animation: marquee-reverse 30s infinite linear;\n}\n.words .words__lines:last-child {\n  direction: rtl;\n}\n.words .words__lines:last-child .words__line {\n  -webkit-animation: marquee 30s infinite linear;\n  animation: marquee 30s infinite linear;\n}\n.words .words__line {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  text-align: center;\n  white-space: nowrap;\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.1;\n  font-size: 110px;\n  letter-spacing: -3.3px;\n  color: var(--dark);\n  pointer-events: none;\n}\n\n@media screen and (max-width: 1330px) {\n  .words .words__inner {\n    padding-top: 225px;\n    min-height: 664px;\n  }\n  .words .words__coin {\n    top: -11px;\n    left: calc(50% - 199px);\n    width: 31px;\n    height: 29px;\n  }\n  .words .words__image {\n    left: calc(50% + 2px);\n    width: 584px;\n    height: 636px;\n  }\n  .words .words__wrapper {\n    margin-bottom: 188px;\n  }\n  .words .words__lines:not(:first-child) {\n    margin-top: 34px;\n  }\n  .words .words__line {\n    font-size: 70px;\n    letter-spacing: -2.115px;\n  }\n}\n@media screen and (max-width: 850px) {\n  .words .words__inner {\n    padding-top: 129px;\n    min-height: 400px;\n  }\n  .words .words__coin {\n    position: absolute;\n    z-index: 3;\n    top: 58px;\n    left: calc(50% - 98px);\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    width: 15px;\n    height: 15px;\n  }\n  .words .words__image {\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    width: 296px;\n    height: auto;\n  }\n  .words .words__wrapper {\n    -webkit-transform: translateY(-200px);\n    transform: translateY(-200px);\n    margin-bottom: 0;\n  }\n  .words .words__lines:not(:first-child) {\n    margin-top: 21px;\n  }\n  .words .words__line {\n    font-size: 42px;\n    letter-spacing: -1.2px;\n  }\n}\n@keyframes marquee {\n  0% {\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n  100% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n  }\n}\n@-webkit-keyframes marquee-reverse {\n  0% {\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n  100% {\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n  }\n}\n@keyframes marquee-reverse {\n  0% {\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n  100% {\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n  }\n}\n.numbers {\n  background-color: var(--yellow);\n}\n.numbers .numbers__inner {\n  padding: 141px 0 171px;\n}\n.numbers .numbers__header {\n  text-align: center;\n  margin-bottom: 46px;\n}\n.numbers .numbers__header-icon {\n  width: 232px;\n  height: 189px;\n  margin: 0 auto 74px;\n}\n.numbers .numbers__header-icon img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.numbers .numbers__header-title {\n  margin-bottom: 10px;\n}\n.numbers .numbers__header-title h2 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.72px;\n  font-size: 72px;\n  color: var(--dark);\n  text-align: center;\n}\n.numbers .numbers__header-text {\n  width: 100%;\n  max-width: 521px;\n  margin: 0 auto;\n}\n.numbers .numbers__list {\n  width: 100%;\n  max-width: 1216px;\n  margin: 0 auto;\n}\n.numbers .numbers__list .list {\n  width: 100%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 32px 1fr 32px 1fr 32px 1fr;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 32px;\n}\n.numbers .numbers__list .item .item-top {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.numbers .numbers__list .item .item-top__number,\n.numbers .numbers__list .item .item-top__symbol {\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: -1.76px;\n  font-size: 80px;\n  color: var(--dark);\n  text-align: center !important;\n}\n.numbers .numbers__list .item .item-top__symbol {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.numbers .numbers__list .item .item-title {\n  text-align: center;\n}\n.numbers .numbers__list .item .item-title h3 {\n  font-weight: 400;\n  line-height: 1.4;\n  font-size: 18px;\n  letter-spacing: -0.18px;\n  color: var(--gray-2);\n  text-align: center;\n}\n.numbers .numbers__buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 76px;\n}\n@media screen and (max-width: 1330px) {\n  .numbers .numbers__inner {\n    padding: 10.6015vw 0 12.8571vw;\n  }\n  .numbers .numbers__header {\n    margin-bottom: 3.4586vw;\n  }\n  .numbers .numbers__header-icon {\n    width: 17.4436vw;\n    height: 14.2105vw;\n    margin: 0 auto 5.5639vw;\n  }\n  .numbers .numbers__header-title {\n    margin-bottom: 0.7519vw;\n  }\n  .numbers .numbers__header-title h2 {\n    letter-spacing: -0.0541vw;\n    font-size: 5.4135vw;\n  }\n  .numbers .numbers__header-text {\n    max-width: 39.1729vw;\n  }\n  .numbers .numbers__list {\n    max-width: 91.4286vw;\n  }\n  .numbers .numbers__list .list {\n    grid-gap: 2.406vw;\n  }\n  .numbers .numbers__list .item .item-top__number,\n  .numbers .numbers__list .item .item-top__symbol {\n    letter-spacing: -0.1323vw;\n    font-size: 6.015vw;\n  }\n  .numbers .numbers__list .item .item-title h3 {\n    font-size: 1.3534vw;\n    letter-spacing: -0.0135vw;\n  }\n  .numbers .numbers__buttons {\n    gap: 1.203vw;\n    margin-top: 5.7143vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .numbers .numbers__inner {\n    padding: 8.8281vw 0 10.8594vw;\n  }\n  .numbers .numbers__header {\n    margin-bottom: 3.75vw;\n  }\n  .numbers .numbers__header-icon {\n    width: 14.7656vw;\n    height: 12.1094vw;\n    margin: 0 auto 5.0781vw;\n  }\n  .numbers .numbers__header-title {\n    margin-bottom: 1.875vw;\n  }\n  .numbers .numbers__header-title h2 {\n    letter-spacing: -0.0297vw;\n    font-size: 2.9688vw;\n  }\n  .numbers .numbers__header-text {\n    max-width: 40.7031vw;\n  }\n  .numbers .numbers__list {\n    max-width: 82.0313vw;\n  }\n  .numbers .numbers__list .list {\n    grid-gap: 2.3438vw;\n  }\n  .numbers .numbers__list .item .item-top__number,\n  .numbers .numbers__list .item .item-top__symbol {\n    letter-spacing: -0.1031vw;\n    font-size: 4.6875vw;\n  }\n  .numbers .numbers__list .item .item-title h3 {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n  }\n  .numbers .numbers__buttons {\n    gap: 1.25vw;\n    margin-top: 5.3906vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .numbers .numbers__inner {\n    padding: 24.8718vw 0 21.5385vw;\n  }\n  .numbers .numbers__header {\n    margin-bottom: 8.2051vw;\n  }\n  .numbers .numbers__header-icon {\n    width: 32.5641vw;\n    height: 26.6667vw;\n    margin: 0 auto 8.4615vw;\n  }\n  .numbers .numbers__header-title {\n    width: 100%;\n    max-width: 74.359vw;\n    margin: 0 auto 4.6154vw;\n  }\n  .numbers .numbers__header-title h2 {\n    letter-spacing: -0.0821vw;\n    font-size: 8.2051vw;\n  }\n  .numbers .numbers__header-text {\n    max-width: 100%;\n  }\n  .numbers .numbers__list {\n    max-width: 100%;\n  }\n  .numbers .numbers__list .list {\n    -ms-grid-columns: 1fr 6.1538vw 1fr;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 8.2051vw 6.1538vw;\n  }\n  .numbers .numbers__list .item .item-top__number,\n  .numbers .numbers__list .item .item-top__symbol {\n    letter-spacing: -0.2256vw;\n    font-size: 10.2564vw;\n  }\n  .numbers .numbers__list .item .item-title h3 {\n    line-height: 1.5;\n    font-size: 4.1026vw;\n    letter-spacing: -0.041vw;\n  }\n  .numbers .numbers__buttons {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 4.1026vw;\n    margin-top: 8.2051vw;\n  }\n}\n.about-cards.about-cards-light .about-cards__title .title,\n.about-cards.about-cards-light .about-cards__list .item .item-content__title h3,\n.about-cards.about-cards-light .about-cards__list .item .item-content__text {\n  color: var(--white);\n}\n.about-cards .about-cards__inner {\n  padding-bottom: 96px;\n}\n.about-cards .about-cards__title {\n  width: 100%;\n  max-width: 983px;\n  margin: 0 auto 76px;\n  text-align: center;\n}\n.about-cards .about-cards__list {\n  width: 100%;\n}\n.about-cards .about-cards__list .list {\n  width: 100%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 31px 1fr 31px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 31px;\n}\n.about-cards .about-cards__list .item .item-icon {\n  width: 58px;\n  height: 58px;\n  margin-bottom: 24px;\n}\n.about-cards .about-cards__list .item .item-icon img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.about-cards .about-cards__list .item .item-content__title {\n  margin-bottom: 19px;\n}\n.about-cards .about-cards__list .item .item-content__title h3 {\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: -0.24px;\n  font-size: 24px;\n  color: var(--dark);\n}\n.about-cards .about-cards__list .item .item-content__text {\n  width: 100%;\n  max-width: 375px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.3px;\n  font-size: 18px;\n  color: var(--gray);\n}\n.about-cards.about-cards--big .about-cards__list {\n  padding: 0 45px 0 55px;\n}\n.about-cards.about-cards--big .about-cards__list .list {\n  -ms-grid-columns: 1fr 114px 1fr;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 80px 114px;\n}\n.about-cards.about-cards--big .about-cards__list .item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 16px;\n}\n.about-cards.about-cards--big .about-cards__list .item .item-content__title {\n  margin-bottom: 32px;\n}\n.about-cards.about-cards--big .about-cards__list .item .item-content__title h3 {\n  font-family: \"Cambon\";\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 48px;\n  letter-spacing: -0.01em;\n}\n.about-cards.about-cards--big .about-cards__list .item .item-icon {\n  width: 58px;\n  height: 58px;\n  margin-bottom: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.about-cards .about-cards__numbers {\n  width: 100%;\n  margin-top: 82px;\n  padding-top: 62px;\n  border-top: 1px solid rgba(22, 22, 22, 0.15);\n  position: relative;\n  z-index: 2;\n}\n.about-cards .about-cards__numbers .about-cards__numbers-title {\n  position: absolute;\n  top: 16px;\n  left: 0;\n  color: var(--dark);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n.about-cards .about-cards__numbers .list {\n  width: 100%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 30px;\n}\n.about-cards .about-cards__numbers .item {\n  width: 100%;\n}\n.about-cards .about-cards__numbers .item .item-top {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.about-cards .about-cards__numbers .item .item-top__symbol,\n.about-cards .about-cards__numbers .item .item-top__number {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  font-size: 40px;\n  color: var(--dark);\n}\n.about-cards .about-cards__numbers .item .item-title h3 {\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--dark);\n}\n\n.page-template-lp .about-cards .about-cards__list .list {\n  grid-gap: 88px;\n}\n\n@media screen and (max-width: 1330px) {\n  .about-cards .about-cards__inner {\n    padding-bottom: 7.218vw;\n  }\n  .about-cards .about-cards__title {\n    max-width: 73.9098vw;\n    margin: 0 auto 5.7143vw;\n  }\n  .about-cards .about-cards__list .list {\n    grid-gap: 2.3308vw;\n  }\n  .about-cards .about-cards__list .item .item-icon {\n    width: 4.3609vw;\n    height: 4.3609vw;\n    margin-bottom: 1.8045vw;\n  }\n  .about-cards .about-cards__list .item .item-content__title {\n    margin-bottom: 1.4286vw;\n  }\n  .about-cards .about-cards__list .item .item-content__title h3 {\n    letter-spacing: -0.018vw;\n    font-size: 1.8045vw;\n  }\n  .about-cards .about-cards__list .item .item-content__text {\n    max-width: 28.1955vw;\n    letter-spacing: -0.0226vw;\n    font-size: 1.3534vw;\n  }\n  .about-cards .about-cards__numbers {\n    margin-top: 6.1654vw;\n    padding-top: 4.6617vw;\n  }\n  .about-cards .about-cards__numbers .about-cards__numbers-title {\n    top: 1.203vw;\n    font-size: 1.0526vw;\n  }\n  .about-cards .about-cards__numbers .list {\n    grid-gap: 2.2556vw;\n  }\n  .about-cards .about-cards__numbers .item .item-top {\n    margin-bottom: 0.4511vw;\n  }\n  .about-cards .about-cards__numbers .item .item-top__symbol,\n  .about-cards .about-cards__numbers .item .item-top__number {\n    letter-spacing: -0.0301vw;\n    font-size: 3.0075vw;\n  }\n  .about-cards .about-cards__numbers .item .item-title h3 {\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n  }\n  .about-cards.about-cards--big .about-cards__list {\n    padding: 0 3.383vw 0 4.135vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .list {\n    gap: 6.015vw 8.571vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .item {\n    gap: 1.203vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .item .item-content__title {\n    margin-bottom: 2.406vw;\n  }\n  .about-cards.about-cards--big\n    .about-cards__list\n    .item\n    .item-content__title\n    h3 {\n    font-size: 3.008vw;\n    line-height: 3.609vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .item .item-icon {\n    width: 4.361vw;\n    height: 4.361vw;\n  }\n  .page-template-lp .about-cards .about-cards__list .list {\n    grid-gap: 6.617vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .about-cards .about-cards__inner {\n    padding-bottom: 7.0313vw;\n  }\n  .about-cards .about-cards__title {\n    max-width: 39.8438vw;\n    margin: 0 auto 4.1406vw;\n  }\n  .about-cards .about-cards__list .list {\n    grid-gap: 2.3438vw;\n  }\n  .about-cards .about-cards__list .item .item-icon {\n    width: 4.5313vw;\n    height: 4.5313vw;\n    margin-bottom: 1.9531vw;\n  }\n  .about-cards .about-cards__list .item .item-content__title {\n    margin-bottom: 0.7031vw;\n  }\n  .about-cards .about-cards__list .item .item-content__title h3 {\n    letter-spacing: -0.0172vw;\n    font-size: 1.7188vw;\n  }\n  .about-cards .about-cards__list .item .item-content__text {\n    max-width: 25.7031vw;\n    line-height: 1.4;\n    letter-spacing: 0px;\n    font-size: 1.25vw;\n  }\n  .about-cards .about-cards__numbers {\n    margin-top: 7.4219vw;\n    padding-top: 5.1563vw;\n  }\n  .about-cards .about-cards__numbers .about-cards__numbers-title {\n    top: 0.7031vw;\n    font-size: 1.0938vw;\n  }\n  .about-cards .about-cards__numbers .list {\n    grid-gap: 2.3438vw;\n  }\n  .about-cards .about-cards__numbers .item .item-top {\n    margin-bottom: 0.625vw;\n  }\n  .about-cards .about-cards__numbers .item .item-top__symbol,\n  .about-cards .about-cards__numbers .item .item-top__number {\n    letter-spacing: -0.0234vw;\n    font-size: 2.3438vw;\n  }\n  .about-cards .about-cards__numbers .item .item-title h3 {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .about-cards.about-cards--big .about-cards__list {\n    padding: 0 3.516vw 0 4.297vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .list {\n    gap: 6.25vw 8.906vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .item {\n    gap: 1.25vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .item .item-content__title {\n    margin-bottom: 2.5vw;\n  }\n  .about-cards.about-cards--big\n    .about-cards__list\n    .item\n    .item-content__title\n    h3 {\n    font-size: 3.125vw;\n    line-height: 3.75vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .item .item-icon {\n    width: 4.531vw;\n    height: 4.531vw;\n  }\n  .page-template-lp .about-cards .about-cards__list .list {\n    grid-gap: 6.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .about-cards .about-cards__inner {\n    padding-bottom: 14.6154vw;\n  }\n  .about-cards .about-cards__title {\n    max-width: 76.9231vw;\n    margin: 0 auto 13.8462vw;\n  }\n  .about-cards .about-cards__title h2 br {\n    display: none;\n  }\n  .about-cards .about-cards__list .list {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 11.7949vw;\n  }\n  .about-cards .about-cards__list .item .item-icon {\n    width: 14.8718vw;\n    height: 14.8718vw;\n    margin-bottom: 6.4103vw;\n  }\n  .about-cards .about-cards__list .item .item-content__title {\n    margin-bottom: 3.5897vw;\n  }\n  .about-cards .about-cards__list .item .item-content__title h3 {\n    letter-spacing: -0.3333vw;\n    font-size: 6.1538vw;\n  }\n  .about-cards .about-cards__list .item .item-content__text {\n    max-width: 96.1538vw;\n    letter-spacing: -0.0769vw;\n    font-size: 4.1026vw;\n  }\n  .about-cards .about-cards__numbers {\n    margin-top: 19.4872vw;\n    padding-top: 13.0769vw;\n  }\n  .about-cards .about-cards__numbers .about-cards__numbers-title {\n    top: 4.1026vw;\n    font-size: 3.5897vw;\n  }\n  .about-cards .about-cards__numbers .list {\n    width: 100%;\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 8.7179vw;\n  }\n  .about-cards .about-cards__numbers .item {\n    width: 100%;\n  }\n  .about-cards .about-cards__numbers .item .item-top {\n    margin-bottom: 1.7949vw;\n  }\n  .about-cards .about-cards__numbers .item .item-top__symbol,\n  .about-cards .about-cards__numbers .item .item-top__number {\n    letter-spacing: -0.1026vw;\n    font-size: 10.2564vw;\n  }\n  .about-cards .about-cards__numbers .item .item-title h3 {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .about-cards.about-cards--big .about-cards__list {\n    padding: 0;\n  }\n  .about-cards.about-cards--big .about-cards__list .list {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n  .about-cards.about-cards--big .about-cards__list .item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 6.154vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .item .item-content__title {\n    margin-bottom: 6.154vw;\n  }\n  .about-cards.about-cards--big\n    .about-cards__list\n    .item\n    .item-content__title\n    h3 {\n    font-size: 7.179vw;\n    line-height: 8.718vw;\n  }\n  .about-cards.about-cards--big .about-cards__list .item .item-icon {\n    width: 14.872vw;\n    height: 14.872vw;\n  }\n  .page-template-lp .about-cards .about-cards__list .list {\n    grid-gap: 11.7949vw;\n  }\n}\n.testimonials-cards {\n  margin-bottom: 148px;\n}\n.testimonials-cards.testimonials-cards--lp .testimonials-cards__wrapper {\n  padding: 95px 156px 92px 142px;\n}\n.testimonials-cards.testimonials-cards--lp .testimonials-cards__content {\n  width: 100%;\n  max-width: 100%;\n}\n.testimonials-cards.testimonials-cards--lp .testimonials-cards__content-text {\n  font-family: \"Cambon\";\n  font-size: 54px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  margin-bottom: 78px;\n}\n.testimonials-cards.testimonials-cards--lp\n  .testimonials-cards__content-info-position {\n  font-size: 18px;\n}\n.testimonials-cards .testimonials-cards__wrapper {\n  width: 100%;\n  background-color: var(--yellow);\n  border-radius: 24px;\n  overflow: hidden;\n  padding: 114px 156px 116px 156px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  gap: 100px;\n}\n.testimonials-cards .testimonials-cards__image {\n  width: 200px;\n  height: 300px;\n  border-radius: 24px;\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#ededed),\n    color-stop(81.83%, #f7f7f7)\n  );\n  background: linear-gradient(180deg, #ededed 0%, #f7f7f7 81.83%);\n  overflow: hidden;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.testimonials-cards .testimonials-cards__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.testimonials-cards .testimonials-cards__content {\n  width: 100%;\n  max-width: 678px;\n}\n.testimonials-cards .testimonials-cards__content-text {\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: -0.5px;\n  font-size: 28px;\n  color: var(--dark);\n  margin-bottom: 14px;\n}\n.testimonials-cards .testimonials-cards__content-button {\n  display: inline-block;\n  margin-bottom: 56px;\n}\n.testimonials-cards .testimonials-cards__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.testimonials-cards .testimonials-cards__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.testimonials-cards .testimonials-cards__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .testimonials-cards .testimonials-cards__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .testimonials-cards .testimonials-cards__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .testimonials-cards .testimonials-cards__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .testimonials-cards .testimonials-cards__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .testimonials-cards .testimonials-cards__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .testimonials-cards .testimonials-cards__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .testimonials-cards .testimonials-cards__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .testimonials-cards .testimonials-cards__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .testimonials-cards .testimonials-cards__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .testimonials-cards .testimonials-cards__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .testimonials-cards .testimonials-cards__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.testimonials-cards .testimonials-cards__content-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.testimonials-cards .testimonials-cards__content-info-name {\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  font-size: 20px;\n  color: var(--dark);\n  margin-bottom: -3px;\n}\n.testimonials-cards .testimonials-cards__content-info-position {\n  font-weight: 400;\n  line-height: 1.5;\n  font-size: 16px;\n  letter-spacing: -0.4px;\n  color: var(--dark);\n}\n.testimonials-cards .testimonials-cards__content-logo {\n  width: 143px;\n  height: auto;\n}\n.testimonials-cards .testimonials-cards__content-logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.testimonials-cards.testimonials-cards--big {\n  margin: 0 30px 30px 30px;\n  border-radius: 24px;\n  background-color: #b8dfd7;\n}\n.testimonials-cards.testimonials-cards--big .testimonials-cards__wrapper {\n  background-color: transparent;\n}\n.testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n  .testimonials-cards__content {\n  max-width: 100%;\n}\n.testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n  .testimonials-cards__content-text,\n.testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n  .testimonials-cards__content-info {\n  max-width: 678px;\n}\n.testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n  .testimonials-cards__image {\n  display: none !important;\n}\n\n@media screen and (max-width: 1330px) {\n  .testimonials-cards {\n    margin-bottom: 11.1278vw;\n  }\n  .testimonials-cards.testimonials-cards--lp .testimonials-cards__wrapper {\n    padding: 7.1429vw 11.7293vw 6.9173vw 10.6767vw;\n  }\n  .testimonials-cards.testimonials-cards--lp .testimonials-cards__content-text {\n    font-size: 4.0602vw;\n    margin-bottom: 5.8647vw;\n  }\n  .testimonials-cards.testimonials-cards--lp\n    .testimonials-cards__content-info-position {\n    font-size: 1.3534vw;\n  }\n  .testimonials-cards .testimonials-cards__wrapper {\n    border-radius: 1.8045vw;\n    padding: 8.5714vw 11.7293vw 8.7218vw 11.7293vw;\n    gap: 7.5188vw;\n  }\n  .testimonials-cards .testimonials-cards__image {\n    width: 15.0376vw;\n    height: 22.5564vw;\n    border-radius: 1.8045vw;\n  }\n  .testimonials-cards .testimonials-cards__content {\n    max-width: 50.9774vw;\n  }\n  .testimonials-cards .testimonials-cards__content-text {\n    letter-spacing: -0.0376vw;\n    font-size: 2.1053vw;\n    margin-bottom: 1.0526vw;\n  }\n  .testimonials-cards .testimonials-cards__content-button {\n    margin-bottom: 4.2105vw;\n  }\n  .testimonials-cards .testimonials-cards__content-info-name {\n    letter-spacing: -0.015vw;\n    font-size: 1.5038vw;\n    margin-bottom: -0.2256vw;\n  }\n  .testimonials-cards .testimonials-cards__content-info-position {\n    font-size: 1.203vw;\n    letter-spacing: -0.0301vw;\n  }\n  .testimonials-cards .testimonials-cards__content-logo {\n    width: 10.7519vw;\n  }\n  .testimonials-cards.testimonials-cards--big {\n    margin: 0 2.256vw 2.256vw 2.256vw;\n    border-radius: 1.805vw;\n  }\n  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n    .testimonials-cards__content-text,\n  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n    .testimonials-cards__content-info {\n    max-width: 50.977vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .testimonials-cards {\n    margin-bottom: 7.0313vw;\n  }\n  .testimonials-cards.testimonials-cards--lp .testimonials-cards__wrapper {\n    padding: 7.0313vw;\n  }\n  .testimonials-cards.testimonials-cards--lp .testimonials-cards__content-text {\n    font-size: 3.5156vw;\n    margin-bottom: 3.9063vw;\n  }\n  .testimonials-cards.testimonials-cards--lp\n    .testimonials-cards__content-info-position {\n    font-size: 1.4063vw;\n  }\n  .testimonials-cards .testimonials-cards__wrapper {\n    border-radius: 1.875vw;\n    padding: 7.0313vw;\n    gap: 3.9063vw;\n  }\n  .testimonials-cards .testimonials-cards__image {\n    width: 15.625vw;\n    height: 23.4375vw;\n    border-radius: 1.4063vw;\n  }\n  .testimonials-cards .testimonials-cards__content {\n    max-width: 48.4375vw;\n  }\n  .testimonials-cards .testimonials-cards__content-text {\n    letter-spacing: -0.0156vw;\n    font-size: 1.5625vw;\n    margin-bottom: 1.0938vw;\n  }\n  .testimonials-cards .testimonials-cards__content-button {\n    margin-bottom: 9.9219vw;\n  }\n  .testimonials-cards .testimonials-cards__content-info-name {\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n    margin-bottom: -0.2344vw;\n  }\n  .testimonials-cards .testimonials-cards__content-info-position {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n  }\n  .testimonials-cards .testimonials-cards__content-logo {\n    width: 9.2969vw;\n  }\n  .testimonials-cards.testimonials-cards--big {\n    margin: 0 2.344vw 2.344vw 2.344vw;\n    border-radius: 1.875vw;\n  }\n  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n    .testimonials-cards__content-text,\n  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n    .testimonials-cards__content-info {\n    max-width: 52.969vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .testimonials-cards {\n    margin-bottom: 17.9487vw;\n  }\n  .testimonials-cards.testimonials-cards--lp .testimonials-cards__wrapper {\n    padding: 8.2051vw;\n  }\n  .testimonials-cards.testimonials-cards--lp .testimonials-cards__content-text {\n    font-size: 6.1538vw;\n    letter-spacing: -0.01em;\n    margin-bottom: 7.9487vw;\n  }\n  .testimonials-cards.testimonials-cards--lp\n    .testimonials-cards__content-footer {\n    gap: 6.1538vw;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n  }\n  .testimonials-cards.testimonials-cards--lp .testimonials-cards__content-logo {\n    margin: 0;\n    width: 22.0256vw;\n  }\n  .testimonials-cards.testimonials-cards--lp\n    .testimonials-cards__content-info-position {\n    font-size: 3.5897vw;\n  }\n  .testimonials-cards .testimonials-cards__wrapper {\n    border-radius: 4.1026vw;\n    padding: 8.2051vw;\n    gap: 0;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .testimonials-cards .testimonials-cards__image {\n    width: 25.1282vw;\n    height: 37.9487vw;\n    border-radius: 4.1026vw;\n  }\n  .testimonials-cards .testimonials-cards__content {\n    max-width: 100%;\n  }\n  .testimonials-cards .testimonials-cards__content-text {\n    letter-spacing: -0.0897vw;\n    font-size: 5.1282vw;\n    margin-bottom: 4.1026vw;\n  }\n  .testimonials-cards .testimonials-cards__content-button {\n    margin-bottom: 13.0769vw;\n  }\n  .testimonials-cards .testimonials-cards__content-footer {\n    margin-top: 3.8462vw;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .testimonials-cards .testimonials-cards__content-info-name {\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n    margin-bottom: -1px;\n  }\n  .testimonials-cards .testimonials-cards__content-info-position {\n    font-size: 3.5897vw;\n    letter-spacing: -0.0667vw;\n  }\n  .testimonials-cards .testimonials-cards__content-logo {\n    margin-top: 8.4615vw;\n    width: 31.0256vw;\n  }\n  .testimonials-cards.testimonials-cards--big {\n    margin: 0 5.128vw 4.103vw 5.128vw;\n    border-radius: 4.103vw;\n  }\n  .testimonials-cards.testimonials-cards--big .testimonials-cards__content {\n    max-width: 100%;\n  }\n  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n    .testimonials-cards__content-text,\n  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n    .testimonials-cards__content-info {\n    max-width: 100%;\n  }\n  .testimonials-cards.testimonials-cards--big.testimonials-cards-hide-img\n    .testimonials-cards__content-footer {\n    margin-top: 0;\n  }\n}\n.info .info__inner {\n  padding-bottom: 157px;\n}\n.info .info__list .list:not(:first-child) {\n  margin-top: 81px;\n}\n.info .info__list .list .item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 0 55px 0 85px;\n  gap: 170px;\n}\n.info .info__list .list .item.item--reverse {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n  padding: 0 85px 0 55px;\n}\n.info .info__list .item:not(:first-child) {\n  margin-top: 81px;\n}\n.info .info__list .item .item-media {\n  width: 100%;\n  max-width: 520px;\n  height: 400px;\n  border-radius: 24px;\n  overflow: hidden;\n}\n.info .info__list .item .item-media img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.info .info__list .item .item__content {\n  width: 100%;\n  max-width: 460px;\n  margin-top: 88px;\n}\n.info .info__list .item .item__content-title {\n  margin-bottom: 29px;\n}\n.info .info__list .item .item__content-title h3 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  font-size: 40px;\n  color: var(--dark);\n}\n.info .info__list .item .item__content-text {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 20px;\n  color: var(--gray);\n}\n.info .info__list .item .item__content-button {\n  display: inline-block;\n  margin-top: 23px;\n}\n.info .info__list .item .item__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.info .info__list .item .item__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.info .info__list .item .item__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .info .info__list .item .item__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .info .info__list .item .item__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .info .info__list .item .item__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .info .info__list .item .item__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .info .info__list .item .item__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .info .info__list .item .item__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .info .info__list .item .item__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .info .info__list .item .item__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .info .info__list .item .item__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .info .info__list .item .item__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .info .info__list .item .item__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n\n@media screen and (max-width: 1330px) {\n  .info .info__inner {\n    padding-bottom: 11.8045vw;\n  }\n  .info .info__list .list:not(:first-child) {\n    margin-top: 6.0902vw;\n  }\n  .info .info__list .list .item {\n    padding: 0 4.1353vw 0 6.391vw;\n    gap: 12.782vw;\n  }\n  .info .info__list .list .item.item--reverse {\n    padding: 0 6.391vw 0 4.1353vw;\n  }\n  .info .info__list .item:not(:first-child) {\n    margin-top: 6.0902vw;\n  }\n  .info .info__list .item .item-media {\n    max-width: 39.0977vw;\n    height: 30.0752vw;\n    border-radius: 1.8045vw;\n  }\n  .info .info__list .item .item__content {\n    max-width: 34.5865vw;\n    margin-top: 6.6165vw;\n  }\n  .info .info__list .item .item__content-title {\n    margin-bottom: 2.1805vw;\n  }\n  .info .info__list .item .item__content-title h3 {\n    letter-spacing: -0.0301vw;\n    font-size: 3.0075vw;\n  }\n  .info .info__list .item .item__content-text {\n    letter-spacing: -0.0301vw;\n    font-size: 1.5038vw;\n  }\n  .info .info__list .item .item__content-button {\n    margin-top: 1.7293vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .info .info__inner {\n    padding-bottom: 12.3438vw;\n  }\n  .info .info__list .list:not(:first-child) {\n    margin-top: 6.7188vw;\n  }\n  .info .info__list .list .item {\n    padding: 0 2.5781vw 0 4.6875vw;\n    gap: 9.6875vw;\n  }\n  .info .info__list .list .item.item--reverse {\n    padding: 0 4.6875vw 0 2.5781vw;\n  }\n  .info .info__list .item:not(:first-child) {\n    margin-top: 6.25vw;\n  }\n  .info .info__list .item .item-media {\n    max-width: 34.5313vw;\n    height: 26.5625vw;\n    border-radius: 1.875vw;\n  }\n  .info .info__list .item .item__content {\n    max-width: 30.4688vw;\n    margin-top: 3.9063vw;\n  }\n  .info .info__list .item .item__content-title {\n    margin-bottom: 2.5vw;\n  }\n  .info .info__list .item .item__content-title h3 {\n    letter-spacing: -0.0234vw;\n    font-size: 2.3438vw;\n  }\n  .info .info__list .item .item__content-text {\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n  }\n  .info .info__list .item .item__content-button {\n    margin-top: 1.1719vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .info .info__inner {\n    padding-bottom: 17.2564vw;\n  }\n  .info .info__list .list:not(:first-child) {\n    margin-top: 16.9231vw;\n  }\n  .info .info__list .list .item {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n    padding: 0;\n    gap: 9.2308vw;\n  }\n  .info .info__list .list .item.item--reverse {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n    padding: 0;\n  }\n  .info .info__list .item:not(:first-child) {\n    margin-top: 16.9231vw;\n  }\n  .info .info__list .item .item-media {\n    max-width: 100%;\n    height: 69.2308vw;\n    border-radius: 4.1026vw;\n  }\n  .info .info__list .item .item__content {\n    max-width: 100%;\n    margin-top: 0;\n  }\n  .info .info__list .item .item__content-title {\n    margin-bottom: 5.641vw;\n  }\n  .info .info__list .item .item__content-title h3 {\n    letter-spacing: -0.0718vw;\n    font-size: 7.1795vw;\n  }\n  .info .info__list .item .item__content-text {\n    letter-spacing: -0.0769vw;\n    font-size: 4.6154vw;\n  }\n  .info .info__list .item .item__content-button {\n    margin-top: 4.1026vw;\n  }\n}\n.fact {\n  position: relative;\n  z-index: 2;\n  padding: 0 30px 30px;\n  border-radius: 0 0 24px 24px;\n  background-color: var(--white);\n}\n.fact .fact__inner {\n  background-color: var(--beige);\n  border-radius: 24px;\n  padding: 155px 0 160px;\n}\n.fact .fact__title {\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto 90px;\n  text-align: center;\n}\n.fact .fact__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  gap: 48px;\n}\n.fact .fact__content {\n  width: 100%;\n  max-width: 624px;\n}\n.fact .fact__content .fact__statistic-logo {\n  display: none;\n}\n.fact .fact__content-img {\n  width: 100%;\n  height: 316px;\n  border-radius: 24px;\n  overflow: hidden;\n  margin-bottom: 42px;\n}\n.fact .fact__content-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.fact .fact__content-text {\n  font-weight: 400;\n  line-height: 1.4;\n  font-size: 28px;\n  letter-spacing: -0.5px;\n  color: var(--dark);\n}\n.fact .fact__content-text.small-text {\n  font-size: 20px;\n}\n.fact .fact__content-text.small-text b {\n  font-size: 28px;\n}\n.fact .fact__content-text ul li {\n  position: relative;\n  z-index: 2;\n  padding-left: 20px;\n}\n.fact .fact__content-text ul li::before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  left: 0;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background-color: var(--dark);\n}\n.fact .fact__content-button {\n  display: inline-block;\n  margin-top: 22px;\n}\n.fact .fact__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.fact .fact__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.fact .fact__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .fact .fact__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .fact .fact__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .fact .fact__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .fact .fact__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .fact .fact__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .fact .fact__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .fact .fact__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .fact .fact__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .fact .fact__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .fact .fact__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .fact .fact__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.fact .fact__content-info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-top: 38px;\n}\n.fact .fact__content-info-img {\n  width: 78px;\n  height: 78px;\n  border-radius: 50%;\n  margin-right: 24px;\n}\n.fact .fact__content-info-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.fact .fact__content-info-name {\n  font-weight: 500;\n  font-size: 20px;\n  color: var(--dark);\n  margin-bottom: 11px;\n}\n.fact .fact__content-info-position {\n  font-weight: 400;\n  font-size: 18px;\n  color: var(--dark);\n}\n.fact .fact__statistic {\n  width: 100%;\n  max-width: 316px;\n}\n.fact .fact__statistic-logo {\n  width: 100%;\n  height: 316px;\n  background-color: var(--white);\n  border-radius: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.fact .fact__statistic-logo img {\n  width: 160px;\n  height: 220px;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.fact .fact__statistic-numbers {\n  margin-top: 42px;\n}\n.fact .fact__statistic-numbers .item:not(:first-child) {\n  margin-top: 28px;\n}\n.fact .fact__statistic-numbers .item .item-top {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.fact .fact__statistic-numbers .item .item-top__number,\n.fact .fact__statistic-numbers .item .item-top__symbol {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  font-size: 50px;\n  line-height: 1.2;\n  letter-spacing: -0.5px;\n  color: var(--dark);\n}\n.fact .fact__statistic-numbers .item .item-title {\n  width: 100%;\n  max-width: 250px;\n}\n.fact .fact__statistic-numbers .item .item-title h3 {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--gray-2);\n}\n\n.page-template-lp .fact .fact__title .title {\n  font-size: 48px;\n}\n\n.page-template-lp .fact .fact__content-text {\n  font-size: 20px;\n}\n\n.page-template-lp .fact .fact__content-text b {\n  font-size: 28px;\n}\n\n.page-template-lp .fact .fact__statistic-numbers .item .item-top__number,\n.page-template-lp .fact .fact__statistic-numbers .item .item-top__symbol {\n  font-size: 48px;\n}\n\n@media screen and (max-width: 1280px) {\n  .fact {\n    padding: 0 2.3438vw 2.3438vw;\n    border-radius: 0 0 1.875vw 1.875vw;\n  }\n  .fact .fact__inner {\n    border-radius: 1.875vw;\n    padding: 9.7656vw 0 10.1563vw;\n  }\n  .fact .fact__title {\n    max-width: 53.9063vw;\n    margin: 0 auto 5.1563vw;\n  }\n  .fact .fact__wrapper {\n    gap: 3.125vw;\n  }\n  .fact .fact__content {\n    width: 100%;\n    max-width: 48.75vw;\n  }\n  .fact .fact__content-img {\n    height: 24.6875vw;\n    border-radius: 1.875vw;\n    margin-bottom: 3.5938vw;\n  }\n  .fact .fact__content-text {\n    max-width: 44.1406vw;\n    font-size: 1.5625vw;\n    letter-spacing: 0px;\n  }\n  .fact .fact__content-text.small-text {\n    font-size: 1.5625vw;\n  }\n  .fact .fact__content-text.small-text b {\n    font-size: 2.1875vw;\n  }\n  .fact .fact__content-text ul li {\n    padding-left: 1.5625vw;\n  }\n  .fact .fact__content-text ul li::before {\n    top: 0.7813vw;\n    width: 0.7031vw;\n    height: 0.7031vw;\n  }\n  .fact .fact__content-button {\n    margin-top: 1.4063vw;\n  }\n  .fact .fact__content-info {\n    margin-top: 3.2813vw;\n  }\n  .fact .fact__content-info-img {\n    width: 6.0938vw;\n    height: 6.0938vw;\n    margin-right: 1.875vw;\n  }\n  .fact .fact__content-info-name {\n    font-size: 1.4063vw;\n    margin-bottom: 0.4688vw;\n  }\n  .fact .fact__content-info-position {\n    font-size: 1.25vw;\n  }\n  .fact .fact__statistic {\n    max-width: 24.6875vw;\n  }\n  .fact .fact__statistic-logo {\n    height: 24.6875vw;\n    border-radius: 1.875vw;\n  }\n  .fact .fact__statistic-logo img {\n    width: 12.5vw;\n    height: 17.1875vw;\n  }\n  .fact .fact__statistic-numbers {\n    margin-top: 3.75vw;\n    padding-left: 0.7031vw;\n  }\n  .fact .fact__statistic-numbers .item:not(:first-child) {\n    margin-top: 3.5938vw;\n  }\n  .fact .fact__statistic-numbers .item .item-top {\n    margin-bottom: 0.625vw;\n  }\n  .fact .fact__statistic-numbers .item .item-top__number,\n  .fact .fact__statistic-numbers .item .item-top__symbol {\n    font-size: 2.9688vw;\n    letter-spacing: -0.0297vw;\n  }\n  .fact .fact__statistic-numbers .item .item-title {\n    max-width: 19.5313vw;\n  }\n  .fact .fact__statistic-numbers .item .item-title h3 {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .page-template-lp .fact .fact__title .title {\n    font-size: 3.75vw;\n  }\n  .page-template-lp .fact .fact__content-text {\n    font-size: 1.563vw;\n  }\n  .page-template-lp .fact .fact__content-text b {\n    font-size: 2.188vw;\n  }\n  .page-template-lp .fact .fact__statistic-numbers .item .item-top__number,\n  .page-template-lp .fact .fact__statistic-numbers .item .item-top__symbol {\n    font-size: 3.75vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .fact {\n    padding: 0;\n    border-radius: 4.1026vw;\n  }\n  .fact .fact__inner {\n    border-radius: 4.1026vw;\n    padding: 17.4359vw 0 21.5385vw;\n  }\n  .fact .fact__title {\n    max-width: 78.4615vw;\n    margin: 0 auto 13.0769vw;\n  }\n  .fact .fact__wrapper {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 14.359vw;\n  }\n  .fact .fact__content {\n    max-width: 100%;\n  }\n  .fact .fact__content-img {\n    width: 100%;\n    height: 46.1538vw;\n    border-radius: 4.1026vw;\n    margin-bottom: 8.2051vw;\n  }\n  .fact .fact__content-text {\n    max-width: 100%;\n    font-size: 5.1282vw;\n    letter-spacing: -0.1026vw;\n  }\n  .fact .fact__content-text.small-text {\n    font-size: 4.6154vw;\n  }\n  .fact .fact__content-text.small-text b {\n    font-size: 5.1282vw;\n  }\n  .fact .fact__content-text ul li {\n    padding-left: 2.5641vw;\n  }\n  .fact .fact__content-text ul li::before {\n    top: 2.8205vw;\n    width: 1.2821vw;\n    height: 1.2821vw;\n  }\n  .fact .fact__content-button {\n    margin-top: 6.4103vw;\n  }\n  .fact .fact__content-info {\n    margin-top: 10.2564vw;\n  }\n  .fact .fact__content-info-img {\n    width: 16.4103vw;\n    height: 16.4103vw;\n    margin-right: 4.1026vw;\n  }\n  .fact .fact__content-info-name {\n    font-size: 4.6154vw;\n    margin-bottom: 2.8205vw;\n  }\n  .fact .fact__content-info-position {\n    font-size: 4.1026vw;\n  }\n  .fact .fact__statistic {\n    max-width: 100%;\n  }\n  .fact .fact__statistic-logo {\n    height: 81.0256vw;\n    border-radius: 4.1026vw;\n  }\n  .fact .fact__statistic-logo img {\n    width: 41.0256vw;\n    height: 56.4103vw;\n  }\n  .fact .fact__statistic-numbers {\n    margin-top: 8.9744vw;\n    padding-left: 0;\n  }\n  .fact .fact__statistic-numbers .item:not(:first-child) {\n    margin-top: 8.4615vw;\n  }\n  .fact .fact__statistic-numbers .item .item-top {\n    margin-bottom: 1.5385vw;\n  }\n  .fact .fact__statistic-numbers .item .item-top__number,\n  .fact .fact__statistic-numbers .item .item-top__symbol {\n    font-size: 8.2051vw;\n    letter-spacing: -0.0821vw;\n  }\n  .fact .fact__statistic-numbers .item .item-title {\n    max-width: 68.4615vw;\n  }\n  .fact .fact__statistic-numbers .item .item-title h3 {\n    letter-spacing: -0.0769vw;\n    font-size: 4.1026vw;\n  }\n  .page-template-lp .fact .fact__title .title {\n    font-size: 8.205vw;\n  }\n  .page-template-lp .fact .fact__content-text {\n    font-size: 5.128vw;\n  }\n  .page-template-lp .fact .fact__content {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .page-template-lp .fact .fact__content .fact__statistic-logo {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 2.128vw 0 12.821vw 0;\n  }\n  .page-template-lp .fact .fact__content .fact__content-img {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n    margin-bottom: 0;\n  }\n  .page-template-lp .fact .fact__content .fact__content-info {\n    margin-top: 4.2564vw;\n  }\n  .page-template-lp .fact .fact__content-text b {\n    font-size: 5.128vw;\n  }\n  .page-template-lp .fact .fact__statistic .fact__statistic-logo {\n    display: none;\n  }\n  .page-template-lp .fact .fact__statistic-numbers {\n    margin-top: 0;\n  }\n  .page-template-lp .fact .fact__statistic-numbers .item .item-top__number,\n  .page-template-lp .fact .fact__statistic-numbers .item .item-top__symbol {\n    font-size: 8.205vw;\n  }\n  .page-template-lp .fact .fact__content-button a {\n    text-decoration: underline;\n  }\n  .page-template-lp .fact .fact__content-button a:hover {\n    text-decoration: none;\n  }\n  .page-template-lp .fact .fact__content-button a::after {\n    display: none;\n  }\n}\n.more-info {\n  margin-top: -20px;\n  padding-top: 20px;\n  background-color: var(--yellow);\n}\n.more-info .more-info__inner {\n  padding: 136px 0 133px;\n}\n.more-info .more-info__header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  margin-bottom: 57px;\n}\n.more-info .more-info__header-title {\n  width: 100%;\n  max-width: 528px;\n}\n.more-info .more-info__header-button {\n  margin-bottom: 15px;\n}\n.more-info .more-info__list .list {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 30px;\n}\n.more-info .more-info__list .card .card-content .card-content__logo {\n  display: none;\n}\n\n@media screen and (max-width: 1280px) {\n  .more-info {\n    margin-top: -1.5625vw;\n    padding-top: 1.5625vw;\n    background-color: var(--yellow);\n  }\n  .more-info .more-info__inner {\n    padding: 9.6875vw 0 11.7188vw;\n  }\n  .more-info .more-info__header {\n    margin-bottom: 3.9063vw;\n  }\n  .more-info .more-info__header-title {\n    max-width: 44.5313vw;\n  }\n  .more-info .more-info__header-button {\n    margin-bottom: 0.3906vw;\n  }\n  .more-info .more-info__list .list {\n    grid-gap: 2.3438vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .more-info {\n    margin-top: -5.1282vw;\n    padding-top: 5.1282vw;\n  }\n  .more-info .more-info__inner {\n    padding: 20.2564vw 0 17.1795vw;\n  }\n  .more-info .more-info__header {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    text-align: center;\n    margin-bottom: 11.2821vw;\n  }\n  .more-info .more-info__header-title {\n    max-width: 100%;\n    margin-bottom: 7.9487vw;\n  }\n  .more-info .more-info__header-button {\n    margin-bottom: 0;\n  }\n  .more-info .more-info__list .list {\n    display: block;\n    width: calc(100% + 5.1282vw);\n    margin: 0 -2.5641vw;\n  }\n  .more-info .more-info__list .list .slick-track {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n  }\n  .more-info .more-info__list .list .slick-track .card {\n    margin: 0 2.5641vw;\n    height: auto;\n  }\n  .more-info .more-info__list .list .slick-dots {\n    margin-top: 8.7179vw;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    position: relative;\n    bottom: 0;\n  }\n  .more-info .more-info__list .list .slick-dots li {\n    width: 2.0513vw;\n    height: 2.0513vw;\n    background-color: var(--dark);\n    opacity: 0.2;\n    border-radius: 50%;\n    -webkit-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n  }\n  .more-info .more-info__list .list .slick-dots li.slick-active {\n    width: 2.5641vw;\n    height: 2.5641vw;\n    opacity: 1;\n  }\n  .more-info .more-info__list .list .slick-dots li:not(:first-child) {\n    margin-left: 2.0513vw;\n  }\n  .more-info .more-info__list .list .slick-dots li button {\n    width: 100%;\n    height: 100%;\n    font-size: 0;\n  }\n}\n.section-404 {\n  background-color: var(--white);\n  width: 100%;\n  height: 100%;\n}\n.section-404__inner {\n  padding: 79px 0 120px 0;\n}\n.section-404__content {\n  text-align: center;\n}\n.section-404__content-title {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  font-size: 62px;\n  line-height: 1.1;\n  letter-spacing: -0.62px;\n  color: var(--dark);\n  margin: 0 auto 40px auto;\n  max-width: 90%;\n}\n.section-404__content-subtitle {\n  font-family: \"Circular Std\";\n  font-size: 20px;\n  font-weight: 400;\n  letter-spacing: -0.2px;\n  line-height: 1.5;\n  color: var(--gray);\n  margin-bottom: 90px;\n}\n.section-404__content-subtitle a {\n  text-decoration: underline;\n}\n.section-404__content-img {\n  margin: 0 auto;\n  width: 812px;\n  height: 426px;\n}\n.section-404__content-img img {\n  -o-object-fit: contain;\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n}\n\n@media screen and (max-width: 1330px) {\n  .section-404__inner {\n    padding: 5.94vw 0 9.023vw 0;\n  }\n  .section-404__content-title {\n    font-size: 4.662vw;\n    margin: 0 auto 3.008vw auto;\n  }\n  .section-404__content-subtitle {\n    font-size: 1.504vw;\n    margin-bottom: 6.767vw;\n  }\n  .section-404__content-img {\n    width: 61.053vw;\n    height: 32.03vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .section-404__inner {\n    padding: 12.308vw 0 42.308vw 0;\n  }\n  .section-404__content-title {\n    font-size: 9.231vw;\n    margin-bottom: 8.205vw;\n  }\n  .section-404__content-subtitle {\n    font-size: 4.615vw;\n    margin-bottom: 21.538vw;\n  }\n  .section-404__content-img {\n    width: 89.744vw;\n    height: 47.179vw;\n  }\n}\n.article .article__inner {\n  padding: 90px 0 150px;\n}\n.article .article__content {\n  width: 100%;\n  max-width: 780px;\n  margin: 0 auto;\n}\n.article .article__footer {\n  margin-top: 110px;\n  padding-top: 126px;\n  border-top: 1px solid rgba(22, 22, 22, 0.15);\n}\n.article .article__footer-title {\n  width: 100%;\n  max-width: 987px;\n  margin: 0 auto;\n  text-align: center;\n}\n.article .article__footer-title h2 {\n  font-weight: 700;\n  font-family: \"Cambon\";\n  line-height: 1.2;\n  letter-spacing: -0.48px;\n  font-size: 48px;\n  color: var(--black);\n}\n.article .article__footer-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-top: 49px;\n}\n\n@media screen and (max-width: 1330px) {\n  .article .article__inner {\n    padding: 6.7669vw 0 11.2782vw;\n  }\n  .article .article__content {\n    max-width: 58.6466vw;\n  }\n  .article .article__footer {\n    margin-top: 8.2707vw;\n    padding-top: 9.4737vw;\n  }\n  .article .article__footer-title {\n    max-width: 74.2105vw;\n  }\n  .article .article__footer-title h2 {\n    letter-spacing: -0.0361vw;\n    font-size: 3.609vw;\n  }\n  .article .article__footer-button {\n    margin-top: 3.6842vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .article .article__inner {\n    padding: 15.1282vw 0 38.4615vw;\n  }\n  .article .article__content {\n    max-width: 100%;\n  }\n  .article .article__footer {\n    margin-top: 18.4615vw;\n    padding-top: 21.5385vw;\n  }\n  .article .article__footer-title {\n    max-width: 100%;\n  }\n  .article .article__footer-title h2 {\n    letter-spacing: -0.0821vw;\n    font-size: 8.2051vw;\n  }\n  .article .article__footer-button {\n    margin-top: 7.4359vw;\n  }\n}\n.other-article {\n  background-color: var(--light-gray);\n}\n.other-article .other-article__inner {\n  padding: 122px 0 142px;\n}\n.other-article .other-article__header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  gap: 50px;\n  margin-bottom: 48px;\n}\n.other-article .other-article__list {\n  width: 100%;\n  max-width: 1290px;\n  margin: 0 auto;\n}\n.other-article .other-article__list .list {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 30px;\n}\n.other-article .other-article__list .list .card .card-info .card-info__time {\n  display: none;\n}\n\n@media screen and (max-width: 1330px) {\n  .other-article .other-article__inner {\n    padding: 9.1729vw 0 10.6767vw;\n  }\n  .other-article .other-article__header {\n    gap: 3.7594vw;\n    margin-bottom: 3.609vw;\n  }\n  .other-article .other-article__list {\n    max-width: 96.9925vw;\n  }\n  .other-article .other-article__list .list {\n    grid-gap: 2.2556vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .other-article {\n    background-color: var(--light-gray);\n  }\n  .other-article .other-article__inner {\n    padding: 7.8125vw 0 9.375vw;\n  }\n  .other-article .other-article__header {\n    gap: 2.7344vw;\n    margin-bottom: 3.5156vw;\n  }\n  .other-article .other-article__list {\n    max-width: 100%;\n  }\n  .other-article .other-article__list .list {\n    grid-gap: 2.3438vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .other-article .other-article__inner {\n    padding: 20vw 0 16.4103vw;\n  }\n  .other-article .other-article__header {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 7.6923vw;\n    margin-bottom: 10.7692vw;\n  }\n  .other-article .other-article__list {\n    max-width: 100%;\n  }\n  .other-article .other-article__list .list {\n    display: block;\n    width: calc(100% + 5.1282vw);\n    margin: 0 -2.5641vw;\n  }\n  .other-article .other-article__list .list .slick-track {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n  }\n  .other-article .other-article__list .list .slick-track .card {\n    margin: 0 2.5641vw;\n    height: auto;\n  }\n  .other-article .other-article__list .list .slick-dots {\n    margin-top: 6.1538vw;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    position: relative;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n  .other-article .other-article__list .list .slick-dots li {\n    width: 2.0513vw;\n    height: 2.0513vw;\n    background-color: var(--dark);\n    opacity: 0.2;\n    border-radius: 50%;\n    -webkit-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n  }\n  .other-article .other-article__list .list .slick-dots li.slick-active {\n    width: 2.5641vw;\n    height: 2.5641vw;\n    opacity: 1;\n  }\n  .other-article .other-article__list .list .slick-dots li:not(:first-child) {\n    margin-left: 2.0513vw;\n  }\n  .other-article .other-article__list .list .slick-dots li button {\n    width: 100%;\n    height: 100%;\n    font-size: 0;\n  }\n  .other-article .other-article__list .card {\n    padding-bottom: 0;\n  }\n  .other-article .other-article__list .card .card-info {\n    margin-top: 5.641vw;\n    gap: 2.5641vw;\n    padding: 0 4.359vw;\n  }\n  .other-article .other-article__list .card .card-info__labels ul li a {\n    font-size: 3.5897vw;\n    padding: 2.5641vw 4.1026vw;\n  }\n  .other-article .other-article__list .card .card-content {\n    margin-top: 3.5897vw;\n    padding: 0 4.359vw 6.1538vw;\n  }\n  .other-article .other-article__list .card .card-content__logo {\n    width: 40vw;\n    height: auto;\n  }\n  .other-article .other-article__list .card .card-content__title {\n    margin-bottom: 6.4103vw;\n  }\n  .other-article .other-article__list .card .card-content__title h3 {\n    font-size: 4.1026vw;\n    letter-spacing: -0.041vw;\n  }\n}\n.contact {\n  background: var(--light-gray);\n}\n.contact .contact__inner {\n  padding: 82px 0 184px;\n}\n.contact .contact__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.contact .contact__content {\n  width: 100%;\n  max-width: 520px;\n  margin-top: 4px;\n}\n.contact .contact__content-title.contact__content-title--less h1 {\n  font-size: 48px;\n  letter-spacing: -0.48px;\n}\n.contact .contact__content-title h1 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.56px;\n  font-size: 56px;\n  color: var(--dark);\n}\n.contact .contact__content-subtitle {\n  margin-top: 29px;\n}\n.contact .contact__content-subtitle h2 {\n  font-weight: 500;\n  line-height: 1.2;\n  letter-spacing: -0.28px;\n  font-size: 28px;\n  color: var(--dark);\n}\n.contact .contact__content-list {\n  margin-top: 27px;\n}\n.contact .contact__content-list > ul li {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.32px;\n  font-size: 18px;\n  color: var(--dark);\n  position: relative;\n  z-index: 2;\n  padding-left: 43px;\n}\n.contact .contact__content-list > ul li:not(:first-child) {\n  margin-top: 24px;\n}\n.contact .contact__content-list > ul li::before {\n  content: \"\";\n  position: absolute;\n  top: 11px;\n  left: 0;\n  width: 32px;\n  height: 32px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none'%3E%3Cpath fill='%23161616' fill-rule='evenodd' d='M24.707 11.707 13.5 22.914l-6.207-6.207 1.414-1.414 4.793 4.793 9.793-9.793 1.414 1.414Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.contact .contact__content-list > a {\n  margin-top: 32px;\n  margin-left: 42px;\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.contact .contact__content-list > a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.contact .contact__content-list > a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .contact .contact__content-list > a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .contact .contact__content-list > a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .contact .contact__content-list > a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .contact .contact__content-list > a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .contact .contact__content-list > a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .contact .contact__content-list > a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .contact .contact__content-list > a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .contact .contact__content-list > a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .contact .contact__content-list > a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact .contact__content-list > a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .contact .contact__content-list > a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.contact .contact__content-text {\n  margin-top: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.3px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.contact .contact__content-button {\n  margin-top: 23px;\n}\n.contact .contact__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.contact .contact__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.contact .contact__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .contact .contact__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .contact .contact__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .contact .contact__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .contact .contact__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .contact .contact__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .contact .contact__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .contact .contact__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .contact .contact__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .contact .contact__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact .contact__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .contact .contact__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.contact .contact__content-info {\n  margin-top: 32px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n.contact .contact__content-info-img {\n  width: 78px;\n  height: 78px;\n  border-radius: 50%;\n  overflow: hidden;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  margin-right: 24px;\n}\n.contact .contact__content-info-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.contact .contact__content-info-wrapper {\n  margin-top: 15px;\n}\n.contact .contact__content-info-name {\n  font-weight: 500;\n  font-size: 20px;\n  color: var(--dark);\n  margin-bottom: 9px;\n}\n.contact .contact__content-info-position {\n  font-weight: 400;\n  font-size: 18px;\n  letter-spacing: -0.15px;\n  color: var(--dark);\n}\n.contact .contact__content-brands {\n  margin-top: 55px;\n}\n.contact .contact__content-brands ul {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 45px 1fr 45px 1fr 45px 1fr;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 30px 45px;\n}\n.contact .contact__content-brands ul li {\n  width: 100%;\n  height: 50px;\n}\n.contact .contact__content-brands ul li img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n  mix-blend-mode: multiply;\n}\n.contact .contact__form {\n  width: 100%;\n  max-width: 660px;\n  background-color: var(--white);\n  border-radius: 24px;\n  position: relative;\n  z-index: 2;\n  padding: 49px 46px 45px;\n}\n.contact .contact__form .contact__form-image {\n  width: 210px;\n  height: 210px;\n  position: absolute;\n  pointer-events: none;\n}\n.contact .contact__form .contact__form-image.contact__form-image--position-1 {\n  right: 66px;\n  bottom: -80px;\n}\n.contact .contact__form .contact__form-image.contact__form-image--position-2 {\n  right: 45px;\n  bottom: -89px;\n}\n.contact .contact__form .contact__form-image.contact__form-image--position-3 {\n  right: -115px;\n  bottom: -62px;\n}\n.contact .contact__form .contact__form-image img {\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.contact .contact__form .contact__form-image img,\n.contact .contact__form .contact__form-image lottie-player {\n  width: 100%;\n  height: 100%;\n}\n.contact .contact__form .contact__form-wrapper form {\n  width: 100%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr;\n  grid-template-columns: 1fr;\n  grid-gap: 24px;\n}\n.contact .contact__form .contact__form-wrapper form fieldset {\n  width: 100%;\n  max-width: 100%;\n}\n.contact .contact__form .contact__form-wrapper form .hs-form-field {\n  width: 100%;\n}\n.contact .contact__form .contact__form-wrapper form .hs-form-field > label {\n  display: inline-block;\n  margin-bottom: 8px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n}\n.contact .contact__form .contact__form-wrapper form .hs-error-msg,\n.contact .contact__form .contact__form-wrapper form .hs-main-font-element {\n  font-size: 14px;\n  line-height: 1;\n  color: red;\n}\n.contact .contact__form .contact__form-wrapper form .form-columns-2 {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 20px 1fr;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 20px;\n}\n.contact .contact__form .contact__form-wrapper form .input {\n  margin: 0;\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  input:not(input[type=\"submit\"]),\n.contact .contact__form .contact__form-wrapper form select,\n.contact .contact__form .contact__form-wrapper form textarea {\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  width: 100%;\n  height: 54px;\n  padding: 0 16px;\n  border-radius: 8px;\n  background: var(--light-gray);\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  input:not(input[type=\"submit\"])::-webkit-input-placeholder,\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  select::-webkit-input-placeholder,\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  textarea::-webkit-input-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: rgba(22, 22, 22, 0.4);\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  input:not(input[type=\"submit\"])::-moz-placeholder,\n.contact .contact__form .contact__form-wrapper form select::-moz-placeholder,\n.contact .contact__form .contact__form-wrapper form textarea::-moz-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: rgba(22, 22, 22, 0.4);\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  input:not(input[type=\"submit\"]):-ms-input-placeholder,\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  select:-ms-input-placeholder,\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  textarea:-ms-input-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: rgba(22, 22, 22, 0.4);\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  input:not(input[type=\"submit\"])::-ms-input-placeholder,\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  select::-ms-input-placeholder,\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  textarea::-ms-input-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: rgba(22, 22, 22, 0.4);\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  input:not(input[type=\"submit\"])::placeholder,\n.contact .contact__form .contact__form-wrapper form select::placeholder,\n.contact .contact__form .contact__form-wrapper form textarea::placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: rgba(22, 22, 22, 0.4);\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  input:not(input[type=\"submit\"]):-moz-placeholder,\n.contact .contact__form .contact__form-wrapper form select:-moz-placeholder,\n.contact .contact__form .contact__form-wrapper form textarea:-moz-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: rgba(22, 22, 22, 0.4);\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  input:not(input[type=\"submit\"])::-moz-placeholder,\n.contact .contact__form .contact__form-wrapper form select::-moz-placeholder,\n.contact .contact__form .contact__form-wrapper form textarea::-moz-placeholder {\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: rgba(22, 22, 22, 0.4);\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  .hs-fieldtype-select\n  .input {\n  position: relative;\n  z-index: 2;\n}\n.contact\n  .contact__form\n  .contact__form-wrapper\n  form\n  .hs-fieldtype-select\n  .input::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  right: 21px;\n  width: 12px;\n  height: 7px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='7' fill='none'%3E%3Cpath fill='%23444340' d='M6.707 6.293a1 1 0 0 1-1.414 0L.707 1.707C.077 1.077.523 0 1.414 0h9.172c.89 0 1.337 1.077.707 1.707L6.707 6.293Z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.contact .contact__form .contact__form-wrapper form select {\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-size: 16px;\n  color: rgba(22, 22, 22, 0.4);\n}\n.contact .contact__form .contact__form-wrapper form select option {\n  color: var(--dark);\n}\n.contact .contact__form .contact__form-wrapper form select::-ms-expand {\n  display: none;\n}\n.contact .contact__form .contact__form-wrapper form textarea {\n  padding: 14px 16px;\n  min-height: 108px;\n}\n.contact .contact__form .contact__form-wrapper form input[type=\"submit\"] {\n  border-radius: 12px;\n  background: var(--dark);\n  padding: 13px 48px;\n  border-radius: 12px;\n  font-family: \"Circular Std\";\n  font-weight: 500;\n  line-height: 1.5;\n  font-size: 17px;\n  color: var(--white);\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  cursor: pointer;\n}\n.contact .contact__form .contact__form-wrapper form input[type=\"submit\"]:hover {\n  background-color: var(--yellow);\n  color: var(--dark);\n}\n\n@media screen and (max-width: 1330px) {\n  .contact .contact__inner {\n    padding: 6.1654vw 0 13.8346vw;\n  }\n  .contact .contact__content {\n    max-width: 39.0977vw;\n    margin-top: 0.3008vw;\n  }\n  .contact .contact__content-title.contact__content-title--less h1 {\n    font-size: 3.609vw;\n    letter-spacing: -0.0361vw;\n  }\n  .contact .contact__content-title h1 {\n    letter-spacing: -0.0421vw;\n    font-size: 4.2105vw;\n  }\n  .contact .contact__content-subtitle {\n    margin-top: 2.1805vw;\n  }\n  .contact .contact__content-subtitle h2 {\n    letter-spacing: -0.0211vw;\n    font-size: 2.1053vw;\n  }\n  .contact .contact__content-list {\n    margin-top: 2.0301vw;\n  }\n  .contact .contact__content-list > ul li {\n    letter-spacing: -0.0241vw;\n    font-size: 1.3534vw;\n    padding-left: 3.2331vw;\n  }\n  .contact .contact__content-list > ul li:not(:first-child) {\n    margin-top: 1.8045vw;\n  }\n  .contact .contact__content-list > ul li::before {\n    top: 0.8271vw;\n    width: 2.406vw;\n    height: 2.406vw;\n  }\n  .contact .contact__content-list > a {\n    margin-top: 2.406vw;\n    margin-left: 3.1579vw;\n  }\n  .contact .contact__content-text {\n    margin-top: 2.2556vw;\n    letter-spacing: -0.0226vw;\n    font-size: 1.3534vw;\n  }\n  .contact .contact__content-button {\n    margin-top: 1.7293vw;\n  }\n  .contact .contact__content-info {\n    margin-top: 2.406vw;\n  }\n  .contact .contact__content-info-img {\n    width: 5.8647vw;\n    height: 5.8647vw;\n    margin-right: 1.8045vw;\n  }\n  .contact .contact__content-info-wrapper {\n    margin-top: 1.1278vw;\n  }\n  .contact .contact__content-info-name {\n    font-size: 1.5038vw;\n    margin-bottom: 0.6767vw;\n  }\n  .contact .contact__content-info-position {\n    font-size: 1.3534vw;\n    letter-spacing: -0.0113vw;\n  }\n  .contact .contact__content-brands {\n    margin-top: 4.1353vw;\n  }\n  .contact .contact__content-brands ul {\n    grid-gap: 2.2556vw 3.3835vw;\n  }\n  .contact .contact__content-brands ul li {\n    height: 3.7594vw;\n  }\n  .contact .contact__form {\n    max-width: 49.6241vw;\n    border-radius: 1.8045vw;\n    padding: 3.6842vw 3.4586vw 3.3835vw;\n  }\n  .contact .contact__form .contact__form-image {\n    width: 15.7895vw;\n    height: 15.7895vw;\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-1 {\n    right: 4.9624vw;\n    bottom: -6.015vw;\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-2 {\n    right: 3.3835vw;\n    bottom: -6.6917vw;\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-3 {\n    right: -8.6466vw;\n    bottom: -4.6617vw;\n  }\n  .contact .contact__form .contact__form-wrapper form {\n    grid-gap: 1.8045vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .hs-form-field > label {\n    display: inline-block;\n    margin-bottom: 0.6015vw;\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .hs-error-msg,\n  .contact .contact__form .contact__form-wrapper form .hs-main-font-element {\n    font-size: 1.0526vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .form-columns-2 {\n    grid-gap: 1.5038vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]),\n  .contact .contact__form .contact__form-wrapper form select,\n  .contact .contact__form .contact__form-wrapper form textarea {\n    height: 4.0602vw;\n    padding: 0 1.203vw;\n    border-radius: 0.6015vw;\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-webkit-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select::-webkit-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-webkit-input-placeholder {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-moz-placeholder {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]):-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select:-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea:-ms-input-placeholder {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select::-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-ms-input-placeholder {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::placeholder,\n  .contact .contact__form .contact__form-wrapper form select::placeholder,\n  .contact .contact__form .contact__form-wrapper form textarea::placeholder {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]):-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select:-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea:-moz-placeholder {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-moz-placeholder {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    .hs-fieldtype-select\n    .input::before {\n    right: 1.5789vw;\n    width: 0.9023vw;\n    height: 0.5263vw;\n  }\n  .contact .contact__form .contact__form-wrapper form select {\n    font-size: 1.203vw;\n  }\n  .contact .contact__form .contact__form-wrapper form textarea {\n    padding: 1.0526vw 1.203vw;\n    min-height: 8.1203vw;\n  }\n  .contact .contact__form .contact__form-wrapper form input[type=\"submit\"] {\n    border-radius: 0.9023vw;\n    padding: 0.9774vw 3.609vw;\n    border-radius: 0.9023vw;\n    font-size: 1.2782vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .contact .contact__inner {\n    padding: 6.25vw 0;\n  }\n  .contact .contact__content {\n    width: 100%;\n    max-width: 35.1563vw;\n    margin-top: 0.3125vw;\n  }\n  .contact .contact__content-title.contact__content-title--less h1 {\n    font-size: 2.1875vw;\n    letter-spacing: -0.0297vw;\n  }\n  .contact .contact__content-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0281vw;\n    font-size: 2.9688vw;\n  }\n  .contact .contact__content-subtitle {\n    margin-top: 1.1719vw;\n  }\n  .contact .contact__content-subtitle h2 {\n    letter-spacing: -0.0141vw;\n    font-size: 1.5625vw;\n  }\n  .contact .contact__content-list {\n    margin-top: 1.1719vw;\n  }\n  .contact .contact__content-list > ul li {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n    padding-left: 2.3438vw;\n  }\n  .contact .contact__content-list > ul li:not(:first-child) {\n    margin-top: 1.1719vw;\n  }\n  .contact .contact__content-list > ul li::before {\n    top: 0.3906vw;\n    width: 1.9531vw;\n    height: 1.9531vw;\n  }\n  .contact .contact__content-list > a {\n    margin-top: 1.1719vw;\n    margin-left: 2.3438vw;\n  }\n  .contact .contact__content-text {\n    margin-top: 1.1719vw;\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact .contact__content-button {\n    margin-top: 1.1719vw;\n  }\n  .contact .contact__content-info {\n    margin-top: 2.3438vw;\n  }\n  .contact .contact__content-info-img {\n    width: 4.5313vw;\n    height: 4.5313vw;\n    margin-right: 1.0938vw;\n  }\n  .contact .contact__content-info-wrapper {\n    margin-top: 0.7813vw;\n  }\n  .contact .contact__content-info-name {\n    font-size: 1.4063vw;\n    margin-bottom: 0.3906vw;\n  }\n  .contact .contact__content-info-position {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n  }\n  .contact .contact__content-brands {\n    margin-top: 2.7344vw;\n  }\n  .contact .contact__content-brands ul {\n    grid-gap: 2.3438vw;\n  }\n  .contact .contact__content-brands ul li {\n    height: 2.7344vw;\n  }\n  .contact .contact__form {\n    max-width: 41.0156vw;\n    border-radius: 1.875vw;\n    padding: 3.125vw 2.3438vw;\n  }\n  .contact .contact__form .contact__form-image {\n    width: 14.0625vw;\n    height: 14.0625vw;\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-1 {\n    right: 3.125vw;\n    bottom: -6.25vw;\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-2 {\n    right: 3.5156vw;\n    bottom: -6.9531vw;\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-3 {\n    right: -5.4688vw;\n    bottom: -4.8438vw;\n  }\n  .contact .contact__form .contact__form-wrapper form {\n    grid-gap: 1.1719vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .hs-form-field > label {\n    margin-bottom: 0.625vw;\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .hs-error-msg,\n  .contact .contact__form .contact__form-wrapper form .hs-main-font-element {\n    font-size: 1.0938vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .form-columns-2 {\n    grid-gap: 1.1719vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]),\n  .contact .contact__form .contact__form-wrapper form select,\n  .contact .contact__form .contact__form-wrapper form textarea {\n    height: 4.2188vw;\n    padding: 0 1.25vw;\n    border-radius: 0.625vw;\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-webkit-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select::-webkit-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-webkit-input-placeholder {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-moz-placeholder {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]):-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select:-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea:-ms-input-placeholder {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select::-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-ms-input-placeholder {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::placeholder,\n  .contact .contact__form .contact__form-wrapper form select::placeholder,\n  .contact .contact__form .contact__form-wrapper form textarea::placeholder {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]):-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select:-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea:-moz-placeholder {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-moz-placeholder {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    .hs-fieldtype-select\n    .input::before {\n    right: 1.6406vw;\n    width: 0.9375vw;\n    height: 0.5469vw;\n  }\n  .contact .contact__form .contact__form-wrapper form select {\n    font-size: 1.25vw;\n  }\n  .contact .contact__form .contact__form-wrapper form textarea {\n    padding: 1.0938vw 1.25vw;\n    min-height: 8.4375vw;\n  }\n  .contact .contact__form .contact__form-wrapper form input[type=\"submit\"] {\n    border-radius: 0.9375vw;\n    padding: 1.0156vw 3.75vw;\n    border-radius: 0.9375vw;\n    font-size: 1.3281vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .contact .contact__inner {\n    padding: 13.8462vw 0 24.8718vw;\n  }\n  .contact .contact__wrapper {\n    display: block;\n  }\n  .contact .contact__content {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    max-width: 100%;\n    margin-top: 0;\n  }\n  .contact .contact__content-title.contact__content-title--less h1 {\n    font-size: 9.2308vw;\n    letter-spacing: -0.0923vw;\n  }\n  .contact .contact__content-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0923vw;\n    font-size: 9.2308vw;\n  }\n  .contact .contact__content-subtitle {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n    margin-top: 20vw;\n    width: 100%;\n    max-width: 66.6667vw;\n  }\n  .contact .contact__content-subtitle h2 {\n    letter-spacing: -0.0718vw;\n    font-size: 5.641vw;\n    color: var(--dark);\n  }\n  .contact .contact__content-subtitle h2 br {\n    display: none;\n  }\n  .contact .contact__content-list {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n    margin-top: 17.6923vw;\n  }\n  .contact .contact__content-list > ul li {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n    padding-left: 11.0256vw;\n  }\n  .contact .contact__content-list > ul li br {\n    display: none;\n  }\n  .contact .contact__content-list > ul li:not(:first-child) {\n    margin-top: 6.1538vw;\n  }\n  .contact .contact__content-list > ul li::before {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 8.2051vw;\n    height: 8.2051vw;\n  }\n  .contact .contact__content-list > a {\n    margin-top: 6.1538vw;\n  }\n  .contact .contact__content-text {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n    margin-top: 7.6923vw;\n    line-height: 1.5;\n    font-size: 4.1026vw;\n    letter-spacing: -0.0846vw;\n  }\n  .contact .contact__content-text br {\n    display: none;\n  }\n  .contact .contact__content-button {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n    margin-top: 5.8974vw;\n  }\n  .contact .contact__content-info {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n    margin-top: 15.1282vw;\n  }\n  .contact .contact__content-info-img {\n    width: 16.4103vw;\n    height: 16.4103vw;\n    margin-right: 4.1026vw;\n  }\n  .contact .contact__content-info-wrapper {\n    margin-top: 0px;\n  }\n  .contact .contact__content-info-name {\n    font-size: 4.6154vw;\n    margin-bottom: 1.2821vw;\n  }\n  .contact .contact__content-info-position {\n    font-size: 4.1026vw;\n    line-height: 1.4;\n    letter-spacing: -0.0385vw;\n  }\n  .contact .contact__content-brands {\n    width: 100%;\n    max-width: 62.3077vw;\n    margin: 10.2564vw auto 0;\n  }\n  .contact .contact__content-brands ul {\n    -ms-grid-columns: 1fr 7.1795vw 1fr;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 7.6923vw 7.1795vw;\n  }\n  .contact .contact__content-brands ul li {\n    width: 100%;\n    height: 11.5385vw;\n  }\n  .contact .contact__form {\n    margin-top: 8.2051vw;\n    margin-bottom: 24.6154vw;\n    max-width: 100%;\n    border-radius: 6.1538vw;\n    padding: 8.2051vw 6.1538vw 23.0769vw;\n  }\n  .contact .contact__form .contact__form-image {\n    width: 41.5385vw;\n    height: 41.5385vw;\n    -webkit-transform: translateX(50%);\n    transform: translateX(50%);\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-1 {\n    right: 50%;\n    bottom: -24.6154vw;\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-2 {\n    right: 50%;\n    bottom: -24.6154vw;\n  }\n  .contact .contact__form .contact__form-image.contact__form-image--position-3 {\n    right: 50%;\n    bottom: -24.6154vw;\n  }\n  .contact .contact__form .contact__form-image img {\n    -o-object-fit: contain;\n    object-fit: contain;\n  }\n  .contact .contact__form .contact__form-image img,\n  .contact .contact__form .contact__form-image lottie-player {\n    width: 100%;\n    height: 100%;\n  }\n  .contact .contact__form .contact__form-wrapper form {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 6.1538vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .hs-form-field > label {\n    margin-bottom: 2.0513vw;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .hs-error-msg,\n  .contact .contact__form .contact__form-wrapper form .hs-main-font-element {\n    font-size: 3.5897vw;\n  }\n  .contact .contact__form .contact__form-wrapper form .form-columns-2 {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 6.1538vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]),\n  .contact .contact__form .contact__form-wrapper form select,\n  .contact .contact__form .contact__form-wrapper form textarea {\n    height: 13.8462vw;\n    padding: 0 4.1026vw;\n    border-radius: 2.0513vw;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-webkit-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select::-webkit-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-webkit-input-placeholder {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-moz-placeholder {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]):-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select:-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea:-ms-input-placeholder {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    select::-ms-input-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-ms-input-placeholder {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::placeholder,\n  .contact .contact__form .contact__form-wrapper form select::placeholder,\n  .contact .contact__form .contact__form-wrapper form textarea::placeholder {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"]):-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select:-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea:-moz-placeholder {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    input:not(input[type=\"submit\"])::-moz-placeholder,\n  .contact .contact__form .contact__form-wrapper form select::-moz-placeholder,\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    textarea::-moz-placeholder {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .contact\n    .contact__form\n    .contact__form-wrapper\n    form\n    .hs-fieldtype-select\n    .input::before {\n    right: 5.3846vw;\n    width: 3.0769vw;\n    height: 1.7949vw;\n  }\n  .contact .contact__form .contact__form-wrapper form select {\n    font-size: 4.1026vw;\n  }\n  .contact .contact__form .contact__form-wrapper form textarea {\n    padding: 3.5897vw 4.1026vw;\n    min-height: 27.6923vw;\n  }\n  .contact .contact__form .contact__form-wrapper form input[type=\"submit\"] {\n    width: 100%;\n    border-radius: 3.0769vw;\n    padding: 3.3333vw 12.3077vw;\n    border-radius: 3.0769vw;\n    font-size: 4.359vw;\n  }\n}\n.general-header {\n  padding: 100px 0 76px;\n}\n.general-header.general-header--store {\n  padding: 90px 0 63px;\n}\n.general-header.general-header--store .general-header__panel {\n  margin: 0 auto;\n}\n.general-header .general-header__wrapper {\n  width: 100%;\n  max-width: 932px;\n  margin: 0 auto;\n  text-align: center;\n}\n.general-header .general-header__label {\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n  text-transform: uppercase;\n  font-size: 14px;\n  color: var(--dark);\n  margin-bottom: 20px;\n}\n.general-header .general-header__title {\n  margin-bottom: 20px;\n}\n.general-header .general-header__title h1 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.56px;\n  font-size: 56px;\n  color: var(--dark);\n}\n.general-header .general-header__text {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.42px;\n  font-size: 20px;\n  color: var(--dark);\n}\n.general-header .general-header__panel {\n  width: 100%;\n  max-width: 630px;\n  margin: 48px auto 0;\n  border-radius: 60px;\n  border: 1px solid var(--white-2);\n  background: var(--white);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 10px;\n}\n.general-header .general-header__panel-button {\n  position: relative;\n  z-index: 2;\n}\n.general-header .general-header__panel-button.current-button button {\n  color: var(--white);\n  background-color: var(--dark);\n}\n.general-header .general-header__panel-button button {\n  padding: 7px 20px;\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n  background-color: transparent;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  border-radius: 40px;\n}\n.general-header .general-header__panel-button .hover-block {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--dark);\n  border-radius: 40px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n\n@media screen and (max-width: 1330px) {\n  .general-header {\n    padding: 7.5188vw 0 5.7143vw;\n  }\n  .general-header.general-header--store {\n    padding: 4.6875vw 0 3.2813vw;\n  }\n  .general-header.general-header--store .general-header__panel {\n    margin: 0 auto;\n  }\n  .general-header .general-header__wrapper {\n    max-width: 70.0752vw;\n  }\n  .general-header .general-header__label {\n    letter-spacing: -0.0105vw;\n    font-size: 1.0526vw;\n    margin-bottom: 1.5038vw;\n  }\n  .general-header .general-header__title {\n    margin-bottom: 1.5038vw;\n  }\n  .general-header .general-header__title h1 {\n    letter-spacing: -0.0421vw;\n    font-size: 4.2105vw;\n  }\n  .general-header .general-header__text {\n    letter-spacing: -0.0316vw;\n    font-size: 1.5038vw;\n  }\n  .general-header .general-header__panel {\n    max-width: 630px;\n    margin: 48px auto 0;\n    border-radius: 60px;\n    padding: 10px;\n  }\n  .general-header .general-header__panel-button button {\n    padding: 7px 20px;\n    font-weight: 450;\n    letter-spacing: -0.16px;\n    font-size: 16px;\n    color: var(--dark);\n    -webkit-transition: all 0.4s linear;\n    transition: all 0.4s linear;\n  }\n  .general-header .general-header__panel-button .hover-block {\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: var(--dark);\n    border-radius: 40px;\n    -webkit-transition: all 0.4s linear;\n    transition: all 0.4s linear;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-header {\n    padding: 6.25vw 0 2.5vw;\n  }\n  .general-header.general-header--store {\n    padding: 3.9063vw 0;\n  }\n  .general-header.general-header--store .general-header__panel {\n    margin: 0 auto;\n  }\n  .general-header .general-header__wrapper {\n    max-width: 55.4688vw;\n  }\n  .general-header .general-header__label {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n    margin-bottom: 1.6406vw;\n  }\n  .general-header .general-header__title {\n    margin-bottom: 1.4844vw;\n  }\n  .general-header .general-header__title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0328vw;\n    font-size: 3.2813vw;\n  }\n  .general-header .general-header__text {\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n  }\n  .general-header .general-header__panel {\n    max-width: 48.4375vw;\n    margin: 3.75vw auto 0;\n    border-radius: 4.6875vw;\n    padding: 0.625vw 0.7813vw;\n  }\n  .general-header .general-header__panel-button button {\n    padding: 0.9375vw 1.5625vw;\n    font-weight: 400;\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n    border-radius: 3.125vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-header {\n    padding: 12.0513vw 0;\n  }\n  .general-header.general-header--store {\n    padding: 6.6667vw 0 11.0256vw;\n  }\n  .general-header.general-header--store .general-header__panel {\n    margin: 0 auto;\n  }\n  .general-header .general-header__wrapper {\n    max-width: 100%;\n  }\n  .general-header .general-header__label {\n    letter-spacing: -0.0359vw;\n    font-size: 3.5897vw;\n    margin-bottom: 4.359vw;\n  }\n  .general-header .general-header__title {\n    margin-bottom: 6.1538vw;\n  }\n  .general-header .general-header__title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0923vw;\n    font-size: 9.2308vw;\n  }\n  .general-header .general-header__text {\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n  }\n  .general-header .general-header__panel {\n    max-width: 100%;\n    margin: 5.641vw auto 0;\n    border-radius: 0px;\n    padding: 0px;\n    border: none;\n    background: transparent;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n  .general-header .general-header__panel-button {\n    border-radius: 10.2564vw;\n    border: 1px solid var(--white-2);\n    background: var(--white);\n    margin: 2.0513vw 1.0256vw 0;\n  }\n  .general-header .general-header__panel-button.current-button {\n    background-color: var(--dark);\n    border-color: var(--dark);\n  }\n  .general-header .general-header__panel-button.current-button button {\n    background-color: transparent;\n    color: var(--white);\n  }\n  .general-header .general-header__panel-button button {\n    padding: 2.5641vw 6.1538vw;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n    color: rgba(22, 22, 22, 0.5);\n  }\n  .general-header .general-header__panel-button .hover-block {\n    display: none;\n  }\n}\n.general-banner {\n  -webkit-box-ordinal-group: 0;\n  -ms-flex-order: -1;\n  order: -1;\n}\n.general-banner .general-banner__wrapper {\n  background-color: var(--beige-2);\n  border-radius: 24px;\n  padding: 77px 80px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.general-banner .general-banner__content {\n  width: 100%;\n  max-width: 480px;\n}\n.general-banner .general-banner__content-logo {\n  width: 198px;\n  height: 53px;\n  margin-bottom: 22px;\n}\n.general-banner .general-banner__content-logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.general-banner .general-banner__content-text {\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: -0.28px;\n  font-size: 28px;\n  color: var(--dark);\n}\n.general-banner .general-banner__content-subtext {\n  margin-top: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.general-banner .general-banner__content-button {\n  display: inline-block;\n  margin-top: 76px;\n}\n.general-banner .general-banner__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.general-banner .general-banner__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.general-banner .general-banner__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .general-banner .general-banner__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .general-banner .general-banner__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .general-banner .general-banner__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .general-banner .general-banner__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .general-banner .general-banner__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .general-banner .general-banner__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-banner .general-banner__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .general-banner .general-banner__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-banner .general-banner__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .general-banner .general-banner__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .general-banner .general-banner__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.general-banner .general-banner__image {\n  width: 100%;\n  max-width: 570px;\n  height: 376px;\n  border-radius: 24px;\n  overflow: hidden;\n}\n.general-banner .general-banner__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media screen and (max-width: 1330px) {\n  .general-banner .general-banner__wrapper {\n    border-radius: 1.8045vw;\n    padding: 5.7895vw 6.015vw;\n  }\n  .general-banner .general-banner__content {\n    max-width: 36.0902vw;\n  }\n  .general-banner .general-banner__content-logo {\n    width: 14.8872vw;\n    height: 3.985vw;\n    margin-bottom: 1.6541vw;\n  }\n  .general-banner .general-banner__content-text {\n    letter-spacing: -0.0211vw;\n    font-size: 2.1053vw;\n  }\n  .general-banner .general-banner__content-subtext {\n    margin-top: 1.203vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .general-banner .general-banner__content-button {\n    margin-top: 5.7143vw;\n  }\n  .general-banner .general-banner__image {\n    max-width: 42.8571vw;\n    height: 28.2707vw;\n    border-radius: 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-banner .general-banner__wrapper {\n    border-radius: 1.875vw;\n    padding: 5.3125vw 4.6875vw;\n  }\n  .general-banner .general-banner__content {\n    max-width: 31.25vw;\n  }\n  .general-banner .general-banner__content-logo {\n    width: 10.9375vw;\n    height: auto;\n    margin-bottom: 1.5625vw;\n  }\n  .general-banner .general-banner__content-text {\n    letter-spacing: -0.0156vw;\n    font-size: 1.5625vw;\n  }\n  .general-banner .general-banner__content-subtext {\n    margin-top: 1.25vw;\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .general-banner .general-banner__content-button {\n    margin-top: 5.9375vw;\n  }\n  .general-banner .general-banner__image {\n    max-width: 36.7188vw;\n    height: 24.2188vw;\n    border-radius: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-banner .container {\n    padding: 0;\n  }\n  .general-banner .general-banner__wrapper {\n    border-radius: 6.1538vw;\n    padding: 5.1282vw 5.1282vw 11.0256vw;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n  }\n  .general-banner .general-banner__content {\n    max-width: 100%;\n  }\n  .general-banner .general-banner__content-logo {\n    display: none;\n  }\n  .general-banner .general-banner__content-text {\n    letter-spacing: -0.0564vw;\n    font-size: 5.641vw;\n  }\n  .general-banner .general-banner__content-subtext {\n    margin-top: 4.1026vw;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .general-banner .general-banner__content-button {\n    margin-top: 8.2051vw;\n  }\n  .general-banner .general-banner__image {\n    width: 100%;\n    max-width: 100%;\n    height: 58.9744vw;\n    border-radius: 4.1026vw;\n    margin-bottom: 6.1538vw;\n  }\n}\n.general-list:nth-child(2) {\n  -webkit-box-ordinal-group: 2;\n  -ms-flex-order: 1;\n  order: 1;\n}\n.general-list:nth-child(3) {\n  -webkit-box-ordinal-group: 3;\n  -ms-flex-order: 2;\n  order: 2;\n}\n.general-list .list {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 50px 30px;\n}\n.general-list .list .card {\n  border: 1px solid var(--white-2);\n  position: relative;\n  z-index: 2;\n  padding: 6px 6px 82px 6px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.general-list .list .card:hover {\n  -webkit-box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),\n    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),\n    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),\n    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),\n    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),\n    0px 100px 80px 0px rgba(0, 0, 0, 0.05);\n  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),\n    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),\n    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),\n    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),\n    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),\n    0px 100px 80px 0px rgba(0, 0, 0, 0.05);\n}\n.general-list .list .card:hover .card-content__button::after {\n  width: 100%;\n}\n.general-list .list .card .card-info__labels ul {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 10px;\n}\n.general-list .list .card .card-info__labels ul li a {\n  font-weight: 500;\n  letter-spacing: -0.3px;\n  font-size: 14px;\n  color: var(--dark);\n  text-align: center;\n  padding: 10px 16px;\n}\n.general-list .list .card .card-info__time {\n  display: none;\n}\n.general-list .list .card .card-content {\n  margin-top: 14px;\n  padding: 0 26px 0;\n}\n.general-list .list .card .card-content__title {\n  margin-bottom: 0;\n}\n.general-list .list .card .card-content__title h3 {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.general-list .list .card .card-content__button {\n  position: absolute;\n  z-index: 2;\n  left: 31px;\n  bottom: 31px;\n}\n\n@media screen and (max-width: 1330px) {\n  .general-list .list {\n    grid-gap: 3.7594vw 2.2556vw;\n  }\n  .general-list .list .card {\n    padding: 0.4511vw 0.4511vw 6.1654vw 0.4511vw;\n  }\n  .general-list .list .card .card-info__labels ul {\n    gap: 0.7519vw;\n  }\n  .general-list .list .card .card-info__labels ul li a {\n    letter-spacing: -0.0226vw;\n    font-size: 1.0526vw;\n    padding: 0.7519vw 1.203vw;\n  }\n  .general-list .list .card .card-content {\n    margin-top: 1.0526vw;\n    padding: 0 1.9549vw 0;\n  }\n  .general-list .list .card .card-content__title h3 {\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .general-list .list .card .card-content__button {\n    left: 2.3308vw;\n    bottom: 2.3308vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-list .list {\n    grid-gap: 3.9063vw 2.3438vw;\n  }\n  .general-list .list .card {\n    padding: 0.4688vw 0.4688vw 6.4063vw 0.4688vw;\n  }\n  .general-list .list .card:hover {\n    -webkit-box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),\n      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),\n      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),\n      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),\n      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),\n      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);\n    box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),\n      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),\n      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),\n      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),\n      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),\n      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);\n  }\n  .general-list .list .card .card-info__labels ul {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    gap: 0.7813vw;\n  }\n  .general-list .list .card .card-info__labels ul li a {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n    padding: 0.7813vw 1.25vw;\n  }\n  .general-list .list .card .card-content {\n    margin-top: 0.7031vw;\n    padding: 0 1.3281vw 0;\n  }\n  .general-list .list .card .card-content__title {\n    margin-bottom: 0;\n  }\n  .general-list .list .card .card-content__title h3 {\n    letter-spacing: -0.0313vw;\n    font-size: 1.25vw;\n  }\n  .general-list .list .card .card-content__button {\n    left: 1.7969vw;\n    bottom: 2.6563vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-list .list {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 7.6923vw;\n  }\n  .general-list .list .card {\n    padding: 1.5385vw 1.5385vw 18.2051vw 1.5385vw;\n  }\n  .general-list .list .card:hover {\n    -webkit-box-shadow: 0px 0.7692vw 0.5128vw 0px rgba(0, 0, 0, 0.01),\n      0px 1.7949vw 1.2821vw 0px rgba(0, 0, 0, 0.02),\n      0px 3.0769vw 2.5641vw 0px rgba(0, 0, 0, 0.03),\n      0px 5.641vw 4.6154vw 0px rgba(0, 0, 0, 0.03),\n      0px 10.7692vw 8.4615vw 0px rgba(0, 0, 0, 0.04),\n      0px 25.641vw 20.5128vw 0px rgba(0, 0, 0, 0.05);\n    box-shadow: 0px 0.7692vw 0.5128vw 0px rgba(0, 0, 0, 0.01),\n      0px 1.7949vw 1.2821vw 0px rgba(0, 0, 0, 0.02),\n      0px 3.0769vw 2.5641vw 0px rgba(0, 0, 0, 0.03),\n      0px 5.641vw 4.6154vw 0px rgba(0, 0, 0, 0.03),\n      0px 10.7692vw 8.4615vw 0px rgba(0, 0, 0, 0.04),\n      0px 25.641vw 20.5128vw 0px rgba(0, 0, 0, 0.05);\n  }\n  .general-list .list .card .card-info {\n    margin-top: 5.3846vw;\n    padding: 0 4.359vw;\n    gap: 2.5641vw;\n  }\n  .general-list .list .card .card-info__labels ul {\n    gap: 2.5641vw;\n  }\n  .general-list .list .card .card-info__labels ul li a {\n    font-weight: 500;\n    letter-spacing: -0.0769vw;\n    font-size: 3.5897vw;\n    color: var(--dark);\n    text-align: center;\n    padding: 2.5641vw 4.1026vw;\n  }\n  .general-list .list .card .card-content {\n    margin-top: 3.5897vw;\n    padding: 0 4.359vw 0;\n  }\n  .general-list .list .card .card-content__logo {\n    width: 40vw;\n    height: auto;\n  }\n  .general-list .list .card .card-content__title h3 {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .general-list .list .card .card-content__button {\n    left: 5.641vw;\n    bottom: 5.3846vw;\n  }\n}\n.general-info .general-info__wrapper {\n  border-radius: 24px;\n  background-color: var(--blue);\n  overflow: hidden;\n  padding: 78px 80px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.general-info .general-info__content-logo {\n  width: 239px;\n  height: 54px;\n  margin-bottom: 30px;\n}\n.general-info .general-info__content-logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.general-info .general-info__content-list {\n  width: 100%;\n  max-width: 495px;\n}\n.general-info .general-info__content-list .list {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 55px 1fr;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 30px 55px;\n}\n.general-info .general-info__content-list .item {\n  width: 100%;\n}\n.general-info .general-info__content-list .item .item-title {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  font-size: 40px;\n  color: var(--black);\n  margin-bottom: 3px;\n}\n.general-info .general-info__content-list .item .item-subtitle {\n  width: 100%;\n  max-width: 215px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.general-info .general-info__content-button {\n  margin-top: 53px;\n  display: inline-block;\n}\n.general-info .general-info__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.general-info .general-info__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.general-info .general-info__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .general-info .general-info__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .general-info .general-info__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .general-info .general-info__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .general-info .general-info__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .general-info .general-info__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .general-info .general-info__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-info .general-info__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .general-info .general-info__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-info .general-info__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .general-info .general-info__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .general-info .general-info__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.general-info .general-info__image {\n  width: 100%;\n  max-width: 570px;\n  height: 376px;\n  border-radius: 24px;\n}\n.general-info .general-info__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media screen and (max-width: 1330px) {\n  .general-info .general-info__wrapper {\n    border-radius: 1.8045vw;\n    padding: 5.8647vw 6.015vw;\n  }\n  .general-info .general-info__content-logo {\n    width: 17.9699vw;\n    height: 4.0602vw;\n    margin-bottom: 2.2556vw;\n  }\n  .general-info .general-info__content-list {\n    max-width: 37.218vw;\n  }\n  .general-info .general-info__content-list .list {\n    grid-gap: 2.2556vw 4.1353vw;\n  }\n  .general-info .general-info__content-list .item .item-title {\n    letter-spacing: -0.0301vw;\n    font-size: 3.0075vw;\n    margin-bottom: 0.2256vw;\n  }\n  .general-info .general-info__content-list .item .item-subtitle {\n    max-width: 16.1654vw;\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n  }\n  .general-info .general-info__content-button {\n    margin-top: 3.985vw;\n  }\n  .general-info .general-info__image {\n    max-width: 42.8571vw;\n    height: 28.2707vw;\n    border-radius: 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-info .general-info__wrapper {\n    border-radius: 1.875vw;\n    padding: 5.3125vw 4.6875vw;\n  }\n  .general-info .general-info__content-logo {\n    width: 13.125vw;\n    height: 2.9688vw;\n    margin-bottom: 1.5625vw;\n  }\n  .general-info .general-info__content-list {\n    max-width: 30.4688vw;\n  }\n  .general-info .general-info__content-list .list {\n    grid-gap: 2.5vw 2.7344vw;\n  }\n  .general-info .general-info__content-list .item .item-title {\n    letter-spacing: -0.0234vw;\n    font-size: 2.3438vw;\n    margin-bottom: 0.625vw;\n  }\n  .general-info .general-info__content-list .item .item-subtitle {\n    max-width: 13.6719vw;\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .general-info .general-info__content-button {\n    margin-top: 3.0469vw;\n  }\n  .general-info .general-info__image {\n    max-width: 36.7188vw;\n    height: 24.2188vw;\n    border-radius: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-info .container {\n    padding: 0;\n  }\n  .general-info .general-info__wrapper {\n    border-radius: 6.1538vw;\n    padding: 5.3846vw 5.1282vw 7.9487vw;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n  }\n  .general-info .general-info__content-logo {\n    width: 47.6923vw;\n    height: 10.7692vw;\n    margin-bottom: 6.1538vw;\n  }\n  .general-info .general-info__content-list {\n    width: 100%;\n    max-width: 126.9231vw;\n  }\n  .general-info .general-info__content-list .list {\n    -ms-grid-columns: 1fr 8.9744vw 1fr;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 6.1538vw 8.9744vw;\n  }\n  .general-info .general-info__content-list .item .item-title {\n    letter-spacing: -0.0718vw;\n    font-size: 7.1795vw;\n    margin-bottom: 0.7692vw;\n  }\n  .general-info .general-info__content-list .item .item-subtitle {\n    max-width: 100%;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .general-info .general-info__content-button {\n    margin-top: 9.7436vw;\n  }\n  .general-info .general-info__image {\n    max-width: 100%;\n    height: 58.9744vw;\n    border-radius: 4.1026vw;\n    margin-bottom: 6.1538vw;\n  }\n}\n.general-testimonial {\n  -webkit-box-ordinal-group: 2;\n  -ms-flex-order: 1;\n  order: 1;\n}\n.general-testimonial .general-testimonial__wrapper {\n  border-radius: 24px;\n  background-color: var(--yellow);\n  padding: 114px 156px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.general-testimonial .general-testimonial__image {\n  width: 200px;\n  height: 300px;\n  border-radius: 18px;\n  overflow: hidden;\n}\n.general-testimonial .general-testimonial__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.general-testimonial .general-testimonial__content {\n  width: 100%;\n  max-width: 678px;\n}\n.general-testimonial .general-testimonial__content-text {\n  font-weight: 400;\n  line-height: 1.4;\n  font-size: 28px;\n  letter-spacing: -0.5px;\n  color: var(--dark);\n}\n.general-testimonial .general-testimonial__content-button {\n  display: inline-block;\n  margin-top: 15px;\n}\n.general-testimonial .general-testimonial__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.general-testimonial .general-testimonial__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.general-testimonial .general-testimonial__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .general-testimonial .general-testimonial__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .general-testimonial .general-testimonial__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .general-testimonial .general-testimonial__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .general-testimonial .general-testimonial__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .general-testimonial .general-testimonial__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .general-testimonial .general-testimonial__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-testimonial .general-testimonial__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .general-testimonial .general-testimonial__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-testimonial .general-testimonial__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .general-testimonial .general-testimonial__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .general-testimonial .general-testimonial__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.general-testimonial .general-testimonial__content-footer {\n  margin-top: 90px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.general-testimonial .general-testimonial__content-info {\n  width: 100%;\n  max-width: 365px;\n}\n.general-testimonial .general-testimonial__content-info-name {\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  color: var(--dark);\n  font-size: 20px;\n}\n.general-testimonial .general-testimonial__content-info-position {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.33px;\n  font-size: 16px;\n  color: var(--dark);\n}\n.general-testimonial .general-testimonial__content-logo {\n  width: 147px;\n  height: 23px;\n}\n.general-testimonial .general-testimonial__content-logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .general-testimonial .general-testimonial__wrapper {\n    border-radius: 1.8045vw;\n    padding: 8.5714vw 11.7293vw;\n  }\n  .general-testimonial .general-testimonial__image {\n    width: 15.0376vw;\n    height: 22.5564vw;\n    border-radius: 1.3534vw;\n  }\n  .general-testimonial .general-testimonial__content {\n    max-width: 50.9774vw;\n  }\n  .general-testimonial .general-testimonial__content-text {\n    font-size: 2.1053vw;\n    letter-spacing: -0.0376vw;\n  }\n  .general-testimonial .general-testimonial__content-button {\n    margin-top: 1.1278vw;\n  }\n  .general-testimonial .general-testimonial__content-footer {\n    margin-top: 6.7669vw;\n  }\n  .general-testimonial .general-testimonial__content-info {\n    max-width: 27.4436vw;\n  }\n  .general-testimonial .general-testimonial__content-info-name {\n    letter-spacing: -0.015vw;\n    font-size: 1.5038vw;\n  }\n  .general-testimonial .general-testimonial__content-info-position {\n    letter-spacing: -0.0248vw;\n    font-size: 1.203vw;\n  }\n  .general-testimonial .general-testimonial__content-logo {\n    width: 11.0526vw;\n    height: 1.7293vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .general-testimonial .general-testimonial__wrapper {\n    border-radius: 1.875vw;\n    padding: 7.0313vw;\n  }\n  .general-testimonial .general-testimonial__image {\n    width: 15.625vw;\n    height: 23.4375vw;\n    border-radius: 1.4063vw;\n  }\n  .general-testimonial .general-testimonial__content {\n    max-width: 47.8906vw;\n  }\n  .general-testimonial .general-testimonial__content-text {\n    font-size: 1.5625vw;\n    letter-spacing: -0.0156vw;\n  }\n  .general-testimonial .general-testimonial__content-button {\n    margin-top: 1.0938vw;\n  }\n  .general-testimonial .general-testimonial__content-footer {\n    margin-top: 9.9219vw;\n  }\n  .general-testimonial .general-testimonial__content-info {\n    max-width: 26.5625vw;\n  }\n  .general-testimonial .general-testimonial__content-info-name {\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n  }\n  .general-testimonial .general-testimonial__content-info-position {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n  .general-testimonial .general-testimonial__content-logo {\n    width: 9.375vw;\n    height: auto;\n  }\n}\n@media screen and (max-width: 850px) {\n  .general-testimonial .general-testimonial__wrapper {\n    border-radius: 4.1026vw;\n    padding: 6.1538vw 6.1538vw 9.2308vw;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .general-testimonial .general-testimonial__image {\n    width: 25.1282vw;\n    height: 37.9487vw;\n    border-radius: 4.1026vw;\n    margin-top: 15.3846vw;\n  }\n  .general-testimonial .general-testimonial__content {\n    max-width: 100%;\n  }\n  .general-testimonial .general-testimonial__content-text {\n    font-size: 5.641vw;\n    letter-spacing: -0.0564vw;\n  }\n  .general-testimonial .general-testimonial__content-button {\n    margin-top: 7.1795vw;\n  }\n  .general-testimonial .general-testimonial__content-footer {\n    margin-top: 4.1026vw;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .general-testimonial .general-testimonial__content-info {\n    max-width: 100%;\n  }\n  .general-testimonial .general-testimonial__content-info-name {\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n  }\n  .general-testimonial .general-testimonial__content-info-position {\n    letter-spacing: -0.0359vw;\n    font-size: 3.5897vw;\n  }\n  .general-testimonial .general-testimonial__content-logo {\n    width: 37.6923vw;\n    height: 5.8974vw;\n    margin-top: 9.2308vw;\n  }\n}\n.lobby-header .lobby-header__inner {\n  padding: 104px 0 40px;\n}\n.lobby-header .lobby-header__title {\n  text-align: center;\n  margin-bottom: 36px;\n}\n.lobby-header .lobby-header__title h1 {\n  font-weight: 700;\n  font-family: \"Cambon\";\n  line-height: 1.2;\n  letter-spacing: -0.56px;\n  font-size: 56px;\n  color: var(--dark);\n}\n.lobby-header .lobby-header__subtitle {\n  text-align: center;\n  margin-bottom: 88px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  font-size: 20px;\n  color: var(--dark);\n}\n.lobby-header .lobby-header__wrapper {\n  width: 100%;\n  background: var(--light-gray);\n  border-radius: 24px;\n  overflow: hidden;\n  padding: 80px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.lobby-header .lobby-header__content {\n  width: 100%;\n  max-width: 428px;\n  margin-top: 7px;\n}\n.lobby-header .lobby-header__content-title {\n  margin-bottom: 28px;\n}\n.lobby-header .lobby-header__content-title h3 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  font-size: 40px;\n  color: var(--dark);\n}\n.lobby-header .lobby-header__content-text {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 20px;\n  color: var(--gray);\n  margin-bottom: 32px;\n}\n.lobby-header .lobby-header__content-button {\n  display: inline-block;\n}\n.lobby-header .lobby-header__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.lobby-header .lobby-header__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.lobby-header .lobby-header__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .lobby-header .lobby-header__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .lobby-header .lobby-header__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .lobby-header .lobby-header__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .lobby-header .lobby-header__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .lobby-header .lobby-header__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .lobby-header .lobby-header__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .lobby-header .lobby-header__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .lobby-header .lobby-header__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .lobby-header .lobby-header__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .lobby-header .lobby-header__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .lobby-header .lobby-header__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.lobby-header .lobby-header__content-info {\n  margin-top: 30px;\n  padding-top: 13px;\n  border-top: 1px solid var(--white-2);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.lobby-header .lobby-header__content-info-autor {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n  font-size: 14px;\n  color: var(--beige-3);\n  padding-right: 13px;\n  margin-right: 8px;\n  position: relative;\n  z-index: 2;\n}\n.lobby-header .lobby-header__content-info-autor::before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  right: 0;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--beige-3);\n}\n.lobby-header .lobby-header__content-info-data {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n  font-size: 14px;\n  color: var(--beige-3);\n}\n.lobby-header .lobby-header__image {\n  width: 100%;\n  max-width: 570px;\n  height: 400px;\n  border-radius: 18px;\n  overflow: hidden;\n}\n.lobby-header .lobby-header__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media screen and (max-width: 1330px) {\n  .lobby-header .lobby-header__inner {\n    padding: 7.8195vw 0 3.0075vw;\n  }\n  .lobby-header .lobby-header__title {\n    margin-bottom: 2.7068vw;\n  }\n  .lobby-header .lobby-header__title h1 {\n    letter-spacing: -0.0421vw;\n    font-size: 4.2105vw;\n  }\n  .lobby-header .lobby-header__subtitle {\n    margin-bottom: 6.6165vw;\n    letter-spacing: -0.015vw;\n    font-size: 1.5038vw;\n  }\n  .lobby-header .lobby-header__wrapper {\n    border-radius: 1.8045vw;\n    padding: 6.015vw;\n  }\n  .lobby-header .lobby-header__content {\n    max-width: 32.1805vw;\n    margin-top: 0.5263vw;\n  }\n  .lobby-header .lobby-header__content-title {\n    margin-bottom: 2.1053vw;\n  }\n  .lobby-header .lobby-header__content-title h3 {\n    letter-spacing: -0.0301vw;\n    font-size: 3.0075vw;\n  }\n  .lobby-header .lobby-header__content-text {\n    letter-spacing: -0.0301vw;\n    font-size: 1.5038vw;\n    margin-bottom: 2.406vw;\n  }\n  .lobby-header .lobby-header__content-info {\n    margin-top: 2.2556vw;\n    padding-top: 0.9774vw;\n  }\n  .lobby-header .lobby-header__content-info-autor {\n    letter-spacing: -0.0105vw;\n    font-size: 1.0526vw;\n    padding-right: 0.9774vw;\n    margin-right: 0.6015vw;\n  }\n  .lobby-header .lobby-header__content-info-autor::before {\n    top: 0.6015vw;\n    width: 0.3008vw;\n    height: 0.3008vw;\n  }\n  .lobby-header .lobby-header__content-info-data {\n    letter-spacing: -0.0105vw;\n    font-size: 1.0526vw;\n  }\n  .lobby-header .lobby-header__image {\n    max-width: 42.8571vw;\n    height: 30.0752vw;\n    border-radius: 1.3534vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .lobby-header .lobby-header__inner {\n    padding: 6.5625vw 0 3.125vw;\n  }\n  .lobby-header .lobby-header__title {\n    margin-bottom: 1.5625vw;\n  }\n  .lobby-header .lobby-header__title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0328vw;\n    font-size: 3.2813vw;\n  }\n  .lobby-header .lobby-header__subtitle {\n    margin-bottom: 6.3281vw;\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n  }\n  .lobby-header .lobby-header__wrapper {\n    border-radius: 1.875vw;\n    padding: 5.3125vw 4.6875vw 3.9063vw;\n  }\n  .lobby-header .lobby-header__content {\n    max-width: 28.9063vw;\n    margin-top: 0.3125vw;\n  }\n  .lobby-header .lobby-header__content-title {\n    margin-bottom: 2.3438vw;\n  }\n  .lobby-header .lobby-header__content-title h3 {\n    letter-spacing: -0.0234vw;\n    font-size: 2.3438vw;\n  }\n  .lobby-header .lobby-header__content-text {\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n    margin-bottom: 1.875vw;\n  }\n  .lobby-header .lobby-header__content-info {\n    margin-top: 2.5vw;\n    padding-top: 0.9375vw;\n  }\n  .lobby-header .lobby-header__content-info-autor {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n    padding-right: 1.0156vw;\n    margin-right: 0.625vw;\n  }\n  .lobby-header .lobby-header__content-info-autor::before {\n    top: 0.625vw;\n    width: 0.3125vw;\n    height: 0.3125vw;\n  }\n  .lobby-header .lobby-header__content-info-data {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n  }\n  .lobby-header .lobby-header__image {\n    max-width: 36.7188vw;\n    height: 25.7813vw;\n    border-radius: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .lobby-header .container {\n    padding: 0;\n  }\n  .lobby-header .lobby-header__inner {\n    padding: 12.308vw 0 7.692vw;\n  }\n  .lobby-header .lobby-header__title {\n    margin-bottom: 10.256vw;\n  }\n  .lobby-header .lobby-header__title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.092vw;\n    font-size: 9.231vw;\n  }\n  .lobby-header .lobby-header__subtitle {\n    width: 100%;\n    max-width: 76.9231vw;\n    margin: 0 auto;\n    margin-bottom: 10.2564vw;\n    letter-spacing: -0.0513vw;\n    font-size: 4.6154vw;\n  }\n  .lobby-header .lobby-header__wrapper {\n    border-radius: 6.154vw;\n    padding: 5.128vw 5.128vw 6.154vw;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n  }\n  .lobby-header .lobby-header__content {\n    max-width: 100%;\n    margin-top: 0;\n  }\n  .lobby-header .lobby-header__content-title {\n    margin-bottom: 6.154vw;\n  }\n  .lobby-header .lobby-header__content-title h3 {\n    letter-spacing: -0.051vw;\n    font-size: 7.179vw;\n  }\n  .lobby-header .lobby-header__content-text {\n    width: 100%;\n    letter-spacing: -0.051vw;\n    font-size: 5.128vw;\n    margin-bottom: 7.692vw;\n  }\n  .lobby-header .lobby-header__content-info {\n    margin-top: 8.205vw;\n    padding-top: 3.333vw;\n  }\n  .lobby-header .lobby-header__content-info-autor {\n    letter-spacing: -0.036vw;\n    font-size: 3.59vw;\n    padding-right: 3.333vw;\n    margin-right: 2.051vw;\n  }\n  .lobby-header .lobby-header__content-info-autor::before {\n    top: 2.051vw;\n    width: 1.026vw;\n    height: 1.026vw;\n  }\n  .lobby-header .lobby-header__content-info-data {\n    letter-spacing: -0.036vw;\n    font-size: 3.59vw;\n  }\n  .lobby-header .lobby-header__image {\n    width: 100%;\n    max-width: 100%;\n    height: 63.077vw;\n    border-radius: 4.103vw;\n    overflow: hidden;\n    margin-bottom: 5.128vw;\n  }\n}\n.lobby-list .list {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 40px 30px;\n}\n.lobby-list .card {\n  border: 1px solid var(--white-2);\n  position: relative;\n  z-index: 2;\n  padding: 6px 6px 123px 6px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n}\n.lobby-list .card:hover {\n  -webkit-box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),\n    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),\n    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),\n    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),\n    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),\n    0px 100px 80px 0px rgba(0, 0, 0, 0.05);\n  box-shadow: 0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.01),\n    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),\n    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),\n    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),\n    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),\n    0px 100px 80px 0px rgba(0, 0, 0, 0.05);\n}\n.lobby-list .card:hover .card-content__button::after {\n  width: 100%;\n}\n.lobby-list .card .card-content {\n  padding: 0 26px 0;\n  margin-bottom: 0;\n}\n.lobby-list .card .card-content__button {\n  position: absolute;\n  z-index: 2;\n  left: 30px;\n  bottom: 95px;\n}\n.lobby-list .card .card-content__button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.lobby-list .card .card-content__button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.lobby-list .card .card-content__button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .lobby-list .card .card-content__button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .lobby-list .card .card-content__button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .lobby-list .card .card-content__button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .lobby-list .card .card-content__button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .lobby-list .card .card-content__button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .lobby-list .card .card-content__button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .lobby-list .card .card-content__button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .lobby-list .card .card-content__button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .lobby-list .card .card-content__button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .lobby-list .card .card-content__button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .lobby-list .card .card-content__button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.lobby-list .card .card-content__footer {\n  position: absolute;\n  left: 32px;\n  z-index: 2;\n  bottom: 31px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding-top: 13px;\n  width: 100%;\n  max-width: 346px;\n  border-top: 1px solid var(--white-2);\n}\n.lobby-list .card .card-content__footer-autor {\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n  font-size: 14px;\n  color: var(--beige-3);\n  position: relative;\n  z-index: 2;\n  padding-right: 13px;\n  margin-right: 8px;\n}\n.lobby-list .card .card-content__footer-autor::before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  right: 0;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background-color: var(--beige-3);\n}\n.lobby-list .card .card-content__footer-data {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n  font-size: 14px;\n  color: var(--beige-3);\n}\n\n@media screen and (max-width: 1330px) {\n  .lobby-list .list {\n    grid-gap: 3.0075vw 2.2556vw;\n  }\n  .lobby-list .card {\n    padding: 0.4511vw 0.4511vw 9.2481vw 0.4511vw;\n  }\n  .lobby-list .card:hover {\n    -webkit-box-shadow: 0px 0.2256vw 0.1504vw 0px rgba(0, 0, 0, 0.01),\n      0px 0.5263vw 0.3759vw 0px rgba(0, 0, 0, 0.02),\n      0px 0.9023vw 0.7519vw 0px rgba(0, 0, 0, 0.03),\n      0px 1.6541vw 1.2782vw 0px rgba(0, 0, 0, 0.03),\n      0px 3.1579vw 2.4812vw 0px rgba(0, 0, 0, 0.04),\n      0px 7.5188vw 6.015vw 0px rgba(0, 0, 0, 0.05);\n    box-shadow: 0px 0.2256vw 0.1504vw 0px rgba(0, 0, 0, 0.01),\n      0px 0.5263vw 0.3759vw 0px rgba(0, 0, 0, 0.02),\n      0px 0.9023vw 0.7519vw 0px rgba(0, 0, 0, 0.03),\n      0px 1.6541vw 1.2782vw 0px rgba(0, 0, 0, 0.03),\n      0px 3.1579vw 2.4812vw 0px rgba(0, 0, 0, 0.04),\n      0px 7.5188vw 6.015vw 0px rgba(0, 0, 0, 0.05);\n  }\n  .lobby-list .card .card-content {\n    padding: 0 1.9549vw 0;\n  }\n  .lobby-list .card .card-content__button {\n    left: 2.2556vw;\n    bottom: 7.1429vw;\n  }\n  .lobby-list .card .card-content__footer {\n    left: 2.406vw;\n    bottom: 2.3308vw;\n    padding-top: 0.9774vw;\n    max-width: 26.015vw;\n  }\n  .lobby-list .card .card-content__footer-autor {\n    letter-spacing: -0.0105vw;\n    font-size: 1.0526vw;\n    padding-right: 0.9774vw;\n    margin-right: 0.6015vw;\n  }\n  .lobby-list .card .card-content__footer-autor::before {\n    top: 0.6015vw;\n    width: 0.3008vw;\n    height: 0.3008vw;\n  }\n  .lobby-list .card .card-content__footer-data {\n    letter-spacing: -0.0105vw;\n    font-size: 1.0526vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .lobby-list .list {\n    grid-gap: 3.125vw 2.3438vw;\n  }\n  .lobby-list .card {\n    padding: 0.4688vw 0.4688vw 9.6094vw 0.4688vw;\n  }\n  .lobby-list .card:hover {\n    -webkit-box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),\n      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),\n      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),\n      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),\n      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),\n      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);\n    box-shadow: 0px 0.2344vw 0.1563vw 0px rgba(0, 0, 0, 0.01),\n      0px 0.5469vw 0.3906vw 0px rgba(0, 0, 0, 0.02),\n      0px 0.9375vw 0.7813vw 0px rgba(0, 0, 0, 0.03),\n      0px 1.7188vw 1.4063vw 0px rgba(0, 0, 0, 0.03),\n      0px 3.2813vw 2.5781vw 0px rgba(0, 0, 0, 0.04),\n      0px 7.8125vw 6.25vw 0px rgba(0, 0, 0, 0.05);\n  }\n  .lobby-list .card .card-content {\n    padding: 0 1.3281vw 0;\n  }\n  .lobby-list .card .card-content__button {\n    left: 1.7969vw;\n    bottom: 7.0313vw;\n  }\n  .lobby-list .card .card-content__footer {\n    left: 1.7969vw;\n    bottom: 1.7969vw;\n    padding-top: 1.0156vw;\n    max-width: 22.1094vw;\n  }\n  .lobby-list .card .card-content__footer-autor {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n    padding-right: 1.0156vw;\n    margin-right: 0.625vw;\n  }\n  .lobby-list .card .card-content__footer-autor::before {\n    top: 0.625vw;\n    width: 0.3125vw;\n    height: 0.3125vw;\n  }\n  .lobby-list .card .card-content__footer-data {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .lobby-list .list {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 7.692vw;\n  }\n  .lobby-list .card {\n    padding: 1.538vw 1.538vw 6.154vw 1.538vw;\n  }\n  .lobby-list .card:hover {\n    -webkit-box-shadow: 0px 0.71vw 0.568vw 0px rgba(0, 0, 0, 0.01),\n      0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),\n      0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),\n      0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),\n      0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),\n      0px 100px 80px 0px rgba(0, 0, 0, 0.05);\n    box-shadow: 0px 0.71vw 0.568vw 0px rgba(0, 0, 0, 0.01),\n      0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.02),\n      0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.03),\n      0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.03),\n      0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.04),\n      0px 100px 80px 0px rgba(0, 0, 0, 0.05);\n  }\n  .lobby-list .card .card-content {\n    padding: 0 6.154vw 0;\n    margin-bottom: 0;\n    margin-top: 6.154vw;\n  }\n  .lobby-list .card .card-content__button {\n    position: relative;\n    margin-bottom: 8.205vw;\n    left: auto;\n    bottom: auto;\n  }\n  .lobby-list .card .card-content__footer {\n    position: relative;\n    left: auto;\n    bottom: auto;\n    padding-top: 3.333vw;\n    max-width: 100%;\n  }\n  .lobby-list .card .card-content__footer-autor {\n    letter-spacing: -0.036vw;\n    font-size: 3.59vw;\n    padding-right: 3.333vw;\n    margin-right: 2.051vw;\n  }\n  .lobby-list .card .card-content__footer-autor::before {\n    top: 2.051vw;\n    width: 1.026vw;\n    height: 1.026vw;\n  }\n  .lobby-list .card .card-content__footer-data {\n    letter-spacing: -0.036vw;\n    font-size: 3.59vw;\n  }\n}\n.blog-single-first-screen {\n  position: relative;\n  z-index: 2;\n}\n.blog-single-first-screen::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 127px);\n  z-index: -1;\n}\n.blog-single-first-screen.default-color::before {\n  background-color: #f6f5ef;\n}\n.blog-single-first-screen.bg-color-1::before {\n  background-color: #ffdebf;\n}\n.blog-single-first-screen.bg-color-2::before {\n  background-color: #fff2e5;\n}\n.blog-single-first-screen.bg-color-3::before {\n  background-color: #ffc2d6;\n}\n.blog-single-first-screen.bg-color-4::before {\n  background-color: #ffe7ef;\n}\n.blog-single-first-screen.bg-color-5::before {\n  background-color: #e3bfff;\n}\n.blog-single-first-screen.bg-color-6::before {\n  background-color: #f4e5ff;\n}\n.blog-single-first-screen.bg-color-7::before {\n  background-color: #b8dfd7;\n}\n.blog-single-first-screen.bg-color-8::before {\n  background-color: #e7f6eb;\n}\n.blog-single-first-screen.bg-color-9::before {\n  background-color: #b1e1f5;\n}\n.blog-single-first-screen.bg-color-10::before {\n  background-color: #e0f3fb;\n}\n.blog-single-first-screen .blog-single-first-screen__inner {\n  padding-top: 100px;\n}\n.blog-single-first-screen .blog-single-first-screen__header {\n  margin-bottom: 76px;\n}\n.blog-single-first-screen .blog-single-first-screen__header-title {\n  width: 100%;\n  max-width: 815px;\n  margin: 0 auto 24px;\n  text-align: center;\n}\n.blog-single-first-screen .blog-single-first-screen__header-title h2 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  font-size: 48px;\n  letter-spacing: -0.48px;\n  color: var(--dark);\n}\n.blog-single-first-screen .blog-single-first-screen__header-info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.blog-single-first-screen .blog-single-first-screen__header-autor,\n.blog-single-first-screen .blog-single-first-screen__header-date,\n.blog-single-first-screen .blog-single-first-screen__header-time {\n  color: var(--gray-2);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n}\n.blog-single-first-screen .blog-single-first-screen__header-autor,\n.blog-single-first-screen .blog-single-first-screen__header-date {\n  padding-right: 13px;\n  margin-right: 8px;\n  position: relative;\n  z-index: 2;\n}\n.blog-single-first-screen .blog-single-first-screen__header-autor::before,\n.blog-single-first-screen .blog-single-first-screen__header-date::before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  right: 0;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--beige-3);\n}\n.blog-single-first-screen .blog-single-first-screen__image {\n  width: 100%;\n  max-width: 780px;\n  height: 470px;\n  margin: 0 auto;\n  border-radius: 24px;\n  overflow: hidden;\n}\n.blog-single-first-screen .blog-single-first-screen__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media screen and (max-width: 1330px) {\n  .blog-single-first-screen::before {\n    height: calc(100% - 9.5489vw);\n  }\n  .blog-single-first-screen .blog-single-first-screen__inner {\n    padding-top: 7.5188vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header {\n    margin-bottom: 5.7143vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-title {\n    max-width: 61.2782vw;\n    margin: 0 auto 1.8045vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-title h2 {\n    font-size: 3.609vw;\n    letter-spacing: -0.0361vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-autor,\n  .blog-single-first-screen .blog-single-first-screen__header-date,\n  .blog-single-first-screen .blog-single-first-screen__header-time {\n    font-size: 1.0526vw;\n    letter-spacing: -0.0105vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-autor,\n  .blog-single-first-screen .blog-single-first-screen__header-date {\n    padding-right: 0.9774vw;\n    margin-right: 0.6015vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-autor::before,\n  .blog-single-first-screen .blog-single-first-screen__header-date::before {\n    top: 0.6015vw;\n    width: 0.3008vw;\n    height: 0.3008vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__image {\n    max-width: 58.6466vw;\n    height: 35.3383vw;\n    border-radius: 1.8045vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .blog-single-first-screen::before {\n    height: calc(100% - 17.179vw);\n  }\n  .blog-single-first-screen .blog-single-first-screen__inner {\n    padding-top: 12.308vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header {\n    margin-bottom: 11.282vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-title {\n    max-width: 100%;\n    margin: 0 auto 6.154vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-title h2 {\n    font-size: 8.205vw;\n    letter-spacing: -0.082vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-autor,\n  .blog-single-first-screen .blog-single-first-screen__header-date,\n  .blog-single-first-screen .blog-single-first-screen__header-time {\n    font-size: 3.59vw;\n    letter-spacing: -0.036vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-autor,\n  .blog-single-first-screen .blog-single-first-screen__header-date {\n    padding-right: 3.333vw;\n    margin-right: 2.051vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__header-autor::before,\n  .blog-single-first-screen .blog-single-first-screen__header-date::before {\n    top: 2.051vw;\n    right: 0;\n    width: 1.026vw;\n    height: 1.026vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__image {\n    width: 100%;\n    max-width: 89.744vw;\n    height: 53.846vw;\n    border-radius: 4.103vw;\n  }\n  .blog-single-first-screen .blog-single-first-screen__image img {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n  }\n}\n.blog-single-article .blog-single-article__inner {\n  padding: 80px 0 178px;\n}\n.blog-single-article .blog-single-article__content {\n  width: 100%;\n  max-width: 780px;\n  margin: 0 auto;\n}\n\n@media screen and (max-width: 1330px) {\n  .blog-single-article .blog-single-article__inner {\n    padding: 6.015vw 0 13.3835vw;\n  }\n  .blog-single-article .blog-single-article__content {\n    max-width: 58.6466vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .blog-single-article .blog-single-article__inner {\n    padding: 10.2564vw 0 33.3333vw;\n  }\n  .blog-single-article .blog-single-article__content {\n    max-width: 100%;\n  }\n}\n.section-thanks {\n  background-color: var(--light-gray);\n  padding: 124px 0 522px 0;\n}\n.section-thanks__content {\n  max-width: 988px;\n  width: 100%;\n  margin: 0 auto;\n  background-color: var(--white);\n  border-radius: 24px;\n  padding: 62px 245px 104px 245px;\n  position: relative;\n}\n.section-thanks__content-title {\n  color: var(--dark);\n  text-align: center;\n  font-family: \"Cambon\";\n  font-size: 56px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n  letter-spacing: -0.56px;\n  margin-bottom: 30px;\n}\n.section-thanks__content-subtitle {\n  color: var(--dark);\n  text-align: center;\n  font-family: \"Circular Std\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.2px;\n  margin: 0 auto 69px auto;\n  max-width: 70%;\n}\n.section-thanks__content-link {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.section-thanks__content-link a {\n  font-weight: 400;\n  line-height: 1.4;\n  font-size: 18px;\n  letter-spacing: -0.18px;\n  color: var(--dark);\n  padding-bottom: 5px;\n  -webkit-text-decoration: underline 2px;\n  text-decoration: underline 2px;\n  text-underline-offset: 5px;\n  position: relative;\n  z-index: 2;\n  padding-right: 27px;\n}\n.section-thanks__content-link a::before {\n  content: \"\";\n  position: absolute;\n  top: 0px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23161616' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.414L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.section-thanks__content-img {\n  position: absolute;\n  bottom: -68px;\n  right: 216px;\n  width: 113px;\n  height: 117px;\n}\n.section-thanks__content-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .section-thanks {\n    padding: 9.323vw 0 39.248vw 0;\n  }\n  .section-thanks__content {\n    max-width: 74.286vw;\n    border-radius: 1.805vw;\n    padding: 4.662vw 18.421vw 7.82vw 18.421vw;\n  }\n  .section-thanks__content-title {\n    font-size: 4.211vw;\n    margin-bottom: 30zpx;\n  }\n  .section-thanks__content-subtitle {\n    font-size: 1.504vw;\n    margin: 0 auto 5.188vw auto;\n  }\n  .section-thanks__content-link a {\n    font-size: 1.3534vw;\n    letter-spacing: -0.0135vw;\n    padding-bottom: 0.3759vw;\n    -webkit-text-decoration: underline 0.1504vw;\n    text-decoration: underline 0.1504vw;\n    text-underline-offset: 0.3759vw;\n    padding-right: 2.0301vw;\n  }\n  .section-thanks__content-link a::before {\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .section-thanks__content-img {\n    bottom: -5.113vw;\n    right: 16.241vw;\n    width: 8.496vw;\n    height: 8.797vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .section-thanks {\n    padding: 9.323vw 0 22.248vw 0;\n  }\n}\n@media screen and (max-width: 850px) {\n  .section-thanks {\n    padding: 13.846vw 0 41.282vw 0;\n  }\n  .section-thanks__content {\n    max-width: 100%;\n    border-radius: 4.615vw;\n    padding: 13.333vw 6.154vw 25.769vw 6.154vw;\n  }\n  .section-thanks__content-title {\n    font-size: 9.231vw;\n    margin-bottom: 7.692vw;\n  }\n  .section-thanks__content-subtitle {\n    font-size: 4.615vw;\n    margin: 0 auto 12.564vw auto;\n    max-width: 100%;\n  }\n  .section-thanks__content-link {\n    max-width: 51.282vw;\n    margin: 0 auto;\n  }\n  .section-thanks__content-link a {\n    font-size: 4.1026vw;\n    letter-spacing: -0.041vw;\n    -webkit-text-decoration: underline 1px;\n    text-decoration: underline 1px;\n    text-underline-offset: 1.2821vw;\n    padding-right: 6.9231vw;\n  }\n  .section-thanks__content-link a::before {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .section-thanks__content-img {\n    position: absolute;\n    bottom: -18.718vw;\n    right: 50%;\n    -webkit-transform: translateX(50%);\n    transform: translateX(50%);\n    width: 28.974vw;\n    height: 30vw;\n  }\n}\n.first-screen-integrations {\n  padding: 0 30px;\n}\n.first-screen-integrations .first-screen-integrations__inner {\n  background-color: var(--light-gray);\n  border-radius: 0 0 24px 24px;\n  overflow: hidden;\n  padding: 105px 0;\n}\n.first-screen-integrations .first-screen-integrations__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.first-screen-integrations .first-screen-integrations__content {\n  width: 100%;\n  max-width: 630px;\n}\n.first-screen-integrations .first-screen-integrations__content-label {\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n  text-transform: uppercase;\n  font-size: 14px;\n  color: var(--dark);\n  margin-bottom: 16px;\n}\n.first-screen-integrations .first-screen-integrations__content-title {\n  margin-bottom: 17px;\n}\n.first-screen-integrations .first-screen-integrations__content-title h1 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.56px;\n  font-size: 56px;\n  color: var(--dark);\n}\n.first-screen-integrations .first-screen-integrations__content-text {\n  width: 100%;\n  max-width: 530px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  font-size: 20px;\n  color: var(--dark);\n}\n.first-screen-integrations .first-screen-integrations__content-button {\n  margin-top: 32px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 16px;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.first-screen-integrations .first-screen-integrations__media {\n  width: 100%;\n  max-width: 579px;\n  height: 540px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 2;\n  margin-right: 52px;\n}\n.first-screen-integrations .first-screen-integrations__media-img {\n  width: 100%;\n  height: 100%;\n}\n.first-screen-integrations .first-screen-integrations__media-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .first-screen-integrations {\n    padding: 0 2.256vw;\n  }\n  .first-screen-integrations .first-screen-integrations__inner {\n    border-radius: 0 0 1.805vw 1.805vw;\n    padding: 7.895vw 0;\n  }\n  .first-screen-integrations .first-screen-integrations__content {\n    max-width: 47.368vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-label {\n    font-size: 1.053vw;\n    margin-bottom: 1.203vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-title {\n    margin-bottom: 1.278vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-title h1 {\n    font-size: 4.211vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-text {\n    max-width: 39.85vw;\n    font-size: 1.504vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-button {\n    margin-top: 2.406vw;\n    gap: 1.203vw;\n  }\n  .first-screen-integrations .first-screen-integrations__media {\n    max-width: 43.534vw;\n    height: 40.602vw;\n    margin-right: 3.91vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .first-screen-integrations {\n    padding: 0 2.3438vw;\n  }\n  .first-screen-integrations .first-screen-integrations__inner {\n    border-radius: 0 0 1.875vw 1.875vw;\n    padding: 4.0625vw 0;\n  }\n  .first-screen-integrations .first-screen-integrations__content {\n    max-width: 38.2813vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-label {\n    letter-spacing: -0.0109vw;\n    font-size: 1.0938vw;\n    margin-bottom: 1.25vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-title {\n    margin-bottom: 1.875vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0328vw;\n    font-size: 3.2813vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-text {\n    max-width: 32.8125vw;\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-button {\n    margin-top: 2.5vw;\n    gap: 1.25vw;\n  }\n  .first-screen-integrations .first-screen-integrations__media {\n    max-width: 39.2188vw;\n    height: 37.1094vw;\n    margin-right: 0;\n  }\n}\n@media screen and (max-width: 850px) {\n  .first-screen-integrations {\n    padding: 0;\n  }\n  .first-screen-integrations .container {\n    padding: 0;\n  }\n  .first-screen-integrations .first-screen-integrations__inner {\n    border-radius: 4.1026vw;\n    padding: 12.0513vw 5.1282vw 11.795vw;\n  }\n  .first-screen-integrations .first-screen-integrations__wrapper {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 11.2821vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content {\n    max-width: 100%;\n  }\n  .first-screen-integrations .first-screen-integrations__content-title {\n    margin-bottom: 5.641vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-title h1 {\n    line-height: 1.1;\n    letter-spacing: -0.0923vw;\n    font-size: 9.2308vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-text {\n    max-width: 100%;\n    letter-spacing: -0.0769vw;\n    font-size: 4.6154vw;\n  }\n  .first-screen-integrations .first-screen-integrations__content-button {\n    margin-top: 6.1538vw;\n    gap: 4.103vw;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .first-screen-integrations .first-screen-integrations__media {\n    max-width: 100%;\n    height: 83.59vw;\n    margin-top: 0;\n    margin-right: 0;\n  }\n}\n.promo .promo__inner {\n  padding: 118px 0 188px 0;\n  border-bottom: 1px solid rgba(22, 22, 22, 0.1450980392);\n}\n.promo .promo__title {\n  margin: 0 auto 90px auto;\n  text-align: center;\n  max-width: 70%;\n}\n.promo .promo__title h2 {\n  color: var(--dark);\n  text-align: center;\n  font-family: \"Cambon\";\n  font-size: 48px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n  letter-spacing: -0.48px;\n}\n.promo .promo__card {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 170px;\n  padding-left: 55px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.promo .promo__card-media {\n  width: 520px;\n  height: auto;\n  position: relative;\n}\n.promo .promo__card-media-img {\n  width: 100%;\n}\n.promo .promo__card-media-img img {\n  width: 100%;\n  height: auto;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.promo .promo__card-media-dec {\n  position: absolute;\n  bottom: -52px;\n  right: 73px;\n  width: 204px;\n  height: 159.648px;\n}\n.promo .promo__card-media-dec img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.promo .promo__card-info {\n  width: 460px;\n}\n.promo .promo__card-title {\n  margin-bottom: 32px;\n}\n.promo .promo__card-title h2 {\n  color: var(--dark);\n  font-family: \"Cambon\";\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n  letter-spacing: -0.4px;\n}\n.promo .promo__card-text {\n  font-family: \"Circular Std\";\n  color: var(--dark);\n}\n.promo .promo__card-text p {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.2px;\n}\n.promo .promo__card-text ul {\n  margin-top: 32px;\n}\n.promo .promo__card-text ul li {\n  list-style-type: disc;\n  list-style-position: inside;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  /* 25.6px */\n  letter-spacing: -0.16px;\n}\n.promo .promo__card-button {\n  margin-top: 32px;\n}\n\n@media screen and (max-width: 1330px) {\n  .promo .promo__inner {\n    padding: 8.872vw 0 14.135vw 0;\n  }\n  .promo .promo__title {\n    margin: 0 auto 7.068vw auto;\n  }\n  .promo .promo__title h2 {\n    font-size: 3.609vw;\n    letter-spacing: -0.036vw;\n  }\n  .promo .promo__card {\n    gap: 12.782vw;\n    padding-left: 4.135vw;\n  }\n  .promo .promo__card-media {\n    width: 39.098vw;\n  }\n  .promo .promo__card-media-dec {\n    bottom: -3.91vw;\n    right: 5.489vw;\n    width: 15.338vw;\n    height: 12.004vw;\n  }\n  .promo .promo__card-info {\n    width: 34.586vw;\n  }\n  .promo .promo__card-title {\n    margin-bottom: 2.406vw;\n  }\n  .promo .promo__card-title h2 {\n    font-size: 3.008vw;\n    letter-spacing: -0.03vw;\n  }\n  .promo .promo__card-text p {\n    font-size: 1.504vw;\n    letter-spacing: -0.015vw;\n  }\n  .promo .promo__card-text ul {\n    margin-top: 2.406vw;\n  }\n  .promo .promo__card-text ul li {\n    font-size: 1.203vw;\n    letter-spacing: -0.012vw;\n  }\n  .promo .promo__card-button {\n    margin-top: 2.406vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .promo .promo__inner {\n    padding: 6.6406vw 0 8.0469vw 0;\n  }\n  .promo .promo__title {\n    margin: 0 auto 5.625vw auto;\n    max-width: 39.8438vw;\n  }\n  .promo .promo__title h2 {\n    font-size: 2.9688vw;\n    letter-spacing: -0.0297vw;\n  }\n  .promo .promo__card {\n    gap: 7.1094vw;\n    padding-left: 2.7344vw;\n  }\n  .promo .promo__card-media {\n    width: 34.375vw;\n    margin-top: -3.5156vw;\n  }\n  .promo .promo__card-media-dec {\n    position: absolute;\n    bottom: -2.8906vw;\n    right: 5.0781vw;\n    width: 12.8906vw;\n    height: 10.1563vw;\n  }\n  .promo .promo__card-info {\n    width: 34.375vw;\n  }\n  .promo .promo__card-title {\n    margin-bottom: 2.1875vw;\n  }\n  .promo .promo__card-title h2 {\n    font-size: 2.3438vw;\n    letter-spacing: -0.0234vw;\n  }\n  .promo .promo__card-text p {\n    font-size: 1.4063vw;\n    letter-spacing: -0.0141vw;\n  }\n  .promo .promo__card-text ul {\n    margin-top: 2.6563vw;\n  }\n  .promo .promo__card-text ul li {\n    font-size: 1.25vw;\n    line-height: 160%;\n    letter-spacing: -0.0125vw;\n  }\n  .promo .promo__card-button {\n    margin-top: 2.6563vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .promo .promo__inner {\n    padding: 15.385vw 0 14.359vw 0;\n  }\n  .promo .promo__title {\n    margin: 0 auto 8.205vw auto;\n    max-width: 100%;\n  }\n  .promo .promo__title h2 {\n    font-size: 8.205vw;\n    letter-spacing: -0.082vw;\n  }\n  .promo .promo__card {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 19.487vw;\n    padding-left: 0;\n  }\n  .promo .promo__card-media {\n    width: 100%;\n    margin-top: 0;\n  }\n  .promo .promo__card-media-dec {\n    bottom: -8.974vw;\n    right: 12.821vw;\n    width: 35.128vw;\n    height: 27.436vw;\n  }\n  .promo .promo__card-info {\n    width: 100%;\n  }\n  .promo .promo__card-title {\n    margin-bottom: 6.154vw;\n  }\n  .promo .promo__card-title h2 {\n    font-size: 7.179vw;\n    letter-spacing: -0.072vw;\n  }\n  .promo .promo__card-text p {\n    font-size: 4.615vw;\n    letter-spacing: -0.046vw;\n  }\n  .promo .promo__card-text ul {\n    margin-top: 6.154vw;\n    margin-left: 5.128vw;\n  }\n  .promo .promo__card-text ul li {\n    list-style-position: outside;\n    font-size: 4.103vw;\n    letter-spacing: -0.041vw;\n  }\n  .promo .promo__card-button {\n    margin-top: 8.205vw;\n  }\n}\n.apps .apps__inner {\n  padding-top: 90px;\n}\n.apps .apps__title {\n  margin: 0 auto 20px auto;\n  text-align: center;\n  max-width: 60%;\n}\n.apps .apps__title h2 {\n  color: var(--dark);\n  text-align: center;\n  font-family: \"Cambon\";\n  font-size: 48px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n  letter-spacing: -0.48px;\n}\n.apps .apps__subtitle {\n  margin: 0 auto 48px auto;\n  text-align: center;\n  max-width: 60%;\n  color: var(--dark);\n  font-family: \"Circular Std\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.2px;\n}\n.apps .apps__filter {\n  width: 100%;\n  max-width: 1050px;\n  margin: 0 auto 39px;\n  border-radius: 60px;\n  border: 1px solid var(--white-2);\n  background: var(--white);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 10px;\n}\n.apps .apps__filter button {\n  padding: 7px 20px;\n  font-family: \"Circular Std\";\n  font-weight: 400;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n  background-color: transparent;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  border-radius: 40px;\n}\n.apps .apps__filter button.active {\n  background-color: var(--dark);\n  color: var(--white);\n}\n.apps .apps__cards {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 38px 30px;\n}\n.apps .apps__cards .item {\n  background-color: var(--light-gray);\n  border-radius: 24px;\n  width: 100%;\n  color: var(--dark);\n}\n.apps .apps__cards .item-img {\n  margin: 8px 8px 24px;\n  background-color: var(--white);\n  border-radius: 18px;\n  height: 212px;\n  max-width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  position: relative;\n}\n.apps .apps__cards .item-img img {\n  display: block;\n  margin: auto;\n  max-width: 100%;\n  height: auto;\n}\n.apps .apps__cards .item-img .link_to_post {\n  width: 48px;\n  height: 48px;\n  background-color: var(--yellow);\n  border-radius: 50%;\n  display: none;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2200_67437)'%3E%3Cmask id='mask0_2200_67437' style='mask-type:luminance' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'%3E%3Cpath d='M0 24L24 24L24 0L0 0L0 24Z' fill='white'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_2200_67437)'%3E%3Cpath d='M6 17.9993L17.3684 6.63086' stroke='%23161616' stroke-width='2' stroke-linecap='square'/%3E%3Cpath d='M8.25 6L18 6V15.75' stroke='%23161616' stroke-width='2' stroke-linecap='square'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2200_67437'%3E%3Crect width='24' height='24' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A\");\n  background-position: center;\n  background-size: 24px 24px;\n  background-repeat: no-repeat;\n  opacity: 0;\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n  cursor: pointer;\n}\n.apps .apps__cards .item-img .link_to_post a {\n  width: 100%;\n  height: 100%;\n}\n.apps .apps__cards .item__content {\n  margin: 0 32px 38px 32px;\n}\n.apps .apps__cards .item-label {\n  display: inline-block;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  letter-spacing: -0.14px;\n  border-radius: 999px;\n  padding: 10px 16px;\n  background-color: var(--white);\n  margin-bottom: 16px;\n}\n.apps .apps__cards .item-title {\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 140%;\n  letter-spacing: -0.24px;\n  margin-bottom: 10px;\n}\n.apps .apps__cards .item-title span {\n  color: #8d8c89;\n}\n.apps .apps__cards .item-info {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.18px;\n}\n.apps .apps__cards .item:hover .link_to_post {\n  opacity: 1;\n}\n\n@media screen and (max-width: 1330px) {\n  .apps .apps__inner {\n    padding-top: 6.767vw;\n  }\n  .apps .apps__title {\n    margin: 0 auto 1.504vw auto;\n  }\n  .apps .apps__title h2 {\n    font-size: 3.609vw;\n    letter-spacing: -0.036vw;\n  }\n  .apps .apps__subtitle {\n    margin: 0 auto 3.609vw auto;\n    font-size: 1.504vw;\n    letter-spacing: -0.015vw;\n  }\n  .apps .apps__filter {\n    max-width: 78.9474vw;\n    margin: 0 auto 2.9323vw;\n    border-radius: 4.5113vw;\n    padding: 0.7519vw;\n  }\n  .apps .apps__filter button {\n    padding: 0.5263vw 1.5038vw;\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n    border-radius: 3.0075vw;\n  }\n  .apps .apps__cards {\n    grid-gap: 2.857vw 2.256vw;\n  }\n  .apps .apps__cards .item {\n    border-radius: 1.805vw;\n  }\n  .apps .apps__cards .item-img {\n    margin: 0.602vw 0.602vw 1.805vw;\n    border-radius: 1.353vw;\n    height: 15.94vw;\n  }\n  .apps .apps__cards .item-img .link_to_post {\n    width: 3.609vw;\n    height: 3.609vw;\n    top: 0.902vw;\n    right: 0.902vw;\n    background-size: 1.805vw 1.805vw;\n  }\n  .apps .apps__cards .item__content {\n    margin: 0 2.406vw 2.857vw 2.406vw;\n  }\n  .apps .apps__cards .item-label {\n    font-size: 1.053vw;\n    letter-spacing: -0.011vw;\n    padding: 0.752vw 1.203vw;\n    margin-bottom: 1.203vw;\n  }\n  .apps .apps__cards .item-title {\n    font-size: 1.805vw;\n    letter-spacing: -0.018vw;\n    margin-bottom: 0.752vw;\n  }\n  .apps .apps__cards .item-info {\n    font-size: 1.353vw;\n    letter-spacing: -0.014vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .apps .apps__inner {\n    padding-top: 7.8906vw;\n  }\n  .apps .apps__title {\n    margin: 0 auto 1.6406vw auto;\n    max-width: 43.4375vw;\n  }\n  .apps .apps__title h2 {\n    font-size: 2.9688vw;\n    letter-spacing: -0.0297vw;\n  }\n  .apps .apps__subtitle {\n    margin: 0 auto 3.75vw auto;\n    max-width: 53.9063vw;\n    font-size: 1.4063vw;\n    letter-spacing: -0.0141vw;\n  }\n  .apps .apps__filter {\n    max-width: 100%;\n    margin: 0 auto 3.125vw;\n    border-radius: 4.6875vw;\n    padding: 1.0938vw 1.1719vw;\n  }\n  .apps .apps__filter button {\n    padding: 0.5469vw 1.5625vw;\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n    border-radius: 3.125vw;\n  }\n  .apps .apps__cards {\n    grid-gap: 2.9688vw 2.3438vw;\n  }\n  .apps .apps__cards .item {\n    border-radius: 1.875vw;\n  }\n  .apps .apps__cards .item-img {\n    margin: 0.625vw 0.625vw 1.6406vw;\n    border-radius: 1.4063vw;\n    height: 13.2031vw;\n  }\n  .apps .apps__cards .item__content {\n    margin: 0 1.875vw 2.9688vw 1.875vw;\n  }\n  .apps .apps__cards .item-label {\n    font-size: 1.0938vw;\n    letter-spacing: -0.0109vw;\n    border-radius: 78.0469vw;\n    padding: 0.5469vw 1.1719vw;\n    margin-bottom: 1.0938vw;\n  }\n  .apps .apps__cards .item-title {\n    font-size: 1.7188vw;\n    letter-spacing: -0.0188vw;\n    margin-bottom: 0.625vw;\n  }\n  .apps .apps__cards .item-info {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .apps .apps__inner {\n    padding-top: 12.821vw;\n  }\n  .apps .apps__title {\n    margin: 0 auto 19.999px auto;\n    max-width: 100%;\n  }\n  .apps .apps__title h2 {\n    font-size: 8.205vw;\n    letter-spacing: -0.082vw;\n  }\n  .apps .apps__subtitle {\n    margin: 0 auto 8.205vw auto;\n    max-width: 100%;\n    font-size: 4.615vw;\n    letter-spacing: -0.051vw;\n  }\n  .apps .apps__filter {\n    max-width: 100%;\n    margin: 0 auto 8.2051vw;\n    border-radius: 0px;\n    padding: 0px;\n    border: none;\n    background: transparent;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n  .apps .apps__filter button {\n    min-width: 17.6923vw;\n    border-radius: 10.2564vw;\n    border: 1px solid var(--white-2);\n    background: var(--white);\n    margin: 2.0513vw 1.0256vw 0;\n    padding: 2.5641vw 6.1538vw;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .apps .apps__cards {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 7.692vw;\n  }\n  .apps .apps__cards .item {\n    border-radius: 4.103vw;\n  }\n  .apps .apps__cards .item-img {\n    margin: 2.051vw 2.051vw 6.154vw;\n    border-radius: 3.077vw;\n    height: 46.154vw;\n  }\n  .apps .apps__cards .item-img .link_to_post {\n    width: 12.308vw;\n    height: 12.308vw;\n    top: 3.077vw;\n    right: 3.077vw;\n    background-size: 6.154vw 6.154vw;\n  }\n  .apps .apps__cards .item__content {\n    margin: 0 6.154vw 6.41vw 6.154vw;\n  }\n  .apps .apps__cards .item-label {\n    font-size: 3.59vw;\n    letter-spacing: -0.036vw;\n    padding: 2.564vw 4.103vw;\n    margin-bottom: 4.103vw;\n  }\n  .apps .apps__cards .item-title {\n    font-size: 5.641vw;\n    letter-spacing: -0.062vw;\n    margin-bottom: 2.564vw;\n  }\n  .apps .apps__cards .item-info {\n    font-size: 4.103vw;\n    letter-spacing: -0.041vw;\n  }\n}\n.pricing {\n  /* padding: 100px 0 40px 0; */\n  /* background-color: var(--beige); */\n}\n.pricing__title {\n  color: var(--gray);\n  font-family: \"Cambon\";\n  text-align: center;\n  margin-bottom: 24px;\n}\n.pricing__title h2 {\n  font-size: 56px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n  letter-spacing: -0.56px;\n}\n.pricing-tabs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 8px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  max-width: -webkit-max-content;\n  max-width: -moz-max-content;\n  max-width: max-content;\n  margin: 0 auto 72px auto;\n  background-color: var(--white);\n  border-radius: 999px;\n  padding: 8px;\n  border: 1px solid var(--white-2);\n}\n.pricing-tabs .pricing-tab {\n  padding: 10px 24px;\n  background-color: var(--white);\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  border-radius: 999px;\n}\n.pricing-tabs .pricing-tab.active {\n  background-color: var(--gray);\n  color: var(--white);\n}\n\n/* Animations for mobile pricing below (Swtiching between tabs) */\n.fade-enter {\n  opacity: 0;\n  transform: translateY(-20px);\n}\n.fade-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.fade-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n.fade-exit-active {\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 300ms, transform 300ms;\n}\n\n.pricing .pricing-tab-content {\n  display: flex;\n  gap: 30px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.pricing .pricing-tab__pane {\n  height: auto;\n}\n.pricing .pricing-tab__pane > .pricing-pane {\n  width: 100%;\n  height: 100%;\n}\n.pricing .pricing-pane {\n  height: auto;\n  background-color: var(--white);\n  padding: 4px 4px 40px 4px;\n  border-radius: 24px;\n  position: relative;\n  border: 2px solid var(--white);\n}\n.pricing .pricing-pane > .pricing-pane {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border-radius: 0;\n  position: static;\n  border: none;\n}\n.pricing .pricing-pane.popular {\n  border: 2px solid #ffd748;\n}\n.pricing .pricing-pane.popular .pricing-pane__header {\n  background-color: var(--yellow);\n}\n.pricing .pricing-pane__label {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  border-radius: 12px 12px 0px 0px;\n  padding: 6px 16px;\n  background: var(--yellow);\n  color: var(--black);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n  letter-spacing: -0.14px;\n}\n.pricing .pricing-pane__header {\n  text-align: center;\n  position: relative;\n  background-color: var(--yellow);\n  border-radius: 18px;\n  background: var(--yellow);\n  padding: 31px 30px 32px 30px;\n  margin-bottom: 48px;\n}\n.pricing .pricing-pane__title {\n  text-align: center;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 140%;\n  letter-spacing: -0.24px;\n}\n.pricing .pricing-pane__subtitle {\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.14px;\n}\n.pricing .pricing-pane__percent {\n  position: absolute;\n  bottom: -13px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  color: #161616;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n  letter-spacing: -0.14px;\n  padding: 2px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--white-2);\n  background: var(--white);\n}\n.pricing .pricing-pane__info {\n  text-align: center;\n}\n.pricing .pricing-pane__info-price {\n  text-align: center;\n  margin-bottom: 24px;\n}\n.pricing .pricing-pane__info-price .price {\n  color: var(--gray);\n  font-family: \"Cambon\";\n  font-size: 56px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n  letter-spacing: -0.56px;\n}\n.pricing .pricing-pane__info-price .price sup {\n  font-size: 36px;\n}\n.pricing .pricing-pane__info-price .gray {\n  color: var(--gray);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.16px;\n  opacity: 0.3;\n}\n.pricing .pricing-pane__info p {\n  color: var(--gray-2);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.14px;\n  max-width: 65%;\n  margin: 0 auto 30px auto;\n  min-height: 42px;\n}\n.pricing .pricing-pane__info p strong {\n  font-weight: 700;\n}\n.pricing .pricing-pane__info .btn {\n  min-width: 170px;\n  margin-bottom: 32px;\n}\n.pricing .pricing-pane__list {\n  padding: 0 18px;\n}\n.pricing .pricing-pane__list ul li {\n  color: #8c8b87;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.15px;\n  padding-left: 32px;\n  position: relative;\n}\n.pricing .pricing-pane__list ul li::before {\n  content: \"\";\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  left: 0;\n  top: 0;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.7072 7.70718L9.50007 18.9143L3.29297 12.7072L4.70718 11.293L9.50007 16.0859L19.293 6.29297L20.7072 7.70718Z' fill='%238C8B87'/%3E%3C/svg%3E%0A\");\n}\n.pricing .pricing-pane__list ul li:not(:last-of-type) {\n  margin-bottom: 10px;\n}\n\n@media screen and (max-width: 1330px) {\n  .pricing {\n    /* padding: 7.519vw 0 3.008vw 0; */\n  }\n  .pricing__title {\n    margin-bottom: 1.805vw;\n  }\n  .pricing__title h2 {\n    font-size: 4.211vw;\n    letter-spacing: -0.042vw;\n  }\n  .pricing-tabs {\n    gap: 0.602vw;\n    margin: 0 auto 5.414vw auto;\n    border-radius: 75.113vw;\n    padding: 0.602vw;\n  }\n  .pricing-tabs .pricing-tab {\n    padding: 0.752vw 1.805vw;\n    font-size: 1.278vw;\n    border-radius: 75.113vw;\n  }\n  .pricing .pricing-tab-content {\n    gap: 2.256vw;\n  }\n  .pricing .pricing-pane {\n    padding: 0.301vw 0.301vw 3.008vw 0.301vw;\n    border-radius: 1.805vw;\n    border: 0.15vw solid var(--white);\n  }\n  .pricing .pricing-pane.popular {\n    border: 0.15vw solid #ffd748;\n  }\n  .pricing .pricing-pane__label {\n    border-radius: 0.902vw 0.902vw 0vw 0vw;\n    padding: 0.451vw 1.203vw;\n    font-size: 1.053vw;\n    letter-spacing: -0.011vw;\n  }\n  .pricing .pricing-pane__header {\n    border-radius: 1.353vw;\n    padding: 2.331vw 2.256vw 2.406vw 2.256vw;\n    margin-bottom: 3.609vw;\n  }\n  .pricing .pricing-pane__title {\n    font-size: 1.805vw;\n    letter-spacing: -0.018vw;\n  }\n  .pricing .pricing-pane__subtitle {\n    font-size: 1.053vw;\n    letter-spacing: -0.011vw;\n  }\n  .pricing .pricing-pane__percent {\n    bottom: -0.977vw;\n    font-size: 1.053vw;\n    letter-spacing: -0.011vw;\n    padding: 0.15vw 0.752vw;\n    border-radius: 75.113vw;\n  }\n  .pricing .pricing-pane__info-price {\n    margin-bottom: 1.805vw;\n  }\n  .pricing .pricing-pane__info-price .price {\n    font-size: 4.211vw;\n    letter-spacing: -0.042vw;\n  }\n  .pricing .pricing-pane__info-price .price sup {\n    font-size: 2.707vw;\n  }\n  .pricing .pricing-pane__info-price .gray {\n    font-size: 1.203vw;\n    letter-spacing: -0.012vw;\n  }\n  .pricing .pricing-pane__info p {\n    font-size: 1.053vw;\n    letter-spacing: -0.011vw;\n    margin: 0 auto 2.256vw auto;\n    min-height: 3.158vw;\n  }\n  .pricing .pricing-pane__info .btn {\n    min-width: 12.782vw;\n    margin-bottom: 2.406vw;\n  }\n  .pricing .pricing-pane__list {\n    padding: 0 1.353vw;\n  }\n  .pricing .pricing-pane__list ul li {\n    font-size: 1.128vw;\n    letter-spacing: -0.011vw;\n    padding-left: 2.406vw;\n  }\n  .pricing .pricing-pane__list ul li::before {\n    width: 1.805vw;\n    height: 1.805vw;\n  }\n  .pricing .pricing-pane__list ul li:not(:last-of-type) {\n    margin-bottom: 0.752vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .pricing {\n    /* padding: 6.5625vw 0 3.125vw 0; */\n  }\n  .pricing__title {\n    margin-bottom: 1.5625vw;\n  }\n  .pricing__title h2 {\n    font-size: 3.2813vw;\n    line-height: 1.1;\n    letter-spacing: -0.0438vw;\n  }\n  .pricing-tabs {\n    gap: 0.625vw;\n    margin: 0 auto 6.3281vw auto;\n    border-radius: 78.0469vw;\n    padding: 0.625vw;\n  }\n  .pricing-tabs .pricing-tab {\n    padding: 0.625vw 2.0313vw;\n    font-size: 1.3281vw;\n    line-height: 1.5;\n    border-radius: 78.0469vw;\n  }\n  .pricing .pricing-tab-content {\n    gap: 1.5625vw;\n  }\n  .pricing .pricing-pane {\n    padding: 0.3125vw 0.3125vw 3.125vw 0.3125vw;\n    border-radius: 1.875vw;\n    border: 0.1563vw solid var(--white);\n  }\n  .pricing .pricing-pane.popular {\n    border: 0.1563vw solid #ffd748;\n  }\n  .pricing .pricing-pane__label {\n    width: 100%;\n    max-width: 11.0156vw;\n    border-radius: 0.9375vw 0.9375vw 0px 0px;\n    padding: 0.4688vw 1.25vw;\n    font-size: 1.0938vw;\n    letter-spacing: -0.0109vw;\n  }\n  .pricing .pricing-pane__header {\n    border-radius: 1.4063vw;\n    padding: 1.3281vw 3.2031vw 1.9531vw;\n    margin-bottom: 3.125vw;\n  }\n  .pricing .pricing-pane__title {\n    font-size: 1.7188vw;\n    letter-spacing: -0.0172vw;\n    margin-bottom: 0.3906vw;\n  }\n  .pricing .pricing-pane__subtitle {\n    font-size: 1.0938vw;\n    letter-spacing: -0.0109vw;\n  }\n  .pricing .pricing-pane__percent {\n    bottom: -1.0156vw;\n    font-size: 1.0938vw;\n    letter-spacing: -0.0109vw;\n    padding: 0.1563vw 0.7031vw;\n    border-radius: 78.0469vw;\n  }\n  .pricing .pricing-pane__info {\n    text-align: center;\n  }\n  .pricing .pricing-pane__info-price {\n    margin-bottom: 2.5781vw;\n  }\n  .pricing .pricing-pane__info-price .price {\n    font-size: 3.5938vw;\n    letter-spacing: -0.0438vw;\n  }\n  .pricing .pricing-pane__info-price .price sup {\n    font-size: 2.1094vw;\n  }\n  .pricing .pricing-pane__info-price .gray {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n    opacity: 0.3;\n  }\n  .pricing .pricing-pane__info p {\n    font-size: 1.0938vw;\n    letter-spacing: -0.0109vw;\n    max-width: 14.0625vw;\n    margin: 0 auto 2.6563vw auto;\n    min-height: 3.2813vw;\n  }\n  .pricing .pricing-pane__info .btn {\n    min-width: 13.2813vw;\n    margin-bottom: 2.9688vw;\n  }\n  .pricing .pricing-pane__list {\n    padding: 0 0.9375vw;\n  }\n  .pricing .pricing-pane__list ul li {\n    font-size: 1.0938vw;\n    letter-spacing: -0.0117vw;\n    padding-left: 2.5781vw;\n  }\n  .pricing .pricing-pane__list ul li::before {\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n  .pricing .pricing-pane__list ul li:not(:last-of-type) {\n    margin-bottom: 0.9375vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .pricing {\n    /* padding: 54px 0 30px 0; */\n    /* background-color: var(--beige); */\n  }\n  .pricing__title {\n    margin: 0 auto 6.154vw auto;\n    max-width: 70%;\n  }\n  .pricing__title h2 {\n    font-size: 9.231vw;\n    letter-spacing: -0.092vw;\n    line-height: 150%;\n  }\n  .pricing-tabs {\n    gap: 2.051vw;\n    margin: 0 auto 10.769vw auto;\n    border-radius: 256.154vw;\n    padding: 2.051vw;\n    border: 1px solid var(--white-2);\n  }\n  .pricing-tabs .pricing-tab {\n    padding: 2.564vw 6.154vw;\n    font-size: 4.359vw;\n    border-radius: 999px;\n  }\n  .pricing .pricing-tab-content {\n    gap: 7.692vw;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .pricing .pricing-pane {\n    padding: 1.026vw 1.026vw 10.256vw 1.026vw;\n    border-radius: 4.615vw;\n    border: 0.513vw solid var(--white);\n  }\n  .pricing .pricing-pane.popular {\n    border: 0.513vw solid #ffd748;\n    margin-top: 15.205vw;\n  }\n  .pricing .pricing-pane__label {\n    border-radius: 3.077vw 3.077vw 0vw 0vw;\n    padding: 1.538vw 4.103vw;\n    font-size: 3.59vw;\n    letter-spacing: -0.036vw;\n    max-width: 36.1538vw;\n  }\n  .pricing .pricing-pane__header {\n    border-radius: 4.615vw;\n    padding: 7.949vw 7.692vw 8.205vw 7.692vw;\n    margin-bottom: 11.538vw;\n  }\n  .pricing .pricing-pane__title {\n    font-size: 6.154vw;\n    letter-spacing: -0.062vw;\n  }\n  .pricing .pricing-pane__subtitle {\n    font-size: 3.59vw;\n    letter-spacing: -0.036vw;\n  }\n  .pricing .pricing-pane__percent {\n    bottom: -3.333vw;\n    font-size: 3.59vw;\n    letter-spacing: -0.036vw;\n    padding: 0.513vw 2.564vw;\n    border-radius: 256.154vw;\n  }\n  .pricing .pricing-pane__info-price {\n    margin-bottom: 6.154vw;\n  }\n  .pricing .pricing-pane__info-price .price {\n    font-size: 14.359vw;\n    letter-spacing: -0.144vw;\n  }\n  .pricing .pricing-pane__info-price .price sup {\n    font-size: 9.231vw;\n  }\n  .pricing .pricing-pane__info-price .gray {\n    font-size: 4.103vw;\n    letter-spacing: -0.041vw;\n  }\n  .pricing .pricing-pane__info p {\n    font-size: 3.59vw;\n    letter-spacing: -0.036vw;\n    max-width: 50%;\n    margin: 0 auto 8.718vw auto;\n    min-height: 10.769vw;\n  }\n  .pricing .pricing-pane__info .btn {\n    min-width: 43.59vw;\n    margin-bottom: 8.205vw;\n  }\n  .pricing .pricing-pane__list {\n    padding: 0 4.615vw;\n  }\n  .pricing .pricing-pane__list ul li {\n    font-size: 3.846vw;\n    letter-spacing: -0.038vw;\n    padding-left: 8.205vw;\n  }\n  .pricing .pricing-pane__list ul li::before {\n    width: 6.154vw;\n    height: 6.154vw;\n  }\n  .pricing .pricing-pane__list ul li:not(:last-of-type) {\n    margin-bottom: 2.821vw;\n  }\n}\n.pricing-plan {\n  /* background-color: var(--beige); */\n  padding-bottom: 73px;\n}\n.pricing-plan__inner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: var(--dark);\n  padding: 6px 39px 6px 6px;\n  min-height: 130px;\n  border-radius: 24px;\n}\n.pricing-plan__title {\n  background-color: var(--yellow);\n  border-radius: 18px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 31px 62px;\n}\n.pricing-plan__title h2 {\n  color: var(--dark);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 140%;\n  letter-spacing: -0.24px;\n}\n.pricing-plan__title span {\n  color: var(--dark);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.14px;\n}\n.pricing-plan__info {\n  color: var(--white);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.16px;\n  margin: auto auto auto 32px;\n}\n.pricing-plan__btn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-left: 32px;\n}\n.pricing-plan__btn .btn-border {\n  background-color: var(--white);\n  min-width: 170px;\n}\n.pricing-plan__btn .btn-border:hover {\n  background-color: var(--yellow);\n  color: var(--dark);\n}\n\n@media screen and (max-width: 1330px) {\n  .pricing-plan {\n    padding-bottom: 5.489vw;\n  }\n  .pricing-plan__inner {\n    padding: 0.451vw 2.932vw 0.451vw 0.451vw;\n    min-height: 9.774vw;\n    border-radius: 1.805vw;\n  }\n  .pricing-plan__title {\n    border-radius: 1.353vw;\n    padding: 2.331vw 4.662vw;\n  }\n  .pricing-plan__title h2 {\n    font-size: 1.805vw;\n    letter-spacing: -0.018vw;\n  }\n  .pricing-plan__title span {\n    font-size: 1.053vw;\n    letter-spacing: -0.011vw;\n  }\n  .pricing-plan__info {\n    font-size: 1.203vw;\n    letter-spacing: -0.012vw;\n    margin: auto auto auto 2.406vw;\n  }\n  .pricing-plan__btn {\n    margin-left: 2.406vw;\n  }\n  .pricing-plan__btn .btn-border {\n    min-width: 12.782vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .pricing-plan {\n    padding-bottom: 8.4375vw;\n  }\n  .pricing-plan__inner {\n    padding: 0.4688vw 2.9688vw 0.4688vw 0.4688vw;\n    min-height: 10.1563vw;\n    border-radius: 1.875vw;\n  }\n  .pricing-plan__title {\n    border-radius: 1.4063vw;\n    padding: 2.4219vw 3.6719vw;\n    min-width: 22.5vw;\n  }\n  .pricing-plan__title h2 {\n    font-size: 1.7188vw;\n    letter-spacing: -0.0172vw;\n  }\n  .pricing-plan__title span {\n    font-size: 1.0938vw;\n    letter-spacing: -0.0109vw;\n  }\n  .pricing-plan__info {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n    margin: auto auto auto 2.5vw;\n  }\n  .pricing-plan__btn {\n    margin-left: 2.5vw;\n  }\n  .pricing-plan__btn .btn-border {\n    min-width: 13.2813vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .pricing-plan {\n    padding-bottom: 15.897vw;\n  }\n  .pricing-plan__inner {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 1.538vw 1.538vw 11.795vw 1.538vw;\n    min-height: unset;\n    border-radius: 6.154vw;\n  }\n  .pricing-plan__title {\n    border-radius: 4.615vw;\n    width: 100%;\n    padding: 7.949vw;\n  }\n  .pricing-plan__title h2 {\n    font-size: 6.154vw;\n    letter-spacing: -0.062vw;\n  }\n  .pricing-plan__title span {\n    font-size: 3.59vw;\n    letter-spacing: -0.036vw;\n  }\n  .pricing-plan__info {\n    font-size: 4.103vw;\n    text-align: center;\n    letter-spacing: -0.041vw;\n    margin: 9.744vw auto 6.154vw auto;\n    max-width: 70%;\n  }\n  .pricing-plan__btn {\n    margin-left: 0;\n  }\n  .pricing-plan__btn .btn-border {\n    min-width: 43.59vw;\n  }\n}\n.pricing-table {\n  background-color: var(--beige);\n  padding-bottom: 157px;\n}\n.pricing-table__title {\n  color: var(--dark);\n  text-align: center;\n  margin-bottom: 60px;\n}\n.pricing-table__title h2 {\n  font-family: \"Cambon\";\n  font-size: 48px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%;\n  letter-spacing: -0.48px;\n}\n.pricing-table__inner table {\n  border-collapse: collapse;\n  width: 100%;\n}\n.pricing-table__inner table thead tr {\n  height: 54px;\n}\n.pricing-table__inner table thead th {\n  color: var(--01-primary-text, #161616);\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n  /* 30px */\n  letter-spacing: -0.2px;\n  background-color: var(--white);\n}\n.pricing-table__inner table thead th:nth-child(1) {\n  width: 25%;\n  background-color: transparent;\n}\n.pricing-table__inner table thead th:nth-child(2) {\n  border-top-left-radius: 999px;\n  border-bottom-left-radius: 999px;\n}\n.pricing-table__inner table thead th:last-of-type {\n  border-top-right-radius: 999px;\n  border-bottom-right-radius: 999px;\n}\n.pricing-table__inner table thead th:not(:first-of-type) {\n  width: 15%;\n}\n.pricing-table__inner table tbody tr {\n  height: 80px;\n  border-bottom: 1px solid rgba(22, 22, 22, 0.0666666667);\n}\n.pricing-table__inner table tbody tr td:nth-child(1) {\n  width: 25%;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.18px;\n}\n.pricing-table__inner table tbody tr td:not(:first-of-type) {\n  width: 15%;\n  text-align: center;\n  padding: 0 15px;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.18px;\n}\n.pricing-table__inner table tbody tr td:not(:first-of-type) img {\n  margin: 0 auto;\n  width: 32px;\n  height: 32px;\n  -o-object-fit: contain;\n  object-fit: contain;\n  -o-object-position: center;\n  object-position: center;\n}\n.pricing-table__inner table tbody tr td span {\n  color: var(--dark);\n  text-align: center;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  letter-spacing: -0.15px;\n}\n.pricing-table__inner table tbody tr td .empty {\n  opacity: 0.2;\n  background-color: var(--dark);\n  width: 13px;\n  height: 2px;\n  margin: auto;\n}\n\n@media screen and (max-width: 1330px) {\n  .pricing-table {\n    padding-bottom: 11.805vw;\n  }\n  .pricing-table__title {\n    margin-bottom: 4.511vw;\n  }\n  .pricing-table__title h2 {\n    font-size: 3.609vw;\n    letter-spacing: -0.036vw;\n  }\n  .pricing-table__inner table thead tr {\n    height: 4.06vw;\n  }\n  .pricing-table__inner table thead th {\n    font-size: 1.504vw;\n    letter-spacing: -0.015vw;\n  }\n  .pricing-table__inner table tbody tr {\n    height: 6.015vw;\n  }\n  .pricing-table__inner table tbody tr td:nth-child(1) {\n    font-size: 1.353vw;\n    letter-spacing: -0.014vw;\n  }\n  .pricing-table__inner table tbody tr td:not(:first-of-type) {\n    padding: 0 1.128vw;\n    font-size: 1.353vw;\n    letter-spacing: -0.014vw;\n  }\n  .pricing-table__inner table tbody tr td:not(:first-of-type) img {\n    width: 2.406vw;\n    height: 2.406vw;\n  }\n  .pricing-table__inner table tbody tr td span {\n    font-size: 1.128vw;\n    letter-spacing: -0.011vw;\n  }\n  .pricing-table__inner table tbody tr td .empty {\n    width: 0.977vw;\n    height: 0.15vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .pricing-table {\n    padding-bottom: 9.375vw;\n  }\n  .pricing-table__title {\n    margin-bottom: 4.4531vw;\n  }\n  .pricing-table__title h2 {\n    font-size: 2.9688vw;\n    line-height: 1.2;\n    letter-spacing: -0.0297vw;\n  }\n  .pricing-table__inner table thead tr {\n    height: 4.2188vw;\n  }\n  .pricing-table__inner table thead th {\n    font-size: 1.5625vw;\n    letter-spacing: -0.0156vw;\n  }\n  .pricing-table__inner table thead th:nth-child(2) {\n    border-top-left-radius: 78.0469vw;\n    border-bottom-left-radius: 78.0469vw;\n  }\n  .pricing-table__inner table thead th:last-of-type {\n    border-top-right-radius: 78.0469vw;\n    border-bottom-right-radius: 78.0469vw;\n  }\n  .pricing-table__inner table tbody tr {\n    height: 6.25vw;\n    border-bottom: 1px solid rgba(22, 22, 22, 0.0666666667);\n  }\n  .pricing-table__inner table tbody tr td:nth-child(1) {\n    font-size: 1.4063vw;\n    letter-spacing: -0.0141vw;\n  }\n  .pricing-table__inner table tbody tr td:not(:first-of-type) {\n    padding: 0 1.1719vw;\n    font-size: 1.4063vw;\n    line-height: 150%;\n    letter-spacing: -0.0141vw;\n  }\n  .pricing-table__inner table tbody tr td:not(:first-of-type) img {\n    width: 2.5vw;\n    height: 2.5vw;\n  }\n  .pricing-table__inner table tbody tr td span {\n    font-size: 1.1719vw;\n    letter-spacing: -0.0117vw;\n  }\n  .pricing-table__inner table tbody tr td .empty {\n    width: 1.0156vw;\n    height: 0.1563vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .pricing-table {\n    padding-bottom: 33.077vw;\n  }\n  .pricing-table__title {\n    margin-bottom: 12.821vw;\n  }\n  .pricing-table__title h2 {\n    font-size: 8.205vw;\n    letter-spacing: -0.082vw;\n  }\n  .pricing-table__inner {\n    max-width: calc(100% + 5.1282vw);\n    overflow: scroll;\n    margin-right: -5.1282vw;\n  }\n  .pricing-table__inner table {\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n  }\n  .pricing-table__inner table thead tr {\n    height: 13.846vw;\n  }\n  .pricing-table__inner table thead th {\n    font-size: 4.615vw;\n    letter-spacing: -0.046vw;\n  }\n  .pricing-table__inner table thead th:nth-child(1) {\n    width: 31.667vw;\n    padding-right: 5.615vw;\n  }\n  .pricing-table__inner table thead th:not(:first-of-type) {\n    width: 40.967vw;\n  }\n  .pricing-table__inner table tbody tr {\n    height: 20.513vw;\n  }\n  .pricing-table__inner table tbody tr td:nth-child(1) {\n    width: 31.667vw;\n    font-size: 4.103vw;\n    letter-spacing: -0.041vw;\n    padding-right: 5.615vw;\n  }\n  .pricing-table__inner table tbody tr td:not(:first-of-type) {\n    width: 40.967vw;\n    padding: 0 3.846vw;\n    font-size: 4.615vw;\n    letter-spacing: -0.046vw;\n  }\n  .pricing-table__inner table tbody tr td:not(:first-of-type) img {\n    width: 8.205vw;\n    height: 8.205vw;\n  }\n  .pricing-table__inner table tbody tr td span {\n    font-size: 3.846vw;\n    letter-spacing: -0.038vw;\n  }\n  .pricing-table__inner table tbody tr td .empty {\n    width: 3.333vw;\n    height: 0.513vw;\n  }\n}\n.first-screen-bfcm {\n  background-color: var(--yellow);\n  position: relative;\n  z-index: 2;\n}\n.first-screen-bfcm::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  left: 0;\n  bottom: calc(100% - 10px);\n  width: 100%;\n  height: 100%;\n  background-color: var(--yellow);\n}\n.first-screen-bfcm .first-screen-bfcm__inner {\n  padding: 32px 0 42px;\n}\n.first-screen-bfcm .first-screen-bfcm__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  z-index: 2;\n  min-height: 726px;\n}\n.first-screen-bfcm .first-screen-bfcm__content {\n  width: 617px;\n}\n.first-screen-bfcm .first-screen-bfcm__content-title {\n  margin-bottom: 20px;\n}\n.first-screen-bfcm .first-screen-bfcm__content-title h2 {\n  font-family: \"Cambon\";\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.48px;\n  color: var(--dark);\n}\n.first-screen-bfcm .first-screen-bfcm__content-title h2 span {\n  position: relative;\n  z-index: 2;\n}\n.first-screen-bfcm .first-screen-bfcm__content-title h2 span::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -5px;\n  z-index: -1;\n  width: 100%;\n  height: 13px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='141' height='13' fill='none'%3E%3Cpath stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M2 3c36.863-.798 115.931-1.812 137.303.518'/%3E%3Cpath stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M2.092 11.065c36.78-2.98 115.702-8.674 137.148-7.614'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.first-screen-bfcm .first-screen-bfcm__content-text {\n  width: 550px;\n  margin-bottom: 32px;\n}\n.first-screen-bfcm .first-screen-bfcm__content-buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 16px;\n}\n.first-screen-bfcm .first-screen-bfcm__content-message {\n  font-size: 18px;\n  margin-top: 42px;\n  letter-spacing: -1px;\n}\n.first-screen-bfcm .first-screen-bfcm__content-message a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.first-screen-bfcm .first-screen-bfcm__content-message a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.first-screen-bfcm .first-screen-bfcm__content-message a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .first-screen-bfcm .first-screen-bfcm__content-message a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .first-screen-bfcm .first-screen-bfcm__content-message a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .first-screen-bfcm .first-screen-bfcm__content-message a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .first-screen-bfcm .first-screen-bfcm__content-message a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.first-screen-bfcm .first-screen-bfcm__image {\n  position: absolute;\n  right: 19px;\n  bottom: 0;\n  width: 690px;\n  height: 750px;\n}\n.first-screen-bfcm .first-screen-bfcm__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.first-screen-bfcm .first-screen-bfcm__offer {\n  background-color: var(--dark);\n  border-radius: 24px;\n  padding: 8px 82px 8px 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.first-screen-bfcm .first-screen-bfcm__offer-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.first-screen-bfcm .first-screen-bfcm__offer-img {\n  width: 275px;\n  height: 184px;\n  border-radius: 18px;\n  overflow: hidden;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  margin-right: 42px;\n}\n.first-screen-bfcm .first-screen-bfcm__offer-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.first-screen-bfcm .first-screen-bfcm__offer-content {\n  width: 430px;\n}\n.first-screen-bfcm .first-screen-bfcm__offer-content-title h3 {\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: -0.3px;\n  font-size: 30px;\n  color: var(--white);\n}\n.first-screen-bfcm .first-screen-bfcm__offer-content-text {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  color: var(--white);\n}\n.first-screen-bfcm .first-screen-bfcm__offer-button a {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  font-size: 34px;\n  line-height: 1.1;\n  letter-spacing: -0.34px;\n  color: var(--yellow);\n  position: relative;\n  z-index: 2;\n}\n.first-screen-bfcm .first-screen-bfcm__offer-button a:hover::before {\n  width: 0;\n}\n.first-screen-bfcm .first-screen-bfcm__offer-button a::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 2px;\n  background-color: var(--yellow);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n\n@media screen and (max-width: 1330px) {\n  .first-screen-bfcm .first-screen-bfcm__inner {\n    padding: 2.406vw 0 3.1579vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__wrapper {\n    min-height: 54.5865vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content {\n    width: 46.391vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title {\n    margin-bottom: 1.5038vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title h2 {\n    font-size: 3.609vw;\n    letter-spacing: -0.0361vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title h2 span::before {\n    bottom: -0.3759vw;\n    height: 0.9774vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-text {\n    width: 41.3534vw;\n    margin-bottom: 2.406vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-buttons {\n    gap: 1.203vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message {\n    font-size: 1.3534vw;\n    margin-top: 3.1579vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__image {\n    right: 1.4286vw;\n    width: 51.8797vw;\n    height: 56.391vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer {\n    border-radius: 1.8045vw;\n    padding: 0.6015vw 6.1654vw 0.6015vw 0.6015vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-img {\n    width: 20.6767vw;\n    height: 13.8346vw;\n    border-radius: 1.3534vw;\n    margin-right: 3.1579vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content {\n    width: 32.3308vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content-title h3 {\n    letter-spacing: -0.0226vw;\n    font-size: 2.2556vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content-text {\n    font-size: 1.5038vw;\n    letter-spacing: -0.015vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-button a {\n    font-size: 2.5564vw;\n    letter-spacing: -0.0256vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-button a::before {\n    height: 0.1504vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .first-screen-bfcm .first-screen-bfcm__inner {\n    padding: 0.7031vw 0 2.3438vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__wrapper {\n    min-height: 39.9219vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content {\n    width: 31.25vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title {\n    margin-bottom: 1.4844vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title h2 {\n    font-size: 2.6563vw;\n    line-height: 1.1;\n    letter-spacing: -0.0266vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title h2 span::before {\n    bottom: -0.1563vw;\n    height: 0.8594vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-text {\n    width: 30.4688vw;\n    margin-bottom: 1.875vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-buttons {\n    gap: 1.25vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message {\n    font-size: 1.4063vw;\n    margin-top: 2.5vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__image {\n    right: 4.2188vw;\n    width: 38.3594vw;\n    height: 40.625vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer {\n    border-radius: 1.875vw;\n    padding: 0.625vw 6.4063vw 0.625vw 0.625vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-img {\n    width: 18.125vw;\n    height: 12.0313vw;\n    border-radius: 1.4063vw;\n    margin-right: 2.3438vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content {\n    width: 26.3438vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content-title h3 {\n    letter-spacing: -0.0188vw;\n    font-size: 1.875vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content-text {\n    font-size: 1.25vw;\n    letter-spacing: -0.0125vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-button a {\n    font-size: 1.875vw;\n    letter-spacing: -0.0188vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-button a::before {\n    height: 1px;\n  }\n}\n@media screen and (max-width: 850px) {\n  .first-screen-bfcm {\n    background-color: transparent;\n    position: relative;\n    z-index: 2;\n  }\n  .first-screen-bfcm::before {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: calc(100% - 42.3077vw);\n    background-color: var(--yellow);\n  }\n  .first-screen-bfcm .first-screen-bfcm__inner {\n    padding: 12.0513vw 0 0;\n  }\n  .first-screen-bfcm .first-screen-bfcm__wrapper {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    min-height: 0;\n    padding-bottom: 114.6154vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content {\n    width: 100%;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title {\n    margin-bottom: 5.1282vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title h2 {\n    font-size: 9.2308vw;\n    line-height: 1.1;\n    letter-spacing: -0.0923vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-title h2 span::before {\n    bottom: 0;\n    height: 2.0513vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-text {\n    width: 100%;\n    margin-bottom: 6.1538vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-buttons {\n    gap: 4.1026vw;\n  }\n  .first-screen-bfcm\n    .first-screen-bfcm__content\n    .first-screen-home__content-button {\n    width: 100%;\n  }\n  .first-screen-bfcm\n    .first-screen-bfcm__content\n    .first-screen-home__content-button\n    .btn {\n    padding: 4.6154vw 3.1538vw;\n  }\n  .first-screen-bfcm\n    .first-screen-bfcm__content\n    .first-screen-home__content-button\n    .btn,\n  .first-screen-bfcm\n    .first-screen-bfcm__content\n    .first-screen-home__content-button\n    .btn-border {\n    width: 100%;\n  }\n  .first-screen-bfcm .first-screen-bfcm__content-message {\n    font-size: 4.1026vw;\n    margin-top: 6.1538vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__image {\n    right: 50%;\n    bottom: 0;\n    -webkit-transform: translateX(50%);\n    transform: translateX(50%);\n    width: 100vw;\n    height: 108.7179vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer {\n    width: 89.7436vw;\n    margin: 0 auto;\n    border-radius: 6.1538vw;\n    padding: 2.0513vw 2.0513vw 10.2564vw 2.0513vw;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-wrapper {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-img {\n    width: 100%;\n    height: 57.9487vw;\n    border-radius: 4.6154vw;\n    margin-right: 0;\n    margin-bottom: 6.6667vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content {\n    width: 100%;\n    margin-bottom: 6.4103vw;\n    text-align: center;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content-title {\n    margin-bottom: 1.2821vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content-title h3 {\n    letter-spacing: -0.0564vw;\n    font-size: 5.641vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-content-text {\n    font-size: 4.1026vw;\n    letter-spacing: -0.041vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-button {\n    text-align: center;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-button a {\n    font-size: 5.1282vw;\n    letter-spacing: -0.0513vw;\n  }\n  .first-screen-bfcm .first-screen-bfcm__offer-button a::before {\n    height: 1px;\n  }\n}\n.must-have-info .must-have-info__inner {\n  padding: 96px 0 125px;\n}\n.must-have-info .must-have-info__header {\n  width: 700px;\n  margin: 0 auto 66px;\n  text-align: center;\n}\n.must-have-info .must-have-info__header-title {\n  margin-bottom: 21px;\n}\n.must-have-info .must-have-info__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  min-height: 730px;\n}\n.must-have-info .must-have-info__accordion {\n  width: 520px;\n}\n.must-have-info .must-have-info__accordion .accordion {\n  width: 100%;\n  border-bottom: 1px solid var(--white-2);\n  padding-bottom: 29px;\n}\n.must-have-info .must-have-info__accordion .accordion:not(:first-child) {\n  margin-top: 34px;\n}\n.must-have-info\n  .must-have-info__accordion\n  .accordion.open\n  .accordion-header::before {\n  -webkit-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n.must-have-info .must-have-info__accordion .accordion .accordion-header {\n  font-weight: 500;\n  line-height: 1.5;\n  font-size: 26px;\n  letter-spacing: -0.26px;\n  color: var(--dark);\n  position: relative;\n  z-index: 2;\n  padding-right: 113px;\n  cursor: pointer;\n}\n.must-have-info\n  .must-have-info__accordion\n  .accordion\n  .accordion-header::before {\n  content: \"\";\n  position: absolute;\n  top: 7px;\n  right: 12px;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M11.996 17.415 2.29 7.707l1.414-1.414 8.293 8.293 8.293-8.293 1.414 1.414-9.707 9.708Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.must-have-info .must-have-info__accordion .accordion .accordion-content {\n  display: none;\n  margin-top: 18px;\n}\n.must-have-info .must-have-info__accordion .accordion .accordion-content__text {\n  margin-bottom: 29px;\n}\n.must-have-info\n  .must-have-info__accordion\n  .accordion\n  .accordion-content__list\n  ul\n  li {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.6;\n  letter-spacing: -0.18px;\n  color: var(--gray);\n  position: relative;\n  z-index: 2;\n  padding-left: 28px;\n}\n.must-have-info\n  .must-have-info__accordion\n  .accordion\n  .accordion-content__list\n  ul\n  li::before {\n  content: \"\";\n  position: absolute;\n  top: 11px;\n  left: 10px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background-color: var(--gray);\n}\n.must-have-info\n  .must-have-info__accordion\n  .accordion\n  .accordion-content__button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  margin-top: 29px;\n}\n.must-have-info .must-have-info__accordion .accordion .accordion-content__img {\n  display: none;\n}\n.must-have-info .must-have-info__gallery {\n  width: 630px;\n  height: 730px;\n  position: absolute;\n  top: 50px;\n  right: 0;\n  z-index: 2;\n}\n.must-have-info .must-have-info__gallery ul {\n  width: 100%;\n  height: 100%;\n}\n.must-have-info .must-have-info__gallery ul li {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  opacity: 0;\n}\n.must-have-info .must-have-info__gallery ul li.show {\n  opacity: 1;\n}\n.must-have-info .must-have-info__gallery ul li.hide {\n  opacity: 0;\n}\n.must-have-info .must-have-info__gallery img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .must-have-info .must-have-info__inner {\n    padding: 7.218vw 0 9.3985vw;\n  }\n  .must-have-info .must-have-info__header {\n    width: 52.6316vw;\n    margin: 0 auto 4.9624vw;\n  }\n  .must-have-info .must-have-info__header-title {\n    margin-bottom: 1.5789vw;\n  }\n  .must-have-info .must-have-info__wrapper {\n    min-height: 54.8872vw;\n  }\n  .must-have-info .must-have-info__accordion {\n    width: 39.0977vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion {\n    padding-bottom: 2.1805vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion:not(:first-child) {\n    margin-top: 2.5564vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion .accordion-header {\n    font-size: 1.9549vw;\n    letter-spacing: -0.0195vw;\n    padding-right: 8.4962vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-header::before {\n    top: 0.5263vw;\n    right: 0.9023vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion .accordion-content {\n    margin-top: 1.3534vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__text {\n    margin-bottom: 2.1805vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__list\n    ul\n    li {\n    font-size: 1.3534vw;\n    letter-spacing: -0.0135vw;\n    padding-left: 2.1053vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__list\n    ul\n    li::before {\n    top: 0.8271vw;\n    left: 0.7519vw;\n    width: 0.5263vw;\n    height: 0.5263vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__button {\n    margin-top: 2.1805vw;\n  }\n  .must-have-info .must-have-info__gallery {\n    width: 47.3684vw;\n    height: 54.8872vw;\n    top: 3.7594vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .must-have-info .must-have-info__inner {\n    padding: 7.2656vw 0 8.2813vw;\n  }\n  .must-have-info .must-have-info__header {\n    width: 44.5313vw;\n    margin: 0 auto 6.0156vw;\n  }\n  .must-have-info .must-have-info__header-title {\n    margin-bottom: 1.0938vw;\n  }\n  .must-have-info .must-have-info__wrapper {\n    min-height: 45.9375vw;\n  }\n  .must-have-info .must-have-info__accordion {\n    width: 32.8125vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion {\n    padding-bottom: 2.5781vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion:not(:first-child) {\n    margin-top: 1.9531vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion .accordion-header {\n    font-size: 1.4063vw;\n    letter-spacing: -0.0141vw;\n    padding-right: 2.9688vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-header::before {\n    top: 0;\n    right: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion .accordion-content {\n    margin-top: 2.2656vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__text {\n    margin-bottom: 1.7969vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__list\n    ul\n    li {\n    font-size: 1.1719vw;\n    letter-spacing: -0.0117vw;\n    padding-left: 1.7969vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__list\n    ul\n    li::before {\n    top: 0.7813vw;\n    left: 0.625vw;\n    width: 0.4688vw;\n    height: 0.4688vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__button {\n    margin-top: 1.9531vw;\n  }\n  .must-have-info .must-have-info__gallery {\n    width: 39.8438vw;\n    height: 45.9375vw;\n    top: 5.7031vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .must-have-info .must-have-info__inner {\n    padding: 20.5128vw 0 23.0769vw;\n  }\n  .must-have-info .must-have-info__header {\n    width: 100%;\n    margin: 0 auto 4.8718vw;\n  }\n  .must-have-info .must-have-info__header-title {\n    width: 82.0513vw;\n    margin: 0 auto 4.8718vw;\n  }\n  .must-have-info .must-have-info__wrapper {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    min-height: 0;\n  }\n  .must-have-info .must-have-info__accordion {\n    width: 100%;\n  }\n  .must-have-info .must-have-info__accordion .accordion {\n    padding-bottom: 6.9231vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion:not(:first-child) {\n    margin-top: 6.1538vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion .accordion-header {\n    font-size: 5.1282vw;\n    letter-spacing: -0.0513vw;\n    padding-right: 10.7692vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-header::before {\n    top: 0.5128vw;\n    right: 0px;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .must-have-info .must-have-info__accordion .accordion .accordion-content {\n    display: none;\n    margin-top: 6.1538vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__text {\n    margin-bottom: 6.1538vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__text.small-text {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__list\n    ul\n    li {\n    font-size: 4.1026vw;\n    letter-spacing: -0.041vw;\n    padding-left: 6.1538vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__list\n    ul\n    li::before {\n    top: 2.5641vw;\n    left: 2.3077vw;\n    width: 1.5385vw;\n    height: 1.5385vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__button {\n    margin-top: 7.1795vw;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__img {\n    margin-top: 6.1538vw;\n    display: block;\n    width: 100%;\n    height: auto;\n  }\n  .must-have-info\n    .must-have-info__accordion\n    .accordion\n    .accordion-content__img\n    img {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: contain;\n    object-fit: contain;\n  }\n  .must-have-info .must-have-info__gallery {\n    display: none;\n  }\n}\n.short-info .short-info__inner {\n  padding-bottom: 137px;\n}\n.short-info .short-info__title {\n  margin-bottom: 88px;\n  text-align: center;\n}\n.short-info .short-info__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.short-info .short-info__image {\n  width: 630px;\n  height: 450px;\n  border-radius: 24px;\n  overflow: hidden;\n  margin-right: 140px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.short-info .short-info__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.short-info .short-info__content {\n  width: 100%;\n}\n.short-info .short-info__content-text {\n  margin-bottom: 22px;\n}\n.short-info .short-info__content-button {\n  margin-bottom: 41px;\n}\n.short-info .short-info__content-button a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.short-info .short-info__content-button a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.short-info .short-info__content-button a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .short-info .short-info__content-button a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .short-info .short-info__content-button a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .short-info .short-info__content-button a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .short-info .short-info__content-button a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .short-info .short-info__content-button a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .short-info .short-info__content-button a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .short-info .short-info__content-button a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .short-info .short-info__content-button a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .short-info .short-info__content-button a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .short-info .short-info__content-button a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .short-info .short-info__content-button a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.short-info .short-info__content-info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.short-info .short-info__content-info-img {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-right: 16px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.short-info .short-info__content-info-img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.short-info .short-info__content-info-name {\n  font-weight: 500;\n  font-size: 20px;\n  color: var(--dark);\n  margin-bottom: 9px;\n}\n.short-info .short-info__content-info-position {\n  font-weight: 400;\n  font-size: 15px;\n  color: var(--dark);\n}\n.short-info .short-info__content-list {\n  margin-top: 49px;\n  padding-top: 28px;\n  border-top: 1px solid rgba(22, 22, 22, 0.2);\n}\n.short-info .short-info__content-list .list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n.short-info .short-info__content-list .item:not(:first-child) {\n  margin-left: 35px;\n}\n.short-info .short-info__content-list .item-top {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.short-info .short-info__content-list .item-top__symbol,\n.short-info .short-info__content-list .item-top__number {\n  font-family: \"Cambon\";\n  color: var(--dark);\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.32px;\n}\n.short-info .short-info__content-list .item-title h3 {\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.18px;\n  font-size: 18px;\n  color: var(--dark);\n}\n\n@media screen and (max-width: 1330px) {\n  .short-info .short-info__inner {\n    padding-bottom: 10.3008vw;\n  }\n  .short-info .short-info__title {\n    margin-bottom: 6.6165vw;\n  }\n  .short-info .short-info__image {\n    width: 47.3684vw;\n    height: 33.8346vw;\n    border-radius: 1.8045vw;\n    margin-right: 10.5263vw;\n  }\n  .short-info .short-info__content-text {\n    margin-bottom: 1.6541vw;\n  }\n  .short-info .short-info__content-button {\n    margin-bottom: 3.0827vw;\n  }\n  .short-info .short-info__content-info-img {\n    width: 4.0602vw;\n    height: 4.0602vw;\n    margin-right: 1.203vw;\n  }\n  .short-info .short-info__content-info-name {\n    font-size: 1.5038vw;\n    margin-bottom: 0.6767vw;\n  }\n  .short-info .short-info__content-info-position {\n    font-size: 1.1278vw;\n  }\n  .short-info .short-info__content-list {\n    margin-top: 3.6842vw;\n    padding-top: 2.1053vw;\n  }\n  .short-info .short-info__content-list .item:not(:first-child) {\n    margin-left: 2.6316vw;\n  }\n  .short-info .short-info__content-list .item-top__symbol,\n  .short-info .short-info__content-list .item-top__number {\n    font-size: 2.406vw;\n    letter-spacing: -0.0241vw;\n  }\n  .short-info .short-info__content-list .item-title h3 {\n    letter-spacing: -0.0135vw;\n    font-size: 1.3534vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .short-info .short-info__inner {\n    padding-bottom: 9.375vw;\n  }\n  .short-info .short-info__title {\n    margin-bottom: 5.7813vw;\n  }\n  .short-info .short-info__image {\n    width: 39.8438vw;\n    height: 28.5156vw;\n    border-radius: 1.875vw;\n    margin-right: 7.0313vw;\n  }\n  .short-info .short-info__content-text {\n    margin-bottom: 1.25vw;\n  }\n  .short-info .short-info__content-button {\n    margin-bottom: 2.3438vw;\n  }\n  .short-info .short-info__content-info-img {\n    width: 4.2188vw;\n    height: 4.2188vw;\n    margin-right: 1.25vw;\n  }\n  .short-info .short-info__content-info-name {\n    font-size: 1.4063vw;\n    margin-bottom: 0.3125vw;\n  }\n  .short-info .short-info__content-info-position {\n    font-size: 1.1719vw;\n  }\n  .short-info .short-info__content-list {\n    margin-top: 2.4219vw;\n    padding-top: 1.5625vw;\n  }\n  .short-info .short-info__content-list .item:not(:first-child) {\n    margin-left: 2.0313vw;\n  }\n  .short-info .short-info__content-list .item-top__symbol,\n  .short-info .short-info__content-list .item-top__number {\n    font-size: 1.875vw;\n    letter-spacing: -0.0188vw;\n  }\n  .short-info .short-info__content-list .item-title h3 {\n    letter-spacing: -0.0125vw;\n    font-size: 1.25vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .short-info .short-info__inner {\n    padding-bottom: 23.0769vw;\n  }\n  .short-info .short-info__title {\n    margin-bottom: 7.4359vw;\n  }\n  .short-info .short-info__wrapper {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .short-info .short-info__image {\n    width: 100%;\n    height: 64.1026vw;\n    border-radius: 3.3333vw;\n    margin-right: 0;\n    margin-bottom: 6.1538vw;\n  }\n  .short-info .short-info__content {\n    width: 100%;\n  }\n  .short-info .short-info__content-text {\n    margin-bottom: 6.1538vw;\n  }\n  .short-info .short-info__content-text.small-text {\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n  }\n  .short-info .short-info__content-button {\n    margin-bottom: 8.2051vw;\n  }\n  .short-info .short-info__content-info-img {\n    width: 13.8462vw;\n    height: 13.8462vw;\n    margin-right: 4.1026vw;\n  }\n  .short-info .short-info__content-info-name {\n    font-size: 4.6154vw;\n    margin-bottom: 1.0256vw;\n  }\n  .short-info .short-info__content-info-position {\n    font-size: 3.5897vw;\n  }\n  .short-info .short-info__content-list {\n    margin-top: 12.3077vw;\n    padding-top: 4.6154vw;\n  }\n  .short-info .short-info__content-list .item:not(:first-child) {\n    margin-left: 7.9487vw;\n  }\n  .short-info .short-info__content-list .item-top__symbol,\n  .short-info .short-info__content-list .item-top__number {\n    font-size: 5.641vw;\n    letter-spacing: -0.0564vw;\n  }\n  .short-info .short-info__content-list .item-title {\n    margin-top: 1.2821vw;\n  }\n  .short-info .short-info__content-list .item-title h3 {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n}\n.enterprise-info {\n  padding: 0 30px;\n}\n.enterprise-info .enterprise-info__inner {\n  border-radius: 24px;\n  background-color: var(--beige);\n  padding: 117px 0 145px;\n}\n.enterprise-info .enterprise-info__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  margin-bottom: 90px;\n}\n.enterprise-info .enterprise-info__content {\n  width: 493px;\n}\n.enterprise-info .enterprise-info__content-title {\n  margin-bottom: 32px;\n}\n.enterprise-info .enterprise-info__content-title h3 span {\n  position: relative;\n  z-index: 2;\n}\n.enterprise-info .enterprise-info__content-title h3 span::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  left: 0;\n  bottom: -6px;\n  width: 100%;\n  height: 13px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='204' height='13' fill='none'%3E%3Cpath stroke='%23D095FF' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M2 3c53.69-.798 168.855-1.812 199.985.518'/%3E%3Cpath stroke='%23D095FF' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M2.13 11.065C55.703 8.085 170.656 2.39 201.893 3.45'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.enterprise-info .enterprise-info__content-text {\n  margin-bottom: 32px;\n}\n.enterprise-info .enterprise-info__content-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.enterprise-info .enterprise-info__image {\n  width: 630px;\n  height: 450px;\n  border-radius: 24px;\n  overflow: hidden;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.enterprise-info .enterprise-info__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n.enterprise-info .enterprise-info__list .list {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 30px;\n}\n.enterprise-info .enterprise-info__list .item .item-icon {\n  width: 48px;\n  height: 48px;\n  margin-bottom: 31px;\n  margin-left: 30px;\n}\n.enterprise-info .enterprise-info__list .item .item-icon img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.enterprise-info .enterprise-info__list .item .item-content {\n  padding: 0 24px 0;\n}\n.enterprise-info .enterprise-info__list .item .item-content__title {\n  margin-bottom: 21px;\n}\n.enterprise-info .enterprise-info__list .item .item-content__title h3 {\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: -0.2px;\n  font-size: 20px;\n  color: var(--dark);\n}\n.enterprise-info .enterprise-info__list .item .item-content__text {\n  font-weight: 400;\n  line-height: 1.3;\n  letter-spacing: -0.198px;\n  font-size: 18px;\n  color: var(--gray);\n}\n\n@media screen and (max-width: 1330px) {\n  .enterprise-info {\n    padding: 0 2.2556vw;\n  }\n  .enterprise-info .enterprise-info__inner {\n    border-radius: 1.8045vw;\n    padding: 8.797vw 0 10.9023vw;\n  }\n  .enterprise-info .enterprise-info__wrapper {\n    margin-bottom: 6.7669vw;\n  }\n  .enterprise-info .enterprise-info__content {\n    width: 37.0677vw;\n  }\n  .enterprise-info .enterprise-info__content-title {\n    margin-bottom: 2.406vw;\n  }\n  .enterprise-info .enterprise-info__content-title h3 span::before {\n    bottom: -0.4511vw;\n    height: 0.9774vw;\n  }\n  .enterprise-info .enterprise-info__content-text {\n    margin-bottom: 2.406vw;\n  }\n  .enterprise-info .enterprise-info__image {\n    width: 47.3684vw;\n    height: 33.8346vw;\n    border-radius: 1.8045vw;\n  }\n  .enterprise-info .enterprise-info__list .list {\n    grid-gap: 2.2556vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-icon {\n    width: 3.609vw;\n    height: 3.609vw;\n    margin-bottom: 2.3308vw;\n    margin-left: 2.2556vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content {\n    padding: 0 1.8045vw 0;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__title {\n    margin-bottom: 1.5789vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__title h3 {\n    letter-spacing: -0.015vw;\n    font-size: 1.5038vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__text {\n    letter-spacing: -0.0149vw;\n    font-size: 1.3534vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .enterprise-info {\n    padding: 0 2.3438vw;\n  }\n  .enterprise-info .enterprise-info__inner {\n    border-radius: 1.875vw;\n    padding: 7.8125vw 0 7.0313vw;\n  }\n  .enterprise-info .enterprise-info__wrapper {\n    margin-bottom: 5.3906vw;\n  }\n  .enterprise-info .enterprise-info__content {\n    width: 32.8906vw;\n  }\n  .enterprise-info .enterprise-info__content-title {\n    margin-bottom: 2.5vw;\n  }\n  .enterprise-info .enterprise-info__content-title h3 span::before {\n    bottom: -0.4688vw;\n    height: 1.0156vw;\n  }\n  .enterprise-info .enterprise-info__content-text {\n    margin-bottom: 2.5vw;\n  }\n  .enterprise-info .enterprise-info__image {\n    width: 39.8438vw;\n    height: 28.4375vw;\n    border-radius: 1.4844vw;\n  }\n  .enterprise-info .enterprise-info__list .list {\n    grid-gap: 2.3438vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-icon {\n    width: 3.75vw;\n    height: 3.75vw;\n    margin-bottom: 1.7188vw;\n    margin-left: 1.6406vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content {\n    padding: 0 1.25vw 0;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__title {\n    margin-bottom: 0.9375vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__title h3 {\n    letter-spacing: -0.0141vw;\n    font-size: 1.4063vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__text {\n    letter-spacing: -0.0138vw;\n    font-size: 1.25vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .enterprise-info {\n    padding: 0;\n  }\n  .enterprise-info .enterprise-info__inner {\n    border-radius: 6.1538vw;\n    padding: 17.4359vw 0 20.5128vw;\n  }\n  .enterprise-info .enterprise-info__wrapper {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 13.8462vw;\n  }\n  .enterprise-info .enterprise-info__content {\n    width: 100%;\n    margin-bottom: 8.2051vw;\n  }\n  .enterprise-info .enterprise-info__content-title {\n    margin-bottom: 4.6154vw;\n  }\n  .enterprise-info .enterprise-info__content-title h3 span::before {\n    bottom: 0;\n    height: 1.7949vw;\n  }\n  .enterprise-info .enterprise-info__content-text {\n    margin-bottom: 6.1538vw;\n  }\n  .enterprise-info .enterprise-info__content-text.small-text {\n    letter-spacing: -0.0462vw;\n    font-size: 4.6154vw;\n  }\n  .enterprise-info .enterprise-info__image {\n    width: 89.7436vw;\n    height: 64.1026vw;\n    border-radius: 3.3333vw;\n  }\n  .enterprise-info .enterprise-info__list {\n    width: 76.9231vw;\n    margin: 0 auto;\n  }\n  .enterprise-info .enterprise-info__list .list {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 11.2821vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-icon {\n    width: 12.3077vw;\n    height: 12.3077vw;\n    margin-bottom: 5.3846vw;\n    margin-left: 0;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content {\n    padding: 0;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__title {\n    margin-bottom: 4.1026vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__title h3 {\n    letter-spacing: -0.0513vw;\n    font-size: 5.1282vw;\n  }\n  .enterprise-info .enterprise-info__list .item .item-content__text {\n    letter-spacing: -0.0451vw;\n    font-size: 4.1026vw;\n  }\n}\n.short-about-company .short-about-company__inner {\n  padding: 173px 0;\n}\n.short-about-company .short-about-company__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  max-width: 1206px;\n  margin: 0 auto;\n}\n.short-about-company .short-about-company__side {\n  width: 402px;\n  margin-right: 89px;\n}\n.short-about-company .short-about-company__side-logo {\n  width: 215px;\n  height: auto;\n  margin: 0 auto 59px;\n}\n.short-about-company .short-about-company__side-logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.short-about-company .short-about-company__side-text h3 {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 1.2;\n  letter-spacing: -0.4px;\n  color: var(--dark);\n  text-align: center;\n}\n.short-about-company .short-about-company__content {\n  width: 740px;\n}\n.short-about-company .short-about-company__content-text {\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: -0.3px;\n  font-size: 30px;\n  color: var(--dark);\n}\n.short-about-company .short-about-company__content-text * {\n  margin-bottom: 30px;\n}\n.short-about-company .short-about-company__content-text *:last-child {\n  margin-bottom: 0;\n}\n.short-about-company .short-about-company__content-button {\n  margin-top: 34px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n@media screen and (max-width: 1330px) {\n  .short-about-company .short-about-company__inner {\n    padding: 13.0075vw 0;\n  }\n  .short-about-company .short-about-company__wrapper {\n    max-width: 90.6767vw;\n  }\n  .short-about-company .short-about-company__side {\n    width: 30.2256vw;\n    margin-right: 6.6917vw;\n  }\n  .short-about-company .short-about-company__side-logo {\n    width: 16.1654vw;\n    margin: 0 auto 4.4361vw;\n  }\n  .short-about-company .short-about-company__side-text h3 {\n    font-size: 3.0075vw;\n    letter-spacing: -0.0301vw;\n  }\n  .short-about-company .short-about-company__content {\n    width: 55.6391vw;\n  }\n  .short-about-company .short-about-company__content-text {\n    letter-spacing: -0.0226vw;\n    font-size: 2.2556vw;\n  }\n  .short-about-company .short-about-company__content-text * {\n    margin-bottom: 2.2556vw;\n  }\n  .short-about-company .short-about-company__content-button {\n    margin-top: 2.5564vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .short-about-company .short-about-company__inner {\n    padding: 11.25vw 0;\n  }\n  .short-about-company .short-about-company__wrapper {\n    max-width: 75vw;\n  }\n  .short-about-company .short-about-company__side {\n    width: 23.4375vw;\n    margin-right: 5.7813vw;\n  }\n  .short-about-company .short-about-company__side-logo {\n    width: 16.7969vw;\n    height: auto;\n    margin: 0 auto 2.6563vw;\n  }\n  .short-about-company .short-about-company__side-text h3 {\n    font-size: 2.1875vw;\n    letter-spacing: -0.0219vw;\n  }\n  .short-about-company .short-about-company__content {\n    width: 46.875vw;\n  }\n  .short-about-company .short-about-company__content-text {\n    letter-spacing: -0.0164vw;\n    font-size: 1.6406vw;\n  }\n  .short-about-company .short-about-company__content-text * {\n    margin-bottom: 1.9531vw;\n  }\n  .short-about-company .short-about-company__content-button {\n    margin-top: 2.5vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .short-about-company .short-about-company__inner {\n    padding: 23.0769vw 0;\n  }\n  .short-about-company .short-about-company__wrapper {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    max-width: 100%;\n  }\n  .short-about-company .short-about-company__side {\n    width: 73.0769vw;\n    margin: 0 auto 9.7436vw;\n  }\n  .short-about-company .short-about-company__side-logo {\n    width: 55.1282vw;\n    margin: 0 auto 9.2308vw;\n  }\n  .short-about-company .short-about-company__side-text h3 {\n    font-size: 7.1795vw;\n    line-height: 1.2;\n    letter-spacing: -0.0718vw;\n  }\n  .short-about-company .short-about-company__content {\n    width: 100%;\n  }\n  .short-about-company .short-about-company__content-text {\n    letter-spacing: -0.0564vw;\n    font-size: 5.641vw;\n  }\n  .short-about-company .short-about-company__content-text * {\n    margin-bottom: 7.6923vw;\n  }\n  .short-about-company .short-about-company__content-button {\n    margin-top: 6.1538vw;\n  }\n}\n.store .store__inner {\n  padding-bottom: 186px;\n}\n.store .store__list .list {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 30px 1fr 30px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 42px 30px;\n}\n.store .store__list .item {\n  width: 100%;\n  cursor: pointer;\n}\n.store .store__list .item.show {\n  display: block;\n}\n.store .store__list .item.hide {\n  display: none;\n}\n.store .store__list .item:hover .item-top::before {\n  opacity: 0.4;\n}\n.store .store__list .item:hover .item-top__text {\n  opacity: 1;\n}\n.store .store__list .item:hover .item-top__text::before {\n  width: 100%;\n}\n.store .store__list .item:hover .item-top__image img {\n  -webkit-transform: scale(1.2);\n  transform: scale(1.2);\n}\n.store .store__list .item .item-top {\n  width: 100%;\n  height: 262px;\n  position: relative;\n  z-index: 2;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 38px;\n  border-radius: 18px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n.store .store__list .item .item-top::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  background: var(--black);\n  opacity: 0;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.store .store__list .item .item-top__image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -2;\n}\n.store .store__list .item .item-top__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.store .store__list .item .item-top__text {\n  font-family: \"Cambon\";\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.22px;\n  font-size: 22px;\n  color: var(--white);\n  text-transform: uppercase;\n  position: relative;\n  z-index: 2;\n  opacity: 0;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.store .store__list .item .item-top__text::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0%;\n  height: 1px;\n  background: var(--white);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.store .store__list .item .item-title h3 {\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: -0.16px;\n  font-size: 16px;\n  color: var(--dark);\n}\n.store .store__button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-top: 82px;\n}\n\n@media screen and (max-width: 1330px) {\n  .store .store__inner {\n    padding-bottom: 13.985vw;\n  }\n  .store .store__list .list {\n    grid-gap: 3.1579vw 2.2556vw;\n  }\n  .store .store__list .item .item-top {\n    height: 19.6992vw;\n    padding: 2.8571vw;\n    border-radius: 1.3534vw;\n    margin-bottom: 0.9023vw;\n  }\n  .store .store__list .item .item-top__text {\n    letter-spacing: -0.0165vw;\n    font-size: 1.6541vw;\n  }\n  .store .store__list .item .item-title h3 {\n    letter-spacing: -0.012vw;\n    font-size: 1.203vw;\n  }\n  .store .store__button {\n    margin-top: 6.1654vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .store .store__inner {\n    padding-bottom: 7.8125vw;\n  }\n  .store .store__list .list {\n    grid-gap: 1.9531vw;\n  }\n  .store .store__list .item .item-top {\n    height: 16.4063vw;\n    padding: 1.5625vw;\n    border-radius: 1.1719vw;\n    margin-bottom: 0.7813vw;\n  }\n  .store .store__list .item .item-top__text {\n    letter-spacing: -0.0172vw;\n    font-size: 1.4063vw;\n  }\n  .store .store__list .item .item-title h3 {\n    letter-spacing: -0.0125vw;\n    font-size: 1.0938vw;\n  }\n  .store .store__button {\n    margin-top: 3.9063vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .store .store__inner {\n    padding-bottom: 33.8462vw;\n  }\n  .store .store__list .list {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    grid-gap: 8.2051vw;\n  }\n  .store .store__list .item .item-top {\n    height: 57.4359vw;\n    padding: 5.1282vw;\n    border-radius: 4.6154vw;\n    margin-bottom: 2.5641vw;\n  }\n  .store .store__list .item .item-top__text {\n    letter-spacing: -0.0564vw;\n    font-size: 4.6154vw;\n  }\n  .store .store__list .item .item-title h3 {\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .store .store__button {\n    margin-top: 12.3077vw;\n  }\n}\n.toast {\n  padding: 10px 0;\n  width: 100%;\n  background: black;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n.toast.toast--color {\n  background: #2e685d;\n}\n.toast.toast--color .toast-content {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  gap: 3px;\n}\n.toast .toast-wrapper {\n  text-decoration: none;\n  width: 100%;\n}\n.toast .toast-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.toast .toast-link {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 8px;\n  color: #ffd748;\n  font-family: \"Circular Std\";\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-decoration: none;\n  position: relative;\n}\n.toast .toast-link::after {\n  content: \"\";\n  position: relative;\n  width: 24px;\n  height: 24px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.2929 17.7929C12.9024 18.1834 12.9024 18.8166 13.2929 19.2071C13.6834 19.5976 14.3166 19.5976 14.7071 19.2071L20.5 13.4142C21.281 12.6332 21.281 11.3668 20.5 10.5858L14.7071 4.79289C14.3166 4.40237 13.6834 4.40237 13.2929 4.79289C12.9024 5.18342 12.9024 5.81658 13.2929 6.20711L18.0858 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H18.0858L13.2929 17.7929Z' fill='%23FFD748'/%3E%3C/svg%3E%0A\");\n}\n.toast .toast-text {\n  color: #fff;\n  font-family: \"Circular Std\";\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n@media screen and (max-width: 1280px) {\n  .toast {\n    padding: 0.7813vw 0;\n  }\n  .toast.toast--color .toast-content {\n    gap: 0.2344vw;\n  }\n  .toast .toast-link {\n    gap: 0.625vw;\n    font-size: 1.1719vw;\n  }\n  .toast .toast-link::after {\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n  .toast .toast-text {\n    font-size: 1.1719vw;\n  }\n}\n@media screen and (max-width: 1150px) {\n  .toast {\n    padding: 10px 0;\n  }\n  .toast.toast--color .toast-content {\n    gap: 3px;\n  }\n  .toast .toast-link {\n    gap: 8px;\n    font-size: 15px;\n  }\n  .toast .toast-link::after {\n    width: 24px;\n    height: 24px;\n  }\n  .toast .toast-text {\n    font-size: 15px;\n  }\n}\n@media screen and (max-width: 850px) {\n  .toast {\n    padding: 2.5641vw 0;\n    height: 15.8974vw;\n  }\n  .toast.toast--color .toast-content,\n  .toast .toast-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    gap: 0.5128vw;\n  }\n  .toast .toast-link {\n    gap: 1.7949vw;\n    font-size: 2.8205vw;\n  }\n  .toast .toast-text {\n    font-size: 2.8205vw;\n  }\n}\n.get-started {\n  margin: 120px 0;\n}\n.get-started .get-started__wrapper {\n  max-width: 1150px;\n  width: 100%;\n  margin: 0 auto;\n  background-color: var(--black);\n  border-radius: 24px;\n  padding: 80px 60px;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 105px 295px;\n  grid-template-columns: 1fr 295px;\n  gap: 105px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.get-started .get-started__title {\n  color: var(--white);\n  font-family: \"Cambon\";\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 48px;\n  letter-spacing: -0.01em;\n}\n.get-started .get-started__title svg {\n  display: inline;\n}\n.get-started .get-started__link {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  width: 295px;\n  padding: 25px 80px;\n  font-family: \"Circular Std\";\n  font-size: 24px;\n  font-weight: 500;\n  color: var(--dark);\n  text-align: center;\n  background-color: var(--yellow);\n  border-radius: 12px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  border: 1px solid var(--yellow);\n}\n.get-started .get-started__link:hover {\n  background-color: var(--dark);\n  color: var(--white);\n}\n.get-started--column {\n  margin: 79px 0 86px 0;\n  padding-top: 79px;\n  position: relative;\n}\n.get-started--column::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -90px;\n  right: -90px;\n  height: 1px;\n  background: rgba(22, 22, 22, 0.1294117647);\n}\n.get-started--column .get-started__wrapper {\n  -ms-grid-columns: 1fr !important;\n  grid-template-columns: 1fr !important;\n  gap: 20px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 0;\n  background-color: transparent;\n}\n.get-started--column .get-started__wrapper .get-started__title {\n  color: var(--black);\n  font-size: 28px;\n  margin-bottom: 0;\n  text-align: center;\n}\n.get-started--column .get-started__wrapper .get-started__link {\n  width: 139px;\n  font-size: 17px;\n  padding: 12px 24px;\n  text-decoration: none !important;\n  margin: 0 auto;\n}\n.get-started--big {\n  margin: 78px 0 108px 0;\n}\n.get-started--big .get-started__wrapper {\n  max-width: 100%;\n  padding: 55px 60px;\n  -ms-grid-columns: 1fr 250px;\n  grid-template-columns: 1fr 250px;\n}\n.get-started--big .get-started__wrapper .get-started__link {\n  padding: 16.5px 20px;\n  width: 187px;\n  font-size: 17px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-left: auto;\n}\n.get-started--big .get-started__title svg {\n  -webkit-transform: translateY(7px);\n  transform: translateY(7px);\n}\n\n@media screen and (max-width: 1330px) {\n  .get-started {\n    margin: 9.023vw 0;\n  }\n  .get-started .get-started__wrapper {\n    max-width: 86.466vw;\n    border-radius: 1.805vw;\n    padding: 6.015vw 4.511vw;\n    -ms-grid-columns: 1fr 7.895vw 22.18vw;\n    grid-template-columns: 1fr 22.18vw;\n    gap: 7.895vw;\n  }\n  .get-started .get-started__title {\n    font-size: 3.008vw;\n    line-height: 3.609vw;\n  }\n  .get-started .get-started__link {\n    width: 22.18vw;\n    padding: 1.88vw 6.015vw;\n    font-size: 1.805vw;\n    border-radius: 0.902vw;\n    border: 0.075vw solid var(--yellow);\n  }\n  .get-started--column {\n    margin: 5.94vw 0 6.466vw 0;\n    padding-top: 5.94vw;\n  }\n  .get-started--column::after {\n    left: -6.767vw;\n    right: -6.767vw;\n    height: 0.075vw;\n  }\n  .get-started--column .get-started__wrapper {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    padding: 0;\n    gap: 1.504vw;\n  }\n  .get-started--column .get-started__link {\n    width: 10.451vw;\n    font-size: 1.278vw;\n    padding: 0.902vw 1.805vw;\n  }\n  .get-started--column .get-started__title {\n    font-size: 2.105vw;\n  }\n  .get-started--big {\n    margin: 5.865vw 0 8.12vw 0;\n  }\n  .get-started--big .get-started__wrapper {\n    padding: 4.135vw 4.511vw;\n  }\n  .get-started--big .get-started__wrapper .get-started__link {\n    padding: 1.241vw 1.305vw;\n    width: 14.06vw;\n    font-size: 1.278vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .get-started {\n    margin: 9.375vw 0;\n  }\n  .get-started .get-started__wrapper {\n    max-width: 89.844vw;\n    border-radius: 1.875vw;\n    padding: 6.25vw 4.688vw;\n    -ms-grid-columns: 1fr 8.203vw 23.047vw;\n    grid-template-columns: 1fr 23.047vw;\n    gap: 8.203vw;\n  }\n  .get-started .get-started__title {\n    font-size: 3.125vw;\n    line-height: 3.75vw;\n  }\n  .get-started .get-started__link {\n    width: 23.047vw;\n    padding: 1.953vw 6.25vw;\n    font-size: 1.875vw;\n    border-radius: 0.938vw;\n    border: 0.078vw solid var(--yellow);\n  }\n  .get-started--column {\n    margin: 6.172vw 0 6.719vw 0;\n    padding-top: 6.172vw;\n  }\n  .get-started--column::after {\n    left: -7.031vw;\n    right: -7.031vw;\n    height: 0.078vw;\n  }\n  .get-started--column .get-started__wrapper {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    padding: 0;\n    gap: 2.5vw;\n  }\n  .get-started--column .get-started__link {\n    width: 10.859vw;\n    font-size: 1.328vw;\n    padding: 0.938vw 1.875vw;\n  }\n  .get-started--column .get-started__title {\n    font-size: 2.188vw;\n  }\n  .get-started--big {\n    margin: 6.094vw 0 8.438vw 0;\n  }\n  .get-started--big .get-started__wrapper {\n    padding: 4.297vw 4.688vw;\n  }\n  .get-started--big .get-started__wrapper .get-started__link {\n    padding: 1.289vw 1.275vw;\n    width: 14.609vw;\n    font-size: 1.328vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .get-started {\n    margin: 5.128vw 0;\n  }\n  .get-started .get-started__wrapper {\n    max-width: 100%;\n    border-radius: 6.154vw;\n    padding: 8.205vw;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    gap: 2.564vw;\n  }\n  .get-started .get-started__title {\n    font-size: 6.154vw;\n    line-height: 1.2;\n  }\n  .get-started .get-started__title svg {\n    width: 7.949vw;\n    height: 4.615vw;\n  }\n  .get-started .get-started__link {\n    width: auto;\n    padding: 5.128vw 7.179vw;\n    font-size: 4.359vw;\n    border-radius: 3.077vw;\n    border: 0.256vw solid var(--yellow);\n  }\n  .get-started--column {\n    margin: 10.256vw 0 14.103vw 0;\n    padding-top: 12.821vw;\n  }\n  .get-started--column::after {\n    left: 0;\n    right: 0;\n    height: 0.256vw;\n  }\n  .get-started--column .get-started__wrapper {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    padding: 0;\n    gap: 8.205vw;\n    max-width: 69.231vw;\n    margin: 0 auto;\n  }\n  .get-started--column .get-started__link {\n    min-width: 35.641vw;\n    font-size: 4.359vw;\n    padding: 5.128vw 6.154vw;\n  }\n  .get-started--column .get-started__title {\n    font-size: 2.188vw;\n  }\n  .get-started--big {\n    margin: 12.821vw 0 10.256vw 0;\n  }\n  .get-started--big .get-started__wrapper {\n    padding: 8.205vw 8.205vw;\n  }\n  .get-started--big .get-started__wrapper .get-started__link {\n    padding: 4.28vw 5.718vw;\n    width: 53.077vw;\n    font-size: 4.359vw;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .get-started--big .get-started__title {\n    max-width: 63vw;\n    margin-bottom: 2.372vw;\n  }\n  .get-started--big .get-started__title br {\n    display: none;\n  }\n  .get-started--big .get-started__title svg {\n    height: 8.615vw;\n  }\n}\n.blog-single-article-card {\n  margin: 32px 0;\n  display: block;\n  text-decoration: none !important;\n}\n.blog-single-article-card__content {\n  max-width: 360px;\n  width: 100%;\n  margin-bottom: 0 !important;\n}\n.blog-single-article-card__text {\n  font-family: \"Cambon\";\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 34px;\n  letter-spacing: -0.02em;\n  margin-bottom: 0 !important;\n}\n.blog-single-article-card__text span {\n  display: block;\n}\n.blog-single-article-card__text span:empty {\n  height: 5px;\n}\n.blog-single-article-card__text p {\n  margin-bottom: 0 !important;\n}\n.blog-single-article-card--blockquote {\n  background-color: #fdfada;\n  border-radius: 24px;\n  padding: 39px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  gap: 33px;\n  margin: 32px 0;\n}\n.blog-single-article-card--blockquote .blog-single-article-card__text span {\n  font-family: \"Cambon\";\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 34px;\n  letter-spacing: -0.02em;\n}\n.blog-single-article-card__author {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 65px 14px 1fr;\n  grid-template-columns: 65px 1fr;\n  gap: 14px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-top: 48px;\n}\n.blog-single-article-card__author img {\n  width: 65px;\n  height: 65px;\n  border-radius: 50%;\n}\n.blog-single-article-card__author-name b {\n  display: block;\n  font-family: \"Circular Std\";\n  font-size: 17px;\n  font-weight: 500;\n  line-height: 1.29;\n  margin-bottom: 4px !important;\n}\n.blog-single-article-card__author-name span {\n  display: block;\n  font-family: \"Circular Std\";\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.26;\n}\n.blog-single-article-card__img {\n  max-width: 100%;\n  width: 100%;\n  height: 100%;\n  border-radius: 15.6px;\n  overflow: hidden;\n}\n.blog-single-article-card__img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  -o-object-position: center;\n  object-position: center;\n}\n\n@media screen and (max-width: 1330px) {\n  .blog-single-article-card {\n    margin: 2.406vw 0;\n  }\n  .blog-single-article-card__content {\n    max-width: 27.068vw;\n  }\n  .blog-single-article-card__text {\n    font-size: 2.105vw;\n    line-height: 2.556vw;\n  }\n  .blog-single-article-card__text span:empty {\n    height: 0.376vw;\n  }\n  .blog-single-article-card--blockquote {\n    border-radius: 1.805vw;\n    padding: 2.932vw;\n    gap: 2.481vw;\n    margin: 2.406vw 0;\n  }\n  .blog-single-article-card--blockquote .blog-single-article-card__text span {\n    font-size: 2.105vw;\n    line-height: 2.556vw;\n  }\n  .blog-single-article-card--v2 .blog-single-article-card__text {\n    max-width: 25.564vw;\n  }\n  .blog-single-article-card--v2\n    .blog-single-article-card__text\n    span:nth-child(1) {\n    font-size: 2.932vw;\n    margin-bottom: 0.376vw !important;\n  }\n  .blog-single-article-card--v2\n    .blog-single-article-card__text\n    span:nth-child(2) {\n    font-size: 2.406vw;\n    margin-bottom: 0.376vw !important;\n  }\n  .blog-single-article-card--v2\n    .blog-single-article-card__text\n    span:nth-child(3) {\n    font-size: 6.316vw;\n  }\n  .blog-single-article-card--v3 {\n    gap: 1.88vw;\n  }\n  .blog-single-article-card--v3\n    .blog-single-article-card__text\n    span:nth-child(1) {\n    font-size: 3.008vw;\n    margin-bottom: 1.579vw !important;\n  }\n  .blog-single-article-card--v3\n    .blog-single-article-card__text\n    span:nth-child(2) {\n    font-size: 2.105vw;\n    margin-bottom: 1.654vw !important;\n  }\n  .blog-single-article-card--v3\n    .blog-single-article-card__text\n    span:nth-child(3) {\n    font-size: 2.105vw;\n  }\n  .blog-single-article-card--v4 .blog-single-article-card__text {\n    max-width: 25.564vw;\n  }\n  .blog-single-article-card--v4\n    .blog-single-article-card__text\n    span:nth-child(1) {\n    font-size: 2.707vw;\n    line-height: 3.233vw;\n    margin-bottom: 0.376vw !important;\n  }\n  .blog-single-article-card--v4\n    .blog-single-article-card__text\n    span:nth-child(2) {\n    font-size: 6.015vw;\n  }\n  .blog-single-article-card__author {\n    -ms-grid-columns: 4.887vw 1.053vw 1fr;\n    grid-template-columns: 4.887vw 1fr;\n    gap: 1.053vw;\n    margin-top: 3.609vw;\n  }\n  .blog-single-article-card__author img {\n    width: 4.887vw;\n    height: 4.887vw;\n  }\n  .blog-single-article-card__author-name b {\n    font-size: 1.278vw;\n    margin-bottom: 0.301vw !important;\n  }\n  .blog-single-article-card__author-name span {\n    font-size: 1.128vw;\n  }\n  .blog-single-article-card__img {\n    border-radius: 1.173vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .blog-single-article-card {\n    margin: 6.154vw 0;\n  }\n  .blog-single-article-card__content {\n    max-width: 37.179vw;\n    width: 37.179vw;\n  }\n  .blog-single-article-card__text {\n    font-size: 7.179vw;\n    font-weight: 700;\n    line-height: 8.718vw;\n  }\n  .blog-single-article-card__text span:empty {\n    height: 1.282vw;\n  }\n  .blog-single-article-card--blockquote {\n    padding: 4.615vw;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    gap: 5.41vw;\n    margin: 6.154vw 0;\n  }\n  .blog-single-article-card--blockquote .blog-single-article-card__text span {\n    font-size: 7.179vw;\n    line-height: 8.718vw;\n  }\n  .blog-single-article-card--v2 {\n    gap: 8.205vw;\n  }\n  .blog-single-article-card--v2 .blog-single-article-card__text {\n    max-width: 100%;\n  }\n  .blog-single-article-card--v2\n    .blog-single-article-card__text\n    span:nth-child(1) {\n    font-size: 8.205vw;\n    margin-bottom: 1.282vw !important;\n  }\n  .blog-single-article-card--v2\n    .blog-single-article-card__text\n    span:nth-child(2) {\n    font-size: 7.179vw;\n    margin-bottom: 1.282vw !important;\n  }\n  .blog-single-article-card--v2\n    .blog-single-article-card__text\n    span:nth-child(3) {\n    font-size: 12.821vw;\n  }\n  .blog-single-article-card--v3 {\n    gap: 8.205vw;\n  }\n  .blog-single-article-card--v3\n    .blog-single-article-card__text\n    span:nth-child(1) {\n    font-size: 8.718vw;\n    margin-bottom: 5.385vw !important;\n  }\n  .blog-single-article-card--v3\n    .blog-single-article-card__text\n    span:nth-child(2) {\n    font-size: 6.154vw;\n    margin-bottom: 5.641vw !important;\n  }\n  .blog-single-article-card--v3\n    .blog-single-article-card__text\n    span:nth-child(3) {\n    font-size: 6.154vw;\n  }\n  .blog-single-article-card--v4 {\n    gap: 8.205vw;\n  }\n  .blog-single-article-card--v4 .blog-single-article-card__text {\n    max-width: 100%;\n  }\n  .blog-single-article-card--v4\n    .blog-single-article-card__text\n    span:nth-child(1) {\n    font-size: 8.205vw;\n    line-height: 1.2;\n    margin-bottom: 1.282vw !important;\n  }\n  .blog-single-article-card--v4\n    .blog-single-article-card__text\n    span:nth-child(2) {\n    font-size: 12.821vw;\n  }\n  .blog-single-article-card__author {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 12.821vw 3.077vw 1fr;\n    grid-template-columns: 12.821vw 1fr;\n    gap: 3.077vw;\n    margin-top: 8.205vw;\n    padding: 0 5.128vw 0 5.128vw;\n  }\n  .blog-single-article-card__author img {\n    width: 12.821vw;\n    height: 12.821vw;\n  }\n  .blog-single-article-card__author-name b {\n    font-size: 4.359vw;\n    margin-bottom: 1.026vw !important;\n  }\n  .blog-single-article-card__author-name span {\n    font-size: 3.59vw;\n  }\n  .blog-single-article-card__img {\n    border-radius: 4vw;\n    margin-bottom: 0 !important;\n  }\n}\n.blog-single-article-v2 .text h5 {\n  margin-bottom: 32px !important;\n}\n.blog-single-article-v2 .text h3 {\n  font-family: \"Cambon\" !important;\n  position: relative;\n  padding-top: 64px;\n  margin-top: 64px;\n}\n.blog-single-article-v2 .text h3::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -90px;\n  right: -90px;\n  height: 1px;\n  background: rgba(22, 22, 22, 0.1294117647);\n}\n.blog-single-article-v2 .title-step {\n  padding-top: 64px;\n  padding-bottom: 16px;\n  position: relative;\n  margin-top: 64px;\n  margin-bottom: 0 !important;\n}\n.blog-single-article-v2 .title-step::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -90px;\n  right: -90px;\n  height: 1px;\n  background: rgba(22, 22, 22, 0.1294117647);\n}\n.blog-single-article-v2 .title-step span {\n  display: inline-block;\n  font-family: \"Cambon\";\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  padding: 10px 24px;\n  border-radius: 16px;\n  min-width: 90px;\n  background-color: var(--yellow);\n}\n.blog-single-article-v2 .title-step + h3 {\n  padding-top: 0;\n  margin-top: 0;\n}\n.blog-single-article-v2 .title-step + h3::after {\n  display: none;\n}\n.blog-single-article-v2 .get-started {\n  margin: 32px 0 64px 0 !important;\n}\n.blog-single-article-v2 .get-started__link {\n  width: 139px;\n  font-size: 17px;\n  padding: 12px 24px;\n  text-decoration: none !important;\n}\n.blog-single-article-v2 .get-started__wrapper {\n  -ms-grid-columns: 1fr 139px;\n  grid-template-columns: 1fr 139px;\n  padding: 55px 60px;\n}\n.blog-single-article-v2 .get-started.get-started--column {\n  padding-top: 79px;\n  margin: 100px 0 0 0 !important;\n}\n.blog-single-article-v2 .get-started.get-started--column .get-started__wrapper {\n  -ms-grid-columns: 1fr;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  padding: 0;\n}\n.blog-single-article-v2 .get-started__title {\n  font-size: 28px;\n  margin-bottom: 0;\n}\n.blog-single-article-v2 .blog-single-article-list {\n  padding: 40px;\n  border-radius: 24px;\n  border: 1px solid rgba(22, 22, 22, 0.1490196078);\n}\n.blog-single-article-v2 .blog-single-article-list ol li {\n  list-style: decimal;\n  font-family: \"Circular Std\";\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.72;\n  letter-spacing: -0.01em;\n  list-style-position: outside;\n  margin-left: 30px;\n}\n.blog-single-article-v2 .blog-single-article-list ol li::before {\n  display: none;\n}\n.blog-single-article-v2 .blog-single-article__table {\n  font-family: \"Circular Std\";\n  margin: 40px 0 64px 0 !important;\n}\n.blog-single-article-v2 .blog-single-article__table * {\n  margin-bottom: 0 !important;\n}\n.blog-single-article-v2 .blog-single-article__table .theader {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 120px 30px 1fr 30px 1fr;\n  grid-template-columns: 120px repeat(2, 1fr);\n  gap: 0 30px;\n}\n.blog-single-article-v2 .blog-single-article__table .theader-item {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.22;\n  letter-spacing: -0.01em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: relative;\n  background: #f6f5ef;\n  padding: 12px 15px 12px 18px;\n  border-radius: 12px;\n}\n.blog-single-article-v2 .blog-single-article__table .theader-item::before {\n  content: \"\";\n  position: relative;\n  gap: 10px;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z' stroke='%23ACA59A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n}\n.blog-single-article-v2\n  .blog-single-article__table\n  .theader-item:nth-child(2)::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5 11L9.5 14L15.5 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z' stroke='%23ACA59A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n}\n.blog-single-article-v2 .blog-single-article__table .tbody {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 120px 30px 1fr 30px 1fr;\n  grid-template-columns: 120px repeat(2, 1fr);\n  gap: 0 30px;\n}\n.blog-single-article-v2 .blog-single-article__table .tbody__title {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.22;\n  letter-spacing: -0.01em;\n  margin-top: 32px;\n}\n.blog-single-article-v2 .blog-single-article__table .tbody__text {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.22;\n  letter-spacing: -0.01em;\n  padding: 0 10px 0 20px;\n  margin-top: 32px;\n}\n.blog-single-article-v2 .blog-single-article__table .tbody__text a {\n  display: inline;\n  text-underline-offset: 4px;\n}\n.blog-single-article-v2 + .more-info .more-info__header-title {\n  max-width: 640px;\n}\n\n@media screen and (max-width: 1330px) {\n  .blog-single-article-v2 .text h5 {\n    margin-bottom: 2.406vw !important;\n  }\n  .blog-single-article-v2 .text h3 {\n    padding-top: 4.812vw;\n    margin-top: 4.812vw;\n  }\n  .blog-single-article-v2 .text h3::after {\n    left: -6.767vw;\n    right: -6.767vw;\n    height: 0.075vw;\n  }\n  .blog-single-article-v2 .title-step {\n    padding-top: 4.812vw;\n    padding-bottom: 1.203vw;\n    margin-top: 4.812vw;\n  }\n  .blog-single-article-v2 .title-step::after {\n    left: -6.767vw;\n    right: -6.767vw;\n    height: 0.075vw;\n  }\n  .blog-single-article-v2 .title-step span {\n    font-size: 3.008vw;\n    padding: 0.752vw 1.805vw;\n    border-radius: 1.203vw;\n    min-width: 6.767vw;\n  }\n  .blog-single-article-v2 .get-started {\n    margin: 2.406vw 0 4.812vw 0 !important;\n  }\n  .blog-single-article-v2 .get-started__link {\n    width: 10.451vw;\n    font-size: 1.278vw;\n    padding: 0.902vw 1.805vw;\n  }\n  .blog-single-article-v2 .get-started__wrapper {\n    -ms-grid-columns: 1fr 10.451vw;\n    grid-template-columns: 1fr 10.451vw;\n    padding: 4.135vw 4.511vw;\n  }\n  .blog-single-article-v2 .get-started__title {\n    font-size: 2.105vw;\n  }\n  .blog-single-article-v2 .get-started.get-started--column {\n    margin: 7.519vw 0 0 0 !important;\n    padding-top: 5.94vw;\n  }\n  .blog-single-article-v2\n    .get-started.get-started--column\n    .get-started__wrapper {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    gap: 1.504vw;\n    padding: 0;\n  }\n  .blog-single-article-v2 .blog-single-article-list {\n    padding: 3.008vw;\n    border-radius: 1.805vw;\n    border: 0.075vw solid rgba(22, 22, 22, 0.1490196078);\n  }\n  .blog-single-article-v2 .blog-single-article-list ol li {\n    font-size: 1.353vw;\n    margin-left: 2.256vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table {\n    margin: 3.008vw 0 4.812vw 0 !important;\n  }\n  .blog-single-article-v2 .blog-single-article__table .theader {\n    -ms-grid-columns: 9.023vw 2.256vw 1fr 2.256vw 1fr;\n    grid-template-columns: 9.023vw repeat(2, 1fr);\n    gap: 0 2.256vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .theader-item {\n    font-size: 1.353vw;\n    gap: 0.752vw;\n    padding: 0.902vw 1.128vw 0.902vw 1.353vw;\n    border-radius: 0.902vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .theader-item::before {\n    width: 1.654vw;\n    height: 1.654vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .tbody {\n    -ms-grid-columns: 9.023vw 2.256vw 1fr 2.256vw 1fr;\n    grid-template-columns: 9.023vw repeat(2, 1fr);\n    gap: 0 2.256vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .tbody__title {\n    font-size: 1.353vw;\n    margin-top: 2.406vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .tbody__text {\n    font-size: 1.353vw;\n    letter-spacing: -0.01em;\n    padding: 0 0.752vw 0 1.504vw;\n    margin-top: 2.406vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .tbody__text a {\n    text-underline-offset: 0.301vw;\n  }\n  .blog-single-article-v2 + .more-info .more-info__header-title {\n    max-width: 38.5313vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .blog-single-article-v2 .text {\n    font-size: 4.103vw;\n  }\n  .blog-single-article-v2 .text h5 {\n    margin-bottom: 8.205vw !important;\n  }\n  .blog-single-article-v2 .text h3 {\n    padding-top: 8.205vw;\n    margin-top: 8.205vw;\n    font-size: 7.179vw;\n  }\n  .blog-single-article-v2 .text h3::after {\n    left: -5.1282vw;\n    right: -5.1282vw;\n    height: 0.256vw;\n  }\n  .blog-single-article-v2 .text h4:first-of-type {\n    font-weight: 450;\n  }\n  .blog-single-article-v2 .text h4 {\n    font-size: 5.128vw !important;\n  }\n  .blog-single-article-v2 .title-step {\n    padding-top: 8.205vw;\n    padding-bottom: 4.103vw;\n    margin-top: 8.205vw;\n  }\n  .blog-single-article-v2 .title-step::after {\n    left: -5.128vw;\n    right: -5.128vw;\n    height: 0.256vw;\n  }\n  .blog-single-article-v2 .title-step span {\n    font-size: 7.179vw;\n    padding: 4.103vw 6.154vw;\n    border-radius: 4.103vw;\n    min-width: 20vw;\n  }\n  .blog-single-article-v2 .title-step + h3 {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n  }\n  .blog-single-article-v2 .get-started {\n    margin: 8.205vw 0 8.205vw 0 !important;\n  }\n  .blog-single-article-v2 .get-started__link {\n    width: auto;\n    padding: 3.128vw 7.179vw;\n    font-size: 4.359vw;\n    border-radius: 3.077vw;\n  }\n  .blog-single-article-v2 .get-started__wrapper {\n    max-width: 100%;\n    border-radius: 6.154vw;\n    padding: 8.205vw;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    gap: 2.564vw;\n  }\n  .blog-single-article-v2 .get-started__title {\n    font-size: 6.154vw;\n    line-height: 1.2;\n  }\n  .blog-single-article-v2 .get-started__title svg {\n    width: 7.949vw;\n    height: 4.615vw;\n    margin-bottom: 0;\n  }\n  .blog-single-article-v2 .get-started.get-started--column {\n    margin: 10.256vw 0 0 0 !important;\n    padding-top: 12.821vw;\n  }\n  .blog-single-article-v2 .get-started.get-started--column::after {\n    left: 0;\n    right: 0;\n    height: 0.256vw;\n  }\n  .blog-single-article-v2\n    .get-started.get-started--column\n    .get-started__wrapper {\n    -ms-grid-columns: 1fr;\n    grid-template-columns: 1fr;\n    padding: 0;\n    gap: 8.205vw;\n    max-width: 69.231vw;\n    margin: 0 auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n  .blog-single-article-v2 .get-started.get-started--column .get-started__link {\n    min-width: 35.641vw;\n    font-size: 4.359vw;\n    padding: 3.128vw 6.154vw;\n  }\n  .blog-single-article-v2 .get-started.get-started--column .get-started__title {\n    text-align: center;\n    font-size: 6.154vw;\n  }\n  .blog-single-article-v2 .blog-single-article-list {\n    padding: 6.41vw;\n    border-radius: 6.154vw;\n    border: 0.256vw solid rgba(22, 22, 22, 0.1490196078);\n  }\n  .blog-single-article-v2 .blog-single-article-list h4 {\n    max-width: 102.564vw;\n    font-size: 5.128vw;\n  }\n  .blog-single-article-v2 .blog-single-article-list h4 br {\n    display: none;\n  }\n  .blog-single-article-v2 .blog-single-article-list ol li {\n    font-size: 4.103vw;\n    margin-left: 7.692vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table {\n    margin: 8.205vw -5.128vw 8.205vw 0 !important;\n    max-width: 100%;\n    overflow: auto;\n    padding-left: 6.154vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .theader {\n    -ms-grid-columns: 30.769vw 5.128vw 71.795vw 5.128vw 71.795vw;\n    grid-template-columns: 30.769vw repeat(2, 71.795vw);\n    gap: 0 5.128vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .theader-item {\n    font-size: 4.615vw;\n    gap: 2.564vw;\n    padding: 3.077vw 3.846vw 3.077vw 4.615vw;\n    border-radius: 3.077vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .theader-item::before {\n    width: 4.615vw;\n    height: 4.615vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .tbody {\n    -ms-grid-columns: 30.769vw 5.128vw 71.795vw 5.128vw 71.795vw;\n    grid-template-columns: 30.769vw repeat(2, 71.795vw);\n    gap: 0 5.128vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .tbody__title {\n    font-size: 4.615vw;\n    margin-top: 8.205vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .tbody__text {\n    font-size: 4.615vw;\n    padding: 0 2.564vw;\n    margin-top: 6.41vw;\n  }\n  .blog-single-article-v2 .blog-single-article__table .tbody__text a {\n    text-underline-offset: 1.026vw;\n  }\n  .blog-single-article-v2 + .more-info .more-info__header-title {\n    max-width: 100%;\n  }\n}\n.table-dec {\n  margin: 60px 0;\n}\n.table-dec .table-dec__title {\n  display: none;\n}\n.table-dec .table-dec__wrapper {\n  background-color: #f6f5ef;\n  border-radius: 16px;\n  padding: 60px 89px 15px 63px;\n}\n.table-dec .theader {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 200px (1fr) [2];\n  grid-template-columns: 200px repeat(2, 1fr);\n  padding-right: 57px;\n  margin-bottom: 10px;\n}\n.table-dec .theader-item {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.22;\n  letter-spacing: -0.01em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: relative;\n  background: #fff;\n  padding: 18px 15px 18px 18px;\n  border-radius: 12px;\n}\n.table-dec .theader-item:first-child {\n  margin-right: 20px;\n}\n.table-dec .theader-item::before {\n  content: \"\";\n  position: relative;\n  gap: 10px;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z' stroke='%23E95B86' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n}\n.table-dec .theader-item:nth-child(2) {\n  margin-right: 45px;\n}\n.table-dec .theader-item:nth-child(2)::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5 11L9.5 14L15.5 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z' stroke='%234DAE9B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\");\n}\n.table-dec .tbody__item {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 180px 20px 1fr 20px 1fr;\n  grid-template-columns: 180px repeat(2, 1fr);\n  gap: 0 20px;\n  padding: 27px 57px 30px 0;\n  border-bottom: 1px solid rgba(22, 22, 22, 0.2117647059);\n}\n.table-dec .tbody__item:last-child {\n  border-bottom: transparent;\n}\n.table-dec .tbody__title {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.22;\n  letter-spacing: -0.01em;\n}\n.table-dec .tbody__text {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.22;\n  letter-spacing: -0.01em;\n  padding: 0 10px 0 20px;\n}\n.table-dec .tbody__text p {\n  margin-bottom: 11px;\n  max-width: 306px;\n}\n.table-dec .tbody__text a {\n  display: block;\n  text-underline-offset: 4px;\n  text-decoration: underline;\n  max-width: 256px;\n  line-height: 1.3;\n}\n\n@media screen and (max-width: 1330px) {\n  .table-dec {\n    margin: 4.511vw 0;\n  }\n  .table-dec .table-dec__wrapper {\n    border-radius: 1.203vw;\n    padding: 4.511vw 6.692vw 1.128vw 4.737vw;\n  }\n  .table-dec .theader {\n    -ms-grid-columns: 15.038vw (1fr) [2];\n    grid-template-columns: 15.038vw repeat(2, 1fr);\n    padding-right: 4.286vw;\n    margin-bottom: 0.752vw;\n  }\n  .table-dec .theader-item {\n    font-size: 1.353vw;\n    gap: 0.752vw;\n    padding: 1.353vw 1.128vw 1.353vw 1.353vw;\n    border-radius: 0.902vw;\n  }\n  .table-dec .theader-item:first-child {\n    margin-right: 1.504vw;\n  }\n  .table-dec .theader-item::before {\n    gap: 0.752vw;\n    width: 1.654vw;\n    height: 1.654vw;\n  }\n  .table-dec .theader-item:nth-child(2) {\n    margin-right: 3.383vw;\n  }\n  .table-dec .tbody__item {\n    -ms-grid-columns: 13.534vw 1.504vw 1fr 1.504vw 1fr;\n    grid-template-columns: 13.534vw repeat(2, 1fr);\n    gap: 0 1.504vw;\n    padding: 2.03vw 4.286vw 2.256vw 0;\n    border-bottom: 0.075vw solid rgba(22, 22, 22, 0.2117647059);\n  }\n  .table-dec .tbody__title {\n    font-size: 1.353vw;\n  }\n  .table-dec .tbody__text {\n    font-size: 1.353vw;\n    padding: 0 0.752vw 0 1.504vw;\n  }\n  .table-dec .tbody__text p {\n    margin-bottom: 0.827vw;\n    max-width: 23.008vw;\n  }\n  .table-dec .tbody__text a {\n    text-underline-offset: 0.301vw;\n    max-width: 19.248vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .table-dec {\n    margin: 15.385vw 0;\n  }\n  .table-dec .table-dec__title {\n    display: block;\n    text-align: center;\n    max-width: 68.205vw;\n    margin: 0 auto 11.026vw auto;\n    font-family: \"Cambon\";\n    font-size: 8.205vw;\n    font-weight: 700;\n    line-height: 1.18;\n  }\n  .table-dec .table-dec__wrapper {\n    border-radius: 4.103vw;\n    padding: 15.385vw 6.59vw 3.846vw 12.59vw;\n    overflow: auto;\n    max-width: 100%;\n  }\n  .table-dec .theader {\n    -ms-grid-columns: 33.846vw (78.462vw) [2];\n    grid-template-columns: 33.846vw repeat(2, 78.462vw);\n    padding-right: 0;\n    margin-bottom: 10px;\n  }\n  .table-dec .theader-item {\n    font-size: 4.615vw;\n    gap: 2.564vw;\n    padding: 4.615vw 3.846vw 4.615vw 4.615vw;\n    border-radius: 3.077vw;\n  }\n  .table-dec .theader-item:first-child {\n    margin-right: 5.128vw;\n  }\n  .table-dec .theader-item::before {\n    gap: 2.564vw;\n    width: 5.641vw;\n    height: 5.641vw;\n  }\n  .table-dec .theader-item:nth-child(2) {\n    margin-right: 11.538vw;\n  }\n  .table-dec .tbody {\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n  }\n  .table-dec .tbody__item {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 36.615vw 5.128vw 71.462vw 5.128vw 71.462vw;\n    grid-template-columns: 36.615vw repeat(2, 71.462vw);\n    gap: 0 5.128vw;\n    padding: 5.641vw 10.256vw 7.692vw 0;\n    border-bottom: 0.256vw solid rgba(22, 22, 22, 0.2117647059);\n  }\n  .table-dec .tbody__title {\n    font-size: 4.615vw;\n  }\n  .table-dec .tbody__text {\n    font-size: 4.615vw;\n    padding: 0 2.564vw 0 0;\n  }\n  .table-dec .tbody__text p {\n    margin-bottom: 2.821vw;\n    max-width: 65.641vw;\n  }\n  .table-dec .tbody__text a {\n    text-underline-offset: 1.026vw;\n    max-width: 65.641vw;\n  }\n}\n.section-form {\n  margin-bottom: 100px;\n}\n.section-form .section-form__top {\n  text-align: center;\n  max-width: 980px;\n  width: 100%;\n  margin: 0 auto 75px auto;\n}\n.section-form .section-form__top .title {\n  margin-bottom: 30px;\n}\n.section-form .section-form__top .subtitle {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 30px;\n  letter-spacing: -0.01em;\n  text-align: center;\n  max-width: 85%;\n  margin: 0 auto;\n}\n.section-form__inner {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 99px;\n  padding: 72px 0 88px 157px;\n  border-radius: 24px;\n  background-color: #4ba594;\n}\n.section-form .section-form__main {\n  width: 432px;\n  padding-top: 22px;\n}\n.section-form .section-form__main .title {\n  font-family: \"Circular Std\";\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: -0.01em;\n  color: var(--white);\n  margin-bottom: 11px;\n}\n.section-form .section-form__main form {\n  position: relative;\n}\n.section-form .section-form__main form .hs_error_rollup {\n  color: white;\n  position: absolute;\n  left: 177px;\n  max-width: 185px;\n  bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.3;\n}\n.section-form .section-form__main form .hs-fieldtype-text label {\n  color: var(--white);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.01em;\n  margin-bottom: 8px;\n  display: block;\n}\n.section-form .section-form__main form fieldset {\n  margin-bottom: 22px;\n}\n.section-form .section-form__main form fieldset.form-columns-1 .input {\n  margin: 0;\n}\n.section-form .section-form__main form fieldset.form-columns-1 .hs-input {\n  width: 100%;\n}\n.section-form .section-form__main form fieldset.form-columns-2 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 24px;\n}\n.section-form .section-form__main form fieldset.form-columns-2 .input {\n  margin: 0;\n}\n.section-form .section-form__main form input {\n  width: 100%;\n  background: #e0f1ee;\n  padding: 12px 16px 14px 16px;\n  border-radius: 8px;\n  border: none;\n  color: var(--dark);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.01em;\n  border: 2px solid #e0f1ee;\n}\n.section-form .section-form__main form input.invalid,\n.section-form .section-form__main form input.error {\n  border: 2px solid #f32a2a;\n}\n.section-form .section-form__main form .hs-submit input {\n  background-color: var(--dark);\n  color: var(--white);\n  font-family: \"Circular Std\";\n  font-size: 17px;\n  font-weight: 500;\n  text-align: center;\n  border-radius: 12px;\n  padding: 13.5px 24px;\n  -webkit-transition: all 0.4s linear;\n  transition: all 0.4s linear;\n  width: 152px;\n  border-color: var(--dark);\n}\n.section-form .section-form__main form .hs-error-msgs {\n  display: none;\n}\n.section-form .section-form__main .submitted-message {\n  background-color: #3b3b3b;\n  border-radius: 5px;\n  padding: 29px 41px 35px 43px;\n  margin-bottom: 100px;\n  margin-top: 40px;\n  max-width: 383px;\n}\n.section-form .section-form__main .submitted-message p {\n  color: var(--white);\n}\n.section-form .section-form__main .submitted-message p:nth-child(1) {\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n  margin-bottom: 36px;\n}\n.section-form .section-form__main .submitted-message p:nth-child(2) {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n}\n.section-form .section-form__img img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n  -o-object-position: center right;\n  object-position: center right;\n}\n.section-form__wrapper {\n  margin-bottom: 24px;\n}\n.section-form__link a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.section-form__link a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.section-form__link a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.section-form__link a:hover::before {\n  -webkit-transform: translateX(3px);\n  transform: translateX(3px);\n}\n.section-form__link a:hover::after {\n  width: 0%;\n}\n\n@media screen and (max-width: 1330px) {\n  .section-form {\n    margin-bottom: 7.519vw;\n  }\n  .section-form .section-form__top {\n    max-width: 73.684vw;\n    margin: 0 auto 5.639vw auto;\n  }\n  .section-form .section-form__top .title {\n    margin-bottom: 2.256vw;\n  }\n  .section-form .section-form__top .subtitle {\n    font-size: 1.504vw;\n    line-height: 2.256vw;\n  }\n  .section-form__inner {\n    gap: 7.444vw;\n    padding: 5.414vw 0 6.617vw 11.805vw;\n    border-radius: 1.805vw;\n  }\n  .section-form .section-form__main {\n    width: 32.481vw;\n    padding-top: 1.654vw;\n  }\n  .section-form .section-form__main .title {\n    font-size: 2.105vw;\n    margin-bottom: 0.827vw;\n  }\n  .section-form .section-form__main form .hs_error_rollup {\n    left: 13.308vw;\n    max-width: 13.91vw;\n    bottom: 0.752vw;\n    font-size: 0.977vw;\n  }\n  .section-form .section-form__main form .hs-fieldtype-text label {\n    font-size: 1.203vw;\n    margin-bottom: 0.602vw;\n  }\n  .section-form .section-form__main form fieldset {\n    margin-bottom: 1.654vw;\n  }\n  .section-form .section-form__main form fieldset.form-columns-2 {\n    gap: 1.805vw;\n  }\n  .section-form .section-form__main form input {\n    padding: 1.053vw 1.203vw 1.203vw 1.203vw;\n    border-radius: 0.602vw;\n    font-size: 1.203vw;\n  }\n  .section-form .section-form__main form .hs-submit input {\n    font-size: 1.278vw;\n    border-radius: 0.902vw;\n    padding: 1.015vw 1.805vw;\n    width: 11.429vw;\n  }\n  .section-form .section-form__main .submitted-message {\n    border-radius: 0.376vw;\n    padding: 2.18vw 3.083vw 2.632vw 3.233vw;\n    margin-bottom: 7.519vw;\n    margin-top: 3.008vw;\n    max-width: 28.797vw;\n  }\n  .section-form .section-form__main .submitted-message p:nth-child(1) {\n    font-size: 2.105vw;\n    margin-bottom: 2.707vw;\n  }\n  .section-form .section-form__main .submitted-message p:nth-child(2) {\n    font-size: 1.203vw;\n  }\n  .section-form__wrapper {\n    margin-bottom: 1.805vw;\n  }\n  .section-form__link a {\n    padding-right: 2.256vw;\n    letter-spacing: -0.03vw;\n    font-size: 1.353vw;\n  }\n  .section-form__link a::before {\n    top: 0.15vw;\n    width: 1.805vw;\n    height: 1.805vw;\n  }\n  .section-form__link a::after {\n    width: calc(100% - 2.256vw);\n    height: 0.15vw;\n    -webkit-transform: translateX(-2.256vw);\n    transform: translateX(-2.256vw);\n  }\n}\n@media screen and (max-width: 850px) {\n  .section-form {\n    margin-bottom: 10.256vw;\n  }\n  .section-form .section-form__top {\n    max-width: 83.59vw;\n    margin: 0 auto 12.051vw auto;\n  }\n  .section-form .section-form__top .title {\n    margin-bottom: 6.41vw;\n  }\n  .section-form .section-form__top .subtitle {\n    font-size: 5.128vw;\n    font-weight: 400;\n    line-height: 7.692vw;\n    max-width: 100%;\n  }\n  .section-form__inner {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 10.256vw;\n    padding: 12.821vw 6.154vw 9.487vw 6.154vw;\n    border-radius: 6.154vw;\n  }\n  .section-form .section-form__main {\n    width: 100%;\n    padding-top: 0;\n  }\n  .section-form .section-form__main .title {\n    font-size: 6.154vw;\n    margin-bottom: 4.103vw;\n  }\n  .section-form .section-form__main .submitted-message {\n    border-radius: 1.282vw;\n    padding: 7.436vw 13.59vw 7.436vw 5.897vw;\n    margin-bottom: 35.897vw;\n    margin-top: 38.462vw;\n    max-width: 100%;\n  }\n  .section-form .section-form__main .submitted-message p:nth-child(1) {\n    font-size: 6.667vw;\n    margin-bottom: 8.462vw;\n  }\n  .section-form .section-form__main .submitted-message p:nth-child(2) {\n    font-size: 4.103vw;\n  }\n  .section-form .section-form__main form .hs_error_rollup {\n    max-width: 100%;\n    font-size: 3.333vw;\n    position: static;\n    margin: 8.205vw 0;\n  }\n  .section-form .section-form__main form .hs-fieldtype-text label {\n    font-size: 4.103vw;\n    margin-bottom: 2.051vw;\n  }\n  .section-form .section-form__main form fieldset {\n    margin-bottom: 4.103vw;\n  }\n  .section-form .section-form__main form fieldset.form-columns-2 {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 16px;\n  }\n  .section-form\n    .section-form__main\n    form\n    fieldset.form-columns-2\n    .hs-form-field {\n    width: 100%;\n  }\n  .section-form .section-form__main form input {\n    padding: 2.29vw 3.333vw 2.103vw 3.333vw;\n    border-radius: 2.051vw;\n    font-size: 4.103vw;\n  }\n  .section-form .section-form__main form .hs-submit input {\n    font-size: 4.359vw;\n    border-radius: 3.077vw;\n    padding: 3.462vw 6.154vw;\n    width: 100%;\n  }\n  .section-form .section-form__img {\n    width: calc(100% + 6.154vw);\n    margin-right: -6.154vw;\n  }\n  .section-form__wrapper {\n    margin-bottom: 6.154vw;\n  }\n  .section-form__link a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .section-form__link a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .section-form__link a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n  .section-form__link a:hover::before {\n    -webkit-transform: translateX(0.7692vw);\n    transform: translateX(0.7692vw);\n  }\n  .section-form__link a:hover::after {\n    width: 0%;\n  }\n}\n.review-banner {\n  margin-bottom: 120px;\n}\n.review-banner .review-banner__wrapper {\n  width: 100%;\n  max-width: 1290px;\n  margin: 0 auto;\n  border-radius: 24px;\n  background: var(--yellow);\n  overflow: hidden;\n  padding: 80px 80px 80px 114px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  gap: 85px;\n}\n.review-banner .review-banner__content {\n  width: 100%;\n  max-width: 487px;\n  margin-top: 15px;\n}\n.review-banner .review-banner__content-text {\n  font-weight: 400;\n  line-height: 1.4;\n  font-size: 28px;\n  letter-spacing: -0.01em;\n  color: var(--dark);\n  margin-bottom: 29px;\n}\n.review-banner .review-banner__content-logo {\n  width: 217px;\n  height: auto;\n  margin-bottom: 50px;\n}\n.review-banner .review-banner__content-logo img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.review-banner .review-banner__content-more a {\n  position: relative;\n  z-index: 2;\n  padding-right: 30px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.4px;\n  font-size: 18px;\n  color: var(--dark);\n}\n.review-banner .review-banner__content-more a::before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%232F2F2F' fill-rule='evenodd' d='m13.707 5.793-1.414 1.414L16.086 11H4v2h12.086l-3.793 3.793 1.414 1.415L19.914 12l-6.207-6.207Z' clip-rule='evenodd'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.review-banner .review-banner__content-more a::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: calc(100% - 30px);\n  height: 2px;\n  -webkit-transform: translateX(-30px);\n  transform: translateX(-30px);\n  background-color: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n@media screen and (min-width: 850px) {\n  .review-banner .review-banner__content-more a:hover::before {\n    -webkit-transform: translateX(3px);\n    transform: translateX(3px);\n  }\n  .review-banner .review-banner__content-more a:hover::after {\n    width: 0%;\n  }\n}\n@media screen and (max-width: 1330px) {\n  .review-banner .review-banner__content-more a {\n    padding-right: 2.2556vw;\n    letter-spacing: -0.0301vw;\n    font-size: 1.3534vw;\n  }\n  .review-banner .review-banner__content-more a::before {\n    top: 0.1504vw;\n    width: 1.8045vw;\n    height: 1.8045vw;\n  }\n  .review-banner .review-banner__content-more a::after {\n    width: calc(100% - 2.2556vw);\n    height: 0.1504vw;\n    -webkit-transform: translateX(-2.2556vw);\n    transform: translateX(-2.2556vw);\n  }\n  .review-banner .review-banner__content-more a:hover::before {\n    -webkit-transform: translateX(0.2256vw);\n    transform: translateX(0.2256vw);\n  }\n}\n@media screen and (max-width: 1280px) {\n  .review-banner .review-banner__content-more a {\n    padding-right: 2.0313vw;\n    letter-spacing: -0.0078vw;\n    font-size: 1.25vw;\n  }\n  .review-banner .review-banner__content-more a::before {\n    top: 0;\n    width: 1.875vw;\n    height: 1.875vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .review-banner .review-banner__content-more a {\n    padding-right: 7.6923vw;\n    line-height: 1.4;\n    letter-spacing: -0.041vw;\n    font-size: 4.1026vw;\n  }\n  .review-banner .review-banner__content-more a::before {\n    top: 0;\n    width: 6.1538vw;\n    height: 6.1538vw;\n  }\n  .review-banner .review-banner__content-more a::after {\n    width: calc(100% - 7.6923vw);\n    height: 0.5128vw;\n    -webkit-transform: translateX(-7.6923vw);\n    transform: translateX(-7.6923vw);\n  }\n}\n.review-banner .review-banner__image {\n  display: block;\n  width: 523px;\n  height: 370px;\n  border-radius: 24px;\n  overflow: hidden;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n.review-banner .review-banner__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media screen and (max-width: 1330px) {\n  .review-banner {\n    margin-bottom: 9.0226vw;\n  }\n  .review-banner .review-banner__wrapper {\n    max-width: 96.9925vw;\n    border-radius: 1.8045vw;\n    padding: 6.015vw 6.015vw 6.015vw 8.5714vw;\n    gap: 6.391vw;\n  }\n  .review-banner .review-banner__content {\n    max-width: 36.6165vw;\n    margin-top: 1.1278vw;\n  }\n  .review-banner .review-banner__content-text {\n    font-size: 2.1053vw;\n    margin-bottom: 2.1805vw;\n  }\n  .review-banner .review-banner__content-logo {\n    width: 16.3158vw;\n    margin-bottom: 3.7594vw;\n  }\n  .review-banner .review-banner__image {\n    width: 39.3233vw;\n    height: 27.8195vw;\n    border-radius: 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .review-banner {\n    margin-bottom: 6.25vw;\n  }\n  .review-banner .review-banner__wrapper {\n    max-width: 100%;\n    border-radius: 1.1719vw;\n    padding: 3.9063vw;\n    gap: 3.9063vw;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n  }\n  .review-banner .review-banner__content {\n    max-width: 38.0469vw;\n    margin-top: 1.1719vw;\n  }\n  .review-banner .review-banner__content-text {\n    font-size: 1.7969vw;\n    margin-bottom: 2.2656vw;\n  }\n  .review-banner .review-banner__content-logo {\n    width: 16.9531vw;\n    margin-bottom: 2.7344vw;\n  }\n  .review-banner .review-banner__image {\n    width: 38.2813vw;\n    height: 26.9531vw;\n    border-radius: 1.1719vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .review-banner {\n    margin-bottom: 14.1026vw;\n  }\n  .review-banner .review-banner__wrapper {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n    border-radius: 4.1026vw;\n    padding: 0;\n    gap: 6.1538vw;\n  }\n  .review-banner .review-banner__content {\n    max-width: 73.3333vw;\n    margin: 0 auto;\n    margin-top: 0;\n    padding-bottom: 10.2564vw;\n  }\n  .review-banner .review-banner__content-text {\n    font-size: 4.6154vw;\n    margin-bottom: 6.1538vw;\n  }\n  .review-banner .review-banner__content-logo {\n    width: 46.9231vw;\n    margin-bottom: 5.8974vw;\n  }\n  .review-banner .review-banner__image {\n    width: 100%;\n    height: auto;\n    border-radius: 4.1026vw;\n  }\n}\n.counter-section {\n  margin-bottom: 170px;\n}\n.counter-section .counter-section__list .list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  gap: 32px;\n}\n.counter-section .counter-section__list .item {\n  width: 280px;\n}\n.counter-section .counter-section__list .item-top {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.counter-section .counter-section__list .item-top__number,\n.counter-section .counter-section__list .item-top__symbol {\n  font-family: \"Circular Std\";\n  font-weight: 700;\n  line-height: 1.5;\n  font-size: 80px;\n  letter-spacing: -0.022em;\n  color: #ffffff;\n}\n.counter-section .counter-section__list .item-title {\n  width: 230px;\n  margin: 0 auto;\n  font-weight: 400;\n  line-height: 1.2;\n  font-size: 20px;\n  letter-spacing: -0.01em;\n  color: #ffffff;\n  text-align: center;\n}\n.counter-section .counter-section__text {\n  margin-bottom: 65px;\n  font-weight: 500;\n  line-height: 1.4;\n  font-size: 24px;\n  letter-spacing: -0.01em;\n  color: #ffffff;\n  text-align: center;\n}\n\n@media screen and (max-width: 1330px) {\n  .counter-section {\n    margin-bottom: 12.782vw;\n  }\n  .counter-section .counter-section__list .list {\n    gap: 2.406vw;\n  }\n  .counter-section .counter-section__list .item {\n    width: 21.0526vw;\n  }\n  .counter-section .counter-section__list .item-top__number,\n  .counter-section .counter-section__list .item-top__symbol {\n    font-size: 6.015vw;\n  }\n  .counter-section .counter-section__list .item-title {\n    width: 17.2932vw;\n    font-size: 1.5038vw;\n  }\n  .counter-section .counter-section__text {\n    margin-bottom: 4.8872vw;\n    font-size: 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .counter-section {\n    margin-bottom: 6.25vw;\n  }\n  .counter-section .counter-section__list .list {\n    gap: 2.3438vw;\n  }\n  .counter-section .counter-section__list .item {\n    width: 16.7969vw;\n  }\n  .counter-section .counter-section__list .item-top__number,\n  .counter-section .counter-section__list .item-top__symbol {\n    font-size: 5.4688vw;\n  }\n  .counter-section .counter-section__list .item-title {\n    width: 15.625vw;\n    font-size: 1.4063vw;\n  }\n  .counter-section .counter-section__text {\n    margin-bottom: 2.3438vw;\n    font-size: 1.5625vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .counter-section {\n    margin-bottom: 20vw;\n  }\n  .counter-section .counter-section__list .list {\n    gap: 8.4615vw;\n  }\n  .counter-section .counter-section__list .item {\n    width: 100%;\n  }\n  .counter-section .counter-section__list .item-top__number,\n  .counter-section .counter-section__list .item-top__symbol {\n    font-size: 15.3846vw;\n  }\n  .counter-section .counter-section__list .item-title {\n    width: 55.3846vw;\n    font-size: 4.6154vw;\n  }\n  .counter-section .counter-section__text {\n    width: 71.7949vw;\n    margin: 0 auto 13.8462vw;\n    font-size: 4.1026vw;\n  }\n}\n.coming-soon-banner {\n  background-color: var(--yellow);\n}\n.coming-soon-banner.hide {\n  padding-bottom: 30px;\n}\n.coming-soon-banner .coming-soon-banner__inner {\n  padding: 60px 0;\n}\n.coming-soon-banner .coming-soon-banner__wrapper {\n  width: 100%;\n  max-width: 1290px;\n  margin: 0 auto;\n  background: #474643;\n  border-radius: 24px;\n  overflow: hidden;\n  position: relative;\n  z-index: 2;\n  min-height: 400px;\n  padding: 60px;\n}\n.coming-soon-banner .coming-soon-banner__wrapper::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1287' height='400' fill='none'%3E%3Cg filter='url(%23a)'%3E%3Ccircle cx='658.5' cy='439.5' r='358.5' fill='%23000' fill-opacity='.9'/%3E%3C/g%3E%3Cg filter='url(%23b)'%3E%3Ccircle cx='891.5' cy='-227.5' r='264.5' fill='%23FFD748'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='a' width='1317' height='1317' x='0' y='-219' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_11319_1798' stdDeviation='150'/%3E%3C/filter%3E%3Cfilter id='b' width='1329' height='1329' x='227' y='-892' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur result='effect1_foregroundBlur_11319_1798' stdDeviation='200'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.coming-soon-banner .coming-soon-banner__content {\n  width: 100%;\n  max-width: 460px;\n}\n.coming-soon-banner .coming-soon-banner__content-top {\n  font-weight: 500;\n  line-height: 1.5;\n  font-size: 14px;\n  letter-spacing: -0.01em;\n  color: var(--yellow);\n  text-transform: uppercase;\n  margin-bottom: 5px;\n}\n.coming-soon-banner .coming-soon-banner__content-title {\n  margin-bottom: 5px;\n}\n.coming-soon-banner .coming-soon-banner__content-title .title {\n  color: var(--white);\n}\n.coming-soon-banner .coming-soon-banner__content-text {\n  font-weight: 400;\n  line-height: 1.5;\n  font-size: 20px;\n  letter-spacing: -0.01em;\n  color: #e9e4dc;\n  margin-top: -3px;\n}\n.coming-soon-banner .coming-soon-banner__content-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  margin-top: 20px;\n}\n.coming-soon-banner .coming-soon-banner__image {\n  position: absolute;\n  right: 22px;\n  bottom: 0;\n  width: 625px;\n  height: 371px;\n}\n.coming-soon-banner .coming-soon-banner__image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n@media screen and (max-width: 1330px) {\n  .coming-soon-banner.hide {\n    padding-bottom: 2.2556vw;\n  }\n  .coming-soon-banner .coming-soon-banner__inner {\n    padding: 4.5113vw 0;\n  }\n  .coming-soon-banner .coming-soon-banner__wrapper {\n    max-width: 96.9925vw;\n    border-radius: 1.8045vw;\n    min-height: 30.0752vw;\n    padding: 4.5113vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content {\n    max-width: 34.5865vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-top {\n    font-size: 1.0526vw;\n    margin-bottom: 0.3759vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-title {\n    margin-bottom: 0.3759vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-text {\n    font-size: 1.5038vw;\n    margin-top: -0.2256vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-button {\n    margin-top: 1.5038vw;\n  }\n  .coming-soon-banner .coming-soon-banner__image {\n    right: 1.6541vw;\n    width: 46.9925vw;\n    height: 27.8947vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .coming-soon-banner.hide {\n    padding-bottom: 2.3438vw;\n  }\n  .coming-soon-banner .coming-soon-banner__inner {\n    padding: 3.9063vw 0;\n  }\n  .coming-soon-banner .coming-soon-banner__wrapper {\n    max-width: 100%;\n    border-radius: 1.1719vw;\n    min-height: 27.3438vw;\n    padding: 3.9063vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content {\n    max-width: 35.9375vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-top {\n    font-size: 1.0938vw;\n    margin-bottom: 0.3906vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-title {\n    margin-bottom: 0.3906vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-text {\n    font-size: 1.5625vw;\n    margin-top: -0.2344vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-button {\n    margin-top: 1.5625vw;\n  }\n  .coming-soon-banner .coming-soon-banner__image {\n    right: 1.5625vw;\n    bottom: 0;\n    width: 35.9375vw;\n    height: 21.3281vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .coming-soon-banner.hide {\n    padding-bottom: 11.5385vw;\n  }\n  .coming-soon-banner .coming-soon-banner__inner {\n    padding: 11.7949vw 0;\n  }\n  .coming-soon-banner .coming-soon-banner__wrapper {\n    border-radius: 4.1026vw;\n    min-height: 1px;\n    padding: 10.2564vw 0 0 0;\n  }\n  .coming-soon-banner .coming-soon-banner__content {\n    max-width: 74.1026vw;\n    margin: 0 auto;\n  }\n  .coming-soon-banner .coming-soon-banner__content-top {\n    font-size: 3.5897vw;\n    margin-bottom: 2.0513vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-title {\n    margin-bottom: 4.359vw;\n  }\n  .coming-soon-banner .coming-soon-banner__content-text {\n    font-size: 4.6154vw;\n    margin-top: 0;\n  }\n  .coming-soon-banner .coming-soon-banner__content-button {\n    margin-top: 6.1538vw;\n  }\n  .coming-soon-banner .coming-soon-banner__image {\n    margin: 16.4103vw auto 0;\n    position: static;\n    width: 99.4872vw;\n    height: 59.1795vw;\n  }\n}\n.programs {\n  margin-bottom: 120px;\n}\n.programs .programs__title {\n  margin-bottom: 68px;\n}\n.programs .programs__title .title {\n  color: var(--white);\n  text-align: center;\n}\n.programs .programs__navigation {\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto 130px;\n}\n.programs .programs__navigation ul {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr 20px 1fr 20px 1fr;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 33px 20px;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.programs .programs__navigation ul li {\n  width: 100%;\n  height: auto;\n  position: relative;\n}\n.programs .programs__navigation ul li::before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #56534f;\n  border-radius: 12px;\n  z-index: -1;\n  background: var(--dark);\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.programs .programs__navigation ul li:hover a::before {\n  opacity: 1;\n}\n.programs .programs__navigation ul li.is-active::before {\n  top: -10px;\n  background: #2b2a28;\n}\n.programs .programs__navigation ul li.is-active a::after {\n  background: #161616;\n}\n.programs .programs__navigation ul li a {\n  position: relative;\n  z-index: 2;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 41px 15px;\n  font-weight: 500;\n  line-height: 1.5;\n  font-size: 24px;\n  text-align: center;\n  letter-spacing: -0.01em;\n  color: var(--yellow);\n}\n.programs .programs__navigation ul li a::before,\n.programs .programs__navigation ul li a::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #56534f;\n  border-radius: 12px;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.programs .programs__navigation ul li a::before {\n  opacity: 0;\n  z-index: -1;\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(#4d452a),\n    to(#2b2a28)\n  );\n  background: linear-gradient(180deg, #4d452a 0%, #2b2a28 100%);\n}\n.programs .programs__navigation ul li a::after {\n  z-index: -2;\n  background: #2b2a28;\n}\n.programs .programs__list {\n  width: 100%;\n  max-width: 1190px;\n  margin: 0 auto;\n  position: relative;\n}\n.programs .programs__list .list-line {\n  position: absolute;\n  top: 209px;\n  left: calc(50% + 26px);\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 60px;\n  height: calc(100% - 656px);\n  border-radius: 16px 0 0 0;\n  border: 2px solid #56534f;\n  border-right: none;\n  border-bottom: none;\n}\n.programs .programs__list .list-line #path-circle {\n  position: absolute;\n  top: 87px;\n  left: -6.6px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background-color: var(--yellow);\n}\n.programs .programs__list .list {\n  width: 100%;\n}\n.programs .programs__list .item {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 130px;\n  position: relative;\n}\n.programs .programs__list .item:not(:first-child) {\n  margin-top: 60px;\n}\n.programs .programs__list .item:nth-child(4n + 1),\n.programs .programs__list .item:nth-child(4n + 2) {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.programs .programs__list .item:nth-child(4n + 1) .item-image::before,\n.programs .programs__list .item:nth-child(4n + 2) .item-image::before {\n  content: \"\";\n  position: absolute;\n  left: -58px;\n  bottom: 100%;\n  width: 330px;\n  height: 30px;\n  border: 2px solid #56534f;\n  border-radius: 0 16px 0 0;\n  border-left: none;\n  border-bottom: none;\n}\n.programs .programs__list .item:nth-child(4n + 3),\n.programs .programs__list .item:nth-child(4n + 4) {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n}\n.programs .programs__list .item:nth-child(4n + 3) .item-image::before,\n.programs .programs__list .item:nth-child(4n + 4) .item-image::before {\n  content: \"\";\n  position: absolute;\n  right: -54px;\n  bottom: 100%;\n  width: 330px;\n  height: 30px;\n  border: 2px solid #56534f;\n  border-radius: 16px 0 0 0;\n  border-right: none;\n  border-bottom: none;\n}\n.programs .programs__list .item:first-child .item-image::before {\n  display: none;\n}\n.programs .programs__list .item-link {\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.programs .programs__list .item-content {\n  width: 100%;\n  max-width: 520px;\n  color: var(--white);\n}\n.programs .programs__list .item-content__title {\n  margin-bottom: 22px;\n}\n.programs .programs__list .item-content__title .small-title {\n  color: var(--white);\n}\n.programs .programs__list .item-content__list {\n  margin-bottom: 22px;\n}\n.programs .programs__list .item-content__list ul {\n  width: 100%;\n  max-width: 510px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.programs .programs__list .item-content__list ul li {\n  border-radius: 60px;\n  background: #2f2f2f;\n  border: 1px solid #74706d;\n  padding: 12px 16px;\n  font-weight: 400;\n  line-height: 1.2;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: var(--yellow);\n}\n.programs .programs__list .item-content__text {\n  font-weight: 450;\n  line-height: 1.5;\n  font-size: 20px;\n  letter-spacing: -0.01em;\n  color: #e9e4dc;\n}\n.programs .programs__list .item-content__text.item-content__text--mobile {\n  display: none;\n}\n.programs .programs__list .item-image {\n  position: relative;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 540px;\n  height: 420px;\n  border-radius: 28px;\n  border: 1px solid #56534f;\n  padding: 10px;\n  background-color: var(--dark);\n}\n.programs .programs__list .item-image img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  border-radius: 24px;\n}\n\n@media screen and (max-width: 1330px) {\n  .programs {\n    margin-bottom: 9.0226vw;\n  }\n  .programs .programs__title {\n    margin-bottom: 5.1128vw;\n  }\n  .programs .programs__navigation {\n    max-width: 75.188vw;\n    margin: 0 auto 9.7744vw;\n  }\n  .programs .programs__navigation ul {\n    grid-gap: 2.4812vw 1.5038vw;\n  }\n  .programs .programs__navigation ul li::before {\n    top: 0.7519vw;\n    border-radius: 0.9023vw;\n  }\n  .programs .programs__navigation ul li a {\n    padding: 3.0827vw 1.1278vw;\n    font-size: 1.8045vw;\n  }\n  .programs .programs__navigation ul li a::before,\n  .programs .programs__navigation ul li a::after {\n    border-radius: 0.9023vw;\n  }\n  .programs .programs__list {\n    max-width: 89.4737vw;\n  }\n  .programs .programs__list .list-line {\n    top: 15.7143vw;\n    left: calc(50% + 1.9549vw);\n    width: 4.5113vw;\n    height: calc(100% - 49.3233vw);\n  }\n  .programs .programs__list .item {\n    gap: 9.7744vw;\n  }\n  .programs .programs__list .item:not(:first-child) {\n    margin-top: 4.5113vw;\n  }\n  .programs .programs__list .item:nth-child(4n + 1) .item-image::before,\n  .programs .programs__list .item:nth-child(4n + 2) .item-image::before {\n    left: -4.3609vw;\n    width: 24.812vw;\n    height: 2.2556vw;\n  }\n  .programs .programs__list .item:nth-child(4n + 3) .item-image::before,\n  .programs .programs__list .item:nth-child(4n + 4) .item-image::before {\n    right: -4.0602vw;\n    width: 24.812vw;\n    height: 2.2556vw;\n  }\n  .programs .programs__list .item-content {\n    max-width: 39.0977vw;\n  }\n  .programs .programs__list .item-content__title {\n    margin-bottom: 1.6541vw;\n  }\n  .programs .programs__list .item-content__list {\n    margin-bottom: 1.6541vw;\n  }\n  .programs .programs__list .item-content__list ul {\n    max-width: 38.3459vw;\n    gap: 0.6015vw;\n  }\n  .programs .programs__list .item-content__list ul li {\n    border-radius: 4.5113vw;\n    padding: 0.9023vw 1.203vw;\n    font-size: 1.203vw;\n  }\n  .programs .programs__list .item-content__text {\n    font-size: 1.5038vw;\n  }\n  .programs .programs__list .item-image {\n    width: 40.6015vw;\n    height: 31.5789vw;\n    border-radius: 2.1053vw;\n    padding: 0.7519vw;\n  }\n  .programs .programs__list .item-image img {\n    border-radius: 1.8045vw;\n  }\n}\n@media screen and (max-width: 1280px) {\n  .programs {\n    margin-bottom: 6.25vw;\n  }\n  .programs .programs__title {\n    margin-bottom: 3.9063vw;\n  }\n  .programs .programs__navigation {\n    max-width: 100%;\n    margin: 0 auto 4.6875vw;\n  }\n  .programs .programs__navigation ul {\n    grid-gap: 2.5781vw 1.5625vw;\n  }\n  .programs .programs__navigation ul li::before {\n    top: 0.7813vw;\n    border-radius: 0.9375vw;\n  }\n  .programs .programs__navigation ul li a {\n    padding: 3.2031vw 1.1719vw;\n    font-size: 1.875vw;\n  }\n  .programs .programs__navigation ul li a::before,\n  .programs .programs__navigation ul li a::after {\n    border-radius: 0.9375vw;\n  }\n  .programs .programs__list {\n    max-width: 92.9688vw;\n  }\n  .programs .programs__list .list-line {\n    top: 16.3281vw;\n    left: calc(50% + 2.0313vw);\n    width: 4.6875vw;\n    height: calc(100% - 47.0313vw);\n  }\n  .programs .programs__list .item {\n    gap: 10.1563vw;\n  }\n  .programs .programs__list .item:not(:first-child) {\n    margin-top: 4.6875vw;\n  }\n  .programs .programs__list .item:nth-child(4n + 1) .item-image::before,\n  .programs .programs__list .item:nth-child(4n + 2) .item-image::before {\n    left: -4.5313vw;\n    width: 25.7813vw;\n    height: 2.3438vw;\n  }\n  .programs .programs__list .item:nth-child(4n + 3) .item-image::before,\n  .programs .programs__list .item:nth-child(4n + 4) .item-image::before {\n    right: -4.0625vw;\n    width: 25.7813vw;\n    height: 2.3438vw;\n  }\n  .programs .programs__list .item-content {\n    max-width: 40.625vw;\n  }\n  .programs .programs__list .item-content__title {\n    margin-bottom: 1.1719vw;\n  }\n  .programs .programs__list .item-content__list {\n    margin-bottom: 1.1719vw;\n  }\n  .programs .programs__list .item-content__list ul {\n    max-width: 34.375vw;\n    gap: 0.625vw;\n  }\n  .programs .programs__list .item-content__list ul li {\n    border-radius: 4.6875vw;\n    padding: 0.7813vw 0.9375vw;\n    font-size: 1.0938vw;\n  }\n  .programs .programs__list .item-content__text {\n    font-size: 1.4063vw;\n  }\n  .programs .programs__list .item-image {\n    width: 36.7188vw;\n    height: 28.5938vw;\n    border-radius: 1.1719vw;\n    padding: 0.7813vw;\n  }\n  .programs .programs__list .item-image img {\n    border-radius: 1.1719vw;\n  }\n}\n@media screen and (max-width: 850px) {\n  .programs {\n    margin-bottom: 17.9487vw;\n  }\n  .programs .programs__title {\n    margin-bottom: 10.2564vw;\n  }\n  .programs .programs__navigation {\n    width: calc(100% + 3.5897vw);\n    margin: 0 -1.7949vw 16.6667vw;\n    max-width: unset;\n  }\n  .programs .programs__navigation ul {\n    grid-gap: 5.641vw 3.0769vw;\n    -ms-grid-columns: 1fr 3.0769vw 1fr;\n    grid-template-columns: 1fr 1fr;\n  }\n  .programs .programs__navigation ul li::before {\n    top: 2.5641vw;\n    border-radius: 3.0769vw;\n  }\n  .programs .programs__navigation ul li a {\n    padding: 5.1282vw 2.5641vw;\n    font-size: 4.1026vw;\n  }\n  .programs .programs__navigation ul li a::before,\n  .programs .programs__navigation ul li a::after {\n    border-radius: 3.0769vw;\n  }\n  .programs .programs__list {\n    max-width: 100%;\n  }\n  .programs .programs__list .list-line {\n    display: none;\n  }\n  .programs .programs__list .item {\n    gap: 8.2051vw;\n  }\n  .programs .programs__list .item:not(:first-child) {\n    margin-top: 17.9487vw;\n  }\n  .programs .programs__list .item:nth-child(4n + 1),\n  .programs .programs__list .item:nth-child(4n + 2),\n  .programs .programs__list .item:nth-child(4n + 3),\n  .programs .programs__list .item:nth-child(4n + 4) {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n  }\n  .programs .programs__list .item:nth-child(4n + 1) .item-image::before,\n  .programs .programs__list .item:nth-child(4n + 2) .item-image::before,\n  .programs .programs__list .item:nth-child(4n + 3) .item-image::before,\n  .programs .programs__list .item:nth-child(4n + 4) .item-image::before {\n    display: none;\n  }\n  .programs .programs__list .item-content {\n    max-width: 100%;\n  }\n  .programs .programs__list .item-content__title {\n    margin-bottom: 5.1282vw;\n  }\n  .programs .programs__list .item-content__list {\n    margin-bottom: 5.1282vw;\n  }\n  .programs .programs__list .item-content__list ul {\n    gap: 2.0513vw;\n    max-width: 100%;\n  }\n  .programs .programs__list .item-content__list ul li {\n    border-radius: 15.3846vw;\n    padding: 3.0769vw 4.1026vw;\n    font-size: 3.5897vw;\n  }\n  .programs .programs__list .item-content__text {\n    font-size: 4.6154vw;\n    letter-spacing: -0.02em;\n    display: none;\n  }\n  .programs .programs__list .item-content__text.item-content__text--mobile {\n    display: block;\n  }\n  .programs .programs__list .item-image {\n    width: 89.7436vw;\n    height: 69.7436vw;\n    border-radius: 4.6154vw;\n    padding: 1.5385vw;\n  }\n  .programs .programs__list .item-image img {\n    border-radius: 4.1026vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
